/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(435);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(19);
	
	Object.keys(_index).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index[key];
	    }
	  });
	});
	
	var _index2 = __webpack_require__(40);
	
	Object.keys(_index2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index2[key];
	    }
	  });
	});
	
	var _index3 = __webpack_require__(318);
	
	Object.keys(_index3).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index3[key];
	    }
	  });
	});
	
	var _index4 = __webpack_require__(359);
	
	Object.keys(_index4).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index4[key];
	    }
	  });
	});
	
	var _index5 = __webpack_require__(339);
	
	Object.keys(_index5).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index5[key];
	    }
	  });
	});
	
	var _index6 = __webpack_require__(391);
	
	Object.keys(_index6).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index6[key];
	    }
	  });
	});
	
	var _index7 = __webpack_require__(434);
	
	Object.keys(_index7).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index7[key];
	    }
	  });
	});
	
	var _index8 = __webpack_require__(398);
	
	Object.keys(_index8).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index8[key];
	    }
	  });
	});

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(638);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
[666, 194],
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(134);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(648);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(647);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(646);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(133);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(135);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(220);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(69);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(221);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(43)(module)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {View} from 'react-native'
	
	
	var CCErrorBoundary = function (_Component) {
	    _inherits(CCErrorBoundary, _Component);
	
	    function CCErrorBoundary(props) {
	        _classCallCheck(this, CCErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, (CCErrorBoundary.__proto__ || Object.getPrototypeOf(CCErrorBoundary)).call(this, props));
	
	        _this.state = {
	            hasError: false
	        };
	        return _this;
	    }
	
	    _createClass(CCErrorBoundary, [{
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error) {
	            this.setState({ hasError: true });
	            //Firebase.crashlytics().recordError(-1000, error.message );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            //console.log(topTitle, bottomTitle, showVersion)
	            if (this.state.hasError == true) {
	                return this.props.fallbackUI;
	            } else {
	                return this.props.children;
	            }
	        }
	    }]);
	
	    return CCErrorBoundary;
	}(_react.Component);
	
	CCErrorBoundary.propTypes = {
	    fallbackUI: _propTypes2.default.element
	};
	CCErrorBoundary.defaultProps = {
	    fallbackUI: _react2.default.createElement('div', null)
	};
	exports.default = CCErrorBoundary;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(51);
	var isBuffer = __webpack_require__(164);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	__webpack_require__(45);
	var firebase = _interopDefault(__webpack_require__(13));
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(145);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");
	
	module.exports = firebase;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var util = __webpack_require__(30);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	// An array to capture listeners before the true auth functions
	// exist
	var tokenListeners = [];
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, config, firebase_) {
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.services_ = {};
	        this.name_ = config.name;
	        this._automaticDataCollectionEnabled =
	            config.automaticDataCollectionEnabled || false;
	        this.options_ = util.deepCopy(options);
	        this.INTERNAL = {
	            getUid: function () { return null; },
	            getToken: function () { return Promise.resolve(null); },
	            addAuthTokenListener: function (callback) {
	                tokenListeners.push(callback);
	                // Make sure callback is called, asynchronously, in the absence of the auth module
	                setTimeout(function () { return callback(null); }, 0);
	            },
	            removeAuthTokenListener: function (callback) {
	                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
	            }
	        };
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
	        get: function () {
	            this.checkDestroyed_();
	            return this._automaticDataCollectionEnabled;
	        },
	        set: function (val) {
	            this.checkDestroyed_();
	            this._automaticDataCollectionEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            var services = [];
	            Object.keys(_this.services_).forEach(function (serviceKey) {
	                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
	                    services.push(_this.services_[serviceKey][instanceKey]);
	                });
	            });
	            return Promise.all(services.map(function (service) {
	                return service.INTERNAL.delete();
	            }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	            _this.services_ = {};
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage is the only one that is leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        if (!this.services_[name]) {
	            this.services_[name] = {};
	        }
	        if (!this.services_[name][instanceIdentifier]) {
	            /**
	             * If a custom instance has been defined (i.e. not '[DEFAULT]')
	             * then we will pass that instance on, otherwise we pass `null`
	             */
	            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
	                ? instanceIdentifier
	                : undefined;
	            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
	            this.services_[name][instanceIdentifier] = service;
	        }
	        return this.services_[name][instanceIdentifier];
	    };
	    /**
	     * Callback function used to extend an App instance at the time
	     * of service instance creation.
	     */
	    FirebaseAppImpl.prototype.extendApp = function (props) {
	        var _this = this;
	        // Copy the object onto the FirebaseAppImpl prototype
	        util.deepExtend(this, props);
	        /**
	         * If the app has overwritten the addAuthTokenListener stub, forward
	         * the active token listeners on to the true fxn.
	         *
	         * TODO: This function is required due to our current module
	         * structure. Once we are able to rely strictly upon a single module
	         * implementation, this code should be refactored and Auth should
	         * provide these stubs and the upgrade logic
	         */
	        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
	            tokenListeners.forEach(function (listener) {
	                _this.INTERNAL.addAuthTokenListener(listener);
	            });
	            tokenListeners = [];
	        }
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            error('app-deleted', { name: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var apps_ = {};
	    var factories = {};
	    var appHooks = {};
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        __esModule: true,
	        initializeApp: initializeApp,
	        app: app,
	        apps: null,
	        Promise: Promise,
	        SDK_VERSION: '5.0.4',
	        INTERNAL: {
	            registerService: registerService,
	            createFirebaseNamespace: createFirebaseNamespace,
	            extendNamespace: extendNamespace,
	            createSubscribe: util.createSubscribe,
	            ErrorFactory: util.ErrorFactory,
	            removeApp: removeApp,
	            factories: factories,
	            useAsService: useAsService,
	            Promise: Promise,
	            deepExtend: util.deepExtend
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    util.patchProperty(namespace, 'default', namespace);
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        var app = apps_[name];
	        callAppHooks(app, 'delete');
	        delete apps_[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!contains(apps_, name)) {
	            error('no-app', { name: name });
	        }
	        return apps_[name];
	    }
	    util.patchProperty(app, 'App', FirebaseAppImpl);
	    function initializeApp(options, rawConfig) {
	        if (rawConfig === void 0) { rawConfig = {}; }
	        if (typeof rawConfig !== 'object' || rawConfig === null) {
	            var name_1 = rawConfig;
	            rawConfig = { name: name_1 };
	        }
	        var config = rawConfig;
	        if (config.name === undefined) {
	            config.name = DEFAULT_ENTRY_NAME;
	        }
	        var name = config.name;
	        if (typeof name !== 'string' || !name) {
	            error('bad-app-name', { name: name + '' });
	        }
	        if (contains(apps_, name)) {
	            error('duplicate-app', { name: name });
	        }
	        var app = new FirebaseAppImpl(options, config, namespace);
	        apps_[name] = app;
	        callAppHooks(app, 'create');
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps_).map(function (name) { return apps_[name]; });
	    }
	    /*
	     * Register a Firebase Service.
	     *
	     * firebase.INTERNAL.registerService()
	     *
	     * TODO: Implement serviceProperties.
	     */
	    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
	        // Cannot re-register a service that already exists
	        if (factories[name]) {
	            error('duplicate-service', { name: name });
	        }
	        // Capture the service factory for later service instantiation
	        factories[name] = createService;
	        // Capture the appHook, if passed
	        if (appHook) {
	            appHooks[name] = appHook;
	            // Run the **new** app hook on all existing apps
	            getApps().forEach(function (app) {
	                appHook('create', app);
	            });
	        }
	        // The Service namespace is an accessor function ...
	        var serviceNamespace = function (appArg) {
	            if (appArg === void 0) { appArg = app(); }
	            if (typeof appArg[name] !== 'function') {
	                // Invalid argument.
	                // This happens in the following case: firebase.storage('gs:/')
	                error('invalid-app-argument', { name: name });
	            }
	            // Forward service instance lookup to the FirebaseApp.
	            return appArg[name]();
	        };
	        // ... and a container for service-level properties.
	        if (serviceProperties !== undefined) {
	            util.deepExtend(serviceNamespace, serviceProperties);
	        }
	        // Monkey-patch the serviceNamespace onto the firebase namespace
	        namespace[name] = serviceNamespace;
	        // Patch the FirebaseAppImpl prototype
	        FirebaseAppImpl.prototype[name] = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var serviceFxn = this._getService.bind(this, name);
	            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
	        };
	        return serviceNamespace;
	    }
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util.deepExtend(namespace, props);
	    }
	    function callAppHooks(app, eventName) {
	        Object.keys(factories).forEach(function (serviceName) {
	            // Ignore virtual services
	            var factoryName = useAsService(app, serviceName);
	            if (factoryName === null) {
	                return;
	            }
	            if (appHooks[factoryName]) {
	                appHooks[factoryName](eventName, app);
	            }
	        });
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        var options = app.options;
	        return useService;
	    }
	    return namespace;
	}
	function error(code, args) {
	    throw appErrors.create(code, args);
	}
	// TypeScript does not support non-string indexes!
	// let errors: {[code: AppError: string} = {
	var errors = {
	    'no-app': "No Firebase App '{$name}' has been created - " +
	        'call Firebase App.initializeApp()',
	    'bad-app-name': "Illegal App name: '{$name}",
	    'duplicate-app': "Firebase App named '{$name}' already exists",
	    'app-deleted': "Firebase App named '{$name}' already deleted",
	    'duplicate-service': "Firebase service named '{$name}' already registered",
	    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
	        'account is only allowed in a Node.js environment. On client ' +
	        'devices, you should instead initialize the SDK with an api key and ' +
	        'auth domain',
	    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
	        'Firebase App instance.'
	};
	var appErrors = new util.ErrorFactory('app', 'Firebase', errors);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var firebase = createFirebaseNamespace();
	
	exports.firebase = firebase;
	exports.default = firebase;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	__webpack_require__(45);
	var firebase = _interopDefault(__webpack_require__(13));
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	module.exports = firebase;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var warning = __webpack_require__(22);
	var canDefineProperty = __webpack_require__(65);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(63);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(321);
	
	Object.keys(_colors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colors[key];
	    }
	  });
	});
	
	var _Constants = __webpack_require__(319);
	
	Object.keys(_Constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Constants[key];
	    }
	  });
	});
	
	var _CricrushConfig = __webpack_require__(320);
	
	Object.keys(_CricrushConfig).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CricrushConfig[key];
	    }
	  });
	});
	
	var _images = __webpack_require__(322);
	
	Object.keys(_images).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _images[key];
	    }
	  });
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [0, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator];
	        return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(657);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(662);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 26 */
[666, 255],
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCActivityIndicator = function (_Component) {
	    _inherits(CCActivityIndicator, _Component);
	
	    function CCActivityIndicator(props) {
	        _classCallCheck(this, CCActivityIndicator);
	
	        var _this = _possibleConstructorReturn(this, (CCActivityIndicator.__proto__ || Object.getPrototypeOf(CCActivityIndicator)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCActivityIndicator, [{
	        key: 'render',
	        value: function render() {
	            var isButton = this.props.isButton == true;
	            if (isButton) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: "loader-" + this.props.size },
	                    ' '
	                );
	            } else {
	                return _react2.default.createElement('div', { className: "loader-" + this.props.size });
	            }
	        }
	    }]);
	
	    return CCActivityIndicator;
	}(_react.Component);
	
	CCActivityIndicator.propTypes = {
	    size: _propTypes2.default.string,
	    isButton: _propTypes2.default.bool,
	    color: _propTypes2.default.string
	};
	CCActivityIndicator.defaultProps = {
	    size: 'l',
	    isButton: false,
	    color: _ccImports.colors.theme2.font_color4
	};
	exports.default = CCActivityIndicator;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(438);
	
	__webpack_require__(463);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCBackLayout = function (_Component) {
	    _inherits(CCBackLayout, _Component);
	
	    function CCBackLayout(props) {
	        _classCallCheck(this, CCBackLayout);
	
	        var _this = _possibleConstructorReturn(this, (CCBackLayout.__proto__ || Object.getPrototypeOf(CCBackLayout)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCBackLayout, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-container", style: Object.assign({ flex: 1 }, this.props.style) },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-container parent2", style: Object.assign({}, this.props.style) },
	                        _react2.default.createElement(_ccImports.CCIcon, { type: 'back', className: 'cc-back-icon b-icon', onPress: this.props.onBackPress, style: {} })
	                    ),
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return CCBackLayout;
	}(_react.Component);
	
	CCBackLayout.propTypes = {
	    onBackPress: _propTypes2.default.func
	};
	CCBackLayout.defaultProps = {
	    scrollable: true
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)({}, dispatch),
	        dispatch: dispatch
	    };
	})(CCBackLayout);

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TransactionsModal = undefined;
	
	var _TransactionsModal = __webpack_require__(390);
	
	var _TransactionsModal2 = _interopRequireDefault(_TransactionsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TransactionsModal = _TransactionsModal2.default;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib_1 = __webpack_require__(20);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	var CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws an error if the provided assertion is falsy
	 * @param {*} assertion The assertion to be tested for falsiness
	 * @param {!string} message The message to display if the check fails
	 */
	var assert = function (assertion, message) {
	    if (!assertion) {
	        throw assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 * @param {string} message
	 * @return {!Error}
	 */
	var assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) == 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param {Array<number>} bytes Array of numbers representing characters.
	 * @return {string} Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// Static lookup maps, lazily populated by init_()
	var base64 = {
	    /**
	     * Maps bytes to characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     * @type {string}
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     * @type {string}
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     * @type {string}
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     * @type {boolean}
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param {boolean=} opt_webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeByteArray: function (input, opt_webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = opt_webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param {string} input A string to encode.
	     * @param {boolean=} opt_webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param {string} input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the
	     *     alternative alphabet.
	     * @return {string} string representing the decoded value.
	     */
	    decodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param {string} input Input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
	     * @return {!Array<number>} bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, opt_webSafe) {
	        this.init_();
	        var charToByteMap = opt_webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 != 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 != 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 * @param {!string} str
	 * @return {!string}
	 */
	var base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param {string} str To be decoded
	 * @return {?string} Decoded result, if possible
	 */
	var base64Decode = function (str) {
	    try {
	        return base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	// TODO: Really needed (for JSCompiler type checking)?
	function patchProperty(obj, prop, value) {
	    obj[prop] = value;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
	     * @return {!function(?(Error), ?=)}
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return {string} user agent string
	 */
	var getUA = function () {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	};
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
	 * Cordova `onDeviceReady`, which would normally wait for a callback.
	 *
	 * @return {boolean} isMobileCordova
	 */
	var isMobileCordova = function () {
	    return (typeof window !== 'undefined' &&
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
	};
	/**
	 * Detect React Native.
	 *
	 * @return {boolean} True if ReactNative environment is detected.
	 */
	var isReactNative = function () {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	};
	/**
	 * Detect Node.js.
	 *
	 * @return {boolean} True if Node.js environment is detected.
	 */
	var isNodeSdk = function () {
	    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
	};
	
	var ERROR_NAME = 'FirebaseError';
	var captureStackTrace = Error
	    .captureStackTrace;
	// Export for faking in tests
	function patchCapture(captureFake) {
	    var result = captureStackTrace;
	    captureStackTrace = captureFake;
	    return result;
	}
	var FirebaseError = /** @class */ (function () {
	    function FirebaseError(code, message) {
	        this.code = code;
	        this.message = message;
	        // We want the stack value, if implemented by Error
	        if (captureStackTrace) {
	            // Patches this.stack, omitted calls above ErrorFactory#create
	            captureStackTrace(this, ErrorFactory.prototype.create);
	        }
	        else {
	            try {
	                // In case of IE11, stack will be set only after error is raised.
	                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
	                throw Error.apply(this, arguments);
	            }
	            catch (err) {
	                this.name = ERROR_NAME;
	                // Make non-enumerable getter for the property.
	                Object.defineProperty(this, 'stack', {
	                    get: function () {
	                        return err.stack;
	                    }
	                });
	            }
	        }
	    }
	    return FirebaseError;
	}());
	// Back-door inheritance
	FirebaseError.prototype = Object.create(Error.prototype);
	FirebaseError.prototype.constructor = FirebaseError;
	FirebaseError.prototype.name = ERROR_NAME;
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	        // Matches {$name}, by default.
	        this.pattern = /\{\$([^}]+)}/g;
	        // empty
	    }
	    ErrorFactory.prototype.create = function (code, data) {
	        if (data === undefined) {
	            data = {};
	        }
	        var template = this.errors[code];
	        var fullCode = this.service + '/' + code;
	        var message;
	        if (template === undefined) {
	            message = 'Error';
	        }
	        else {
	            message = template.replace(this.pattern, function (match, key) {
	                var value = data[key];
	                return value !== undefined ? value.toString() : '<' + key + '?>';
	            });
	        }
	        // Service: Error message (service/code).
	        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
	        var err = new FirebaseError(fullCode, message);
	        // Populate the Error object with message parts for programmatic
	        // accesses (e.g., e.file).
	        for (var prop in data) {
	            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
	                continue;
	            }
	            err[prop] = data[prop];
	        }
	        return err;
	    };
	    return ErrorFactory;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {{header: *, claims: *, data: *, signature: string}}
	 */
	var decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = jsonEval(base64Decode(parts[0]) || '');
	        claims = jsonEval(base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isValidTimestamp = function (token) {
	    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {?number}
	 */
	var issuedAtTime = function (token) {
	    var claims = decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
	 * signature.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isValidFormat = function (token) {
	    var decoded = decode(token), claims = decoded.claims;
	    return (!!decoded.signature &&
	        !!claims &&
	        typeof claims === 'object' &&
	        claims.hasOwnProperty('iat'));
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isAdmin = function (token) {
	    var claims = decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var safeGet = function (obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key))
	        return obj[key];
	    // else return undefined.
	};
	/**
	 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
	 *
	 * @param {?Object.<K,V>} obj Object to enumerate.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	var forEach = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	};
	/**
	 * Copies all the (own) properties from one object to another.
	 * @param {!Object} objTo
	 * @param {!Object} objFrom
	 * @return {!Object} objTo
	 */
	var extend = function (objTo, objFrom) {
	    forEach(objFrom, function (key, value) {
	        objTo[key] = value;
	    });
	    return objTo;
	};
	/**
	 * Returns a clone of the specified object.
	 * @param {!Object} obj
	 * @return {!Object} cloned obj.
	 */
	var clone = function (obj) {
	    return extend({}, obj);
	};
	/**
	 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
	 * for functions.
	 *
	 * @param obj {*} A potential object.
	 * @returns {boolean} True if it's an object.
	 */
	var isNonNullObject = function (obj) {
	    return typeof obj === 'object' && obj !== null;
	};
	var isEmpty = function (obj) {
	    for (var key in obj) {
	        return false;
	    }
	    return true;
	};
	var getCount = function (obj) {
	    var rv = 0;
	    for (var key in obj) {
	        rv++;
	    }
	    return rv;
	};
	var map = function (obj, f, opt_obj) {
	    var res = {};
	    for (var key in obj) {
	        res[key] = f.call(opt_obj, obj[key], key, obj);
	    }
	    return res;
	};
	var findKey = function (obj, fn, opt_this) {
	    for (var key in obj) {
	        if (fn.call(opt_this, obj[key], key, obj)) {
	            return key;
	        }
	    }
	    return undefined;
	};
	var findValue = function (obj, fn, opt_this) {
	    var key = findKey(obj, fn, opt_this);
	    return key && obj[key];
	};
	var getAnyKey = function (obj) {
	    for (var key in obj) {
	        return key;
	    }
	};
	var getValues = function (obj) {
	    var res = [];
	    var i = 0;
	    for (var key in obj) {
	        res[i++] = obj[key];
	    }
	    return res;
	};
	/**
	 * Tests whether every key/value pair in an object pass the test implemented
	 * by the provided function
	 *
	 * @param {?Object.<K,V>} obj Object to test.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	var every = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            if (!fn(key, obj[key])) {
	                return false;
	            }
	        }
	    }
	    return true;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
	 * object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 *
	 * @param {!Object} querystringParams
	 * @return {string}
	 */
	var querystring = function (querystringParams) {
	    var params = [];
	    forEach(querystringParams, function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    });
	    return params.length ? '&' + params.join('&') : '';
	};
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
	 *
	 * @param {string} querystring
	 * @return {!Object}
	 */
	var querystringDecode = function (querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Copyright 2011 The Closure Library Authors. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	/**
	 * @fileoverview Abstract cryptographic hash interface.
	 *
	 * See Sha1 and Md5 for sample implementations.
	 *
	 */
	/**
	 * Create a cryptographic hash instance.
	 *
	 * @constructor
	 * @struct
	 */
	var Hash = /** @class */ (function () {
	    function Hash() {
	        /**
	         * The block size for the hasher.
	         * @type {number}
	         */
	        this.blockSize = -1;
	    }
	    return Hash;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @extends {Hash}
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function (_super) {
	    tslib_1.__extends(Sha1, _super);
	    function Sha1() {
	        var _this = _super.call(this) || this;
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        _this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        _this.total_ = 0;
	        _this.blockSize = 512 / 8;
	        _this.pad_[0] = 128;
	        for (var i = 1; i < _this.blockSize; ++i) {
	            _this.pad_[i] = 0;
	        }
	        _this.reset();
	        return _this;
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
	     * @param {number=} opt_offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, opt_offset) {
	        if (!opt_offset) {
	            opt_offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(opt_offset) << 24) |
	                        (buf.charCodeAt(opt_offset + 1) << 16) |
	                        (buf.charCodeAt(opt_offset + 2) << 8) |
	                        buf.charCodeAt(opt_offset + 3);
	                opt_offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[opt_offset] << 24) |
	                        (buf[opt_offset + 1] << 16) |
	                        (buf[opt_offset + 2] << 8) |
	                        buf[opt_offset + 3];
	                opt_offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, opt_length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (opt_length === undefined) {
	            opt_length = bytes.length;
	        }
	        var lengthMinusBlock = opt_length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < opt_length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf == 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += opt_length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}(Hash));
	
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} minCount The minimum number of arguments to allow for the function call
	 * @param {!number} maxCount The maximum number of argument to allow for the function call
	 * @param {!number} argCount The actual number of arguments provided.
	 */
	var validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} argumentNumber The index of the argument
	 * @param {boolean} optional Whether or not the argument is optional
	 * @return {!string} The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	/**
	 * @param {!string} fnName
	 * @param {!number} argumentNumber
	 * @param {!string} namespace
	 * @param {boolean} optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace)
	        return;
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback)
	        return;
	    if (typeof callback !== 'function')
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	}
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context)
	        return;
	    if (typeof context !== 'object' || context === null)
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	var stringToByteArray$1 = function (str) {
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	var stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	exports.assert = assert;
	exports.assertionError = assertionError;
	exports.base64 = base64;
	exports.base64Decode = base64Decode;
	exports.base64Encode = base64Encode;
	exports.CONSTANTS = CONSTANTS;
	exports.deepCopy = deepCopy;
	exports.deepExtend = deepExtend;
	exports.patchProperty = patchProperty;
	exports.Deferred = Deferred;
	exports.getUA = getUA;
	exports.isMobileCordova = isMobileCordova;
	exports.isNodeSdk = isNodeSdk;
	exports.isReactNative = isReactNative;
	exports.ErrorFactory = ErrorFactory;
	exports.FirebaseError = FirebaseError;
	exports.patchCapture = patchCapture;
	exports.jsonEval = jsonEval;
	exports.stringify = stringify;
	exports.decode = decode;
	exports.isAdmin = isAdmin;
	exports.issuedAtTime = issuedAtTime;
	exports.isValidFormat = isValidFormat;
	exports.isValidTimestamp = isValidTimestamp;
	exports.clone = clone;
	exports.contains = contains;
	exports.every = every;
	exports.extend = extend;
	exports.findKey = findKey;
	exports.findValue = findValue;
	exports.forEach = forEach;
	exports.getAnyKey = getAnyKey;
	exports.getCount = getCount;
	exports.getValues = getValues;
	exports.isEmpty = isEmpty;
	exports.isNonNullObject = isNonNullObject;
	exports.map = map;
	exports.safeGet = safeGet;
	exports.querystring = querystring;
	exports.querystringDecode = querystringDecode;
	exports.Sha1 = Sha1;
	exports.async = async;
	exports.createSubscribe = createSubscribe;
	exports.errorPrefix = errorPrefix;
	exports.validateArgCount = validateArgCount;
	exports.validateCallback = validateCallback;
	exports.validateContextObject = validateContextObject;
	exports.validateNamespace = validateNamespace;
	exports.stringLength = stringLength;
	exports.stringToByteArray = stringToByteArray$1;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(9);
	var normalizeHeaderName = __webpack_require__(161);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(47);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(47);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(170);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(37);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(243);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(244);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(75);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(245);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(246);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(247);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(248);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(76);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(35);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(249);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(250);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(251);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(257);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(264);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CCActivityIndicator = __webpack_require__(27);
	
	var _CCActivityIndicator2 = _interopRequireDefault(_CCActivityIndicator);
	
	var _lib = __webpack_require__(40);
	
	__webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-list-view.css'
	
	
	var CCListView = function (_Component) {
	    _inherits(CCListView, _Component);
	
	    function CCListView(props) {
	        _classCallCheck(this, CCListView);
	
	        var _this = _possibleConstructorReturn(this, (CCListView.__proto__ || Object.getPrototypeOf(CCListView)).call(this, props));
	
	        _this.trackScrolling = function () {
	            var _this$props = _this.props,
	                data = _this$props.data,
	                onEndReached = _this$props.onEndReached;
	
	
	            var parent = document.getElementById('listViewParent');
	            var child = document.getElementById('cc_footer');
	            if (_this.isBottom(parent, child)) {
	                console.log('header bottom reached');
	                onEndReached();
	            }
	        };
	
	        _this.state = {};
	        //this._onShow=this._onShow.bind(this);
	        _this.trackScrolling = _this.trackScrolling.bind(_this);
	        _this.isBottom = _this.isBottom.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCListView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //document.addEventListener('scroll', this.trackScrolling);
	        }
	    }, {
	        key: 'isBottom',
	        value: function isBottom(parent, el) {
	            return el.getBoundingClientRect().bottom <= parent.getBoundingClientRect().bottom;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                refreshing = _props.refreshing,
	                onRefresh = _props.onRefresh,
	                onEndReached = _props.onEndReached,
	                onEndReachedThreshold = _props.onEndReachedThreshold,
	                data = _props.data,
	                ListEmptyComponent = _props.ListEmptyComponent,
	                renderItem = _props.renderItem,
	                ListFooterComponent = _props.ListFooterComponent,
	                endReached = _props.endReached,
	                ListEndComponent = _props.ListEndComponent;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container list-view-container', id: 'listViewParent',
	                    style: Object.assign({}, this.props.style),
	                    onScroll: this.trackScrolling },
	                data.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: "scroll vertical" },
	                    data.map(function (item, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            renderItem(item, index)
	                        );
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container list-view-container',
	                            id: "cc_footer" },
	                        endReached ? ListEndComponent ? ListEmptyComponent : _react2.default.createElement(
	                            'h3',
	                            { className: 'list-view-eor' },
	                            (0, _lib.strings)('end_of_results2')
	                        ) : _react2.default.createElement(_CCActivityIndicator2.default, { size: 's' })
	                    ),
	                    ListFooterComponent
	                ) : ListEmptyComponent
	            );
	        }
	    }]);
	
	    return CCListView;
	}(_react.Component);
	
	CCListView.propTypes = {
	    refreshing: _propTypes2.default.bool,
	    onRefresh: _propTypes2.default.func,
	    onEndReached: _propTypes2.default.func,
	    onEndReachedThreshold: _propTypes2.default.number,
	    data: _propTypes2.default.array,
	    ListEmptyComponent: _propTypes2.default.component,
	    renderItem: _propTypes2.default.func,
	    ListFooterComponent: _propTypes2.default.component,
	    endReached: _propTypes2.default.bool,
	    ListEndComponent: _propTypes2.default.component
	};
	CCListView.defaultProps = {
	    refreshing: false,
	    onRefresh: function onRefresh() {},
	    onEndReached: function onEndReached() {},
	    onEndReachedThreshold: 1,
	    data: [],
	    ListEmptyComponent: undefined,
	    renderItem: function renderItem() {},
	    ListFooterComponent: undefined,
	    endReached: false,
	    ListEndComponent: undefined
	};
	exports.default = CCListView;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CCAppEventLogger = __webpack_require__(361);
	
	Object.keys(_CCAppEventLogger).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCAppEventLogger[key];
	    }
	  });
	});
	
	var _CCAxios = __webpack_require__(362);
	
	Object.keys(_CCAxios).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCAxios[key];
	    }
	  });
	});
	
	var _CCNavigationUtils = __webpack_require__(363);
	
	Object.keys(_CCNavigationUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCNavigationUtils[key];
	    }
	  });
	});
	
	var _CCUIUtils = __webpack_require__(84);
	
	Object.keys(_CCUIUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCUIUtils[key];
	    }
	  });
	});
	
	var _CCUtils = __webpack_require__(364);
	
	Object.keys(_CCUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCUtils[key];
	    }
	  });
	});
	
	var _FirebaseUtils = __webpack_require__(365);
	
	Object.keys(_FirebaseUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FirebaseUtils[key];
	    }
	  });
	});
	
	var _i18n = __webpack_require__(370);
	
	Object.keys(_i18n).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _i18n[key];
	    }
	  });
	});
	
	var _ImageUtils = __webpack_require__(366);
	
	Object.keys(_ImageUtils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ImageUtils[key];
	    }
	  });
	});

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Home = undefined;
	
	var _Home = __webpack_require__(411);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Home = _Home2.default;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Leagues = undefined;
	
	var _Leagues = __webpack_require__(414);
	
	var _Leagues2 = _interopRequireDefault(_Leagues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Leagues = _Leagues2.default;

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A container for all of the Logger instances
	 */
	var instances = [];
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
	    LogLevel[LogLevel["INFO"] = 2] = "INFO";
	    LogLevel[LogLevel["WARN"] = 3] = "WARN";
	    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
	})(exports.LogLevel || (exports.LogLevel = {}));
	/**
	 * The default log level
	 */
	var defaultLogLevel = exports.LogLevel.INFO;
	/**
	 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
	 * messages on to their corresponding console counterparts (if the log method
	 * is supported by the current log level)
	 */
	var defaultLogHandler = function (instance, logType) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (logType < instance.logLevel)
	        return;
	    var now = new Date().toISOString();
	    switch (logType) {
	        /**
	         * By default, `console.debug` is not displayed in the developer console (in
	         * chrome). To avoid forcing users to have to opt-in to these logs twice
	         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
	         * logs to the `console.log` function.
	         */
	        case exports.LogLevel.DEBUG:
	            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
	            break;
	        case exports.LogLevel.VERBOSE:
	            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
	            break;
	        case exports.LogLevel.INFO:
	            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
	            break;
	        case exports.LogLevel.WARN:
	            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
	            break;
	        case exports.LogLevel.ERROR:
	            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
	            break;
	        default:
	            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
	    }
	};
	var Logger = /** @class */ (function () {
	    /**
	     * Gives you an instance of a Logger to capture messages according to
	     * Firebase's logging scheme.
	     *
	     * @param name The name that the logs will be associated with
	     */
	    function Logger(name) {
	        this.name = name;
	        /**
	         * The log level of the given Logger instance.
	         */
	        this._logLevel = defaultLogLevel;
	        /**
	         * The log handler for the Logger instance.
	         */
	        this._logHandler = defaultLogHandler;
	        /**
	         * Capture the current instance for later use
	         */
	        instances.push(this);
	    }
	    Object.defineProperty(Logger.prototype, "logLevel", {
	        get: function () {
	            return this._logLevel;
	        },
	        set: function (val) {
	            if (!(val in exports.LogLevel)) {
	                throw new TypeError('Invalid value assigned to `logLevel`');
	            }
	            this._logLevel = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Logger.prototype, "logHandler", {
	        get: function () {
	            return this._logHandler;
	        },
	        set: function (val) {
	            if (typeof val !== 'function') {
	                throw new TypeError('Value assigned to `logHandler` must be a function');
	            }
	            this._logHandler = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * The functions below are all based on the `console` interface
	     */
	    Logger.prototype.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, [this, exports.LogLevel.DEBUG].concat(args));
	    };
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, [this, exports.LogLevel.VERBOSE].concat(args));
	    };
	    Logger.prototype.info = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, [this, exports.LogLevel.INFO].concat(args));
	    };
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, [this, exports.LogLevel.WARN].concat(args));
	    };
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, [this, exports.LogLevel.ERROR].concat(args));
	    };
	    return Logger;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function setLogLevel(level) {
	    instances.forEach(function (inst) {
	        inst.logLevel = level;
	    });
	}
	
	exports.setLogLevel = setLogLevel;
	exports.Logger = Logger;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {'use strict';
	
	__webpack_require__(144);
	
	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;
	
	function noop() {}
	
	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}
	
	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  this._state = 0;
	  this._handled = false;
	  this._value = undefined;
	  this._deferreds = [];
	
	  doResolve(fn, this);
	}
	
	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}
	
	function resolve(self, newValue) {
	  try {
	    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}
	
	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}
	
	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }
	
	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}
	
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}
	
	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  var prom = new this.constructor(noop);
	
	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};
	
	Promise.prototype['finally'] = function(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      return constructor.resolve(callback()).then(function() {
	        return constructor.reject(reason);
	      });
	    }
	  );
	};
	
	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!arr || typeof arr.length === 'undefined')
	      throw new TypeError('Promise.all accepts an array');
	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	
	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }
	
	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};
	
	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function(values) {
	  return new Promise(function(resolve, reject) {
	    for (var i = 0, len = values.length; i < len; i++) {
	      values[i].then(resolve, reject);
	    }
	  });
	};
	
	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn =
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };
	
	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	  }
	};
	
	var globalNS = (function() {
	  // the only reliable means to get the global object is
	  // `Function('return this')()`
	  // However, this causes CSP violations in Chrome apps.
	  if (typeof self !== 'undefined') {
	    return self;
	  }
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	  if (typeof global !== 'undefined') {
	    return global;
	  }
	  throw new Error('unable to locate global object');
	})();
	
	if (!globalNS.Promise) {
	  globalNS.Promise = Promise;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});
	
	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.5.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;
	
	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	var document = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document) && _isObject(document.createElement);
	var _domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	var dP = Object.defineProperty;
	
	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	var _objectDp = {
		f: f
	};
	
	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	var _redefine = createCommonjsModule(function (module) {
	var SRC = _uid('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	_core.inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === _global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    _hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    _hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	});
	
	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	// optional / simple context binding
	
	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) _redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) _hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;
	
	var toString = {}.toString;
	
	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	
	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	// 7.1.13 ToObject(argument)
	
	var _toObject = function (it) {
	  return Object(_defined(it));
	};
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	// 7.1.15 ToLength
	
	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	// 7.2.2 IsArray(argument)
	
	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};
	
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});
	var _shared = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');
	
	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	});
	
	var SPECIES = _wks('species');
	
	var _arraySpeciesConstructor = function (original) {
	  var C;
	  if (_isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
	    if (_isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	
	
	var _arraySpeciesCreate = function (original, length) {
	  return new (_arraySpeciesConstructor(original))(length);
	};
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	
	
	
	
	
	var _arrayMethods = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || _arraySpeciesCreate;
	  return function ($this, callbackfn, that) {
	    var O = _toObject($this);
	    var self = _iobject(O);
	    var f = _ctx(callbackfn, that, 3);
	    var length = _toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = _wks('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
	var _addToUnscopables = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	
	var $find = _arrayMethods(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	_export(_export.P + _export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY);
	
	var find = _core.Array.find;
	
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	
	var $find$1 = _arrayMethods(6);
	var KEY$1 = 'findIndex';
	var forced$1 = true;
	// Shouldn't skip holes
	if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
	_export(_export.P + _export.F * forced$1, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY$1);
	
	var findIndex = _core.Array.findIndex;
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	
	
	var _toIobject = function (it) {
	  return _iobject(_defined(it));
	};
	
	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};
	
	// false -> Array#indexOf
	// true  -> Array#includes
	
	
	
	var _arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	var shared = _shared('keys');
	
	var _sharedKey = function (key) {
	  return shared[key] || (shared[key] = _uid(key));
	};
	
	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO = _sharedKey('IE_PROTO');
	
	var _objectKeysInternal = function (object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (_has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	// IE 8- don't enum bug keys
	var _enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	
	
	
	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};
	
	var f$1 = Object.getOwnPropertySymbols;
	
	var _objectGops = {
		f: f$1
	};
	
	var f$2 = {}.propertyIsEnumerable;
	
	var _objectPie = {
		f: f$2
	};
	
	// 19.1.2.1 Object.assign(target, source, ...)
	
	
	
	
	
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	var _objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = _toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = _objectGops.f;
	  var isEnum = _objectPie.f;
	  while (aLen > index) {
	    var S = _iobject(arguments[index++]);
	    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;
	
	// 19.1.3.1 Object.assign(target, source)
	
	
	_export(_export.S + _export.F, 'Object', { assign: _objectAssign });
	
	var assign = _core.Object.assign;
	
	// 7.2.8 IsRegExp(argument)
	
	
	var MATCH = _wks('match');
	var _isRegexp = function (it) {
	  var isRegExp;
	  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
	};
	
	// helper for String#{startsWith, endsWith, includes}
	
	
	
	var _stringContext = function (that, searchString, NAME) {
	  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(_defined(that));
	};
	
	var MATCH$1 = _wks('match');
	var _failsIsRegexp = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH$1] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};
	
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = _stringContext(this, searchString, STARTS_WITH);
	    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});
	
	var startsWith = _core.String.startsWith;
	
	var _stringRepeat = function repeat(count) {
	  var str = String(_defined(this));
	  var res = '';
	  var n = _toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};
	
	_export(_export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: _stringRepeat
	});
	
	var repeat = _core.String.repeat;
	
	var _meta = createCommonjsModule(function (module) {
	var META = _uid('meta');
	
	
	var setDesc = _objectDp.f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !_fails(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	});
	var _meta_1 = _meta.KEY;
	var _meta_2 = _meta.NEED;
	var _meta_3 = _meta.fastKey;
	var _meta_4 = _meta.getWeak;
	var _meta_5 = _meta.onFreeze;
	
	var def = _objectDp.f;
	
	var TAG = _wks('toStringTag');
	
	var _setToStringTag = function (it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	var f$3 = _wks;
	
	var _wksExt = {
		f: f$3
	};
	
	var _library = false;
	
	var defineProperty = _objectDp.f;
	var _wksDefine = function (name) {
	  var $Symbol = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
	};
	
	// all enumerable object keys, includes symbols
	
	
	
	var _enumKeys = function (it) {
	  var result = _objectKeys(it);
	  var getSymbols = _objectGops.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = _objectPie.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};
	
	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	var document$1 = _global.document;
	var _html = document$1 && document$1.documentElement;
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	
	
	
	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE$1 = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  return createDict();
	};
	
	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$1] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	
	var hiddenKeys = _enumBugKeys.concat('length', 'prototype');
	
	var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return _objectKeysInternal(O, hiddenKeys);
	};
	
	var _objectGopn = {
		f: f$4
	};
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	
	var gOPN = _objectGopn.f;
	var toString$1 = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	var f$5 = function getOwnPropertyNames(it) {
	  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
	};
	
	var _objectGopnExt = {
		f: f$5
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = _toIobject(O);
	  P = _toPrimitive(P, true);
	  if (_ie8DomDefine) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
	};
	
	var _objectGopd = {
		f: f$6
	};
	
	// ECMAScript 6 symbols shim
	
	
	
	
	
	var META = _meta.KEY;
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var gOPD$1 = _objectGopd.f;
	var dP$1 = _objectDp.f;
	var gOPN$1 = _objectGopnExt.f;
	var $Symbol = _global.Symbol;
	var $JSON = _global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE$2 = 'prototype';
	var HIDDEN = _wks('_hidden');
	var TO_PRIMITIVE = _wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = _shared('symbol-registry');
	var AllSymbols = _shared('symbols');
	var OPSymbols = _shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE$2];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = _global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = _descriptors && _fails(function () {
	  return _objectCreate(dP$1({}, 'a', {
	    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD$1(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP$1(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
	} : dP$1;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  _anObject(it);
	  key = _toPrimitive(key, true);
	  _anObject(D);
	  if (_has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP$1(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  _anObject(it);
	  var keys = _enumKeys(P = _toIobject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = _toPrimitive(key, true));
	  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
	  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = _toIobject(it);
	  key = _toPrimitive(key, true);
	  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
	  var D = gOPD$1(it, key);
	  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN$1(_toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, _propertyDesc(1, value));
	    };
	    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
	    return this._k;
	  });
	
	  _objectGopd.f = $getOwnPropertyDescriptor;
	  _objectDp.f = $defineProperty;
	  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
	  _objectPie.f = $propertyIsEnumerable;
	  _objectGops.f = $getOwnPropertySymbols;
	
	  if (_descriptors && !_library) {
	    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  _wksExt.f = function (name) {
	    return wrap(_wks(name));
	  };
	}
	
	_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);
	
	_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return _has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!_isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	_setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	_setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	_setToStringTag(_global.JSON, 'JSON', true);
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	
	var TAG$1 = _wks('toStringTag');
	// ES3 wrong here
	var ARG = _cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	var _classof = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
	    // builtinTag case
	    : ARG ? _cof(O)
	    // ES3 arguments fallback
	    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	// 19.1.3.6 Object.prototype.toString()
	
	var test = {};
	test[_wks('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  _redefine(Object.prototype, 'toString', function toString() {
	    return '[object ' + _classof(this) + ']';
	  }, true);
	}
	
	_wksDefine('asyncIterator');
	
	_wksDefine('observable');
	
	var symbol = _core.Symbol;
	
	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	var _iterators = {};
	
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	_hide(IteratorPrototype, _wks('iterator'), function () { return this; });
	
	var _iterCreate = function (Constructor, NAME, next) {
	  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
	  _setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	
	
	var IE_PROTO$2 = _sharedKey('IE_PROTO');
	var ObjectProto$1 = Object.prototype;
	
	var _objectGpo = Object.getPrototypeOf || function (O) {
	  O = _toObject(O);
	  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto$1 : null;
	};
	
	var ITERATOR = _wks('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  _iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      _setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    _hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  _iterators[NAME] = $default;
	  _iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) _redefine(proto, key, methods[key]);
	    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	var $at = _stringAt(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	_iterDefine(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});
	
	var _iterStep = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
	  this._t = _toIobject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return _iterStep(1);
	  }
	  if (kind == 'keys') return _iterStep(0, index);
	  if (kind == 'values') return _iterStep(0, O[index]);
	  return _iterStep(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	_iterators.Arguments = _iterators.Array;
	
	_addToUnscopables('keys');
	_addToUnscopables('values');
	_addToUnscopables('entries');
	
	var ITERATOR$1 = _wks('iterator');
	var TO_STRING_TAG = _wks('toStringTag');
	var ArrayValues = _iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = _global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR$1]) _hide(proto, ITERATOR$1, ArrayValues);
	    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
	    _iterators[NAME] = ArrayValues;
	    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
	  }
	}
	
	var iterator = _wksExt.f('iterator');
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138).setImmediate, (function() { return this; }())))

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(147);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	var settle = __webpack_require__(153);
	var buildURL = __webpack_require__(156);
	var parseHeaders = __webpack_require__(162);
	var isURLSameOrigin = __webpack_require__(160);
	var createError = __webpack_require__(50);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(155);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(158);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(152);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(23);
	
	var _PathUtils = __webpack_require__(17);
	
	var _createTransitionManager = __webpack_require__(32);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(23);
	
	var _PathUtils = __webpack_require__(17);
	
	var _createTransitionManager = __webpack_require__(32);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(17);
	
	var _LocationUtils = __webpack_require__(23);
	
	var _createTransitionManager = __webpack_require__(32);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 57 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(199);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2018, Alibaba Group.
	 * Copyrights licensed under the BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var intl = _interopDefault(__webpack_require__(186));
	var React = _interopDefault(__webpack_require__(212));
	var IntlMessageFormat = _interopDefault(__webpack_require__(180));
	var escapeHtml = _interopDefault(__webpack_require__(169));
	var cookie = _interopDefault(__webpack_require__(166));
	var queryParser = _interopDefault(__webpack_require__(198));
	var load = _interopDefault(__webpack_require__(190));
	var invariant = _interopDefault(__webpack_require__(12));
	__webpack_require__(165);
	var merge = _interopDefault(__webpack_require__(191));
	var isElectron = _interopDefault(__webpack_require__(188));
	
	/**
	 * Currency code list
	 * https://www.currency-iso.org/en/home/tables/table-a1.html
	 */
	var currency = ["AFN", "EUR", "ALL", "DZD", "USD", "AOA", "XCD", "ARS", "AMD", "AWG", "AUD", "AZN", "BSD", "BHD", "BDT", "BBD", "BYN", "BZD", "XOF", "BMD", "INR", "BTN", "BOB", "BOV", "BAM", "BWP", "NOK", "BRL", "BND", "BGN", "BIF", "CVE", "KHR", "XAF", "CAD", "KYD", "CLP", "CLF", "CNY", "COP", "COU", "KMF", "CDF", "NZD", "CRC", "HRK", "CUP", "CUC", "ANG", "CZK", "DKK", "DJF", "DOP", "EGP", "SVC", "ERN", "ETB", "FKP", "FJD", "XPF", "GMD", "GEL", "GHS", "GIP", "GTQ", "GBP", "GNF", "GYD", "HTG", "HNL", "HKD", "HUF", "ISK", "IDR", "XDR", "IRR", "IQD", "ILS", "JMD", "JPY", "JOD", "KZT", "KES", "KPW", "KRW", "KWD", "KGS", "LAK", "LBP", "LSL", "ZAR", "LRD", "LYD", "CHF", "MOP", "MKD", "MGA", "MWK", "MYR", "MVR", "MRO", "MUR", "XUA", "MXN", "MXV", "MDL", "MNT", "MAD", "MZN", "MMK", "NAD", "NPR", "NIO", "NGN", "OMR", "PKR", "PAB", "PGK", "PYG", "PEN", "PHP", "PLN", "QAR", "RON", "RUB", "RWF", "SHP", "WST", "STD", "SAR", "RSD", "SCR", "SLL", "SGD", "XSU", "SBD", "SOS", "SSP", "LKR", "SDG", "SRD", "SZL", "SEK", "CHE", "CHW", "SYP", "TWD", "TJS", "TZS", "THB", "TOP", "TTD", "TND", "TRY", "TMT", "UGX", "UAH", "AED", "USN", "UYU", "UYI", "UZS", "VUV", "VEF", "VND", "YER", "ZMW", "ZWL", "XBA", "XBB", "XBC", "XBD", "XTS", "XXX", "XAU", "XPD", "XPT", "XAG"];
	
	var numberFormat = {};
	
	for (var i = 0; i < currency.length; i++) {
	  numberFormat[currency[i]] = {
	    style: 'currency',
	    currency: currency[i]
	  };
	}
	
	var defaultFormats = {
	  number: numberFormat
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var COMMON_LOCALE_DATA_URLS = {
	  en: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/en.js",
	  zh: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/zh.js",
	  fr: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/fr.js",
	  ja: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/ja.js",
	  de: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/de.js",
	  es: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/es.js",
	  ko: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/ko.js",
	  pt: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/pt.js",
	  it: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/it.js",
	  ru: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/ru.js",
	  pl: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/pl.js",
	  nl: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/nl.js",
	  sv: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/sv.js"
	};
	
	var isBrowser = !isElectron() && typeof window !== "undefined";
	
	String.prototype.defaultMessage = String.prototype.d = function (msg) {
	  return this || msg || "";
	};
	
	var ReactIntlUniversal = function () {
	  function ReactIntlUniversal() {
	    classCallCheck(this, ReactIntlUniversal);
	
	    this.options = {
	      currentLocale: null, // Current locale such as 'en-US'
	      urlLocaleKey: null, // URL's query Key to determine locale. Example: if URL=http://localhost?lang=en-US, then set it 'lang'
	      cookieLocaleKey: null, // Cookie's Key to determine locale. Example: if cookie=lang:en-US, then set it 'lang'
	      locales: {}, // app locale data like {"en-US":{"key1":"value1"},"zh-CN":{"key1":"值1"}}
	      warningHandler: console.warn // ability to accumulate missing messages using third party services like Sentry
	    };
	  }
	
	  /**
	   * Get the formatted message by key
	   * @param {string} key The string representing key in locale data file
	   * @param {Object} variables Variables in message
	   * @returns {string} message
	   */
	
	
	  createClass(ReactIntlUniversal, [{
	    key: "get",
	    value: function get$$1(key, variables) {
	      invariant(key, "key is required");
	      var _options = this.options,
	          locales = _options.locales,
	          currentLocale = _options.currentLocale,
	          formats = _options.formats;
	
	
	      if (!locales || !locales[currentLocale]) {
	        return "";
	      }
	      var msg = this.getDescendantProp(locales[currentLocale], key);
	      if (msg == null) {
	        this.options.warningHandler("react-intl-universal key \"" + key + "\" not defined in " + currentLocale);
	        return "";
	      }
	      if (variables) {
	        variables = Object.assign({}, variables);
	        // HTML message with variables. Escape it to avoid XSS attack.
	        for (var i in variables) {
	          var value = variables[i];
	          if (typeof value === "string" && value.indexOf("<") >= 0 && value.indexOf(">") >= 0) {
	            value = escapeHtml(value);
	          }
	          variables[i] = value;
	        }
	      }
	
	      try {
	        msg = new IntlMessageFormat(msg, currentLocale, formats); // TODO memorize
	        msg = msg.format(variables);
	        return msg;
	      } catch (err) {
	        this.options.warningHandler("react-intl-universal format message failed for key='" + key + "'", err);
	        return "";
	      }
	    }
	
	    /**
	     * Get the formatted html message by key.
	     * @param {string} key The string representing key in locale data file
	     * @param {Object} variables Variables in message
	     * @returns {React.Element} message
	    */
	
	  }, {
	    key: "getHTML",
	    value: function getHTML(key, variables) {
	      var msg = this.get(key, variables);
	      if (msg) {
	        var el = React.createElement("span", {
	          dangerouslySetInnerHTML: {
	            __html: msg
	          }
	        });
	        // when key exists, it should still return element if there's defaultMessage() after getHTML()
	        var defaultMessage = function defaultMessage() {
	          return el;
	        };
	        return Object.assign({ defaultMessage: defaultMessage, d: defaultMessage }, el);
	      }
	      return "";
	    }
	
	    /**
	     * As same as get(...) API
	     * @param {Object} options 
	     * @param {string} options.id 
	     * @param {string} options.defaultMessage
	     * @param {Object} variables Variables in message
	     * @returns {string} message
	    */
	
	  }, {
	    key: "formatMessage",
	    value: function formatMessage(messageDescriptor, variables) {
	      var id = messageDescriptor.id,
	          defaultMessage = messageDescriptor.defaultMessage;
	
	      return this.get(id, variables).defaultMessage(defaultMessage);
	    }
	
	    /**
	     * As same as getHTML(...) API
	     * @param {Object} options 
	     * @param {string} options.id 
	     * @param {React.Element} options.defaultMessage
	     * @param {Object} variables Variables in message
	     * @returns {React.Element} message
	    */
	
	  }, {
	    key: "formatHTMLMessage",
	    value: function formatHTMLMessage(messageDescriptor, variables) {
	      var id = messageDescriptor.id,
	          defaultMessage = messageDescriptor.defaultMessage;
	
	      return this.getHTML(id, variables).defaultMessage(defaultMessage);
	    }
	
	    /**
	     * Helper: determine user's locale via URL, cookie, and browser's language.
	     * You may not this API, if you have other rules to determine user's locale.
	     * @param {string} options.urlLocaleKey URL's query Key to determine locale. Example: if URL=http://localhost?lang=en-US, then set it 'lang'
	     * @param {string} options.cookieLocaleKey Cookie's Key to determine locale. Example: if cookie=lang:en-US, then set it 'lang'
	     * @returns {string} determined locale such as 'en-US'
	     */
	
	  }, {
	    key: "determineLocale",
	    value: function determineLocale() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return this.getLocaleFromURL(options) || this.getLocaleFromCookie(options) || this.getLocaleFromBrowser();
	    }
	
	    /**
	     * Initialize properties and load CLDR locale data according to currentLocale
	     * @param {Object} options
	     * @param {string} options.currentLocale Current locale such as 'en-US'
	     * @param {string} options.locales App locale data like {"en-US":{"key1":"value1"},"zh-CN":{"key1":"值1"}}
	     * @returns {Promise}
	     */
	
	  }, {
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      invariant(options.currentLocale, "options.currentLocale is required");
	      invariant(options.locales, "options.locales is required");
	
	      Object.assign(this.options, options);
	
	      this.options.formats = Object.assign({}, this.options.formats, defaultFormats);
	
	      return new Promise(function (resolve, reject) {
	
	        var lang = _this.options.currentLocale.split('-')[0].split('_')[0];
	        var langUrl = COMMON_LOCALE_DATA_URLS[lang];
	        if (isBrowser) {
	          if (langUrl) {
	            load(langUrl, function (err, script) {
	              if (err) {
	                reject(err);
	              } else {
	                resolve();
	              }
	            });
	          } else {
	            _this.options.warningHandler("lang \"" + lang + "\" is not supported.");
	            resolve();
	          }
	        } else {
	          // For Node.js, common locales are added in the application
	          resolve();
	        }
	      });
	    }
	
	    /**
	     * Get the inital options 
	     */
	
	  }, {
	    key: "getInitOptions",
	    value: function getInitOptions() {
	      return this.options;
	    }
	
	    /**
	     * Load more locales after init
	     */
	
	  }, {
	    key: "load",
	    value: function load$$1(locales) {
	      merge(this.options.locales, locales);
	    }
	  }, {
	    key: "getLocaleFromCookie",
	    value: function getLocaleFromCookie(options) {
	      var cookieLocaleKey = options.cookieLocaleKey;
	
	      if (cookieLocaleKey) {
	        var params = cookie.parse(document.cookie);
	        return params && params[cookieLocaleKey];
	      }
	    }
	  }, {
	    key: "getLocaleFromURL",
	    value: function getLocaleFromURL(options) {
	      var urlLocaleKey = options.urlLocaleKey;
	
	      if (urlLocaleKey) {
	        var query = location.search.split("?");
	        if (query.length >= 2) {
	          var params = queryParser.parse(query[1]);
	          return params && params[urlLocaleKey];
	        }
	      }
	    }
	  }, {
	    key: "getDescendantProp",
	    value: function getDescendantProp(locale, key) {
	
	      if (locale[key]) {
	        return locale[key];
	      }
	
	      var msg = key.split(".").reduce(function (a, b) {
	        return a != undefined ? a[b] : a;
	      }, locale);
	
	      return msg;
	    }
	  }, {
	    key: "getLocaleFromBrowser",
	    value: function getLocaleFromBrowser() {
	      return navigator.language || navigator.userLanguage;
	    }
	  }]);
	  return ReactIntlUniversal;
	}();
	
	module.exports = new ReactIntlUniversal();


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(15);
	
	var ReactNoopUpdateQueue = __webpack_require__(64);
	
	var canDefineProperty = __webpack_require__(65);
	var emptyObject = __webpack_require__(21);
	var invariant = __webpack_require__(10);
	var lowPriorityWarning = __webpack_require__(209);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(22);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var NODE_ENV = ("production");
	
	var invariant$3 = function(condition, format, a, b, c, d, e, f) {
	  if (NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	var invariant_1$2 = invariant$3;
	
	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	var camel2hyphen_1 = camel2hyphen;
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen_1(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and ';
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', ';
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	var json2mq_1 = json2mq;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * Conditionally renders based on whether or not a media query matches.
	 */
	
	var Media = function (_React$Component) {
	  inherits(Media, _React$Component);
	
	  function Media() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Media);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      matches: _this.props.defaultMatches
	    }, _this.updateMatches = function () {
	      return _this.setState({ matches: _this.mediaQueryList.matches });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Media.prototype.componentWillMount = function componentWillMount() {
	    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object") return;
	
	    var targetWindow = this.props.targetWindow || window;
	
	    invariant_1$2(typeof targetWindow.matchMedia === "function", "<Media targetWindow> does not support `matchMedia`.");
	
	    var query = this.props.query;
	
	    if (typeof query !== "string") query = json2mq_1(query);
	
	    this.mediaQueryList = targetWindow.matchMedia(query);
	    this.mediaQueryList.addListener(this.updateMatches);
	    this.updateMatches();
	  };
	
	  Media.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.mediaQueryList.removeListener(this.updateMatches);
	  };
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        render = _props.render;
	    var matches = this.state.matches;
	
	
	    return render ? matches ? render() : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
	    ? matches ? React.Children.only(children) : null : null : null;
	  };
	
	  return Media;
	}(React.Component);
	
	Media.propTypes = {
	  defaultMatches: propTypes.bool,
	  query: propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]).isRequired,
	  render: propTypes.func,
	  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
	  targetWindow: propTypes.object
	};
	Media.defaultProps = {
	  defaultMatches: true
	};
	
	module.exports = Media;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(56);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(231);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _Subscription = __webpack_require__(227);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(72);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(74);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(240);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 73 */
[667, 238],
/* 74 */
[666, 241],
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(26);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(254);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(77);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(38);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCCoinPile = function (_Component) {
	    _inherits(CCCoinPile, _Component);
	
	    function CCCoinPile(props) {
	        _classCallCheck(this, CCCoinPile);
	
	        var _this = _possibleConstructorReturn(this, (CCCoinPile.__proto__ || Object.getPrototypeOf(CCCoinPile)).call(this, props));
	
	        _this.state = {};
	        _this._getIcon = _this._getIcon.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCCoinPile, [{
	        key: '_getIcon',
	        value: function _getIcon(theme, icon, uiDisabled) {
	            var finalIcon = icon;
	            if (!icon) finalIcon = theme === 'dark' ? _ccImports.images.icons.coinsPileDark : _ccImports.images.icons.coinsPile;
	            if (uiDisabled) finalIcon = _ccImports.images.icons.disabled.coinsPile;
	            return finalIcon;
	        }
	    }, {
	        key: '_getFontColor',
	        value: function _getFontColor(theme) {
	            var color = theme == 'dark' ? _ccImports.colors.theme2.font_color1 : _ccImports.colors.theme2.font_color3;
	            color = this.props.uiDisabled == true ? _ccImports.colors.theme2.font_color5 : color;
	            return color;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                coins = _props.coins,
	                theme = _props.theme,
	                icon = _props.icon,
	                className = _props.className,
	                textClass = _props.textClass,
	                iconClass = _props.iconClass,
	                disabled = _props.disabled,
	                uiDisabled = _props.uiDisabled;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, onClick: this.props.onClick, style: Object.assign({}, this.props.style), disabled: disabled },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container', style: { alignItems: 'center' } },
	                    _react2.default.createElement('img', { className: 'flex-container ' + iconClass, src: this._getIcon(theme, icon, uiDisabled),
	                        style: { alignItems: 'center' } }),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: textClass, style: { alignItems: 'center', marginBottom: 3, color: this._getFontColor(theme) } },
	                        coins
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCCoinPile;
	}(_react.Component);
	
	CCCoinPile.propTypes = {
	    onPress: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool,
	    coins: _propTypes2.default.number,
	    theme: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    uiDisabled: _propTypes2.default.bool
	};
	CCCoinPile.defaultProps = {
	    onClick: function onClick() {},
	    disabled: false,
	    coins: 0,
	    theme: 'default',
	
	    icon: undefined,
	    className: '',
	    textClass: '',
	    iconClass: '',
	    uiDisabled: false
	};
	exports.default = CCCoinPile;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCIcon = function (_Component) {
	    _inherits(CCIcon, _Component);
	
	    function CCIcon(props) {
	        _classCallCheck(this, CCIcon);
	
	        var _this = _possibleConstructorReturn(this, (CCIcon.__proto__ || Object.getPrototypeOf(CCIcon)).call(this, props));
	
	        _this.state = {};
	        _this._getIcon = _this._getIcon.bind(_this);
	        _this._onPress = _this._onPress.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCIcon, [{
	        key: '_getIcon',
	        value: function _getIcon() {
	            return (0, _ccImports.getIcon)(this.props.type);
	        }
	    }, {
	        key: '_onPress',
	        value: function _onPress() {
	            var analytics = this.props.analytics;
	
	            if (analytics && analytics.event) {
	                var event = analytics.event,
	                    params = analytics.params;
	
	                _ccImports.CCAppEventLogger.logAppEvent(event, params ? params : {});
	            }
	            this.props.onPress && this.props.onPress();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container icon-container ' + this.props.className, onClick: this._onPress, disabled: this.props.disabled },
	                _react2.default.createElement('img', { style: Object.assign({ resizeMode: 'cover' }), src: this._getIcon() })
	            );
	        }
	    }]);
	
	    return CCIcon;
	}(_react.Component);
	
	CCIcon.propTypes = {
	    onPress: _propTypes2.default.func,
	    type: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    analytics: _propTypes2.default.object,
	    className: _propTypes2.default.string
	};
	CCIcon.defaultProps = {
	    onPress: function onPress() {},
	    type: 'none',
	    disabled: false,
	    analytics: {},
	    className: 'cc-icon-xs'
	};
	exports.default = CCIcon;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CCActivityIndicator = __webpack_require__(27);
	
	var _CCActivityIndicator2 = _interopRequireDefault(_CCActivityIndicator);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-section-list.css'
	
	
	var CCSectionList = function (_Component) {
	    _inherits(CCSectionList, _Component);
	
	    function CCSectionList(props) {
	        _classCallCheck(this, CCSectionList);
	
	        var _this = _possibleConstructorReturn(this, (CCSectionList.__proto__ || Object.getPrototypeOf(CCSectionList)).call(this, props));
	
	        _this.trackScrolling = function () {
	            var _this$props = _this.props,
	                data = _this$props.data,
	                onEndReached = _this$props.onEndReached;
	
	
	            var parent = document.getElementById('listViewParent');
	            var child = document.getElementById('cc_footer');
	            if (_this.isBottom(parent, child)) {
	                console.log('header bottom reached');
	                onEndReached();
	            }
	        };
	
	        _this.state = {};
	        //this._onShow=this._onShow.bind(this);
	        _this.trackScrolling = _this.trackScrolling.bind(_this);
	        _this.isBottom = _this.isBottom.bind(_this);
	        return _this;
	    }
	
	    /*_onShow(length, endThreshold, index) {
	        console.log(length,endThreshold,index);
	        console.log("------------------------------------------")
	        if(length-1-endThreshold==index){
	            this.props.onEndReached();
	        }
	    }*/
	
	    _createClass(CCSectionList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //document.addEventListener('scroll', this.trackScrolling);
	        }
	    }, {
	        key: 'isBottom',
	        value: function isBottom(parent, el) {
	            return el.getBoundingClientRect().bottom <= parent.getBoundingClientRect().bottom;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                refreshing = _props.refreshing,
	                onRefresh = _props.onRefresh,
	                onEndReached = _props.onEndReached,
	                onEndReachedThreshold = _props.onEndReachedThreshold,
	                scrollClassName = _props.scrollClassName,
	                sections = _props.sections,
	                ListEmptyComponent = _props.ListEmptyComponent,
	                renderItem = _props.renderItem,
	                renderSectionHeader = _props.renderSectionHeader,
	                ListFooterComponent = _props.ListFooterComponent,
	                endReached = _props.endReached,
	                ListEndComponent = _props.ListEndComponent;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container section-container', id: 'listViewParent',
	                    style: Object.assign({}, this.props.style),
	                    onScroll: this.trackScrolling },
	                sections.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: "scroll vertical " + scrollClassName },
	                    sections.map(function (section, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            renderSectionHeader(section, index),
	                            section && section.data && _react2.default.createElement(
	                                'div',
	                                null,
	                                section.data.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        renderItem(item)
	                                    );
	                                })
	                            )
	                        );
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container section-container',
	                            id: "cc_footer" },
	                        endReached ? ListEndComponent ? ListEndComponent : _react2.default.createElement(
	                            'h3',
	                            { className: 'section-list-eor' },
	                            (0, _ccImports.strings)('end_of_results2')
	                        ) : _react2.default.createElement(_CCActivityIndicator2.default, { size: 's' })
	                    )
	                ) : ListEmptyComponent
	            );
	        }
	    }]);
	
	    return CCSectionList;
	}(_react.Component);
	
	CCSectionList.propTypes = {
	    refreshing: _propTypes2.default.bool,
	    onRefresh: _propTypes2.default.bool,
	    onEndReached: _propTypes2.default.func,
	    onEndReachedThreshold: _propTypes2.default.number,
	    ListEmptyComponent: _propTypes2.default.component,
	    renderSectionHeader: _propTypes2.default.func,
	    renderItem: _propTypes2.default.func,
	    ListFooterComponent: _propTypes2.default.component,
	    endReached: _propTypes2.default.bool,
	    sections: _propTypes2.default.array,
	    ListEndComponent: _propTypes2.default.component,
	    scrollClassName: _propTypes2.default.string
	};
	CCSectionList.defaultProps = {
	    refreshing: false,
	    onRefresh: function onRefresh() {},
	    onEndReached: function onEndReached() {},
	    onEndReachedThreshold: 1,
	    sections: [],
	    ListEmptyComponent: undefined,
	    renderItem: function renderItem() {},
	    ListFooterComponent: undefined,
	    endReached: false,
	    ListEndComponent: undefined,
	    scrollClassName: ''
	};
	exports.default = CCSectionList;

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ActionTypes;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ActionTypes = (_ActionTypes = {
	    CREATE_ENTRY: 'CREATE_ENTRY',
	    GET_ENTRIES: 'GET_ENTRIES',
	
	    SHOW_HELP: 'SHOW_HELP',
	
	    GET_LEAGUE: 'GET_LEAGUE',
	    REFRESH_LEAGUE: 'REFRESH_LEAGUE',
	    GET_LEAGUES: 'GET_LEAGUES',
	    PAGINATE_LEAGUES: 'PAGINATE_LEAGUES'
	}, _defineProperty(_ActionTypes, 'REFRESH_LEAGUE', 'REFRESH_LEAGUE'), _defineProperty(_ActionTypes, 'GET_MATCH', 'GET_MATCH'), _defineProperty(_ActionTypes, 'REFRESH_MATCH', 'REFRESH_MATCH'), _defineProperty(_ActionTypes, 'GET_MATCHES', 'GET_MATCHES'), _defineProperty(_ActionTypes, 'GET_REWARD', 'GET_REWARD'), _defineProperty(_ActionTypes, 'UPDATE_REWARD_CLAIM', 'UPDATE_REWARD_CLAIM'), _defineProperty(_ActionTypes, 'GET_NOTIFICATIONS', 'GET_NOTIFICATIONS'), _defineProperty(_ActionTypes, 'GET_NOTIFICATION', 'GET_NOTIFICATION'), _defineProperty(_ActionTypes, 'PAGINATE_NOTIFICATIONS', 'PAGINATE_NOTIFICATIONS'), _defineProperty(_ActionTypes, 'REFRESH_NOTIFICATIONS', 'REFRESH_NOTIFICATIONS'), _defineProperty(_ActionTypes, 'GET_UNSEEN_COUNT', 'GET_UNSEEN_COUNT'), _defineProperty(_ActionTypes, 'UPDATE_SEEN', 'UPDATE_SEEN'), _defineProperty(_ActionTypes, 'GET_PLAYERS', 'GET_PLAYERS'), _defineProperty(_ActionTypes, 'UPDATE_PLAYERS', 'UPDATE_PLAYERS'), _defineProperty(_ActionTypes, 'UPDATE_PLAYER', 'UPDATE_PLAYER'), _defineProperty(_ActionTypes, 'SHARE_FB', 'SHARE_FB'), _defineProperty(_ActionTypes, 'SAVE_USER', 'SAVE_USER'), _defineProperty(_ActionTypes, 'SAVE_USER_FULFILLED', 'SAVE_USER_FULFILLED'), _defineProperty(_ActionTypes, 'RETRIEVE_USER_PENDING', "RETRIEVE_USER_PENDING"), _defineProperty(_ActionTypes, 'RETRIEVE_USER_FULFILLED', 'RETRIEVE_USER_FULFILLED'), _defineProperty(_ActionTypes, 'RETRIEVE_USER_REJECTED', 'RETRIEVE_USER_REJECTED'), _defineProperty(_ActionTypes, 'GET_TRANSACTIONS', 'GET_TRANSACTIONS'), _defineProperty(_ActionTypes, 'GET_USER', 'GET_USER'), _defineProperty(_ActionTypes, 'GET_OR_CREATE_USER', 'GET_OR_CREATE_USER'), _defineProperty(_ActionTypes, 'SIGN_UP_USER', 'SIGN_UP_USER'), _defineProperty(_ActionTypes, 'SIGN_OUT_USER', 'SIGN_OUT_USER'), _defineProperty(_ActionTypes, 'ANONYMOUS_USER_IN', 'ANONYMOUS_USER_IN'), _defineProperty(_ActionTypes, 'UPDATE_SHOW_HELP', 'UPDATE_SHOW_HELP'), _defineProperty(_ActionTypes, 'UPDATE_PHONE_NUMBER', 'UPDATE_PHONE_NUMBER'), _defineProperty(_ActionTypes, 'UPDATE_INVITED_BY', 'UPDATE_INVITED_BY'), _defineProperty(_ActionTypes, 'UPDATE_SETTINGS', 'UPDATE_SETTINGS'), _defineProperty(_ActionTypes, 'UPDATE_USER', 'UPDATE_USER'), _defineProperty(_ActionTypes, 'SAVE_FAILED_CREDENTIALS', 'SAVE_FAILED_CREDENTIALS'), _defineProperty(_ActionTypes, 'EDITION_CHANGED', 'EDITION_CHANGED'), _defineProperty(_ActionTypes, 'FB_USER_NOT_FOUND', 'FB_USER_NOT_FOUND'), _defineProperty(_ActionTypes, 'HOME', 'HOME'), _defineProperty(_ActionTypes, 'LEAGUES', 'LEAGUES'), _defineProperty(_ActionTypes, 'BACK', 'BACK'), _defineProperty(_ActionTypes, 'OPEN_MODAL', 'OPEN_MODAL'), _defineProperty(_ActionTypes, 'OPEN_LAST_OPEN_MODAL', 'OPEN_LAST_OPEN_MODAL'), _defineProperty(_ActionTypes, 'CLOSE_MODAL', "CLOSE_MODAL"), _defineProperty(_ActionTypes, 'PRE_CLOSE_MODAL', "PRE_CLOSE_MODAL"), _defineProperty(_ActionTypes, 'ADD_TO_CACHE', 'ADD_TO_CACHE'), _defineProperty(_ActionTypes, 'REMOVE_FROM_CACHE', 'REMOVE_FROM_CACHE'), _defineProperty(_ActionTypes, 'SHOW_ALERT', 'SHOW_ALERT'), _defineProperty(_ActionTypes, 'HIDE_ALERT', 'HIDE_ALERT'), _defineProperty(_ActionTypes, 'DIMENSION_CHANGED', 'DIMENSION_CHANGED'), _defineProperty(_ActionTypes, 'GET_LBS', 'GET_LBS'), _defineProperty(_ActionTypes, 'GET_LB_STATUS', 'GET_LB_STATUS'), _defineProperty(_ActionTypes, 'GET_SPONSORS', 'GET_SPONSORS'), _defineProperty(_ActionTypes, 'getCCFulfilled', function getCCFulfilled(action) {
	    return action + '_CC_FULFILLED';
	}), _defineProperty(_ActionTypes, 'getFulfilled', function getFulfilled(action) {
	    return action + '_FULFILLED';
	}), _defineProperty(_ActionTypes, 'getRejected', function getRejected(action) {
	    return action + '_REJECTED';
	}), _defineProperty(_ActionTypes, 'getPending', function getPending(action) {
	    return action + '_PENDING';
	}), _ActionTypes);
	
	exports.default = ActionTypes;

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DataActionTypes = {
	    GET: 'GET',
	    PAGINATE: 'PAGINATE',
	    MANUAL_REFRESH: 'MANUAL_REFRESH',
	    AUTO_REFRESH: 'AUTO_REFRESH',
	    CREATE: 'CREATE',
	    GET_RESET: 'GET_RESET',
	    UPDATE: 'UPDATE'
	};
	
	exports.default = DataActionTypes;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(464);
	
	var _ccImports = __webpack_require__(1);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//
	// import './cc_lahout.css'
	// import './cc_lahout_320.css'
	
	var CCLayout = function (_Component) {
	    _inherits(CCLayout, _Component);
	
	    function CCLayout(props) {
	        _classCallCheck(this, CCLayout);
	
	        var _this = _possibleConstructorReturn(this, (CCLayout.__proto__ || Object.getPrototypeOf(CCLayout)).call(this, props));
	
	        _this.state = {};
	        _this._openModal = _this._openModal.bind(_this);
	        _this._getCoins = _this._getCoins.bind(_this);
	        _this._isLoggedIn = _this._isLoggedIn.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCLayout, [{
	        key: "_openModal",
	        value: function _openModal(func, source) {
	            if (this.props.user && this.props.user.user && this.props.user.user.id) {
	                func();
	            } else {
	                this.props.actions.openSignInModal({ source: source });
	            }
	        }
	    }, {
	        key: "_getCoins",
	        value: function _getCoins() {
	            if (this.props.user && this.props.user.user && this.props.user.user.id) {
	                return this.props.user.user.coins;
	            } else {
	                return 1000;
	            }
	        }
	    }, {
	        key: "_isLoggedIn",
	        value: function _isLoggedIn() {
	            if (this.props.user && this.props.user.user && this.props.user.user.id != undefined) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { style: { flex: 1 } },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { flex: 1 } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: 'flex-container header-parent' },
	                            _react2.default.createElement(
	                                "div",
	                                { className: 'flex-container header-inner' },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: 'flex-container menu-left-container' },
	                                    _react2.default.createElement(_ccImports.CCIcon, { className: 'btn cc-more-icon-xxs mgn-r-2', analytics: { event: 'MoreClicked', params: { loggedIn: this._isLoggedIn() } }, onPress: function onPress() {
	                                            _this2.props.actions.openMoreModal();
	                                        }, type: 'menu' })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: 'flex-container' },
	                                    _react2.default.createElement(_ccImports.CCIcon, { className: 'btn cc-more-icon-xxs mgn-r-1', analytics: { event: 'EntriesClicked', params: { loggedIn: this._isLoggedIn() } }, onPress: function onPress() {
	                                            _this2._openModal(_this2.props.actions.openEntriesModal, 'entries');
	                                        }, type: 'trophy' }),
	                                    _react2.default.createElement(_ccImports.CCIcon, { className: 'btn cc-more-icon-xxs mgn-r-3', analytics: { event: 'NotificationsClicked', params: { loggedIn: this._isLoggedIn() } }, onPress: function onPress() {
	                                            _this2._openModal(_this2.props.actions.openNotificationsModal, 'notifications');
	                                        }, type: 'notification' }),
	                                    _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(_ccImports.CCCoins, { loggedIn: this._isLoggedIn(), coins: this._getCoins(),
	                                            style: Object.assign({ marginLeft: '2px', marginRight: '5px' }),
	                                            onCoinsIconPress: function onCoinsIconPress() {
	                                                _this2._openModal(_this2.props.actions.openTransactionsHistoryModal, 'transactions');
	                                            },
	                                            onCoinsPress: function onCoinsPress() {
	                                                _this2._openModal(_this2.props.actions.openTransactionsHistoryModal, 'transactions');
	                                            }
	                                            // onPlusPress={()=>{this._openModal(this.props.actions.openAddCoinsModal, 'AddCoins'
	                                            // )}}
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { flexGrow: 1 } },
	                            _react2.default.createElement(_ccImports.CCModals, null),
	                            this.props.children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCLayout;
	}(_react.Component);
	
	CCLayout.propTypes = {
	    scrollable: _propTypes2.default.bool
	};
	CCLayout.defaultProps = {
	    scrollable: false
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(CCLayout);

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CCUIUtils = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntlUniversal = __webpack_require__(60);
	
	var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);
	
	var _ccImports = __webpack_require__(1);
	
	var _DataActionTypes = __webpack_require__(82);
	
	var _DataActionTypes2 = _interopRequireDefault(_DataActionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { View } from 'react-native'
	var CCUIUtils = {
	
	    getLocaleStr: function getLocaleStr(value) {
	        var locale = _reactIntlUniversal2.default.currentLocale;
	        if (value[locale] === null || value[locale] === undefined || value[locale].length === 0) {
	            return value['en'];
	        } else {
	            return value[locale];
	        }
	    },
	
	    getEmptyListItem: function getEmptyListItem(reqStatus, emptyListTitle) {
	        if (reqStatus == _ccImports.Constants.reqStatus.COM || reqStatus == _ccImports.Constants.reqStatus.FAI) {
	            return _react2.default.createElement(
	                'div',
	                { style: { height: 20, marginTop: 30, alignItems: 'center', justifyContent: 'center', textAlign: 'center' } },
	                _react2.default.createElement(
	                    'h3',
	                    { style: { fontSize: '1vw' } },
	                    emptyListTitle ? emptyListTitle : (0, _ccImports.strings)('end_of_results')
	                )
	            );
	        } else {
	            return _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 'large' });
	        }
	    },
	
	    //updated
	    getListFooter: function getListFooter(reqStatus, type, data) {
	        if (data && data.length == 0) {
	            return _react2.default.createElement('div', null);
	        }
	
	        if ((reqStatus == _ccImports.Constants.reqStatus.COM || reqStatus == _ccImports.Constants.reqStatus.SUC) && type !== _DataActionTypes2.default.GET && type !== undefined || reqStatus === _ccImports.Constants.reqStatus.FAI && type === _DataActionTypes2.default.PAGINATE) {
	            return _react2.default.createElement(
	                'div',
	                { style: { height: 20, marginBottom: 10, alignItems: 'center', justifyContent: 'center' } },
	                _react2.default.createElement('h2', { title: (0, _ccImports.strings)('end_of_results') })
	            );
	        } else {
	            return _react2.default.createElement(
	                'div',
	                { style: { height: 20, marginBottom: 10 } },
	                _react2.default.createElement(_ccImports.CCActivityIndicator, { size: "s" })
	            );
	        }
	    },
	
	    getFlatListFooter: function getFlatListFooter(loading, completed, data) {
	        if (data && data.length === 0) {
	            return _react2.default.createElement('div', null);
	        }
	        if (loading) {
	            return _react2.default.createElement(
	                'div',
	                { style: { height: 20, marginBottom: 10 } },
	                _react2.default.createElement(_ccImports.CCActivityIndicator, { size: "s" })
	            );
	        } else if (completed) {
	            return _react2.default.createElement(
	                'div',
	                { style: { height: 20, marginBottom: 10, alignItems: 'center', justifyContent: 'center' } },
	                _react2.default.createElement('h2', { title: (0, _ccImports.strings)('end_of_results') })
	            );
	        }
	    }
	};
	//TODO
	exports.CCUIUtils = CCUIUtils;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(470);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './DreamTeamEntryCreation.css'
	
	
	var totalSalary = 10000;
	var playersPerTeam = 2;
	
	var DreamTeamEntryCreation = function (_Component) {
	    _inherits(DreamTeamEntryCreation, _Component);
	
	    function DreamTeamEntryCreation(props) {
	        _classCallCheck(this, DreamTeamEntryCreation);
	
	        var _this = _possibleConstructorReturn(this, (DreamTeamEntryCreation.__proto__ || Object.getPrototypeOf(DreamTeamEntryCreation)).call(this, props));
	
	        _this.initialState = {
	            teams: [],
	            remainingSalaryCap: totalSalary,
	            selectedPlayers: [],
	            league: {},
	            error: undefined,
	            created: false
	        };
	
	        _this.state = _this.initialState;
	
	        _this.totalSalary = 10000;
	        _this._populatePlayers = _this._populatePlayers.bind(_this);
	        _this._playerOnLongPress = _this._playerOnLongPress.bind(_this);
	        _this._playerOnPress = _this._playerOnPress.bind(_this);
	        _this._getUpdatedSalaryCap = _this._getUpdatedSalaryCap.bind(_this);
	        _this._getDisableUpdatedTeams = _this._getDisableUpdatedTeams.bind(_this);
	        _this._showSubmit = _this._showSubmit.bind(_this);
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        _this._getSelectedPlayers = _this._getSelectedPlayers.bind(_this);
	        _this._onAck = _this._onAck.bind(_this);
	        return _this;
	    }
	
	    _createClass(DreamTeamEntryCreation, [{
	        key: '_populatePlayers',
	        value: function _populatePlayers(league) {
	            var _this2 = this;
	
	            if (league) {
	                var matchId = league.match.id;
	                var matchesById = this.props.matchesById;
	
	                var match = matchesById[matchId];
	                var teams = [];
	                _lodash2.default.forEach(match.teams, function (team) {
	                    team.players = _lodash2.default.orderBy(team.players, ['salary'], ['desc']);
	                    _lodash2.default.forEach(team.players, function (player) {
	                        _lodash2.default.set(player, 'disabled', false);
	                    });
	                    var existingTeam = _lodash2.default.find(_this2.state.teams, { 'key': team.key });
	                    //user playersPerTeam here to initiate
	                    team.selectedPlayers = [{}, {}];
	                    teams.push(team);
	                });
	
	                this.setState({ teams: teams, selectedPlayers: [], remainingSalaryCap: totalSalary });
	                // this.props.actions.removeFromCache(league.id, this.state);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //console.log("dream team component mount")
	            // console.log("dtem ----- didmount")
	            var league = this.props.league;
	
	            if (league) {
	                var leagueCache = this.props.cache[league.id];
	                if (leagueCache) {
	                    this.setState(leagueCache);
	                } else {
	                    this._populatePlayers(league);
	                    this.setState({ league: league });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	        //console.log("dtem ----- unmount")
	
	
	        /*componentWillReceiveProps(nextProps){
	            if(nextProps.league){
	                const league = nextProps.league;
	                this._populatePlayers(league);
	                this.setState({league});
	            }
	        }*/
	
	    }, {
	        key: '_playerOnPress',
	        value: function _playerOnPress(player, selected, teamIndex) {
	            var teams = this.state.teams;
	            var selectedPlayers = teams[teamIndex].selectedPlayers;
	            _lodash2.default.forEach(teams[teamIndex].selectedPlayers, function (selectedPlayer, index) {
	                if (!selectedPlayer.key) {
	                    if (!_lodash2.default.find(selectedPlayers, { 'key': player.key }) && selected == false) {
	                        player.teamKey = teams[teamIndex].key;
	                        selectedPlayers[index] = player;
	                        return false;
	                    }
	                } else {
	                    if (selectedPlayer.key == player.key && selected == true) {
	                        selectedPlayers[index] = {};
	                        return false;
	                    }
	                }
	            });
	            teams[teamIndex].selectedPlayers = selectedPlayers;
	            selectedPlayers = this._getSelectedPlayers(teams);
	            var remainingSalaryCap = this._getUpdatedSalaryCap(teams);
	            teams = this._getDisableUpdatedTeams(teams, selectedPlayers, remainingSalaryCap);
	            this.setState({ teams: teams, remainingSalaryCap: remainingSalaryCap, selectedPlayers: selectedPlayers });
	        }
	    }, {
	        key: '_getDisableUpdatedTeams',
	        value: function _getDisableUpdatedTeams(teams, selectedPlayers, remainingSalaryCap) {
	            var groupResults = _lodash2.default.groupBy(selectedPlayers, function (selectedPlayer) {
	                return selectedPlayer.teamKey;
	            });
	
	            var updatedTeams = [];
	            _lodash2.default.forEach(teams, function (team, index) {
	                var players = [];
	                _lodash2.default.forEach(team.players, function (player) {
	                    if (groupResults[team.key] && groupResults[team.key].length == playersPerTeam) {
	                        player.disabled = true;
	                    } else {
	                        if (remainingSalaryCap < player.salary) {
	                            player.disabled = true;
	                        } else {
	                            player.disabled = false;
	                        }
	
	                        if (_lodash2.default.find(selectedPlayers, { key: player.key })) {
	                            player.disabled = true;
	                        }
	                    }
	                    players.push(player);
	                });
	                players = _lodash2.default.orderBy(players, ['disabled', 'salary'], ['asc', 'desc']);
	                team.players = players;
	                updatedTeams.push(team);
	            });
	            return updatedTeams;
	        }
	    }, {
	        key: '_getUpdatedSalaryCap',
	        value: function _getUpdatedSalaryCap(teams) {
	            var salary = totalSalary;
	            _lodash2.default.forEach(teams, function (team, index) {
	                _lodash2.default.forEach(team.selectedPlayers, function (selectedPlayer) {
	                    if (selectedPlayer.key) {
	                        salary = salary - selectedPlayer.salary;
	                    }
	                });
	            });
	            return salary;
	        }
	    }, {
	        key: '_playerOnLongPress',
	        value: function _playerOnLongPress(player, selected) {}
	    }, {
	        key: '_showSubmit',
	        value: function _showSubmit() {
	            return this.state.selectedPlayers.length == 4;
	        }
	    }, {
	        key: '_onAck',
	        value: function _onAck() {
	            var _this3 = this;
	
	            this.props.actions.removeFromCache(this.props.league.id);
	            this.setState(this.initialState, function () {
	                _this3.props.onAck();
	            });
	        }
	    }, {
	        key: '_getSelectedPlayers',
	        value: function _getSelectedPlayers(teams) {
	            var selectedPlayers = [];
	            _lodash2.default.forEach(this.state.teams, function (team) {
	                _lodash2.default.forEach(team.selectedPlayers, function (selectedPlayer) {
	                    if (selectedPlayer.key) {
	                        selectedPlayers.push(selectedPlayer);
	                    }
	                });
	            });
	            return selectedPlayers;
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit() {
	            var _this4 = this;
	
	            var _props = this.props,
	                userId = _props.userId,
	                user = _props.user;
	
	            if (userId) {
	                var league = this.state.league;
	                _ccImports.CCAppEventLogger.logAppEvent('CreateEntryClicked', {
	                    'league_category': league.category,
	                    'league_type': league.type,
	                    'match_key': league.match.key,
	                    loggedIn: true
	                });
	
	                var entry = {};
	                entry.dreamTeam = this.state.selectedPlayers;
	                entry.creator = user;
	                entry.league = league;
	                entry.coins = league.coinsPerEntry;
	                _app2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                    _this4.props.actions.createEntry(entry, {
	                        userId: userId,
	                        accessToken: idToken
	                    }).then(function () {
	                        var _props2 = _this4.props,
	                            entriesType = _props2.entriesType,
	                            entriesReqStatus = _props2.entriesReqStatus,
	                            entriesError = _props2.entriesError;
	                        //console.log("entry type after creation ---- ", entriesType, entriesReqStatus)
	
	                        if (entriesType == _ccImports.DataActionTypes.CREATE) {
	                            if (entriesReqStatus == _ccImports.Constants.reqStatus.FAI) {
	                                _this4.setState({ error: entriesError });
	                            } else {
	                                //console.log("-------------------- ------")
	                                _this4.setState(Object.assign({}, _this4.initialState, { created: true }));
	                                _this4.props.actions.removeFromCache(_this4.props.league.id);
	                                //this._populatePlayers(league)
	                                //this.props.actions.getLeague(league.id,{accessToken:idToken}, DataAT.AUTO_REFRESH);
	                                //this.props.actions.getUser({userId : this.props.user.user.id});
	                            }
	                        }
	                    });
	                });
	            } else {
	                var _league = this.state.league;
	                if (_league) {
	                    _ccImports.CCAppEventLogger.logAppEvent('CreateEntryClicked', {
	                        'league_category': _league.category,
	                        'league_type': _league.type,
	                        'match_key': _league.match.key,
	                        'entry_type': 'dream_team',
	                        loggedIn: false
	                    });
	                }
	
	                this.props.actions.addToCache(_league.id, this.state);
	                this.props.openSignIn();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var styles = ccStyle.default;
	            var _props3 = this.props,
	                entriesType = _props3.entriesType,
	                entriesReqStatus = _props3.entriesReqStatus;
	
	            //console.log("dream team entry creation reached -----", entriesType, entriesReqStatus)
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container dream-team-container' },
	                    !this.state.created ? _react2.default.createElement(
	                        'div',
	                        { style: { flex: 1 } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dreamTeamHeading' },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'dreamTeamHeading1' },
	                                (0, _ccImports.strings)('dream_team_leagues')
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'dreamTeamHeading2', style: { color: _ccImports.colors.theme2.font_color4 } },
	                                (0, _ccImports.strings)('budget') + this.state.remainingSalaryCap
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container fRow' },
	                            this.state.teams.map(function (team, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container ', style: { flexDirection: 'column', flex: 1, marginRight: 2 }, key: index },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'team' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-container team1', style: { justifyContent: 'center', alignItems: 'center' } },
	                                            _react2.default.createElement(_ccImports.CCFlag, { teamKey: team.key, style: { marginRight: 5 } }),
	                                            _react2.default.createElement(
	                                                'h1',
	                                                { className: 'dream-team-team-name' },
	                                                team.key.toUpperCase()
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-container  player selected-player', style: { justifyContent: 'center', marginTop: 10 } },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: "dreamTeamGridView" },
	                                                team.selectedPlayers.map(function (player) {
	                                                    return _react2.default.createElement(_ccImports.CCPlayerItem, { disabled: player.key == null || player.key == undefined, index: index + 1, size: styles.selectedPlayerItemSize, player: player, key: player.key, onPress: function onPress() {
	                                                            _this5._playerOnPress(player, true, index);
	                                                        } });
	                                                })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: "flex-container dream-team-container-scroll" },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'dreamTeamGridView ' },
	                                            team.players.map(function (player) {
	                                                return _react2.default.createElement(_ccImports.CCPlayerItem, { size: styles.playerItemSize, disabled: player.disabled, index: index + 1, player: player, key: player.key, onPress: function onPress() {
	                                                        _this5._playerOnPress(player, false, index);
	                                                    } });
	                                            })
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        this._showSubmit() && _react2.default.createElement(
	                            'div',
	                            { className: 'dream-team-submit-btn' },
	                            _react2.default.createElement(_ccImports.CCButton, { loading: entriesType == _ccImports.DataActionTypes.CREATE && entriesReqStatus == _ccImports.Constants.reqStatus.PEN, onPress: this._onSubmit, title: (0, _ccImports.strings)('submit'), style: { width: '50%', position: 'absolute', left: '25%', bottom: 25 } })
	                        ),
	                        this.state.error && _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container', style: { justifyContent: 'center', alignItems: 'center', width: '90%', position: 'absolute', left: '5%', bottom: 5 } },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'dream-team-entry-creation-error', numberOfLines: 2, style: { color: _ccImports.colors.theme2.font_color1 } },
	                                this.state.error
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(_ccImports.CCAck, { buttonText: (0, _ccImports.strings)('close'), title: (0, _ccImports.strings)('dream_team_leagues'), detail: (0, _ccImports.strings)('your_entry_created'), type: "success", onAck: this.props.onAck })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DreamTeamEntryCreation;
	}(_react.Component);
	
	DreamTeamEntryCreation.propTypes = {
	    league: _propTypes2.default.object,
	    openSignIn: _propTypes2.default.func,
	    onAck: _propTypes2.default.func
	};
	DreamTeamEntryCreation.defaultProps = {
	    openSignIn: function openSignIn() {},
	    onAck: function onAck() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        matches: state.matches,
	
	        reqStatus: state.entries.reqStatus,
	
	        entries: state.entries,
	        entriesById: state.entries.byId,
	        entriesByLeague: state.entries.byLeague,
	        entriesByCreatorId: state.entries.byCreatorId,
	        entriesPages: state.entries.pages,
	        entriesReqStatus: state.entries.reqStatus,
	        entriesError: state.entries.error,
	        entriesType: state.entries.type,
	
	        user: state.user.user,
	        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,
	
	        matchesById: state.matches.byId,
	
	        cache: state.cache.cache
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(DreamTeamEntryCreation);
	
	
	var ccStyle = {
	    default: {
	        playerItemSize: 'r',
	        selectedPlayerItemSize: 's'
	    },
	    s: {
	        playerItemSize: 's',
	        selectedPlayerItemSize: 'xs'
	    }
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	__webpack_require__(478);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(19);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*import {GoogleSignin} from "react-native-google-signin";
	import {AccessToken, LoginManager} from "react-native-fbsdk";*/
	// import './signin_old.css'
	
	// import './signin_320.css'
	
	
	var SignIn = function (_Component) {
	    _inherits(SignIn, _Component);
	
	    function SignIn(props) {
	        _classCallCheck(this, SignIn);
	
	        var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));
	
	        _this.initialState = {
	            fbLoading: false,
	            gglLoading: false,
	            emailLoading: false,
	
	            error: null,
	
	            email: '',
	            password: '',
	            displayName: ''
	        };
	        _this.state = Object.assign({
	            showSignIn: true
	        }, _this.initialState);
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._showSignUp = _this._showSignUp.bind(_this);
	        _this._showSignIn = _this._showSignIn.bind(_this);
	
	        _this._fbSignOn = _this._fbSignOn.bind(_this);
	        _this._gglSignOn = _this._gglSignOn.bind(_this);
	        _this._emailSignIn = _this._emailSignIn.bind(_this);
	        _this._emailSignUp = _this._emailSignUp.bind(_this);
	
	        _this._toggleLoading = _this._toggleLoading.bind(_this);
	        _this._signOnError = _this._signOnError.bind(_this);
	        _this._signOnSuccess = _this._signOnSuccess.bind(_this);
	        return _this;
	    }
	
	    _createClass(SignIn, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("SignIn");
	        }
	    }, {
	        key: '_showSignUp',
	        value: function _showSignUp() {
	            this.setState({ showSignIn: false });
	        }
	    }, {
	        key: '_showSignIn',
	        value: function _showSignIn() {
	            this.setState({ showSignIn: true });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._setupGoogleSignin();
	        }
	    }, {
	        key: '_setupGoogleSignin',
	        value: function _setupGoogleSignin() {
	            /*GoogleSignin.hasPlayServices({
	                //load prod configs
	                autoResolve: true
	            }).then(() => {
	                GoogleSignin.configure(CricrushConfig.googleSigninConfig);
	                const user = GoogleSignin.currentUserAsync();
	            })
	                .catch((err) => {
	                    //console.log(err)
	                })*/
	        }
	    }, {
	        key: '_toggleLoading',
	        value: function _toggleLoading(type, value) {
	            switch (type) {
	                case 'fb':
	                    this.setState({ fbLoading: value });
	                    break;
	                case 'ggl':
	                    this.setState({ gglLoading: value });
	                    break;
	                case 'email':
	                    this.setState({ emailLoading: value });
	                    break;
	                default:
	                    this.setState({ fbLoading: value, gglLoading: value, emailLoading: value });
	            }
	        }
	    }, {
	        key: '_signOnSuccess',
	        value: function _signOnSuccess(user) {
	            var _this2 = this;
	
	            this._toggleLoading('all', false);
	            this.setState({ error: null });
	
	            var url_string = window.location.href; //window.location.href
	            var url = new URL(url_string);
	            var invitedById = url.searchParams.get("invitedBy");
	
	            var linkParams = invitedById;
	
	            if (user) {
	                _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                    var createUser = { email: user.email, accessToken: idToken };
	
	                    if (linkParams) {
	                        createUser.invitedBy = { id: linkParams };
	                    }
	                    if (_this2.state.displayName && _this2.state.displayName.length > 0) {
	                        createUser.displayName = _this2.state.displayName;
	                    }
	                    //console.log("-- -- -- -- -- -- -- ", createUser)
	                    _this2.props.actions.getOrCreateUserByEmail(createUser, idToken).then(function () {
	                        _this2.props.onSignInSuccess();
	                    }).catch(function () {
	                        _this2.props.onSignInSuccess();
	                    });
	                }).catch(function () {
	                    _this2.props.onSignInSuccess();
	                });
	            } else {
	                this.props.onSignInSuccess();
	            }
	
	            //link failed providers with new user signedin
	            if (this.props.user.failedCredentials && this.props.user.failedCredentials.length > 0) {
	                _ccImports.FirebaseUtils.linkProviders(this.props.user.failedCredentials);
	            }
	        }
	    }, {
	        key: '_signOnError',
	        value: function _signOnError(error) {
	            this._toggleLoading('all', false);
	            this.setState({ error: error });
	        }
	    }, {
	        key: '_fbSignOn',
	        value: function _fbSignOn() {
	            this._toggleLoading('fb', true);
	            /* LoginManager.logInWithReadPermissions(['public_profile', 'email', 'user_friends']).then(
	                 function (result) {
	                     if (result.isCancelled) {
	                      } else {
	                         AccessToken.getCurrentAccessToken().then(
	                             (data) => {
	                                 FirebaseUtils.signOnFb(data.accessToken, this._signOnSuccess, this._signOnError, this.props.actions);
	                             }
	                         )
	                     }
	                 }.bind(this),
	                 function (error) {
	                     this._toggleLoading('fb', false);
	                 }
	             );*/
	            var provider = new _firebase2.default.auth.FacebookAuthProvider();
	            _ccImports.FirebaseUtils.signOnFb(provider, this._signOnSuccess, this._signOnError, this.props.actions);
	        }
	    }, {
	        key: '_gglSignOn',
	        value: function _gglSignOn() {
	            this._toggleLoading('ggl', true);
	            var provider = new _firebase2.default.auth.GoogleAuthProvider();
	            _ccImports.FirebaseUtils.signOnGgl(provider, this._signOnSuccess, this._signOnError, this.props.actions);
	        }
	    }, {
	        key: '_emailSignIn',
	        value: function _emailSignIn() {
	            this._toggleLoading('email', true);
	            _ccImports.FirebaseUtils.signInEmail({ email: this.state.email, password: this.state.password }, this._signOnSuccess, this._signOnError, this.props.actions);
	        }
	    }, {
	        key: '_emailSignUp',
	        value: function _emailSignUp() {
	            this._toggleLoading('email', true);
	            _ccImports.FirebaseUtils.signUpEmail({ email: this.state.email, password: this.state.password, displayName: this.state.displayName }, this._signOnSuccess, this._signOnError, this.props.actions);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var styles = ccStyles.default;
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container', style: { flex: 1, flexDirection: 'column' } },
	                    this.state.showSignIn ? _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container sign-in-parent' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container sign-in-title-div' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'sign-in-title', onClick: this._showSignUp },
	                                (0, _ccImports.strings)('do_not_have_an_account')
	                            ),
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'sign-in-title sign-in-title-btn', onClick: this._showSignUp },
	                                (0, _ccImports.strings)('register_here')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sign-in-social-div' },
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'FacebookSignIn' }, type: "fb_signin", onPress: this._fbSignOn, loading: this.state.fbLoading }),
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'GoogleSignIn' }, type: "ggl_signin", style: { marginTop: 5 }, onPress: this._gglSignOn, loading: this.state.gglLoading })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container sign-in-or-div' },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'sign-in-or-text' },
	                                (0, _ccImports.strings)('or')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sign-in-form-div' },
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('email'), type: "email", onEndEditing: function onEndEditing(email) {
	                                    _this3.setState({ email: email });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('password'), type: "password", onEndEditing: function onEndEditing(password) {
	                                    _this3.setState({ password: password });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'ManualSignIn' }, title: (0, _ccImports.strings)('login'), style: { marginTop: 5 },
	                                onPress: this._emailSignIn, loading: this.state.emailLoading })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container sign-in-parent' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container sign-in-title-div' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'sign-in-title', onClick: this._showSignIn },
	                                (0, _ccImports.strings)('already_registered'),
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'sign-in-title sign-in-title-btn', onClick: this._showSignIn },
	                                (0, _ccImports.strings)('login_here')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sign-in-social-div' },
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'FacebookSignUp' }, type: "fb_signup", onPress: this._fbSignOn, loading: this.state.fbLoading }),
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'GoogleSignUp' }, type: "ggl_signup", style: { marginTop: 5 }, onPress: this._gglSignOn, loading: this.state.gglLoading })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container sign-in-or-div' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'sign-in-or-text' },
	                                (0, _ccImports.strings)('or'),
	                                ' '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sign-in-form-div' },
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('display_name'), onEndEditing: function onEndEditing(displayName) {
	                                    //console.log(displayName);
	                                    _this3.setState({ displayName: displayName });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('email'), type: "email", onEndEditing: function onEndEditing(email) {
	                                    //console.log(email);
	                                    _this3.setState({ email: email });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('password'), type: "password", onEndEditing: function onEndEditing(password) {
	                                    //console.log(password);
	                                    _this3.setState({ password: password });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'sign-in-btn', titleClassName: 'sign-in-btn-txt', analytics: { event: 'ManualSignUp' }, title: (0, _ccImports.strings)('create_account'), style: { marginTop: 5 }, onPress: this._emailSignUp, loading: this.state.emailLoading })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { width: '100%', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'sign-in-btn-txt', style: { width: '80%' } },
	                            this.state.error
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SignIn;
	}(_react.Component);
	
	SignIn.propTypes = {
	    onSignInSuccess: _propTypes2.default.func
	};
	SignIn.defaultProps = {
	    onSignInSuccess: function onSignInSuccess() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user
	
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SignIn);
	
	
	var ccStyles = {
	    default: {
	        title: {
	            fontSize: 15
	        }
	    },
	    s: {
	        title: {
	            fontSize: 12
	        }
	    }
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(267);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/afg@3x.a006a8b3.png";

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/aus@3x.607832a7.png";

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAACOlJREFUeAHtmk1sVFUUx29b2pK0NBhEGhAmUBIqjXykxFgaPiwbhCokJagLoobIxo2JCxPjXhcmJC6JC8NCCUoCBAxVAVuSVggaooGaUGypgNgS0jIVaj89Z+w00+m90xYQ3nh+Nzl9b879ePf8z29e77vzctx9lpGRkRzpukJsg1i52GKxp0ePRXKkoMDDUiAuAzWJNYo1iJ3LyckZkON9FQV3WkVgj0mH3aM2f1qdaYwCD0eBHhnmc7F9Av+F6Q45ZegF9udl8A/EtohNud90J0R7FJimAuek/ccC/5dT7TcpvAL7LBnsE7HXxSZtP9UL0w4FHrICp2W8NwT+jsnGzQixAP+MDHBcbPFkA1GPAhFQQJc9OwX8bzLNJQi9AK8Pp/rw8ESmAahDgYgpMCjzqRPwj4bm5YVegC+TDj+IPRnqmPS3tra6pqYm19bW5uLxuOvp6XGDg3rdR19k3omL1tXVua1bt7rc3NxHP4n/wRVVx5s3b7qGhobHqqHmr7CwMGElJSUuFou50tJSJ0BPprIC+JK0O+FrOCPdKQGXiu+UWBD4gYEB19jY6Orr611XV1f6EHxGgYeiwPDwsLt3717Curu7XUdHhysoKHBlZWWuvLzc5efnh66jXH8lLG8Q8H9MbzQOemmkoxwRW5TeMPm5ubnZHThwwN25cyfp4ogCj0yB/v5+19LS4i5fvuyWLVvmKioqQtfW34qOCtOrBfzO1EbjoJeKD8WeS22Qen7kyBF3+PDhVBfnKPBYFNAl9MWLF53+B6iqqgotw/R3JN3K3JA6ybFFr3wjlknFO6mVqef79+8H+FRBOI+EAtevX08stXUpFCjrhe3XUuvGoBfnXrG81Mrk+aFDh9zp07oNSkGB6CnQ2dmZ2EwRuEOT+0jqxlY1CejFsVpav+jrcebMGXfs2DFfFT4UiIwCN27ccBcuBN9I0GdUfXUmUZJ3+reTjtSj7tIcPHgw1cU5CkRWAd0+7+3tDc3vrWRFrtzldcfmlaQj9Xjy5MlMg6Q25RwFHrsCury5dOlSaB6VUq+/Pzm9068VK9YPqUUHOHHCu7ef2oxzFIiUAlevXnV9fX2hOdVqhUK/UU/Sy5UrVxK/rqb7+YwCUVZAb9bXrl0LTbFGKxR6fYidUM6fPz/BhwMFskEB3cYMlJXqV+h1f35CaW9vn+DDgQLZoMDt27dD04zJf4KZCv1Tvhb6SxcFBbJRAd11zPBj1VyFfsJDrAZ669atbIyXOaNAQoG7d++GlChW6At8tUNDQz43PhTICgUyvN5eqNBTUMCUAkBvKt0EqwoAPRyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CghwFzCgC9uZQTMNDDgDkFgN5cygkY6GHAnAJAby7lBAz0MGBOAaA3l3ICBnoYMKcA0JtLOQEDPQyYUwDozaWcgIEeBswpAPTmUk7AQA8D5hQAenMpJ2CFvt8nQ2Fhoc+NDwWyQoEZM2aE5vm3Qt/rq509e7bPjQ8FskKBoqKi0Dx7FfouXy3Q+1TBlw0K5Ofnu5ycnNBUuxT6Fl/tkiVLfG58KBB5BebMmROaY7t8GfoU+gu+FpWVlT43PhSIvAILFiwIzfFnrVDoT/lalJWVOZY4PmXwRVkBXdZkgP47nbtC3yzmfZjdvHmztqGgQNYoEIvF3MyZM0PzPa4VufLNGJTjF75WNTU1btasWb4qfCgQOQX0Lr98+fLQvM5L/W9aqXd6LZ/+exj/V5+Cd+zYMd7JJxSIqAJLly51xcXFodmNMZ6AXr4B56Tl177W69evd7W1tb4qfCgQGQVKS0vdqlWrQvP5XSrGQz/a8l05Dvl61dXVOV3qUFAgigrMmzfPVVdXZ9qbf09u7GNsJ5c32uFXCWhvKKhdu3a57du3h6rxo8BjUWDhwoVu3bp1Li8vL3T9U8L2uGfWMehHe7wvR13qeMu2bdvcnj17XElJibceJwo8KgX03ZqKigpXVVXlcnPTMR6bxR9y9urYp9GTcW/lyDdiYGRk5GWpU/AXpTfWz3qRNWvWuMbGRldfX++6urxvMfi64kOBB1agoKDA6W9I5eXlTjdaMpS/pK5WmJ4A6DjodQBp9KeArwt43b+fq770ohfbtGlTwlpbW11TU5Nra2tz8Xjc9fT0uMFB3QWloMCDKaB3cH3bV01XF7oHrw+swuhkAyuAO6TdT76Gwd4C/rPSoUHsCV9HfCgQUQUU+DoB/mhofsHFkHT6RTpVi7WFOuNHgYgp0CPz2ZIJeJ1vEHqtlM76BuZKsc/ERsQoKBBVBb6Xia0QZr+dbIIZodfOMkhc7E05XSum7y4Mi1FQICoKnJWJ7BRGXxDrmMqkgmv6UGdZ68ekbveozQ+1w48C/6EC3TK27r3vE9C9r8Znuva0oU8OJvBr3xViNWK69t8oFnx7X+ooKHC/CsSlY5NYo1iD2FmB/b63CP8BjUedbYMsCN8AAAAASUVORK5CYII="

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nep@3x.fde60393.png";

/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sl@3x.d0ffca02.png";

/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/wi@3x.e999fb88.png";

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nep@3x.8dd93ca4.png";

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAAH2hJREFUeAHtXQmUVNWZ/lvofaH3prtpmk02QWRHBBWkwQUUBKMxGhNjTDIxm5nEOZlzktkyiTNZjiYxyWRIkOiJThSJREAWQWWnQTYXlgaa3ve9m24amO+78rDAquqq6lpe3b73nHdeLa/e8r+v7vvuf///+yOkF+3ixYtj8PPbsHA9GEs+lmFY4rGYZizQWwt0YAdnsBRfWh/D+m0shRERERew9qlFePsrAH0OfvMYlnlYMr39vdneWMAPFmjCPgj+v2J5EX+Ai97s02PQA+wjseP/xnK3Nwcw2xoLBNgC+7D/bwH42z09To+gB9j7YWc/xfJtLP093bHZzlggyBZ4Gcf7CsDPp4Db5hb0AHwSfv06llvc7sV8aSxgDwuQ8xcA+BwHuGwuQQ/A5+FXb2EZ4fLX5gtjAftZoBantBDA3+3q1JyCHoAfgh/swZLh6of8vLb1nGz+sEE2fVgvB0tbpablnFQ2dcnZbp8H1u4OZ77rYxaI6hchGYmRkpkYJSOz4qRgbKrcMS5NcpKjerJEFza4A8Bnp/2p9inQX6I0HBy47OFbzp6X/1hbLD/fcEbOX/Bq4PypEzAfGAt4a4HPTsuSn983QrIHuAV/M/Z7A4B/6ur9X+P4AQDP9+TwLgF/4eJFKW04K43tXeqgUf2v2IXj7sxrYwG/WqA/ev7MpEjpApP4sKJNus+77XA5Hn3zUid+xXlc0dNjgyfw7a+u2MLFm9bO87Lpg3r53Tvlsr+4Rerazonp9F0Yy3zcKwtcA5QmxvSXcTnx8tCMLFk6KQO0x20v73i85ejtH3P84DLoAfgUfFGEhWuPGv9nZQ2d8uKeSnl5b7UUVXdIM6iPacYC/rJAbNQ1kp8aI3eNT5MvzMyW6wD8iMuo9egohOlkAP89a+vLPwfof40Pv2594c36HB4zB0paZPm2CtmI3r+ssUs6zWDWGxOaba+yQOSlQexNwwfIF2/KlltHpUhspM9UejdAP8M6hAI9AD8WHxzCwokon1tTR7dseL9eVu6qlMLTLVIN784Fw3l8tmdf/CGpzIDY/nL9oARZBhqzbHKmDHQ/YPXUTPcB+K9wYwv0v8Xrr3r6a3fbYZwrp+s6FN1ZfaBWPqpsF/4ZTDMW6MkCpDIjMmKlYEyqPHzjQJkA4HtJZdwdYhdAfyM3sEBfjtfZ7n7h7XccYRdigPsCev3NHzVIcV2noTzeGrGPbE+vTHZSlMwcMUA+B3fkvDGgMlG9Ih3OLEdunwng10aA2kzGm0JnW/njs3p4dd4E5fm/wmrZfapZqjCBZSiPPywb/vtgL54MKjNxcKIsnpCmqEx2cnQgL+yLAP0Kgv5fcZQfBvJIpDwnatrllX018sahOjlc3irNHcbLE0ib233fMRiUjsIsK3t1TjZNAvD9SGVcXf4qgH4pQb8aW9zjait/fk6Pzu6TzarXJ+U5VXvWUB5/GjgM9tUPI9UcDExnj0yWz2CQWjA2ReL8T2VcWeI0QD+UoN+JLS67c1xt7c/PGbNDyvPaezWyo6hJqpq7zMSWPw1sw32xF0/CBNO0oYmyCD73ewH43MBSGWdW6ALoown6k/h2qLMtAvkZKc/RqnZZfaBG1h6ug5+/VRjTY5p+FqDPnZNK8xEwdh/APjk/KFTGlSETCHpGpEW62iLQn589d0F2nWxCr18rGzCxdbKmQ7rcx1QE+pTM/v1kAfrccwZEy9wxybJkYoYCfRCpjKurGEbQ05UT8sawZIL+9YO18vaxBhWmbOa1Qn5bfD6BePD02dcOkIXXp8niGzIkNyWgXhlvznOibUDPs+bf76PKNvk7PDxvgPLsPd0s7V0mNt+bOxrqbcndOal057hUWYzefUp+UjC8Mt5ctr1Ab525RXnWHPwY/EWgPN2m27fMY9v1QEww3Tk+Ve5Gz14AV6QNqIwzW9kT9NaZ1rR0ISurQdYcAt+Ht6e+vVs9DazvzdoeFmAgGAPC7sYE06Lr0+1EZZwZyN6g5xlblGc9QM9Ynt0Y9HZ222IY4sygfe6zG/IS5J4J6eDu6TIpP0GuCcIMUy+NbH/QWxdIysMwBro3X91fg4mtDuPbt4wTgjVT9RZhkLoQgJ8zMkUSYvweKxOoqwof0FsWoJdn69EGWQ0vzxosxrdvWSY4a1KZuaNT4JFJl/nXpcqglBj07sE5tp+OEn6g54V/PLHVpvg+A9m2nWgyXN9PiHC3G1IZpurdDrAz3j1M86PDE/TWjSHlKSxulnWH6+XF3VVSXH/W+sqs/WgBemXYsy8ClZmJTCYmedifurs0QHiD3rosxvJsO9EoryKKk/E8bca3b5mmV2tGQt4GKrNscobyzuRhgokBY2He9AA9bwKlSY4jMX3r0UaVuLIdgWykQab5ZgFOMN0/JVPx9rGIm+lFfqpvJxC4X+kDestGHejlmaS+9kidrNxZJWcM5bFM49E6C7oyjJNh6MDUIYmSHBcZbgPVnq5TP9DzitnD17R2yR64OF+CNAkpjwlncI+FGIh2zRmVrBI6GOvOsF9GR2rY9AS9daOogHUS/vx3jjfKiu0VsgMJLIbyWNb5ZD0uN17lpi6AV2bUwDi7hg98csK9e6U36Gkb0vp2qLG9X96mwhme31kpJfWdvTObJr/OhDjqkonpKjeVeaopcf3DYUa1t9bXH/SWhZiMXosk9X1QaPgzFBr+hpCGvkp5okFlbkbY7yMzByL8NxmapPpRGXZ2LsiZa9AfR1bTtUjc1a1RmqQEUoT08vzvtnIV2tCXKM/o7Dh5ZMZAuQshBMOgMcO4d90a7y9lvrMwv+CkuQb99J8UysMwzuexJGEyQqdGkLd1nZejEKLiIJeUpxSG0rmlxUeqCSYKoHI2NVlDKtOOe8pcjD/tqJCfLRuhUhSd3NOJLtFcWNwK7lusQnqfmDNI5iFrPQwi6Jxc46c/4mxiQnQ/4bR6flqMesQv316uDEaXp04tqn+EzBw2QB6/OUdugVeGar+6eWXYiXFm/vdQ0H4LKhvUUnWXf+ES9OTAFagqsuGDBiXNx0yYb8wdJMMz9aE8nF1MT4hUrjp6LRaMTZPfvV2meD85Ybi34Zmx8ih4+72TMmUwlH/jIJunWytv7MR8TKWSlTmGyUn29j3RVZegt4xDrZoTyFz6445K2V7ULI/OypaHpmcpvXBrm3BfM3CKctAPTMuUKZiQ+cueKmVI/unDsdELw7Bf9u7jchPUvQr/6IEr7wSfyOvfr1OdFMWCm6Ck4WlVHJc5shGPb7nyKHjHnjE1vr/MGJok356Xh3iMZG0oj3WxNBzDlZmf+xx6/fVH6oWBbeHQSFumQF7jm3gi34Z0vRTMplInUqfGXvxgaYs8t7VM1uHeVEMzyZl6xoEfTlW5uk6u3TWnd7Kx+icxnp1CTUfg916CyLsnYOCh6bHONg/Lz/jH5iCP6W/UamGC+m+2lMqh0jbl87frReWlRsuXZ+WoSh2U3YhGsJhujaJgFAReATrDAiAs6NcTlXFmA696escdcDDIKLwx4MJfuzVXHpiSFU7ZM46X4vI1eX0nenlq8SzHjO4Lu6qkGnm7dmqJyFjieOvJgsGgMgwM6xfOYb9OTcsnLWUgn9lcIjtBsTm/wgBDd81dT+8z6K0D0qOTBMPTM/Dd+XlyE+SWdfHyWNdIIYYODJB2Ij/3FxtL4CFoDLkGZ388kcYD5N9fMFj53Kk8oEHYr2VytSauWVDtWTxpVyFFtKGt261XxvHH7kDf40DWcUfOXvMf14iiC38HDdh3pkUexGDw67cOksFwBerSOAiMh4tzDijPxLxE+eu+anl2c6nyarnvbwJjAdZW/eotufK1W3KUC5J/AN0acyRegkPh11vKVPwUSzz5q/W6p3c8EZqevQ0fs08W5Mm9CFElWHRrHOyS8jwD4DOKk5UVg9EY006V339ZNFTGY4JJR7DTW8j0z5+uK4bSXaPq2XtgMk5N766n9yvoHY8ehxvEqL2nbs+HUq3tVK4cT9Xn1wT/FiSp/xiFpKm+3BUgaRLSxWszYxTYWYNJN48MbwCBzYjYX24qUe7iVnjQetO3uwN9r+mNK8S0Y/DxGoK6diGc97HZ2cpnnJsco9Ugi0+1eaiPNH3oAFmBqW8OtKi5zzGAPxqfnEmx/RSVeQrcPQWhBLo1mqoRIl6vgDI+vf6MUM0u0C1gPf3VJ0555u9hoHsHtMkTo8M6sfjqS7v8/gTcaE+vL1YKzA3tvheTJtjpGWMk5NNLh8sEjCN0awS7SuzHfMiP155WM/++0BhXdnHX0wcN9Dw5ctJ74Nv/Dia2JiDuJarfNVr1/LxGDuwpQfif4KT7Eb/Ufq7naXH+zmqMlRkMLZkfLRqisph088jwOjkoZRrnc1tL5Q/vVgREu8gd6ANGb6yb6LjuAOXhwG/b8SY8snPkQYQzUCxIpwAo8u/bx6WhUl4ybmgZpsnL1Q0+B77vjvVwUEqf+6MoFPyDO/Mx860fleEYiIX3OOH3E4yDGCsTihbUnt7xAjm5NWNYkjypwhk4Zd5fOz8zr5fhy/RErEPvTzccb7xjo7eRHi6GdpDKMINJt0ba0tLZrWa1Sf8Ien9SGWf2ctfThwz01oky8m8ZogD/AbO618HVyUkWAkGnRsrDG/1fGKgdLmuT5rMfqy/zWvMRPsAJJhYL1pHKkLeXNJxFwk6F/BbxMsGSYXQH+qDSG2dA5pTySsRTsPoIwxno2+fEFiMfdcE+KQ8lrG9Gah5Dl/+IkAYKUlFX5vsL8pDhY5sqHc5ukU+fMZ5dSa0jNJ3jG1aOt0sLeU/vaAhSnlkIY/gWgtjIiTnzqOMEDKfWmbbIsF/deneSN7ogmYj/szfPqGT8qxid4y0P2Gtb9/SOV02e9y4GufuRvP3A1Cz5EmL3qa6ViFKMOlGeMdnxjpetzWvGuNMrs3JXhQofsGuB7JDTG2d3nI9+RjUy9Ytcn0nMDF9muKwulMfZdYfrZ6QyFchgYtgAqcyHFfahMs5sakvQWyd6qu6sfH9VkZLo+zrAPx25niwGoBslsK433NakMvRIHcHg/NdbSmQ1yqKGgsp4azdbg54XQ8qzBXIde5ES9uC0LHg5smRcTkK4y0V7e59st30bBLSYRsr6AByc1yPsN1ya7UFvGbIVRv6fd8tRiKFeUZ4F16VBlweUB14e04JnAUolsg4Aqcyv3ipVLtir5x6Cdza+HSlsQG9d3kkEdH3v1SI12fOV2TmgPEmSh1lden5MC5wFSGWYrncAORPUlWG5U86wh2MLO9DTyKQ8m1FqczciOD+HUIbPgvZQT525rab53wKcUKKbdfWBmssqEeHA3V1ZIqxRQspDgZ9NH9TLVxDLUwDdmrGQrQvTWkiu7lHIPmdgGJNltoLK/AnetPeg+x+onIFgXmRYg94yVBEozz+tOikb0ft/AdP5Nw5PliGY1TWUx7KQd2tSmYqmTuU8eHlvlSpj2tRx3rud2HhrLUBP+/JxuxFT3ntPtcj9UzNVFTxqwOiYeBFIPJHKHC5tlTWHa+VlRMSegax5uA1Ue7KPNqC3LpRJ6ozRfgePZIqVzoeXh6oBxstjWcj5mlTmRHW7mhD8C8DOWfFwHag6v8JPPtUO9Lw0RjV+iACnf3+jWIU1fAaBXZQo4ayuoTyf3Hy+UlQGs6k74RSgzMYGjI844aRz0xL01g1jWOubuInvwc12DwqHMWuLMfw6JmhY1+zNmlSGg9M3IG9Nz0xRzVntqIwze2gNel4w3ZtVkCKkb5liTayJejsoD9MV+yrlIZU5DiqzER3Cqv21SqWZev19pWkPeutG8kYzgYPxPFRoWIKefy5ETof1IcpjeWUYyfo6lCoolccJp77W+gzorRtLPZU3329QqWt7kIl/N0q/U4pQd8pDKrMfNO/vh2pVFtfxqg6PJfIs2+my7nOg543jQLcMgzcGS3WfvyCjIUKrP+i75S3MY7y4u0oV29AFwL5cR58EPdP3GKJ8B9R+2dOnoRqJ7o2JOKRzlCRhvq7p6XW/4w7XlwCZjdmgM32N01Ne5Ga4bRmZOmVIkuH0DpjQ9iW1dUhj+rL3hoGoLNjA5HtO2E0bmmi8NzoinpNRmaAvxk//yd1lBzAWeboMyabOjvHTf2KbsH9FPchb8Ug3M7LObyUpDyuGj0ARZSpLmxlZ53YKi085UB0F7mpib3q+XYryJEerAT3DsmcOTxITe9Oz3Wy1RTKqm5soS+9vCSkPpUmoLcpqKybK0nsbBv0X1MVhGUkTT98705Py3Ajv1pCMGMQpDUB4sYmn751FA/Tr4ekxJnPKj7a1vDx3jouS0VlxiFBNMZlTfrRvr3aVALVfkyPbKxO6/TEpzyi4eXPA+SciQM/kyLo1V2C/pBty7ugUMWoIgbWztXdSnqnw7lBYlyK0Rg3BskyQ1sNAZSj1Z3RvgmTwS4ch5RmYFKVqbF0LykP7G92bAN8DUhmjcBZgI3uwe1Y2HA6/Pv8ArCNmFM48MJq3m5DKcILJaFl6a7nAbs/qKddDa4h8nxUWjZaln+w9FBzSqBb7yZgB2A0pTwZCPGajCuIIuDgZxGdUi300dDxK8uisT++jWWz7MxbOyEuNgexKpkxFBKfRp/fiVpHKmEokXhjMZpvGorMaCRfnP87PR65CekgrkbgzjW2SSFhwTNeaU9YNaIImj+41p0h5WCmSqhO/fWikLP3gY8pjp5pTIQd9X64uyBqz65DFpGN1QVKebMTu3wfNoRkIYgt2dUGro3G2DlmhNVIZU0dWVC0tU0fWGTR795m7QmshAf0guLl0rRhu3apmqA+YiuGWNT5eB7NiuG1AH4ukDqqMfQdVwim2FNUPhdNIAjVqVFrYgOrgdN3tL25VidgUnPK0RfWPkMEI7/3RoiFKd1/H+lrUIGIVwue2lirdUcqT+LvZAvScvfve/Dy5Y3yaJEb31w7svGknqjuEZeBfQ8GxhvZzPhcdYz/ArK+b4f9+eulwdBCJ/sZEyPfHfoCyi4XQHvrx2tPQ0GxQanT+OrGQgj4b09WPzc6Wx2/OkdxkPTXj2VOtgGzgM5tL5BS08v1VpYPgT4rtByqYK08tGKyl7DjBz2LLr+yrRodxBnqaHX7BfUhAH4eeasF1qfLU7fkq/1I3GsM7Q4665WgDeqpi2VHUFLAqHUx/vDYzRv5l0VCoOWQK4190a6SAJ2s75JebSlSJHyrRecEKP2WOoIGet4IcdBzkJZ4syFNSE/RM6NYIdpaleWZzqbwELfe6tuBIW3NMVDA2RYF/POJe6BbUrXV2X5BtJ5rkpxgTsYIhCzN7Myay7OEO9H7z0xPsVA17cFomgsMGqdhr6wR0WRPsfBT/FY/iZwF4Trj0pjfy1i4skvA6qvpRS56U52uos5WRGKUV+KkkfRtyJVg476U9VQhkK1NPAA5+/dV67bLkozcJSQYsevBdDFQphsrPdGrAunRAyppS37/YWIJqHY3CHimUjb08BZs4sXXX9WkSF9VPu0rq7OFZ1fDZLaVKnqQBBZrZ83vS3PX0PoOeuKaHYQxiLRg+8MCULKFknk6N5u1E70oqsxzV9V7YVSXVLfaStmZW053Q5HyyYLCilbGR/bTzjNHLQ1lxOgp2FjVLe9cFJcLrDmvuQO8TvYnCQCo3JRqhpOnyxNxBqqyNuxMIx+/4OK0BwCl2+hv0NIdK24JKZTy1GT1HLxfWyA5Qni/PylFaP5Tui0aHpEtj53oXXN0snPfCrkpZsbNSiuAePounrS9836uenrw9NR7BRMiX/DYmmG4dlawdlSFvJ5D2wn/83Ntlsv5IvfInhwOAmMhNYHwTHRHlUFLiIrXz9BDkB0tbMLFVJutwb6pRVKLLCd/vdU9PKsN0vVHIjXx0VrY8hCrdlH7WqdGYlLHmBNNfMIBaid6kosleVKYne/PpxEHuR5XHZBF4PudGxuUmqHuli6OHWLwBk3XP3D8S4ct1Kmq18HSLNKGjYoflSesRuRxND0bYL3njN9CDDM+M82S/YbVNFx6T5QD4ZhQtYOjvPpST9Mx89rzMBniYVmL8sR1/gEdnDpR7kdwxGEkejGjVpTF2fwnUl6eDdbCDYq7uMXRY7XA49ER5XNKbfl/dKlmJkepx+cScQTIP/mHdvDLsGQgQgnz59nKUpqmDlya0Xhl/g5KxPDOhVMZenx42ujhJg3RqBHlhcbP8/p1yVQe3rLFL9vxgsnJ7OrnOiS57+in5CfLwjIHyeSxJ0IfUqdFIrKZ3FH72196rkefRU5Q2dOp0iZevpav7omzFJA+LzC2G44GitkzoTkaihy6dGCkP0xSvy4lXHRd1edxN3Lns6Y9XtaNqhZ5UpgQA33q0EYkN5bL7VHOPj8PLCNLgxWgoEz+Cjoy+/WGQ8oiHf1+3xvtLD2MW4r6ctIkuQe9k47D+6AKoTC3CBUhl/gy3199QUpL+3r7YOE5jBOcj4PvUp2eGk3aUBzfWBYnTH/QckLZ3npf3y9tkDcpJksqU1OtJZbz9A2dizLZkYroKYmNFEua26kJ53NhCb9B3w4XHyL13jjfKCsyocgKnp5G9G2Np+xUDBD83LUtFxVKwlSENGjc9QU9g17RiBA++zihIDlb7KpXxFLwxoDxzMNn4WYB/Nrw8uUjp1I3yXLKFfqCny/FASYusPVIH/22VSkvz9Mab7QSDP1KeDHh6MuARSYSXJxKURyvL6AN65qYex+QEvTKMz9iOpA5DZXwHK0N774d8x3wkAo2FK5Cx/Jo0PUBf23oOiQeN8uq+GkVl2vqoV8bfoGSgF2PbWXv31lEpKMEZrUP4cniDXiUWYyZu3eF6eXF3lRQjw940/1uAstyc2Fo0IR3VBwfIAExWckIoTFt4gp605WhVm2xCrAxjLpheZqhM4CF4A2Rblk7KkNtBeTirG4XBbxi28AN9Tcs58PYGWX2wVtZgCYRmShjeyKCdMrk9Sx+x5yffZwnOMBvohg/oSWUYMrAWSR2v7q+B1EaH36Q2goYYjQ7EfGiGLy8E5ZmD6oNhlDVnf9CTtnxU2SbroRq2GqEDu5Gn2okgKtPsYQFSnnsA/IXXp8skBCmGwYyuvUHPdD3ydoYPUCqvHmHAhrvbA+yOZ0HKQ+/O3RPS0Punq1RSx+9t9tqeoCeV2YUefQ3kLpijStUrT7PgbWbgPnU69PLcOT5V7sbEVgHSFW0azmAv0FtUhskcBDvzVE34QHj9b+jK5MQWM+0WY2Z3Sn6S3dyb9gE9vTIbPqiHmFEtlK0aoETguwBqeMFEz7NlnD4LsC3EYJchDVTPsElToG/FycSH6oQsKkOlX4KeGjPOsttDdX7muL5bgK5MypHMHZOs4nnmj021A+W5lkkkRbisYb5fmm+/JJU5iuys1QdqlBvyQEmr8bn7Zkrb/4rRmkzlI+jvgwAtZdtDOKObSNDvgNVuDKblGCvzJrwxDPml2m8VtEs8VG8I5mmaY/nRAgR5EmRjpg1NlEUQbroX4Gf4cpDbuYiIiChmfFcF68DUf9yNRA6GDlCmjVruodaEDNa19/Xj8MnO6orUAf2ool12QavmMwA+VZiD6OU5w/tA0O/HsphvAtV4wSdq2iG8XyNvwDNzuLxVmjv8X3IlUOdv9us/C1B2hYnbqzCr/j4UGt5FVhsTVyYhXTEIlOcgr4T0ZgrWe/13WVfuqR7J2KQy7N0ZRlBFr4zhMlcaqY++I8iTEbHJ/NzFmNhiwYnswFKeL4He/BGHFcxyXqzGKsOftqdqWCGUB5jQQSpTXNdpqIw/DazRvlhZhWWaZkLmnbm68zCxFRuYPN0MgL7WAv3zsOHn/WFHUpnTdR3yMnJTGSvDwgXkcqYZC/RkAUr1jYAWT8GYVHn4xoFqksuPlOc9AH4Sz8ECvV8oDsHNGJmV6N0pqlkNL42hMj3davO9owXo22eSCuP1lyF2n5RnICI6/dAeB+j/wP0o0PMFKM4rWC3la28b1XKZjL18W4VsxAQTtQSNV8ZbK5rtHS1A334GdHluQqbWF2/KVgFtvcjTPYZ9jwXolffEEfRD8cVxLB6LnoDJSBlG4i/uqVR0hkL5rJRtmrGAvyxAypMPxWUWZfjCzGw1yeUD5VkCwK+2zuky6PkBevvfY/W49aW7dStUwzahV/8dlGL3Y8DKCnvGKePOYuY7Xy1AysN6COMwq0sBWqYsUn3Zw7YfgJ/suO3VoGdpas7QjnPcyPE1pTaOIXyA9T7XIiG7Gi5IempMMxYItAXo5WElnNkjklH2KVdmDU/uqdJKHc5pOkDPUJvL7YrMXnzZgm/mYSm/vMVVL5gZMyIjDlnxyZKeEGkAf5V9zNvAWYAyjfEIImAhhulDBvQE+DacScHVgOfZXdHTW6cLmjMKr9/F0qPvnnEzGz9oUEkfFEk9VNqqMpysfZm1sYCvFkhEyScKTTFYjbW0ChCwNiIz1pPdsW7SPQD8emcbOwU9NwTw87DagGU035tmLBAmFuBE60IA3mWUwRX0xvGi8KMSvJ+KZa3j5+a1sYCNLXAE5zbRHeB57i5Bzy/xYyaYLMTyEBb+CUwzFrCjBRpxUk9hmQzMuhyPWifukt5YG1hr0B0GP38Lyz9jSbI+N2tjgRBagNz9OSz/BrA3eHoeHoPe2iHAn4rX7Pk5ezsLi9unBb43zVjA3xZgiPAqLM8D7MXe7txr0DseAH+AdLxfhoV+/fxLyzCsQ5Zzi2Obpo8FOnApZ7AQ2Fx/iGUVgH4aa5/b/wNRz4tNW3j3PAAAAABJRU5ErkJggg=="

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sl@3x.9ffb115e.png";

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/wi@3x.d58f7730.png";

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/zim@3x.ddc5774d.png";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lang_bn_icon_0094bb_132.4c9ed732.png";

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lang_en_icon_0094bb_132.a1131b19.png";

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lang_hi_icon_0094bb_132.1caabe99.png";

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lang_si_icon_0094bb_132.8bf69cbf.png";

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lang_ta_icon_0094bb_132.ce5ede67.png";

/***/ },
/* 132 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 133 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(659);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 136 */
[667, 655],
/* 137 */
[672, 649, 651, 656],
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(658);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {
	  var firebase = __webpack_require__(13).default;
	  var g,aa=aa||{},k=this;function l(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
	function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
	function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.lb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.cd=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function oa(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function pa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function qa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}t(qa,u);qa.prototype.name="AssertionError";function ra(a,b){throw new qa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function sa(a,b){this.c=a;this.f=b;this.b=0;this.a=null}sa.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function ta(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function ua(){this.b=this.a=null}var wa=new sa(function(){return new va},function(a){a.reset()});ua.prototype.add=function(a,b){var c=wa.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function xa(){var a=ya,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function va(){this.next=this.b=this.a=null}va.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};va.prototype.reset=function(){this.next=this.b=this.a=null};var za=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},v=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Aa(a,b){var c=a.length,d=l(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}
	var Ba=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=l(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ca=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
	function Da(a){a:{var b=Ea;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function Fa(a,b){return 0<=za(a,b)}function Ga(a,b){b=za(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ha(a,b){var c=0;Aa(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ia(a){return Array.prototype.concat.apply([],arguments)}
	function Ja(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var La=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};
	function Ma(a){if(!Na.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Oa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Pa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Qa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Ra,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Sa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Ta,"&#0;"));return a}var Oa=/&/g,Pa=/</g,Qa=/>/g,Ra=/"/g,Sa=/'/g,Ta=/\x00/g,Na=/[\x00&<>"']/;function w(a,b){return-1!=a.indexOf(b)}function Ua(a,b){return a<b?-1:a>b?1:0};var Va;a:{var Wa=k.navigator;if(Wa){var Xa=Wa.userAgent;if(Xa){Va=Xa;break a}}Va=""}function x(a){return w(Va,a)};function Ya(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Za(a){for(var b in a)return!1;return!0}function $a(a){var b={},c;for(c in a)b[c]=a[c];return b}var ab="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function bb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<ab.length;f++)c=ab[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function cb(a){k.setTimeout(function(){throw a;},0)}var db;
	function eb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.tb;c.tb=null;a()}};return function(a){d.next={tb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function fb(a,b){gb||hb();ib||(gb(),ib=!0);ya.add(a,b)}var gb;function hb(){if(k.Promise&&k.Promise.resolve){var a=k.Promise.resolve(void 0);gb=function(){a.then(jb)}}else gb=function(){var a=jb;!n(k.setImmediate)||k.Window&&k.Window.prototype&&!x("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(db||(db=eb()),db(a)):k.setImmediate(a)}}var ib=!1,ya=new ua;function jb(){for(var a;a=xa();){try{a.a.call(a.b)}catch(b){cb(b)}ta(wa,a)}ib=!1};function y(a,b){this.a=kb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){lb(c,mb,a)},function(a){if(!(a instanceof nb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}lb(c,ob,a)})}catch(d){lb(this,ob,d)}}var kb=0,mb=2,ob=3;function pb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}pb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var qb=new sa(function(){return new pb},function(a){a.reset()});
	function rb(a,b,c){var d=qb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof y)return a;var b=new y(ca);lb(b,mb,a);return b}function B(a){return new y(function(b,c){c(a)})}function sb(a,b,c){tb(a,b,c,null)||fb(ma(b,a))}function ub(a){return new y(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},h=function(a){c(a)},m=0,p;m<a.length;m++)p=a[m],sb(p,ma(f,m),h);else b(e)})}
	function vb(a){return new y(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Zb:!0,value:f}:{Zb:!1,reason:f};0==c&&b(d)},f=0,h;f<a.length;f++)h=a[f],sb(h,ma(e,f,!0),ma(e,f,!1));else b(d)})}y.prototype.then=function(a,b,c){return wb(this,n(a)?a:null,n(b)?b:null,c)};oa(y);g=y.prototype;g.ia=function(a,b){a=rb(a,a,b);a.c=!0;xb(this,a);return this};g.s=function(a,b){return wb(this,null,a,b)};g.cancel=function(a){this.a==kb&&fb(function(){var b=new nb(a);yb(this,b)},this)};
	function yb(a,b){if(a.a==kb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,h=c.b;h&&(h.c||(d++,h.a==a&&(e=h),!(e&&1<d)));h=h.next)e||(f=h);e&&(c.a==kb&&1==d?yb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):zb(c),Ab(c,e,ob,b)))}a.c=null}else lb(a,ob,b)}function xb(a,b){a.b||a.a!=mb&&a.a!=ob||Bb(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function wb(a,b,c,d){var e=rb(null,null,null);e.a=new y(function(a,h){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(z){h(z)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof nb?h(b):a(e)}catch(z){h(z)}}:h});e.a.c=a;xb(a,e);return e.a}g.Lc=function(a){this.a=kb;lb(this,mb,a)};g.Mc=function(a){this.a=kb;lb(this,ob,a)};
	function lb(a,b,c){a.a==kb&&(a===c&&(b=ob,c=new TypeError("Promise cannot resolve to itself")),a.a=1,tb(c,a.Lc,a.Mc,a)||(a.i=c,a.a=b,a.c=null,Bb(a),b!=ob||c instanceof nb||Cb(a,c)))}function tb(a,b,c,d){if(a instanceof y)return xb(a,rb(b||ca,c||null,d)),!0;if(pa(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Db(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Db(a,b,c,d,e){function f(a){m||(m=!0,d.call(e,a))}function h(a){m||(m=!0,c.call(e,a))}var m=!1;try{b.call(a,h,f)}catch(p){f(p)}}function Bb(a){a.h||(a.h=!0,fb(a.Ub,a))}function zb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}g.Ub=function(){for(var a;a=zb(this);)Ab(this,a,this.a,this.i);this.h=!1};
	function Ab(a,b,c,d){if(c==ob&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Eb(b,c,d);else try{b.c?b.g.call(b.f):Eb(b,c,d)}catch(e){Fb.call(null,e)}ta(qb,b)}function Eb(a,b,c){b==mb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Cb(a,b){a.g=!0;fb(function(){a.g&&Fb.call(null,b)})}var Fb=cb;function nb(a){u.call(this,a)}t(nb,u);nb.prototype.name="cancel";function Gb(){0!=Hb&&(Ib[this[ia]||(this[ia]=++ja)]=this);this.pa=this.pa;this.ja=this.ja}var Hb=0,Ib={};Gb.prototype.pa=!1;function Jb(a){if(!a.pa&&(a.pa=!0,a.ua(),0!=Hb)){var b=a[ia]||(a[ia]=++ja);if(0!=Hb&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Ib[b]}}Gb.prototype.ua=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Kb(a){Kb[" "](a);return a}Kb[" "]=ca;function Lb(a,b){var c=Mb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Nb=x("Opera"),Ob=x("Trident")||x("MSIE"),Pb=x("Edge"),Qb=Pb||Ob,Rb=x("Gecko")&&!(w(Va.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),Sb=w(Va.toLowerCase(),"webkit")&&!x("Edge");function Tb(){var a=k.document;return a?a.documentMode:void 0}var Ub;
	a:{var Vb="",Wb=function(){var a=Va;if(Rb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Pb)return/Edge\/([\d\.]+)/.exec(a);if(Ob)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Sb)return/WebKit\/(\S+)/.exec(a);if(Nb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Wb&&(Vb=Wb?Wb[1]:"");if(Ob){var Xb=Tb();if(null!=Xb&&Xb>parseFloat(Vb)){Ub=String(Xb);break a}}Ub=Vb}var Mb={};
	function Yb(a){return Lb(a,function(){for(var b=0,c=La(String(Ub)).split("."),d=La(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=Ua(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||Ua(0==h[2].length,0==m[2].length)||Ua(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Zb;var $b=k.document;
	Zb=$b&&Ob?Tb()||("CSS1Compat"==$b.compatMode?parseInt(Ub,10):5):void 0;var ac=Object.freeze||function(a){return a};var bc=!Ob||9<=Number(Zb),cc=Ob&&!Yb("9"),dc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function C(a,b){this.type=a;this.b=this.target=b;this.Gb=!0}C.prototype.preventDefault=function(){this.Gb=!1};function ec(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Rb){a:{try{Kb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:fc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(ec,C);var fc=ac({2:"touch",3:"pen",4:"mouse"});ec.prototype.preventDefault=function(){ec.lb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,cc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};ec.prototype.f=function(){return this.a};var gc="closure_listenable_"+(1E6*Math.random()|0),hc=0;function ic(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++hc;this.na=this.Ia=!1}function jc(a){a.na=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null};function kc(a){this.src=a;this.a={};this.b=0}kc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=lc(a,b,d,e);-1<h?(b=a[h],c||(b.Ia=!1)):(b=new ic(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function mc(a,b){var c=b.type;c in a.a&&Ga(a.a[c],b)&&(jc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function lc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.na&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var nc="closure_lm_"+(1E6*Math.random()|0),oc={},qc=0;function rc(a,b,c,d,e){if(d&&d.once)sc(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)rc(a,b[f],c,d,e);else c=tc(c),a&&a[gc]?uc(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!1,d,e)}
	function vc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=q(e)?!!e.capture:!!e,m=wc(a);m||(a[nc]=m=new kc(a));c=m.add(b,c,d,h,f);if(!c.proxy){d=xc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)dc||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(yc(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");qc++}}
	function xc(){var a=zc,b=bc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function sc(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)sc(a,b[f],c,d,e);else c=tc(c),a&&a[gc]?Ac(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!0,d,e)}
	function D(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)D(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=tc(c),a&&a[gc])?(a=a.m,b=String(b).toString(),b in a.a&&(f=a.a[b],c=lc(f,c,d,e),-1<c&&(jc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=wc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=lc(b,c,d,e)),(c=-1<a?b[a]:null)&&Bc(c))}
	function Bc(a){if("number"!=typeof a&&a&&!a.na){var b=a.src;if(b&&b[gc])mc(b.m,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(yc(c),d):b.addListener&&b.removeListener&&b.removeListener(d);qc--;(c=wc(b))?(mc(c,a),0==c.b&&(c.src=null,b[nc]=null)):jc(a)}}}function yc(a){return a in oc?oc[a]:oc[a]="on"+a}
	function Cc(a,b,c,d){var e=!0;if(a=wc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.na&&(f=Dc(f,d),e=e&&!1!==f)}return e}function Dc(a,b){var c=a.listener,d=a.La||a.src;a.Ia&&Bc(a);return c.call(d,b)}
	function zc(a,b){if(a.na)return!0;if(!bc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new ec(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Cc(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Cc(d[e],a,!1,b),c=c&&f}return c}return Dc(a,
	new ec(b,this))}function wc(a){a=a[nc];return a instanceof kc?a:null}var Ec="__closure_events_fn_"+(1E9*Math.random()>>>0);function tc(a){if(n(a))return a;a[Ec]||(a[Ec]=function(b){return a.handleEvent(b)});return a[Ec]};function E(){Gb.call(this);this.m=new kc(this);this.Nb=this;this.Ua=null}t(E,Gb);E.prototype[gc]=!0;E.prototype.addEventListener=function(a,b,c,d){rc(this,a,b,c,d)};E.prototype.removeEventListener=function(a,b,c,d){D(this,a,b,c,d)};
	E.prototype.dispatchEvent=function(a){var b,c=this.Ua;if(c)for(b=[];c;c=c.Ua)b.push(c);c=this.Nb;var d=a.type||a;if(l(a))a=new C(a,c);else if(a instanceof C)a.target=a.target||c;else{var e=a;a=new C(d,c);bb(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.b=b[f];e=Fc(h,d,!0,a)&&e}h=a.b=c;e=Fc(h,d,!0,a)&&e;e=Fc(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.b=b[f],e=Fc(h,d,!1,a)&&e;return e};
	E.prototype.ua=function(){E.lb.ua.call(this);if(this.m){var a=this.m,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,jc(d[e]);delete a.a[c];a.b--}}this.Ua=null};function uc(a,b,c,d,e){a.m.add(String(b),c,!1,d,e)}function Ac(a,b,c,d,e){a.m.add(String(b),c,!0,d,e)}
	function Fc(a,b,c,d){b=a.m.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.na&&h.capture==c){var m=h.listener,p=h.La||h.src;h.Ia&&mc(a.m,h);e=!1!==m.call(p,d)&&e}}return e&&0!=d.Gb};function Gc(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Hc(a){var b=null;return(new y(function(c,d){b=Gc(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function Ic(a){if(a.S&&"function"==typeof a.S)return a.S();if(l(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Jc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ha(a)||l(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
	function Kc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||l(a))v(a,b,void 0);else for(var c=Jc(a),d=Ic(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Lc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Lc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=Lc.prototype;g.S=function(){Mc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.U=function(){Mc(this);return this.a.concat()};
	g.clear=function(){this.b={};this.c=this.a.length=0};function Mc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Nc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Nc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return Nc(this.b,a)?this.b[a]:b};g.set=function(a,b){Nc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	g.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Nc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Oc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Qc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Rc(a,b){this.b=this.m=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof Rc){this.f=void 0!==b?b:a.f;Sc(this,a.c);this.m=a.m;this.b=a.b;Tc(this,a.i);this.g=a.g;b=a.a;var c=new Uc;c.c=b.c;b.a&&(c.a=new Lc(b.a),c.b=b.b);Vc(this,c);this.h=a.h}else a&&(c=String(a).match(Oc))?(this.f=!!b,Sc(this,c[1]||"",!0),this.m=Wc(c[2]||""),this.b=Wc(c[3]||"",!0),Tc(this,c[4]),this.g=Wc(c[5]||"",!0),Vc(this,c[6]||"",!0),this.h=Wc(c[7]||"")):(this.f=!!b,this.a=new Uc(null,this.f))}
	Rc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Xc(b,Yc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.m)&&a.push(Xc(b,Yc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Xc(c,"/"==c.charAt(0)?Zc:$c,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Xc(c,ad));return a.join("")};
	function Sc(a,b,c){a.c=c?Wc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Tc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function Vc(a,b,c){b instanceof Uc?(a.a=b,bd(a.a,a.f)):(c||(b=Xc(b,cd)),a.a=new Uc(b,a.f))}function F(a,b,c){a.a.set(b,c)}function dd(a,b){return a.a.get(b)}function ed(a){return a instanceof Rc?new Rc(a):new Rc(a,void 0)}function fd(a,b){var c=new Rc(null,void 0);Sc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
	function Wc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Xc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,gd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function gd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Yc=/[#\/\?@]/g,$c=/[#\?:]/g,Zc=/[#\?]/g,cd=/[#\?@]/g,ad=/#/g;function Uc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
	function hd(a){a.a||(a.a=new Lc,a.b=0,a.c&&Qc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function id(a){var b=Jc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Uc(null,void 0);a=Ic(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?jd(c,e,f):c.add(e,f)}return c}g=Uc.prototype;g.add=function(a,b){hd(this);this.c=null;a=kd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
	function ld(a,b){hd(a);b=kd(a,b);Nc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Nc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Mc(a)))}g.clear=function(){this.a=this.c=null;this.b=0};function md(a,b){hd(a);b=kd(a,b);return Nc(a.a.b,b)}g.forEach=function(a,b){hd(this);this.a.forEach(function(c,d){v(c,function(c){a.call(b,c,d,this)},this)},this)};g.U=function(){hd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	g.S=function(a){hd(this);var b=[];if(l(a))md(this,a)&&(b=Ia(b,this.a.get(kd(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ia(b,a[c])}return b};g.set=function(a,b){hd(this);this.c=null;a=kd(this,a);md(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.S(a):[];return 0<a.length?String(a[0]):b};function jd(a,b,c){ld(a,b);0<c.length&&(a.c=null,a.a.set(kd(a,b),Ja(c)),a.b+=c.length)}
	g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function kd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function bd(a,b){b&&!a.f&&(hd(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(ld(this,b),jd(this,c,a))},a));a.f=b};var nd=!Ob||9<=Number(Zb);function od(){this.a="";this.b=pd}od.prototype.ma=!0;od.prototype.la=function(){return this.a};od.prototype.toString=function(){return"Const{"+this.a+"}"};function qd(a){if(a instanceof od&&a.constructor===od&&a.b===pd)return a.a;ra("expected object of type Const, got '"+a+"'");return"type_error:Const"}var pd={};function rd(a){var b=new od;b.a=a;return b}rd("");function sd(){this.a="";this.b=td}sd.prototype.ma=!0;sd.prototype.la=function(){return this.a};sd.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function ud(a){if(a instanceof sd&&a.constructor===sd&&a.b===td)return a.a;ra("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}
	function vd(a,b){var c=qd(a);if(!wd.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(xd,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof od?qd(a):encodeURIComponent(String(a))});return yd(a)}var xd=/%{(\w+)}/g,wd=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i,td={};
	function yd(a){var b=new sd;b.a=a;return b};function zd(){this.a="";this.b=Ad}zd.prototype.ma=!0;zd.prototype.la=function(){return this.a};zd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Bd(a){if(a instanceof zd&&a.constructor===zd&&a.b===Ad)return a.a;ra("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var Cd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function Dd(a){if(a instanceof zd)return a;a=a.ma?a.la():String(a);Cd.test(a)||(a="about:invalid#zClosurez");return Ed(a)}var Ad={};function Ed(a){var b=new zd;b.a=a;return b}Ed("about:blank");function Fd(){this.a="";this.b=Gd}Fd.prototype.ma=!0;Fd.prototype.la=function(){return this.a};Fd.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Hd(a){if(a instanceof Fd&&a.constructor===Fd&&a.b===Gd)return a.a;ra("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var Gd={};function Id(a){var b=new Fd;b.a=a;return b}Id("<!DOCTYPE html>");Id("");Id("<br>");function Jd(a){var b=document;return l(a)?b.getElementById(a):a}function Kd(a,b){Ya(b,function(b,d){b&&b.ma&&(b=b.la());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Ld.hasOwnProperty(d)?a.setAttribute(Ld[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
	var Ld={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function Md(a,b,c){var d=arguments,e=document,f=String(d[0]),h=d[1];if(!nd&&h&&(h.name||h.type)){f=["<",f];h.name&&f.push(' name="',Ma(h.name),'"');if(h.type){f.push(' type="',Ma(h.type),'"');var m={};bb(m,h);delete m.type;h=m}f.push(">");f=f.join("")}f=e.createElement(f);h&&(l(h)?f.className=h:fa(h)?f.className=h.join(" "):Kd(f,h));2<d.length&&Nd(e,f,d);return f}
	function Nd(a,b,c){function d(c){c&&b.appendChild(l(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):v(Od(f)?Ja(f):f,d)}}function Od(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function Pd(a){var b=[];Qd(new Rd,a,b);return b.join("")}function Rd(){}
	function Qd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Qd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Sd(d,c),c.push(":"),Qd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Sd(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Td={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ud=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function Sd(a,b){b.push('"',a.replace(Ud,function(a){var b=Td[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Td[a]=b);return b}),'"')};function Vd(){var a=G();return Ob&&!!Zb&&11==Zb||/Edge\/\d+/.test(a)}function Wd(){return k.window&&k.window.location.href||self&&self.location&&self.location.href||""}function Xd(a,b){b=b||k.window;var c="about:blank";a&&(c=Bd(Dd(a)));b.location.href=c}function Yd(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Yd(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function Zd(){var a=G();a=$d(a)!=ae?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Ob||!Zb||9<Zb}function be(a){a=(a||G()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ce(a){a=a||k.window;try{a.close()}catch(b){}}
	function de(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=G().toLowerCase();d&&(b.target=d,w(c,"crios/")&&(b.target="_blank"));$d(G())==ee&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof zd?c:Dd("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
	for(h in a)switch(h){case "width":case "height":case "top":case "left":e.push(h+"="+a[h]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(h+"="+(a[h]?1:0))}var h=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(h=d.document.createElement("A"),b instanceof zd||b instanceof zd||(b=b.ma?b.la():String(b),Cd.test(b)||(b="about:invalid#zClosurez"),b=Ed(b)),h.href=Bd(b),h.setAttribute("target",c),a.noreferrer&&
	h.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),h.dispatchEvent(a),h={}):a.noreferrer?(h=d.open("",c,h),a=Bd(b),h&&(Qb&&w(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),h.opener=null,rd("b/12014412, meta tag with sanitized URL"),a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ma(a)+'">',a=Id(a),h.document.write(Hd(a)),h.document.close())):(h=d.open(Bd(b),c,h))&&a.noopener&&(h.opener=null);if(h)try{h.focus()}catch(m){}return h}
	function fe(a){return new y(function(b){function c(){Hc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ge=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function he(){var a=null;return(new y(function(b){"complete"==k.document.readyState?b():(a=function(){b()},sc(window,"load",a))})).s(function(b){D(window,"load",a);throw b;})}
	function ie(){return je(void 0)?he().then(function(){return new y(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function je(a){a=a||G();return!("file:"!==ke()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function le(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function me(){return"object"!==typeof k.window&&"function"===typeof k.importScripts}function ne(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":me()?"Worker":"Browser"}function oe(){var a=ne();return"ReactNative"===a||"Node"===a}function pe(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}var ee="Firefox",ae="Chrome";
	function $d(a){var b=a.toLowerCase();if(w(b,"opera/")||w(b,"opr/")||w(b,"opios/"))return"Opera";if(w(b,"iemobile"))return"IEMobile";if(w(b,"msie")||w(b,"trident/"))return"IE";if(w(b,"edge/"))return"Edge";if(w(b,"firefox/"))return ee;if(w(b,"silk/"))return"Silk";if(w(b,"blackberry"))return"Blackberry";if(w(b,"webos"))return"Webos";if(!w(b,"safari/")||w(b,"chrome/")||w(b,"crios/")||w(b,"android"))if(!w(b,"chrome/")&&!w(b,"crios/")||w(b,"edge/")){if(w(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return ae;else return"Safari";return"Other"}var qe={Sc:"FirebaseCore-web",Uc:"FirebaseUI-web"};function re(a,b){b=b||[];var c=[],d={},e;for(e in qe)d[qe[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=ne();"Browser"===c?(d=G(),c=$d(d)):"Worker"===c&&(d=G(),c=$d(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function G(){return k.navigator&&k.navigator.userAgent||""}
	function H(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function se(){try{var a=k.localStorage,b=te();if(a)return a.setItem(b,"1"),a.removeItem(b),Vd()?!!k.indexedDB:!0}catch(c){return me()&&!!k.indexedDB}return!1}function ue(){return(ve()||"chrome-extension:"===ke()||je())&&!oe()&&se()&&!me()}function ve(){return"http:"===ke()||"https:"===ke()}function ke(){return k.location&&k.location.protocol||null}
	function we(a){a=a||G();return be(a)||$d(a)==ee?!1:!0}function xe(a){return"undefined"===typeof a?null:Pd(a)}function ye(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function ze(a){if(null!==a)return JSON.parse(a)}function te(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ae(a){a=a||G();return"Safari"==$d(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Be(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Ce(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=G();b=ne();this.b=be(a)||"ReactNative"===b}
	Ce.prototype.get=function(){var a=k.navigator;return(a&&"boolean"===typeof a.onLine&&(ve()||"chrome-extension:"===ke()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function De(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
	function Ee(){var a=k.document,b=null;return De()||!a?A():(new y(function(c){b=function(){De()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Fe(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Ge(){return!(!H("fireauth.oauthhelper",k)&&!H("fireauth.iframe",k))};var He={};function Ie(a){He[a]||(He[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Je;try{var Ke={};Object.defineProperty(Ke,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Ke,"abcd",{configurable:!0,enumerable:!0,value:2});Je=2==Ke.abcd}catch(a){Je=!1}function I(a,b,c){Je?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function J(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&I(a,c,b[c])}function Le(a){var b={};J(b,a);return b}function Me(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function Ne(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Oe(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)I(b,c,Oe(a[c]))}return b};function Pe(a){var b={},c=a[Qe],d=a[Re];a=a[Se];if(!a||a!=Te&&!c)throw Error("Invalid provider user info!");b[Ue]=d||null;b[Ve]=c||null;I(this,We,a);I(this,Xe,Oe(b))}var Te="EMAIL_SIGNIN",Qe="email",Re="newEmail",Se="requestType",Ve="email",Ue="fromEmail",Xe="data",We="operation";function K(a,b){this.code=Ye+a;this.message=b||Ze[a]||""}t(K,Error);K.prototype.D=function(){return{code:this.code,message:this.message}};K.prototype.toJSON=function(){return this.D()};function $e(a){var b=a&&a.code;return b?new K(b.substring(Ye.length),a.message):null}
	var Ye="auth/",Ze={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
	"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
	"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
	"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
	"invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
	"invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
	"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
	"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
	"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
	"operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.",
	"quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.",
	"unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.",
	"user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function af(a){var b=a[bf];if("undefined"===typeof b)throw new K("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new K("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[cf];if(c&&"object"===typeof c){b=c[df];var d=c[ef];c=c[ff];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new K("argument-error",ef+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new K("argument-error",ff+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new K("argument-error",df+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new K("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new K("argument-error",cf+" property must be a non null object when specified.");this.f=null;if((b=a[gf])&&"object"===
	typeof b)if(b=b[hf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new K("argument-error",hf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new K("argument-error",gf+" property must be a non null object when specified.");a=a[jf];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new K("argument-error",jf+" property must be a boolean when specified.");this.c=!!a}
	var cf="android",jf="handleCodeInApp",gf="iOS",bf="url",ef="installApp",ff="minimumVersion",df="packageName",hf="bundleId";function kf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;for(var c in b)null===b[c]&&delete b[c];return b};function lf(a){return Ba(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var mf=null,nf=null;function of(a){var b="";pf(a,function(a){b+=String.fromCharCode(a)});return b}function pf(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=nf[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}qf();for(var d=0;;){var e=c(-1),f=c(0),h=c(64),m=c(64);if(64===m&&-1===e)break;b(e<<2|f>>4);64!=h&&(b(f<<4&240|h>>2),64!=m&&b(h<<6&192|m))}}
	function qf(){if(!mf){mf={};nf={};for(var a=0;65>a;a++)mf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),nf[mf[a]]=a,62<=a&&(nf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function rf(a){this.c=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}rf.prototype.f=function(){return this.b};function sf(a){return(a=tf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new rf(a):null}function tf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(of(a))}catch(d){}return null};var uf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),vf=["client_id","response_type","scope","redirect_uri","state"],wf={Tc:{Ma:"locale",Ba:500,Aa:600,Na:"facebook.com",eb:vf},Vc:{Ma:null,Ba:500,Aa:620,Na:"github.com",eb:vf},Wc:{Ma:"hl",Ba:515,Aa:680,Na:"google.com",eb:vf},bd:{Ma:"lang",Ba:485,Aa:705,Na:"twitter.com",eb:uf}};function xf(a){for(var b in wf)if(wf[b].Na==a)return wf[b];return null};function yf(a){var b={};b["facebook.com"]=zf;b["google.com"]=Af;b["github.com"]=Bf;b["twitter.com"]=Cf;var c=a&&a[Df];try{if(c)return b[c]?new b[c](a):new Ef(a);if("undefined"!==typeof a[Ff])return new Gf(a)}catch(d){}return null}var Ff="idToken",Df="providerId";
	function Gf(a){var b=a[Df];if(!b&&a[Ff]){var c=sf(a[Ff]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);I(this,"providerId",b);I(this,"isNewUser",c)}function Ef(a){Gf.call(this,a);a=ze(a.rawUserInfo||"{}");I(this,"profile",Oe(a||{}))}t(Ef,Gf);
	function zf(a){Ef.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(zf,Ef);function Bf(a){Ef.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");I(this,"username",this.profile&&this.profile.login||null)}t(Bf,Ef);function Af(a){Ef.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Af,Ef);
	function Cf(a){Ef.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");I(this,"username",a.screenName||null)}t(Cf,Ef);function Hf(a){this.a=ed(a)};function If(a){var b=ed(a),c=dd(b,"link"),d=dd(ed(c),"link");b=dd(b,"deep_link_id");return dd(ed(b),"link")||b||d||c||a};function Jf(a,b){return a.then(function(a){if(a[L]){var c=sf(a[L]);if(!c||b!=c.c)throw new K("user-mismatch");return a}throw new K("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==Ye+"user-not-found"?new K("user-mismatch"):a;})}
	function Kf(a,b,c){if(b.idToken||b.accessToken)b.idToken&&I(this,"idToken",b.idToken),b.accessToken&&I(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)I(this,"accessToken",b.oauthToken),I(this,"secret",b.oauthTokenSecret);else throw new K("internal-error","failed to construct a credential");I(this,"providerId",a);I(this,"signInMethod",c)}Kf.prototype.ya=function(a){return Lf(a,Mf(this))};Kf.prototype.c=function(a,b){var c=Mf(this);c.idToken=b;return Nf(a,c)};
	Kf.prototype.f=function(a,b){var c=Mf(this);return Jf(Of(a,c),b)};function Mf(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:id(b).toString(),requestUri:"http://localhost"}}
	Kf.prototype.D=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function Pf(a,b){this.Ac=b||[];J(this,{providerId:a,isOAuthProvider:!0});this.vb={};this.$a=(xf(a)||{}).Ma||null;this.Ya=null}Pf.prototype.Da=function(a){this.vb=$a(a);return this};function M(a){Pf.call(this,a,vf);this.a=[]}t(M,Pf);
	M.prototype.ta=function(a){Fa(this.a,a)||this.a.push(a);return this};M.prototype.Ab=function(){return Ja(this.a)};M.prototype.credential=function(a,b){if(!a&&!b)throw new K("argument-error","credential failed: must provide the ID token and/or the access token.");return new Kf(this.providerId,{idToken:a||null,accessToken:b||null},this.providerId)};function Qf(){M.call(this,"facebook.com")}t(Qf,M);I(Qf,"PROVIDER_ID","facebook.com");I(Qf,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
	function Rf(a){if(!a)throw new K("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Qf).credential(null,b)}function Sf(){M.call(this,"github.com")}t(Sf,M);I(Sf,"PROVIDER_ID","github.com");I(Sf,"GITHUB_SIGN_IN_METHOD","github.com");function Tf(a){if(!a)throw new K("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Sf).credential(null,b)}
	function Uf(){M.call(this,"google.com");this.ta("profile")}t(Uf,M);I(Uf,"PROVIDER_ID","google.com");I(Uf,"GOOGLE_SIGN_IN_METHOD","google.com");function Vf(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new Uf).credential(c,b)}function Wf(){Pf.call(this,"twitter.com",uf)}t(Wf,Pf);I(Wf,"PROVIDER_ID","twitter.com");I(Wf,"TWITTER_SIGN_IN_METHOD","twitter.com");
	function Xf(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new K("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Kf("twitter.com",c,"twitter.com")}function Yf(a,b,c){this.a=a;this.b=b;I(this,"providerId","password");I(this,"signInMethod",c===N.EMAIL_LINK_SIGN_IN_METHOD?N.EMAIL_LINK_SIGN_IN_METHOD:N.EMAIL_PASSWORD_SIGN_IN_METHOD)}
	Yf.prototype.ya=function(a){return this.signInMethod==N.EMAIL_LINK_SIGN_IN_METHOD?O(a,Zf,{email:this.a,oobCode:this.b}):O(a,$f,{email:this.a,password:this.b})};Yf.prototype.c=function(a,b){return this.signInMethod==N.EMAIL_LINK_SIGN_IN_METHOD?O(a,ag,{idToken:b,email:this.a,oobCode:this.b}):O(a,bg,{idToken:b,email:this.a,password:this.b})};Yf.prototype.f=function(a,b){return Jf(this.ya(a),b)};Yf.prototype.D=function(){return{email:this.a,password:this.b,signInMethod:this.signInMethod}};
	function N(){J(this,{providerId:"password",isOAuthProvider:!1})}function cg(a,b){b=dg(b);if(!b)throw new K("argument-error","Invalid email link!");return new Yf(a,b,N.EMAIL_LINK_SIGN_IN_METHOD)}function dg(a){a=If(a);a=new Hf(a);var b=dd(a.a,"oobCode")||null;return"signIn"===(dd(a.a,"mode")||null)&&b?b:null}J(N,{PROVIDER_ID:"password"});J(N,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});J(N,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
	function eg(a){if(!(a.Sa&&a.Ra||a.Fa&&a.$))throw new K("internal-error");this.a=a;I(this,"providerId","phone");I(this,"signInMethod","phone")}eg.prototype.ya=function(a){return a.Ta(fg(this))};eg.prototype.c=function(a,b){var c=fg(this);c.idToken=b;return O(a,gg,c)};eg.prototype.f=function(a,b){var c=fg(this);c.operation="REAUTH";a=O(a,hg,c);return Jf(a,b)};
	eg.prototype.D=function(){var a={providerId:"phone"};this.a.Sa&&(a.verificationId=this.a.Sa);this.a.Ra&&(a.verificationCode=this.a.Ra);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function fg(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Sa,code:a.a.Ra}}
	function ig(a){try{this.a=a||firebase.auth()}catch(b){throw new K("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}J(this,{providerId:"phone",isOAuthProvider:!1})}
	ig.prototype.Ta=function(a,b){var c=this.a.b;return A(b.verify()).then(function(d){if(!l(d))throw new K("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return jg(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new K("argument-error",
	'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function kg(a,b){if(!a)throw new K("missing-verification-id");if(!b)throw new K("missing-verification-code");return new eg({Sa:a,Ra:b})}J(ig,{PROVIDER_ID:"phone"});J(ig,{PHONE_SIGN_IN_METHOD:"phone"});
	function lg(a){if(a.temporaryProof&&a.phoneNumber)return new eg({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return Vf(a,c);case "facebook.com":return Rf(c);case "github.com":return Tf(c);case "twitter.com":return Xf(c,d);default:return(new M(b)).credential(a,c)}}catch(e){return null}}
	function mg(a){if(!a.isOAuthProvider)throw new K("invalid-oauth-provider");};function ng(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new K("invalid-auth-event");if(this.f&&!this.g)throw new K("invalid-auth-event");}else throw new K("invalid-auth-event");}ng.prototype.D=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.D()}};function og(a){a=a||{};return a.type?new ng(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&$e(a.error)):null};function pg(){this.b=null;this.a=[]}var qg=null;pg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=H("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};pg.prototype.unsubscribe=function(a){Ha(this.a,function(b){return b==a})};function rg(a){var b="unauthorized-domain",c=void 0,d=ed(a);a=d.b;d=d.c;"chrome-extension"==d?c=Ka("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ka("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	K.call(this,b,c)}t(rg,K);function sg(a,b,c){K.call(this,a,c);a=b||{};a.wb&&I(this,"email",a.wb);a.$&&I(this,"phoneNumber",a.$);a.credential&&I(this,"credential",a.credential)}t(sg,K);sg.prototype.D=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.D();b&&bb(a,b);return a};sg.prototype.toJSON=function(){return this.D()};
	function tg(a){if(a.code){var b=a.code||"";0==b.indexOf(Ye)&&(b=b.substring(Ye.length));var c={credential:lg(a)};if(a.email)c.wb=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else return new K(b,a.message||void 0);return new sg(b,c,a.message)}return null};var ug=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function vg(){}vg.prototype.c=null;function wg(a){return a.c||(a.c=a.b())};var xg;function yg(){}t(yg,vg);yg.prototype.a=function(){var a=zg(this);return a?new ActiveXObject(a):new XMLHttpRequest};yg.prototype.b=function(){var a={};zg(this)&&(a[0]=!0,a[1]=!0);return a};
	function zg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}xg=new yg;function Ag(){}t(Ag,vg);Ag.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Bg;throw Error("Unsupported browser");};Ag.prototype.b=function(){return{}};
	function Bg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText="";this.a.onload=r(this.bc,this);this.a.onerror=r(this.Bb,this);this.a.onprogress=r(this.cc,this);this.a.ontimeout=r(this.fc,this)}g=Bg.prototype;g.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	g.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};g.abort=function(){this.a.abort()};g.setRequestHeader=function(){};g.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};g.bc=function(){this.status=200;this.responseText=this.a.responseText;Cg(this,4)};g.Bb=function(){this.status=500;this.responseText="";Cg(this,4)};g.fc=function(){this.Bb()};
	g.cc=function(){this.status=200;Cg(this,1)};function Cg(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}g.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Dg(a,b,c){this.reset(a,b,c,void 0,void 0)}Dg.prototype.a=null;var Eg=0;Dg.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Eg++;d||na();delete this.a};function Fg(a){this.f=a;this.b=this.c=this.a=null}function Gg(a,b){this.name=a;this.value=b}Gg.prototype.toString=function(){return this.name};var Hg=new Gg("SEVERE",1E3),Ig=new Gg("WARNING",900),Jg=new Gg("CONFIG",700),Kg=new Gg("FINE",500);function Lg(a){if(a.c)return a.c;if(a.a)return Lg(a.a);ra("Root logger has no level set.");return null}Fg.prototype.log=function(a,b,c){if(a.value>=Lg(this).value)for(n(b)&&(b=b()),a=new Dg(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Mg={},Ng=null;
	function Og(a){Ng||(Ng=new Fg(""),Mg[""]=Ng,Ng.c=Jg);var b;if(!(b=Mg[a])){b=new Fg(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Og(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Mg[a]=b}return b};function P(a,b){a&&a.log(Kg,b,void 0)};function Pg(a){this.f=a}t(Pg,vg);Pg.prototype.a=function(){return new Qg(this.f)};Pg.prototype.b=function(a){return function(){return a}}({});function Qg(a){E.call(this);this.i=a;this.readyState=Rg;this.status=0;this.responseText=this.statusText="";this.onreadystatechange=null;this.g=new Headers;this.b=null;this.h="GET";this.c="";this.a=!1;this.f=Og("goog.net.FetchXmlHttp")}t(Qg,E);var Rg=0;g=Qg.prototype;
	g.open=function(a,b){if(this.readyState!=Rg)throw this.abort(),Error("Error reopening a connection");this.h=a;this.c=b;this.readyState=1;Sg(this)};g.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.g,method:this.h,credentials:void 0,cache:void 0};a&&(b.body=a);this.i.fetch(new Request(this.c,b)).then(this.ec.bind(this),this.Cb.bind(this))};
	g.abort=function(){this.responseText="";this.g=new Headers;this.status=0;1<=this.readyState&&this.a&&4!=this.readyState&&(this.readyState=4,this.a=!1,Sg(this));this.readyState=Rg};g.ec=function(a){this.a&&(this.b||(this.b=a.headers,this.readyState=2,Sg(this)),this.a&&(this.readyState=3,Sg(this),this.a&&a.text().then(this.dc.bind(this,a),this.Cb.bind(this))))};g.dc=function(a,b){this.a&&(this.status=a.status,this.statusText=a.statusText,this.responseText=b,this.readyState=4,Sg(this))};
	g.Cb=function(a){var b=this.f;b&&b.log(Ig,"Failed to fetch url "+this.c,a instanceof Error?a:Error(a));this.a&&(this.readyState=4,Sg(this))};g.setRequestHeader=function(a,b){this.g.append(a,b)};g.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.f)&&a.log(Ig,"Attempting to get response header but no headers have been received for url: "+this.c,void 0),"")};
	g.getAllResponseHeaders=function(){if(!this.b){var a=this.f;a&&a.log(Ig,"Attempting to get all response headers but no headers have been received for url: "+this.c,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Sg(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Tg(a){E.call(this);this.headers=new Lc;this.C=a||null;this.c=!1;this.w=this.a=null;this.h=this.N=this.l="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.o=Ug;this.v=this.O=!1}t(Tg,E);var Ug="";Tg.prototype.b=Og("goog.net.XhrIo");var Vg=/^https?$/i,Wg=["POST","PUT"];
	function Xg(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.C?a.C.a():xg.a();a.w=a.C?wg(a.C):wg(xg);a.a.onreadystatechange=r(a.Fb,a);try{P(a.b,Yg(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(h){P(a.b,Yg(a,"Error opening Xhr: "+h.message));Zg(a,h);return}b=d||"";var f=new Lc(a.headers);e&&Kc(e,function(a,b){f.set(b,a)});e=Da(f.U());d=k.FormData&&b instanceof
	k.FormData;!Fa(Wg,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{$g(a),0<a.g&&(a.v=ah(a.a),P(a.b,Yg(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=r(a.Ga,a)):a.u=Gc(a.Ga,a.g,a)),P(a.b,Yg(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(h){P(a.b,Yg(a,
	"Send error: "+h.message)),Zg(a,h)}}function ah(a){return Ob&&Yb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ea(a){return"content-type"==a.toLowerCase()}g=Tg.prototype;g.Ga=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",P(this.b,Yg(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Zg(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;bh(a);ch(a)}
	function bh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}g.abort=function(){this.a&&this.c&&(P(this.b,Yg(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),ch(this))};g.ua=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),ch(this,!0));Tg.lb.ua.call(this)};g.Fb=function(){this.pa||(this.I||this.i||this.f?dh(this):this.tc())};g.tc=function(){dh(this)};
	function dh(a){if(a.c&&"undefined"!=typeof aa)if(a.w[1]&&4==eh(a)&&2==fh(a))P(a.b,Yg(a,"Local request error detected and ignored"));else if(a.i&&4==eh(a))Gc(a.Fb,0,a);else if(a.dispatchEvent("readystatechange"),4==eh(a)){P(a.b,Yg(a,"Request complete"));a.c=!1;try{var b=fh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Oc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
	f=h.substr(0,h.length-1)}e=!Vg.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var m=2<eh(a)?a.a.statusText:""}catch(p){P(a.b,"Can not get status: "+p.message),m=""}a.h=m+" ["+fh(a)+"]";bh(a)}}finally{ch(a)}}}function ch(a,b){if(a.a){$g(a);var c=a.a,d=a.w[0]?ca:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Hg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function $g(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(k.clearTimeout(a.u),a.u=null)}function eh(a){return a.a?a.a.readyState:0}function fh(a){try{return 2<eh(a)?a.a.status:-1}catch(b){return-1}}function gh(a){try{return a.a?a.a.responseText:""}catch(b){return P(a.b,"Can not get responseText: "+b.message),""}}
	g.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case Ug:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Hg,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return P(this.b,"Can not get response: "+b.message),null}};function Yg(a,b){return b+" ["+a.N+" "+a.l+" "+fh(a)+"]"};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function hh(a,b){this.g=[];this.v=a;this.u=b||null;this.f=this.a=!1;this.c=void 0;this.l=this.w=this.i=!1;this.h=0;this.b=null;this.m=0}hh.prototype.cancel=function(a){if(this.a)this.c instanceof hh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.m--,0>=b.m&&b.cancel())}this.v?this.v.call(this.u,this):this.l=!0;this.a||(a=new ih(this),jh(this),kh(this,!1,a))}};hh.prototype.o=function(a,b){this.i=!1;kh(this,a,b)};function kh(a,b,c){a.a=!0;a.c=c;a.f=!b;lh(a)}
	function jh(a){if(a.a){if(!a.l)throw new mh(a);a.l=!1}}hh.prototype.C=function(){jh(this);kh(this,!0,null)};function nh(a,b){oh(a,null,b,void 0)}function oh(a,b,c,d){a.g.push([b,c,d]);a.a&&lh(a)}hh.prototype.then=function(a,b,c){var d,e,f=new y(function(a,b){d=a;e=b});oh(this,d,function(a){a instanceof ih?f.cancel():e(a)});return f.then(a,b,c)};oa(hh);function ph(a){return Ca(a.g,function(a){return n(a[1])})}
	function lh(a){if(a.h&&a.a&&ph(a)){var b=a.h,c=qh[b];c&&(k.clearTimeout(c.a),delete qh[b]);a.h=0}a.b&&(a.b.m--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],h=e[1];e=e[2];if(f=a.f?h:f)try{var m=f.call(e||a.u,b);void 0!==m&&(a.f=a.f&&(m==b||m instanceof Error),a.c=b=m);if(pa(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(p){b=p,a.f=!0,ph(a)||(c=!0)}}a.c=b;d&&(m=r(a.o,a,!0),d=r(a.o,a,!1),b instanceof hh?(oh(b,m,d),b.w=!0):b.then(m,d));c&&(b=
	new rh(b),qh[b.a]=b,a.h=b.a)}function mh(){u.call(this)}t(mh,u);mh.prototype.message="Deferred has already fired";mh.prototype.name="AlreadyCalledError";function ih(){u.call(this)}t(ih,u);ih.prototype.message="Deferred was canceled";ih.prototype.name="CanceledError";function rh(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}rh.prototype.c=function(){delete qh[this.a];throw this.b;};var qh={};function sh(a){var b={},c=b.document||document,d=ud(a),e=document.createElement("SCRIPT"),f={Hb:e,Ga:void 0},h=new hh(th,f),m=null,p=null!=b.timeout?b.timeout:5E3;0<p&&(m=window.setTimeout(function(){uh(e,!0);var a=new vh(wh,"Timeout reached for loading script "+d);jh(h);kh(h,!1,a)},p),f.Ga=m);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(uh(e,b.dd||!1,m),h.C())};e.onerror=function(){uh(e,!0,m);var a=new vh(xh,"Error while loading script "+
	d);jh(h);kh(h,!1,a)};f=b.attributes||{};bb(f,{type:"text/javascript",charset:"UTF-8"});Kd(e,f);e.src=ud(a);yh(c).appendChild(e);return h}function yh(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function th(){if(this&&this.Hb){var a=this.Hb;a&&"SCRIPT"==a.tagName&&uh(a,!0,this.Ga)}}
	function uh(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var xh=0,wh=1;function vh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(vh,u);function zh(a){this.f=a}t(zh,vg);zh.prototype.a=function(){return new this.f};zh.prototype.b=function(){return{}};
	function Ah(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||Bh;this.f=$a(a.secureTokenHeaders||Ch);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Dh;this.a=$a(a.firebaseHeaders||Eh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==ne();c=k.XMLHttpRequest||c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&
	!me())throw new K("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;me()?this.c=new Pg(self):oe()?this.c=new zh(c):this.c=new Ag}var Fh,L="idToken",Bh=new Ce(3E4,6E4),Ch={"Content-Type":"application/x-www-form-urlencoded"},Dh=new Ce(3E4,6E4),Eh={"Content-Type":"application/json"};function Gh(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
	function Hh(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function Ih(a,b,c,d,e,f,h){Zd()||me()?a=r(a.o,a):(Fh||(Fh=new y(function(a,b){Jh(a,b)})),a=r(a.l,a));a(b,c,d,e,f,h)}
	Ah.prototype.o=function(a,b,c,d,e,f){if(me()&&("undefined"===typeof k.fetch||"undefined"===typeof k.Headers||"undefined"===typeof k.Request))throw new K("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var h=new Tg(this.c);if(f){h.g=Math.max(0,f);var m=setTimeout(function(){h.dispatchEvent("timeout")},f)}uc(h,"complete",function(){m&&clearTimeout(m);var a=null;try{a=
	JSON.parse(gh(this))||null}catch(z){a=null}b&&b(a)});Ac(h,"ready",function(){m&&clearTimeout(m);Jb(this)});Ac(h,"timeout",function(){m&&clearTimeout(m);Jb(this);b&&b(null)});Xg(h,a,c,d,e)};var Kh=rd("https://apis.google.com/js/client.js?onload=%{onload}"),Lh="__fcb"+Math.floor(1E6*Math.random()).toString();
	function Jh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Lh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=vd(Kh,{onload:Lh});nh(sh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Ah.prototype.l=function(a,b,c,d,e){var f=this;Fh.then(function(){window.gapi.client.setApiKey(f.b);var h=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(h);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	function Mh(a,b){return new y(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Ih(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Nh(a)):a.access_token&&a.refresh_token?c(a):d(new K("internal-error")):d(new K("network-request-failed"))},"POST",id(b).toString(),a.f,a.m.get()):d(new K("internal-error"))})}
	function Oh(a,b,c,d,e,f){var h=ed(a.g+b);F(h,"key",a.b);f&&F(h,"cb",na().toString());var m="GET"==c;if(m)for(var p in d)d.hasOwnProperty(p)&&F(h,p,d[p]);return new y(function(b,f){Ih(a,h.toString(),function(a){a?a.error?f(Nh(a,e||{})):b(a):f(new K("network-request-failed"))},c,m?void 0:Pd(ye(d)),a.a,a.h.get())})}function Ph(a){if(!ug.test(a.email))throw new K("invalid-email");}function Qh(a){"email"in a&&Ph(a)}
	function Rh(a,b){return O(a,Sh,{identifier:b,continueUri:ve()?Wd():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Th(a,b){return O(a,Sh,{identifier:b,continueUri:ve()?Wd():"http://localhost"}).then(function(a){return a.signinMethods||[]})}function Uh(a){return O(a,Vh,{}).then(function(a){return a.authorizedDomains||[]})}function Wh(a){if(!a[L])throw new K("internal-error");}
	function Xh(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new K("internal-error");}else{if(!a.sessionInfo)throw new K("missing-verification-id");if(!a.code)throw new K("missing-verification-code");}}Ah.prototype.Pa=function(){return O(this,Yh,{})};Ah.prototype.mb=function(a,b){return O(this,Zh,{idToken:a,email:b})};Ah.prototype.nb=function(a,b){return O(this,bg,{idToken:a,password:b})};var $h={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};g=Ah.prototype;
	g.ob=function(a,b){var c={idToken:a},d=[];Ya($h,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return O(this,Zh,c)};g.hb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};bb(a,b);return O(this,ai,a)};g.ib=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};bb(a,b);return O(this,bi,a)};g.gb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};bb(a,b);return O(this,ci,a)};function jg(a,b){return O(a,di,b)}g.Ta=function(a){return O(this,ei,a)};
	function fi(a,b,c){return O(a,gi,{idToken:b,deleteProvider:c})}function hi(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new K("internal-error");}
	function ii(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=tg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=tg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=tg(a)):a.errorMessage&&(b=ji(a.errorMessage));if(b)throw b;if(!a[L])throw new K("internal-error");}function Lf(a,b){b.returnIdpCredential=!0;return O(a,ki,b)}function Nf(a,b){b.returnIdpCredential=!0;return O(a,li,b)}
	function Of(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return O(a,mi,b)}function ni(a){if(!a.oobCode)throw new K("invalid-action-code");}g.Xa=function(a,b){return O(this,oi,{oobCode:a,newPassword:b})};g.Ja=function(a){return O(this,pi,{oobCode:a})};g.Va=function(a){return O(this,qi,{oobCode:a})};
	var qi={endpoint:"setAccountInfo",B:ni,da:"email"},pi={endpoint:"resetPassword",B:ni,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new K("internal-error");}},ri={endpoint:"signupNewUser",B:function(a){Ph(a);if(!a.password)throw new K("weak-password");},J:Wh,R:!0},Sh={endpoint:"createAuthUri"},si={endpoint:"deleteAccount",T:["idToken"]},gi={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],B:function(a){if(!fa(a.deleteProvider))throw new K("internal-error");}},Zf=
	{endpoint:"emailLinkSignin",T:["email","oobCode"],B:Ph,J:Wh,R:!0},ag={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],B:Ph,J:Wh,R:!0},ti={endpoint:"getAccountInfo"},bi={endpoint:"getOobConfirmationCode",T:["requestType"],B:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new K("internal-error");Ph(a)},da:"email"},ci={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],B:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new K("internal-error");},da:"email"},ai={endpoint:"getOobConfirmationCode",
	T:["requestType"],B:function(a){if("PASSWORD_RESET"!=a.requestType)throw new K("internal-error");Ph(a)},da:"email"},Vh={rb:!0,endpoint:"getProjectConfig",Eb:"GET"},ui={rb:!0,endpoint:"getRecaptchaParam",Eb:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new K("internal-error");}},oi={endpoint:"resetPassword",B:ni,da:"email"},di={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},Zh={endpoint:"setAccountInfo",T:["idToken"],B:Qh,R:!0},bg={endpoint:"setAccountInfo",
	T:["idToken"],B:function(a){Qh(a);if(!a.password)throw new K("weak-password");},J:Wh,R:!0},Yh={endpoint:"signupNewUser",J:Wh,R:!0},ki={endpoint:"verifyAssertion",B:hi,J:ii,R:!0},mi={endpoint:"verifyAssertion",B:hi,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new K("user-not-found");if(a.errorMessage)throw ji(a.errorMessage);if(!a[L])throw new K("internal-error");},R:!0},li={endpoint:"verifyAssertion",B:function(a){hi(a);if(!a.idToken)throw new K("internal-error");},J:ii,
	R:!0},vi={endpoint:"verifyCustomToken",B:function(a){if(!a.token)throw new K("invalid-custom-token");},J:Wh,R:!0},$f={endpoint:"verifyPassword",B:function(a){Ph(a);if(!a.password)throw new K("wrong-password");},J:Wh,R:!0},ei={endpoint:"verifyPhoneNumber",B:Xh,J:Wh},gg={endpoint:"verifyPhoneNumber",B:function(a){if(!a.idToken)throw new K("internal-error");Xh(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",tg(a);Wh(a)}},hg={Tb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",
	B:Xh,J:Wh};function O(a,b,c){if(!Ne(c,b.T))return B(new K("internal-error"));var d=b.Eb||"POST",e;return A(c).then(b.B).then(function(){b.R&&(c.returnSecureToken=!0);return Oh(a,b.endpoint,d,c,b.Tb,b.rb||!1)}).then(function(a){return e=a}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new K("internal-error");return e[b.da]})}function ji(a){return Nh({error:{errors:[{message:a}],code:400,message:a}})}
	function Nh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new K(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
	INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
	INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
	UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};bb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new K(d[e],b);!b&&a&&(b=xe(a));return new K("internal-error",b)};var wi={Yc:{Za:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",fb:"https://securetoken.googleapis.com/v1/token",id:"p"},$c:{Za:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",fb:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},ad:{Za:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",fb:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
	function xi(a){for(var b in wi)if(wi[b].id===a)return a=wi[b],{firebaseEndpoint:a.Za,secureTokenEndpoint:a.fb};return null}var yi;yi=xi("__EID__")?"__EID__":void 0;function zi(a){this.b=a;this.a=null;this.bb=Ai(this)}
	function Ai(a){return Bi().then(function(){return new y(function(b,c){H("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ci.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Di(a,b){return a.bb.then(function(){return new y(function(c){a.a.send(b.type,b,c,H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Ei(a,b){a.bb.then(function(){a.a.register("authEvent",b,H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Fi=rd("https://apis.google.com/js/api.js?onload=%{onload}"),Gi=new Ce(3E4,6E4),Ci=new Ce(5E3,15E3),Hi=null;
	function Bi(){return Hi?Hi:Hi=(new y(function(a,b){function c(){Be();H("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Be();b(Error("Network Error"))},timeout:Gi.get()})}if(H("gapi.iframes.Iframe"))a();else if(H("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){H("gapi.load")?c():b(Error("Network Error"))};d=vd(Fi,{onload:d});A(sh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){Hi=null;throw a;})};function Ii(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=fd(this.i,"/__/auth/iframe");F(this.a,"apiKey",this.g);F(this.a,"appName",this.h);this.b=null;this.c=[]}Ii.prototype.toString=function(){this.f?F(this.a,"v",this.f):ld(this.a.a,"v");this.b?F(this.a,"eid",this.b):ld(this.a.a,"eid");this.c.length?F(this.a,"fw",this.c.join(",")):ld(this.a.a,"fw");return this.a.toString()};function Ji(a,b,c,d,e){this.o=a;this.l=b;this.c=c;this.m=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
	Ji.prototype.toString=function(){var a=fd(this.o,"/__/auth/handler");F(a,"apiKey",this.l);F(a,"appName",this.c);F(a,"authType",this.m);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ea()}catch(m){c=null}b.Ya=c;F(a,"providerId",this.a.providerId);b=this.a;c=ye(b.vb);for(var d in c)c[d]=c[d].toString();d=b.Ac;c=$a(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.$a&&b.Ya&&!c[b.$a]&&(c[b.$a]=b.Ya);Za(c)||F(a,"customParameters",xe(c))}"function"===typeof this.a.Ab&&
	(b=this.a.Ab(),b.length&&F(a,"scopes",b.join(",")));this.i?F(a,"redirectUrl",this.i):ld(a.a,"redirectUrl");this.g?F(a,"eventId",this.g):ld(a.a,"eventId");this.h?F(a,"v",this.h):ld(a.a,"v");if(this.b)for(var h in this.b)this.b.hasOwnProperty(h)&&!dd(a,h)&&F(a,h,this.b[h]);this.f?F(a,"eid",this.f):ld(a.a,"eid");h=Ki(this.c);h.length&&F(a,"fw",h.join(","));return a.toString()};function Ki(a){try{return firebase.app(a).auth().xa()}catch(b){return[]}}
	function Li(a,b,c,d,e){this.l=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.u=this.v=null;this.g=[];this.m=this.a=null}
	function Mi(a){var b=Wd();return Uh(a).then(function(a){a:{var c=ed(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var h=a[f];var m=c;var p=e;0==h.indexOf("chrome-extension://")?m=ed(h).b==m&&"chrome-extension"==p:"http"!=p&&"https"!=p?m=!1:ge.test(h)?m=m==h:(h=h.split(".").join("\\."),m=(new RegExp("^(.+\\."+h+"|"+h+")$","i")).test(m));if(m){a=!0;break a}}a=!1}if(!a)throw new rg(Wd());})}
	function Ni(a){if(a.m)return a.m;a.m=he().then(function(){if(!a.u){var b=a.c,c=a.h,d=Ki(a.b),e=new Ii(a.l,a.f,a.b);e.f=b;e.b=c;e.c=Ja(d||[]);a.u=e.toString()}a.i=new zi(a.u);Oi(a)});return a.m}g=Li.prototype;g.Ea=function(a,b,c){var d=new K("popup-closed-by-user"),e=new K("web-storage-unsupported"),f=this,h=!1;return this.ga().then(function(){Pi(f).then(function(c){c||(a&&ce(a),b(e),h=!0)})}).s(function(){}).then(function(){if(!h)return fe(a)}).then(function(){if(!h)return Hc(c).then(function(){b(d)})})};
	g.Ib=function(){var a=G();return!we(a)&&!Ae(a)};g.Db=function(){return!1};
	g.zb=function(a,b,c,d,e,f,h){if(!a)return B(new K("popup-blocked"));if(h&&!we())return this.ga().s(function(b){ce(a);e(b)}),d(),A();this.a||(this.a=Mi(Qi(this)));var m=this;return this.a.then(function(){var b=m.ga().s(function(b){ce(a);e(b);throw b;});d();return b}).then(function(){mg(c);if(!h){var d=Ri(m.l,m.f,m.b,b,c,null,f,m.c,void 0,m.h);Xd(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(m.a=null);throw a;})};
	function Qi(a){a.o||(a.v=a.c?re(a.c,Ki(a.b)):null,a.o=new Ah(a.f,xi(a.h),a.v));return a.o}g.Ca=function(a,b,c){this.a||(this.a=Mi(Qi(this)));var d=this;return this.a.then(function(){mg(b);var e=Ri(d.l,d.f,d.b,a,b,Wd(),c,d.c,void 0,d.h);Xd(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};g.ga=function(){var a=this;return Ni(this).then(function(){return a.i.bb}).s(function(){a.a=null;throw new K("network-request-failed");})};g.Mb=function(){return!0};
	function Ri(a,b,c,d,e,f,h,m,p,z){a=new Ji(a,b,c,d,e);a.i=f;a.g=h;a.h=m;a.b=$a(p||null);a.f=z;return a.toString()}function Oi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Ei(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=og(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
	function Pi(a){var b={type:"webStorageSupport"};return Ni(a).then(function(){return Di(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}g.va=function(a){this.g.push(a)};g.Ka=function(a){Ha(this.g,function(b){return b==a})};function Si(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new K("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}g=Si.prototype;g.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&ze(a)})};g.set=function(a,b){return A(this.a.setItem(a,xe(b)))};g.P=function(a){return A(this.a.removeItem(a))};g.Y=function(){};g.ca=function(){};function Ti(){if(!Ui())throw new K("web-storage-unsupported");this.f={};this.a=[];this.b=0;this.g=k.indexedDB;this.type="indexedDB"}var Vi;function Wi(a){return new y(function(b,c){var d=a.g.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(a){c(Error(a.target.error))}})}
	function Xi(a){return new y(function(b,c){var d=a.g.open("firebaseLocalStorageDb",1);d.onerror=function(a){try{a.preventDefault()}catch(f){}c(Error(a.target.error))};d.onupgradeneeded=function(a){a=a.target.result;try{a.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(d){d=d.target.result;d.objectStoreNames.contains("firebaseLocalStorage")?b(d):Wi(a).then(function(){return Xi(a)}).then(function(a){b(a)}).s(function(a){c(a)})}})}
	function Yi(a){a.h||(a.h=Xi(a));return a.h}function Ui(){try{return!!k.indexedDB}catch(a){return!1}}function Zi(a){return a.objectStore("firebaseLocalStorage")}function $i(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function aj(a){return new y(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}g=Ti.prototype;
	g.set=function(a,b){var c=!1,d,e=this;return Yi(this).then(function(b){d=b;b=Zi($i(d,!0));return aj(b.get(a))}).then(function(f){var h=Zi($i(d,!0));if(f)return f.value=b,aj(h.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return aj(h.add(f))}).then(function(){e.f[a]=b}).ia(function(){c&&e.b--})};g.get=function(a){return Yi(this).then(function(b){return aj(Zi($i(b,!1)).get(a))}).then(function(a){return a&&a.value})};
	g.P=function(a){var b=!1,c=this;return Yi(this).then(function(d){b=!0;c.b++;return aj(Zi($i(d,!0))["delete"](a))}).then(function(){delete c.f[a]}).ia(function(){b&&c.b--})};
	g.Kc=function(){var a=this;return Yi(this).then(function(a){var b=Zi($i(a,!1));return b.getAll?aj(b.getAll()):new y(function(a,c){var d=[],e=b.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){c(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=Yd(a.f,c);a.f=c}return d})};g.Y=function(a){0==this.a.length&&bj(this);this.a.push(a)};
	g.ca=function(a){Ha(this.a,function(b){return b==a});0==this.a.length&&this.c&&this.c.cancel("STOP_EVENT")};function bj(a){function b(){a.c=Hc(800).then(r(a.Kc,a)).then(function(b){0<b.length&&v(a.a,function(a){a(b)})}).then(b).s(function(a){"STOP_EVENT"!=a.message&&b()});return a.c}a.c&&a.c.cancel("STOP_EVENT");b()};function cj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=A().then(function(){return Ui()?(Vi||(Vi=new Ti),c=Vi,c.set("__sak","!").then(function(){return c.get("__sak")}).then(function(a){if("!"!==a)throw Error("indexedDB not supported!");return c.P("__sak")}).then(function(){return c}).s(function(){return b.c})):b.c}).then(function(a){b.type=a.type;a.Y(function(a){v(b.a,function(b){b(a)})});return a})}g=cj.prototype;g.get=function(a){return this.b.then(function(b){return b.get(a)})};
	g.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};g.P=function(a){return this.b.then(function(b){return b.P(a)})};g.Y=function(a){this.a.push(a)};g.ca=function(a){Ha(this.a,function(b){return b==a})};function dj(){this.a={};this.type="inMemory"}g=dj.prototype;g.get=function(a){return A(this.a[a])};g.set=function(a,b){this.a[a]=b;return A()};g.P=function(a){delete this.a[a];return A()};g.Y=function(){};g.ca=function(){};function ej(){if(!fj()){if("Node"==ne())throw new K("internal-error","The LocalStorage compatibility library was not found.");throw new K("web-storage-unsupported");}this.a=gj()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function gj(){try{var a=k.localStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function fj(){var a="Node"==ne();a=gj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=ej.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
	g.Y=function(a){k.window&&rc(k.window,"storage",a)};g.ca=function(a){k.window&&D(k.window,"storage",a)};function hj(){this.type="nullStorage"}g=hj.prototype;g.get=function(){return A(null)};g.set=function(){return A()};g.P=function(){return A()};g.Y=function(){};g.ca=function(){};function ij(){if(!jj()){if("Node"==ne())throw new K("internal-error","The SessionStorage compatibility library was not found.");throw new K("web-storage-unsupported");}this.a=kj()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function kj(){try{var a=k.sessionStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function jj(){var a="Node"==ne();a=kj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=ij.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};g.Y=function(){};
	g.ca=function(){};function lj(){var a={};a.Browser=mj;a.Node=nj;a.ReactNative=oj;a.Worker=pj;this.a=a[ne()]}var qj,mj={A:ej,Qa:ij},nj={A:ej,Qa:ij},oj={A:Si,Qa:hj},pj={A:ej,Qa:hj};var rj={Xc:"local",NONE:"none",Zc:"session"};function sj(a){var b=new K("invalid-persistence-type"),c=new K("unsupported-persistence-type");a:{for(d in rj)if(rj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(ne()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!se()&&"none"!==a)throw c;}}
	function tj(){var a=!Ae(G())&&le()?!0:!1,b=we(),c=se();this.o=a;this.h=b;this.m=c;this.a={};qj||(qj=new lj);a=qj;try{this.g=!Vd()&&Ge()||!k.indexedDB?new a.a.A:new cj(me()?new dj:new a.a.A)}catch(d){this.g=new dj,this.h=!0}try{this.i=new a.a.Qa}catch(d){this.i=new dj}this.l=new dj;this.f=r(this.Lb,this);this.b={}}var uj;function vj(){uj||(uj=new tj);return uj}function wj(a,b){switch(b){case "session":return a.i;case "none":return a.l;default:return a.g}}
	function xj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function yj(a,b,c){var d=xj(b,c),e=wj(a,b.A);return a.get(b,c).then(function(f){var h=null;try{h=ze(k.localStorage.getItem(d))}catch(m){}if(h&&!f)return k.localStorage.removeItem(d),a.set(b,h,c);h&&f&&"localStorage"!=e.type&&k.localStorage.removeItem(d)})}g=tj.prototype;g.get=function(a,b){return wj(this,a.A).get(xj(a,b))};function zj(a,b,c){c=xj(b,c);"local"==b.A&&(a.b[c]=null);return wj(a,b.A).P(c)}
	g.set=function(a,b,c){var d=xj(a,c),e=this,f=wj(this,a.A);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.A&&(e.b[d]=b)})};g.addListener=function(a,b,c){a=xj(a,b);this.m&&(this.b[a]=k.localStorage.getItem(a));Za(this.a)&&(wj(this,"local").Y(this.f),this.h||(Vd()||!Ge())&&k.indexedDB||!this.m||Aj(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
	g.removeListener=function(a,b,c){a=xj(a,b);this.a[a]&&(Ha(this.a[a],function(a){return a==c}),0==this.a[a].length&&delete this.a[a]);Za(this.a)&&(wj(this,"local").ca(this.f),Bj(this))};function Aj(a){Bj(a);a.c=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new ec({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Lb(c))}},1E3)}function Bj(a){a.c&&(clearInterval(a.c),a.c=null)}
	g.Lb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Wa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?wj(this,"local").ca(this.f):Bj(this);if(this.o)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
	typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.Wa(b)};Ob&&Zb&&10==Zb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else v(a,r(this.Wa,this))};g.Wa=function(a){this.a[a]&&v(this.a[a],function(a){a()})};function Cj(a){this.a=a;this.b=vj()}var Dj={name:"authEvent",A:"local"};function Ej(a){return a.b.get(Dj,a.a).then(function(a){return og(a)})};function Fj(){this.a=vj()};function Gj(){this.b=-1};function Hj(a,b){this.b=-1;this.b=Ij;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.m=k.Int32Array?new Int32Array(64):Array(64);void 0!==Jj||(k.Int32Array?Jj=new Int32Array(Kj):Jj=Kj);this.reset()}var Jj;t(Hj,Gj);for(var Ij=64,Lj=Ij-1,Mj=[],Nj=0;Nj<Lj;Nj++)Mj[Nj]=0;var Oj=Ia(128,Mj);Hj.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):Ja(this.h)};
	function Pj(a){for(var b=a.f,c=a.m,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,h=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+h|0}d=a.a[0]|0;e=a.a[1]|0;var m=a.a[2]|0,p=a.a[3]|0,z=a.a[4]|0,pc=a.a[5]|0,Pc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Rl=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&m^e&m)|0;h=z&pc^~z&Pc;f=f+((z>>>6|z<<26)^(z>>>11|z<<21)^(z>>>
	25|z<<7))|0;h=h+(Jj[b]|0)|0;h=f+(h+(c[b]|0)|0)|0;f=Pc;Pc=pc;pc=z;z=p+h|0;p=m;m=e;e=d;d=h+Rl|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+m|0;a.a[3]=a.a[3]+p|0;a.a[4]=a.a[4]+z|0;a.a[5]=a.a[5]+pc|0;a.a[6]=a.a[6]+Pc|0;a.a[7]=a.a[7]+f|0}
	function Qj(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(l(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(Pj(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(Pj(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var Kj=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Rj(){Hj.call(this,8,Sj)}t(Rj,Hj);var Sj=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Tj(a,b,c,d,e){this.l=a;this.i=b;this.m=c;this.o=d||null;this.u=e||null;this.h=b+":"+c;this.v=new Fj;this.g=new Cj(this.h);this.f=null;this.b=[];this.a=this.c=null}function Uj(a){return new K("invalid-cordova-configuration",a)}g=Tj.prototype;
	g.ga=function(){return this.za?this.za:this.za=ie().then(function(){if("function"!==typeof H("universalLinks.subscribe",k))throw Uj("cordova-universal-links-plugin is not installed");if("undefined"===typeof H("BuildInfo.packageName",k))throw Uj("cordova-plugin-buildinfo is not installed");if("function"!==typeof H("cordova.plugins.browsertab.openUrl",k))throw Uj("cordova-plugin-browsertab is not installed");if("function"!==typeof H("cordova.InAppBrowser.open",k))throw Uj("cordova-plugin-inappbrowser is not installed");
	},function(){throw new K("cordova-not-ready");})};function Vj(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Wj(a){var b=new Rj;Qj(b,a);a=[];var c=8*b.g;56>b.c?Qj(b,Oj,56-b.c):Qj(b,Oj,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;Pj(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return lf(a)}
	g.Ea=function(a,b){b(new K("operation-not-supported-in-this-environment"));return A()};g.zb=function(){return B(new K("operation-not-supported-in-this-environment"))};g.Mb=function(){return!1};g.Ib=function(){return!0};g.Db=function(){return!0};
	g.Ca=function(a,b,c){if(this.c)return B(new K("redirect-operation-pending"));var d=this,e=k.document,f=null,h=null,m=null,p=null;return this.c=A().then(function(){mg(b);return Xj(d)}).then(function(){return Yj(d,a,b,c)}).then(function(){return(new y(function(a,b){h=function(){var b=H("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.va(h);m=function(){f||(f=Hc(2E3).then(function(){b(new K("redirect-cancelled-by-user"))}))};
	p=function(){De()&&m()};e.addEventListener("resume",m,!1);G().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",p,!1)})).s(function(a){return Zj(d).then(function(){throw a;})})}).ia(function(){m&&e.removeEventListener("resume",m,!1);p&&e.removeEventListener("visibilitychange",p,!1);f&&f.cancel();h&&d.Ka(h);d.c=null})};
	function Yj(a,b,c,d){var e=Vj(),f=new ng(b,d,null,e,new K("no-auth-event")),h=H("BuildInfo.packageName",k);if("string"!==typeof h)throw new K("invalid-cordova-configuration");var m=H("BuildInfo.displayName",k),p={};if(G().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(G().toLowerCase().match(/android/))p.apn=h;else return B(new K("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);e=Wj(e);p.sessionId=e;var z=Ri(a.l,a.i,a.m,b,c,null,d,a.o,p,a.u);return a.ga().then(function(){var b=
	a.h;return a.v.a.set(Dj,f.D(),b)}).then(function(){var b=H("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new K("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=H("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new K("invalid-cordova-configuration");c(z)}else{c=H("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new K("invalid-cordova-configuration");b=G();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.a=c(z,b?"_blank":"_system","location=yes")}})})}function ak(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Xj(a){a.f||(a.f=a.ga().then(function(){return new y(function(b){function c(d){b(d);a.Ka(c);return!1}a.va(c);bk(a)})}));return a.f}function Zj(a){var b=null;return Ej(a.g).then(function(c){b=c;c=a.g;return zj(c.b,Dj,c.a)}).then(function(){return b})}
	function bk(a){function b(b){d=!0;e&&e.cancel();Zj(a).then(function(d){var e=c;if(d&&b&&b.url){var f=null;e=If(b.url);-1!=e.indexOf("/__/auth/callback")&&(f=ed(e),f=ze(dd(f,"firebaseError")||null),f=(f="object"===typeof f?$e(f):null)?new ng(d.b,d.c,null,null,f):new ng(d.b,d.c,e,d.g));e=f||c}ak(a,e)})}var c=new ng("unknown",null,null,null,new K("no-auth-event")),d=!1,e=Hc(500).then(function(){return Zj(a).then(function(){d||ak(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(H("BuildInfo.packageName",
	k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(m){console.error(m)}};qg||(qg=new pg);qg.subscribe(b)}g.va=function(a){this.b.push(a);Xj(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new ng("unknown",null,null,null,new K("no-auth-event")),a(b))})};g.Ka=function(a){Ha(this.b,function(b){return b==a})};function ck(a){this.a=a;this.b=vj()}var dk={name:"pendingRedirect",A:"session"};function ek(a){return a.b.set(dk,"pending",a.a)}function fk(a){return zj(a.b,dk,a.a)}function gk(a){return a.b.get(dk,a.a).then(function(a){return"pending"==a})};function hk(a,b,c){this.v=a;this.m=b;this.l=c;this.h=[];this.f=!1;this.i=r(this.o,this);this.c=new ik;this.u=new jk;this.g=new ck(this.m+":"+this.l);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.u;this.b.linkViaPopup=this.u;this.b.reauthViaPopup=this.u;this.a=kk(this.v,this.m,this.l,yi)}function kk(a,b,c,d){var e=firebase.SDK_VERSION||null;return je()?new Tj(a,b,c,e,d):new Li(a,b,c,e,d)}
	hk.prototype.reset=function(){this.f=!1;this.a.Ka(this.i);this.a=kk(this.v,this.m,this.l)};function lk(a){a.f||(a.f=!0,a.a.va(a.i));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}function mk(a){a.a.Ib()&&lk(a).s(function(b){var c=new ng("unknown",null,null,null,new K("operation-not-supported-in-this-environment"));nk(b)&&a.o(c)});a.a.Db()||ok(a.c)}
	hk.prototype.subscribe=function(a){Fa(this.h,a)||this.h.push(a);if(!this.f){var b=this;gk(this.g).then(function(a){a?fk(b.g).then(function(){lk(b).s(function(a){var c=new ng("unknown",null,null,null,new K("operation-not-supported-in-this-environment"));nk(a)&&b.o(c)})}):mk(b)}).s(function(){mk(b)})}};hk.prototype.unsubscribe=function(a){Ha(this.h,function(b){return b==a})};
	hk.prototype.o=function(a){if(!a)throw new K("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.sb(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}ok(this.c);return b};var pk=new Ce(2E3,1E4),qk=new Ce(3E4,6E4);hk.prototype.fa=function(){return this.c.fa()};function rk(a,b,c,d,e,f){return a.a.zb(b,c,d,function(){a.f||(a.f=!0,a.a.va(a.i))},function(){a.reset()},e,f)}function nk(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	hk.prototype.Ca=function(a,b,c){var d=this,e;return ek(this.g).then(function(){return d.a.Ca(a,b,c).s(function(a){if(nk(a))throw new K("operation-not-supported-in-this-environment");e=a;return fk(d.g).then(function(){throw e;})}).then(function(){return d.a.Mb()?new y(function(){}):fk(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};hk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(c){a.ha(b,null,c,d)},pk.get())};var sk={};
	function tk(a,b,c){var d=b+":"+c;sk[d]||(sk[d]=new hk(a,b,c));return sk[d]}function ik(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}ik.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	ik.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(uk(this,!0,null,a.a),A()):b.wa(c,d)?vk(this,a,b):B(new K("invalid-auth-event")):(uk(this,!1,null,null),A())}else B(new K("invalid-auth-event"))};function ok(a){a.g||(a.g=!0,uk(a,!1,null,null))}
	function vk(a,b,c){c=c.wa(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);c(d,e).then(function(b){uk(a,f,b,null)}).s(function(b){uk(a,f,null,b)})}function wk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function xk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function uk(a,b,c,d){b?d?wk(a,d):xk(a,c):xk(a,{user:null});a.f=[];a.c=[]}
	ik.prototype.fa=function(){var a=this;return new y(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),yk(a))})};function yk(a){var b=new K("timeout");a.a&&a.a.cancel();a.a=Hc(qk.get()).then(function(){a.b||uk(a,!0,null,b)})}function jk(){}jk.prototype.h=function(a,b){if(a){var c=a.b,d=a.c;a.a?(b.ha(a.b,null,a.a,a.c),A()):b.wa(c,d)?zk(a,b):B(new K("invalid-auth-event"))}else B(new K("invalid-auth-event"))};
	function zk(a,b){var c=a.c,d=a.b;b.wa(d,c)(a.f,a.g).then(function(a){b.ha(d,a,null,c)}).s(function(a){b.ha(d,null,a,c)})};function Ak(){this.pb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.pb},set:function(a){this.pb=a},enumerable:!1})};function Bk(a,b){this.a=b;I(this,"verificationId",a)}Bk.prototype.confirm=function(a){a=kg(this.verificationId,a);return this.a(a)};function Ck(a,b,c,d){return(new ig(a)).Ta(b,c).then(function(a){return new Bk(a,d)})};function Dk(a){var b=tf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new K("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");J(this,{token:a,expirationTime:Fe(1E3*b.exp),authTime:Fe(1E3*b.auth_time),issuedAtTime:Fe(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Ek(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Ek.prototype.start=function(){this.a=this.c;Fk(this,!0)};function Gk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Fk(a,b){a.stop();a.b=Hc(Gk(a,b)).then(function(){return Ee()}).then(function(){return a.h()}).then(function(){Fk(a,!0)}).s(function(b){a.i(b)&&Fk(a,!1)})}
	Ek.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Hk(a){this.f=a;this.b=this.a=null;this.c=0}Hk.prototype.D=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Ik(a,b){var c=b[L],d=b.refreshToken;b=Jk(b.expiresIn);a.b=c;a.c=b;a.a=d}function Kk(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function Jk(a){return na()+1E3*parseInt(a,10)}
	function Lk(a,b){return Mh(a.f,b).then(function(b){a.b=b.access_token;a.c=Jk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}Hk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new K("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?Lk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function Mk(a,b){this.a=a||null;this.b=b||null;J(this,{lastSignInTime:Fe(b||null),creationTime:Fe(a||null)})}function Nk(a){return new Mk(a.a,a.b)}Mk.prototype.D=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Ok(a,b,c,d,e,f){J(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Pk(a,b){C.call(this,a);for(var c in b)this[c]=b[c]}t(Pk,C);
	function Q(a,b,c){this.G=[];this.l=a.apiKey;this.o=a.appName;this.u=a.authDomain||null;a=firebase.SDK_VERSION?re(firebase.SDK_VERSION):null;this.b=new Ah(this.l,xi(yi),a);this.h=new Hk(this.b);Qk(this,b[L]);Ik(this.h,b);I(this,"refreshToken",this.h.a);Rk(this,c||{});E.call(this);this.I=!1;this.u&&ue()&&(this.a=tk(this.u,this.l,this.o));this.N=[];this.i=null;this.w=Sk(this);this.V=r(this.Ha,this);var d=this;this.ka=null;this.sa=function(a){d.oa(a.g)};this.X=null;this.O=[];this.ra=function(a){Tk(d,
	a.c)};this.W=null}t(Q,E);Q.prototype.oa=function(a){this.ka=a;Gh(this.b,a)};Q.prototype.ea=function(){return this.ka};function Uk(a,b){a.X&&D(a.X,"languageCodeChanged",a.sa);(a.X=b)&&rc(b,"languageCodeChanged",a.sa)}function Tk(a,b){a.O=b;Hh(a.b,firebase.SDK_VERSION?re(firebase.SDK_VERSION,a.O):null)}Q.prototype.xa=function(){return Ja(this.O)};function Vk(a,b){a.W&&D(a.W,"frameworkChanged",a.ra);(a.W=b)&&rc(b,"frameworkChanged",a.ra)}Q.prototype.Ha=function(){this.w.b&&(this.w.stop(),this.w.start())};
	function Wk(a){try{return firebase.app(a.o).auth()}catch(b){throw new K("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Sk(a){return new Ek(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0})}function Xk(a){a.C||a.w.b||(a.w.start(),D(a,"tokenChanged",a.V),rc(a,"tokenChanged",a.V))}function Yk(a){D(a,"tokenChanged",a.V);a.w.stop()}
	function Qk(a,b){a.qa=b;I(a,"_lat",b)}function Zk(a,b){Ha(a.N,function(a){return a==b})}function $k(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return vb(b).then(function(){return a})}function al(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
	function Rk(a,b){J(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new Mk(b.createdAt,b.lastLoginAt),providerData:[]})}I(Q.prototype,"providerId","firebase");function bl(){}function cl(a){return A().then(function(){if(a.C)throw new K("app-deleted");})}function dl(a){return Ba(a.providerData,function(a){return a.providerId})}
	function el(a,b){b&&(fl(a,b.providerId),a.providerData.push(b))}function fl(a,b){Ha(a.providerData,function(a){return a.providerId==b})}function gl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&I(a,b,c)}
	function hl(a,b){a!=b&&(J(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?I(a,"metadata",Nk(b.metadata)):I(a,"metadata",new Mk),v(b.providerData,function(b){el(a,b)}),Kk(a.h,b.h),I(a,"refreshToken",a.h.a))}g=Q.prototype;g.reload=function(){var a=this;return R(this,cl(this).then(function(){return il(a).then(function(){return $k(a)}).then(bl)}))};
	function il(a){return a.F().then(function(b){var c=a.isAnonymous;return jl(a,b).then(function(){c||gl(a,"isAnonymous",!1);return b})})}g.ac=function(a){return this.F(a).then(function(a){return new Dk(a)})};g.F=function(a){var b=this;return R(this,cl(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new K("internal-error");a.accessToken!=b.qa&&(Qk(b,a.accessToken),b.dispatchEvent(new Pk("tokenChanged")));gl(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	function kl(a,b){b[L]&&a.qa!=b[L]&&(Ik(a.h,b),a.dispatchEvent(new Pk("tokenChanged")),Qk(a,b[L]),gl(a,"refreshToken",a.h.a))}function jl(a,b){return O(a.b,ti,{idToken:b}).then(r(a.uc,a))}
	g.uc=function(a){a=a.users;if(!a||!a.length)throw new K("internal-error");a=a[0];Rk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=ll(a),c=0;c<b.length;c++)el(this,b[c]);gl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	function ll(a){return(a=a.providerUserInfo)&&a.length?Ba(a,function(a){return new Ok(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}g.cb=function(a){var b=this,c=null;return R(this,a.f(this.b,this.uid).then(function(a){kl(b,a);c=ml(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};
	g.vc=function(a){Ie("firebase.User.prototype.reauthenticateWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential instead.");return this.cb(a).then(function(){})};function nl(a,b){return il(a).then(function(){if(Fa(dl(a),b))return $k(a).then(function(){throw new K("provider-already-linked");})})}
	g.ab=function(a){var b=this,c=null;return R(this,nl(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.c(b.b,c)}).then(function(a){c=ml(b,a,"link");return ol(b,a)}).then(function(){return c}))};g.mc=function(a){Ie("firebase.User.prototype.linkWithCredential is deprecated. Please use firebase.User.prototype.linkAndRetrieveDataWithCredential instead.");return this.ab(a).then(function(a){return a.user})};
	g.nc=function(a,b){var c=this;return R(this,nl(this,"phone").then(function(){return Ck(Wk(c),a,b,r(c.ab,c))}))};g.wc=function(a,b){var c=this;return R(this,A().then(function(){return Ck(Wk(c),a,b,r(c.cb,c))}),!0)};function ml(a,b,c){var d=lg(b);b=yf(b);return Le({user:a,credential:d,additionalUserInfo:b,operationType:c})}function ol(a,b){kl(a,b);return a.reload().then(function(){return a})}
	g.mb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.mb(c,a)}).then(function(a){kl(b,a);return b.reload()}))};g.Pc=function(a){var b=this;return R(this,this.F().then(function(c){return a.c(b.b,c)}).then(function(a){kl(b,a);return b.reload()}))};g.nb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.nb(c,a)}).then(function(a){kl(b,a);return b.reload()}))};
	g.ob=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return cl(this);var b=this;return R(this,this.F().then(function(c){return b.b.ob(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){kl(b,a);gl(b,"displayName",a.displayName||null);gl(b,"photoURL",a.photoUrl||null);v(b.providerData,function(a){"password"===a.providerId&&(I(a,"displayName",b.displayName),I(a,"photoURL",b.photoURL))});return $k(b)}).then(bl))};
	g.Nc=function(a){var b=this;return R(this,il(this).then(function(c){return Fa(dl(b),a)?fi(b.b,c,[a]).then(function(a){var c={};v(a.providerUserInfo||[],function(a){c[a.providerId]=!0});v(dl(b),function(a){c[a]||fl(b,a)});c[ig.PROVIDER_ID]||I(b,"phoneNumber",null);return $k(b)}):$k(b).then(function(){throw new K("no-such-provider");})}))};
	g.delete=function(){var a=this;return R(this,this.F().then(function(b){return O(a.b,si,{idToken:b})}).then(function(){a.dispatchEvent(new Pk("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");Uk(a,null);Vk(a,null);a.G=[];a.C=!0;Yk(a);I(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
	g.sb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};g.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
	g.wa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.xb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.yb,this):"linkViaRedirect"==a&&(this.aa||null)==b?r(this.xb,this):"reauthViaRedirect"==a&&(this.aa||null)==b?r(this.yb,this):null};g.oc=function(a){var b=this;return pl(this,"linkViaPopup",a,function(){return nl(b,a.providerId).then(function(){return $k(b)})},!1)};g.xc=function(a){return pl(this,"reauthViaPopup",a,function(){return A()},!0)};
	function pl(a,b,c,d,e){if(!ue())return B(new K("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=xf(c.providerId),h=te(a.uid+":::"),m=null;(!we()||le())&&a.u&&c.isOAuthProvider&&(m=Ri(a.u,a.l,a.o,b,c,null,h,firebase.SDK_VERSION||null));var p=de(m,f&&f.Ba,f&&f.Aa);d=d().then(function(){ql(a);if(!e)return a.F().then(function(){})}).then(function(){return rk(a.a,p,b,c,h,!!m)}).then(function(){return new y(function(c,d){a.ha(b,null,new K("cancelled-popup-request"),a.g||null);
	a.f=c;a.v=d;a.g=h;a.c=a.a.Ea(a,b,p,h)})}).then(function(a){p&&ce(p);return a?Le(a):null}).s(function(a){p&&ce(p);throw a;});return R(a,d,e)}g.pc=function(a){var b=this;return rl(this,"linkViaRedirect",a,function(){return nl(b,a.providerId)},!1)};g.yc=function(a){return rl(this,"reauthViaRedirect",a,function(){return A()},!0)};
	function rl(a,b,c,d,e){if(!ue())return B(new K("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=null,h=te(a.uid+":::");d=d().then(function(){ql(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=h;return $k(a)}).then(function(b){a.ba&&(b=a.ba,b=b.b.set(sl,a.D(),b.a));return b}).then(function(){return a.a.Ca(b,c,h)}).s(function(b){f=b;if(a.ba)return tl(a.ba);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function ql(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new K("internal-error");throw new K("auth-domain-config-required");}}g.xb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=this.F().then(function(d){return Nf(c.b,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=ml(c,a,"link");return ol(c,a)}).then(function(){return d});return R(this,e)};
	g.yb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=A().then(function(){return Jf(Of(c.b,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=ml(c,a,"reauthenticate");kl(c,a);c.i=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};g.gb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Za(a)?{}:kf(new af(a))}).then(function(a){return b.b.gb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
	function R(a,b,c){var d=ul(a,b,c);a.G.push(d);d.ia(function(){Ga(a.G,d)});return d}function ul(a,b,c){return a.i&&!c?(b.cancel(),B(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||a.dispatchEvent(new Pk("userInvalidated")),a.i=b);throw b;})}g.toJSON=function(){return this.D()};
	g.D=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.l,appName:this.o,authDomain:this.u,stsTokenManager:this.h.D(),redirectEventId:this.aa||null};this.metadata&&bb(a,this.metadata.D());v(this.providerData,function(b){a.providerData.push(Me(b))});return a};
	function vl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[L]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&v(a.providerData,function(a){a&&el(d,Le(a))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
	function wl(a,b,c,d){var e=new Q(a,b);c&&(e.ba=c);d&&Tk(e,d);return e.reload().then(function(){return e})}function xl(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.u,appName:a.o};var e=a.h,f={};f[L]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-na())/1E3;b=new Q(b,f);c&&(b.ba=c);d&&Tk(b,d);hl(b,a);return b};function yl(a){this.a=a;this.b=vj()}var sl={name:"redirectUser",A:"session"};function tl(a){return zj(a.b,sl,a.a)}function zl(a,b){return a.b.get(sl,a.a).then(function(a){a&&b&&(a.authDomain=b);return vl(a||{})})};function Al(a){this.a=a;this.b=vj();this.c=null;this.f=Bl(this);this.b.addListener(Cl("local"),this.a,r(this.g,this))}Al.prototype.g=function(){var a=this,b=Cl("local");Dl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.A?a.b.get(b,a.a):null}).then(function(c){if(c)return El(a,"local").then(function(){a.c=b})})})};function El(a,b){var c=[],d;for(d in rj)rj[d]!==b&&c.push(zj(a.b,Cl(rj[d]),a.a));c.push(zj(a.b,Fl,a.a));return ub(c)}
	function Bl(a){var b=Cl("local"),c=Cl("session"),d=Cl("none");return yj(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(Fl,a.a).then(function(a){return a?Cl(a):b})})})}).then(function(b){a.c=b;return El(a,b.A)}).s(function(){a.c||(a.c=b)})}var Fl={name:"persistence",A:"session"};function Cl(a){return{name:"authUser",A:a}}
	Al.prototype.jb=function(a){var b=null,c=this;sj(a);return Dl(this,function(){return a!=c.c.A?c.b.get(c.c,c.a).then(function(d){b=d;return El(c,a)}).then(function(){c.c=Cl(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function Gl(a){return Dl(a,function(){return a.b.set(Fl,a.c.A,a.a)})}function Hl(a,b){return Dl(a,function(){return a.b.set(a.c,b.D(),a.a)})}function Il(a){return Dl(a,function(){return zj(a.b,a.c,a.a)})}
	function Jl(a,b){return Dl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return vl(a||{})})})}function Dl(a,b){a.f=a.f.then(b,b);return a.f};function Kl(a){this.l=!1;I(this,"settings",new Ak);I(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?re(firebase.SDK_VERSION):null,this.b=new Ah(S(this).options&&S(this).options.apiKey,xi(yi),a);else throw new K("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Pb=firebase.INTERNAL.createSubscribe(r(this.ic,this));this.O=void 0;this.Qb=firebase.INTERNAL.createSubscribe(r(this.jc,this));Ll(this,null);this.h=new Al(S(this).options.apiKey+":"+S(this).name);this.w=
	new yl(S(this).options.apiKey+":"+S(this).name);this.V=T(this,Ml(this));this.i=T(this,Nl(this));this.X=!1;this.ka=r(this.Jc,this);this.Ha=r(this.Z,this);this.qa=r(this.Yb,this);this.ra=r(this.gc,this);this.sa=r(this.hc,this);Ol(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.qc,this);this.u=0;E.call(this);Pl(this);this.G=[]}t(Kl,E);function Ql(a){C.call(this,"languageCodeChanged");this.g=a}t(Ql,C);
	function Sl(a){C.call(this,"frameworkChanged");this.c=a}t(Sl,C);g=Kl.prototype;g.jb=function(a){a=this.h.jb(a);return T(this,a)};g.oa=function(a){this.W===a||this.l||(this.W=a,Gh(this.b,this.W),this.dispatchEvent(new Ql(this.ea())))};g.ea=function(){return this.W};g.Qc=function(){var a=k.navigator;this.oa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};g.qc=function(a){this.G.push(a);Hh(this.b,firebase.SDK_VERSION?re(firebase.SDK_VERSION,this.G):null);this.dispatchEvent(new Sl(this.G))};
	g.xa=function(){return Ja(this.G)};function Pl(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(a){this.oa(a)},enumerable:!1});a.W=null}g.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).D()}};function Tl(a){return a.Ob||B(new K("auth-domain-config-required"))}
	function Ol(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&ue()&&(a.Ob=a.V.then(function(){if(!a.l){a.a=tk(b,c,S(a).name);a.a.subscribe(a);U(a)&&al(U(a));if(a.C){al(a.C);var d=a.C;d.oa(a.ea());Uk(d,a);d=a.C;Tk(d,a.G);Vk(d,a);a.C=null}return a.a}}))}g.sb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
	g.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};g.wa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Xb,this):null};
	g.Xb=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.c&&(this.c.cancel(),this.c=null);var d=null,e=null,f=Lf(c.b,a).then(function(a){d=lg(a);e=yf(a);return a});a=c.V.then(function(){return f}).then(function(a){return Ul(c,a)}).then(function(){return Le({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
	g.Hc=function(a){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var b=this,c=xf(a.providerId),d=te(),e=null;(!we()||le())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Ri(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=de(e,c&&c.Ba,c&&c.Aa);c=Tl(this).then(function(b){return rk(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new y(function(a,c){b.ha("signInViaPopup",null,new K("cancelled-popup-request"),
	b.g);b.f=a;b.v=c;b.g=d;b.c=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(a){f&&ce(f);return a?Le(a):null}).s(function(a){f&&ce(f);throw a;});return T(this,c)};g.Ic=function(a){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var b=this,c=Tl(this).then(function(){return Gl(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return T(this,c)};
	g.fa=function(){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var a=this,b=Tl(this).then(function(){return a.a.fa()}).then(function(a){return a?Le(a):null});return T(this,b)};
	g.Oc=function(a){if(!a)return B(new K("null-user"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=xl(a,c,b.w,b.xa());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return hl(U(b),a),b.Z(a);Ll(b,d);al(d);return b.Z(d)}).then(function(){Vl(b)}))};
	function Ul(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return wl(c,b,a.w,a.xa())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return hl(U(a),b),a.Z(b);Ll(a,b);al(b);return a.Z(b)}).then(function(){Vl(a)})}
	function Ll(a,b){U(a)&&(Zk(U(a),a.Ha),D(U(a),"tokenChanged",a.qa),D(U(a),"userDeleted",a.ra),D(U(a),"userInvalidated",a.sa),Yk(U(a)));b&&(b.N.push(a.Ha),rc(b,"tokenChanged",a.qa),rc(b,"userDeleted",a.ra),rc(b,"userInvalidated",a.sa),0<a.u&&Xk(b));I(a,"currentUser",b);b&&(b.oa(a.ea()),Uk(b,a),Tk(b,a.G),Vk(b,a))}g.kb=function(){var a=this,b=this.i.then(function(){if(!U(a))return A();Ll(a,null);return Il(a.h).then(function(){Vl(a)})});return T(this,b)};
	function Wl(a){var b=zl(a.w,S(a).options.authDomain).then(function(b){if(a.C=b)b.ba=a.w;return tl(a.w)});return T(a,b)}function Ml(a){var b=S(a).options.authDomain,c=Wl(a).then(function(){return Jl(a.h,b)}).then(function(b){return b?(b.ba=a.w,a.C&&(a.C.aa||null)==(b.aa||null)?b:b.reload().then(function(){return Hl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:Il(a.h)})):null}).then(function(b){Ll(a,b||null)});return T(a,c)}
	function Nl(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.l)return a.ka()}).s(function(){}).then(function(){if(!a.l){a.X=!0;var b=a.h;b.b.addListener(Cl("local"),b.a,a.ka)}})}
	g.Jc=function(){var a=this;return Jl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return hl(U(a),b),U(a).F();if(U(a)||b)Ll(a,b),b&&(al(b),b.ba=a.w),a.a&&a.a.subscribe(a),Vl(a)}})};g.Z=function(a){return Hl(this.h,a)};g.Yb=function(){Vl(this);this.Z(U(this))};g.gc=function(){this.kb()};g.hc=function(){this.kb()};
	function Xl(a,b){var c=null,d=null;return T(a,b.then(function(b){c=lg(b);d=yf(b);return Ul(a,b)}).then(function(){return Le({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}g.ic=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};g.jc=function(a){var b=this;Yl(this,function(){a.next(U(b))})};g.sc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Pb(a,b,c)};
	g.rc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){d.O=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Qb(a,b,c)};g.$b=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};g.Jb=function(a){var b=this;return this.i.then(function(){return Xl(b,O(b.b,vi,{token:a}))}).then(function(a){var c=a.user;gl(c,"isAnonymous",!1);b.Z(c);return a})};
	g.Bc=function(a){Ie("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCustomToken is deprecated. Please use firebase.auth.Auth.prototype.signInWithCustomToken instead.");return this.Jb(a)};g.Cc=function(a,b){Ie("firebase.auth.Auth.prototype.signInAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.signInWithEmailAndPassword instead.");return this.Kb(a,b)};g.Kb=function(a,b){var c=this;return this.i.then(function(){return Xl(c,O(c.b,$f,{email:a,password:b}))})};
	g.ub=function(a,b){var c=this;return this.i.then(function(){return Xl(c,O(c.b,ri,{email:a,password:b}))})};g.Sb=function(a,b){Ie("firebase.auth.Auth.prototype.createUserAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.createUserWithEmailAndPassword instead.");return this.ub(a,b)};g.Ec=function(a){Ie("firebase.auth.Auth.prototype.signInWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential instead.");return this.Oa(a).then(function(a){return a.user})};
	g.Oa=function(a){var b=this;return this.i.then(function(){return Xl(b,a.ya(b.b))})};g.Pa=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=Le({providerId:null,isNewUser:!1});return Le({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Xl(a,a.b.Pa()).then(function(b){var c=b.user;gl(c,"isAnonymous",!0);a.Z(c);return b})})};
	g.Dc=function(){Ie("firebase.auth.Auth.prototype.signInAnonymouslyAndRetrieveData is deprecated. Please use firebase.auth.Auth.prototype.signInAnonymously instead.");return this.Pa()};function S(a){return a.app}function U(a){return a.currentUser}g.getUid=function(){return U(this)&&U(this).uid||null};function Zl(a){return U(a)&&U(a)._lat||null}
	function Vl(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](Zl(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Zl(a))}}g.Rb=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&Xk(U(this))};g.zc=function(a){var b=this;v(this.o,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&Yk(U(this));this.removeAuthTokenListener(a)};
	g.addAuthTokenListener=function(a){var b=this;this.o.push(a);T(this,this.i.then(function(){b.l||Fa(b.o,a)&&a(Zl(b))}))};g.removeAuthTokenListener=function(a){Ha(this.o,function(b){return b==a})};function Yl(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Fa(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(Zl(a)))}))}
	g.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(Cl("local"),a.a,this.ka));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};function T(a,b){a.N.push(b);b.ia(function(){Ga(a.N,b)});return b}g.Vb=function(a){Ie("firebase.auth.Auth.prototype.fetchProvidersForEmail is deprecated. Please use firebase.auth.Auth.prototype.fetchSignInMethodsForEmail instead.");return T(this,Rh(this.b,a))};
	g.Wb=function(a){return T(this,Th(this.b,a))};g.kc=function(a){return!!dg(a)};g.ib=function(a,b){var c=this;return T(this,A().then(function(){var a=new af(b);if(!a.c)throw new K("argument-error",jf+" must be true when sending sign in link to email");return kf(a)}).then(function(b){return c.b.ib(a,b)}).then(function(){}))};g.Rc=function(a){return this.Ja(a).then(function(a){return a.data.email})};g.Xa=function(a,b){return T(this,this.b.Xa(a,b).then(function(){}))};g.Ja=function(a){return T(this,this.b.Ja(a).then(function(a){return new Pe(a)}))};
	g.Va=function(a){return T(this,this.b.Va(a).then(function(){}))};g.hb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Za(b)?{}:kf(new af(b))}).then(function(b){return c.b.hb(a,b)}).then(function(){}))};g.Gc=function(a,b){return T(this,Ck(this,a,b,r(this.Oa,this)))};g.Fc=function(a,b){var c=this;return T(this,A().then(function(){var d=cg(a,b||Wd());return c.Oa(d)}))};function $l(){}$l.prototype.render=function(){};$l.prototype.reset=function(){};$l.prototype.getResponse=function(){};$l.prototype.execute=function(){};function am(){this.a={};this.b=1E12}var bm=null;am.prototype.render=function(a,b){this.a[this.b.toString()]=new cm(a,b);return this.b++};am.prototype.reset=function(a){var b=dm(this,a);a=em(a);b&&a&&(b.delete(),delete this.a[a])};am.prototype.getResponse=function(a){return(a=dm(this,a))?a.getResponse():null};am.prototype.execute=function(a){(a=dm(this,a))&&a.execute()};function dm(a,b){return(b=em(b))?a.a[b]||null:null}function em(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
	function cm(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Jd(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():rc(this.f,"click",this.i)}cm.prototype.getResponse=function(){fm(this);return this.b};
	cm.prototype.execute=function(){fm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=pe();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};cm.prototype.delete=function(){fm(this);this.g=!0;clearTimeout(this.a);this.a=null;D(this.f,"click",this.i)};function fm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function gm(){}gm.prototype.g=function(){bm||(bm=new am);return A(bm)};gm.prototype.c=function(){};var hm=null;function im(){this.b=k.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var jm=rd("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),km=new Ce(3E4,6E4);
	im.prototype.g=function(a){var b=this;return new y(function(c,d){var e=setTimeout(function(){d(new K("network-request-failed"))},km.get());if(!k.grecaptcha||a!==b.f&&!b.b){k[b.a]=function(){if(k.grecaptcha){b.f=a;var f=k.grecaptcha.render;k.grecaptcha.render=function(a,c){a=f(a,c);b.b++;return a};clearTimeout(e);c(k.grecaptcha)}else clearTimeout(e),d(new K("internal-error"));delete k[b.a]};var f=vd(jm,{onload:b.a,hl:a||""});A(sh(f)).s(function(){clearTimeout(e);d(new K("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
	c(k.grecaptcha)})};im.prototype.c=function(){this.b--};var lm=null;function mm(a,b,c,d,e,f,h){I(this,"type","recaptcha");this.c=this.f=null;this.C=!1;this.l=b;this.g=null;h?(hm||(hm=new gm),h=hm):(lm||(lm=new im),h=lm);this.o=h;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[nm])throw new K("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[om];if(!k.document)throw new K("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
	if(!Jd(b)||!this.i&&Jd(b).hasChildNodes())throw new K("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Ah(a,f||null,e||null);this.v=d||function(){return null};var m=this;this.m=[];var p=this.a[pm];this.a[pm]=function(a){qm(m,a);if("function"===typeof p)p(a);else if("string"===typeof p){var b=H(p,k);"function"===typeof b&&b(a)}};var z=this.a[rm];this.a[rm]=function(){qm(m,null);if("function"===typeof z)z();else if("string"===typeof z){var a=
	H(z,k);"function"===typeof a&&a()}}}var pm="callback",rm="expired-callback",nm="sitekey",om="size";function qm(a,b){for(var c=0;c<a.m.length;c++)try{a.m[c](b)}catch(d){}}function sm(a,b){Ha(a.m,function(a){return a==b})}function tm(a,b){a.h.push(b);b.ia(function(){Ga(a.h,b)});return b}g=mm.prototype;
	g.za=function(){var a=this;return this.f?this.f:this.f=tm(this,A().then(function(){if(ve()&&!me())return he();throw new K("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.o.g(a.v())}).then(function(b){a.g=b;return O(a.u,ui,{})}).then(function(b){a.a[nm]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
	g.render=function(){um(this);var a=this;return tm(this,this.za().then(function(){if(null===a.c){var b=a.l;if(!a.i){var c=Jd(b);b=Md("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};g.verify=function(){um(this);var a=this;return tm(this,this.render().then(function(b){return new y(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(b){b&&(sm(a,e),c(b))};a.m.push(e);a.i&&a.g.execute(a.c)}})}))};g.reset=function(){um(this);null!==this.c&&this.g.reset(this.c)};
	function um(a){if(a.C)throw new K("internal-error","RecaptchaVerifier instance has been destroyed.");}g.clear=function(){um(this);this.C=!0;this.o.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Jd(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};
	function vm(a,b,c){var d=!1;try{this.b=c||firebase.app()}catch(h){throw new K("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new K("invalid-api-key");var e=this,f=null;try{f=this.b.auth().xa()}catch(h){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(h){}f=firebase.SDK_VERSION?re(firebase.SDK_VERSION,f):null;mm.call(this,c,a,b,function(){try{var a=e.b.auth().ea()}catch(m){a=
	null}return a},f,xi(yi),d)}t(vm,mm);function wm(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,h=0;h<b.length;h++)if(b[h].optional)f=!0;else{if(f)throw new K("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=xm.length)throw new K("internal-error",
	"Argument validator received an unsupported number of arguments.");c=xm[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new K("argument-error",a+" failed: "+d);}var xm="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:l}}function ym(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ba}}
	function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function zm(a,b){return{name:a||"",K:"a function",optional:!!b,M:n}}function Am(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Bm(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Cm(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof Kl)}}}
	function Dm(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Em(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.ya||!c)}}}
	function Fm(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Gm(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&l(a.type)&&n(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Hm(d,a[c],b[c].j)}}function Im(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].qb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){wm(d,[e],[a],!0);this[c]=a},enumerable:!0})}}}function Z(a,b,c,d){a[b]=Hm(b,c,d)}
	function Hm(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);wm(e,c,a);return b.apply(this,a)}if(!c)return b;var e=Jm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function Jm(a){a=a.split(".");return a[a.length-1]};Y(Kl.prototype,{Va:{name:"applyActionCode",j:[V("code")]},Ja:{name:"checkActionCode",j:[V("code")]},Xa:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},ub:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Sb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Vb:{name:"fetchProvidersForEmail",j:[V("email")]},Wb:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},kc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},
	rc:{name:"onAuthStateChanged",j:[X(W(),zm(),"nextOrObserver"),zm("opt_error",!0),zm("opt_completed",!0)]},sc:{name:"onIdTokenChanged",j:[X(W(),zm(),"nextOrObserver"),zm("opt_error",!0),zm("opt_completed",!0)]},hb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Am(null,!0),"opt_actionCodeSettings",!0)]},ib:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},jb:{name:"setPersistence",j:[V("persistence")]},Oa:{name:"signInAndRetrieveDataWithCredential",
	j:[Em()]},Pa:{name:"signInAnonymously",j:[]},Dc:{name:"signInAnonymouslyAndRetrieveData",j:[]},Ec:{name:"signInWithCredential",j:[Em()]},Jb:{name:"signInWithCustomToken",j:[V("token")]},Bc:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},Kb:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Fc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Cc:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Gc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),
	Gm()]},Hc:{name:"signInWithPopup",j:[Fm()]},Ic:{name:"signInWithRedirect",j:[Fm()]},Oc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(a){return!!(a&&a instanceof Q)}}}(),Am(),"user")]},kb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Qc:{name:"useDeviceLanguage",j:[]},Rc:{name:"verifyPasswordResetCode",j:[V("code")]}});Im(Kl.prototype,{lc:{name:"languageCode",qb:X(V(),Am(),"languageCode")}});Kl.Persistence=rj;
	Kl.Persistence.LOCAL="local";Kl.Persistence.SESSION="session";Kl.Persistence.NONE="none";
	Y(Q.prototype,{"delete":{name:"delete",j:[]},ac:{name:"getIdTokenResult",j:[ym("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[ym("opt_forceRefresh",!0)]},ab:{name:"linkAndRetrieveDataWithCredential",j:[Em()]},mc:{name:"linkWithCredential",j:[Em()]},nc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Gm()]},oc:{name:"linkWithPopup",j:[Fm()]},pc:{name:"linkWithRedirect",j:[Fm()]},cb:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Em()]},vc:{name:"reauthenticateWithCredential",j:[Em()]},wc:{name:"reauthenticateWithPhoneNumber",
	j:[V("phoneNumber"),Gm()]},xc:{name:"reauthenticateWithPopup",j:[Fm()]},yc:{name:"reauthenticateWithRedirect",j:[Fm()]},reload:{name:"reload",j:[]},gb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Am(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Nc:{name:"unlink",j:[V("provider")]},mb:{name:"updateEmail",j:[V("email")]},nb:{name:"updatePassword",j:[V("password")]},Pc:{name:"updatePhoneNumber",j:[Em("phone")]},ob:{name:"updateProfile",j:[W("profile")]}});
	Y(am.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y($l.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(y.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Im(Ak.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",qb:ym("appVerificationDisabledForTesting")}});Y(Bk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
	Z(N,"credential",function(a,b){return new Yf(a,b)},[V("email"),V("password")]);Y(Qf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Qf,"credential",Rf,[X(V(),W(),"token")]);Z(N,"credentialWithLink",cg,[V("email"),V("emailLink")]);Y(Sf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Sf,"credential",Tf,[X(V(),W(),"token")]);
	Y(Uf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Uf,"credential",Vf,[X(V(),X(W(),Am()),"idToken"),X(V(),Am(),"accessToken",!0)]);Y(Wf.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Wf,"credential",Xf,[X(V(),W(),"token"),V("secret",!0)]);
	Y(M.prototype,{ta:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Am(),"idToken",!0),X(V(),Am(),"accessToken",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ig,"credential",kg,[V("verificationId"),V("verificationCode")]);Y(ig.prototype,{Ta:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Gm()]}});Y(K.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(sg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
	Y(rg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(vm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:Kl,Error:K};Z(a,"EmailAuthProvider",N,[]);Z(a,"FacebookAuthProvider",Qf,[]);Z(a,"GithubAuthProvider",Sf,[]);Z(a,"GoogleAuthProvider",Uf,[]);Z(a,"TwitterAuthProvider",Wf,[]);Z(a,"OAuthProvider",M,[V("providerId")]);Z(a,"PhoneAuthProvider",ig,[Cm()]);Z(a,"RecaptchaVerifier",vm,[X(V(),Bm(),"recaptchaContainer"),W("recaptchaParameters",!0),Dm()]);firebase.INTERNAL.registerService("auth",function(a,
	c){a=new Kl(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.$b,a),addAuthTokenListener:r(a.Rb,a),removeAuthTokenListener:r(a.zc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
	}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var util = __webpack_require__(30);
	var logger = __webpack_require__(44);
	var tslib_1 = __webpack_require__(20);
	var firebase = _interopDefault(__webpack_require__(13));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	var PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	var SessionStorage = createStoragefor('sessionStorage');
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger.Logger('@firebase/database');
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	var LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	var sha1 = function (str) {
	    var utf8Bytes = util.stringToByteArray(str);
	    var sha1 = new util.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} var_args
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < var_args.length; i++) {
	        if (Array.isArray(var_args[i]) ||
	            (var_args[i] &&
	                typeof var_args[i] === 'object' &&
	                typeof var_args[i].length === 'number')) {
	            message += buildLogMessage_.apply(null, var_args[i]);
	        }
	        else if (typeof var_args[i] === 'object') {
	            message += util.stringify(var_args[i]);
	        }
	        else {
	            message += var_args[i];
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	var logger$1 = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	var enableLogging = function (logger_, persistent) {
	    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        logClient.logLevel = logger.LogLevel.VERBOSE;
	        logger$1 = logClient.log.bind(logClient);
	        if (persistent)
	            SessionStorage.set('logging_enabled', true);
	    }
	    else if (typeof logger_ === 'function') {
	        logger$1 = logger_;
	    }
	    else {
	        logger$1 = null;
	        SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} var_args
	 */
	var log = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (logger$1 === null && SessionStorage.get('logging_enabled') === true)
	            enableLogging(true);
	    }
	    if (logger$1) {
	        var message = buildLogMessage_.apply(null, var_args);
	        logger$1(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	var logWrapper = function (prefix) {
	    return function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        log.apply(void 0, [prefix].concat(var_args));
	    };
	};
	/**
	 * @param {...string} var_args
	 */
	var error = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
	    logClient.error(message);
	};
	/**
	 * @param {...string} var_args
	 */
	var fatal = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
	    logClient.error(message);
	    throw new Error(message);
	};
	/**
	 * @param {...*} var_args
	 */
	var warn = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
	    logClient.warn(message);
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	var warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	var isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data != data || // NaN
	            data == Number.POSITIVE_INFINITY ||
	            data == Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	var executeWhenDOMReady = function (fn) {
	    if (util.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	        }
	        else if (document.attachEvent) {
	            // IE.
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete')
	                    wrappedFn_1();
	            });
	            // fallback to onload.
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	var MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	var MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	var nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === MIN_NAME || b === MAX_NAME) {
	        return -1;
	    }
	    else if (b === MIN_NAME || a === MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	var stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	var requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	var ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null)
	        return util.stringify(obj);
	    var keys = [];
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0)
	            key += ',';
	        key += util.stringify(keys[i]);
	        key += ':';
	        key += ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	var splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param {!(Object|Array)} obj The object or array to iterate over
	 * @param {function(?, ?)} fn The function to apply
	 */
	var each = function (obj, fn) {
	    if (Array.isArray(obj)) {
	        for (var i = 0; i < obj.length; ++i) {
	            fn(i, obj[i]);
	        }
	    }
	    else {
	        /**
	         * in the conversion of code we removed the goog.object.forEach
	         * function which did a value,key callback. We standardized on
	         * a single impl that does a key, value callback. So we invert
	         * to not have to touch the `each` code points
	         */
	        util.forEach(obj, function (key, val) { return fn(val, key); });
	    }
	};
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	var doubleToIEEE754String = function (v) {
	    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1)
	            hexByte = '0' + hexByte;
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	var isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	var isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	var errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code == 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code == 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	var tryParseInt = function (str) {
	    if (INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	var exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	var beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	var setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    if (typeof timeout === 'object' && timeout['unref']) {
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length)
	            return this.pieces_[this.pieces_.length - 1];
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + this.pieces_[i];
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
	            pieces.push(this.pieces_[i]);
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
	            pieces.push(this.pieces_[i]);
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0)
	                    pieces.push(childPieces[i]);
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0)
	                return cmp;
	        }
	        if (leftKeys.length === rightKeys.length)
	            return 0;
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length == 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PROTOCOL_VERSION = '5';
	var VERSION_PARAM = 'v';
	var TRANSPORT_SESSION_PARAM = 's';
	var REFERER_PARAM = 'r';
	var FORGE_REF = 'f';
	var FORGE_DOMAIN = 'firebaseio.com';
	var LAST_SESSION_PARAM = 'ls';
	var WEBSOCKET = 'websocket';
	var LONG_POLLING = 'long_polling';
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return this.host !== this.internalHost || this.isCustomHost();
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util.assert(typeof type === 'string', 'typeof type must == string');
	        util.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        util.forEach(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 * @param {!string} queryString
	 * @return {!{[key:string]:string}} key value hash
	 */
	function decodeQuery(queryString) {
	    var results = {};
	    if (queryString.startsWith('?')) {
	        queryString = queryString.substring(1);
	    }
	    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
	        var segment = _a[_i];
	        if (segment.length === 0) {
	            continue;
	        }
	        var kv = segment.split('=');
	        if (kv.length === 2) {
	            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
	        }
	        else {
	            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
	        }
	    }
	    return results;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	var parseRepoInfo = function (dataURL) {
	    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
	    if (parsedUrl.domain === 'firebase') {
	        fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if ((!namespace || namespace == 'undefined') &&
	        parsedUrl.domain !== 'localhost') {
	        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
	        path: new Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
	 */
	var parseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host, path, and query string.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        var questionMarkInd = dataURL.indexOf('?');
	        if (questionMarkInd === -1) {
	            questionMarkInd = dataURL.length;
	        }
	        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
	        if (slashInd < questionMarkInd) {
	            // For pathString, questionMarkInd will always come after slashInd
	            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
	        }
	        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	        else {
	            colonInd = dataURL.length;
	        }
	        var parts = host.split('.');
	        if (parts.length === 3) {
	            // Normalize namespaces to lowercase to share storage / connection.
	            domain = parts[1];
	            subdomain = parts[0].toLowerCase();
	        }
	        else if (parts.length === 2) {
	            domain = parts[0];
	        }
	        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
	            domain = 'localhost';
	        }
	        // Support `ns` query param if subdomain not already set
	        if (subdomain === '' && 'ns' in queryParams) {
	            subdomain = queryParams['ns'];
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString
	    };
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	var isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	var isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
	        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	var validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > MAX_LEAF_SIZE_ / 3 &&
	        util.stringLength(data) > MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false, hasActualChild_1 = false;
	        util.forEach(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) {
	                // .priority is OK
	            }
	            else if (!isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    util.forEach(data, function (key, value) {
	        var curPath = new Path(key);
	        validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	var validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined)
	        return;
	    if (isInvalidJSONNumber(priority))
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    // Special case to allow importing data with a .sv.
	    if (!isValidPriority(priority))
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	};
	var validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined)
	        return;
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	var validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined)
	        return;
	    if (!isValidKey(key))
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	};
	var validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined)
	        return;
	    if (!isValidPathString(pathString))
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	};
	var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    validatePathString(fnName, argumentNumber, pathString, optional);
	};
	var validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	var validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        (!isValidKey(parsedUrl.repoInfo.namespace) &&
	            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
	        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	var validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined)
	        return;
	    if (typeof bool !== 'boolean')
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validateWritablePath('OnDisconnect.remove', this.path_);
	        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.set', this.path_);
	        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	var nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
	        var newWrapped = new NamedNode(MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        return NamedNode.MIN;
	    };
	    return Index;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    tslib_1.__extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new NamedNode(MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index));
	var KEY_INDEX = new KeyIndex();
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	var priorityHashText = function (priority) {
	    if (typeof priority === 'number')
	        return 'number:' + doubleToIEEE754String(priority);
	    else
	        return 'string:' + priority;
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	var validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty())
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        else
	            return this.getValue();
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty())
	                toHash +=
	                    'priority:' +
	                        priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var nodeFromJSON;
	var MAX_NODE$1;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	function setMaxNode$1(val) {
	    MAX_NODE$1 = val;
	}
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    tslib_1.__extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index));
	var PRIORITY_INDEX = new PriorityIndex();
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_)
	            result = this.resultGenerator_(node.key, node.value);
	        else
	            result = { key: node.key, value: node.value };
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var cmp, n;
	        n = this;
	        cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_())
	            n = n.moveRedLeft_();
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_())
	                n = n.rotateRight_();
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_())
	            n = n.rotateLeft_();
	        if (n.left.isRed_() && n.left.left.isRed_())
	            n = n.rotateRight_();
	        if (n.left.isRed_() && n.right.isRed_())
	            n = n.colorFlip_();
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        var blackDepth;
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty())
	                        node = node.right;
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length == 0) {
	            return null;
	        }
	        else if (length == 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
	        }
	        else {
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, LLRBNode.BLACK);
	                buildPennant(chunkSize, LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    return new SortedMap(mapSortFn || cmp, root);
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _defaultIndexMap;
	var fallbackObject = {};
	/**
	 *
	 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
	 * @param {Object.<string, Index>} indexSet
	 * @constructor
	 */
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         * @type {!IndexMap}
	         * @const
	         */
	        get: function () {
	            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     *
	     * @param {!string} indexKey
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util.safeGet(this.indexes_, indexKey);
	        if (!sortedMap)
	            throw new Error('No index defined for ' + indexKey);
	        if (sortedMap === fallbackObject) {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	        else {
	            return sortedMap;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {boolean}
	     */
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util.contains(this.indexSet_, indexDefinition.toString());
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = util.clone(this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = util.clone(this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util.safeGet(_this.indexSet_, indexName);
	            util.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name != namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function NAME_ONLY_COMPARATOR(left, right) {
	    return nameCompare(left.name, right.name);
	}
	function NAME_COMPARATOR(left, right) {
	    return nameCompare(left, right);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null)
	            return this;
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty())
	            return null;
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            for (var key in obj)
	                array[key] = obj[key];
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty())
	                toHash_1 +=
	                    'priority:' +
	                        priorityHashText(this.getPriority().val()) +
	                        ':';
	            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '')
	                    toHash_1 += ':' + key + ':' + childHash;
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === MAX_NODE$2) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    tslib_1.__extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	var MAX_NODE$2 = new MaxNode();
	Object.defineProperties(NamedNode, {
	    MIN: {
	        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new NamedNode(MAX_NAME, MAX_NODE$2)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode.__childrenNodeConstructor = ChildrenNode;
	setMaxNode(MAX_NODE$2);
	setMaxNode$1(MAX_NODE$2);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON$1(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj_1 = json;
	        util.forEach(hinzeJsonObj_1, function (key, child) {
	            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length == 0) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode.EMPTY_NODE;
	        var jsonObj_1 = json;
	        util.forEach(jsonObj_1, function (key, childData) {
	            if (util.contains(jsonObj_1, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON$1(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty())
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON$1(priority));
	    }
	}
	setNodeFromJSON(nodeFromJSON$1);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    tslib_1.__extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        return NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        return new NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index));
	var VALUE_INDEX = new ValueIndex();
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    tslib_1.__extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
	        return new NamedNode(MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode())
	            return false;
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode())
	            return false;
	        else
	            return !this.node_.isEmpty();
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherCount = util.getCount(other.callbacks_);
	                var thisCount = util.getCount(this.callbacks_);
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    //  If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
	                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName != MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName != MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PRIORITY_INDEX) {
	            if ((startNode != null && !isValidPriority(startNode)) ||
	                (endNode != null && !isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util.assert(params.getIndex() instanceof PathIndex ||
	                params.getIndex() === VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util.validateArgCount('Query.on', 2, 4, arguments.length);
	        validateEventType('Query.on', 1, eventType, false);
	        util.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util.validateArgCount('Query.off', 0, 3, arguments.length);
	        validateEventType('Query.off', 1, eventType, true);
	        util.validateCallback('Query.off', 2, callback, true);
	        util.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param cancelOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
	        var _this = this;
	        util.validateArgCount('Query.once', 1, 4, arguments.length);
	        validateEventType('Query.once', 1, eventType, false);
	        util.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel)
	                ret.cancel.bind(ret.context)(err);
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error$$1 = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error$$1);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Query;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Implements a set with a count of elements.
	 *
	 * @template K, V
	 */
	var CountedSet = /** @class */ (function () {
	    function CountedSet() {
	        this.set = {};
	    }
	    /**
	     * @param {!K} item
	     * @param {V} val
	     */
	    CountedSet.prototype.add = function (item, val) {
	        this.set[item] = val !== null ? val : true;
	    };
	    /**
	     * @param {!K} key
	     * @return {boolean}
	     */
	    CountedSet.prototype.contains = function (key) {
	        return util.contains(this.set, key);
	    };
	    /**
	     * @param {!K} item
	     * @return {V}
	     */
	    CountedSet.prototype.get = function (item) {
	        return this.contains(item) ? this.set[item] : undefined;
	    };
	    /**
	     * @param {!K} item
	     */
	    CountedSet.prototype.remove = function (item) {
	        delete this.set[item];
	    };
	    /**
	     * Deletes everything in the set
	     */
	    CountedSet.prototype.clear = function () {
	        this.set = {};
	    };
	    /**
	     * True if there's nothing in the set
	     * @return {boolean}
	     */
	    CountedSet.prototype.isEmpty = function () {
	        return util.isEmpty(this.set);
	    };
	    /**
	     * @return {number} The number of items in the set
	     */
	    CountedSet.prototype.count = function () {
	        return util.getCount(this.set);
	    };
	    /**
	     * Run a function on each k,v pair in the set
	     * @param {function(K, V)} fn
	     */
	    CountedSet.prototype.each = function (fn) {
	        util.forEach(this.set, function (k, v) { return fn(k, v); });
	    };
	    /**
	     * Mostly for debugging
	     * @return {Array.<K>} The keys present in this CountedSet
	     */
	    CountedSet.prototype.keys = function () {
	        var keys = [];
	        util.forEach(this.set, function (k) {
	            keys.push(k);
	        });
	        return keys;
	    };
	    return CountedSet;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper class to store a sparse set of snapshots.
	 *
	 * @constructor
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        /**
	         * @private
	         * @type {Node}
	         */
	        this.value_ = null;
	        /**
	         * @private
	         * @type {CountedSet}
	         */
	        this.children_ = null;
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {?Node} The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value_ != null) {
	            return this.value_.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children_ != null) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children_.contains(childKey)) {
	                var childTree = this.children_.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @param {!Node} data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value_ = data;
	            this.children_ = null;
	        }
	        else if (this.value_ !== null) {
	            this.value_ = this.value_.updateChild(path, data);
	        }
	        else {
	            if (this.children_ == null) {
	                this.children_ = new CountedSet();
	            }
	            var childKey = path.getFront();
	            if (!this.children_.contains(childKey)) {
	                this.children_.add(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children_.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {boolean} True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value_ = null;
	            this.children_ = null;
	            return true;
	        }
	        else {
	            if (this.value_ !== null) {
	                if (this.value_.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value_;
	                    this.value_ = null;
	                    var self_1 = this;
	                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children_ !== null) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children_.contains(childKey)) {
	                    var safeToRemove = this.children_.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children_.remove(childKey);
	                    }
	                }
	                if (this.children_.isEmpty()) {
	                    this.children_ = null;
	                    return true;
	                }
	                else {
	                    return false;
	                }
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param {!Path} prefixPath Path to look up node for.
	     * @param {!Function} func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value_ !== null) {
	            func(prefixPath, this.value_);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param {!Function} func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        if (this.children_ !== null) {
	            this.children_.each(function (key, tree) {
	                func(key, tree);
	            });
	        }
	    };
	    return SparseSnapshotTree;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	var generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	var resolveDeferredValue = function (value, serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    else {
	        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	        return serverValues[value['.sv']];
	    }
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!SparseSnapshotTree} tree
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	var resolveDeferredValueTree = function (tree, serverValues) {
	    var resolvedTree = new SparseSnapshotTree();
	    tree.forEachTree(new Path(''), function (path, node) {
	        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
	    });
	    return resolvedTree;
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	var resolveDeferredValueSnapshot = function (node, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = resolveDeferredValue(rawPri, serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode(value, nodeFromJSON$1(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode(priority));
	        }
	        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType || (OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	    /**@inheritDoc */ path, 
	    /**@inheritDoc */ affectedTree, 
	    /**@inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path(childName));
	            return new AckUserWrite(Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap(stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        util.forEach(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	    /**@inheritDoc */ source, 
	    /**@inheritDoc */ path, 
	    /**@inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite(this.source, Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path.Empty, childTree);
	            }
	        }
	        else {
	            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() == newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap_ = {};
	    }
	    /**
	     * @param {!Change} change
	     */
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey /** @type {!string} */ = change.childName;
	        util.assert(type == Change.CHILD_ADDED ||
	            type == Change.CHILD_CHANGED ||
	            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = util.safeGet(this.changeMap_, childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
	                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
	            }
	            else if (type == Change.CHILD_REMOVED &&
	                oldType == Change.CHILD_ADDED) {
	                delete this.changeMap_[childKey];
	            }
	            else if (type == Change.CHILD_REMOVED &&
	                oldType == Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
	            }
	            else if (type == Change.CHILD_CHANGED &&
	                oldType == Change.CHILD_ADDED) {
	                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
	            }
	            else if (type == Change.CHILD_CHANGED &&
	                oldType == Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
	            }
	            else {
	                throw util.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap_[childKey] = change;
	        }
	    };
	    /**
	     * @return {!Array.<!Change>}
	     */
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return util.getValues(this.changeMap_);
	    };
	    return ChildChangeAccumulator;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util.assert(viewCache
	            .getEventCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util.assert(viewCache
	            .getServerCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap
	                        .getNode()
	                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
	                !eventSnap
	                    .getNode()
	                    .getPriority()
	                    .equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode
	                        ? serverCache
	                        : ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey == '.priority') {
	                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey == '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache
	            .getServerCache()
	            .getNode()
	            .isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache
	                    .getEventCache()
	                    .getNode()
	                    .hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor$1;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         *
	         * @type {!Object.<!string, !View>}
	         * @private
	         */
	        this.views_ = {};
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
	            return __referenceConstructor$1;
	        },
	        set: function (val) {
	            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
	            __referenceConstructor$1 = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.isEmpty = function () {
	        return util.isEmpty(this.views_);
	    };
	    /**
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} optCompleteServerCache
	     * @return {!Array.<!Event>}
	     */
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = util.safeGet(this.views_, queryId);
	            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events_1 = [];
	            util.forEach(this.views_, function (key, view) {
	                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	            });
	            return events_1;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = util.safeGet(this.views_, queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache(new CacheNode(
	            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
	            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
	            view = new View(query, viewCache);
	            this.views_[queryId] = view;
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            // When you do ref.off(...), we search all views for the registration to remove.
	            var self_1 = this;
	            util.forEach(this.views_, function (viewQueryId, view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete self_1.views_[viewQueryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            });
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = util.safeGet(this.views_, queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete this.views_[queryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    /**
	     * @return {!Array.<!View>}
	     */
	    SyncPoint.prototype.getQueryViews = function () {
	        var _this = this;
	        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
	        return values.filter(function (view) {
	            return !view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	    };
	    /**
	     *
	     * @param {!Path} path The path to the desired complete snapshot
	     * @return {?Node} A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var serverCache = null;
	        util.forEach(this.views_, function (key, view) {
	            serverCache = serverCache || view.getCompleteServerCache(path);
	        });
	        return serverCache;
	    };
	    /**
	     * @param {!Query} query
	     * @return {?View}
	     */
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return util.safeGet(this.views_, queryId);
	        }
	    };
	    /**
	     * @param {!Query} query
	     * @return {boolean}
	     */
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    /**
	     * @return {?View}
	     */
	    SyncPoint.prototype.getCompleteView = function () {
	        var completeView = util.findValue(this.views_, function (view) {
	            return view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	        return completeView || null;
	    };
	    return SyncPoint;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 *
	 * @constructor
	 * @param {!ImmutableTree.<!Node>} writeTree
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    /**
	     * @param {!Path} path
	     * @param {!Node} node
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} updates
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        util.forEach(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param {!Path} path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param {!Path} path The path to check for
	     * @return {boolean} Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param {!Path} path The path to get a complete write
	     * @return {?Node} The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return {!Array.<NamedNode>} A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    /**
	     * @param {!Path} path
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return {boolean} Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param {!Node} node The node to apply this CompoundWrite to
	     * @return {!Node} The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
	    };
	    /**
	     * @type {!CompoundWrite}
	     */
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
	    /**
	     * @param {!Path} relativePath
	     * @param {!ImmutableTree.<!Node>} writeTree
	     * @param {!Node} node
	     * @return {!Node}
	     * @private
	     */
	    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
	        if (writeTree.value != null) {
	            // Since there a write is always a leaf, we're done here
	            return node.updateChild(relativePath, writeTree.value);
	        }
	        else {
	            var priorityWrite_1 = null;
	            writeTree.children.inorderTraversal(function (childKey, childTree) {
	                if (childKey === '.priority') {
	                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                    // to apply priorities to empty nodes that are later filled
	                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                    priorityWrite_1 = childTree.value;
	                }
	                else {
	                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
	                }
	            });
	            // If there was a priority write, we only apply it if the node is not empty
	            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	            }
	            return node;
	        }
	    };
	    return CompoundWrite;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                util.forEach(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    /**
	     * @param {!WriteRecord} writeRecord
	     * @param {!Path} path
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            // findKey can return undefined, so use !! to coerce to boolean
	            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
	                return writeRecord.path.child(childName).contains(path);
	            });
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     * @private
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     *
	     * @param {!WriteRecord} write
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     *
	     * @param {!Array.<!WriteRecord>} writes
	     * @param {!function(!WriteRecord):boolean} filter
	     * @param {!Path} treeRoot
	     * @return {!CompoundWrite}
	     * @private
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else {
	                    throw util.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         * @type {!ImmutableTree.<!SyncPoint>}
	         * @private
	         */
	        this.syncPointTree_ = ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         * @type {!WriteTree}
	         * @private
	         */
	        this.pendingWriteTree_ = new WriteTree();
	        this.tagToQueryMap_ = {};
	        this.queryToTagMap_ = {};
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @param {number} writeId
	     * @param {boolean=} visible
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param {!number} writeId
	     * @param {boolean=} revert True if the given write failed and needs to be reverted
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
	            }
	            else {
	                util.forEach(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @param {!Path} path
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree.fromObject(changedChildren);
	            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @param {!Path} path
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap_[queryKey] = tag;
	            // Coerce to string to avoid sparse arrays.
	            this.tagToQueryMap_['_' + tag] = queryKey;
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	                else {
	                    // There's nothing below us, so nothing we need to start listening on
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        else {
	            // No-op, this listener must've been already removed
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
	     * it, but as this is only used by transaction code, that should always be the case anyways.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     * @param {!Path} path The path to the data we want
	     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
	     * @return {?Node}
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     *
	     * @param {!ImmutableTree.<!SyncPoint>} subtree
	     * @return {!Array.<!View>}
	     * @private
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                util.forEach(childMap, function (key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    /**
	     * @param {!Array.<!Query>} queries
	     * @private
	     */
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
	                delete this.queryToTagMap_[removedQueryKey];
	                delete this.tagToQueryMap_['_' + removedQueryTag];
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     * @param {!Query} query
	     * @return {!Query} The normalized query
	     * @private
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return /** @type {!Query} */ query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @param {!Query} query
	     * @param {!View} view
	     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
	     * @private
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    util.forEach(childMap, function (key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    /**
	     *
	     * @param {!View} view
	     * @return {{hashFn: function(), onComplete: function(!string, *)}}
	     * @private
	     */
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error$$1 = errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error$$1);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     * @private
	     * @param {!Query} query
	     * @return {string}
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     * @private
	     * @param {!string} queryKey
	     * @return {{queryId: !string, path: !Path}}
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     * @param {!number} tag
	     * @return {?string}
	     * @private
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap_['_' + tag];
	    };
	    /**
	     * Return the tag associated with the given query.
	     * @param {!Query} query
	     * @return {?number}
	     * @private
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return util.safeGet(this.queryToTagMap_, queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     * @return {number}
	     * @private
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     *
	     * @param {!Path} queryPath
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	  
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	  
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     *
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     * @type {number}
	     * @private
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var AuthTokenProvider = /** @class */ (function () {
	    /**
	     * @param {!FirebaseApp} app_
	     */
	    function AuthTokenProvider(app_) {
	        this.app_ = app_;
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
	        // .catch
	        function (error$$1) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error$$1 && error$$1.code === 'auth/token-not-initialized') {
	                log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error$$1);
	            }
	        });
	    };
	    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        this.app_['INTERNAL']['addAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        warn(errorMessage);
	    };
	    return AuthTokenProvider;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util.contains(this.counters_, name))
	            this.counters_[name] = 0;
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = util.clone(newStats);
	        if (this.last_) {
	            util.forEach(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        util.forEach(stats, function (stat, value) {
	            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (logger$1) {
	                    log('event: ' + eventData.toString());
	                }
	                exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} var_args
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = this.listeners_[eventType].slice();
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, var_args);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    tslib_1.__extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    tslib_1.__extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// URL query parameters associated with longpolling
	var FIREBASE_LONGPOLL_START_PARAM = 'start';
	var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	var FIREBASE_LONGPOLL_ID_PARAM = 'id';
	var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
	var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId An identifier for this connection, used for logging
	     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
	     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = logWrapper(connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        executeWhenDOMReady(function () {
	            if (_this.isClosed_)
	                return;
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var command = args[0], arg1 = args[1], arg2 = args[2];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder)
	                    return; // we closed the connection.
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command == FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var pN = args[0], data = args[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
	                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (!util.isNodeSdk() &&
	                typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(FORGE_DOMAIN) !== -1) {
	                urlParams[REFERER_PARAM] = FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	        return (BrowserPollConnection.forceAllow_ ||
	            (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !isChromeExtensionContentScript() &&
	                !isWindowsStoreApp() &&
	                !util.isNodeSdk()));
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util.isNodeSdk())
	            return;
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        /**
	         * @type {CountedSet.<number, number>}
	         */
	        this.outstandingRequests = new CountedSet();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = LUIDGenerator();
	            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                log('frame writing exception');
	                if (e.stack) {
	                    log(e.stack);
	                }
	                log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	        }
	        else if (iframe.document) {
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        if (util.isNodeSdk() && this.myID) {
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
	            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            var theURL = this.urlFn(urlParams);
	            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial, 1);
	        var doNewRequest = function () {
	            _this.outstandingRequests.remove(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util.isNodeSdk()) {
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls)
	                        return;
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId identifier for this transport
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = logWrapper(this.connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	        if (!util.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(FORGE_DOMAIN) !== -1) {
	            urlParams[REFERER_PARAM] = FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util.isNodeSdk()) {
	                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') == 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                this.mySock = new WebSocketImpl(this.connURL);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error$$1 = e.message || e.data;
	            if (error$$1) {
	                this.log_(error$$1);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            var error$$1 = e.message || e.data;
	            if (error$$1) {
	                _this.log_(error$$1);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (PersistentStorage.isInMemoryStorage ||
	            PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length == this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null)
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection, WebSocketConnection];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable)
	                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection];
	        }
	        else {
	            var transports_1 = (this.transports_ = []);
	            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
	                if (transport && transport['isAvailable']()) {
	                    transports_1.push(transport);
	                }
	            });
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param {!string} id - an id for this connection
	     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
	     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
	        if (healthyTimeout_ms > 0) {
	            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	            }, Math.floor(healthyTimeout_ms));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ != 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer == 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onControl_(data);
	        }
	        else if (layer == 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ == 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (PROTOCOL_VERSION !== version) {
	                warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    tslib_1.__extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param onConnectStatus_
	     * @param onServerInfoUpdate_
	     * @param authTokenProvider_
	     * @param authOverride_
	     */
	    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = logWrapper('p:' + _this.id + ':');
	        /** @private {Object} */
	        _this.interruptReasons_ = {};
	        _this.listens_ = {};
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        /** @private {number|null} */
	        _this.establishConnectionTimer_ = null;
	        /** @private {boolean} */
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        /** @private {?{
	         *   sendRequest(Object),
	         *   close()
	         * }} */
	        _this.realtime_ = null;
	        /** @private {string|null} */
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    /**
	     * @param {!string} action
	     * @param {*} body
	     * @param {function(*)=} onResponse
	     * @protected
	     */
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util.stringify(msg));
	        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        this.listens_[pathString] = this.listens_[pathString] || {};
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens_[pathString][queryId] = listenSpec;
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    /**
	     * @param {!{onComplete(),
	     *           hashFn():!string,
	     *           query: !Query,
	     *           tag: ?number}} listenSpec
	     * @private
	     */
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req[ /*hash*/'h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message[ /*data*/'d'];
	            var status = message[ /*status*/'s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    /**
	     * @param {*} payload
	     * @param {!Query} query
	     * @private
	     */
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
	            var warnings = util.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' +
	                    query
	                        .getQueryParams()
	                        .getIndex()
	                        .toString() +
	                    '"';
	                var indexPath = query.path.toString();
	                warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    /**
	     * @param {!string} credential
	     * @private
	     */
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res[ /*status*/'s'];
	                var data = res[ /*data*/'d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined)
	            request[ /*hash*/'h'] = hash;
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete)
	                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result[ /*status*/'s'];
	                if (status !== 'ok') {
	                    var errorReason = result[ /* data */'d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    /**
	     * @param {*} message
	     * @private
	     */
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message[ /*body*/'b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd')
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge*/ false, body['t']);
	        else if (action === 'm')
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge=*/ true, body['t']);
	        else if (action === 'c')
	            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
	        else if (action === 'ac')
	            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
	        else if (action === 'sd')
	            this.onSecurityDebugPacket_(body);
	        else
	            error('Unrecognized action received from server: ' +
	                util.stringify(action) +
	                '\nAre you using the latest client?');
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	        }, Math.floor(timeout));
	    };
	    /**
	     * @param {boolean} visible
	     * @private
	     */
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error$$1) {
	                self_1.log_('Failed to get token: ' + error$$1);
	                if (!canceled_1) {
	                    if (util.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        warn(error$$1);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.interrupt = function (reason) {
	        log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.resume = function (reason) {
	        log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete)
	                    put.onComplete('disconnect');
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0)
	            this.outstandingPuts_ = [];
	    };
	    /**
	     * @param {!string} pathString
	     * @param {Array.<*>=} query
	     * @private
	     */
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete)
	            listen.onComplete('permission_denied');
	    };
	    /**
	     * @param {!string} pathString
	     * @param {!string} queryId
	     * @return {{queries:Array.<Query>, onComplete:function(string)}}
	     * @private
	     */
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens_[normalizedPathString] !== undefined) {
	            listen = this.listens_[normalizedPathString][queryId];
	            delete this.listens_[normalizedPathString][queryId];
	            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
	                delete this.listens_[normalizedPathString];
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body) {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var _this = this;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        // Puts depend on having received the corresponding data update from the server before they complete, so we must
	        // make sure to send listens before puts.
	        util.forEach(this.listens_, function (pathString, queries) {
	            util.forEach(queries, function (key, listenSpec) {
	                _this.sendListen_(listenSpec);
	            });
	        });
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i])
	                this.sendPut_(i);
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     * @private
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    /**
	     * @return {boolean}
	     * @private
	     */
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor.getInstance().currentlyOnline();
	        return util.isEmpty(this.interruptReasons_) && online;
	    };
	    /**
	     * @private
	     */
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     * @type {number}
	     * @private
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    tslib_1.__extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParamaters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParamaters, function (error$$1, result) {
	            var data = result;
	            if (error$$1 === 404) {
	                data = null;
	                error$$1 = null;
	            }
	            if (error$$1 === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error$$1) {
	                    status_1 = 'ok';
	                }
	                else if (error$$1 == 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error$$1;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                util.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo_
	     * @param {boolean} forceRestClient
	     * @param {!FirebaseApp} app
	     */
	    function Repo(repoInfo_, forceRestClient, app) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        // A list of data pieces and paths to be set when this client disconnects.
	        this.onDisconnect_ = new SparseSnapshotTree();
	        /**
	         * TODO: This should be @private but it's used by test_access.js and internal.js
	         * @type {?PersistentConnection}
	         */
	        this.persistentConnection_ = null;
	        /** @type {!AuthTokenProvider} */
	        var authTokenProvider = new AuthTokenProvider(app);
	        this.stats_ = StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || beingCrawled()) {
	            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
	        this.transactions_init_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return {string}  The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return {!string} The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     * @return {!Object}
	     */
	    Repo.prototype.generateServerValues = function () {
	        return generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     *
	     * @private
	     * @param {string} pathString
	     * @param {*} data
	     * @param {boolean} isMerge
	     * @param {?number} tag
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util.map(data, function (raw) {
	                    return nodeFromJSON$1(raw);
	                });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON$1(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util.map(data, function (raw) {
	                return nodeFromJSON$1(raw);
	            });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON$1(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    /**
	     * TODO: This should be @private but it's used by test_access.js and internal.js
	     * @param {?function(!string, *):*} callback
	     * @private
	     */
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    /**
	     * @param {!boolean} connectStatus
	     * @private
	     */
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    /**
	     * @param {!Object} updates
	     * @private
	     */
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        each(updates, function (value, key) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    /**
	     *
	     * @param {!string} pathString
	     * @param {*} value
	     * @private
	     */
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path('/.info/' + pathString);
	        var newNode = nodeFromJSON$1(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    /**
	     * @return {!number}
	     * @private
	     */
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} newVal
	     * @param {number|string|null} newPriority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        util.forEach(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            var newNodeUnresolved = nodeFromJSON$1(changedValue);
	            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            util.forEach(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     * @private
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
	    };
	    /**
	     * @param {!Path} path
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {*} priority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util.isEmpty(childrenToMerge)) {
	            log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                util.forEach(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON$1(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     */
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    /**
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration
	     */
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined')
	            return;
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_)
	                this.statsListener_ = new StatsListener(this.stats_);
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        util.forEach(stats, function (stat, value) {
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++)
	                stat += ' ';
	            console.log(stat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    /**
	     * @param {...*} var_args
	     * @private
	     */
	    Repo.prototype.log_ = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        log.apply(void 0, [prefix].concat(var_args));
	    };
	    /**
	     * @param {?function(?Error, *=)} callback
	     * @param {!string} status
	     * @param {?string=} errorReason
	     */
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            exceptionGuard(function () {
	                if (status == 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason)
	                        message += ': ' + errorReason;
	                    var error$$1 = new Error(message);
	                    error$$1.code = code;
	                    callback(error$$1);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database(this));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Repo;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util.assert(oldEventCache.numChildren() == this.limit_, '');
	        var newChildNamedNode = new NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Reference = /** @class */ (function (_super) {
	    tslib_1.__extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty())
	            return null;
	        else
	            return this.path.getBack();
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path)) {
	            if (this.path.getFront() === null)
	                validateRootPathString('Reference.child', 1, pathString, false);
	            else
	                validatePathString('Reference.child', 1, pathString, false);
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validateWritablePath('Reference.set', this.path);
	        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('Reference.setWithPriority', this.path);
	        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validateWritablePath('Reference.remove', this.path);
	        util.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validateWritablePath('Reference.transaction', this.path);
	        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        if (applyLocally === undefined)
	            applyLocally = true;
	        var deferred = new util.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error$$1, committed, snapshot) {
	            if (error$$1) {
	                deferred.reject(error$$1);
	            }
	            else {
	                deferred.resolve(new TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error$$1, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validateWritablePath('Reference.setPriority', this.path);
	        validatePriority('Reference.setPriority', 1, priority, false);
	        util.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validateWritablePath('Reference.push', this.path);
	        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validateWritablePath('Reference.onDisconnect', this.path);
	        return new OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Reference;
	}(Query));
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query.__referenceConstructor = Reference;
	SyncPoint.__referenceConstructor = Reference;
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
	        var child = this, next;
	        while ((next = path.getFront()) !== null) {
	            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        util.forEach(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst)
	            action(this);
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst)
	            action(this);
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null)
	                action(child);
	            else
	                child.forEachImmediateDescendantWithValue(action);
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null)
	            this.parent_.updateChild_(this.name_, this);
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus || (TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	Repo.prototype.transactions_init_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util.contains(newVal, '.priority')) {
	            priorityForNode = util.safeGet(newVal, '.priority');
	            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    else
	                        queue[i].status = TransactionStatus.RUN;
	                }
	            }
	            else {
	                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON$1(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    while ((front = path.getFront()) !== null &&
	        transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                // Already marked.  No action needed.
	            }
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].interrupt();
	            }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].resume();
	            }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.initializeApp().');
	        }
	        var parsedUrl = parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app) {
	        var appRepos = util.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo(repoInfo, this.useRestClient_, app);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo)) {
	            fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference(repo_, Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Database.prototype.ref = function (path) {
	        this.checkDeleted_('ref');
	        util.validateArgCount('database.ref', 0, 1, arguments.length);
	        if (path instanceof Reference) {
	            return this.refFromURL(path.toString());
	        }
	        return path !== undefined ? this.root_.child(path) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parseRepoInfo(url);
	        validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        }
	    };
	    return Database;
	}());
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                this.database.checkDeleted_('delete');
	                RepoManager.getInstance().deleteRepo(this.database.repo_);
	                this.database.repo_ = null;
	                this.database.root_ = null;
	                this.database.INTERNAL = null;
	                this.database = null;
	                return [2 /*return*/];
	            });
	        });
	    };
	    return DatabaseInternals;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	var forceLongPolling = function () {
	    WebSocketConnection.forceDisallow();
	    BrowserPollConnection.forceAllow();
	};
	var forceWebSockets = function () {
	    BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	var isWebSocketsAvailable = function () {
	    return WebSocketConnection['isAvailable']();
	};
	var setSecurityDebugCallback = function (ref, callback) {
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	var stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	var statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	var dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	var interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	var INTERNAL = /*#__PURE__*/Object.freeze({
	  forceLongPolling: forceLongPolling,
	  forceWebSockets: forceWebSockets,
	  isWebSocketsAvailable: isWebSocketsAvailable,
	  setSecurityDebugCallback: setSecurityDebugCallback,
	  stats: stats,
	  statsIncrementCounter: statsIncrementCounter,
	  dataUpdateCount: dataUpdateCount,
	  interceptServerData: interceptServerData
	});
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DataConnection = PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	var RealTimeConnection = Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	var hijackHash = function (newHash) {
	    var oldPut = PersistentConnection.prototype.put;
	    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
	        if (opt_hash !== undefined) {
	            opt_hash = newHash();
	        }
	        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
	    };
	    return function () {
	        PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	var ConnectionTarget = RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	var queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * @param {!Query} firebaseRef
	 * @return {!Object}
	 */
	var listens = function (firebaseRef) {
	    return firebaseRef.repo.persistentConnection_.listens_;
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	var forceRestClient = function (forceRestClient) {
	    RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	var TEST_ACCESS = /*#__PURE__*/Object.freeze({
	  DataConnection: DataConnection,
	  RealTimeConnection: RealTimeConnection,
	  hijackHash: hijackHash,
	  ConnectionTarget: ConnectionTarget,
	  queryIdentifier: queryIdentifier,
	  listens: listens,
	  forceRestClient: forceRestClient
	});
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ServerValue = Database.ServerValue;
	function registerDatabase(instance) {
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
	    // firebase.database namespace properties
	    {
	        Reference: Reference,
	        Query: Query,
	        Database: Database,
	        enableLogging: enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    }, null, true);
	    if (util.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	registerDatabase(firebase);
	
	exports.registerDatabase = registerDatabase;
	exports.Database = Database;
	exports.Query = Query;
	exports.Reference = Reference;
	exports.enableLogging = enableLogging;
	exports.ServerValue = ServerValue;
	exports.DataSnapshot = DataSnapshot;
	exports.OnDisconnect = OnDisconnect;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(13));
	var logger = __webpack_require__(44);
	var tslib_1 = __webpack_require__(20);
	var webchannelWrapper = __webpack_require__(146);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The semver (www.semver.org) version of the SDK. */
	var SDK_VERSION = firebase.SDK_VERSION;
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger.Logger('@firebase/firestore');
	var LogLevel;
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
	})(LogLevel || (LogLevel = {}));
	// Helper methods are needed because variables can't be exported as read/write
	function getLogLevel() {
	    if (logClient.logLevel === logger.LogLevel.DEBUG) {
	        return LogLevel.DEBUG;
	    }
	    else if (logClient.logLevel === logger.LogLevel.SILENT) {
	        return LogLevel.SILENT;
	    }
	    else {
	        return LogLevel.ERROR;
	    }
	}
	function setLogLevel(newLevel) {
	    /**
	     * Map the new log level to the associated Firebase Log Level
	     */
	    switch (newLevel) {
	        case LogLevel.DEBUG:
	            logClient.logLevel = logger.LogLevel.DEBUG;
	            break;
	        case LogLevel.ERROR:
	            logClient.logLevel = logger.LogLevel.ERROR;
	            break;
	        case LogLevel.SILENT:
	            logClient.logLevel = logger.LogLevel.SILENT;
	            break;
	        default:
	            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
	    }
	}
	function debug(tag, msg) {
	    var obj = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        obj[_i - 2] = arguments[_i];
	    }
	    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
	        var args = obj.map(argToString);
	        logClient.debug.apply(logClient, ["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg].concat(args));
	    }
	}
	function error(msg) {
	    var obj = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        obj[_i - 1] = arguments[_i];
	    }
	    if (logClient.logLevel <= logger.LogLevel.ERROR) {
	        var args = obj.map(argToString);
	        logClient.error.apply(logClient, ["Firestore (" + SDK_VERSION + "): " + msg].concat(args));
	    }
	}
	/**
	 * Converts an additional log parameter to a string representation.
	 */
	function argToString(obj) {
	    if (typeof obj === 'string') {
	        return obj;
	    }
	    else {
	        var platform = PlatformSupport.getPlatform();
	        try {
	            return platform.formatJSON(obj);
	        }
	        catch (e) {
	            // Converting to JSON failed, just log the object directly
	            return obj;
	        }
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Unconditionally fails, throwing an Error with the given message.
	 *
	 * Returns any so it can be used in expressions:
	 * @example
	 * let futureVar = fail('not implemented yet');
	 */
	function fail(failure) {
	    // Log the failure in addition to throw an exception, just in case the
	    // exception is swallowed.
	    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
	    error(message);
	    // NOTE: We don't use FirestoreError here because these are internal failures
	    // that cannot be handled by the user. (Also it would create a circular
	    // dependency between the error and assert modules which doesn't work.)
	    throw new Error(message);
	}
	/**
	 * Fails if the given assertion condition is false, throwing an Error with the
	 * given message if it did.
	 */
	function assert(assertion, message) {
	    if (!assertion) {
	        fail(message);
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides singleton helpers where setup code can inject a platform at runtime.
	 * setPlatform needs to be set before Firestore is used and must be set exactly
	 * once.
	 */
	var PlatformSupport = /** @class */ (function () {
	    function PlatformSupport() {
	    }
	    PlatformSupport.setPlatform = function (platform) {
	        if (PlatformSupport.platform) {
	            fail('Platform already defined');
	        }
	        PlatformSupport.platform = platform;
	    };
	    PlatformSupport.getPlatform = function () {
	        if (!PlatformSupport.platform) {
	            fail('Platform not set');
	        }
	        return PlatformSupport.platform;
	    };
	    return PlatformSupport;
	}());
	/**
	 * Returns the representation of an empty "proto" byte string for the
	 * platform.
	 */
	function emptyByteString() {
	    return PlatformSupport.getPlatform().emptyByteString;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
	//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
	var Code = {
	    // Causes are copied from:
	    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	    /** Not an error; returned on success. */
	    OK: 'ok',
	    /** The operation was cancelled (typically by the caller). */
	    CANCELLED: 'cancelled',
	    /** Unknown error or an error from a different error domain. */
	    UNKNOWN: 'unknown',
	    /**
	     * Client specified an invalid argument. Note that this differs from
	     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
	     * problematic regardless of the state of the system (e.g., a malformed file
	     * name).
	     */
	    INVALID_ARGUMENT: 'invalid-argument',
	    /**
	     * Deadline expired before operation could complete. For operations that
	     * change the state of the system, this error may be returned even if the
	     * operation has completed successfully. For example, a successful response
	     * from a server could have been delayed long enough for the deadline to
	     * expire.
	     */
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    /** Some requested entity (e.g., file or directory) was not found. */
	    NOT_FOUND: 'not-found',
	    /**
	     * Some entity that we attempted to create (e.g., file or directory) already
	     * exists.
	     */
	    ALREADY_EXISTS: 'already-exists',
	    /**
	     * The caller does not have permission to execute the specified operation.
	     * PERMISSION_DENIED must not be used for rejections caused by exhausting
	     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
	     * PERMISSION_DENIED must not be used if the caller can not be identified
	     * (use UNAUTHENTICATED instead for those errors).
	     */
	    PERMISSION_DENIED: 'permission-denied',
	    /**
	     * The request does not have valid authentication credentials for the
	     * operation.
	     */
	    UNAUTHENTICATED: 'unauthenticated',
	    /**
	     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
	     * entire file system is out of space.
	     */
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    /**
	     * Operation was rejected because the system is not in a state required for
	     * the operation's execution. For example, directory to be deleted may be
	     * non-empty, an rmdir operation is applied to a non-directory, etc.
	     *
	     * A litmus test that may help a service implementor in deciding
	     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
	     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
	     *  (b) Use ABORTED if the client should retry at a higher-level
	     *      (e.g., restarting a read-modify-write sequence).
	     *  (c) Use FAILED_PRECONDITION if the client should not retry until
	     *      the system state has been explicitly fixed. E.g., if an "rmdir"
	     *      fails because the directory is non-empty, FAILED_PRECONDITION
	     *      should be returned since the client should not retry unless
	     *      they have first fixed up the directory by deleting files from it.
	     *  (d) Use FAILED_PRECONDITION if the client performs conditional
	     *      REST Get/Update/Delete on a resource and the resource on the
	     *      server does not match the condition. E.g., conflicting
	     *      read-modify-write on the same resource.
	     */
	    FAILED_PRECONDITION: 'failed-precondition',
	    /**
	     * The operation was aborted, typically due to a concurrency issue like
	     * sequencer check failures, transaction aborts, etc.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    ABORTED: 'aborted',
	    /**
	     * Operation was attempted past the valid range. E.g., seeking or reading
	     * past end of file.
	     *
	     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
	     * if the system state changes. For example, a 32-bit file system will
	     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
	     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
	     * an offset past the current file size.
	     *
	     * There is a fair bit of overlap between FAILED_PRECONDITION and
	     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
	     * when it applies so that callers who are iterating through a space can
	     * easily look for an OUT_OF_RANGE error to detect when they are done.
	     */
	    OUT_OF_RANGE: 'out-of-range',
	    /** Operation is not implemented or not supported/enabled in this service. */
	    UNIMPLEMENTED: 'unimplemented',
	    /**
	     * Internal errors. Means some invariants expected by underlying System has
	     * been broken. If you see one of these errors, Something is very broken.
	     */
	    INTERNAL: 'internal',
	    /**
	     * The service is currently unavailable. This is a most likely a transient
	     * condition and may be corrected by retrying with a backoff.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    UNAVAILABLE: 'unavailable',
	    /** Unrecoverable data loss or corruption. */
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An error class used for Firestore-generated errors. Ideally we should be
	 * using FirebaseError, but integrating with it is overly arduous at the moment,
	 * so we define our own compatible error class (with a `name` of 'FirebaseError'
	 * and compatible `code` and `message` fields.)
	 */
	var FirestoreError = /** @class */ (function (_super) {
	    tslib_1.__extends(FirestoreError, _super);
	    function FirestoreError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.message = message;
	        _this.name = 'FirebaseError';
	        // HACK: We write a toString property directly because Error is not a real
	        // class and so inheritance does not work correctly. We could alternatively
	        // do the same "back-door inheritance" trick that FirebaseError does.
	        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
	        return _this;
	    }
	    return FirestoreError;
	}(Error));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper function to prevent instantiation through the constructor.
	 *
	 * This method creates a new constructor that throws when it's invoked.
	 * The prototype of that constructor is then set to the prototype of the hidden
	 * "class" to expose all the prototype methods and allow for instanceof
	 * checks.
	 *
	 * To also make all the static methods available, all properties of the
	 * original constructor are copied to the new constructor.
	 */
	function makeConstructorPrivate(cls, optionalMessage) {
	    function PublicConstructor() {
	        var error = 'This constructor is private.';
	        if (optionalMessage) {
	            error += ' ';
	            error += optionalMessage;
	        }
	        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
	    }
	    // Make sure instanceof checks work and all methods are exposed on the public
	    // constructor
	    PublicConstructor.prototype = cls.prototype;
	    // Copy any static methods/members
	    for (var staticProperty in cls) {
	        if (cls.hasOwnProperty(staticProperty)) {
	            PublicConstructor[staticProperty] = cls[staticProperty];
	        }
	    }
	    return PublicConstructor;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	/** Returns the given value if it's defined or the defaultValue otherwise. */
	function defaulted(value, defaultValue) {
	    return value !== undefined ? value : defaultValue;
	}
	function forEachNumber(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            var num = Number(key);
	            if (!isNaN(num)) {
	                fn(num, obj[key]);
	            }
	        }
	    }
	}
	function forEach(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	function isEmpty(obj) {
	    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	function shallowCopy(obj) {
	    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
	    var result = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            result[key] = obj[key];
	        }
	    }
	    return result;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Validates the invocation of functionName has the exact number of arguments.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateExactNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
	    if (args.length !== numberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
	            formatPlural(numberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the invocation of functionName has at least the provided number of
	 * arguments (but can have many more).
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
	    if (args.length < minNumberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
	            formatPlural(minNumberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the invocation of functionName has number of arguments between
	 * the values provided.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
	 */
	function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
	    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
	            (maxNumberOfArgs + " arguments, but was called with ") +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the provided argument is an array and has as least the expected
	 * number of elements.
	 */
	function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
	    if (!(value instanceof Array) || value.length < minNumberOfElements) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
	            'array with at least ' +
	            (formatPlural(minNumberOfElements, 'element') + "."));
	    }
	}
	/**
	 * Validates the provided positional argument has the native JavaScript type
	 * using typeof checks.
	 */
	function validateArgType(functionName, type, position, argument) {
	    validateType(functionName, type, ordinal(position) + " argument", argument);
	}
	/**
	 * Validates the provided argument has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateOptionalArgType(functionName, type, position, argument) {
	    if (argument !== undefined) {
	        validateArgType(functionName, type, position, argument);
	    }
	}
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks.
	 */
	function validateNamedType(functionName, type, optionName, argument) {
	    validateType(functionName, type, optionName + " option", argument);
	}
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateNamedOptionalType(functionName, type, optionName, argument) {
	    if (argument !== undefined) {
	        validateNamedType(functionName, type, optionName, argument);
	    }
	}
	function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
	    if (!(argument instanceof Array)) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
	            ("option to be an array, but it was: " + valueDescription(argument)));
	    }
	    for (var i = 0; i < argument.length; ++i) {
	        if (!validator(argument[i])) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
	                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
	                ("was: " + valueDescription(argument[i])));
	        }
	    }
	}
	function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
	    if (argument !== undefined) {
	        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
	    }
	}
	/**
	 * Validates that the provided named option equals one of the expected values.
	 */
	function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
	    var expectedDescription = [];
	    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
	        var val = expected_1[_i];
	        if (val === input) {
	            return;
	        }
	        expectedDescription.push(valueDescription(val));
	    }
	    var actualDescription = valueDescription(input);
	    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option \"" + optionName + "\". Acceptable values: " + expectedDescription.join(', '));
	}
	/**
	 * Validates that the provided named option equals one of the expected values or
	 * is undefined.
	 */
	function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
	    if (input !== undefined) {
	        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
	    }
	}
	/** Helper to validate the type of a provided input. */
	function validateType(functionName, type, inputName, input) {
	    if (typeof input !== type || (type === 'object' && !isPlainObject(input))) {
	        var description = valueDescription(input);
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
	            ("to be of type " + type + ", but it was: " + description));
	    }
	}
	/**
	 * Returns true if it's a non-null object without a custom prototype
	 * (i.e. excludes Array, Date, etc.).
	 */
	function isPlainObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        (Object.getPrototypeOf(input) === Object.prototype ||
	            Object.getPrototypeOf(input) === null));
	}
	/** Returns a string describing the type / value of the provided input. */
	function valueDescription(input) {
	    if (input === undefined) {
	        return 'undefined';
	    }
	    else if (input === null) {
	        return 'null';
	    }
	    else if (typeof input === 'string') {
	        if (input.length > 20) {
	            input = input.substring(0, 20) + "...";
	        }
	        return JSON.stringify(input);
	    }
	    else if (typeof input === 'number' || typeof input === 'boolean') {
	        return '' + input;
	    }
	    else if (typeof input === 'object') {
	        if (input instanceof Array) {
	            return 'an array';
	        }
	        else {
	            var customObjectName = tryGetCustomObjectType(input);
	            if (customObjectName) {
	                return "a custom " + customObjectName + " object";
	            }
	            else {
	                return 'an object';
	            }
	        }
	    }
	    else if (typeof input === 'function') {
	        return 'a function';
	    }
	    else {
	        return fail('Unknown wrong type: ' + typeof input);
	    }
	}
	/** Hacky method to try to get the constructor name for an object. */
	function tryGetCustomObjectType(input) {
	    if (input.constructor) {
	        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
	        var results = funcNameRegex.exec(input.constructor.toString());
	        if (results && results.length > 1) {
	            return results[1];
	        }
	    }
	    return null;
	}
	/** Validates the provided argument is defined. */
	function validateDefined(functionName, position, argument) {
	    if (argument === undefined) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
	            "argument, but it was undefined.");
	    }
	}
	/**
	 * Validates the provided positional argument is an object, and its keys and
	 * values match the expected keys and types provided in optionTypes.
	 */
	function validateOptionNames(functionName, options, optionNames) {
	    forEach(options, function (key, _) {
	        if (optionNames.indexOf(key) < 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
	                'Available options: ' +
	                optionNames.join(', '));
	        }
	    });
	}
	/**
	 * Helper method to throw an error that the provided argument did not pass
	 * an instanceof check.
	 */
	function invalidClassError(functionName, type, position, argument) {
	    var description = valueDescription(argument);
	    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
	        ("argument to be a " + type + ", but it was: " + description));
	}
	/** Converts a number to its english word representation */
	function ordinal(num) {
	    switch (num) {
	        case 1:
	            return 'first';
	        case 2:
	            return 'second';
	        case 3:
	            return 'third';
	        default:
	            return num + 'th';
	    }
	}
	/**
	 * Formats the given word as plural conditionally given the preceding number.
	 */
	function formatPlural(num, str) {
	    return num + " " + str + (num === 1 ? '' : 's');
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// tslint:disable-next-line:class-as-namespace
	var AutoId = /** @class */ (function () {
	    function AutoId() {
	    }
	    AutoId.newId = function () {
	        // Alphanumeric characters
	        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        var autoId = '';
	        for (var i = 0; i < 20; i++) {
	            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
	        return autoId;
	    };
	    return AutoId;
	}());
	function primitiveComparator(left, right) {
	    if (left < right)
	        return -1;
	    if (left > right)
	        return 1;
	    return 0;
	}
	/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
	function equals(left, right) {
	    if (left !== null && left !== undefined) {
	        return !!(right && left.isEqual(right));
	    }
	    else {
	        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
	        // smart enough.
	        return left === right;
	    }
	}
	/** Helper to compare arrays using isEqual(). */
	function arrayEquals(left, right) {
	    if (left.length !== right.length) {
	        return false;
	    }
	    for (var i = 0; i < left.length; i++) {
	        if (!left[i].isEqual(right[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * Returns the largest lexicographically smaller string of equal or smaller
	 * length. Returns an empty string if there is no such predecessor (if the input
	 * is empty).
	 *
	 * Strings returned from this method can be invalid UTF-16 but this is sufficent
	 * in use for indexeddb because that depends on lexicographical ordering but
	 * shouldn't be used elsewhere.
	 */
	function immediatePredecessor(s) {
	    // We can decrement the last character in the string and be done
	    // unless that character is 0 (0x0000), in which case we have to erase the
	    // last character.
	    var lastIndex = s.length - 1;
	    if (s.length === 0) {
	        // Special case the empty string.
	        return '';
	    }
	    else if (s.charAt(lastIndex) === '\0') {
	        return s.substring(0, lastIndex);
	    }
	    else {
	        return (s.substring(0, lastIndex) +
	            String.fromCharCode(s.charCodeAt(lastIndex) - 1));
	    }
	}
	/**
	 * Returns the immediate lexicographically-following string. This is useful to
	 * construct an inclusive range for indexeddb iterators.
	 */
	function immediateSuccessor(s) {
	    // Return the input string, with an additional NUL byte appended.
	    return s + '\0';
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Helper function to assert Uint8Array is available at runtime. */
	function assertUint8ArrayAvailable() {
	    if (typeof Uint8Array === 'undefined') {
	        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
	    }
	}
	/** Helper function to assert Base64 functions are available at runtime. */
	function assertBase64Available() {
	    if (!PlatformSupport.getPlatform().base64Available) {
	        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
	    }
	}
	/**
	 * Immutable class holding a blob (binary data).
	 * This class is directly exposed in the public API.
	 *
	 * Note that while you can't hide the constructor in JavaScript code, we are
	 * using the hack above to make sure no-one outside this module can call it.
	 */
	var Blob = /** @class */ (function () {
	    function Blob(binaryString) {
	        assertBase64Available();
	        this._binaryString = binaryString;
	    }
	    Blob.fromBase64String = function (base64) {
	        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
	        validateArgType('Blob.fromBase64String', 'string', 1, base64);
	        assertBase64Available();
	        try {
	            var binaryString = PlatformSupport.getPlatform().atob(base64);
	            return new Blob(binaryString);
	        }
	        catch (e) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
	        }
	    };
	    Blob.fromUint8Array = function (array) {
	        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
	        assertUint8ArrayAvailable();
	        if (!(array instanceof Uint8Array)) {
	            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
	        }
	        // We can't call array.map directly because it expects the return type to
	        // be a Uint8Array, whereas we can convert it to a regular array by invoking
	        // map on the Array prototype.
	        var binaryString = Array.prototype.map
	            .call(array, function (char) {
	            return String.fromCharCode(char);
	        })
	            .join('');
	        return new Blob(binaryString);
	    };
	    Blob.prototype.toBase64 = function () {
	        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
	        assertBase64Available();
	        return PlatformSupport.getPlatform().btoa(this._binaryString);
	    };
	    Blob.prototype.toUint8Array = function () {
	        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
	        assertUint8ArrayAvailable();
	        var buffer = new Uint8Array(this._binaryString.length);
	        for (var i = 0; i < this._binaryString.length; i++) {
	            buffer[i] = this._binaryString.charCodeAt(i);
	        }
	        return buffer;
	    };
	    Blob.prototype.toString = function () {
	        return 'Blob(base64: ' + this.toBase64() + ')';
	    };
	    Blob.prototype.isEqual = function (other) {
	        return this._binaryString === other._binaryString;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    Blob.prototype._compareTo = function (other) {
	        return primitiveComparator(this._binaryString, other._binaryString);
	    };
	    return Blob;
	}());
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting Blob on firebase.firestore.Blob and will be called Blob
	// publicly. Internally we still use Blob which has a type checked private
	// constructor. Note that Blob and PublicBlob can be used interchangeably in
	// instanceof checks.
	// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
	// we need to use Blob as type and export it too.
	// tslint:disable-next-line:variable-name We're treating this as a class name.
	var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Immutable class representing a geo point as latitude-longitude pair.
	 * This class is directly exposed in the public API, including its constructor.
	 */
	var GeoPoint = /** @class */ (function () {
	    function GeoPoint(latitude, longitude) {
	        validateExactNumberOfArgs('GeoPoint', arguments, 2);
	        validateArgType('GeoPoint', 'number', 1, latitude);
	        validateArgType('GeoPoint', 'number', 2, longitude);
	        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
	        }
	        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
	        }
	        this._lat = latitude;
	        this._long = longitude;
	    }
	    Object.defineProperty(GeoPoint.prototype, "latitude", {
	        /**
	         * Returns the latitude of this geo point, a number between -90 and 90.
	         */
	        get: function () {
	            return this._lat;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GeoPoint.prototype, "longitude", {
	        /**
	         * Returns the longitude of this geo point, a number between -180 and 180.
	         */
	        get: function () {
	            return this._long;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GeoPoint.prototype.isEqual = function (other) {
	        return this._lat === other._lat && this._long === other._long;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    GeoPoint.prototype._compareTo = function (other) {
	        return (primitiveComparator(this._lat, other._lat) ||
	            primitiveComparator(this._long, other._long));
	    };
	    return GeoPoint;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Timestamp = /** @class */ (function () {
	    function Timestamp(seconds, nanoseconds) {
	        this.seconds = seconds;
	        this.nanoseconds = nanoseconds;
	        if (nanoseconds < 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
	        }
	        if (nanoseconds >= 1e9) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
	        }
	        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
	        if (seconds < -62135596800) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
	        }
	        // This will break in the year 10,000.
	        if (seconds >= 253402300800) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
	        }
	    }
	    Timestamp.now = function () {
	        return Timestamp.fromMillis(Date.now());
	    };
	    Timestamp.fromDate = function (date) {
	        return Timestamp.fromMillis(date.getTime());
	    };
	    Timestamp.fromMillis = function (milliseconds) {
	        var seconds = Math.floor(milliseconds / 1000);
	        var nanos = (milliseconds - seconds * 1000) * 1e6;
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.prototype.toDate = function () {
	        return new Date(this.toMillis());
	    };
	    Timestamp.prototype.toMillis = function () {
	        return this.seconds * 1000 + this.nanoseconds / 1e6;
	    };
	    Timestamp.prototype._compareTo = function (other) {
	        if (this.seconds === other.seconds) {
	            return primitiveComparator(this.nanoseconds, other.nanoseconds);
	        }
	        return primitiveComparator(this.seconds, other.seconds);
	    };
	    Timestamp.prototype.isEqual = function (other) {
	        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
	    };
	    Timestamp.prototype.toString = function () {
	        return ('Timestamp(seconds=' +
	            this.seconds +
	            ', nanoseconds=' +
	            this.nanoseconds +
	            ')');
	    };
	    return Timestamp;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DatabaseInfo = /** @class */ (function () {
	    /**
	     * Constructs a DatabaseInfo using the provided host, databaseId and
	     * persistenceKey.
	     *
	     * @param databaseId The database to use.
	     * @param persistenceKey A unique identifier for this Firestore's local
	     * storage (used in conjunction with the databaseId).
	     * @param host The Firestore backend host to connect to.
	     * @param ssl Whether to use SSL when connecting.
	     */
	    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
	        this.databaseId = databaseId;
	        this.persistenceKey = persistenceKey;
	        this.host = host;
	        this.ssl = ssl;
	    }
	    return DatabaseInfo;
	}());
	/** The default database name for a project. */
	var DEFAULT_DATABASE_NAME = '(default)';
	/** Represents the database ID a Firestore client is associated with. */
	var DatabaseId = /** @class */ (function () {
	    function DatabaseId(projectId, database) {
	        this.projectId = projectId;
	        this.database = database ? database : DEFAULT_DATABASE_NAME;
	    }
	    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
	        get: function () {
	            return this.database === DEFAULT_DATABASE_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatabaseId.prototype.isEqual = function (other) {
	        return (other instanceof DatabaseId &&
	            other.projectId === this.projectId &&
	            other.database === this.database);
	    };
	    DatabaseId.prototype.compareTo = function (other) {
	        return (primitiveComparator(this.projectId, other.projectId) ||
	            primitiveComparator(this.database, other.database));
	    };
	    return DatabaseId;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DOCUMENT_KEY_NAME = '__name__';
	/**
	 * Path represents an ordered sequence of string segments.
	 */
	var Path = /** @class */ (function () {
	    function Path(segments, offset, length) {
	        this.init(segments, offset, length);
	    }
	    /**
	     * An initialization method that can be called from outside the constructor.
	     * We need this so that we can have a non-static construct method that returns
	     * the polymorphic `this` type.
	     */
	    Path.prototype.init = function (segments, offset, length) {
	        if (offset === undefined) {
	            offset = 0;
	        }
	        else if (offset > segments.length) {
	            fail('offset ' + offset + ' out of range ' + segments.length);
	        }
	        if (length === undefined) {
	            length = segments.length - offset;
	        }
	        else if (length > segments.length - offset) {
	            fail('length ' + length + ' out of range ' + (segments.length - offset));
	        }
	        this.segments = segments;
	        this.offset = offset;
	        this.len = length;
	    };
	    /**
	     * Constructs a new instance of Path using the same concrete type as `this`.
	     * We need this instead of using the normal constructor, because polymorphic
	     * `this` doesn't work on static methods.
	     */
	    Path.prototype.construct = function (segments, offset, length) {
	        var path = Object.create(Object.getPrototypeOf(this));
	        path.init(segments, offset, length);
	        return path;
	    };
	    Object.defineProperty(Path.prototype, "length", {
	        get: function () {
	            return this.len;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.isEqual = function (other) {
	        return Path.comparator(this, other) === 0;
	    };
	    Path.prototype.child = function (nameOrPath) {
	        var segments = this.segments.slice(this.offset, this.limit());
	        if (nameOrPath instanceof Path) {
	            nameOrPath.forEach(function (segment) {
	                segments.push(segment);
	            });
	        }
	        else if (typeof nameOrPath === 'string') {
	            segments.push(nameOrPath);
	        }
	        else {
	            fail('Unknown parameter type for Path.child(): ' + nameOrPath);
	        }
	        return this.construct(segments);
	    };
	    /** The index of one past the last segment of the path. */
	    Path.prototype.limit = function () {
	        return this.offset + this.length;
	    };
	    Path.prototype.popFirst = function (size) {
	        size = size === undefined ? 1 : size;
	        assert(this.length >= size, "Can't call popFirst() with less segments");
	        return this.construct(this.segments, this.offset + size, this.length - size);
	    };
	    Path.prototype.popLast = function () {
	        assert(!this.isEmpty(), "Can't call popLast() on empty path");
	        return this.construct(this.segments, this.offset, this.length - 1);
	    };
	    Path.prototype.firstSegment = function () {
	        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
	        return this.segments[this.offset];
	    };
	    Path.prototype.lastSegment = function () {
	        assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
	        return this.segments[this.limit() - 1];
	    };
	    Path.prototype.get = function (index) {
	        assert(index < this.length, 'Index out of range');
	        return this.segments[this.offset + index];
	    };
	    Path.prototype.isEmpty = function () {
	        return this.length === 0;
	    };
	    Path.prototype.isPrefixOf = function (other) {
	        if (other.length < this.length) {
	            return false;
	        }
	        for (var i = 0; i < this.length; i++) {
	            if (this.get(i) !== other.get(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Path.prototype.forEach = function (fn) {
	        for (var i = this.offset, end = this.limit(); i < end; i++) {
	            fn(this.segments[i]);
	        }
	    };
	    Path.prototype.toArray = function () {
	        return this.segments.slice(this.offset, this.limit());
	    };
	    Path.comparator = function (p1, p2) {
	        var len = Math.min(p1.length, p2.length);
	        for (var i = 0; i < len; i++) {
	            var left = p1.get(i);
	            var right = p2.get(i);
	            if (left < right)
	                return -1;
	            if (left > right)
	                return 1;
	        }
	        if (p1.length < p2.length)
	            return -1;
	        if (p1.length > p2.length)
	            return 1;
	        return 0;
	    };
	    return Path;
	}());
	/**
	 * A slash-separated path for navigating resources (documents and collections)
	 * within Firestore.
	 */
	var ResourcePath = /** @class */ (function (_super) {
	    tslib_1.__extends(ResourcePath, _super);
	    function ResourcePath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourcePath.prototype.canonicalString = function () {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        return this.toArray().join('/');
	    };
	    ResourcePath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Creates a resource path from the given slash-delimited string.
	     */
	    ResourcePath.fromString = function (path) {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        if (path.indexOf('//') >= 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
	        }
	        // We may still have an empty segment at the beginning or end if they had a
	        // leading or trailing slash (which we allow).
	        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
	        return new ResourcePath(segments);
	    };
	    ResourcePath.EMPTY_PATH = new ResourcePath([]);
	    return ResourcePath;
	}(Path));
	var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	/** A dot-separated path for navigating sub-objects within a document. */
	var FieldPath = /** @class */ (function (_super) {
	    tslib_1.__extends(FieldPath, _super);
	    function FieldPath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Returns true if the string could be used as a segment in a field path
	     * without escaping.
	     */
	    FieldPath.isValidIdentifier = function (segment) {
	        return identifierRegExp.test(segment);
	    };
	    FieldPath.prototype.canonicalString = function () {
	        return this.toArray()
	            .map(function (str) {
	            str = str.replace('\\', '\\\\').replace('`', '\\`');
	            if (!FieldPath.isValidIdentifier(str)) {
	                str = '`' + str + '`';
	            }
	            return str;
	        })
	            .join('.');
	    };
	    FieldPath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Returns true if this field references the key of a document.
	     */
	    FieldPath.prototype.isKeyField = function () {
	        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
	    };
	    /**
	     * The field designating the key of a document.
	     */
	    FieldPath.keyField = function () {
	        return new FieldPath([DOCUMENT_KEY_NAME]);
	    };
	    /**
	     * Parses a field string from the given server-formatted string.
	     *
	     * - Splitting the empty string is not allowed (for now at least).
	     * - Empty segments within the string (e.g. if there are two consecutive
	     *   separators) are not allowed.
	     *
	     * TODO(b/37244157): we should make this more strict. Right now, it allows
	     * non-identifier path components, even if they aren't escaped.
	     */
	    FieldPath.fromServerFormat = function (path) {
	        var segments = [];
	        var current = '';
	        var i = 0;
	        var addCurrentSegment = function () {
	            if (current.length === 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
	                    "with '.', end with '.', or contain '..'");
	            }
	            segments.push(current);
	            current = '';
	        };
	        var inBackticks = false;
	        while (i < path.length) {
	            var c = path[i];
	            if (c === '\\') {
	                if (i + 1 === path.length) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
	                }
	                var next = path[i + 1];
	                if (!(next === '\\' || next === '.' || next === '`')) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
	                }
	                current += next;
	                i += 2;
	            }
	            else if (c === '`') {
	                inBackticks = !inBackticks;
	                i++;
	            }
	            else if (c === '.' && !inBackticks) {
	                addCurrentSegment();
	                i++;
	            }
	            else {
	                current += c;
	                i++;
	            }
	        }
	        addCurrentSegment();
	        if (inBackticks) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
	        }
	        return new FieldPath(segments);
	    };
	    FieldPath.EMPTY_PATH = new FieldPath([]);
	    return FieldPath;
	}(Path));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DocumentKey = /** @class */ (function () {
	    function DocumentKey(path) {
	        this.path = path;
	        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
	            path.toArray().join('/'));
	    }
	    DocumentKey.prototype.isEqual = function (other) {
	        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
	    };
	    DocumentKey.prototype.toString = function () {
	        return this.path.toString();
	    };
	    DocumentKey.comparator = function (k1, k2) {
	        return ResourcePath.comparator(k1.path, k2.path);
	    };
	    DocumentKey.isDocumentKey = function (path) {
	        return path.length % 2 === 0;
	    };
	    /**
	     * Creates and returns a new document key with the given segments.
	     *
	     * @param path The segments of the path to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromSegments = function (segments) {
	        return new DocumentKey(new ResourcePath(segments.slice()));
	    };
	    /**
	     * Creates and returns a new document key using '/' to split the string into
	     * segments.
	     *
	     * @param path The slash-separated path string to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromPathString = function (path) {
	        return new DocumentKey(ResourcePath.fromString(path));
	    };
	    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
	    return DocumentKey;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Document = /** @class */ (function () {
	    function Document(key, version, data, options) {
	        this.key = key;
	        this.version = version;
	        this.data = data;
	        this.hasLocalMutations = options.hasLocalMutations;
	    }
	    Document.prototype.field = function (path) {
	        return this.data.field(path);
	    };
	    Document.prototype.fieldValue = function (path) {
	        var field = this.field(path);
	        return field ? field.value() : undefined;
	    };
	    Document.prototype.value = function () {
	        return this.data.value();
	    };
	    Document.prototype.isEqual = function (other) {
	        return (other instanceof Document &&
	            this.key.isEqual(other.key) &&
	            this.version.isEqual(other.version) &&
	            this.data.isEqual(other.data) &&
	            this.hasLocalMutations === other.hasLocalMutations);
	    };
	    Document.prototype.toString = function () {
	        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
	            ("{hasLocalMutations: " + this.hasLocalMutations + "})"));
	    };
	    Document.compareByKey = function (d1, d2) {
	        return DocumentKey.comparator(d1.key, d2.key);
	    };
	    Document.compareByField = function (field, d1, d2) {
	        var v1 = d1.field(field);
	        var v2 = d2.field(field);
	        if (v1 !== undefined && v2 !== undefined) {
	            return v1.compareTo(v2);
	        }
	        else {
	            return fail("Trying to compare documents on fields that don't exist");
	        }
	    };
	    return Document;
	}());
	/**
	 * A class representing a deleted document.
	 * Version is set to 0 if we don't point to any specific time, otherwise it
	 * denotes time we know it didn't exist at.
	 */
	var NoDocument = /** @class */ (function () {
	    function NoDocument(key, version) {
	        this.key = key;
	        this.version = version;
	    }
	    NoDocument.prototype.toString = function () {
	        return "NoDocument(" + this.key + ", " + this.version + ")";
	    };
	    NoDocument.prototype.isEqual = function (other) {
	        return (other &&
	            other.version.isEqual(this.version) &&
	            other.key.isEqual(this.key));
	    };
	    NoDocument.compareByKey = function (d1, d2) {
	        return DocumentKey.comparator(d1.key, d2.key);
	    };
	    return NoDocument;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// An immutable sorted map implementation, based on a Left-leaning Red-Black
	// tree.
	var SortedMap = /** @class */ (function () {
	    function SortedMap(comparator, root) {
	        this.comparator = comparator;
	        this.root = root ? root : LLRBNode.EMPTY;
	    }
	    // Returns a copy of the map, with the specified key/value added or replaced.
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator, this.root
	            .insert(key, value, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns a copy of the map, with the specified key removed.
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator, this.root
	            .remove(key, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns the value of the node with the given key, or null.
	    SortedMap.prototype.get = function (key) {
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    // Returns the index of the element in this sorted map, or -1 if it doesn't
	    // exist.
	    SortedMap.prototype.indexOf = function (key) {
	        // Number of nodes that were pruned when descending right
	        var prunedNodes = 0;
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return prunedNodes + node.left.size;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else {
	                // Count all nodes left of the node plus the node itself
	                prunedNodes += node.left.size + 1;
	                node = node.right;
	            }
	        }
	        // Node not found
	        return -1;
	    };
	    SortedMap.prototype.isEmpty = function () {
	        return this.root.isEmpty();
	    };
	    Object.defineProperty(SortedMap.prototype, "size", {
	        // Returns the total number of nodes in the map.
	        get: function () {
	            return this.root.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Returns the minimum key in the map.
	    SortedMap.prototype.minKey = function () {
	        return this.root.minKey();
	    };
	    // Returns the maximum key in the map.
	    SortedMap.prototype.maxKey = function () {
	        return this.root.maxKey();
	    };
	    // Traverses the map in key order and calls the specified action function
	    // for each key/value pair. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root.inorderTraversal(action);
	    };
	    SortedMap.prototype.forEach = function (fn) {
	        this.inorderTraversal(function (k, v) {
	            fn(k, v);
	            return false;
	        });
	    };
	    // Traverses the map in reverse key order and calls the specified action
	    // function for each key/value pair. If action returns true, traversal is
	    // aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root.reverseTraversal(action);
	    };
	    // Returns an iterator over the SortedMap.
	    SortedMap.prototype.getIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, false);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, false);
	    };
	    SortedMap.prototype.getReverseIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, true);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, true);
	    };
	    return SortedMap;
	}()); // end SortedMap
	// An iterator over an LLRBNode.
	var SortedMapIterator = /** @class */ (function () {
	    function SortedMapIterator(node, startKey, comparator, isReverse) {
	        this.isReverse = isReverse;
	        this.nodeStack = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack,
	                // but stop iterating;
	                this.nodeStack.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move
	                // to the next one
	                this.nodeStack.push(node);
	                if (this.isReverse) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
	        var node = this.nodeStack.pop();
	        var result = { key: node.key, value: node.value };
	        if (this.isReverse) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack.length === 0)
	            return null;
	        var node = this.nodeStack[this.nodeStack.length - 1];
	        return { key: node.key, value: node.value };
	    };
	    return SortedMapIterator;
	}()); // end SortedMapIterator
	// Represents a node in a Left-leaning Red-Black tree.
	var LLRBNode = /** @class */ (function () {
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left = left != null ? left : LLRBNode.EMPTY;
	        this.right = right != null ? right : LLRBNode.EMPTY;
	        this.size = this.left.size + 1 + this.right.size;
	    }
	    // Returns a copy of the current node, optionally replacing pieces of it.
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    // Traverses the tree in key order and calls the specified action function
	    // for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    // Traverses the tree in reverse key order and calls the specified action
	    // function for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    // Returns the minimum node in the tree.
	    LLRBNode.prototype.min = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min();
	        }
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.minKey = function () {
	        return this.min().key;
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    // Returns new tree, with the key/value added.
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.removeMin = function () {
	        if (this.left.isEmpty()) {
	            return LLRBNode.EMPTY;
	        }
	        var n = this;
	        if (!n.left.isRed() && !n.left.left.isRed())
	            n = n.moveRedLeft();
	        n = n.copy(null, null, null, n.left.removeMin(), null);
	        return n.fixUp();
	    };
	    // Returns new tree, with the specified item removed.
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var smallest;
	        var n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
	                n = n.moveRedLeft();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed())
	                n = n.rotateRight();
	            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
	                n = n.moveRedRight();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return LLRBNode.EMPTY;
	                }
	                else {
	                    smallest = n.right.min();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.isRed = function () {
	        return this.color;
	    };
	    // Returns new tree after performing any needed rotations.
	    LLRBNode.prototype.fixUp = function () {
	        var n = this;
	        if (n.right.isRed() && !n.left.isRed())
	            n = n.rotateLeft();
	        if (n.left.isRed() && n.left.left.isRed())
	            n = n.rotateRight();
	        if (n.left.isRed() && n.right.isRed())
	            n = n.colorFlip();
	        return n;
	    };
	    LLRBNode.prototype.moveRedLeft = function () {
	        var n = this.colorFlip();
	        if (n.right.left.isRed()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight());
	            n = n.rotateLeft();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.moveRedRight = function () {
	        var n = this.colorFlip();
	        if (n.left.left.isRed()) {
	            n = n.rotateRight();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.rotateLeft = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    LLRBNode.prototype.rotateRight = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    LLRBNode.prototype.colorFlip = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    // For testing.
	    LLRBNode.prototype.checkMaxDepth = function () {
	        var blackDepth = this.check();
	        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // In a balanced RB tree, the black-depth (number of black nodes) from root to
	    // leaves is equal on both sides.  This function verifies that or asserts.
	    LLRBNode.prototype.check = function () {
	        if (this.isRed() && this.left.isRed()) {
	            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed()) {
	            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check();
	        if (blackDepth !== this.right.check()) {
	            throw fail('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed() ? 0 : 1);
	        }
	    };
	    // tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
	    LLRBNode.EMPTY = null;
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}()); // end LLRBNode
	// Represents an empty node (a leaf node in the Red-Black Tree).
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	        this.size = 0;
	    }
	    // Returns a copy of the current node.
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    // Returns a copy of the tree, with the specified key/value added.
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value);
	    };
	    // Returns a copy of the tree, with the specified key removed.
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.isRed = function () {
	        return false;
	    };
	    // For testing.
	    LLRBEmptyNode.prototype.checkMaxDepth = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.check = function () {
	        return 0;
	    };
	    return LLRBEmptyNode;
	}()); // end LLRBEmptyNode
	LLRBNode.EMPTY = new LLRBEmptyNode();
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TypeOrder;
	(function (TypeOrder) {
	    // This order is defined by the backend.
	    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
	    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
	    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
	    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
	    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
	    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
	    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
	    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
	    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
	    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
	})(TypeOrder || (TypeOrder = {}));
	/** Defines the return value for pending server timestamps. */
	var ServerTimestampBehavior;
	(function (ServerTimestampBehavior) {
	    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
	    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
	    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
	})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
	/** Holds properties that define field value deserialization options. */
	var FieldValueOptions = /** @class */ (function () {
	    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
	        this.serverTimestampBehavior = serverTimestampBehavior;
	        this.timestampsInSnapshots = timestampsInSnapshots;
	    }
	    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
	        switch (options.serverTimestamps) {
	            case 'estimate':
	                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
	            case 'previous':
	                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
	            case 'none': // Fall-through intended.
	            case undefined:
	                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
	            default:
	                return fail('fromSnapshotOptions() called with invalid options.');
	        }
	    };
	    return FieldValueOptions;
	}());
	/**
	 * A field value represents a datatype as stored by Firestore.
	 */
	var FieldValue = /** @class */ (function () {
	    function FieldValue() {
	    }
	    FieldValue.prototype.toString = function () {
	        var val = this.value();
	        return val === null ? 'null' : val.toString();
	    };
	    FieldValue.prototype.defaultCompareTo = function (other) {
	        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
	        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
	        return cmp;
	    };
	    return FieldValue;
	}());
	var NullValue = /** @class */ (function (_super) {
	    tslib_1.__extends(NullValue, _super);
	    function NullValue() {
	        var _this = _super.call(this) || this;
	        _this.typeOrder = TypeOrder.NullValue;
	        // internalValue is unused but we add it to work around
	        // https://github.com/Microsoft/TypeScript/issues/15585
	        _this.internalValue = null;
	        return _this;
	    }
	    NullValue.prototype.value = function (options) {
	        return null;
	    };
	    NullValue.prototype.isEqual = function (other) {
	        return other instanceof NullValue;
	    };
	    NullValue.prototype.compareTo = function (other) {
	        if (other instanceof NullValue) {
	            return 0;
	        }
	        return this.defaultCompareTo(other);
	    };
	    NullValue.INSTANCE = new NullValue();
	    return NullValue;
	}(FieldValue));
	var BooleanValue = /** @class */ (function (_super) {
	    tslib_1.__extends(BooleanValue, _super);
	    function BooleanValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BooleanValue;
	        return _this;
	    }
	    BooleanValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BooleanValue.prototype.isEqual = function (other) {
	        return (other instanceof BooleanValue &&
	            this.internalValue === other.internalValue);
	    };
	    BooleanValue.prototype.compareTo = function (other) {
	        if (other instanceof BooleanValue) {
	            return primitiveComparator(this, other);
	        }
	        return this.defaultCompareTo(other);
	    };
	    BooleanValue.of = function (value) {
	        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
	    };
	    BooleanValue.TRUE = new BooleanValue(true);
	    BooleanValue.FALSE = new BooleanValue(false);
	    return BooleanValue;
	}(FieldValue));
	/** Base class for IntegerValue and DoubleValue. */
	var NumberValue = /** @class */ (function (_super) {
	    tslib_1.__extends(NumberValue, _super);
	    function NumberValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.NumberValue;
	        return _this;
	    }
	    NumberValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    NumberValue.prototype.compareTo = function (other) {
	        if (other instanceof NumberValue) {
	            return numericComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return NumberValue;
	}(FieldValue));
	/** Utility function to compare doubles (using Firestore semantics for NaN). */
	function numericComparator(left, right) {
	    if (left < right) {
	        return -1;
	    }
	    else if (left > right) {
	        return 1;
	    }
	    else if (left === right) {
	        return 0;
	    }
	    else {
	        // one or both are NaN.
	        if (isNaN(left)) {
	            return isNaN(right) ? 0 : -1;
	        }
	        else {
	            return 1;
	        }
	    }
	}
	/**
	 * Utility function to check numbers for equality using Firestore semantics
	 * (NaN === NaN, -0.0 !== 0.0).
	 */
	function numericEquals(left, right) {
	    // Implemented based on Object.is() polyfill from
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	    if (left === right) {
	        // +0 != -0
	        return left !== 0 || 1 / left === 1 / right;
	    }
	    else {
	        // NaN == NaN
	        return left !== left && right !== right;
	    }
	}
	var IntegerValue = /** @class */ (function (_super) {
	    tslib_1.__extends(IntegerValue, _super);
	    function IntegerValue(internalValue) {
	        return _super.call(this, internalValue) || this;
	    }
	    IntegerValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof IntegerValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    return IntegerValue;
	}(NumberValue));
	var DoubleValue = /** @class */ (function (_super) {
	    tslib_1.__extends(DoubleValue, _super);
	    function DoubleValue(internalValue) {
	        var _this = _super.call(this, internalValue) || this;
	        _this.internalValue = internalValue;
	        return _this;
	    }
	    DoubleValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof DoubleValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    DoubleValue.NAN = new DoubleValue(NaN);
	    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
	    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
	    return DoubleValue;
	}(NumberValue));
	// TODO(b/37267885): Add truncation support
	var StringValue = /** @class */ (function (_super) {
	    tslib_1.__extends(StringValue, _super);
	    function StringValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.StringValue;
	        return _this;
	    }
	    StringValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    StringValue.prototype.isEqual = function (other) {
	        return (other instanceof StringValue && this.internalValue === other.internalValue);
	    };
	    StringValue.prototype.compareTo = function (other) {
	        if (other instanceof StringValue) {
	            return primitiveComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return StringValue;
	}(FieldValue));
	var TimestampValue = /** @class */ (function (_super) {
	    tslib_1.__extends(TimestampValue, _super);
	    function TimestampValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    TimestampValue.prototype.value = function (options) {
	        if (options && options.timestampsInSnapshots) {
	            return this.internalValue;
	        }
	        else {
	            return this.internalValue.toDate();
	        }
	    };
	    TimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof TimestampValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    TimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof TimestampValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        else if (other instanceof ServerTimestampValue) {
	            // Concrete timestamps come before server timestamps.
	            return -1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    return TimestampValue;
	}(FieldValue));
	/**
	 * Represents a locally-applied ServerTimestamp.
	 *
	 * Notes:
	 * - ServerTimestampValue instances are created as the result of applying a
	 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
	 *   the local view of a document. Therefore they do not need to be parsed or
	 *   serialized.
	 * - When evaluated locally (e.g. for snapshot.data()), they by default
	 *   evaluate to `null`. This behavior can be configured by passing custom
	 *   FieldValueOptions to value().
	 * - With respect to other ServerTimestampValues, they sort by their
	 *   localWriteTime.
	 */
	var ServerTimestampValue = /** @class */ (function (_super) {
	    tslib_1.__extends(ServerTimestampValue, _super);
	    function ServerTimestampValue(localWriteTime, previousValue) {
	        var _this = _super.call(this) || this;
	        _this.localWriteTime = localWriteTime;
	        _this.previousValue = previousValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    ServerTimestampValue.prototype.value = function (options) {
	        if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
	            return new TimestampValue(this.localWriteTime).value(options);
	        }
	        else if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
	            return this.previousValue ? this.previousValue.value(options) : null;
	        }
	        else {
	            return null;
	        }
	    };
	    ServerTimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof ServerTimestampValue &&
	            this.localWriteTime.isEqual(other.localWriteTime));
	    };
	    ServerTimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof ServerTimestampValue) {
	            return this.localWriteTime._compareTo(other.localWriteTime);
	        }
	        else if (other instanceof TimestampValue) {
	            // Server timestamps come after all concrete timestamps.
	            return 1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ServerTimestampValue.prototype.toString = function () {
	        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
	    };
	    return ServerTimestampValue;
	}(FieldValue));
	var BlobValue = /** @class */ (function (_super) {
	    tslib_1.__extends(BlobValue, _super);
	    function BlobValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BlobValue;
	        return _this;
	    }
	    BlobValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BlobValue.prototype.isEqual = function (other) {
	        return (other instanceof BlobValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    BlobValue.prototype.compareTo = function (other) {
	        if (other instanceof BlobValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return BlobValue;
	}(FieldValue));
	var RefValue = /** @class */ (function (_super) {
	    tslib_1.__extends(RefValue, _super);
	    function RefValue(databaseId, key) {
	        var _this = _super.call(this) || this;
	        _this.databaseId = databaseId;
	        _this.key = key;
	        _this.typeOrder = TypeOrder.RefValue;
	        return _this;
	    }
	    RefValue.prototype.value = function (options) {
	        return this.key;
	    };
	    RefValue.prototype.isEqual = function (other) {
	        if (other instanceof RefValue) {
	            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
	        }
	        else {
	            return false;
	        }
	    };
	    RefValue.prototype.compareTo = function (other) {
	        if (other instanceof RefValue) {
	            var cmp = this.databaseId.compareTo(other.databaseId);
	            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return RefValue;
	}(FieldValue));
	var GeoPointValue = /** @class */ (function (_super) {
	    tslib_1.__extends(GeoPointValue, _super);
	    function GeoPointValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.GeoPointValue;
	        return _this;
	    }
	    GeoPointValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    GeoPointValue.prototype.isEqual = function (other) {
	        return (other instanceof GeoPointValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    GeoPointValue.prototype.compareTo = function (other) {
	        if (other instanceof GeoPointValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return GeoPointValue;
	}(FieldValue));
	var ObjectValue = /** @class */ (function (_super) {
	    tslib_1.__extends(ObjectValue, _super);
	    function ObjectValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ObjectValue;
	        return _this;
	    }
	    ObjectValue.prototype.value = function (options) {
	        var result = {};
	        this.internalValue.inorderTraversal(function (key, val) {
	            result[key] = val.value(options);
	        });
	        return result;
	    };
	    ObjectValue.prototype.forEach = function (action) {
	        this.internalValue.inorderTraversal(action);
	    };
	    ObjectValue.prototype.isEqual = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
	                    return false;
	                }
	            }
	            return !it1.hasNext() && !it2.hasNext();
	        }
	        return false;
	    };
	    ObjectValue.prototype.compareTo = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                var cmp = primitiveComparator(next1.key, next2.key) ||
	                    next1.value.compareTo(next2.value);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            // Only equal if both iterators are exhausted
	            return primitiveComparator(it1.hasNext(), it2.hasNext());
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ObjectValue.prototype.set = function (path, to) {
	        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return this.setChild(path.firstSegment(), to);
	        }
	        else {
	            var child = this.child(path.firstSegment());
	            if (!(child instanceof ObjectValue)) {
	                child = ObjectValue.EMPTY;
	            }
	            var newChild = child.set(path.popFirst(), to);
	            return this.setChild(path.firstSegment(), newChild);
	        }
	    };
	    ObjectValue.prototype.delete = function (path) {
	        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
	        }
	        else {
	            // nested field
	            var child = this.child(path.firstSegment());
	            if (child instanceof ObjectValue) {
	                var newChild = child.delete(path.popFirst());
	                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
	            }
	            else {
	                // Don't actually change a primitive value to an object for a delete
	                return this;
	            }
	        }
	    };
	    ObjectValue.prototype.contains = function (path) {
	        return this.field(path) !== undefined;
	    };
	    ObjectValue.prototype.field = function (path) {
	        assert(!path.isEmpty(), "Can't get field of empty path");
	        var field = this;
	        path.forEach(function (pathSegment) {
	            if (field instanceof ObjectValue) {
	                field = field.internalValue.get(pathSegment) || undefined;
	            }
	            else {
	                field = undefined;
	            }
	        });
	        return field;
	    };
	    ObjectValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    ObjectValue.prototype.child = function (childName) {
	        return this.internalValue.get(childName) || undefined;
	    };
	    ObjectValue.prototype.setChild = function (childName, value) {
	        return new ObjectValue(this.internalValue.insert(childName, value));
	    };
	    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
	    return ObjectValue;
	}(FieldValue));
	var ArrayValue = /** @class */ (function (_super) {
	    tslib_1.__extends(ArrayValue, _super);
	    function ArrayValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ArrayValue;
	        return _this;
	    }
	    ArrayValue.prototype.value = function (options) {
	        return this.internalValue.map(function (v) { return v.value(options); });
	    };
	    ArrayValue.prototype.forEach = function (action) {
	        this.internalValue.forEach(action);
	    };
	    ArrayValue.prototype.isEqual = function (other) {
	        if (other instanceof ArrayValue) {
	            if (this.internalValue.length !== other.internalValue.length) {
	                return false;
	            }
	            for (var i = 0; i < this.internalValue.length; i++) {
	                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        return false;
	    };
	    ArrayValue.prototype.compareTo = function (other) {
	        if (other instanceof ArrayValue) {
	            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
	            for (var i = 0; i < minLength; i++) {
	                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            return primitiveComparator(this.internalValue.length, other.internalValue.length);
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ArrayValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    return ArrayValue;
	}(FieldValue));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Untyped Number alias we can use to check for ES6 methods / properties.
	// tslint:disable-next-line:no-any variable-name
	var NumberAsAny = Number;
	/**
	 * Minimum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
	/**
	 * Maximum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * Returns whether an number is an integer, uses native implementation if
	 * available.
	 * Added to not rely on ES6 features.
	 * @param value The value to test for being an integer
	 */
	var isInteger = NumberAsAny.isInteger ||
	    (function (value) {
	        return typeof value === 'number' &&
	            isFinite(value) &&
	            Math.floor(value) === value;
	    });
	/**
	 * Returns whether a variable is either undefined or null.
	 */
	function isNullOrUndefined(value) {
	    return value === null || value === undefined;
	}
	/**
	 * Returns whether a value is an integer and in the safe integer range
	 * @param value The value to test for being an integer and in the safe range
	 */
	function isSafeInteger(value) {
	    return (isInteger(value) &&
	        value <= MAX_SAFE_INTEGER &&
	        value >= MIN_SAFE_INTEGER);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Query = /** @class */ (function () {
	    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
	        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
	        if (filters === void 0) { filters = []; }
	        if (limit === void 0) { limit = null; }
	        if (startAt === void 0) { startAt = null; }
	        if (endAt === void 0) { endAt = null; }
	        this.path = path;
	        this.explicitOrderBy = explicitOrderBy;
	        this.filters = filters;
	        this.limit = limit;
	        this.startAt = startAt;
	        this.endAt = endAt;
	        this.memoizedCanonicalId = null;
	        this.memoizedOrderBy = null;
	        if (this.startAt) {
	            this.assertValidBound(this.startAt);
	        }
	        if (this.endAt) {
	            this.assertValidBound(this.endAt);
	        }
	    }
	    Query.atPath = function (path) {
	        return new Query(path);
	    };
	    Object.defineProperty(Query.prototype, "orderBy", {
	        get: function () {
	            if (this.memoizedOrderBy === null) {
	                var inequalityField = this.getInequalityFilterField();
	                var firstOrderByField = this.getFirstOrderByField();
	                if (inequalityField !== null && firstOrderByField === null) {
	                    // In order to implicitly add key ordering, we must also add the
	                    // inequality filter field for it to be a valid query.
	                    // Note that the default inequality field and key ordering is ascending.
	                    if (inequalityField.isKeyField()) {
	                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
	                    }
	                    else {
	                        this.memoizedOrderBy = [
	                            new OrderBy(inequalityField),
	                            KEY_ORDERING_ASC
	                        ];
	                    }
	                }
	                else {
	                    assert(inequalityField === null ||
	                        (firstOrderByField !== null &&
	                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
	                    this.memoizedOrderBy = [];
	                    var foundKeyOrdering = false;
	                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	                        var orderBy = _a[_i];
	                        this.memoizedOrderBy.push(orderBy);
	                        if (orderBy.field.isKeyField()) {
	                            foundKeyOrdering = true;
	                        }
	                    }
	                    if (!foundKeyOrdering) {
	                        // The order of the implicit key ordering always matches the last
	                        // explicit order by
	                        var lastDirection = this.explicitOrderBy.length > 0
	                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
	                            : Direction.ASCENDING;
	                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
	                            ? KEY_ORDERING_ASC
	                            : KEY_ORDERING_DESC);
	                    }
	                }
	            }
	            return this.memoizedOrderBy;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Query.prototype.addFilter = function (filter) {
	        assert(this.getInequalityFilterField() == null ||
	            !(filter instanceof RelationFilter) ||
	            !filter.isInequality() ||
	            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
	        assert(!DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
	        var newFilters = this.filters.concat([filter]);
	        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.addOrderBy = function (orderBy) {
	        assert(!DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
	        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
	        // TODO(dimond): validate that orderBy does not list the same key twice.
	        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
	        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withLimit = function (limit) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withStartAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
	    };
	    Query.prototype.withEndAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
	    };
	    // TODO(b/29183165): This is used to get a unique string from a query to, for
	    // example, use as a dictionary key, but the implementation is subject to
	    // collisions. Make it collision-free.
	    Query.prototype.canonicalId = function () {
	        if (this.memoizedCanonicalId === null) {
	            var canonicalId = this.path.canonicalString();
	            canonicalId += '|f:';
	            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	                var filter = _a[_i];
	                canonicalId += filter.canonicalId();
	                canonicalId += ',';
	            }
	            canonicalId += '|ob:';
	            // TODO(dimond): make this collision resistant
	            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
	                var orderBy = _c[_b];
	                canonicalId += orderBy.canonicalId();
	                canonicalId += ',';
	            }
	            if (!isNullOrUndefined(this.limit)) {
	                canonicalId += '|l:';
	                canonicalId += this.limit;
	            }
	            if (this.startAt) {
	                canonicalId += '|lb:';
	                canonicalId += this.startAt.canonicalId();
	            }
	            if (this.endAt) {
	                canonicalId += '|ub:';
	                canonicalId += this.endAt.canonicalId();
	            }
	            this.memoizedCanonicalId = canonicalId;
	        }
	        return this.memoizedCanonicalId;
	    };
	    Query.prototype.toString = function () {
	        var str = 'Query(' + this.path.canonicalString();
	        if (this.filters.length > 0) {
	            str += ", filters: [" + this.filters.join(', ') + "]";
	        }
	        if (!isNullOrUndefined(this.limit)) {
	            str += ', limit: ' + this.limit;
	        }
	        if (this.explicitOrderBy.length > 0) {
	            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
	        }
	        if (this.startAt) {
	            str += ', startAt: ' + this.startAt.canonicalId();
	        }
	        if (this.endAt) {
	            str += ', endAt: ' + this.endAt.canonicalId();
	        }
	        return str + ')';
	    };
	    Query.prototype.isEqual = function (other) {
	        if (this.limit !== other.limit) {
	            return false;
	        }
	        if (this.orderBy.length !== other.orderBy.length) {
	            return false;
	        }
	        for (var i = 0; i < this.orderBy.length; i++) {
	            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
	                return false;
	            }
	        }
	        if (this.filters.length !== other.filters.length) {
	            return false;
	        }
	        for (var i = 0; i < this.filters.length; i++) {
	            if (!this.filters[i].isEqual(other.filters[i])) {
	                return false;
	            }
	        }
	        if (!this.path.isEqual(other.path)) {
	            return false;
	        }
	        if (this.startAt !== null
	            ? !this.startAt.isEqual(other.startAt)
	            : other.startAt !== null) {
	            return false;
	        }
	        return this.endAt !== null
	            ? this.endAt.isEqual(other.endAt)
	            : other.endAt === null;
	    };
	    Query.prototype.docComparator = function (d1, d2) {
	        var comparedOnKeyField = false;
	        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            var comp = orderBy.compare(d1, d2);
	            if (comp !== 0)
	                return comp;
	            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
	        }
	        // Assert that we actually compared by key
	        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
	        return 0;
	    };
	    Query.prototype.matches = function (doc) {
	        return (this.matchesAncestor(doc) &&
	            this.matchesOrderBy(doc) &&
	            this.matchesFilters(doc) &&
	            this.matchesBounds(doc));
	    };
	    Query.prototype.hasLimit = function () {
	        return !isNullOrUndefined(this.limit);
	    };
	    Query.prototype.getFirstOrderByField = function () {
	        return this.explicitOrderBy.length > 0
	            ? this.explicitOrderBy[0].field
	            : null;
	    };
	    Query.prototype.getInequalityFilterField = function () {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (filter instanceof RelationFilter && filter.isInequality()) {
	                return filter.field;
	            }
	        }
	        return null;
	    };
	    Query.prototype.hasArrayContainsFilter = function () {
	        return (this.filters.find(function (filter) {
	            return filter instanceof RelationFilter &&
	                filter.op === RelationOp.ARRAY_CONTAINS;
	        }) !== undefined);
	    };
	    Query.prototype.isDocumentQuery = function () {
	        return DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
	    };
	    Query.prototype.matchesAncestor = function (doc) {
	        var docPath = doc.key.path;
	        if (DocumentKey.isDocumentKey(this.path)) {
	            // exact match for document queries
	            return this.path.isEqual(docPath);
	        }
	        else {
	            // shallow ancestor queries by default
	            return (this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1);
	        }
	    };
	    /**
	     * A document must have a value for every ordering clause in order to show up
	     * in the results.
	     */
	    Query.prototype.matchesOrderBy = function (doc) {
	        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            // order by key always matches
	            if (!orderBy.field.isKeyField() &&
	                doc.field(orderBy.field) === undefined) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Query.prototype.matchesFilters = function (doc) {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (!filter.matches(doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Makes sure a document is within the bounds, if provided.
	     */
	    Query.prototype.matchesBounds = function (doc) {
	        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        return true;
	    };
	    Query.prototype.assertValidBound = function (bound) {
	        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
	    };
	    return Query;
	}());
	var RelationOp = /** @class */ (function () {
	    function RelationOp(name) {
	        this.name = name;
	    }
	    RelationOp.fromString = function (op) {
	        switch (op) {
	            case '<':
	                return RelationOp.LESS_THAN;
	            case '<=':
	                return RelationOp.LESS_THAN_OR_EQUAL;
	            case '==':
	                return RelationOp.EQUAL;
	            case '>=':
	                return RelationOp.GREATER_THAN_OR_EQUAL;
	            case '>':
	                return RelationOp.GREATER_THAN;
	            case 'array-contains':
	                return RelationOp.ARRAY_CONTAINS;
	            default:
	                return fail('Unknown relation: ' + op);
	        }
	    };
	    RelationOp.prototype.toString = function () {
	        return this.name;
	    };
	    RelationOp.prototype.isEqual = function (other) {
	        return this.name === other.name;
	    };
	    RelationOp.LESS_THAN = new RelationOp('<');
	    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
	    RelationOp.EQUAL = new RelationOp('==');
	    RelationOp.GREATER_THAN = new RelationOp('>');
	    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
	    RelationOp.ARRAY_CONTAINS = new RelationOp('array-contains');
	    return RelationOp;
	}());
	var RelationFilter = /** @class */ (function () {
	    function RelationFilter(field, op, value) {
	        this.field = field;
	        this.op = op;
	        this.value = value;
	    }
	    RelationFilter.prototype.matches = function (doc) {
	        if (this.field.isKeyField()) {
	            assert(this.value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
	            assert(this.op !== RelationOp.ARRAY_CONTAINS, "array-contains queries don't make sense on document keys.");
	            var refValue = this.value;
	            var comparison = DocumentKey.comparator(doc.key, refValue.key);
	            return this.matchesComparison(comparison);
	        }
	        else {
	            var val = doc.field(this.field);
	            return val !== undefined && this.matchesValue(val);
	        }
	    };
	    RelationFilter.prototype.matchesValue = function (value) {
	        var _this = this;
	        if (this.op === RelationOp.ARRAY_CONTAINS) {
	            return (value instanceof ArrayValue &&
	                value.internalValue.find(function (element) { return element.isEqual(_this.value); }) !==
	                    undefined);
	        }
	        else {
	            // Only compare types with matching backend order (such as double and int).
	            return (this.value.typeOrder === value.typeOrder &&
	                this.matchesComparison(value.compareTo(this.value)));
	        }
	    };
	    RelationFilter.prototype.matchesComparison = function (comparison) {
	        switch (this.op) {
	            case RelationOp.LESS_THAN:
	                return comparison < 0;
	            case RelationOp.LESS_THAN_OR_EQUAL:
	                return comparison <= 0;
	            case RelationOp.EQUAL:
	                return comparison === 0;
	            case RelationOp.GREATER_THAN:
	                return comparison > 0;
	            case RelationOp.GREATER_THAN_OR_EQUAL:
	                return comparison >= 0;
	            default:
	                return fail('Unknown relation op' + this.op);
	        }
	    };
	    RelationFilter.prototype.isInequality = function () {
	        return (this.op !== RelationOp.EQUAL && this.op !== RelationOp.ARRAY_CONTAINS);
	    };
	    RelationFilter.prototype.canonicalId = function () {
	        // TODO(b/29183165): Technically, this won't be unique if two values have
	        // the same description, such as the int 3 and the string "3". So we should
	        // add the types in here somehow, too.
	        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
	    };
	    RelationFilter.prototype.isEqual = function (other) {
	        if (other instanceof RelationFilter) {
	            return (this.op.isEqual(other.op) &&
	                this.field.isEqual(other.field) &&
	                this.value.isEqual(other.value));
	        }
	        else {
	            return false;
	        }
	    };
	    RelationFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
	    };
	    return RelationFilter;
	}());
	/**
	 * Filter that matches 'null' values.
	 */
	var NullFilter = /** @class */ (function () {
	    function NullFilter(field) {
	        this.field = field;
	    }
	    NullFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field);
	        return val !== undefined && val.value() === null;
	    };
	    NullFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS null';
	    };
	    NullFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS null";
	    };
	    NullFilter.prototype.isEqual = function (other) {
	        if (other instanceof NullFilter) {
	            return this.field.isEqual(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NullFilter;
	}());
	/**
	 * Filter that matches 'NaN' values.
	 */
	var NanFilter = /** @class */ (function () {
	    function NanFilter(field) {
	        this.field = field;
	    }
	    NanFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field).value();
	        return typeof val === 'number' && isNaN(val);
	    };
	    NanFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS NaN';
	    };
	    NanFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS NaN";
	    };
	    NanFilter.prototype.isEqual = function (other) {
	        if (other instanceof NanFilter) {
	            return this.field.isEqual(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NanFilter;
	}());
	/**
	 * Creates a filter based on the provided arguments.
	 */
	function fieldFilter(field, op, value) {
	    if (value.isEqual(NullValue.INSTANCE)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on null.');
	        }
	        return new NullFilter(field);
	    }
	    else if (value.isEqual(DoubleValue.NAN)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on NaN.');
	        }
	        return new NanFilter(field);
	    }
	    else {
	        return new RelationFilter(field, op, value);
	    }
	}
	/**
	 * The direction of sorting in an order by.
	 */
	var Direction = /** @class */ (function () {
	    function Direction(name) {
	        this.name = name;
	    }
	    Direction.prototype.toString = function () {
	        return this.name;
	    };
	    Direction.ASCENDING = new Direction('asc');
	    Direction.DESCENDING = new Direction('desc');
	    return Direction;
	}());
	/**
	 * Represents a bound of a query.
	 *
	 * The bound is specified with the given components representing a position and
	 * whether it's just before or just after the position (relative to whatever the
	 * query order is).
	 *
	 * The position represents a logical index position for a query. It's a prefix
	 * of values for the (potentially implicit) order by clauses of a query.
	 *
	 * Bound provides a function to determine whether a document comes before or
	 * after a bound. This is influenced by whether the position is just before or
	 * just after the provided values.
	 */
	var Bound = /** @class */ (function () {
	    function Bound(position, before) {
	        this.position = position;
	        this.before = before;
	    }
	    Bound.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        var canonicalId = this.before ? 'b:' : 'a:';
	        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
	            var component = _a[_i];
	            canonicalId += component.toString();
	        }
	        return canonicalId;
	    };
	    /**
	     * Returns true if a document sorts before a bound using the provided sort
	     * order.
	     */
	    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
	        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
	        var comparison = 0;
	        for (var i = 0; i < this.position.length; i++) {
	            var orderByComponent = orderBy[i];
	            var component = this.position[i];
	            if (orderByComponent.field.isKeyField()) {
	                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
	                comparison = DocumentKey.comparator(component.key, doc.key);
	            }
	            else {
	                var docValue = doc.field(orderByComponent.field);
	                assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
	                comparison = component.compareTo(docValue);
	            }
	            if (orderByComponent.dir === Direction.DESCENDING) {
	                comparison = comparison * -1;
	            }
	            if (comparison !== 0) {
	                break;
	            }
	        }
	        return this.before ? comparison <= 0 : comparison < 0;
	    };
	    Bound.prototype.isEqual = function (other) {
	        if (other === null) {
	            return false;
	        }
	        if (this.before !== other.before ||
	            this.position.length !== other.position.length) {
	            return false;
	        }
	        for (var i = 0; i < this.position.length; i++) {
	            var thisPosition = this.position[i];
	            var otherPosition = other.position[i];
	            return thisPosition.isEqual(otherPosition);
	        }
	        return true;
	    };
	    return Bound;
	}());
	/**
	 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
	 */
	var OrderBy = /** @class */ (function () {
	    function OrderBy(field, dir) {
	        this.field = field;
	        if (dir === undefined) {
	            dir = Direction.ASCENDING;
	        }
	        this.dir = dir;
	        this.isKeyOrderBy = field.isKeyField();
	    }
	    OrderBy.prototype.compare = function (d1, d2) {
	        var comparison = this.isKeyOrderBy
	            ? Document.compareByKey(d1, d2)
	            : Document.compareByField(this.field, d1, d2);
	        switch (this.dir) {
	            case Direction.ASCENDING:
	                return comparison;
	            case Direction.DESCENDING:
	                return -1 * comparison;
	            default:
	                return fail('Unknown direction: ' + this.dir);
	        }
	    };
	    OrderBy.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        return this.field.canonicalString() + this.dir.toString();
	    };
	    OrderBy.prototype.toString = function () {
	        return this.field.canonicalString() + " (" + this.dir + ")";
	    };
	    OrderBy.prototype.isEqual = function (other) {
	        return this.dir === other.dir && this.field.isEqual(other.field);
	    };
	    return OrderBy;
	}());
	var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
	var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A version of a document in Firestore. This corresponds to the version
	 * timestamp, such as update_time or read_time.
	 */
	var SnapshotVersion = /** @class */ (function () {
	    function SnapshotVersion(timestamp) {
	        this.timestamp = timestamp;
	    }
	    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
	    // delete this constructor and use a timestamp-backed version everywhere.
	    SnapshotVersion.fromMicroseconds = function (value) {
	        var seconds = Math.floor(value / 1e6);
	        var nanos = (value % 1e6) * 1e3;
	        return new SnapshotVersion(new Timestamp(seconds, nanos));
	    };
	    SnapshotVersion.fromTimestamp = function (value) {
	        return new SnapshotVersion(value);
	    };
	    SnapshotVersion.forDeletedDoc = function () {
	        return SnapshotVersion.MIN;
	    };
	    SnapshotVersion.prototype.compareTo = function (other) {
	        return this.timestamp._compareTo(other.timestamp);
	    };
	    SnapshotVersion.prototype.isEqual = function (other) {
	        return this.timestamp.isEqual(other.timestamp);
	    };
	    /** Returns a number representation of the version for use in spec tests. */
	    SnapshotVersion.prototype.toMicroseconds = function () {
	        // Convert to microseconds.
	        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
	    };
	    SnapshotVersion.prototype.toString = function () {
	        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
	    };
	    SnapshotVersion.prototype.toTimestamp = function () {
	        return this.timestamp;
	    };
	    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
	    return SnapshotVersion;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** An enumeration of the different purposes we have for queries. */
	var QueryPurpose;
	(function (QueryPurpose) {
	    /** A regular, normal query. */
	    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
	    /**
	     * The query was used to refill a query after an existence filter mismatch.
	     */
	    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
	    /** The query was used to resolve a limbo document. */
	    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
	})(QueryPurpose || (QueryPurpose = {}));
	/**
	 * An immutable set of metadata that the local store tracks for each query.
	 */
	var QueryData = /** @class */ (function () {
	    function QueryData(
	    /** The query being listened to. */
	    query, 
	    /**
	     * The target ID to which the query corresponds; Assigned by the
	     * LocalStore for user listens and by the SyncEngine for limbo watches.
	     */
	    targetId, 
	    /** The purpose of the query. */
	    purpose, 
	    /** The latest snapshot version seen for this target. */
	    snapshotVersion, 
	    /**
	     * An opaque, server-assigned token that allows watching a query to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the query. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */
	    resumeToken) {
	        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
	        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
	        this.query = query;
	        this.targetId = targetId;
	        this.purpose = purpose;
	        this.snapshotVersion = snapshotVersion;
	        this.resumeToken = resumeToken;
	    }
	    /**
	     * Creates a new query data instance with an updated snapshot version and
	     * resume token.
	     */
	    QueryData.prototype.update = function (updated) {
	        return new QueryData(this.query, this.targetId, this.purpose, updated.snapshotVersion, updated.resumeToken);
	    };
	    QueryData.prototype.isEqual = function (other) {
	        return (this.targetId === other.targetId &&
	            this.purpose === other.purpose &&
	            this.snapshotVersion.isEqual(other.snapshotVersion) &&
	            this.resumeToken === other.resumeToken &&
	            this.query.isEqual(other.query));
	    };
	    return QueryData;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides a set of fields that can be used to partially patch a document.
	 * FieldMask is used in conjunction with ObjectValue.
	 * Examples:
	 *   foo - Overwrites foo entirely with the provided value. If foo is not
	 *         present in the companion ObjectValue, the field is deleted.
	 *   foo.bar - Overwrites only the field bar of the object foo.
	 *             If foo is not an object, foo is replaced with an object
	 *             containing foo
	 */
	var FieldMask = /** @class */ (function () {
	    function FieldMask(fields) {
	        this.fields = fields;
	        // TODO(dimond): validation of FieldMask
	    }
	    /**
	     * Verifies that `fieldPath` is included by at least one field in this field
	     * mask.
	     *
	     * This is an O(n) operation, where `n` is the size of the field mask.
	     */
	    FieldMask.prototype.covers = function (fieldPath) {
	        for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
	            var fieldMaskPath = _a[_i];
	            if (fieldMaskPath.isPrefixOf(fieldPath)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    FieldMask.prototype.isEqual = function (other) {
	        return arrayEquals(this.fields, other.fields);
	    };
	    return FieldMask;
	}());
	/** A field path and the TransformOperation to perform upon it. */
	var FieldTransform = /** @class */ (function () {
	    function FieldTransform(field, transform) {
	        this.field = field;
	        this.transform = transform;
	    }
	    FieldTransform.prototype.isEqual = function (other) {
	        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
	    };
	    return FieldTransform;
	}());
	/** The result of successfully applying a mutation to the backend. */
	var MutationResult = /** @class */ (function () {
	    function MutationResult(
	    /**
	     * The version at which the mutation was committed or null for a delete.
	     */
	    version, 
	    /**
	     * The resulting fields returned from the backend after a
	     * TransformMutation has been committed. Contains one FieldValue for each
	     * FieldTransform that was in the mutation.
	     *
	     * Will be null if the mutation was not a TransformMutation.
	     */
	    transformResults) {
	        this.version = version;
	        this.transformResults = transformResults;
	    }
	    return MutationResult;
	}());
	var MutationType;
	(function (MutationType) {
	    MutationType[MutationType["Set"] = 0] = "Set";
	    MutationType[MutationType["Patch"] = 1] = "Patch";
	    MutationType[MutationType["Transform"] = 2] = "Transform";
	    MutationType[MutationType["Delete"] = 3] = "Delete";
	})(MutationType || (MutationType = {}));
	/**
	 * Encodes a precondition for a mutation. This follows the model that the
	 * backend accepts with the special case of an explicit "empty" precondition
	 * (meaning no precondition).
	 */
	var Precondition = /** @class */ (function () {
	    function Precondition(updateTime, exists) {
	        this.updateTime = updateTime;
	        this.exists = exists;
	        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
	    }
	    /** Creates a new Precondition with an exists flag. */
	    Precondition.exists = function (exists) {
	        return new Precondition(undefined, exists);
	    };
	    /** Creates a new Precondition based on a version a document exists at. */
	    Precondition.updateTime = function (version) {
	        return new Precondition(version);
	    };
	    Object.defineProperty(Precondition.prototype, "isNone", {
	        /** Returns whether this Precondition is empty. */
	        get: function () {
	            return this.updateTime === undefined && this.exists === undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns true if the preconditions is valid for the given document
	     * (or null if no document is available).
	     */
	    Precondition.prototype.isValidFor = function (maybeDoc) {
	        if (this.updateTime !== undefined) {
	            return (maybeDoc instanceof Document &&
	                maybeDoc.version.isEqual(this.updateTime));
	        }
	        else if (this.exists !== undefined) {
	            if (this.exists) {
	                return maybeDoc instanceof Document;
	            }
	            else {
	                return maybeDoc === null || maybeDoc instanceof NoDocument;
	            }
	        }
	        else {
	            assert(this.isNone, 'Precondition should be empty');
	            return true;
	        }
	    };
	    Precondition.prototype.isEqual = function (other) {
	        return (equals(this.updateTime, other.updateTime) &&
	            this.exists === other.exists);
	    };
	    Precondition.NONE = new Precondition();
	    return Precondition;
	}());
	/**
	 * A mutation describes a self-contained change to a document. Mutations can
	 * create, replace, delete, and update subsets of documents.
	 *
	 * Mutations not only act on the value of the document but also it version.
	 * In the case of Set, Patch, and Transform mutations we preserve the existing
	 * version. In the case of Delete mutations, we reset the version to 0.
	 *
	 * Here's the expected transition table.
	 *
	 * MUTATION           APPLIED TO            RESULTS IN
	 *
	 * SetMutation        Document(v3)          Document(v3)
	 * SetMutation        NoDocument(v3)        Document(v0)
	 * SetMutation        null                  Document(v0)
	 * PatchMutation      Document(v3)          Document(v3)
	 * PatchMutation      NoDocument(v3)        NoDocument(v3)
	 * PatchMutation      null                  null
	 * TransformMutation  Document(v3)          Document(v3)
	 * TransformMutation  NoDocument(v3)        NoDocument(v3)
	 * TransformMutation  null                  null
	 * DeleteMutation     Document(v3)          NoDocument(v0)
	 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
	 * DeleteMutation     null                  NoDocument(v0)
	 *
	 * Note that TransformMutations don't create Documents (in the case of being
	 * applied to a NoDocument), even though they would on the backend. This is
	 * because the client always combines the TransformMutation with a SetMutation
	 * or PatchMutation and we only want to apply the transform if the prior
	 * mutation resulted in a Document (always true for a SetMutation, but not
	 * necessarily for a PatchMutation).
	 *
	 * ## Subclassing Notes
	 *
	 * Subclasses of Mutation need to implement applyToRemoteDocument() and
	 * applyToLocalView() to implement the actual behavior of applying the mutation
	 * to some source document.
	 */
	var Mutation = /** @class */ (function () {
	    function Mutation() {
	    }
	    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
	        if (maybeDoc != null) {
	            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
	        }
	    };
	    /**
	     * Returns the version from the given document for use as the result of a
	     * mutation. Mutations are defined to return the version of the base document
	     * only if it is an existing document. Deleted and unknown documents have a
	     * post-mutation version of SnapshotVersion.MIN.
	     */
	    Mutation.getPostMutationVersion = function (maybeDoc) {
	        if (maybeDoc instanceof Document) {
	            return maybeDoc.version;
	        }
	        else {
	            return SnapshotVersion.MIN;
	        }
	    };
	    return Mutation;
	}());
	/**
	 * A mutation that creates or replaces the document at the given key with the
	 * object value contents.
	 */
	var SetMutation = /** @class */ (function (_super) {
	    tslib_1.__extends(SetMutation, _super);
	    function SetMutation(key, value, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.value = value;
	        _this.precondition = precondition;
	        _this.type = MutationType.Set;
	        return _this;
	    }
	    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new Document(this.key, version, this.value, {
	            hasLocalMutations: false
	        });
	    };
	    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new Document(this.key, version, this.value, {
	            hasLocalMutations: true
	        });
	    };
	    SetMutation.prototype.isEqual = function (other) {
	        return (other instanceof SetMutation &&
	            this.key.isEqual(other.key) &&
	            this.value.isEqual(other.value) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return SetMutation;
	}(Mutation));
	/**
	 * A mutation that modifies fields of the document at the given key with the
	 * given values. The values are applied through a field mask:
	 *
	 *  * When a field is in both the mask and the values, the corresponding field
	 *    is updated.
	 *  * When a field is in neither the mask nor the values, the corresponding
	 *    field is unmodified.
	 *  * When a field is in the mask but not in the values, the corresponding field
	 *    is deleted.
	 *  * When a field is not in the mask but is in the values, the values map is
	 *    ignored.
	 */
	var PatchMutation = /** @class */ (function (_super) {
	    tslib_1.__extends(PatchMutation, _super);
	    function PatchMutation(key, data, fieldMask, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.data = data;
	        _this.fieldMask = fieldMask;
	        _this.precondition = precondition;
	        _this.type = MutationType.Patch;
	        return _this;
	    }
	    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new Document(this.key, version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new Document(this.key, version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    PatchMutation.prototype.isEqual = function (other) {
	        return (other instanceof PatchMutation &&
	            this.key.isEqual(other.key) &&
	            this.fieldMask.isEqual(other.fieldMask) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Patches the data of document if available or creates a new document. Note
	     * that this does not check whether or not the precondition of this patch
	     * holds.
	     */
	    PatchMutation.prototype.patchDocument = function (maybeDoc) {
	        var data;
	        if (maybeDoc instanceof Document) {
	            data = maybeDoc.data;
	        }
	        else {
	            data = ObjectValue.EMPTY;
	        }
	        return this.patchObject(data);
	    };
	    PatchMutation.prototype.patchObject = function (data) {
	        for (var _i = 0, _a = this.fieldMask.fields; _i < _a.length; _i++) {
	            var fieldPath = _a[_i];
	            var newValue = this.data.field(fieldPath);
	            if (newValue !== undefined) {
	                data = data.set(fieldPath, newValue);
	            }
	            else {
	                data = data.delete(fieldPath);
	            }
	        }
	        return data;
	    };
	    return PatchMutation;
	}(Mutation));
	/**
	 * A mutation that modifies specific fields of the document with transform
	 * operations. Currently the only supported transform is a server timestamp, but
	 * IP Address, increment(n), etc. could be supported in the future.
	 *
	 * It is somewhat similar to a PatchMutation in that it patches specific fields
	 * and has no effect when applied to a null or NoDocument (see comment on
	 * Mutation for rationale).
	 */
	var TransformMutation = /** @class */ (function (_super) {
	    tslib_1.__extends(TransformMutation, _super);
	    function TransformMutation(key, fieldTransforms) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.fieldTransforms = fieldTransforms;
	        _this.type = MutationType.Transform;
	        // NOTE: We set a precondition of exists: true as a safety-check, since we
	        // always combine TransformMutations with a SetMutation or PatchMutation which
	        // (if successful) should end up with an existing document.
	        _this.precondition = Precondition.exists(true);
	        return _this;
	    }
	    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new Document(this.key, doc.version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.localTransformResults(localWriteTime, baseDoc);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new Document(this.key, doc.version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    TransformMutation.prototype.isEqual = function (other) {
	        return (other instanceof TransformMutation &&
	            this.key.isEqual(other.key) &&
	            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Asserts that the given MaybeDocument is actually a Document and verifies
	     * that it matches the key for this mutation. Since we only support
	     * transformations with precondition exists this method is guaranteed to be
	     * safe.
	     */
	    TransformMutation.prototype.requireDocument = function (maybeDoc) {
	        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
	        var doc = maybeDoc;
	        assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
	        return doc;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use after a
	     * TransformMutation has been acknowledged by the server.
	     *
	     * @param baseDoc The document prior to applying this mutation batch.
	     * @param serverTransformResults The transform results received by the server.
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
	        var transformResults = [];
	        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
	            ("should match field transform count (" + this.fieldTransforms.length + ")"));
	        for (var i = 0; i < serverTransformResults.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var transform = fieldTransform.transform;
	            var previousValue = null;
	            if (baseDoc instanceof Document) {
	                previousValue = baseDoc.field(fieldTransform.field) || null;
	            }
	            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
	        }
	        return transformResults;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use when applying a
	     * TransformMutation locally.
	     *
	     * @param localWriteTime The local time of the transform mutation (used to
	     *     generate ServerTimestampValues).
	     * @param baseDoc The document prior to applying this mutation batch.
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.localTransformResults = function (localWriteTime, baseDoc) {
	        var transformResults = [];
	        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
	            var fieldTransform = _a[_i];
	            var transform = fieldTransform.transform;
	            var previousValue = null;
	            if (baseDoc instanceof Document) {
	                previousValue = baseDoc.field(fieldTransform.field) || null;
	            }
	            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
	        }
	        return transformResults;
	    };
	    TransformMutation.prototype.transformObject = function (data, transformResults) {
	        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
	        for (var i = 0; i < this.fieldTransforms.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var fieldPath = fieldTransform.field;
	            data = data.set(fieldPath, transformResults[i]);
	        }
	        return data;
	    };
	    return TransformMutation;
	}(Mutation));
	/** A mutation that deletes the document at the given key. */
	var DeleteMutation = /** @class */ (function (_super) {
	    tslib_1.__extends(DeleteMutation, _super);
	    function DeleteMutation(key, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.precondition = precondition;
	        _this.type = MutationType.Delete;
	        return _this;
	    }
	    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        return new NoDocument(this.key, SnapshotVersion.MIN);
	    };
	    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
	        }
	        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
	    };
	    DeleteMutation.prototype.isEqual = function (other) {
	        return (other instanceof DeleteMutation &&
	            this.key.isEqual(other.key) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return DeleteMutation;
	}(Mutation));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ExistenceFilter = /** @class */ (function () {
	    // TODO(b/33078163): just use simplest form of existence filter for now
	    function ExistenceFilter(count) {
	        this.count = count;
	    }
	    ExistenceFilter.prototype.isEqual = function (other) {
	        return other && other.count === this.count;
	    };
	    return ExistenceFilter;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Error Codes describing the different ways GRPC can fail. These are copied
	 * directly from GRPC's sources here:
	 *
	 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	 *
	 * Important! The names of these identifiers matter because the string forms
	 * are used for reverse lookups from the webchannel stream. Do NOT change the
	 * names of these identifiers.
	 */
	var RpcCode;
	(function (RpcCode) {
	    RpcCode[RpcCode["OK"] = 0] = "OK";
	    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
	    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
	    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
	    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
	    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
	    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
	    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
	    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
	    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
	    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
	    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
	    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
	    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
	    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
	    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
	    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
	})(RpcCode || (RpcCode = {}));
	function isPermanentError(code) {
	    switch (code) {
	        case Code.OK:
	            return fail('Treated status OK as error');
	        case Code.CANCELLED:
	        case Code.UNKNOWN:
	        case Code.DEADLINE_EXCEEDED:
	        case Code.RESOURCE_EXHAUSTED:
	        case Code.INTERNAL:
	        case Code.UNAVAILABLE:
	        // Unauthenticated means something went wrong with our token and we need
	        // to retry with new credentials which will happen automatically.
	        // TODO(b/37325376): Give up after second unauthenticated error.
	        case Code.UNAUTHENTICATED:
	            return false;
	        case Code.INVALID_ARGUMENT:
	        case Code.NOT_FOUND:
	        case Code.ALREADY_EXISTS:
	        case Code.PERMISSION_DENIED:
	        case Code.FAILED_PRECONDITION:
	        // Aborted might be retried in some scenarios, but that is dependant on
	        // the context and should handled individually by the calling code.
	        // See https://cloud.google.com/apis/design/errors.
	        case Code.ABORTED:
	        case Code.OUT_OF_RANGE:
	        case Code.UNIMPLEMENTED:
	        case Code.DATA_LOSS:
	            return true;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
	 *
	 * @returns The Code equivalent to the given status string or undefined if
	 *     there is no match.
	 */
	function mapCodeFromRpcStatus(status) {
	    // tslint:disable-next-line:no-any lookup by string
	    var code = RpcCode[status];
	    if (code === undefined) {
	        return undefined;
	    }
	    return mapCodeFromRpcCode(code);
	}
	/**
	 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
	 * are not the same as HTTP status codes.
	 *
	 * @returns The Code equivalent to the given GRPC status code. Fails if there
	 *     is no match.
	 */
	function mapCodeFromRpcCode(code) {
	    if (code === undefined) {
	        // This shouldn't normally happen, but in certain error cases (like trying
	        // to send invalid proto messages) we may get an error with no GRPC code.
	        error('GRPC error has no .code');
	        return Code.UNKNOWN;
	    }
	    switch (code) {
	        case RpcCode.OK:
	            return Code.OK;
	        case RpcCode.CANCELLED:
	            return Code.CANCELLED;
	        case RpcCode.UNKNOWN:
	            return Code.UNKNOWN;
	        case RpcCode.DEADLINE_EXCEEDED:
	            return Code.DEADLINE_EXCEEDED;
	        case RpcCode.RESOURCE_EXHAUSTED:
	            return Code.RESOURCE_EXHAUSTED;
	        case RpcCode.INTERNAL:
	            return Code.INTERNAL;
	        case RpcCode.UNAVAILABLE:
	            return Code.UNAVAILABLE;
	        case RpcCode.UNAUTHENTICATED:
	            return Code.UNAUTHENTICATED;
	        case RpcCode.INVALID_ARGUMENT:
	            return Code.INVALID_ARGUMENT;
	        case RpcCode.NOT_FOUND:
	            return Code.NOT_FOUND;
	        case RpcCode.ALREADY_EXISTS:
	            return Code.ALREADY_EXISTS;
	        case RpcCode.PERMISSION_DENIED:
	            return Code.PERMISSION_DENIED;
	        case RpcCode.FAILED_PRECONDITION:
	            return Code.FAILED_PRECONDITION;
	        case RpcCode.ABORTED:
	            return Code.ABORTED;
	        case RpcCode.OUT_OF_RANGE:
	            return Code.OUT_OF_RANGE;
	        case RpcCode.UNIMPLEMENTED:
	            return Code.UNIMPLEMENTED;
	        case RpcCode.DATA_LOSS:
	            return Code.DATA_LOSS;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Maps an RPC code from a Code. This is the reverse operation from
	 * mapCodeFromRpcCode and should really only be used in tests.
	 */
	function mapRpcCodeFromCode(code) {
	    if (code === undefined) {
	        return RpcCode.OK;
	    }
	    switch (code) {
	        case Code.OK:
	            return RpcCode.OK;
	        case Code.CANCELLED:
	            return RpcCode.CANCELLED;
	        case Code.UNKNOWN:
	            return RpcCode.UNKNOWN;
	        case Code.DEADLINE_EXCEEDED:
	            return RpcCode.DEADLINE_EXCEEDED;
	        case Code.RESOURCE_EXHAUSTED:
	            return RpcCode.RESOURCE_EXHAUSTED;
	        case Code.INTERNAL:
	            return RpcCode.INTERNAL;
	        case Code.UNAVAILABLE:
	            return RpcCode.UNAVAILABLE;
	        case Code.UNAUTHENTICATED:
	            return RpcCode.UNAUTHENTICATED;
	        case Code.INVALID_ARGUMENT:
	            return RpcCode.INVALID_ARGUMENT;
	        case Code.NOT_FOUND:
	            return RpcCode.NOT_FOUND;
	        case Code.ALREADY_EXISTS:
	            return RpcCode.ALREADY_EXISTS;
	        case Code.PERMISSION_DENIED:
	            return RpcCode.PERMISSION_DENIED;
	        case Code.FAILED_PRECONDITION:
	            return RpcCode.FAILED_PRECONDITION;
	        case Code.ABORTED:
	            return RpcCode.ABORTED;
	        case Code.OUT_OF_RANGE:
	            return RpcCode.OUT_OF_RANGE;
	        case Code.UNIMPLEMENTED:
	            return RpcCode.UNIMPLEMENTED;
	        case Code.DATA_LOSS:
	            return RpcCode.DATA_LOSS;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Converts an HTTP Status Code to the equivalent error code.
	 *
	 * @param status An HTTP Status Code, like 200, 404, 503, etc.
	 * @returns The equivalent Code. Unknown status codes are mapped to
	 *     Code.UNKNOWN.
	 */
	function mapCodeFromHttpStatus(status) {
	    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
	    // status codes but the mapping is not bijective. In each case of ambiguity
	    // this function chooses a primary error.
	    //
	    // [1]
	    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	    switch (status) {
	        case 200: // OK
	            return Code.OK;
	        case 400: // Bad Request
	            return Code.INVALID_ARGUMENT;
	        // Other possibilities based on the forward mapping
	        // return Code.FAILED_PRECONDITION;
	        // return Code.OUT_OF_RANGE;
	        case 401: // Unauthorized
	            return Code.UNAUTHENTICATED;
	        case 403: // Forbidden
	            return Code.PERMISSION_DENIED;
	        case 404: // Not Found
	            return Code.NOT_FOUND;
	        case 409: // Conflict
	            return Code.ABORTED;
	        // Other possibilities:
	        // return Code.ALREADY_EXISTS;
	        case 416: // Range Not Satisfiable
	            return Code.OUT_OF_RANGE;
	        case 429: // Too Many Requests
	            return Code.RESOURCE_EXHAUSTED;
	        case 499: // Client Closed Request
	            return Code.CANCELLED;
	        case 500: // Internal Server Error
	            return Code.UNKNOWN;
	        // Other possibilities:
	        // return Code.INTERNAL;
	        // return Code.DATA_LOSS;
	        case 501: // Unimplemented
	            return Code.UNIMPLEMENTED;
	        case 503: // Service Unavailable
	            return Code.UNAVAILABLE;
	        case 504: // Gateway Timeout
	            return Code.DEADLINE_EXCEEDED;
	        default:
	            if (status >= 200 && status < 300)
	                return Code.OK;
	            if (status >= 400 && status < 500)
	                return Code.FAILED_PRECONDITION;
	            if (status >= 500 && status < 600)
	                return Code.INTERNAL;
	            return Code.UNKNOWN;
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SortedSet is an immutable (copy-on-write) collection that holds elements
	 * in order specified by the provided comparator.
	 *
	 * NOTE: if provided comparator returns 0 for two elements, we consider them to
	 * be equal!
	 */
	var SortedSet = /** @class */ (function () {
	    function SortedSet(comparator) {
	        this.comparator = comparator;
	        this.data = new SortedMap(this.comparator);
	    }
	    /**
	     * Creates a SortedSet from the keys of the map.
	     * This is currently implemented as an O(n) copy.
	     */
	    SortedSet.fromMapKeys = function (map) {
	        var keys = new SortedSet(map.comparator);
	        map.forEach(function (key) {
	            keys = keys.add(key);
	        });
	        return keys;
	    };
	    SortedSet.prototype.has = function (elem) {
	        return this.data.get(elem) !== null;
	    };
	    SortedSet.prototype.first = function () {
	        return this.data.minKey();
	    };
	    SortedSet.prototype.last = function () {
	        return this.data.maxKey();
	    };
	    Object.defineProperty(SortedSet.prototype, "size", {
	        get: function () {
	            return this.data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SortedSet.prototype.indexOf = function (elem) {
	        return this.data.indexOf(elem);
	    };
	    /** Iterates elements in order defined by "comparator" */
	    SortedSet.prototype.forEach = function (cb) {
	        this.data.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
	    SortedSet.prototype.forEachInRange = function (range, cb) {
	        var iter = this.data.getIteratorFrom(range[0]);
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            if (this.comparator(elem.key, range[1]) >= 0)
	                return;
	            cb(elem.key);
	        }
	    };
	    /**
	     * Iterates over `elem`s such that: start <= elem until false is returned.
	     */
	    SortedSet.prototype.forEachWhile = function (cb, start) {
	        var iter;
	        if (start !== undefined) {
	            iter = this.data.getIteratorFrom(start);
	        }
	        else {
	            iter = this.data.getIterator();
	        }
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            var result = cb(elem.key);
	            if (!result)
	                return;
	        }
	    };
	    /** Finds the least element greater than or equal to `elem`. */
	    SortedSet.prototype.firstAfterOrEqual = function (elem) {
	        var iter = this.data.getIteratorFrom(elem);
	        return iter.hasNext() ? iter.getNext().key : null;
	    };
	    /** Inserts or updates an element */
	    SortedSet.prototype.add = function (elem) {
	        return this.copy(this.data.remove(elem).insert(elem, true));
	    };
	    /** Deletes an element */
	    SortedSet.prototype.delete = function (elem) {
	        if (!this.has(elem))
	            return this;
	        return this.copy(this.data.remove(elem));
	    };
	    SortedSet.prototype.isEmpty = function () {
	        return this.data.isEmpty();
	    };
	    SortedSet.prototype.unionWith = function (other) {
	        var result = this;
	        other.forEach(function (elem) {
	            result = result.add(elem);
	        });
	        return result;
	    };
	    SortedSet.prototype.isEqual = function (other) {
	        if (!(other instanceof SortedSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.data.getIterator();
	        var otherIt = other.data.getIterator();
	        while (thisIt.hasNext()) {
	            var thisElem = thisIt.getNext().key;
	            var otherElem = otherIt.getNext().key;
	            if (this.comparator(thisElem, otherElem) !== 0)
	                return false;
	        }
	        return true;
	    };
	    SortedSet.prototype.toString = function () {
	        var result = [];
	        this.forEach(function (elem) { return result.push(elem); });
	        return 'SortedSet(' + result.toString() + ')';
	    };
	    SortedSet.prototype.copy = function (data) {
	        var result = new SortedSet(this.comparator);
	        result.data = data;
	        return result;
	    };
	    return SortedSet;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
	function maybeDocumentMap() {
	    return EMPTY_MAYBE_DOCUMENT_MAP;
	}
	var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
	function documentMap() {
	    return EMPTY_DOCUMENT_MAP;
	}
	var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
	function documentVersionMap() {
	    return EMPTY_DOCUMENT_VERSION_MAP;
	}
	var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
	function documentKeySet() {
	    return EMPTY_DOCUMENT_KEY_SET;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An event from the RemoteStore. It is split into targetChanges (changes to the
	 * state or the set of documents in our watched targets) and documentUpdates
	 * (changes to the actual documents).
	 */
	var RemoteEvent = /** @class */ (function () {
	    function RemoteEvent(
	    /**
	     * The snapshot version this event brings us up to, or MIN if not set.
	     */
	    snapshotVersion, 
	    /**
	     * A map from target to changes to the target. See TargetChange.
	     */
	    targetChanges, 
	    /**
	     * A set of which documents have changed or been deleted, along with the
	     * doc's new values (if not deleted).
	     */
	    documentUpdates, 
	    /**
	     * A set of which document updates are due only to limbo resolution targets.
	     */
	    limboDocuments) {
	        this.snapshotVersion = snapshotVersion;
	        this.targetChanges = targetChanges;
	        this.documentUpdates = documentUpdates;
	        this.limboDocuments = limboDocuments;
	    }
	    RemoteEvent.prototype.addDocumentUpdate = function (doc) {
	        this.documentUpdates = this.documentUpdates.insert(doc.key, doc);
	    };
	    RemoteEvent.prototype.handleExistenceFilterMismatch = function (targetId) {
	        /*
	         * An existence filter mismatch will reset the query and we need to reset
	         * the mapping to contain no documents and an empty resume token.
	         *
	         * Note:
	         *   * The reset mapping is empty, specifically forcing the consumer of the
	         *     change to forget all keys for this targetID;
	         *   * The resume snapshot for this target must be reset
	         *   * The target must be unacked because unwatching and rewatching
	         *     introduces a race for changes.
	         */
	        this.targetChanges[targetId] = {
	            mapping: new ResetMapping(),
	            snapshotVersion: SnapshotVersion.MIN,
	            currentStatusUpdate: CurrentStatusUpdate.MarkNotCurrent,
	            resumeToken: emptyByteString()
	        };
	    };
	    /**
	     * Synthesize a delete change if necessary for the given limbo target.
	     */
	    RemoteEvent.prototype.synthesizeDeleteForLimboTargetChange = function (targetChange, key) {
	        if (targetChange.currentStatusUpdate === CurrentStatusUpdate.MarkCurrent &&
	            !this.documentUpdates.get(key)) {
	            // When listening to a query the server responds with a snapshot
	            // containing documents matching the query and a current marker
	            // telling us we're now in sync. It's possible for these to arrive
	            // as separate remote events or as a single remote event.
	            // For a document query, there will be no documents sent in the
	            // response if the document doesn't exist.
	            //
	            // If the snapshot arrives separately from the current marker,
	            // we handle it normally and updateTrackedLimbos will resolve the
	            // limbo status of the document, removing it from limboDocumentRefs.
	            // This works because clients only initiate limbo resolution when
	            // a target is current and because all current targets are
	            // always at a consistent snapshot.
	            //
	            // However, if the document doesn't exist and the current marker
	            // arrives, the document is not present in the snapshot and our
	            // normal view handling would consider the document to remain in
	            // limbo indefinitely because there are no updates to the document.
	            // To avoid this, we specially handle this case here:
	            // synthesizing a delete.
	            //
	            // TODO(dimond): Ideally we would have an explicit lookup query
	            // instead resulting in an explicit delete message and we could
	            // remove this special logic.
	            this.documentUpdates = this.documentUpdates.insert(key, new NoDocument(key, this.snapshotVersion));
	            this.limboDocuments = this.limboDocuments.add(key);
	        }
	    };
	    return RemoteEvent;
	}());
	/**
	 * Represents an update to the current status of a target, either explicitly
	 * having no new state, or the new value to set. Note "current" has special
	 * meaning for in the RPC protocol that implies that a target is both up-to-date
	 * and consistent with the rest of the watch stream.
	 */
	var CurrentStatusUpdate;
	(function (CurrentStatusUpdate) {
	    /** The current status is not affected and should not be modified. */
	    CurrentStatusUpdate[CurrentStatusUpdate["None"] = 0] = "None";
	    /** The target must be marked as no longer "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkNotCurrent"] = 1] = "MarkNotCurrent";
	    /** The target must be marked as "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkCurrent"] = 2] = "MarkCurrent";
	})(CurrentStatusUpdate || (CurrentStatusUpdate = {}));
	var EMPTY_KEY_SET = documentKeySet();
	var ResetMapping = /** @class */ (function () {
	    function ResetMapping() {
	        this.docs = EMPTY_KEY_SET;
	    }
	    Object.defineProperty(ResetMapping.prototype, "documents", {
	        get: function () {
	            return this.docs;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ResetMapping.prototype.add = function (key) {
	        this.docs = this.docs.add(key);
	    };
	    ResetMapping.prototype.delete = function (key) {
	        this.docs = this.docs.delete(key);
	    };
	    ResetMapping.prototype.isEqual = function (other) {
	        return other !== null && this.docs.isEqual(other.docs);
	    };
	    ResetMapping.prototype.filterUpdates = function (existingKeys) {
	        // No-op. Resets don't get filtered.
	    };
	    return ResetMapping;
	}());
	var UpdateMapping = /** @class */ (function () {
	    function UpdateMapping() {
	        this.addedDocuments = EMPTY_KEY_SET;
	        this.removedDocuments = EMPTY_KEY_SET;
	    }
	    UpdateMapping.prototype.applyToKeySet = function (keys) {
	        var result = keys;
	        this.addedDocuments.forEach(function (key) { return (result = result.add(key)); });
	        this.removedDocuments.forEach(function (key) { return (result = result.delete(key)); });
	        return result;
	    };
	    UpdateMapping.prototype.add = function (key) {
	        this.addedDocuments = this.addedDocuments.add(key);
	        this.removedDocuments = this.removedDocuments.delete(key);
	    };
	    UpdateMapping.prototype.delete = function (key) {
	        this.addedDocuments = this.addedDocuments.delete(key);
	        this.removedDocuments = this.removedDocuments.add(key);
	    };
	    UpdateMapping.prototype.isEqual = function (other) {
	        return (other !== null &&
	            this.addedDocuments.isEqual(other.addedDocuments) &&
	            this.removedDocuments.isEqual(other.removedDocuments));
	    };
	    /**
	     * Strips out mapping changes that aren't actually changes. That is, if the document already
	     * existed in the target, and is being added in the target, and this is not a reset, we can
	     * skip doing the work to associate the document with the target because it has already been done.
	     */
	    UpdateMapping.prototype.filterUpdates = function (existingKeys) {
	        var results = this.addedDocuments;
	        this.addedDocuments.forEach(function (docKey) {
	            if (existingKeys.has(docKey)) {
	                results = results.delete(docKey);
	            }
	        });
	        this.addedDocuments = results;
	    };
	    return UpdateMapping;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a changed document and a list of target ids to which this change
	 * applies.
	 *
	 * If document has been deleted NoDocument will be provided.
	 */
	var DocumentWatchChange = /** @class */ (function () {
	    function DocumentWatchChange(
	    /** The new document applies to all of these targets. */
	    updatedTargetIds, 
	    /** The new document is removed from all of these targets. */
	    removedTargetIds, 
	    /** The key of the document for this change. */
	    key, 
	    /**
	     * The new document or NoDocument if it was deleted. Is null if the
	     * document went out of view without the server sending a new document.
	     */
	    newDoc) {
	        this.updatedTargetIds = updatedTargetIds;
	        this.removedTargetIds = removedTargetIds;
	        this.key = key;
	        this.newDoc = newDoc;
	    }
	    return DocumentWatchChange;
	}());
	var ExistenceFilterChange = /** @class */ (function () {
	    function ExistenceFilterChange(targetId, existenceFilter) {
	        this.targetId = targetId;
	        this.existenceFilter = existenceFilter;
	    }
	    return ExistenceFilterChange;
	}());
	var WatchTargetChangeState;
	(function (WatchTargetChangeState) {
	    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
	    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
	    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
	    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
	    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
	})(WatchTargetChangeState || (WatchTargetChangeState = {}));
	var WatchTargetChange = /** @class */ (function () {
	    function WatchTargetChange(
	    /** What kind of change occurred to the watch target. */
	    state, 
	    /** The target IDs that were added/removed/set. */
	    targetIds, 
	    /**
	     * An opaque, server-assigned token that allows watching a query to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the query. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */
	    resumeToken, 
	    /** An RPC error indicating why the watch failed. */
	    cause) {
	        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
	        if (cause === void 0) { cause = null; }
	        this.state = state;
	        this.targetIds = targetIds;
	        this.resumeToken = resumeToken;
	        this.cause = cause;
	    }
	    return WatchTargetChange;
	}());
	/**
	 * A helper class to accumulate watch changes into a RemoteEvent and other
	 * target information.
	 */
	var WatchChangeAggregator = /** @class */ (function () {
	    function WatchChangeAggregator(snapshotVersion, listenTargets, pendingTargetResponses) {
	        this.snapshotVersion = snapshotVersion;
	        this.listenTargets = listenTargets;
	        /** The existence filter - if any - for the given target IDs. */
	        this.existenceFilters = {};
	        /** Keeps track of the current target mappings */
	        this.targetChanges = {};
	        /** Keeps track of document to update */
	        this.documentUpdates = maybeDocumentMap();
	        /** Whether this aggregator was frozen and can no longer be modified */
	        this.frozen = false;
	        /** Tracks which document updates are due only to limbo target resolution */
	        this.limboDocuments = documentKeySet();
	        this.pendingTargetResponses = shallowCopy(pendingTargetResponses);
	    }
	    /** Aggregates a watch change into the current state */
	    WatchChangeAggregator.prototype.add = function (watchChange) {
	        assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        if (watchChange instanceof DocumentWatchChange) {
	            this.addDocumentChange(watchChange);
	        }
	        else if (watchChange instanceof WatchTargetChange) {
	            this.addTargetChange(watchChange);
	        }
	        else if (watchChange instanceof ExistenceFilterChange) {
	            this.addExistenceFilterChange(watchChange);
	        }
	        else {
	            fail('Unknown watch change: ' + watchChange);
	        }
	    };
	    /** Aggregates all provided watch changes to the current state in order */
	    WatchChangeAggregator.prototype.addChanges = function (watchChanges) {
	        var _this = this;
	        assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        watchChanges.forEach(function (change) { return _this.add(change); });
	    };
	    /**
	     * Converts the current state into a remote event with the snapshot version
	     * provided via the constructor.
	     */
	    WatchChangeAggregator.prototype.createRemoteEvent = function () {
	        var _this = this;
	        var targetChanges = this.targetChanges;
	        // Remove all the non-active targets from the remote event.
	        forEachNumber(this.targetChanges, function (targetId) {
	            if (!_this.isActiveTarget(targetId)) {
	                delete targetChanges[targetId];
	            }
	        });
	        // Mark this aggregator as frozen so no further modifications are made
	        this.frozen = true;
	        return new RemoteEvent(this.snapshotVersion, targetChanges, this.documentUpdates, this.limboDocuments);
	    };
	    WatchChangeAggregator.prototype.ensureTargetChange = function (targetId) {
	        var change = this.targetChanges[targetId];
	        if (!change) {
	            // Create an UpdateMapping by default, since resets are always explicit.
	            change = {
	                currentStatusUpdate: CurrentStatusUpdate.None,
	                snapshotVersion: this.snapshotVersion,
	                mapping: new UpdateMapping(),
	                resumeToken: emptyByteString()
	            };
	            this.targetChanges[targetId] = change;
	        }
	        return change;
	    };
	    /**
	     * Returns the QueryData instance for the given targetId if the target is
	     * active, or null otherwise. For a target to be considered active there must
	     * be no pending acks we're waiting for and it must be in the current list of
	     * targets that the client cares about.
	     */
	    WatchChangeAggregator.prototype.queryDataForActiveTarget = function (targetId) {
	        var queryData = this.listenTargets[targetId];
	        return queryData &&
	            !contains(this.pendingTargetResponses, targetId)
	            ? queryData
	            : null;
	    };
	    /**
	     * Defers to queryForActiveTarget to determine if the given targetId
	     * corresponds to an active target.
	     *
	     * This method is visible for testing.
	     */
	    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
	        return this.queryDataForActiveTarget(targetId) !== null;
	    };
	    /**
	     * Updates limbo document tracking for a given target-document mapping change.
	     * If the target is a limbo target, and the change for the document has only
	     * seen limbo targets so far, and we are not already tracking a change for
	     * this document, then consider this document a limbo document update.
	     * Otherwise, ensure that we don't consider this document a limbo document.
	     * Returns true if the change still has only seen limbo resolution changes.
	     */
	    WatchChangeAggregator.prototype.updateLimboDocuments = function (key, queryData, isOnlyLimbo) {
	        if (!isOnlyLimbo) {
	            // It wasn't a limbo doc before, so it definitely isn't now.
	            return false;
	        }
	        if (!this.documentUpdates.get(key)) {
	            // We haven't seen the document update for this key yet.
	            if (queryData.purpose === QueryPurpose.LimboResolution) {
	                this.limboDocuments = this.limboDocuments.add(key);
	                return true;
	            }
	            else {
	                // We haven't seen the document before, but this is a non-limbo target.
	                // Since we haven't seen it, we know it's not in our set of limbo docs.
	                // Return false to ensure that this key is marked as non-limbo.
	                return false;
	            }
	        }
	        else if (queryData.purpose === QueryPurpose.LimboResolution) {
	            // We have only seen limbo targets so far for this document, and this is
	            // another limbo target.
	            return true;
	        }
	        else {
	            // We haven't marked this as non-limbo yet, but this target is not a limbo
	            // target. Mark the key as non-limbo and make sure it isn't in our set.
	            this.limboDocuments = this.limboDocuments.delete(key);
	            return false;
	        }
	    };
	    WatchChangeAggregator.prototype.addDocumentChange = function (docChange) {
	        var relevant = false;
	        var isOnlyLimbo = true;
	        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
	            var targetId = _a[_i];
	            var queryData = this.queryDataForActiveTarget(targetId);
	            if (queryData) {
	                var change = this.ensureTargetChange(targetId);
	                isOnlyLimbo = this.updateLimboDocuments(docChange.key, queryData, isOnlyLimbo);
	                change.mapping.add(docChange.key);
	                relevant = true;
	            }
	        }
	        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
	            var targetId = _c[_b];
	            var queryData = this.queryDataForActiveTarget(targetId);
	            if (queryData) {
	                var change = this.ensureTargetChange(targetId);
	                isOnlyLimbo = this.updateLimboDocuments(docChange.key, queryData, isOnlyLimbo);
	                change.mapping.delete(docChange.key);
	                relevant = true;
	            }
	        }
	        // Only update the document if there is a new document to replace to an
	        // active target that is being listened to, this might be just a target
	        // update instead.
	        if (docChange.newDoc && relevant) {
	            this.documentUpdates = this.documentUpdates.insert(docChange.key, docChange.newDoc);
	        }
	    };
	    WatchChangeAggregator.prototype.addTargetChange = function (targetChange) {
	        var _this = this;
	        targetChange.targetIds.forEach(function (targetId) {
	            var change = _this.ensureTargetChange(targetId);
	            switch (targetChange.state) {
	                case WatchTargetChangeState.NoChange:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Creating the change above satisfies the semantics of no-change.
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Added:
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    if (!contains(_this.pendingTargetResponses, targetId)) {
	                        // We have a freshly added target, so we need to reset any state
	                        // that we had previously This can happen e.g. when remove and add
	                        // back a target for existence filter mismatches.
	                        change.mapping = new UpdateMapping();
	                        change.currentStatusUpdate = CurrentStatusUpdate.None;
	                        delete _this.existenceFilters[targetId];
	                    }
	                    applyResumeToken(change, targetChange.resumeToken);
	                    break;
	                case WatchTargetChangeState.Removed:
	                    // We need to keep track of removed targets to we can
	                    // post-filter and remove any target changes.
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
	                    break;
	                case WatchTargetChangeState.Current:
	                    if (_this.isActiveTarget(targetId)) {
	                        change.currentStatusUpdate = CurrentStatusUpdate.MarkCurrent;
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Reset:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Overwrite any existing target mapping with a reset
	                        // mapping. Every subsequent update will modify the reset
	                        // mapping, not an update mapping.
	                        change.mapping = new ResetMapping();
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                default:
	                    fail('Unknown target watch change state: ' + targetChange.state);
	            }
	        });
	    };
	    /**
	     * Record that we get a watch target add/remove by decrementing the number of
	     * pending target responses that we have.
	     */
	    WatchChangeAggregator.prototype.recordTargetResponse = function (targetId) {
	        var newCount = (this.pendingTargetResponses[targetId] || 0) - 1;
	        if (newCount === 0) {
	            delete this.pendingTargetResponses[targetId];
	        }
	        else {
	            this.pendingTargetResponses[targetId] = newCount;
	        }
	    };
	    WatchChangeAggregator.prototype.addExistenceFilterChange = function (change) {
	        if (this.isActiveTarget(change.targetId)) {
	            this.existenceFilters[change.targetId] = change.existenceFilter;
	        }
	    };
	    return WatchChangeAggregator;
	}());
	/**
	 * Applies the resume token to the TargetChange, but only when it has a new
	 * value. null and empty resumeTokens are discarded.
	 */
	function applyResumeToken(change, resumeToken) {
	    if (resumeToken.length > 0) {
	        change.resumeToken = resumeToken;
	    }
	}
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Transforms a value into a server-generated timestamp. */
	var ServerTimestampTransform = /** @class */ (function () {
	    function ServerTimestampTransform() {
	    }
	    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return new ServerTimestampValue(localWriteTime, previousValue);
	    };
	    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        return transformResult;
	    };
	    ServerTimestampTransform.prototype.isEqual = function (other) {
	        return other instanceof ServerTimestampTransform;
	    };
	    ServerTimestampTransform.instance = new ServerTimestampTransform();
	    return ServerTimestampTransform;
	}());
	/** Transforms an array value via a union operation. */
	var ArrayUnionTransformOperation = /** @class */ (function () {
	    function ArrayUnionTransformOperation(elements) {
	        this.elements = elements;
	    }
	    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return this.apply(previousValue);
	    };
	    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        // The server just sends null as the transform result for array operations,
	        // so we have to calculate a result the same as we do for local
	        // applications.
	        return this.apply(previousValue);
	    };
	    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
	        var result = coercedFieldValuesArray(previousValue);
	        var _loop_1 = function (toUnion) {
	            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
	                result.push(toUnion);
	            }
	        };
	        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
	            var toUnion = _a[_i];
	            _loop_1(toUnion);
	        }
	        return new ArrayValue(result);
	    };
	    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
	        return (other instanceof ArrayUnionTransformOperation &&
	            arrayEquals(other.elements, this.elements));
	    };
	    return ArrayUnionTransformOperation;
	}());
	/** Transforms an array value via a remove operation. */
	var ArrayRemoveTransformOperation = /** @class */ (function () {
	    function ArrayRemoveTransformOperation(elements) {
	        this.elements = elements;
	    }
	    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return this.apply(previousValue);
	    };
	    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        // The server just sends null as the transform result for array operations,
	        // so we have to calculate a result the same as we do for local
	        // applications.
	        return this.apply(previousValue);
	    };
	    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
	        var result = coercedFieldValuesArray(previousValue);
	        var _loop_2 = function (toRemove) {
	            result = result.filter(function (element) { return !element.isEqual(toRemove); });
	        };
	        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
	            var toRemove = _a[_i];
	            _loop_2(toRemove);
	        }
	        return new ArrayValue(result);
	    };
	    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
	        return (other instanceof ArrayRemoveTransformOperation &&
	            arrayEquals(other.elements, this.elements));
	    };
	    return ArrayRemoveTransformOperation;
	}());
	function coercedFieldValuesArray(value) {
	    if (value instanceof ArrayValue) {
	        return value.internalValue.slice();
	    }
	    else {
	        // coerce to empty array.
	        return [];
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DIRECTIONS = (function () {
	    var dirs = {};
	    dirs[Direction.ASCENDING.name] = 'ASCENDING';
	    dirs[Direction.DESCENDING.name] = 'DESCENDING';
	    return dirs;
	})();
	var OPERATORS = (function () {
	    var ops = {};
	    ops[RelationOp.LESS_THAN.name] = 'LESS_THAN';
	    ops[RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
	    ops[RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
	    ops[RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
	    ops[RelationOp.EQUAL.name] = 'EQUAL';
	    ops[RelationOp.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
	    return ops;
	})();
	// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
	var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
	function assertPresent(value, description) {
	    assert(!isNullOrUndefined(value), description + ' is missing');
	}
	function parseInt64(value) {
	    // TODO(bjornick): Handle int64 greater than 53 bits.
	    if (typeof value === 'number') {
	        return value;
	    }
	    else if (typeof value === 'string') {
	        return Number(value);
	    }
	    else {
	        return fail("can't parse " + value);
	    }
	}
	/**
	 * Generates JsonObject values for the Datastore API suitable for sending to
	 * either GRPC stub methods or via the JSON/HTTP REST API.
	 * TODO(klimt): We can remove the databaseId argument if we keep the full
	 * resource name in documents.
	 */
	var JsonProtoSerializer = /** @class */ (function () {
	    function JsonProtoSerializer(databaseId, options) {
	        this.databaseId = databaseId;
	        this.options = options;
	    }
	    JsonProtoSerializer.prototype.emptyByteString = function () {
	        if (this.options.useProto3Json) {
	            return '';
	        }
	        else {
	            return new Uint8Array(0);
	        }
	    };
	    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
	        // byteStrings can be either string or UInt8Array, but the typings say
	        // it's always a string. Cast as string to avoid type check failing
	        return byteString;
	    };
	    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
	        var code = status.code === undefined
	            ? Code.UNKNOWN
	            : mapCodeFromRpcCode(status.code);
	        return new FirestoreError(code, status.message || '');
	    };
	    /**
	     * Returns a value for a number (or undefined) that's appropriate to put into
	     * a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "number" because that's what
	     * our generated proto interfaces say Int32Value must be. But GRPC actually
	     * expects a { value: <number> } struct.
	     */
	    JsonProtoSerializer.prototype.toInt32Value = function (val) {
	        if (!isNullOrUndefined(val)) {
	            // tslint:disable-next-line:no-any We need to match generated Proto types.
	            return { value: val };
	        }
	        else {
	            return undefined;
	        }
	    };
	    /**
	     * Returns a number (or null) from a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as accepting "number" because that's what
	     * our generated proto interfaces say Int32Value must be, but it actually
	     * accepts { value: number } to match our serialization in toInt32Value().
	     */
	    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
	        var result;
	        if (typeof val === 'object') {
	            // tslint:disable-next-line:no-any We need to match generated Proto types.
	            result = val.value;
	        }
	        else {
	            // We accept raw numbers (without the {value: ... } wrapper) for
	            // compatibility with legacy persisted data.
	            result = val;
	        }
	        return isNullOrUndefined(result) ? null : result;
	    };
	    /**
	     * Returns a value for a Date that's appropriate to put into a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say dates must be. But it's easier and safer
	     * to actually return a Timestamp proto.
	     */
	    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
	        return {
	            seconds: timestamp.seconds,
	            nanos: timestamp.nanoseconds
	            // tslint:disable-next-line:no-any
	        };
	    };
	    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
	        // The json interface (for the browser) will return an iso timestamp string,
	        // while the proto js library (for node) will return a
	        // google.protobuf.Timestamp instance.
	        if (typeof date === 'string') {
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(this.options.useProto3Json,
	            //   'The timestamp string format requires Proto3.');
	            return this.fromIso8601String(date);
	        }
	        else {
	            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(!this.options.useProto3Json,
	            //   'The timestamp instance format requires Proto JS.');
	            var seconds = parseInt64(date.seconds || '0');
	            var nanos = date.nanos || 0;
	            return new Timestamp(seconds, nanos);
	        }
	    };
	    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
	        // The date string can have higher precision (nanos) than the Date class
	        // (millis), so we do some custom parsing here.
	        // Parse the nanos right out of the string.
	        var nanos = 0;
	        var fraction = ISO_REG_EXP.exec(utc);
	        assert(!!fraction, 'invalid timestamp: ' + utc);
	        if (fraction[1]) {
	            // Pad the fraction out to 9 digits (nanos).
	            var nanoStr = fraction[1];
	            nanoStr = (nanoStr + '000000000').substr(0, 9);
	            nanos = Number(nanoStr);
	        }
	        // Parse the date to get the seconds.
	        var date = new Date(utc);
	        var seconds = Math.floor(date.getTime() / 1000);
	        return new Timestamp(seconds, nanos);
	    };
	    /**
	     * Returns a value for bytes that's appropriate to put in a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say bytes must be. But it should return
	     * an Uint8Array in Node.
	     */
	    JsonProtoSerializer.prototype.toBytes = function (bytes) {
	        if (this.options.useProto3Json) {
	            return bytes.toBase64();
	        }
	        else {
	            // The typings say it's a string, but it needs to be a Uint8Array in Node.
	            return this.unsafeCastProtoByteString(bytes.toUint8Array());
	        }
	    };
	    /**
	     * Parse the blob from the protos into the internal Blob class. Note that the
	     * typings assume all blobs are strings, but they are actually Uint8Arrays
	     * on Node.
	     */
	    JsonProtoSerializer.prototype.fromBlob = function (blob) {
	        if (typeof blob === 'string') {
	            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
	            return Blob.fromBase64String(blob);
	        }
	        else {
	            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
	            return Blob.fromUint8Array(blob);
	        }
	    };
	    JsonProtoSerializer.prototype.toVersion = function (version) {
	        return this.toTimestamp(version.toTimestamp());
	    };
	    JsonProtoSerializer.prototype.fromVersion = function (version) {
	        assert(!!version, "Trying to deserialize version that isn't set");
	        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
	    };
	    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
	        return this.fullyQualifiedPrefixPath(databaseId)
	            .child('documents')
	            .child(path)
	            .canonicalString();
	    };
	    JsonProtoSerializer.prototype.fromResourceName = function (name) {
	        var resource = ResourcePath.fromString(name);
	        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
	        return resource;
	    };
	    JsonProtoSerializer.prototype.toName = function (key) {
	        return this.toResourceName(this.databaseId, key.path);
	    };
	    JsonProtoSerializer.prototype.fromName = function (name) {
	        var resource = this.fromResourceName(name);
	        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
	            resource.get(1) +
	            ' vs ' +
	            this.databaseId.projectId);
	        assert((!resource.get(3) && !this.databaseId.database) ||
	            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
	            resource.get(3) +
	            ' vs ' +
	            this.databaseId.database);
	        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
	    };
	    JsonProtoSerializer.prototype.toQueryPath = function (path) {
	        if (path.length === 0) {
	            // If the path is empty, the backend requires we leave off the /documents
	            // at the end.
	            return this.encodedDatabaseId;
	        }
	        return this.toResourceName(this.databaseId, path);
	    };
	    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
	        var resourceName = this.fromResourceName(name);
	        if (resourceName.length === 4) {
	            return ResourcePath.EMPTY_PATH;
	        }
	        return this.extractLocalPathFromResourceName(resourceName);
	    };
	    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
	        get: function () {
	            var path = new ResourcePath([
	                'projects',
	                this.databaseId.projectId,
	                'databases',
	                this.databaseId.database
	            ]);
	            return path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
	        return new ResourcePath([
	            'projects',
	            databaseId.projectId,
	            'databases',
	            databaseId.database
	        ]);
	    };
	    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
	        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
	        return resourceName.popFirst(5);
	    };
	    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
	        // Resource names have at least 4 components (project ID, database ID)
	        return (path.length >= 4 &&
	            path.get(0) === 'projects' &&
	            path.get(2) === 'databases');
	    };
	    JsonProtoSerializer.prototype.toValue = function (val) {
	        if (val instanceof NullValue) {
	            return { nullValue: 'NULL_VALUE' };
	        }
	        else if (val instanceof BooleanValue) {
	            return { booleanValue: val.value() };
	        }
	        else if (val instanceof IntegerValue) {
	            return { integerValue: '' + val.value() };
	        }
	        else if (val instanceof DoubleValue) {
	            var doubleValue = val.value();
	            if (this.options.useProto3Json) {
	                // Proto 3 let's us encode NaN and Infinity as string values as
	                // expected by the backend. This is currently not checked by our unit
	                // tests because they rely on protobuf.js.
	                if (isNaN(doubleValue)) {
	                    return { doubleValue: 'NaN' };
	                }
	                else if (doubleValue === Infinity) {
	                    return { doubleValue: 'Infinity' };
	                }
	                else if (doubleValue === -Infinity) {
	                    return { doubleValue: '-Infinity' };
	                }
	            }
	            return { doubleValue: val.value() };
	        }
	        else if (val instanceof StringValue) {
	            return { stringValue: val.value() };
	        }
	        else if (val instanceof ObjectValue) {
	            return { mapValue: this.toMapValue(val) };
	        }
	        else if (val instanceof ArrayValue) {
	            return { arrayValue: this.toArrayValue(val) };
	        }
	        else if (val instanceof TimestampValue) {
	            return {
	                timestampValue: this.toTimestamp(val.internalValue)
	            };
	        }
	        else if (val instanceof GeoPointValue) {
	            return {
	                geoPointValue: {
	                    latitude: val.value().latitude,
	                    longitude: val.value().longitude
	                }
	            };
	        }
	        else if (val instanceof BlobValue) {
	            return {
	                bytesValue: this.toBytes(val.value())
	            };
	        }
	        else if (val instanceof RefValue) {
	            return {
	                referenceValue: this.toResourceName(val.databaseId, val.key.path)
	            };
	        }
	        else {
	            return fail('Unknown FieldValue ' + JSON.stringify(val));
	        }
	    };
	    JsonProtoSerializer.prototype.fromValue = function (obj) {
	        var _this = this;
	        // tslint:disable-next-line:no-any
	        var type = obj['value_type'];
	        if (hasTag(obj, type, 'nullValue')) {
	            return NullValue.INSTANCE;
	        }
	        else if (hasTag(obj, type, 'booleanValue')) {
	            return BooleanValue.of(obj.booleanValue);
	        }
	        else if (hasTag(obj, type, 'integerValue')) {
	            return new IntegerValue(parseInt64(obj.integerValue));
	        }
	        else if (hasTag(obj, type, 'doubleValue')) {
	            if (this.options.useProto3Json) {
	                // Proto 3 uses the string values 'NaN' and 'Infinity'.
	                if (obj.doubleValue === 'NaN') {
	                    return DoubleValue.NAN;
	                }
	                else if (obj.doubleValue === 'Infinity') {
	                    return DoubleValue.POSITIVE_INFINITY;
	                }
	                else if (obj.doubleValue === '-Infinity') {
	                    return DoubleValue.NEGATIVE_INFINITY;
	                }
	            }
	            return new DoubleValue(obj.doubleValue);
	        }
	        else if (hasTag(obj, type, 'stringValue')) {
	            return new StringValue(obj.stringValue);
	        }
	        else if (hasTag(obj, type, 'mapValue')) {
	            return this.fromFields(obj.mapValue.fields || {});
	        }
	        else if (hasTag(obj, type, 'arrayValue')) {
	            // "values" is not present if the array is empty
	            assertPresent(obj.arrayValue, 'arrayValue');
	            var values = obj.arrayValue.values || [];
	            return new ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if (hasTag(obj, type, 'timestampValue')) {
	            assertPresent(obj.timestampValue, 'timestampValue');
	            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
	        }
	        else if (hasTag(obj, type, 'geoPointValue')) {
	            assertPresent(obj.geoPointValue, 'geoPointValue');
	            var latitude = obj.geoPointValue.latitude || 0;
	            var longitude = obj.geoPointValue.longitude || 0;
	            return new GeoPointValue(new GeoPoint(latitude, longitude));
	        }
	        else if (hasTag(obj, type, 'bytesValue')) {
	            assertPresent(obj.bytesValue, 'bytesValue');
	            var blob = this.fromBlob(obj.bytesValue);
	            return new BlobValue(blob);
	        }
	        else if (hasTag(obj, type, 'referenceValue')) {
	            assertPresent(obj.referenceValue, 'referenceValue');
	            var resourceName = this.fromResourceName(obj.referenceValue);
	            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
	            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
	            return new RefValue(dbId, key);
	        }
	        else {
	            return fail('Unknown Value proto ' + JSON.stringify(obj));
	        }
	    };
	    /** Creates an api.Document from key and fields (but no create/update time) */
	    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
	        return {
	            name: this.toName(key),
	            fields: this.toFields(fields)
	        };
	    };
	    JsonProtoSerializer.prototype.toDocument = function (document) {
	        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
	        return {
	            name: this.toName(document.key),
	            fields: this.toFields(document.data),
	            updateTime: this.toTimestamp(document.version.toTimestamp())
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocument = function (document) {
	        return new Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.toFields = function (fields) {
	        var _this = this;
	        var result = {};
	        fields.forEach(function (key, value) {
	            result[key] = _this.toValue(value);
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromFields = function (object) {
	        var _this = this;
	        // Proto map<string, Value> gets mapped to Object, so cast it.
	        var map = object;
	        var result = ObjectValue.EMPTY;
	        forEach(map, function (key, value) {
	            result = result.set(new FieldPath([key]), _this.fromValue(value));
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.toMapValue = function (map) {
	        return {
	            fields: this.toFields(map)
	        };
	    };
	    JsonProtoSerializer.prototype.toArrayValue = function (array) {
	        var _this = this;
	        var result = [];
	        array.forEach(function (value) {
	            result.push(_this.toValue(value));
	        });
	        return { values: result };
	    };
	    JsonProtoSerializer.prototype.fromFound = function (doc) {
	        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
	        assertPresent(doc.found.name, 'doc.found.name');
	        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
	        var key = this.fromName(doc.found.name);
	        var version = this.fromVersion(doc.found.updateTime);
	        var fields = this.fromFields(doc.found.fields || {});
	        return new Document(key, version, fields, { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.fromMissing = function (result) {
	        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
	        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
	        var key = this.fromName(result.missing);
	        var version = this.fromVersion(result.readTime);
	        return new NoDocument(key, version);
	    };
	    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
	        // tslint:disable-next-line:no-any
	        var type = result['result'];
	        if (hasTag(result, type, 'found')) {
	            return this.fromFound(result);
	        }
	        else if (hasTag(result, type, 'missing')) {
	            return this.fromMissing(result);
	        }
	        return fail('invalid batch get response: ' + JSON.stringify(result));
	    };
	    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
	        switch (state) {
	            case WatchTargetChangeState.Added:
	                return 'ADD';
	            case WatchTargetChangeState.Current:
	                return 'CURRENT';
	            case WatchTargetChangeState.NoChange:
	                return 'NO_CHANGE';
	            case WatchTargetChangeState.Removed:
	                return 'REMOVE';
	            case WatchTargetChangeState.Reset:
	                return 'RESET';
	            default:
	                return fail('Unknown WatchTargetChangeState: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
	        if (watchChange instanceof ExistenceFilterChange) {
	            return {
	                filter: {
	                    count: watchChange.existenceFilter.count,
	                    targetId: watchChange.targetId
	                }
	            };
	        }
	        if (watchChange instanceof DocumentWatchChange) {
	            if (watchChange.newDoc instanceof Document) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentChange: {
	                        document: {
	                            name: this.toName(doc.key),
	                            fields: this.toFields(doc.data),
	                            updateTime: this.toVersion(doc.version)
	                        },
	                        targetIds: watchChange.updatedTargetIds,
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc instanceof NoDocument) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentDelete: {
	                        document: this.toName(doc.key),
	                        readTime: this.toVersion(doc.version),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc === null) {
	                return {
	                    documentRemove: {
	                        document: this.toName(watchChange.key),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	        }
	        if (watchChange instanceof WatchTargetChange) {
	            var cause = undefined;
	            if (watchChange.cause) {
	                cause = {
	                    code: mapRpcCodeFromCode(watchChange.cause.code),
	                    message: watchChange.cause.message
	                };
	            }
	            return {
	                targetChange: {
	                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
	                    targetIds: watchChange.targetIds,
	                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
	                    cause: cause
	                }
	            };
	        }
	        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
	    };
	    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        var watchChange;
	        if (hasTag(change, type, 'targetChange')) {
	            assertPresent(change.targetChange, 'targetChange');
	            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
	            // if unset
	            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
	            var targetIds = change.targetChange.targetIds || [];
	            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
	            var causeProto = change.targetChange.cause;
	            var cause = causeProto && this.fromRpcStatus(causeProto);
	            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
	        }
	        else if (hasTag(change, type, 'documentChange')) {
	            assertPresent(change.documentChange, 'documentChange');
	            assertPresent(change.documentChange.document, 'documentChange.name');
	            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
	            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
	            var entityChange = change.documentChange;
	            var key = this.fromName(entityChange.document.name);
	            var version = this.fromVersion(entityChange.document.updateTime);
	            var fields = this.fromFields(entityChange.document.fields || {});
	            var doc = new Document(key, version, fields, {
	                hasLocalMutations: false
	            });
	            var updatedTargetIds = entityChange.targetIds || [];
	            var removedTargetIds = entityChange.removedTargetIds || [];
	            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentDelete')) {
	            assertPresent(change.documentDelete, 'documentDelete');
	            assertPresent(change.documentDelete.document, 'documentDelete.document');
	            var docDelete = change.documentDelete;
	            var key = this.fromName(docDelete.document);
	            var version = docDelete.readTime
	                ? this.fromVersion(docDelete.readTime)
	                : SnapshotVersion.forDeletedDoc();
	            var doc = new NoDocument(key, version);
	            var removedTargetIds = docDelete.removedTargetIds || [];
	            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentRemove')) {
	            assertPresent(change.documentRemove, 'documentRemove');
	            assertPresent(change.documentRemove.document, 'documentRemove');
	            var docRemove = change.documentRemove;
	            var key = this.fromName(docRemove.document);
	            var removedTargetIds = docRemove.removedTargetIds || [];
	            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
	        }
	        else if (hasTag(change, type, 'filter')) {
	            // TODO(dimond): implement existence filter parsing with strategy.
	            assertPresent(change.filter, 'filter');
	            assertPresent(change.filter.targetId, 'filter.targetId');
	            var filter = change.filter;
	            var count = filter.count || 0;
	            var existenceFilter = new ExistenceFilter(count);
	            var targetId = filter.targetId;
	            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
	        }
	        else {
	            return fail('Unknown change type ' + JSON.stringify(change));
	        }
	        return watchChange;
	    };
	    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
	        if (state === 'NO_CHANGE') {
	            return WatchTargetChangeState.NoChange;
	        }
	        else if (state === 'ADD') {
	            return WatchTargetChangeState.Added;
	        }
	        else if (state === 'REMOVE') {
	            return WatchTargetChangeState.Removed;
	        }
	        else if (state === 'CURRENT') {
	            return WatchTargetChangeState.Current;
	        }
	        else if (state === 'RESET') {
	            return WatchTargetChangeState.Reset;
	        }
	        else {
	            return fail('Got unexpected TargetChange.state: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
	        // We have only reached a consistent snapshot for the entire stream if there
	        // is a read_time set and it applies to all targets (i.e. the list of
	        // targets is empty). The backend is guaranteed to send such responses.
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        if (!hasTag(change, type, 'targetChange')) {
	            return SnapshotVersion.MIN;
	        }
	        var targetChange = change.targetChange;
	        if (targetChange.targetIds && targetChange.targetIds.length) {
	            return SnapshotVersion.MIN;
	        }
	        if (!targetChange.readTime) {
	            return SnapshotVersion.MIN;
	        }
	        return this.fromVersion(targetChange.readTime);
	    };
	    JsonProtoSerializer.prototype.toMutation = function (mutation) {
	        var _this = this;
	        var result;
	        if (mutation instanceof SetMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.value)
	            };
	        }
	        else if (mutation instanceof DeleteMutation) {
	            result = { delete: this.toName(mutation.key) };
	        }
	        else if (mutation instanceof PatchMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.data),
	                updateMask: this.toDocumentMask(mutation.fieldMask)
	            };
	        }
	        else if (mutation instanceof TransformMutation) {
	            result = {
	                transform: {
	                    document: this.toName(mutation.key),
	                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
	                        return _this.toFieldTransform(transform);
	                    })
	                }
	            };
	        }
	        else {
	            return fail('Unknown mutation type ' + mutation.type);
	        }
	        if (!mutation.precondition.isNone) {
	            result.currentDocument = this.toPrecondition(mutation.precondition);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromMutation = function (proto) {
	        var _this = this;
	        var precondition = proto.currentDocument
	            ? this.fromPrecondition(proto.currentDocument)
	            : Precondition.NONE;
	        if (proto.update) {
	            assertPresent(proto.update.name, 'name');
	            var key = this.fromName(proto.update.name);
	            var value = this.fromFields(proto.update.fields || {});
	            if (proto.updateMask) {
	                var fieldMask = this.fromDocumentMask(proto.updateMask);
	                return new PatchMutation(key, value, fieldMask, precondition);
	            }
	            else {
	                return new SetMutation(key, value, precondition);
	            }
	        }
	        else if (proto.delete) {
	            var key = this.fromName(proto.delete);
	            return new DeleteMutation(key, precondition);
	        }
	        else if (proto.transform) {
	            var key = this.fromName(proto.transform.document);
	            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
	                return _this.fromFieldTransform(transform);
	            });
	            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
	            return new TransformMutation(key, fieldTransforms);
	        }
	        else {
	            return fail('unknown mutation proto: ' + JSON.stringify(proto));
	        }
	    };
	    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
	        assert(!precondition.isNone, "Can't serialize an empty precondition");
	        if (precondition.updateTime !== undefined) {
	            return {
	                updateTime: this.toVersion(precondition.updateTime)
	            };
	        }
	        else if (precondition.exists !== undefined) {
	            return { exists: precondition.exists };
	        }
	        else {
	            return fail('Unknown precondition');
	        }
	    };
	    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
	        if (precondition.updateTime !== undefined) {
	            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
	        }
	        else if (precondition.exists !== undefined) {
	            return Precondition.exists(precondition.exists);
	        }
	        else {
	            return Precondition.NONE;
	        }
	    };
	    JsonProtoSerializer.prototype.fromWriteResult = function (proto) {
	        var _this = this;
	        // NOTE: Deletes don't have an updateTime.
	        var version = proto.updateTime
	            ? this.fromVersion(proto.updateTime)
	            : null;
	        var transformResults = null;
	        if (proto.transformResults && proto.transformResults.length > 0) {
	            transformResults = proto.transformResults.map(function (result) {
	                return _this.fromValue(result);
	            });
	        }
	        return new MutationResult(version, transformResults);
	    };
	    JsonProtoSerializer.prototype.fromWriteResults = function (protos) {
	        var _this = this;
	        return (protos || []).map(function (proto) { return _this.fromWriteResult(proto); });
	    };
	    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
	        var _this = this;
	        var transform = fieldTransform.transform;
	        if (transform instanceof ServerTimestampTransform) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                setToServerValue: 'REQUEST_TIME'
	            };
	        }
	        else if (transform instanceof ArrayUnionTransformOperation) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                appendMissingElements: {
	                    values: transform.elements.map(function (v) { return _this.toValue(v); })
	                }
	            };
	        }
	        else if (transform instanceof ArrayRemoveTransformOperation) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                removeAllFromArray: {
	                    values: transform.elements.map(function (v) { return _this.toValue(v); })
	                }
	            };
	        }
	        else {
	            fail('Unknown transform: ' + fieldTransform.transform);
	        }
	    };
	    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
	        var _this = this;
	        // tslint:disable-next-line:no-any We need to match generated Proto types.
	        var type = proto['transform_type'];
	        var transform = null;
	        if (hasTag(proto, type, 'setToServerValue')) {
	            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
	            transform = ServerTimestampTransform.instance;
	        }
	        else if (hasTag(proto, type, 'appendMissingElements')) {
	            var values = proto.appendMissingElements.values || [];
	            transform = new ArrayUnionTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if (hasTag(proto, type, 'removeAllFromArray')) {
	            var values = proto.removeAllFromArray.values || [];
	            transform = new ArrayRemoveTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else {
	            fail('Unknown transform proto: ' + JSON.stringify(proto));
	        }
	        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
	        return new FieldTransform(fieldPath, transform);
	    };
	    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
	        return { documents: [this.toQueryPath(query.path)] };
	    };
	    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
	        var count = documentsTarget.documents.length;
	        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
	        var name = documentsTarget.documents[0];
	        return Query.atPath(this.fromQueryPath(name));
	    };
	    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
	        // Dissect the path into parent, collectionId, and optional key filter.
	        var result = { structuredQuery: {} };
	        if (query.path.isEmpty()) {
	            result.parent = this.toQueryPath(ResourcePath.EMPTY_PATH);
	        }
	        else {
	            var path = query.path;
	            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
	            result.parent = this.toQueryPath(path.popLast());
	            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
	        }
	        var where = this.toFilter(query.filters);
	        if (where) {
	            result.structuredQuery.where = where;
	        }
	        var orderBy = this.toOrder(query.orderBy);
	        if (orderBy) {
	            result.structuredQuery.orderBy = orderBy;
	        }
	        var limit = this.toInt32Value(query.limit);
	        if (limit !== undefined) {
	            result.structuredQuery.limit = limit;
	        }
	        if (query.startAt) {
	            result.structuredQuery.startAt = this.toCursor(query.startAt);
	        }
	        if (query.endAt) {
	            result.structuredQuery.endAt = this.toCursor(query.endAt);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
	        var path = this.fromQueryPath(target.parent);
	        var query = target.structuredQuery;
	        var fromCount = query.from ? query.from.length : 0;
	        if (fromCount > 0) {
	            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
	            var from = query.from[0];
	            path = path.child(from.collectionId);
	        }
	        var filterBy = [];
	        if (query.where) {
	            filterBy = this.fromFilter(query.where);
	        }
	        var orderBy = [];
	        if (query.orderBy) {
	            orderBy = this.fromOrder(query.orderBy);
	        }
	        var limit = null;
	        if (query.limit) {
	            limit = this.fromInt32Value(query.limit);
	        }
	        var startAt = null;
	        if (query.startAt) {
	            startAt = this.fromCursor(query.startAt);
	        }
	        var endAt = null;
	        if (query.endAt) {
	            endAt = this.fromCursor(query.endAt);
	        }
	        return new Query(path, orderBy, filterBy, limit, startAt, endAt);
	    };
	    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
	        var value = this.toLabel(queryData.purpose);
	        if (value == null) {
	            return null;
	        }
	        else {
	            return {
	                'goog-listen-tags': value
	            };
	        }
	    };
	    JsonProtoSerializer.prototype.toLabel = function (purpose) {
	        switch (purpose) {
	            case QueryPurpose.Listen:
	                return null;
	            case QueryPurpose.ExistenceFilterMismatch:
	                return 'existence-filter-mismatch';
	            case QueryPurpose.LimboResolution:
	                return 'limbo-document';
	            default:
	                return fail('Unrecognized query purpose: ' + purpose);
	        }
	    };
	    JsonProtoSerializer.prototype.toTarget = function (queryData) {
	        var result;
	        var query = queryData.query;
	        if (query.isDocumentQuery()) {
	            result = { documents: this.toDocumentsTarget(query) };
	        }
	        else {
	            result = { query: this.toQueryTarget(query) };
	        }
	        result.targetId = queryData.targetId;
	        if (queryData.resumeToken.length > 0) {
	            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.toFilter = function (filters) {
	        var _this = this;
	        if (filters.length === 0)
	            return;
	        var protos = filters.map(function (filter) {
	            return filter instanceof RelationFilter
	                ? _this.toRelationFilter(filter)
	                : _this.toUnaryFilter(filter);
	        });
	        if (protos.length === 1) {
	            return protos[0];
	        }
	        return { compositeFilter: { op: 'AND', filters: protos } };
	    };
	    JsonProtoSerializer.prototype.fromFilter = function (filter) {
	        var _this = this;
	        if (!filter) {
	            return [];
	        }
	        else if (filter.unaryFilter !== undefined) {
	            return [this.fromUnaryFilter(filter)];
	        }
	        else if (filter.fieldFilter !== undefined) {
	            return [this.fromRelationFilter(filter)];
	        }
	        else if (filter.compositeFilter !== undefined) {
	            return filter.compositeFilter
	                .filters.map(function (f) { return _this.fromFilter(f); })
	                .reduce(function (accum, current) { return accum.concat(current); });
	        }
	        else {
	            return fail('Unknown filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
	        var _this = this;
	        if (orderBys.length === 0)
	            return;
	        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
	        var _this = this;
	        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.toCursor = function (cursor) {
	        var _this = this;
	        return {
	            before: cursor.before,
	            values: cursor.position.map(function (component) { return _this.toValue(component); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
	        var _this = this;
	        var before = !!cursor.before;
	        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
	        return new Bound(position, before);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toDirection = function (dir) {
	        return DIRECTIONS[dir.name];
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.fromDirection = function (dir) {
	        switch (dir) {
	            case 'ASCENDING':
	                return Direction.ASCENDING;
	            case 'DESCENDING':
	                return Direction.DESCENDING;
	            default:
	                return undefined;
	        }
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toOperatorName = function (op) {
	        return OPERATORS[op.name];
	    };
	    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
	        switch (op) {
	            case 'EQUAL':
	                return RelationOp.EQUAL;
	            case 'GREATER_THAN':
	                return RelationOp.GREATER_THAN;
	            case 'GREATER_THAN_OR_EQUAL':
	                return RelationOp.GREATER_THAN_OR_EQUAL;
	            case 'LESS_THAN':
	                return RelationOp.LESS_THAN;
	            case 'LESS_THAN_OR_EQUAL':
	                return RelationOp.LESS_THAN_OR_EQUAL;
	            case 'ARRAY_CONTAINS':
	                return RelationOp.ARRAY_CONTAINS;
	            case 'OPERATOR_UNSPECIFIED':
	                return fail('Unspecified relation');
	            default:
	                return fail('Unknown relation');
	        }
	    };
	    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
	        return { fieldPath: path.canonicalString() };
	    };
	    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
	        return FieldPath.fromServerFormat(fieldReference.fieldPath);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
	        return {
	            field: this.toFieldPathReference(orderBy.field),
	            direction: this.toDirection(orderBy.dir)
	        };
	    };
	    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
	        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
	        if (filter instanceof RelationFilter) {
	            return {
	                fieldFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: this.toOperatorName(filter.op),
	                    value: this.toValue(filter.value)
	                }
	            };
	        }
	        else {
	            return fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
	        return new RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
	        if (filter instanceof NanFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NAN'
	                }
	            };
	        }
	        else if (filter instanceof NullFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NULL'
	                }
	            };
	        }
	        else {
	            return fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
	        switch (filter.unaryFilter.op) {
	            case 'IS_NAN':
	                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new NanFilter(nanField);
	            case 'IS_NULL':
	                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new NullFilter(nullField);
	            case 'OPERATOR_UNSPECIFIED':
	                return fail('Unspecified filter');
	            default:
	                return fail('Unknown filter');
	        }
	    };
	    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
	        return {
	            fieldPaths: fieldMask.fields.map(function (field) { return field.canonicalString(); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
	        var paths = proto.fieldPaths || [];
	        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
	        return new FieldMask(fields);
	    };
	    return JsonProtoSerializer;
	}());
	/**
	 * Checks for a specific oneof tag in a protocol buffer message.
	 *
	 * This intentionally accommodates two distinct cases:
	 *
	 * 1) Messages containing a type tag: these are the format produced by GRPC in
	 * return values. These may contain default-value mappings for all tags in the
	 * oneof but the type tag specifies which one was actually set.
	 *
	 * 2) Messages that don't contain a type tag: these are the format required by
	 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
	 * choke claiming that the tags aren't fields in the Message.
	 *
	 * Allowing both formats here makes the serializer able to consume the outputs
	 * it produces: for all messages it supports, fromX(toX(value)) == value.
	 *
	 * Note that case 2 suffers from ambiguity: if multiple tags are present
	 * without a type tag then the callers are structured in such a way that the
	 * first invocation will win. Since we only parse in this mode when parsing
	 * the output of a serialize method this works, but it's not a general
	 * solution.
	 *
	 * Unfortunately there is no general solution here because proto3 makes it
	 * impossible to distinguish unset from explicitly set fields: both have the
	 * default value for the type. Without the type tag but multiple value tags
	 * it's possible to have default values for each tag in the oneof and not be
	 * able to know which was actually in effect.
	 */
	function hasTag(obj, type, tag) {
	    return type === tag || (!type && tag in obj);
	}
	
	/**
	 * Detect React Native.
	 *
	 * @return {boolean} True if ReactNative environment is detected.
	 */
	var isReactNative = function () {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	};
	
	var ERROR_NAME = 'FirebaseError';
	var captureStackTrace = Error
	    .captureStackTrace;
	var FirebaseError = /** @class */ (function () {
	    function FirebaseError(code, message) {
	        this.code = code;
	        this.message = message;
	        // We want the stack value, if implemented by Error
	        if (captureStackTrace) {
	            // Patches this.stack, omitted calls above ErrorFactory#create
	            captureStackTrace(this, ErrorFactory.prototype.create);
	        }
	        else {
	            try {
	                // In case of IE11, stack will be set only after error is raised.
	                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
	                throw Error.apply(this, arguments);
	            }
	            catch (err) {
	                this.name = ERROR_NAME;
	                // Make non-enumerable getter for the property.
	                Object.defineProperty(this, 'stack', {
	                    get: function () {
	                        return err.stack;
	                    }
	                });
	            }
	        }
	    }
	    return FirebaseError;
	}());
	// Back-door inheritance
	FirebaseError.prototype = Object.create(Error.prototype);
	FirebaseError.prototype.constructor = FirebaseError;
	FirebaseError.prototype.name = ERROR_NAME;
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	        // Matches {$name}, by default.
	        this.pattern = /\{\$([^}]+)}/g;
	        // empty
	    }
	    ErrorFactory.prototype.create = function (code, data) {
	        if (data === undefined) {
	            data = {};
	        }
	        var template = this.errors[code];
	        var fullCode = this.service + '/' + code;
	        var message;
	        if (template === undefined) {
	            message = 'Error';
	        }
	        else {
	            message = template.replace(this.pattern, function (match, key) {
	                var value = data[key];
	                return value !== undefined ? value.toString() : '<' + key + '?>';
	            });
	        }
	        // Service: Error message (service/code).
	        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
	        var err = new FirebaseError(fullCode, message);
	        // Populate the Error object with message parts for programmatic
	        // accesses (e.g., e.file).
	        for (var prop in data) {
	            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
	                continue;
	            }
	            err[prop] = data[prop];
	        }
	        return err;
	    };
	    return ErrorFactory;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Copyright 2011 The Closure Library Authors. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	/**
	 * @fileoverview Abstract cryptographic hash interface.
	 *
	 * See Sha1 and Md5 for sample implementations.
	 *
	 */
	/**
	 * Create a cryptographic hash instance.
	 *
	 * @constructor
	 * @struct
	 */
	var Hash = /** @class */ (function () {
	    function Hash() {
	        /**
	         * The block size for the hasher.
	         * @type {number}
	         */
	        this.blockSize = -1;
	    }
	    return Hash;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @extends {Hash}
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function (_super) {
	    tslib_1.__extends(Sha1, _super);
	    function Sha1() {
	        var _this = _super.call(this) || this;
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        _this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        _this.total_ = 0;
	        _this.blockSize = 512 / 8;
	        _this.pad_[0] = 128;
	        for (var i = 1; i < _this.blockSize; ++i) {
	            _this.pad_[i] = 0;
	        }
	        _this.reset();
	        return _this;
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
	     * @param {number=} opt_offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, opt_offset) {
	        if (!opt_offset) {
	            opt_offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(opt_offset) << 24) |
	                        (buf.charCodeAt(opt_offset + 1) << 16) |
	                        (buf.charCodeAt(opt_offset + 2) << 8) |
	                        buf.charCodeAt(opt_offset + 3);
	                opt_offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[opt_offset] << 24) |
	                        (buf[opt_offset + 1] << 16) |
	                        (buf[opt_offset + 2] << 8) |
	                        buf[opt_offset + 3];
	                opt_offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, opt_length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (opt_length === undefined) {
	            opt_length = bytes.length;
	        }
	        var lengthMinusBlock = opt_length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < opt_length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf == 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += opt_length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}(Hash));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides a simple helper class that implements the Stream interface to
	 * bridge to other implementations that are streams but do not implement the
	 * interface. The stream callbacks are invoked with the callOn... methods.
	 */
	var StreamBridge = /** @class */ (function () {
	    function StreamBridge(args) {
	        this.sendFn = args.sendFn;
	        this.closeFn = args.closeFn;
	    }
	    StreamBridge.prototype.onOpen = function (callback) {
	        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
	        this.wrappedOnOpen = callback;
	    };
	    StreamBridge.prototype.onClose = function (callback) {
	        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
	        this.wrappedOnClose = callback;
	    };
	    StreamBridge.prototype.onMessage = function (callback) {
	        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
	        this.wrappedOnMessage = callback;
	    };
	    StreamBridge.prototype.close = function () {
	        this.closeFn();
	    };
	    StreamBridge.prototype.send = function (msg) {
	        this.sendFn(msg);
	    };
	    StreamBridge.prototype.callOnOpen = function () {
	        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
	        this.wrappedOnOpen();
	    };
	    StreamBridge.prototype.callOnClose = function (err) {
	        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
	        this.wrappedOnClose(err);
	    };
	    StreamBridge.prototype.callOnMessage = function (msg) {
	        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
	        this.wrappedOnMessage(msg);
	    };
	    return StreamBridge;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG = 'Connection';
	var RPC_STREAM_SERVICE = 'google.firestore.v1beta1.Firestore';
	var RPC_URL_VERSION = 'v1beta1';
	/** Maps RPC names to the corresponding REST endpoint name. */
	var RPC_NAME_REST_MAPPING = {
	    BatchGetDocuments: 'batchGet',
	    Commit: 'commit'
	};
	// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
	// we are doing out-of-band releases. Once we release as part of Firebase, we
	// should use the Firebase version instead.
	var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
	var XHR_TIMEOUT_SECS = 15;
	var WebChannelConnection = /** @class */ (function () {
	    function WebChannelConnection(info) {
	        this.databaseId = info.databaseId;
	        this.pool = new webchannelWrapper.XhrIoPool();
	        var proto = info.ssl ? 'https' : 'http';
	        this.baseUrl = proto + '://' + info.host;
	    }
	    /**
	     * Modifies the headers for a request, adding any authorization token if
	     * present and any additional headers for the request.
	     */
	    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
	        if (token) {
	            for (var header in token.authHeaders) {
	                if (token.authHeaders.hasOwnProperty(header)) {
	                    headers[header] = token.authHeaders[header];
	                }
	            }
	        }
	        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
	    };
	    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
	        var _this = this;
	        var url = this.makeUrl(rpcName);
	        return new Promise(function (resolve, reject) {
	            // tslint:disable-next-line:no-any XhrIoPool doesn't have TS typings.
	            _this.pool.getObject(function (xhr) {
	                xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
	                    try {
	                        switch (xhr.getLastErrorCode()) {
	                            case webchannelWrapper.ErrorCode.NO_ERROR:
	                                var json = xhr.getResponseJson();
	                                debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
	                                resolve(json);
	                                break;
	                            case webchannelWrapper.ErrorCode.TIMEOUT:
	                                debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
	                                reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
	                                break;
	                            case webchannelWrapper.ErrorCode.HTTP_ERROR:
	                                var status_1 = xhr.getStatus();
	                                debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
	                                if (status_1 > 0) {
	                                    reject(new FirestoreError(mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
	                                }
	                                else {
	                                    // If we received an HTTP_ERROR but there's no status code,
	                                    // it's most probably a connection issue
	                                    debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
	                                    reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
	                                }
	                                break;
	                            default:
	                                fail('RPC "' +
	                                    rpcName +
	                                    '" failed with unanticipated ' +
	                                    'webchannel error ' +
	                                    xhr.getLastErrorCode() +
	                                    ': ' +
	                                    xhr.getLastError() +
	                                    ', giving up.');
	                        }
	                    }
	                    finally {
	                        debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
	                        _this.pool.releaseObject(xhr);
	                    }
	                });
	                var requestString = JSON.stringify(request);
	                debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
	                // Content-Type: text/plain will avoid preflight requests which might
	                // mess with CORS and redirects by proxies. If we add custom headers
	                // we will need to change this code to potentially use the
	                // $httpOverwrite parameter supported by ESF to avoid
	                // triggering preflight requests.
	                var headers = { 'Content-Type': 'text/plain' };
	                _this.modifyHeadersForRequest(headers, token);
	                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
	            });
	        });
	    };
	    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
	        // The REST API automatically aggregates all of the streamed results, so we
	        // can just use the normal invoke() method.
	        return this.invokeRPC(rpcName, request, token);
	    };
	    WebChannelConnection.prototype.openStream = function (rpcName, token) {
	        var urlParts = [
	            this.baseUrl,
	            '/',
	            RPC_STREAM_SERVICE,
	            '/',
	            rpcName,
	            '/channel'
	        ];
	        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
	        var request = {
	            // Background channel test avoids the initial two test calls and decreases
	            // initial cold start time.
	            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
	            // we should monitor closely for any reports.
	            backgroundChannelTest: true,
	            // Required for backend stickiness, routing behavior is based on this
	            // parameter.
	            httpSessionIdParam: 'gsessionid',
	            initMessageHeaders: {},
	            messageUrlParams: {
	                // This param is used to improve routing and project isolation by the
	                // backend and must be included in every request.
	                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
	            },
	            sendRawJson: true,
	            supportsCrossDomainXhr: true
	        };
	        this.modifyHeadersForRequest(request.initMessageHeaders, token);
	        // Sending the custom headers we just added to request.initMessageHeaders
	        // (Authorization, etc.) will trigger the browser to make a CORS preflight
	        // request because the XHR will no longer meet the criteria for a "simple"
	        // CORS request:
	        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
	        //
	        // Therefore to avoid the CORS preflight request (an extra network
	        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
	        // the headers should instead be encoded into a special "$httpHeaders" query
	        // parameter, which is recognized by the webchannel backend. This is
	        // formally defined here:
	        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
	        //
	        // But for some unclear reason (see
	        // https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
	        // ReactNative and so we exclude it, which just means ReactNative may be
	        // subject to the extra network roundtrip for CORS preflight.
	        if (!isReactNative()) {
	            request['httpHeadersOverwriteParam'] = '$httpHeaders';
	        }
	        var url = urlParts.join('');
	        debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
	        // tslint:disable-next-line:no-any Because listen isn't defined on it.
	        var channel = webchannelTransport.createWebChannel(url, request);
	        // WebChannel supports sending the first message with the handshake - saving
	        // a network round trip. However, it will have to call send in the same
	        // JS event loop as open. In order to enforce this, we delay actually
	        // opening the WebChannel until send is called. Whether we have called
	        // open is tracked with this variable.
	        var opened = false;
	        // A flag to determine whether the stream was closed (by us or through an
	        // error/close event) to avoid delivering multiple close events or sending
	        // on a closed stream
	        var closed = false;
	        var streamBridge = new StreamBridge({
	            sendFn: function (msg) {
	                if (!closed) {
	                    if (!opened) {
	                        debug(LOG_TAG, 'Opening WebChannel transport.');
	                        channel.open();
	                        opened = true;
	                    }
	                    debug(LOG_TAG, 'WebChannel sending:', msg);
	                    channel.send(msg);
	                }
	                else {
	                    debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
	                }
	            },
	            closeFn: function () { return channel.close(); }
	        });
	        // Closure events are guarded and exceptions are swallowed, so catch any
	        // exception and rethrow using a setTimeout so they become visible again.
	        // Note that eventually this function could go away if we are confident
	        // enough the code is exception free.
	        var unguardedEventListen = function (type, fn) {
	            // TODO(dimond): closure typing seems broken because WebChannel does
	            // not implement goog.events.Listenable
	            channel.listen(type, function (param) {
	                try {
	                    fn(param);
	                }
	                catch (e) {
	                    setTimeout(function () {
	                        throw e;
	                    }, 0);
	                }
	            });
	        };
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
	            if (!closed) {
	                debug(LOG_TAG, 'WebChannel transport opened.');
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
	            if (!closed) {
	                closed = true;
	                debug(LOG_TAG, 'WebChannel transport closed');
	                streamBridge.callOnClose();
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
	            if (!closed) {
	                closed = true;
	                debug(LOG_TAG, 'WebChannel transport errored:', err);
	                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
	            if (!closed) {
	                var msgData = msg.data[0];
	                assert(!!msgData, 'Got a webchannel message without data.');
	                // TODO(b/35143891): There is a bug in One Platform that caused errors
	                // (and only errors) to be wrapped in an extra array. To be forward
	                // compatible with the bug we need to check either condition. The latter
	                // can be removed once the fix has been rolled out.
	                var error$$1 = 
	                // tslint:disable-next-line:no-any msgData.error is not typed.
	                msgData.error || (msgData[0] && msgData[0].error);
	                if (error$$1) {
	                    debug(LOG_TAG, 'WebChannel received error:', error$$1);
	                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
	                    var status_2 = error$$1.status;
	                    var code = mapCodeFromRpcStatus(status_2);
	                    var message = error$$1.message;
	                    if (code === undefined) {
	                        code = Code.INTERNAL;
	                        message =
	                            'Unknown error status: ' +
	                                status_2 +
	                                ' with message ' +
	                                error$$1.message;
	                    }
	                    // Mark closed so no further events are propagated
	                    closed = true;
	                    streamBridge.callOnClose(new FirestoreError(code, message));
	                    channel.close();
	                }
	                else {
	                    debug(LOG_TAG, 'WebChannel received:', msgData);
	                    streamBridge.callOnMessage(msgData);
	                }
	            }
	        });
	        setTimeout(function () {
	            // Technically we could/should wait for the WebChannel opened event,
	            // but because we want to send the first message with the WebChannel
	            // handshake we pretend the channel opened here (asynchronously), and
	            // then delay the actual open until the first message is sent.
	            streamBridge.callOnOpen();
	        }, 0);
	        return streamBridge;
	    };
	    // visible for testing
	    WebChannelConnection.prototype.makeUrl = function (rpcName) {
	        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
	        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
	        var url = [this.baseUrl, '/', RPC_URL_VERSION];
	        url.push('/projects/');
	        url.push(this.databaseId.projectId);
	        url.push('/databases/');
	        url.push(this.databaseId.database);
	        url.push('/documents');
	        url.push(':');
	        url.push(urlRpcName);
	        return url.join('');
	    };
	    return WebChannelConnection;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var BrowserPlatform = /** @class */ (function () {
	    function BrowserPlatform() {
	        this.emptyByteString = '';
	        this.base64Available = typeof atob !== 'undefined';
	    }
	    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
	        return Promise.resolve(new WebChannelConnection(databaseInfo));
	    };
	    BrowserPlatform.prototype.newSerializer = function (databaseId) {
	        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
	    };
	    BrowserPlatform.prototype.formatJSON = function (value) {
	        return JSON.stringify(value);
	    };
	    BrowserPlatform.prototype.atob = function (encoded) {
	        return atob(encoded);
	    };
	    BrowserPlatform.prototype.btoa = function (raw) {
	        return btoa(raw);
	    };
	    return BrowserPlatform;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This code needs to run before Firestore is used. This can be achieved in
	 * several ways:
	 *   1) Through the JSCompiler compiling this code and then (automatically)
	 *      executing it before exporting the Firestore symbols.
	 *   2) Through importing this module first in a Firestore main module
	 */
	PlatformSupport.setPlatform(new BrowserPlatform());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	/**
	 * A FieldPath refers to a field in a document. The path may consist of a single
	 * field name (referring to a top-level field in the document), or a list of
	 * field names (referring to a nested field in the document).
	 */
	var FieldPath$1 = /** @class */ (function () {
	    /**
	     * Creates a FieldPath from the provided field names. If more than one field
	     * name is provided, the path will point to a nested field in a document.
	     *
	     * @param fieldNames A list of field names.
	     */
	    function FieldPath$$1() {
	        var fieldNames = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fieldNames[_i] = arguments[_i];
	        }
	        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
	        for (var i = 0; i < fieldNames.length; ++i) {
	            validateArgType('FieldPath', 'string', i, fieldNames[i]);
	            if (fieldNames[i].length === 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
	                    'Field names must not be empty.');
	            }
	        }
	        this._internalPath = new FieldPath(fieldNames);
	    }
	    FieldPath$$1.documentId = function () {
	        return FieldPath$$1._DOCUMENT_ID;
	    };
	    FieldPath$$1.prototype.isEqual = function (other) {
	        if (!(other instanceof FieldPath$$1)) {
	            throw invalidClassError('isEqual', 'FieldPath', 1, other);
	        }
	        return this._internalPath.isEqual(other._internalPath);
	    };
	    /**
	     * Internal Note: The backend doesn't technically support querying by
	     * document ID. Instead it queries by the entire document name (full path
	     * included), but in the cases we currently support documentId(), the net
	     * effect is the same.
	     */
	    FieldPath$$1._DOCUMENT_ID = new FieldPath$$1(FieldPath.keyField().canonicalString());
	    return FieldPath$$1;
	}());
	/**
	 * Matches any characters in a field path string that are reserved.
	 */
	var RESERVED = new RegExp('[~\\*/\\[\\]]');
	/**
	 * Parses a field path string into a FieldPath, treating dots as separators.
	 */
	function fromDotSeparatedString(path) {
	    var found = path.search(RESERVED);
	    if (found >= 0) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
	            "'~', '*', '/', '[', or ']'");
	    }
	    try {
	        return new (FieldPath$1.bind.apply(FieldPath$1, [void 0].concat(path.split('.'))))();
	    }
	    catch (e) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
	            "begin with '.', end with '.', or contain '..'");
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Describes the online state of the Firestore client. Note that this does not
	 * indicate whether or not the remote store is trying to connect or not. This is
	 * primarily used by the View / EventManager code to change their behavior while
	 * offline (e.g. get() calls shouldn't wait for data from the server and
	 * snapshot events should set metadata.isFromCache=true).
	 */
	var OnlineState;
	(function (OnlineState) {
	    /**
	     * The Firestore client is in an unknown online state. This means the client
	     * is either not actively trying to establish a connection or it is currently
	     * trying to establish a connection, but it has not succeeded or failed yet.
	     * Higher-level components should not operate in offline mode.
	     */
	    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
	    /**
	     * The client is connected and the connections are healthy. This state is
	     * reached after a successful connection and there has been at least one
	     * successful message received from the backends.
	     */
	    OnlineState[OnlineState["Online"] = 1] = "Online";
	    /**
	     * The client is either trying to establish a connection but failing, or it
	     * has been explicitly marked offline via a call to disableNetwork().
	     * Higher-level components should operate in offline mode.
	     */
	    OnlineState[OnlineState["Offline"] = 2] = "Offline";
	})(OnlineState || (OnlineState = {}));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ChangeType;
	(function (ChangeType) {
	    ChangeType[ChangeType["Added"] = 0] = "Added";
	    ChangeType[ChangeType["Removed"] = 1] = "Removed";
	    ChangeType[ChangeType["Modified"] = 2] = "Modified";
	    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
	})(ChangeType || (ChangeType = {}));
	var SyncState;
	(function (SyncState) {
	    SyncState[SyncState["Local"] = 0] = "Local";
	    SyncState[SyncState["Synced"] = 1] = "Synced";
	})(SyncState || (SyncState = {}));
	/**
	 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
	 * duplicate events for the same doc.
	 */
	var DocumentChangeSet = /** @class */ (function () {
	    function DocumentChangeSet() {
	        this.changeMap = new SortedMap(DocumentKey.comparator);
	    }
	    DocumentChangeSet.prototype.track = function (change) {
	        var key = change.doc.key;
	        var oldChange = this.changeMap.get(key);
	        if (!oldChange) {
	            this.changeMap = this.changeMap.insert(key, change);
	            return;
	        }
	        // Merge the new change with the existing change.
	        if (change.type !== ChangeType.Added &&
	            oldChange.type === ChangeType.Metadata) {
	            this.changeMap = this.changeMap.insert(key, change);
	        }
	        else if (change.type === ChangeType.Metadata &&
	            oldChange.type !== ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: oldChange.type,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Added,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.remove(key);
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Removed,
	                doc: oldChange.doc
	            });
	        }
	        else if (change.type === ChangeType.Added &&
	            oldChange.type === ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else {
	            // This includes these cases, which don't make sense:
	            // Added->Added
	            // Removed->Removed
	            // Modified->Added
	            // Removed->Modified
	            // Metadata->Added
	            // Removed->Metadata
	            fail('unsupported combination of changes: ' +
	                JSON.stringify(change) +
	                ' after ' +
	                JSON.stringify(oldChange));
	        }
	    };
	    DocumentChangeSet.prototype.getChanges = function () {
	        var changes = [];
	        this.changeMap.inorderTraversal(function (key, change) {
	            changes.push(change);
	        });
	        return changes;
	    };
	    return DocumentChangeSet;
	}());
	var ViewSnapshot = /** @class */ (function () {
	    function ViewSnapshot(query, docs, oldDocs, docChanges, fromCache, hasPendingWrites, syncStateChanged, excludesMetadataChanges) {
	        this.query = query;
	        this.docs = docs;
	        this.oldDocs = oldDocs;
	        this.docChanges = docChanges;
	        this.fromCache = fromCache;
	        this.hasPendingWrites = hasPendingWrites;
	        this.syncStateChanged = syncStateChanged;
	        this.excludesMetadataChanges = excludesMetadataChanges;
	    }
	    ViewSnapshot.prototype.isEqual = function (other) {
	        if (this.fromCache !== other.fromCache ||
	            this.hasPendingWrites !== other.hasPendingWrites ||
	            this.syncStateChanged !== other.syncStateChanged ||
	            !this.query.isEqual(other.query) ||
	            !this.docs.isEqual(other.docs) ||
	            !this.oldDocs.isEqual(other.oldDocs)) {
	            return false;
	        }
	        var changes = this.docChanges;
	        var otherChanges = other.docChanges;
	        if (changes.length !== otherChanges.length) {
	            return false;
	        }
	        for (var i = 0; i < changes.length; i++) {
	            if (changes[i].type !== otherChanges[i].type ||
	                !changes[i].doc.isEqual(otherChanges[i].doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return ViewSnapshot;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * DocumentSet is an immutable (copy-on-write) collection that holds documents
	 * in order specified by the provided comparator. We always add a document key
	 * comparator on top of what is provided to guarantee document equality based on
	 * the key.
	 */
	var DocumentSet = /** @class */ (function () {
	    /** The default ordering is by key if the comparator is omitted */
	    function DocumentSet(comp) {
	        // We are adding document key comparator to the end as it's the only
	        // guaranteed unique property of a document.
	        if (comp) {
	            this.comparator = function (d1, d2) {
	                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        else {
	            this.comparator = function (d1, d2) {
	                return DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        this.keyedMap = documentMap();
	        this.sortedSet = new SortedMap(this.comparator);
	    }
	    /**
	     * Returns an empty copy of the existing DocumentSet, using the same
	     * comparator.
	     */
	    DocumentSet.emptySet = function (oldSet) {
	        return new DocumentSet(oldSet.comparator);
	    };
	    DocumentSet.prototype.has = function (key) {
	        return this.keyedMap.get(key) != null;
	    };
	    DocumentSet.prototype.get = function (key) {
	        return this.keyedMap.get(key);
	    };
	    DocumentSet.prototype.first = function () {
	        return this.sortedSet.minKey();
	    };
	    DocumentSet.prototype.last = function () {
	        return this.sortedSet.maxKey();
	    };
	    DocumentSet.prototype.isEmpty = function () {
	        return this.sortedSet.isEmpty();
	    };
	    /**
	     * Returns the index of the provided key in the document set, or -1 if the
	     * document key is not present in the set;
	     */
	    DocumentSet.prototype.indexOf = function (key) {
	        var doc = this.keyedMap.get(key);
	        return doc ? this.sortedSet.indexOf(doc) : -1;
	    };
	    Object.defineProperty(DocumentSet.prototype, "size", {
	        get: function () {
	            return this.sortedSet.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Iterates documents in order defined by "comparator" */
	    DocumentSet.prototype.forEach = function (cb) {
	        this.sortedSet.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Inserts or updates a document with the same key */
	    DocumentSet.prototype.add = function (doc) {
	        // First remove the element if we have it.
	        var set = this.delete(doc.key);
	        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
	    };
	    /** Deletes a document with a given key */
	    DocumentSet.prototype.delete = function (key) {
	        var doc = this.get(key);
	        if (!doc) {
	            return this;
	        }
	        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
	    };
	    DocumentSet.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.sortedSet.getIterator();
	        var otherIt = other.sortedSet.getIterator();
	        while (thisIt.hasNext()) {
	            var thisDoc = thisIt.getNext().key;
	            var otherDoc = otherIt.getNext().key;
	            if (!thisDoc.isEqual(otherDoc))
	                return false;
	        }
	        return true;
	    };
	    DocumentSet.prototype.toString = function () {
	        var docStrings = [];
	        this.forEach(function (doc) {
	            docStrings.push(doc.toString());
	        });
	        if (docStrings.length === 0) {
	            return 'DocumentSet ()';
	        }
	        else {
	            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
	        }
	    };
	    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
	        var newSet = new DocumentSet();
	        newSet.comparator = this.comparator;
	        newSet.keyedMap = keyedMap;
	        newSet.sortedSet = sortedSet;
	        return newSet;
	    };
	    return DocumentSet;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A map implementation that uses objects as keys. Objects must implement the
	 * Equatable interface and must be immutable. Entries in the map are stored
	 * together with the key being produced from the mapKeyFn. This map
	 * automatically handles collisions of keys.
	 */
	var ObjectMap = /** @class */ (function () {
	    function ObjectMap(mapKeyFn) {
	        this.mapKeyFn = mapKeyFn;
	        /**
	         * The inner map for a key -> value pair. Due to the possibility of
	         * collisions we keep a list of entries that we do a linear search through
	         * to find an actual match. Note that collisions should be rare, so we still
	         * expect near constant time lookups in practice.
	         */
	        this.inner = {};
	    }
	    /** Get a value for this key, or undefined if it does not exist. */
	    ObjectMap.prototype.get = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return undefined;
	        }
	        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
	            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
	            if (otherKey.isEqual(key)) {
	                return value;
	            }
	        }
	        return undefined;
	    };
	    ObjectMap.prototype.has = function (key) {
	        return this.get(key) !== undefined;
	    };
	    /** Put this key and value in the map. */
	    ObjectMap.prototype.set = function (key, value) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            this.inner[id] = [[key, value]];
	            return;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                matches[i] = [key, value];
	                return;
	            }
	        }
	        matches.push([key, value]);
	    };
	    /**
	     * Remove this key from the map. Returns a boolean if anything was deleted.
	     */
	    ObjectMap.prototype.delete = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return false;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                if (matches.length === 1) {
	                    delete this.inner[id];
	                }
	                else {
	                    matches.splice(i, 1);
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    ObjectMap.prototype.forEach = function (fn) {
	        forEach(this.inner, function (_, entries) {
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var _a = entries_1[_i], k = _a[0], v = _a[1];
	                fn(k, v);
	            }
	        });
	    };
	    ObjectMap.prototype.isEmpty = function () {
	        return isEmpty(this.inner);
	    };
	    return ObjectMap;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Holds the listeners and the last received ViewSnapshot for a query being
	 * tracked by EventManager.
	 */
	var QueryListenersInfo = /** @class */ (function () {
	    function QueryListenersInfo() {
	        this.listeners = [];
	    }
	    return QueryListenersInfo;
	}());
	/**
	 * EventManager is responsible for mapping queries to query event emitters.
	 * It handles "fan-out". -- Identical queries will re-use the same watch on the
	 * backend.
	 */
	var EventManager = /** @class */ (function () {
	    function EventManager(syncEngine) {
	        this.syncEngine = syncEngine;
	        this.queries = new ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.onlineState = OnlineState.Unknown;
	        this.syncEngine.subscribe(this.onChange.bind(this), this.onError.bind(this));
	    }
	    EventManager.prototype.listen = function (listener) {
	        var query = listener.query;
	        var firstListen = false;
	        var queryInfo = this.queries.get(query);
	        if (!queryInfo) {
	            firstListen = true;
	            queryInfo = new QueryListenersInfo();
	            this.queries.set(query, queryInfo);
	        }
	        queryInfo.listeners.push(listener);
	        listener.applyOnlineStateChange(this.onlineState);
	        if (queryInfo.viewSnap)
	            listener.onViewSnapshot(queryInfo.viewSnap);
	        if (firstListen) {
	            return this.syncEngine.listen(query).then(function (targetId) {
	                queryInfo.targetId = targetId;
	                return targetId;
	            });
	        }
	        else {
	            return Promise.resolve(queryInfo.targetId);
	        }
	    };
	    EventManager.prototype.unlisten = function (listener) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var query, lastListen, queryInfo, i;
	            return tslib_1.__generator(this, function (_a) {
	                query = listener.query;
	                lastListen = false;
	                queryInfo = this.queries.get(query);
	                if (queryInfo) {
	                    i = queryInfo.listeners.indexOf(listener);
	                    if (i >= 0) {
	                        queryInfo.listeners.splice(i, 1);
	                        lastListen = queryInfo.listeners.length === 0;
	                    }
	                }
	                if (lastListen) {
	                    this.queries.delete(query);
	                    return [2 /*return*/, this.syncEngine.unlisten(query)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    EventManager.prototype.onChange = function (viewSnaps) {
	        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
	            var viewSnap = viewSnaps_1[_i];
	            var query = viewSnap.query;
	            var queryInfo = this.queries.get(query);
	            if (queryInfo) {
	                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
	                    var listener = _b[_a];
	                    listener.onViewSnapshot(viewSnap);
	                }
	                queryInfo.viewSnap = viewSnap;
	            }
	        }
	    };
	    EventManager.prototype.onError = function (query, error) {
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.onError(error);
	            }
	        }
	        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
	        // after an error.
	        this.queries.delete(query);
	    };
	    EventManager.prototype.applyOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        this.queries.forEach(function (_, queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.applyOnlineStateChange(onlineState);
	            }
	        });
	    };
	    return EventManager;
	}());
	/**
	 * QueryListener takes a series of internal view snapshots and determines
	 * when to raise the event.
	 *
	 * It uses an Observer to dispatch events.
	 */
	var QueryListener = /** @class */ (function () {
	    function QueryListener(query, queryObserver, options) {
	        this.query = query;
	        this.queryObserver = queryObserver;
	        /**
	         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
	         * observer. This flag is set to true once we've actually raised an event.
	         */
	        this.raisedInitialEvent = false;
	        this.onlineState = OnlineState.Unknown;
	        this.options = options || {};
	    }
	    QueryListener.prototype.onViewSnapshot = function (snap) {
	        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
	        if (!this.options.includeMetadataChanges) {
	            // Remove the metadata only changes.
	            var docChanges = [];
	            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
	                var docChange = _a[_i];
	                if (docChange.type !== ChangeType.Metadata) {
	                    docChanges.push(docChange);
	                }
	            }
	            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.fromCache, snap.hasPendingWrites, snap.syncStateChanged, 
	            /* excludesMetadataChanges= */ true);
	        }
	        if (!this.raisedInitialEvent) {
	            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
	                this.raiseInitialEvent(snap);
	            }
	        }
	        else if (this.shouldRaiseEvent(snap)) {
	            this.queryObserver.next(snap);
	        }
	        this.snap = snap;
	    };
	    QueryListener.prototype.onError = function (error) {
	        this.queryObserver.error(error);
	    };
	    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        if (this.snap &&
	            !this.raisedInitialEvent &&
	            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
	            this.raiseInitialEvent(this.snap);
	        }
	    };
	    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
	        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
	        // Always raise the first event when we're synced
	        if (!snap.fromCache) {
	            return true;
	        }
	        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
	        // or Online if we wait long enough).
	        var maybeOnline = onlineState !== OnlineState.Offline;
	        // Don't raise the event if we're online, aren't synced yet (checked
	        // above) and are waiting for a sync.
	        if (this.options.waitForSyncWhenOnline && maybeOnline) {
	            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
	            return false;
	        }
	        // Raise data from cache if we have any documents or we are offline
	        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
	    };
	    QueryListener.prototype.shouldRaiseEvent = function (snap) {
	        // We don't need to handle includeDocumentMetadataChanges here because
	        // the Metadata only changes have already been stripped out if needed.
	        // At this point the only changes we will see are the ones we should
	        // propagate.
	        if (snap.docChanges.length > 0) {
	            return true;
	        }
	        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
	        if (snap.syncStateChanged || hasPendingWritesChanged) {
	            return this.options.includeMetadataChanges === true;
	        }
	        // Generally we should have hit one of the cases above, but it's possible
	        // to get here if there were only metadata docChanges and they got
	        // stripped out.
	        return false;
	    };
	    QueryListener.prototype.raiseInitialEvent = function (snap) {
	        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
	        snap = new ViewSnapshot(snap.query, snap.docs, DocumentSet.emptySet(snap.docs), QueryListener.getInitialViewChanges(snap), snap.fromCache, snap.hasPendingWrites, 
	        /* syncChangesState= */ true, 
	        /* excludesMetadataChanges= */ false);
	        this.raisedInitialEvent = true;
	        this.queryObserver.next(snap);
	    };
	    /** Returns changes as if all documents in the snap were added. */
	    QueryListener.getInitialViewChanges = function (snap) {
	        var result = [];
	        snap.docs.forEach(function (doc) {
	            result.push({ type: ChangeType.Added, doc: doc });
	        });
	        return result;
	    };
	    return QueryListener;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * PersistencePromise<> is essentially a re-implementation of Promise<> except
	 * it has a .next() method instead of .then() and .next() and .catch() callbacks
	 * are executed synchronously when a PersistencePromise resolves rather than
	 * asynchronously (Promise<> implementations use setImmediate() or similar).
	 *
	 * This is necessary to interoperate with IndexedDB which will automatically
	 * commit transactions if control is returned to the event loop without
	 * synchronously initiating another operation on the transaction.
	 *
	 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
	 * Promises.
	 */
	var PersistencePromise = /** @class */ (function () {
	    function PersistencePromise(callback) {
	        var _this = this;
	        // NOTE: next/catchCallback will always point to our own wrapper functions,
	        // not the user's raw next() or catch() callbacks.
	        // tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
	        this.nextCallback = null;
	        // tslint:disable-next-line:no-any Accept any result type for the error handler.
	        this.catchCallback = null;
	        // When the operation resolves, we'll set result or error and mark isDone.
	        this.result = undefined;
	        this.error = undefined;
	        this.isDone = false;
	        // Set to true when .then() or .catch() are called and prevents additional
	        // chaining.
	        this.callbackAttached = false;
	        callback(function (value) {
	            _this.isDone = true;
	            _this.result = value;
	            if (_this.nextCallback) {
	                // value should be defined unless T is Void, but we can't express
	                // that in the type system.
	                _this.nextCallback(value);
	            }
	        }, function (error) {
	            _this.isDone = true;
	            _this.error = error;
	            if (_this.catchCallback) {
	                _this.catchCallback(error);
	            }
	        });
	    }
	    PersistencePromise.prototype.catch = function (fn) {
	        return this.next(undefined, fn);
	    };
	    PersistencePromise.prototype.next = function (nextFn, catchFn) {
	        var _this = this;
	        if (this.callbackAttached) {
	            fail('Called next() or catch() twice for PersistencePromise');
	        }
	        this.callbackAttached = true;
	        if (this.isDone) {
	            if (!this.error) {
	                return this.wrapSuccess(nextFn, this.result);
	            }
	            else {
	                return this.wrapFailure(catchFn, this.error);
	            }
	        }
	        else {
	            return new PersistencePromise(function (resolve, reject) {
	                _this.nextCallback = function (value) {
	                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
	                };
	                _this.catchCallback = function (error) {
	                    _this.wrapFailure(catchFn, error).next(resolve, reject);
	                };
	            });
	        }
	    };
	    PersistencePromise.prototype.toPromise = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.next(resolve, reject);
	        });
	    };
	    PersistencePromise.prototype.wrapUserFunction = function (fn) {
	        try {
	            var result = fn();
	            if (result instanceof PersistencePromise) {
	                return result;
	            }
	            else {
	                return PersistencePromise.resolve(result);
	            }
	        }
	        catch (e) {
	            return PersistencePromise.reject(e);
	        }
	    };
	    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
	        if (nextFn) {
	            return this.wrapUserFunction(function () { return nextFn(value); });
	        }
	        else {
	            // If there's no nextFn, then R must be the same as T but we
	            // can't express that in the type system.
	            // tslint:disable-next-line:no-any
	            return PersistencePromise.resolve(value);
	        }
	    };
	    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
	        if (catchFn) {
	            return this.wrapUserFunction(function () { return catchFn(error); });
	        }
	        else {
	            return PersistencePromise.reject(error);
	        }
	    };
	    PersistencePromise.resolve = function (result) {
	        return new PersistencePromise(function (resolve, reject) {
	            resolve(result);
	        });
	    };
	    PersistencePromise.reject = function (error) {
	        return new PersistencePromise(function (resolve, reject) {
	            reject(error);
	        });
	    };
	    PersistencePromise.waitFor = function (
	    // tslint:disable-next-line:no-any Accept all Promise types in waitFor().
	    all) {
	        var expectedCount = all.length;
	        if (expectedCount === 0) {
	            return PersistencePromise.resolve();
	        }
	        var resolvedCount = 0;
	        return new PersistencePromise(function (resolve, reject) {
	            for (var _i = 0, all_1 = all; _i < all_1.length; _i++) {
	                var promise = all_1[_i];
	                promise.next(function () {
	                    ++resolvedCount;
	                    if (resolvedCount === expectedCount) {
	                        resolve();
	                    }
	                }, function (err) { return reject(err); });
	            }
	        });
	    };
	    PersistencePromise.map = function (all) {
	        var results = [];
	        var promises = [];
	        var _loop_1 = function (i) {
	            promises[i] = all[i].next(function (result) {
	                results[i] = result;
	            });
	        };
	        for (var i = 0; i < all.length; ++i) {
	            _loop_1(i);
	        }
	        return PersistencePromise.waitFor(promises).next(function () {
	            return results;
	        });
	    };
	    return PersistencePromise;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A garbage collector implementation that eagerly collects documents as soon as
	 * they're no longer referenced in any of its registered GarbageSources.
	 *
	 * This implementation keeps track of a set of keys that are potentially garbage
	 * without keeping an exact reference count. During collectGarbage, the
	 * collector verifies that all potential garbage keys actually have no
	 * references by consulting its list of garbage sources.
	 */
	var EagerGarbageCollector = /** @class */ (function () {
	    function EagerGarbageCollector() {
	        this.isEager = true;
	        /**
	         * The garbage collectible sources to double-check during garbage collection.
	         */
	        this.sources = [];
	        /**
	         * A set of potentially garbage keys.
	         * PORTING NOTE: This would be a mutable set if Javascript had one.
	         */
	        this.potentialGarbage = documentKeySet();
	    }
	    EagerGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        this.sources.push(garbageSource);
	        garbageSource.setGarbageCollector(this);
	    };
	    EagerGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        this.sources.splice(this.sources.indexOf(garbageSource), 1);
	        garbageSource.setGarbageCollector(null);
	    };
	    EagerGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        this.potentialGarbage = this.potentialGarbage.add(key);
	    };
	    EagerGarbageCollector.prototype.collectGarbage = function (txn) {
	        var _this = this;
	        var promises = [];
	        var garbageKeys = documentKeySet();
	        this.potentialGarbage.forEach(function (key) {
	            var hasRefsPromise = _this.documentHasAnyReferences(txn, key);
	            promises.push(hasRefsPromise.next(function (hasRefs) {
	                // If there are no references, get the key.
	                if (!hasRefs) {
	                    garbageKeys = garbageKeys.add(key);
	                }
	                return PersistencePromise.resolve();
	            }));
	        });
	        // Clear locally retained potential keys and returned confirmed garbage.
	        this.potentialGarbage = documentKeySet();
	        return PersistencePromise.waitFor(promises).next(function () { return garbageKeys; });
	    };
	    EagerGarbageCollector.prototype.documentHasAnyReferences = function (txn, key) {
	        var initial = PersistencePromise.resolve(false);
	        return this.sources
	            .map(function (source) { return function () { return source.containsKey(txn, key); }; })
	            .reduce(function (promise, nextPromise) {
	            return promise.next(function (result) {
	                if (result) {
	                    return PersistencePromise.resolve(true);
	                }
	                else {
	                    return nextPromise();
	                }
	            });
	        }, initial);
	    };
	    return EagerGarbageCollector;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A set of changes to what documents are currently in view and out of view for
	 * a given query. These changes are sent to the LocalStore by the View (via
	 * the SyncEngine) and are used to pin / unpin documents as appropriate.
	 */
	var LocalViewChanges = /** @class */ (function () {
	    function LocalViewChanges(query, addedKeys, removedKeys) {
	        this.query = query;
	        this.addedKeys = addedKeys;
	        this.removedKeys = removedKeys;
	    }
	    LocalViewChanges.fromSnapshot = function (viewSnapshot) {
	        var addedKeys = documentKeySet();
	        var removedKeys = documentKeySet();
	        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
	            var docChange = _a[_i];
	            switch (docChange.type) {
	                case ChangeType.Added:
	                    addedKeys = addedKeys.add(docChange.doc.key);
	                    break;
	                case ChangeType.Removed:
	                    removedKeys = removedKeys.add(docChange.doc.key);
	                    break;
	                default:
	                // do nothing
	            }
	        }
	        return new LocalViewChanges(viewSnapshot.query, addedKeys, removedKeys);
	    };
	    return LocalViewChanges;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A collection of references to a document from some kind of numbered entity
	 * (either a target ID or batch ID). As references are added to or removed from
	 * the set corresponding events are emitted to a registered garbage collector.
	 *
	 * Each reference is represented by a DocumentReference object. Each of them
	 * contains enough information to uniquely identify the reference. They are all
	 * stored primarily in a set sorted by key. A document is considered garbage if
	 * there's no references in that set (this can be efficiently checked thanks to
	 * sorting by key).
	 *
	 * ReferenceSet also keeps a secondary set that contains references sorted by
	 * IDs. This one is used to efficiently implement removal of all references by
	 * some target ID.
	 */
	var ReferenceSet = /** @class */ (function () {
	    function ReferenceSet() {
	        // A set of outstanding references to a document sorted by key.
	        this.refsByKey = new SortedSet(DocReference.compareByKey);
	        // A set of outstanding references to a document sorted by target id.
	        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
	        /** Keeps track of keys that have references */
	        this.garbageCollector = null;
	    }
	    /** Returns true if the reference set contains no references. */
	    ReferenceSet.prototype.isEmpty = function () {
	        return this.refsByKey.isEmpty();
	    };
	    /** Adds a reference to the given document key for the given ID. */
	    ReferenceSet.prototype.addReference = function (key, id) {
	        var ref = new DocReference(key, id);
	        this.refsByKey = this.refsByKey.add(ref);
	        this.refsByTarget = this.refsByTarget.add(ref);
	    };
	    /** Add references to the given document keys for the given ID. */
	    ReferenceSet.prototype.addReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.addReference(key, id); });
	    };
	    /**
	     * Removes a reference to the given document key for the given
	     * ID.
	     */
	    ReferenceSet.prototype.removeReference = function (key, id) {
	        this.removeRef(new DocReference(key, id));
	    };
	    ReferenceSet.prototype.removeReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.removeReference(key, id); });
	    };
	    /**
	     * Clears all references with a given ID. Calls removeRef() for each key
	     * removed.
	     */
	    ReferenceSet.prototype.removeReferencesForId = function (id) {
	        var _this = this;
	        var emptyKey = DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            _this.removeRef(ref);
	        });
	    };
	    ReferenceSet.prototype.removeAllReferences = function () {
	        var _this = this;
	        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
	    };
	    ReferenceSet.prototype.removeRef = function (ref) {
	        this.refsByKey = this.refsByKey.delete(ref);
	        this.refsByTarget = this.refsByTarget.delete(ref);
	        if (this.garbageCollector !== null) {
	            this.garbageCollector.addPotentialGarbageKey(ref.key);
	        }
	    };
	    ReferenceSet.prototype.referencesForId = function (id) {
	        var emptyKey = DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        var keys = documentKeySet();
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            keys = keys.add(ref.key);
	        });
	        return keys;
	    };
	    ReferenceSet.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    ReferenceSet.prototype.containsKey = function (txn, key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
	        return PersistencePromise.resolve(firstRef !== null && key.isEqual(firstRef.key));
	    };
	    return ReferenceSet;
	}());
	var DocReference = /** @class */ (function () {
	    function DocReference(key, targetOrBatchId) {
	        this.key = key;
	        this.targetOrBatchId = targetOrBatchId;
	    }
	    /** Compare by key then by ID */
	    DocReference.compareByKey = function (left, right) {
	        return (DocumentKey.comparator(left.key, right.key) ||
	            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
	    };
	    /** Compare by ID then by key */
	    DocReference.compareByTargetId = function (left, right) {
	        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
	            DocumentKey.comparator(left.key, right.key));
	    };
	    return DocReference;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RESERVED_BITS = 1;
	var GeneratorIds;
	(function (GeneratorIds) {
	    GeneratorIds[GeneratorIds["LocalStore"] = 0] = "LocalStore";
	    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine";
	})(GeneratorIds || (GeneratorIds = {}));
	/**
	 * TargetIdGenerator generates monotonically increasing integer IDs. There are
	 * separate generators for different scopes. While these generators will operate
	 * independently of each other, they are scoped, such that no two generators
	 * will ever produce the same ID. This is useful, because sometimes the backend
	 * may group IDs from separate parts of the client into the same ID space.
	 */
	var TargetIdGenerator = /** @class */ (function () {
	    function TargetIdGenerator(generatorId, initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        this.generatorId = generatorId;
	        // Replace the generator part of initAfter with this generator's ID.
	        var afterWithoutGenerator = (initAfter >> RESERVED_BITS) << RESERVED_BITS;
	        var afterGenerator = initAfter - afterWithoutGenerator;
	        if (afterGenerator >= generatorId) {
	            // For example, if:
	            //   this.generatorId = 0b0000
	            //   after = 0b1011
	            //   afterGenerator = 0b0001
	            // Then:
	            //   previous = 0b1010
	            //   next = 0b1100
	            this.previousId = afterWithoutGenerator | this.generatorId;
	        }
	        else {
	            // For example, if:
	            //   this.generatorId = 0b0001
	            //   after = 0b1010
	            //   afterGenerator = 0b0000
	            // Then:
	            //   previous = 0b1001
	            //   next = 0b1011
	            this.previousId =
	                (afterWithoutGenerator | this.generatorId) - (1 << RESERVED_BITS);
	        }
	    }
	    TargetIdGenerator.prototype.next = function () {
	        this.previousId += 1 << RESERVED_BITS;
	        return this.previousId;
	    };
	    TargetIdGenerator.forLocalStore = function (initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        return new TargetIdGenerator(GeneratorIds.LocalStore, initAfter);
	    };
	    TargetIdGenerator.forSyncEngine = function () {
	        return new TargetIdGenerator(GeneratorIds.SyncEngine);
	    };
	    return TargetIdGenerator;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AddedLimboDocument = /** @class */ (function () {
	    function AddedLimboDocument(key) {
	        this.key = key;
	    }
	    return AddedLimboDocument;
	}());
	var RemovedLimboDocument = /** @class */ (function () {
	    function RemovedLimboDocument(key) {
	        this.key = key;
	    }
	    return RemovedLimboDocument;
	}());
	/**
	 * View is responsible for computing the final merged truth of what docs are in
	 * a query. It gets notified of local and remote changes to docs, and applies
	 * the query filters and limits to determine the most correct possible results.
	 */
	var View = /** @class */ (function () {
	    function View(query, 
	    /** Documents included in the remote target */
	    _syncedDocuments) {
	        this.query = query;
	        this._syncedDocuments = _syncedDocuments;
	        this.syncState = null;
	        /**
	         * A flag whether the view is current with the backend. A view is considered
	         * current after it has seen the current flag from the backend and did not
	         * lose consistency within the watch stream (e.g. because of an existence
	         * filter mismatch).
	         */
	        this.current = false;
	        /** Documents in the view but not in the remote target */
	        this.limboDocuments = documentKeySet();
	        /** Document Keys that have local changes */
	        this.mutatedKeys = documentKeySet();
	        this.documentSet = new DocumentSet(query.docComparator.bind(query));
	    }
	    Object.defineProperty(View.prototype, "syncedDocuments", {
	        /**
	         * The set of remote documents that the server has told us belongs to the target associated with
	         * this view.
	         */
	        get: function () {
	            return this._syncedDocuments;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Iterates over a set of doc changes, applies the query limit, and computes
	     * what the new results should be, what the changes were, and whether we may
	     * need to go back to the local cache for more results. Does not make any
	     * changes to the view.
	     * @param docChanges The doc changes to apply to this view.
	     * @param previousChanges If this is being called with a refill, then start
	     *        with this set of docs and changes instead of the current view.
	     * @return a new set of docs, changes, and refill flag.
	     */
	    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
	        var _this = this;
	        var changeSet = previousChanges
	            ? previousChanges.changeSet
	            : new DocumentChangeSet();
	        var oldDocumentSet = previousChanges
	            ? previousChanges.documentSet
	            : this.documentSet;
	        var newMutatedKeys = previousChanges
	            ? previousChanges.mutatedKeys
	            : this.mutatedKeys;
	        var newDocumentSet = oldDocumentSet;
	        var needsRefill = false;
	        // Track the last doc in a (full) limit. This is necessary, because some
	        // update (a delete, or an update moving a doc past the old limit) might
	        // mean there is some other document in the local cache that either should
	        // come (1) between the old last limit doc and the new last document, in the
	        // case of updates, or (2) after the new last document, in the case of
	        // deletes. So we keep this doc at the old limit to compare the updates to.
	        //
	        // Note that this should never get used in a refill (when previousChanges is
	        // set), because there will only be adds -- no deletes or updates.
	        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
	            ? oldDocumentSet.last()
	            : null;
	        docChanges.inorderTraversal(function (key, newMaybeDoc) {
	            var oldDoc = oldDocumentSet.get(key);
	            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
	            if (newDoc) {
	                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
	                    key +
	                    ' != ' +
	                    newDoc.key);
	                newDoc = _this.query.matches(newDoc) ? newDoc : null;
	            }
	            if (newDoc) {
	                newDocumentSet = newDocumentSet.add(newDoc);
	                if (newDoc.hasLocalMutations) {
	                    newMutatedKeys = newMutatedKeys.add(key);
	                }
	                else {
	                    newMutatedKeys = newMutatedKeys.delete(key);
	                }
	            }
	            else {
	                newDocumentSet = newDocumentSet.delete(key);
	                newMutatedKeys = newMutatedKeys.delete(key);
	            }
	            // Calculate change
	            if (oldDoc && newDoc) {
	                var docsEqual = oldDoc.data.isEqual(newDoc.data);
	                if (!docsEqual ||
	                    oldDoc.hasLocalMutations !== newDoc.hasLocalMutations) {
	                    // only report a change if document actually changed
	                    if (docsEqual) {
	                        changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
	                    }
	                    else {
	                        changeSet.track({ type: ChangeType.Modified, doc: newDoc });
	                    }
	                    if (lastDocInLimit &&
	                        _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
	                        // This doc moved from inside the limit to after the limit.
	                        // That means there may be some doc in the local cache that's
	                        // actually less than this one.
	                        needsRefill = true;
	                    }
	                }
	            }
	            else if (!oldDoc && newDoc) {
	                changeSet.track({ type: ChangeType.Added, doc: newDoc });
	            }
	            else if (oldDoc && !newDoc) {
	                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
	                if (lastDocInLimit) {
	                    // A doc was removed from a full limit query. We'll need to
	                    // requery from the local cache to see if we know about some other
	                    // doc that should be in the results.
	                    needsRefill = true;
	                }
	            }
	        });
	        if (this.query.hasLimit()) {
	            // TODO(klimt): Make DocumentSet size be constant time.
	            while (newDocumentSet.size > this.query.limit) {
	                var oldDoc = newDocumentSet.last();
	                newDocumentSet = newDocumentSet.delete(oldDoc.key);
	                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
	            }
	        }
	        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
	        return {
	            documentSet: newDocumentSet,
	            changeSet: changeSet,
	            needsRefill: needsRefill,
	            mutatedKeys: newMutatedKeys
	        };
	    };
	    /**
	     * Updates the view with the given ViewDocumentChanges and updates limbo docs
	     * and sync state from the given (optional) target change.
	     * @param docChanges The set of changes to make to the view's docs.
	     * @param targetChange A target change to apply for computing limbo docs and
	     *        sync state.
	     * @return A new ViewChange with the given docs, changes, and sync state.
	     */
	    View.prototype.applyChanges = function (docChanges, targetChange) {
	        var _this = this;
	        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
	        var oldDocs = this.documentSet;
	        this.documentSet = docChanges.documentSet;
	        this.mutatedKeys = docChanges.mutatedKeys;
	        // Sort changes based on type and query comparator
	        var changes = docChanges.changeSet.getChanges();
	        changes.sort(function (c1, c2) {
	            return (compareChangeType(c1.type, c2.type) ||
	                _this.query.docComparator(c1.doc, c2.doc));
	        });
	        this.applyTargetChange(targetChange);
	        var limboChanges = this.updateLimboDocuments();
	        var synced = this.limboDocuments.size === 0 && this.current;
	        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
	        var syncStateChanged = newSyncState !== this.syncState;
	        this.syncState = newSyncState;
	        if (changes.length === 0 && !syncStateChanged) {
	            // no changes
	            return { limboChanges: limboChanges };
	        }
	        else {
	            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, newSyncState === SyncState.Local, !docChanges.mutatedKeys.isEmpty(), syncStateChanged, 
	            /* excludesMetadataChanges= */ false);
	            return {
	                snapshot: snap,
	                limboChanges: limboChanges
	            };
	        }
	    };
	    /**
	     * Applies an OnlineState change to the view, potentially generating a
	     * ViewChange if the view's syncState changes as a result.
	     */
	    View.prototype.applyOnlineStateChange = function (onlineState) {
	        if (this.current && onlineState === OnlineState.Offline) {
	            // If we're offline, set `current` to false and then call applyChanges()
	            // to refresh our syncState and generate a ViewChange as appropriate. We
	            // are guaranteed to get a new TargetChange that sets `current` back to
	            // true once the client is back online.
	            this.current = false;
	            return this.applyChanges({
	                documentSet: this.documentSet,
	                changeSet: new DocumentChangeSet(),
	                mutatedKeys: this.mutatedKeys,
	                needsRefill: false
	            });
	        }
	        else {
	            // No effect, just return a no-op ViewChange.
	            return { limboChanges: [] };
	        }
	    };
	    /**
	     * Returns whether the doc for the given key should be in limbo.
	     */
	    View.prototype.shouldBeInLimbo = function (key) {
	        // If the remote end says it's part of this query, it's not in limbo.
	        if (this._syncedDocuments.has(key)) {
	            return false;
	        }
	        // The local store doesn't think it's a result, so it shouldn't be in limbo.
	        if (!this.documentSet.has(key)) {
	            return false;
	        }
	        // If there are local changes to the doc, they might explain why the server
	        // doesn't know that it's part of the query. So don't put it in limbo.
	        // TODO(klimt): Ideally, we would only consider changes that might actually
	        // affect this specific query.
	        if (this.documentSet.get(key).hasLocalMutations) {
	            return false;
	        }
	        // Everything else is in limbo.
	        return true;
	    };
	    /**
	     * Updates syncedDocuments, current, and limbo docs based on the given change.
	     * Returns the list of changes to which docs are in limbo.
	     */
	    View.prototype.applyTargetChange = function (targetChange) {
	        if (targetChange) {
	            var targetMapping = targetChange.mapping;
	            if (targetMapping instanceof ResetMapping) {
	                this._syncedDocuments = targetMapping.documents;
	            }
	            else if (targetMapping instanceof UpdateMapping) {
	                this._syncedDocuments = targetMapping.applyToKeySet(this._syncedDocuments);
	            }
	            switch (targetChange.currentStatusUpdate) {
	                case CurrentStatusUpdate.MarkCurrent:
	                    this.current = true;
	                    break;
	                case CurrentStatusUpdate.MarkNotCurrent:
	                    this.current = false;
	                    break;
	                case CurrentStatusUpdate.None:
	                    break;
	                default:
	                    fail('Unknown current status update: ' + targetChange.currentStatusUpdate);
	            }
	        }
	    };
	    View.prototype.updateLimboDocuments = function () {
	        var _this = this;
	        // We can only determine limbo documents when we're in-sync with the server.
	        if (!this.current) {
	            return [];
	        }
	        // TODO(klimt): Do this incrementally so that it's not quadratic when
	        // updating many documents.
	        var oldLimboDocuments = this.limboDocuments;
	        this.limboDocuments = documentKeySet();
	        this.documentSet.forEach(function (doc) {
	            if (_this.shouldBeInLimbo(doc.key)) {
	                _this.limboDocuments = _this.limboDocuments.add(doc.key);
	            }
	        });
	        // Diff the new limbo docs with the old limbo docs.
	        var changes = [];
	        oldLimboDocuments.forEach(function (key) {
	            if (!_this.limboDocuments.has(key)) {
	                changes.push(new RemovedLimboDocument(key));
	            }
	        });
	        this.limboDocuments.forEach(function (key) {
	            if (!oldLimboDocuments.has(key)) {
	                changes.push(new AddedLimboDocument(key));
	            }
	        });
	        return changes;
	    };
	    return View;
	}());
	function compareChangeType(c1, c2) {
	    var order = function (change) {
	        switch (change) {
	            case ChangeType.Added:
	                return 1;
	            case ChangeType.Modified:
	                return 2;
	            case ChangeType.Metadata:
	                // A metadata change is converted to a modified change at the public
	                // api layer.  Since we sort by document key and then change type,
	                // metadata and modified changes must be sorted equivalently.
	                return 2;
	            case ChangeType.Removed:
	                return 0;
	            default:
	                return fail('Unknown ChangeType: ' + change);
	        }
	    };
	    return order(c1) - order(c2);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$1 = 'SyncEngine';
	/**
	 * QueryView contains all of the data that SyncEngine needs to keep track of for
	 * a particular query.
	 */
	var QueryView = /** @class */ (function () {
	    function QueryView(
	    /**
	     * The query itself.
	     */
	    query, 
	    /**
	     * The target number created by the client that is used in the watch
	     * stream to identify this query.
	     */
	    targetId, 
	    /**
	     * An identifier from the datastore backend that indicates the last state
	     * of the results that was received. This can be used to indicate where
	     * to continue receiving new doc changes for the query.
	     */
	    resumeToken, 
	    /**
	     * The view is responsible for computing the final merged truth of what
	     * docs are in the query. It gets notified of local and remote changes,
	     * and applies the query filters and limits to determine the most correct
	     * possible results.
	     */
	    view) {
	        this.query = query;
	        this.targetId = targetId;
	        this.resumeToken = resumeToken;
	        this.view = view;
	    }
	    return QueryView;
	}());
	/**
	 * SyncEngine is the central controller in the client SDK architecture. It is
	 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
	 * SyncEngine's responsibilities include:
	 * 1. Coordinating client requests and remote events between the EventManager
	 *    and the local and remote data stores.
	 * 2. Managing a View object for each query, providing the unified view between
	 *    the local and remote data stores.
	 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
	 *    queue that need sending to the backend.
	 *
	 * The SyncEngine’s methods should only ever be called by methods running in the
	 * global async queue.
	 */
	var SyncEngine = /** @class */ (function () {
	    function SyncEngine(localStore, remoteStore, currentUser) {
	        this.localStore = localStore;
	        this.remoteStore = remoteStore;
	        this.currentUser = currentUser;
	        this.viewHandler = null;
	        this.errorHandler = null;
	        this.queryViewsByQuery = new ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.queryViewsByTarget = {};
	        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
	        this.limboKeysByTarget = {};
	        this.limboDocumentRefs = new ReferenceSet();
	        this.limboCollector = new EagerGarbageCollector();
	        /** Stores user completion handlers, indexed by User and BatchId. */
	        this.mutationUserCallbacks = {};
	        this.targetIdGenerator = TargetIdGenerator.forSyncEngine();
	    }
	    /** Subscribes view and error handler. Can be called only once. */
	    SyncEngine.prototype.subscribe = function (viewHandler, errorHandler) {
	        assert(viewHandler !== null && errorHandler !== null, 'View and error handlers cannot be null');
	        assert(this.viewHandler === null && this.errorHandler === null, 'SyncEngine already has a subscriber.');
	        this.viewHandler = viewHandler;
	        this.errorHandler = errorHandler;
	        this.limboCollector.addGarbageSource(this.limboDocumentRefs);
	    };
	    /**
	     * Initiates the new listen, resolves promise when listen enqueued to the
	     * server. All the subsequent view snapshots or errors are sent to the
	     * subscribed handlers. Returns the targetId of the query.
	     */
	    SyncEngine.prototype.listen = function (query) {
	        var _this = this;
	        this.assertSubscribed('listen()');
	        assert(!this.queryViewsByQuery.has(query), 'We already listen to the query: ' + query);
	        return this.localStore.allocateQuery(query).then(function (queryData) {
	            return _this.localStore
	                .executeQuery(query)
	                .then(function (docs) {
	                return _this.localStore
	                    .remoteDocumentKeys(queryData.targetId)
	                    .then(function (remoteKeys) {
	                    var view = new View(query, remoteKeys);
	                    var viewDocChanges = view.computeDocChanges(docs);
	                    var viewChange = view.applyChanges(viewDocChanges);
	                    assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
	                    assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
	                    var data = new QueryView(query, queryData.targetId, queryData.resumeToken, view);
	                    _this.queryViewsByQuery.set(query, data);
	                    _this.queryViewsByTarget[queryData.targetId] = data;
	                    _this.viewHandler([viewChange.snapshot]);
	                    _this.remoteStore.listen(queryData);
	                });
	            })
	                .then(function () {
	                return queryData.targetId;
	            });
	        });
	    };
	    /** Stops listening to the query. */
	    SyncEngine.prototype.unlisten = function (query) {
	        var _this = this;
	        this.assertSubscribed('unlisten()');
	        var queryView = this.queryViewsByQuery.get(query);
	        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
	        return this.localStore.releaseQuery(query).then(function () {
	            _this.remoteStore.unlisten(queryView.targetId);
	            return _this.removeAndCleanupQuery(queryView).then(function () {
	                return _this.localStore.collectGarbage();
	            });
	        });
	    };
	    /**
	     * Initiates the write of local mutation batch which involves adding the
	     * writes to the mutation queue, notifying the remote store about new
	     * mutations and raising events for any changes this write caused.
	     *
	     * The promise returned by this call is resolved when the above steps
	     * have completed, *not* when the write was acked by the backend. The
	     * userCallback is resolved once the write was acked/rejected by the
	     * backend (or failed locally for any other reason).
	     */
	    SyncEngine.prototype.write = function (batch, userCallback) {
	        var _this = this;
	        this.assertSubscribed('write()');
	        return this.localStore
	            .localWrite(batch)
	            .then(function (result) {
	            _this.addMutationCallback(result.batchId, userCallback);
	            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
	        })
	            .then(function () {
	            return _this.remoteStore.fillWritePipeline();
	        });
	    };
	    // TODO(klimt): Wrap the given error in a standard Firestore error object.
	    SyncEngine.prototype.wrapUpdateFunctionError = function (error$$1) {
	        return error$$1;
	    };
	    /**
	     * Takes an updateFunction in which a set of reads and writes can be performed
	     * atomically. In the updateFunction, the client can read and write values
	     * using the supplied transaction object. After the updateFunction, all
	     * changes will be committed. If some other client has changed any of the data
	     * referenced, then the updateFunction will be called again. If the
	     * updateFunction still fails after the given number of retries, then the
	     * transaction will be rejection.
	     *
	     * The transaction object passed to the updateFunction contains methods for
	     * accessing documents and collections. Unlike other datastore access, data
	     * accessed with the transaction will not reflect local changes that have not
	     * been committed. For this reason, it is required that all reads are
	     * performed before any writes. Transactions must be performed while online.
	     *
	     * The promise returned is resolved when the transaction is fully committed.
	     */
	    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
	        var _this = this;
	        if (retries === void 0) { retries = 5; }
	        assert(retries >= 0, 'Got negative number of retries for transaction.');
	        var transaction = this.remoteStore.createTransaction();
	        var wrappedUpdateFunction = function () {
	            try {
	                var userPromise = updateFunction(transaction);
	                if (isNullOrUndefined(userPromise) ||
	                    !userPromise.catch ||
	                    !userPromise.then) {
	                    return Promise.reject(Error('Transaction callback must return a Promise'));
	                }
	                return userPromise.catch(function (e) {
	                    return Promise.reject(_this.wrapUpdateFunctionError(e));
	                });
	            }
	            catch (e) {
	                return Promise.reject(_this.wrapUpdateFunctionError(e));
	            }
	        };
	        return wrappedUpdateFunction().then(function (result) {
	            return transaction
	                .commit()
	                .then(function () {
	                return result;
	            })
	                .catch(function (error$$1) {
	                if (retries === 0) {
	                    return Promise.reject(error$$1);
	                }
	                // TODO(klimt): Put in a retry delay?
	                return _this.runTransaction(updateFunction, retries - 1);
	            });
	        });
	    };
	    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        this.assertSubscribed('applyRemoteEvent()');
	        // Make sure limbo documents are deleted if there were no results.
	        // Filter out document additions to targets that they already belong to.
	        forEachNumber(remoteEvent.targetChanges, function (targetId, targetChange) {
	            var limboKey = _this.limboKeysByTarget[targetId];
	            if (!limboKey) {
	                var qv = _this.queryViewsByTarget[targetId];
	                assert(!!qv, 'Missing QueryView for non-limbo query: ' + targetId);
	                targetChange.mapping.filterUpdates(qv.view.syncedDocuments);
	            }
	            else {
	                remoteEvent.synthesizeDeleteForLimboTargetChange(targetChange, limboKey);
	            }
	        });
	        return this.localStore.applyRemoteEvent(remoteEvent).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
	        });
	    };
	    /**
	     * Applies an OnlineState change to the sync engine and notifies any views of
	     * the change.
	     */
	    SyncEngine.prototype.applyOnlineStateChange = function (onlineState) {
	        var newViewSnapshots = [];
	        this.queryViewsByQuery.forEach(function (query, queryView) {
	            var viewChange = queryView.view.applyOnlineStateChange(onlineState);
	            assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
	            if (viewChange.snapshot) {
	                newViewSnapshots.push(viewChange.snapshot);
	            }
	        });
	        this.viewHandler(newViewSnapshots);
	    };
	    SyncEngine.prototype.rejectListen = function (targetId, err) {
	        var _this = this;
	        this.assertSubscribed('rejectListens()');
	        var limboKey = this.limboKeysByTarget[targetId];
	        if (limboKey) {
	            // Since this query failed, we won't want to manually unlisten to it.
	            // So go ahead and remove it from bookkeeping.
	            this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
	            delete this.limboKeysByTarget[targetId];
	            // TODO(klimt): We really only should do the following on permission
	            // denied errors, but we don't have the cause code here.
	            // It's a limbo doc. Create a synthetic event saying it was deleted.
	            // This is kind of a hack. Ideally, we would have a method in the local
	            // store to purge a document. However, it would be tricky to keep all of
	            // the local store's invariants with another method.
	            var docMap = new SortedMap(DocumentKey.comparator);
	            docMap = docMap.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
	            var limboDocuments = documentKeySet().add(limboKey);
	            var event_1 = new RemoteEvent(SnapshotVersion.MIN, {}, docMap, limboDocuments);
	            return this.applyRemoteEvent(event_1);
	        }
	        else {
	            var queryView_1 = this.queryViewsByTarget[targetId];
	            assert(!!queryView_1, 'Unknown targetId: ' + targetId);
	            return this.localStore.releaseQuery(queryView_1.query).then(function () {
	                return _this.removeAndCleanupQuery(queryView_1).then(function () {
	                    _this.errorHandler(queryView_1.query, err);
	                });
	            });
	        }
	    };
	    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
	        var _this = this;
	        this.assertSubscribed('applySuccessfulWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught
	        // up), so we raise user callbacks first so that they consistently happen
	        // before listen events.
	        this.processUserCallback(mutationBatchResult.batch.batchId, 
	        /*error=*/ null);
	        return this.localStore
	            .acknowledgeBatch(mutationBatchResult)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.rejectFailedWrite = function (batchId, error$$1) {
	        var _this = this;
	        this.assertSubscribed('rejectFailedWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught up),
	        // so we raise user callbacks first so that they consistently happen before
	        // listen events.
	        this.processUserCallback(batchId, error$$1);
	        return this.localStore.rejectBatch(batchId).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        if (!newCallbacks) {
	            newCallbacks = new SortedMap(primitiveComparator);
	        }
	        newCallbacks = newCallbacks.insert(batchId, callback);
	        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	    };
	    /**
	     * Resolves or rejects the user callback for the given batch and then discards
	     * it.
	     */
	    SyncEngine.prototype.processUserCallback = function (batchId, error$$1) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        // NOTE: Mutations restored from persistence won't have callbacks, so it's
	        // okay for there to be no callback for this ID.
	        if (newCallbacks) {
	            var callback = newCallbacks.get(batchId);
	            if (callback) {
	                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
	                if (error$$1) {
	                    callback.reject(error$$1);
	                }
	                else {
	                    callback.resolve();
	                }
	                newCallbacks = newCallbacks.remove(batchId);
	            }
	            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	        }
	    };
	    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
	        this.queryViewsByQuery.delete(queryView.query);
	        delete this.queryViewsByTarget[queryView.targetId];
	        this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
	        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
	            var limboChange = limboChanges_1[_i];
	            if (limboChange instanceof AddedLimboDocument) {
	                this.limboDocumentRefs.addReference(limboChange.key, targetId);
	                this.trackLimboChange(limboChange);
	            }
	            else if (limboChange instanceof RemovedLimboDocument) {
	                debug(LOG_TAG$1, 'Document no longer in limbo: ' + limboChange.key);
	                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
	            }
	            else {
	                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
	            }
	        }
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.trackLimboChange = function (limboChange) {
	        var key = limboChange.key;
	        if (!this.limboTargetsByKey.get(key)) {
	            debug(LOG_TAG$1, 'New document in limbo: ' + key);
	            var limboTargetId = this.targetIdGenerator.next();
	            var query = Query.atPath(key.path);
	            this.limboKeysByTarget[limboTargetId] = key;
	            this.remoteStore.listen(new QueryData(query, limboTargetId, QueryPurpose.Listen));
	            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
	        }
	    };
	    SyncEngine.prototype.gcLimboDocuments = function () {
	        var _this = this;
	        // HACK: We can use a null transaction here, because we know that the
	        // reference set is entirely within memory and doesn't need a store engine.
	        return this.limboCollector
	            .collectGarbage(null)
	            .next(function (keys) {
	            keys.forEach(function (key) {
	                var limboTargetId = _this.limboTargetsByKey.get(key);
	                if (limboTargetId === null) {
	                    // This target already got removed, because the query failed.
	                    return;
	                }
	                _this.remoteStore.unlisten(limboTargetId);
	                _this.limboTargetsByKey = _this.limboTargetsByKey.remove(key);
	                delete _this.limboKeysByTarget[limboTargetId];
	            });
	        })
	            .toPromise();
	    };
	    // Visible for testing
	    SyncEngine.prototype.currentLimboDocs = function () {
	        return this.limboTargetsByKey;
	    };
	    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
	        var _this = this;
	        var newSnaps = [];
	        var docChangesInAllViews = [];
	        var queriesProcessed = [];
	        this.queryViewsByQuery.forEach(function (_, queryView) {
	            queriesProcessed.push(Promise.resolve()
	                .then(function () {
	                var viewDocChanges = queryView.view.computeDocChanges(changes);
	                if (!viewDocChanges.needsRefill) {
	                    return viewDocChanges;
	                }
	                // The query has a limit and some docs were removed, so we need
	                // to re-run the query against the local store to make sure we
	                // didn't lose any good docs that had been past the limit.
	                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
	                    return queryView.view.computeDocChanges(docs, viewDocChanges);
	                });
	            })
	                .then(function (viewDocChanges) {
	                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
	                var viewChange = queryView.view.applyChanges(viewDocChanges, targetChange);
	                return _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges).then(function () {
	                    if (viewChange.snapshot) {
	                        newSnaps.push(viewChange.snapshot);
	                        var docChanges = LocalViewChanges.fromSnapshot(viewChange.snapshot);
	                        docChangesInAllViews.push(docChanges);
	                    }
	                });
	            }));
	        });
	        return Promise.all(queriesProcessed)
	            .then(function () {
	            _this.viewHandler(newSnaps);
	            return _this.localStore.notifyLocalViewChanges(docChangesInAllViews);
	        })
	            .then(function () {
	            return _this.localStore.collectGarbage();
	        });
	    };
	    SyncEngine.prototype.assertSubscribed = function (fnName) {
	        assert(this.viewHandler !== null && this.errorHandler !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
	    };
	    SyncEngine.prototype.handleUserChange = function (user) {
	        var _this = this;
	        this.currentUser = user;
	        return this.localStore
	            .handleUserChange(user)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        })
	            .then(function () {
	            return _this.remoteStore.handleUserChange(user);
	        });
	    };
	    return SyncEngine;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var BATCHID_UNKNOWN = -1;
	/**
	 * A batch of mutations that will be sent as one unit to the backend.
	 */
	var MutationBatch = /** @class */ (function () {
	    function MutationBatch(batchId, localWriteTime, mutations) {
	        this.batchId = batchId;
	        this.localWriteTime = localWriteTime;
	        this.mutations = mutations;
	    }
	    /**
	     * Applies all the mutations in this MutationBatch to the specified document
	     * to create a new remote document
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     * @param batchResult The result of applying the MutationBatch to the
	     * backend.
	     */
	    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var mutationResults = batchResult.mutationResults;
	        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.isEqual(docKey)) {
	                var mutationResult = mutationResults[i];
	                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
	            }
	        }
	        return maybeDoc;
	    };
	    /**
	     * Computes the local view of a document given all the mutations in this
	     * batch.
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     */
	    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var baseDoc = maybeDoc;
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.isEqual(docKey)) {
	                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
	            }
	        }
	        return maybeDoc;
	    };
	    MutationBatch.prototype.keys = function () {
	        var keySet = documentKeySet();
	        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
	            var mutation = _a[_i];
	            keySet = keySet.add(mutation.key);
	        }
	        return keySet;
	    };
	    MutationBatch.prototype.isEqual = function (other) {
	        return (this.batchId === other.batchId &&
	            arrayEquals(this.mutations, other.mutations));
	    };
	    /**
	     * Returns true if this mutation batch has already been removed from the
	     * mutation queue.
	     *
	     * Note that not all implementations of the MutationQueue necessarily use
	     * tombstones as part of their implementation and generally speaking no code
	     * outside the mutation queues should really care about this.
	     */
	    MutationBatch.prototype.isTombstone = function () {
	        return this.mutations.length === 0;
	    };
	    /** Converts this batch into a tombstone */
	    MutationBatch.prototype.toTombstone = function () {
	        return new MutationBatch(this.batchId, this.localWriteTime, []);
	    };
	    return MutationBatch;
	}());
	/** The result of applying a mutation batch to the backend. */
	var MutationBatchResult = /** @class */ (function () {
	    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
	    /**
	     * A pre-computed mapping from each mutated document to the resulting
	     * version.
	     */
	    docVersions) {
	        this.batch = batch;
	        this.commitVersion = commitVersion;
	        this.mutationResults = mutationResults;
	        this.streamToken = streamToken;
	        this.docVersions = docVersions;
	    }
	    /**
	     * Creates a new MutationBatchResult for the given batch and results. There
	     * must be one result for each mutation in the batch. This static factory
	     * caches a document=>version mapping (docVersions).
	     */
	    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
	        assert(batch.mutations.length === results.length, 'Mutations sent ' +
	            batch.mutations.length +
	            ' must equal results received ' +
	            results.length);
	        var versionMap = documentVersionMap();
	        var mutations = batch.mutations;
	        for (var i = 0; i < mutations.length; i++) {
	            var version = results[i].version;
	            if (version === null) {
	                // deletes don't have a version, so we substitute the commitVersion
	                // of the entire batch.
	                version = commitVersion;
	            }
	            versionMap = versionMap.insert(mutations[i].key, version);
	        }
	        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
	    };
	    return MutationBatchResult;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var escapeChar = '\u0001';
	var encodedSeparatorChar = '\u0001';
	var encodedNul = '\u0010';
	var encodedEscape = '\u0011';
	/**
	 * Encodes a resource path into a IndexedDb-compatible string form.
	 */
	function encode(path) {
	    var result = '';
	    for (var i = 0; i < path.length; i++) {
	        if (result.length > 0) {
	            result = encodeSeparator(result);
	        }
	        result = encodeSegment(path.get(i), result);
	    }
	    return encodeSeparator(result);
	}
	/** Encodes a single segment of a resource path into the given result */
	function encodeSegment(segment, resultBuf) {
	    var result = resultBuf;
	    var length = segment.length;
	    for (var i = 0; i < length; i++) {
	        var c = segment.charAt(i);
	        switch (c) {
	            case '\0':
	                result += escapeChar + encodedNul;
	                break;
	            case escapeChar:
	                result += escapeChar + encodedEscape;
	                break;
	            default:
	                result += c;
	        }
	    }
	    return result;
	}
	/** Encodes a path separator into the given result */
	function encodeSeparator(result) {
	    return result + escapeChar + encodedSeparatorChar;
	}
	/**
	 * Decodes the given IndexedDb-compatible string form of a resource path into
	 * a ResourcePath instance. Note that this method is not suitable for use with
	 * decoding resource names from the server; those are One Platform format
	 * strings.
	 */
	function decode$1(path) {
	    // Event the empty path must encode as a path of at least length 2. A path
	    // with exactly 2 must be the empty path.
	    var length = path.length;
	    assert(length >= 2, 'Invalid path ' + path);
	    if (length === 2) {
	        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
	        return ResourcePath.EMPTY_PATH;
	    }
	    // Escape characters cannot exist past the second-to-last position in the
	    // source value.
	    var lastReasonableEscapeIndex = length - 2;
	    var segments = [];
	    var segmentBuilder = '';
	    for (var start = 0; start < length;) {
	        // The last two characters of a valid encoded path must be a separator, so
	        // there must be an end to this segment.
	        var end = path.indexOf(escapeChar, start);
	        if (end < 0 || end > lastReasonableEscapeIndex) {
	            fail('Invalid encoded resource path: "' + path + '"');
	        }
	        var next = path.charAt(end + 1);
	        switch (next) {
	            case encodedSeparatorChar:
	                var currentPiece = path.substring(start, end);
	                var segment = void 0;
	                if (segmentBuilder.length === 0) {
	                    // Avoid copying for the common case of a segment that excludes \0
	                    // and \001
	                    segment = currentPiece;
	                }
	                else {
	                    segmentBuilder += currentPiece;
	                    segment = segmentBuilder;
	                    segmentBuilder = '';
	                }
	                segments.push(segment);
	                break;
	            case encodedNul:
	                segmentBuilder += path.substring(start, end);
	                segmentBuilder += '\0';
	                break;
	            case encodedEscape:
	                // The escape character can be used in the output to encode itself.
	                segmentBuilder += path.substring(start, end + 1);
	                break;
	            default:
	                fail('Invalid encoded resource path: "' + path + '"');
	        }
	        start = end + 2;
	    }
	    return new ResourcePath(segments);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Schema Version for the Web client:
	 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
	 *    Cache
	 * 2. Added targetCount to targetGlobal row.
	 */
	var SCHEMA_VERSION = 2;
	/**
	 * Performs database creation and schema upgrades.
	 *
	 * Note that in production, this method is only ever used to upgrade the schema
	 * to SCHEMA_VERSION. Different values of toVersion are only used for testing
	 * and local feature development.
	 */
	function createOrUpgradeDb(db, txn, fromVersion, toVersion) {
	    // This function currently supports migrating to schema version 1 (Mutation
	    // Queue, Query and Remote Document Cache) and schema version 2 (Query
	    // counting).
	    assert(fromVersion < toVersion && fromVersion >= 0 && toVersion <= 2, 'Unexpected schema upgrade from v${fromVersion} to v{toVersion}.');
	    if (fromVersion < 1 && toVersion >= 1) {
	        createOwnerStore(db);
	        createMutationQueue(db);
	        createQueryCache(db);
	        createRemoteDocumentCache(db);
	    }
	    var p = PersistencePromise.resolve();
	    if (fromVersion < 2 && toVersion >= 2) {
	        p = ensureTargetGlobalExists(txn).next(function (targetGlobal) {
	            return saveTargetCount(txn, targetGlobal);
	        });
	    }
	    return p;
	}
	/**
	 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
	 */
	var DbTimestamp = /** @class */ (function () {
	    function DbTimestamp(seconds, nanoseconds) {
	        this.seconds = seconds;
	        this.nanoseconds = nanoseconds;
	    }
	    return DbTimestamp;
	}());
	/**
	 * A singleton object to be stored in the 'owner' store in IndexedDb.
	 *
	 * A given database can be owned by a single tab at a given time. That tab
	 * must validate that it is still the owner before every write operation and
	 * should regularly write an updated timestamp to prevent other tabs from
	 * "stealing" ownership of the db.
	 */
	var DbOwner = /** @class */ (function () {
	    function DbOwner(ownerId, leaseTimestampMs) {
	        this.ownerId = ownerId;
	        this.leaseTimestampMs = leaseTimestampMs;
	    }
	    /** Name of the IndexedDb object store. */
	    DbOwner.store = 'owner';
	    return DbOwner;
	}());
	function createOwnerStore(db) {
	    db.createObjectStore(DbOwner.store);
	}
	/**
	 * An object to be stored in the 'mutationQueues' store in IndexedDb.
	 *
	 * Each user gets a single queue of MutationBatches to apply to the server.
	 * DbMutationQueue tracks the metadata about the queue.
	 */
	var DbMutationQueue = /** @class */ (function () {
	    function DbMutationQueue(
	    /**
	     * The normalized user ID to which this queue belongs.
	     */
	    userId, 
	    /**
	     * An identifier for the highest numbered batch that has been acknowledged
	     * by the server. All MutationBatches in this queue with batchIds less
	     * than or equal to this value are considered to have been acknowledged by
	     * the server.
	     */
	    lastAcknowledgedBatchId, 
	    /**
	     * A stream token that was previously sent by the server.
	     *
	     * See StreamingWriteRequest in datastore.proto for more details about
	     * usage.
	     *
	     * After sending this token, earlier tokens may not be used anymore so
	     * only a single stream token is retained.
	     */
	    lastStreamToken) {
	        this.userId = userId;
	        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
	        this.lastStreamToken = lastStreamToken;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationQueue.store = 'mutationQueues';
	    /** Keys are automatically assigned via the userId property. */
	    DbMutationQueue.keyPath = 'userId';
	    return DbMutationQueue;
	}());
	/**
	 * An object to be stored in the 'mutations' store in IndexedDb.
	 *
	 * Represents a batch of user-level mutations intended to be sent to the server
	 * in a single write. Each user-level batch gets a separate DbMutationBatch
	 * with a new batchId.
	 */
	var DbMutationBatch = /** @class */ (function () {
	    function DbMutationBatch(
	    /**
	     * The normalized user ID to which this batch belongs.
	     */
	    userId, 
	    /**
	     * An identifier for this batch, allocated by the mutation queue in a
	     * monotonically increasing manner.
	     */
	    batchId, 
	    /**
	     * The local write time of the batch, stored as milliseconds since the
	     * epoch.
	     */
	    localWriteTimeMs, 
	    /**
	     * A list of mutations to apply. All mutations will be applied atomically.
	     *
	     * Mutations are serialized via JsonProtoSerializer.toMutation().
	     */
	    mutations) {
	        this.userId = userId;
	        this.batchId = batchId;
	        this.localWriteTimeMs = localWriteTimeMs;
	        this.mutations = mutations;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationBatch.store = 'mutations';
	    /** Keys are automatically assigned via the userId, batchId properties. */
	    DbMutationBatch.keyPath = ['userId', 'batchId'];
	    return DbMutationBatch;
	}());
	function createMutationQueue(db) {
	    db.createObjectStore(DbMutationQueue.store, {
	        keyPath: DbMutationQueue.keyPath
	    });
	    db.createObjectStore(DbMutationBatch.store, {
	        keyPath: DbMutationBatch.keyPath
	    });
	    db.createObjectStore(DbDocumentMutation.store);
	}
	/**
	 * An object to be stored in the 'documentMutations' store in IndexedDb.
	 *
	 * A manually maintained index of all the mutation batches that affect a given
	 * document key. The rows in this table are references based on the contents of
	 * DbMutationBatch.mutations.
	 */
	var DbDocumentMutation = /** @class */ (function () {
	    function DbDocumentMutation() {
	    }
	    /**
	     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
	     * over all of a user's document mutations.
	     */
	    DbDocumentMutation.prefixForUser = function (userId) {
	        return [userId];
	    };
	    /**
	     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
	     * index to iterate over all at document mutations for a given path or lower.
	     */
	    DbDocumentMutation.prefixForPath = function (userId, path) {
	        return [userId, encode(path)];
	    };
	    /**
	     * Creates a full index key of [userId, encodedPath, batchId] for inserting
	     * and deleting into the DbDocumentMutations index.
	     */
	    DbDocumentMutation.key = function (userId, path, batchId) {
	        return [userId, encode(path), batchId];
	    };
	    DbDocumentMutation.store = 'documentMutations';
	    /**
	     * Because we store all the useful information for this store in the key,
	     * there is no useful information to store as the value. The raw (unencoded)
	     * path cannot be stored because IndexedDb doesn't store prototype
	     * information.
	     */
	    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
	    return DbDocumentMutation;
	}());
	function createRemoteDocumentCache(db) {
	    db.createObjectStore(DbRemoteDocument.store);
	}
	/**
	 * Represents the known absence of a document at a particular version.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */
	var DbNoDocument = /** @class */ (function () {
	    function DbNoDocument(path, readTime) {
	        this.path = path;
	        this.readTime = readTime;
	    }
	    return DbNoDocument;
	}());
	/**
	 * An object to be stored in the 'remoteDocuments' store in IndexedDb. It
	 * represents either a cached document (if it exists) or a cached "no-document"
	 * (if it is known to not exist).
	 *
	 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
	 * be made more general if necessary.
	 */
	var DbRemoteDocument = /** @class */ (function () {
	    function DbRemoteDocument(
	    /**
	     * Set to an instance of a DbNoDocument if it is known that no document
	     * exists.
	     */
	    noDocument, 
	    /**
	     * Set to an instance of a Document if there's a cached version of the
	     * document.
	     */
	    document) {
	        this.noDocument = noDocument;
	        this.document = document;
	    }
	    DbRemoteDocument.store = 'remoteDocuments';
	    return DbRemoteDocument;
	}());
	/**
	 * An object to be stored in the 'targets' store in IndexedDb.
	 *
	 * This is based on and should be kept in sync with the proto used in the iOS
	 * client.
	 *
	 * Each query the client listens to against the server is tracked on disk so
	 * that the query can be efficiently resumed on restart.
	 */
	var DbTarget = /** @class */ (function () {
	    function DbTarget(
	    /**
	     * An auto-generated sequential numeric identifier for the query.
	     *
	     * Queries are stored using their canonicalId as the key, but these
	     * canonicalIds can be quite long so we additionally assign a unique
	     * queryId which can be used by referenced data structures (e.g.
	     * indexes) to minimize the on-disk cost.
	     */
	    targetId, 
	    /**
	     * The canonical string representing this query. This is not unique.
	     */
	    canonicalId, 
	    /**
	     * The last readTime received from the Watch Service for this query.
	     *
	     * This is the same value as TargetChange.read_time in the protos.
	     */
	    readTime, 
	    /**
	     * An opaque, server-assigned token that allows watching a query to be
	     * resumed after disconnecting without retransmitting all the data
	     * that matches the query. The resume token essentially identifies a
	     * point in time from which the server should resume sending results.
	     *
	     * This is related to the snapshotVersion in that the resumeToken
	     * effectively also encodes that value, but the resumeToken is opaque
	     * and sometimes encodes additional information.
	     *
	     * A consequence of this is that the resumeToken should be used when
	     * asking the server to reason about where this client is in the watch
	     * stream, but the client should use the snapshotVersion for its own
	     * purposes.
	     *
	     * This is the same value as TargetChange.resume_token in the protos.
	     */
	    resumeToken, 
	    /**
	     * A sequence number representing the last time this query was
	     * listened to, used for garbage collection purposes.
	     *
	     * Conventionally this would be a timestamp value, but device-local
	     * clocks are unreliable and they must be able to create new listens
	     * even while disconnected. Instead this should be a monotonically
	     * increasing number that's incremented on each listen call.
	     *
	     * This is different from the queryId since the queryId is an
	     * immutable identifier assigned to the Query on first use while
	     * lastListenSequenceNumber is updated every time the query is
	     * listened to.
	     */
	    lastListenSequenceNumber, 
	    /**
	     * The query for this target.
	     *
	     * Because canonical ids are not unique we must store the actual query. We
	     * use the proto to have an object we can persist without having to
	     * duplicate translation logic to and from a `Query` object.
	     */
	    query) {
	        this.targetId = targetId;
	        this.canonicalId = canonicalId;
	        this.readTime = readTime;
	        this.resumeToken = resumeToken;
	        this.lastListenSequenceNumber = lastListenSequenceNumber;
	        this.query = query;
	    }
	    DbTarget.store = 'targets';
	    /** Keys are automatically assigned via the targetId property. */
	    DbTarget.keyPath = 'targetId';
	    /** The name of the queryTargets index. */
	    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
	    /**
	     * The index of all canonicalIds to the targets that they match. This is not
	     * a unique mapping because canonicalId does not promise a unique name for all
	     * possible queries, so we append the targetId to make the mapping unique.
	     */
	    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
	    return DbTarget;
	}());
	/**
	 * An object representing an association between a target and a document.
	 * Stored in the targetDocument object store to store the documents tracked by a
	 * particular target.
	 */
	var DbTargetDocument = /** @class */ (function () {
	    function DbTargetDocument(
	    /**
	     * The targetId identifying a target.
	     */
	    targetId, 
	    /**
	     * The path to the document, as encoded in the key.
	     */
	    path) {
	        this.targetId = targetId;
	        this.path = path;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbTargetDocument.store = 'targetDocuments';
	    /** Keys are automatically assigned via the targetId, path properties. */
	    DbTargetDocument.keyPath = ['targetId', 'path'];
	    /** The index name for the reverse index. */
	    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
	    /** We also need to create the reverse index for these properties. */
	    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
	    return DbTargetDocument;
	}());
	/**
	 * A record of global state tracked across all Targets, tracked separately
	 * to avoid the need for extra indexes.
	 *
	 * This should be kept in-sync with the proto used in the iOS client.
	 */
	var DbTargetGlobal = /** @class */ (function () {
	    function DbTargetGlobal(
	    /**
	     * The highest numbered target id across all targets.
	     *
	     * See DbTarget.targetId.
	     */
	    highestTargetId, 
	    /**
	     * The highest numbered lastListenSequenceNumber across all targets.
	     *
	     * See DbTarget.lastListenSequenceNumber.
	     */
	    highestListenSequenceNumber, 
	    /**
	     * A global snapshot version representing the last consistent snapshot we
	     * received from the backend. This is monotonically increasing and any
	     * snapshots received from the backend prior to this version (e.g. for
	     * targets resumed with a resumeToken) should be suppressed (buffered)
	     * until the backend has caught up to this snapshot version again. This
	     * prevents our cache from ever going backwards in time.
	     */
	    lastRemoteSnapshotVersion, 
	    /**
	     * The number of targets persisted.
	     */
	    targetCount) {
	        this.highestTargetId = highestTargetId;
	        this.highestListenSequenceNumber = highestListenSequenceNumber;
	        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
	        this.targetCount = targetCount;
	    }
	    /**
	     * The key string used for the single object that exists in the
	     * DbTargetGlobal store.
	     */
	    DbTargetGlobal.key = 'targetGlobalKey';
	    DbTargetGlobal.store = 'targetGlobal';
	    return DbTargetGlobal;
	}());
	function createQueryCache(db) {
	    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
	        keyPath: DbTargetDocument.keyPath
	    });
	    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
	    var targetStore = db.createObjectStore(DbTarget.store, {
	        keyPath: DbTarget.keyPath
	    });
	    // NOTE: This is unique only because the TargetId is the suffix.
	    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
	    db.createObjectStore(DbTargetGlobal.store);
	}
	/**
	 * Counts the number of targets persisted and adds that value to the target
	 * global singleton.
	 */
	function saveTargetCount(txn, metadata) {
	    var globalStore = txn.store(DbTargetGlobal.store);
	    var targetStore = txn.store(DbTarget.store);
	    return targetStore.count().next(function (count) {
	        metadata.targetCount = count;
	        return globalStore.put(DbTargetGlobal.key, metadata);
	    });
	}
	/**
	 * Ensures that the target global singleton row exists by adding it if it's
	 * missing.
	 *
	 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
	 */
	function ensureTargetGlobalExists(txn) {
	    var globalStore = txn.store(DbTargetGlobal.store);
	    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
	        if (metadata != null) {
	            return PersistencePromise.resolve(metadata);
	        }
	        else {
	            metadata = new DbTargetGlobal(
	            /*highestTargetId=*/ 0, 
	            /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
	            /*targetCount=*/ 0);
	            return globalStore.put(DbTargetGlobal.key, metadata).next(function () { return metadata; });
	        }
	    });
	}
	/**
	 * The list of all default IndexedDB stores used throughout the SDK. This is
	 * used when creating transactions so that access across all stores is done
	 * atomically.
	 */
	var ALL_STORES = [
	    DbMutationQueue.store,
	    DbMutationBatch.store,
	    DbDocumentMutation.store,
	    DbRemoteDocument.store,
	    DbTarget.store,
	    DbOwner.store,
	    DbTargetGlobal.store,
	    DbTargetDocument.store
	];
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred$1 = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    return Deferred;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$2 = 'SimpleDb';
	/**
	 * Provides a wrapper around IndexedDb with a simplified interface that uses
	 * Promise-like return values to chain operations. Real promises cannot be used
	 * since .then() continuations are executed asynchronously (e.g. via
	 * .setImmediate), which would cause IndexedDB to end the transaction.
	 * See PersistencePromise for more details.
	 */
	var SimpleDb = /** @class */ (function () {
	    function SimpleDb(db) {
	        this.db = db;
	    }
	    /** Opens the specified database, creating or upgrading it if necessary. */
	    SimpleDb.openOrCreate = function (name, version, runUpgrade) {
	        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
	        debug(LOG_TAG$2, 'Opening database:', name);
	        return new PersistencePromise(function (resolve, reject) {
	            // TODO(mikelehen): Investigate browser compatibility.
	            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
	            // suggests IE9 and older WebKit browsers handle upgrade
	            // differently. They expect setVersion, as described here:
	            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
	            var request = window.indexedDB.open(name, version);
	            request.onsuccess = function (event) {
	                var db = event.target.result;
	                resolve(new SimpleDb(db));
	            };
	            request.onerror = function (event) {
	                reject(event.target.error);
	            };
	            request.onupgradeneeded = function (event) {
	                debug(LOG_TAG$2, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
	                var db = event.target.result;
	                // We are provided a version upgrade transaction from the request, so
	                // we wrap that in a SimpleDbTransaction to allow use of our friendlier
	                // API for schema migration operations.
	                var txn = new SimpleDbTransaction(request.transaction);
	                runUpgrade(db, txn, event.oldVersion, SCHEMA_VERSION).next(function () {
	                    debug(LOG_TAG$2, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
	                });
	            };
	        }).toPromise();
	    };
	    /** Deletes the specified database. */
	    SimpleDb.delete = function (name) {
	        debug(LOG_TAG$2, 'Removing database:', name);
	        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
	    };
	    /** Returns true if IndexedDB is available in the current environment. */
	    SimpleDb.isAvailable = function () {
	        if (typeof window === 'undefined' || window.indexedDB == null) {
	            return false;
	        }
	        // We extensively use indexed array values and compound keys,
	        // which IE and Edge do not support. However, they still have indexedDB
	        // defined on the window, so we need to check for them here and make sure
	        // to return that persistence is not enabled for those browsers.
	        // For tracking support of this feature, see here:
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
	        // If we are running in Node using the IndexedDBShim, `window` is defined,
	        // but `window.navigator` is not. In this case, we support IndexedDB and
	        // return `true`.
	        if (window.navigator === undefined) {
	            return ({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES';
	        }
	        // Check the UA string to find out the browser.
	        // TODO(mikelehen): Move this logic into packages/util/environment.ts
	        var ua = window.navigator.userAgent;
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
	        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        if (ua.indexOf('MSIE ') > 0 ||
	            ua.indexOf('Trident/') > 0 ||
	            ua.indexOf('Edge/') > 0) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
	        var transaction = SimpleDbTransaction.open(this.db, mode, objectStores);
	        var transactionFnResult = transactionFn(transaction)
	            .catch(function (error$$1) {
	            // Abort the transaction if there was an error.
	            transaction.abort(error$$1);
	        })
	            .toPromise();
	        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	        // fire), but still return the original transactionFnResult back to the
	        // caller.
	        return transaction.completionPromise.then(function () { return transactionFnResult; });
	    };
	    SimpleDb.prototype.close = function () {
	        this.db.close();
	    };
	    return SimpleDb;
	}());
	/**
	 * A controller for iterating over a key range or index. It allows an iterate
	 * callback to delete the currently-referenced object, or jump to a new key
	 * within the key range or index.
	 */
	var IterationController = /** @class */ (function () {
	    function IterationController(dbCursor) {
	        this.dbCursor = dbCursor;
	        this.shouldStop = false;
	        this.nextKey = null;
	    }
	    Object.defineProperty(IterationController.prototype, "isDone", {
	        get: function () {
	            return this.shouldStop;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "skipToKey", {
	        get: function () {
	            return this.nextKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "cursor", {
	        set: function (value) {
	            this.dbCursor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * This function can be called to stop iteration at any point.
	     */
	    IterationController.prototype.done = function () {
	        this.shouldStop = true;
	    };
	    /**
	     * This function can be called to skip to that next key, which could be
	     * an index or a primary key.
	     */
	    IterationController.prototype.skip = function (key) {
	        this.nextKey = key;
	    };
	    /**
	     * Delete the current cursor value from the object store.
	     *
	     * NOTE: You CANNOT do this with a keysOnly query.
	     */
	    IterationController.prototype.delete = function () {
	        return wrapRequest(this.dbCursor.delete());
	    };
	    return IterationController;
	}());
	/**
	 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
	 * specific object store.
	 */
	var SimpleDbTransaction = /** @class */ (function () {
	    function SimpleDbTransaction(transaction) {
	        var _this = this;
	        this.transaction = transaction;
	        this.aborted = false;
	        /**
	         * A promise that resolves with the result of the IndexedDb transaction.
	         */
	        this.completionDeferred = new Deferred$1();
	        this.transaction.oncomplete = function () {
	            _this.completionDeferred.resolve();
	        };
	        this.transaction.onabort = function () {
	            if (transaction.error) {
	                _this.completionDeferred.reject(transaction.error);
	            }
	            else {
	                _this.completionDeferred.resolve();
	            }
	        };
	        this.transaction.onerror = function (event) {
	            _this.completionDeferred.reject(event.target.error);
	        };
	    }
	    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
	        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
	    };
	    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
	        get: function () {
	            return this.completionDeferred.promise;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SimpleDbTransaction.prototype.abort = function (error$$1) {
	        if (error$$1) {
	            this.completionDeferred.reject(error$$1);
	        }
	        if (!this.aborted) {
	            debug(LOG_TAG$2, 'Aborting transaction: %s', error$$1 ? error$$1.message : 'Client-initiated abort');
	            this.aborted = true;
	            this.transaction.abort();
	        }
	    };
	    /**
	     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
	     * operations performed on the SimpleDbStore happen within the context of this
	     * transaction and it cannot be used anymore once the transaction is
	     * completed.
	     *
	     * Note that we can't actually enforce that the KeyType and ValueType are
	     * correct, but they allow type safety through the rest of the consuming code.
	     */
	    SimpleDbTransaction.prototype.store = function (storeName) {
	        var store = this.transaction.objectStore(storeName);
	        assert(!!store, 'Object store not part of transaction: ' + storeName);
	        return new SimpleDbStore(store);
	    };
	    return SimpleDbTransaction;
	}());
	/**
	 * A wrapper around an IDBObjectStore providing an API that:
	 *
	 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
	 * methods for acting against the object store.
	 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
	 * method return a PersistencePromise instead.
	 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
	 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
	 */
	var SimpleDbStore = /** @class */ (function () {
	    function SimpleDbStore(store) {
	        this.store = store;
	    }
	    SimpleDbStore.prototype.put = function (keyOrValue, value) {
	        var request;
	        if (value !== undefined) {
	            debug(LOG_TAG$2, 'PUT', this.store.name, keyOrValue, value);
	            request = this.store.put(value, keyOrValue);
	        }
	        else {
	            debug(LOG_TAG$2, 'PUT', this.store.name, '<auto-key>', keyOrValue);
	            request = this.store.put(keyOrValue);
	        }
	        return wrapRequest(request);
	    };
	    /**
	     * Gets the object with the specified key from the specified store, or null
	     * if no object exists with the specified key.
	     *
	     * @key The key of the object to get.
	     * @return The object with the specified key or null if no object exists.
	     */
	    SimpleDbStore.prototype.get = function (key) {
	        var _this = this;
	        var request = this.store.get(key);
	        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
	        return wrapRequest(request).next(function (result) {
	            // Normalize nonexistence to null.
	            if (result === undefined) {
	                result = null;
	            }
	            debug(LOG_TAG$2, 'GET', _this.store.name, key, result);
	            return result;
	        });
	    };
	    SimpleDbStore.prototype.delete = function (key) {
	        debug(LOG_TAG$2, 'DELETE', this.store.name, key);
	        var request = this.store.delete(key);
	        return wrapRequest(request);
	    };
	    /**
	     * If we ever need more of the count variants, we can add overloads. For now,
	     * all we need is to count everything in a store.
	     *
	     * Returns the number of rows in the store.
	     */
	    SimpleDbStore.prototype.count = function () {
	        debug(LOG_TAG$2, 'COUNT', this.store.name);
	        var request = this.store.count();
	        return wrapRequest(request);
	    };
	    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
	        var cursor = this.cursor(this.options(indexOrRange, range));
	        var results = [];
	        return this.iterateCursor(cursor, function (key, value) {
	            results.push(value);
	        }).next(function () {
	            return results;
	        });
	    };
	    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
	        debug(LOG_TAG$2, 'DELETE ALL', this.store.name);
	        var options = this.options(indexOrRange, range);
	        options.keysOnly = false;
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, function (key, value, control) {
	            // NOTE: Calling delete() on a cursor is documented as more efficient than
	            // calling delete() on an object store with a single key
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
	            // however, this requires us *not* to use a keysOnly cursor
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
	            // may want to compare the performance of each method.
	            return control.delete();
	        });
	    };
	    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
	        var options;
	        if (!callback) {
	            options = {};
	            callback = optionsOrCallback;
	        }
	        else {
	            options = optionsOrCallback;
	        }
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, callback);
	    };
	    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
	        var results = [];
	        return new PersistencePromise(function (resolve, reject) {
	            cursorRequest.onerror = function (event) {
	                reject(event.target.error);
	            };
	            cursorRequest.onsuccess = function (event) {
	                var cursor = event.target.result;
	                if (!cursor) {
	                    resolve();
	                    return;
	                }
	                var controller = new IterationController(cursor);
	                var userResult = fn(cursor.primaryKey, cursor.value, controller);
	                if (userResult instanceof PersistencePromise) {
	                    results.push(userResult);
	                }
	                if (controller.isDone) {
	                    resolve();
	                }
	                else if (controller.skipToKey === null) {
	                    cursor.continue();
	                }
	                else {
	                    cursor.continue(controller.skipToKey);
	                }
	            };
	        }).next(function () {
	            return PersistencePromise.waitFor(results);
	        });
	    };
	    SimpleDbStore.prototype.options = function (indexOrRange, range) {
	        var indexName = undefined;
	        if (indexOrRange !== undefined) {
	            if (typeof indexOrRange === 'string') {
	                indexName = indexOrRange;
	            }
	            else {
	                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
	                range = indexOrRange;
	            }
	        }
	        return { index: indexName, range: range };
	    };
	    SimpleDbStore.prototype.cursor = function (options) {
	        var direction = 'next';
	        if (options.reverse) {
	            direction = 'prev';
	        }
	        if (options.index) {
	            var index = this.store.index(options.index);
	            if (options.keysOnly) {
	                return index.openKeyCursor(options.range, direction);
	            }
	            else {
	                return index.openCursor(options.range, direction);
	            }
	        }
	        else {
	            return this.store.openCursor(options.range, direction);
	        }
	    };
	    return SimpleDbStore;
	}());
	/**
	 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
	 * handlers to resolve / reject the PersistencePromise as appropriate.
	 */
	function wrapRequest(request) {
	    return new PersistencePromise(function (resolve, reject) {
	        request.onsuccess = function (event) {
	            var result = event.target.result;
	            resolve(result);
	        };
	        request.onerror = function (event) {
	            reject(event.target.error);
	        };
	    });
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** A mutation queue for a specific user, backed by IndexedDB. */
	var IndexedDbMutationQueue = /** @class */ (function () {
	    function IndexedDbMutationQueue(
	    /**
	     * The normalized userId (e.g. null UID => "" userId) used to store /
	     * retrieve mutations.
	     */
	    userId, serializer) {
	        this.userId = userId;
	        this.serializer = serializer;
	        this.garbageCollector = null;
	    }
	    /**
	     * Creates a new mutation queue for the given user.
	     * @param user The user for which to create a mutation queue.
	     * @param serializer The serializer to use when persisting to IndexedDb.
	     */
	    IndexedDbMutationQueue.forUser = function (user, serializer) {
	        // TODO(mcg): Figure out what constraints there are on userIDs
	        // In particular, are there any reserved characters? are empty ids allowed?
	        // For the moment store these together in the same mutations table assuming
	        // that empty userIDs aren't allowed.
	        assert(user.uid !== '', 'UserID must not be an empty string.');
	        var userId = user.isAuthenticated() ? user.uid : '';
	        return new IndexedDbMutationQueue(userId, serializer);
	    };
	    IndexedDbMutationQueue.prototype.start = function (transaction) {
	        var _this = this;
	        return IndexedDbMutationQueue.loadNextBatchIdFromDb(transaction)
	            .next(function (nextBatchId) {
	            _this.nextBatchId = nextBatchId;
	            return mutationQueuesStore(transaction).get(_this.userId);
	        })
	            .next(function (metadata) {
	            if (!metadata) {
	                metadata = new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
	                /*lastStreamToken=*/ '');
	            }
	            _this.metadata = metadata;
	            // On restart, nextBatchId may end up lower than
	            // lastAcknowledgedBatchId since it's computed from the queue
	            // contents, and there may be no mutations in the queue. In this
	            // case, we need to reset lastAcknowledgedBatchId (which is safe
	            // since the queue must be empty).
	            if (_this.metadata.lastAcknowledgedBatchId >= _this.nextBatchId) {
	                return _this.checkEmpty(transaction).next(function (empty) {
	                    assert(empty, 'Reset nextBatchID is only possible when the queue is empty');
	                    _this.metadata.lastAcknowledgedBatchId = BATCHID_UNKNOWN;
	                    return mutationQueuesStore(transaction).put(_this.metadata);
	                });
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns one larger than the largest batch ID that has been stored. If there
	     * are no mutations returns 0. Note that batch IDs are global.
	     */
	    IndexedDbMutationQueue.loadNextBatchIdFromDb = function (txn) {
	        var maxBatchId = BATCHID_UNKNOWN;
	        return mutationsStore(txn)
	            .iterate({ reverse: true }, function (key, batch, control) {
	            var userId = key[0], batchId = key[1];
	            if (batchId > maxBatchId) {
	                maxBatchId = batch.batchId;
	            }
	            if (userId === '') {
	                // We can't compute a predecessor for the empty string, since it
	                // is lexographically first. That also means that no other
	                // userIds can come before this one, so we can just exit early.
	                control.done();
	            }
	            else {
	                var nextUser = immediatePredecessor(userId);
	                control.skip([nextUser]);
	            }
	        })
	            .next(function () { return maxBatchId + 1; });
	    };
	    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
	        var empty = true;
	        var range = IDBKeyRange.bound(this.keyForBatchId(Number.NEGATIVE_INFINITY), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, value, control) {
	            empty = false;
	            control.done();
	        })
	            .next(function () { return empty; });
	    };
	    IndexedDbMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return PersistencePromise.resolve(this.nextBatchId);
	    };
	    IndexedDbMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return PersistencePromise.resolve(this.metadata.lastAcknowledgedBatchId);
	    };
	    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert(batchId > this.metadata.lastAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        this.metadata.lastAcknowledgedBatchId = batchId;
	        this.metadata.lastStreamToken = convertStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return PersistencePromise.resolve(this.metadata.lastStreamToken);
	    };
	    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.metadata.lastStreamToken = convertStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        var _this = this;
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        var batch = new MutationBatch(batchId, localWriteTime, mutations);
	        var dbBatch = this.serializer.toDbMutationBatch(this.userId, batch);
	        return mutationsStore(transaction)
	            .put(dbBatch)
	            .next(function () {
	            var promises = [];
	            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	                var mutation = mutations_1[_i];
	                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
	                promises.push(documentMutationsStore(transaction).put(indexKey, DbDocumentMutation.PLACEHOLDER));
	            }
	            return PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            return batch;
	        });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        var _this = this;
	        return mutationsStore(transaction)
	            .get(this.keyForBatchId(batchId))
	            .next(function (dbBatch) {
	            return dbBatch ? _this.serializer.fromDbMutationBatch(dbBatch) : null;
	        });
	    };
	    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var _this = this;
	        // All batches with batchId <= this.metadata.lastAcknowledgedBatchId have
	        // been acknowledged so the first unacknowledged batch after batchID will
	        // have a batchID larger than both of these values.
	        var nextBatchId = Math.max(batchId, this.metadata.lastAcknowledgedBatchId) + 1;
	        var range = IDBKeyRange.lowerBound(this.keyForBatchId(nextBatchId));
	        var foundBatch = null;
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, dbBatch, control) {
	            if (dbBatch.userId === _this.userId) {
	                assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
	                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
	            }
	            control.done();
	        })
	            .next(function () { return foundBatch; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(BATCHID_UNKNOWN), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(BATCHID_UNKNOWN), this.keyForBatchId(batchId));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        // Scan the document-mutation index starting with a prefix starting with
	        // the given documentKey.
	        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        var results = [];
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            // Only consider rows matching exactly the specific key of
	            // interest. Note that because we order by path first, and we
	            // order terminators before path separators, we'll encounter all
	            // the index rows for documentKey contiguously. In particular, all
	            // the rows for documentKey will occur before any rows for
	            // documents nested in a subcollection beneath documentKey so we
	            // can stop as soon as we hit any such row.
	            var path = decode$1(encodedPath);
	            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
	                control.done();
	                return;
	            }
	            var mutationKey = _this.keyForBatchId(batchID);
	            // Look up the mutation batch in the store.
	            // PORTING NOTE: because iteration is callback driven in the web,
	            // we just look up the key instead of keeping an open iterator
	            // like iOS.
	            return mutationsStore(transaction)
	                .get(mutationKey)
	                .next(function (dbBatch) {
	                if (dbBatch === null) {
	                    fail('Dangling document-mutation reference found: ' +
	                        indexKey +
	                        ' which points to ' +
	                        mutationKey);
	                }
	                results.push(_this.serializer.fromDbMutationBatch(dbBatch));
	            });
	        })
	            .next(function () { return results; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
	        var queryPath = query.path;
	        var immediateChildrenLength = queryPath.length + 1;
	        // TODO(mcg): Actually implement a single-collection query
	        //
	        // This is actually executing an ancestor query, traversing the whole
	        // subtree below the collection which can be horrifically inefficient for
	        // some structures. The right way to solve this is to implement the full
	        // value index, but that's not in the cards in the near future so this is
	        // the best we can do for the moment.
	        //
	        // Since we don't yet index the actual properties in the mutations, our
	        // current approach is to just return all mutation batches that affect
	        // documents in the collection being queried.
	        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        // Collect up unique batchIDs encountered during a scan of the index. Use a
	        // SortedSet to accumulate batch IDs so they can be traversed in order in a
	        // scan of the main table.
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            var path = decode$1(encodedPath);
	            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
	                control.done();
	                return;
	            }
	            // Rows with document keys more than one segment longer than the
	            // query path can't be matches. For example, a query on 'rooms'
	            // can't match the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            if (path.length !== immediateChildrenLength) {
	                return;
	            }
	            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
	        })
	            .next(function () {
	            var results = [];
	            var promises = [];
	            // TODO(rockwood): Implement this using iterate.
	            uniqueBatchIDs.forEach(function (batchID) {
	                var mutationKey = _this.keyForBatchId(batchID);
	                promises.push(mutationsStore(transaction)
	                    .get(mutationKey)
	                    .next(function (mutation) {
	                    if (mutation === null) {
	                        fail('Dangling document-mutation reference found, ' +
	                            'which points to ' +
	                            mutationKey);
	                    }
	                    results.push(_this.serializer.fromDbMutationBatch(mutation));
	                }));
	            });
	            return PersistencePromise.waitFor(promises).next(function () { return results; });
	        });
	    };
	    IndexedDbMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var txn = mutationsStore(transaction);
	        var indexTxn = documentMutationsStore(transaction);
	        var promises = [];
	        var _loop_1 = function (batch) {
	            var range = IDBKeyRange.only(this_1.keyForBatchId(batch.batchId));
	            var numDeleted = 0;
	            var removePromise = txn.iterate({ range: range }, function (key, value, control) {
	                numDeleted++;
	                return control.delete();
	            });
	            promises.push(removePromise.next(function () {
	                assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
	                    batch.batchId);
	            }));
	            for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
	                var mutation = _a[_i];
	                var indexKey = DbDocumentMutation.key(this_1.userId, mutation.key.path, batch.batchId);
	                promises.push(indexTxn.delete(indexKey));
	                if (this_1.garbageCollector !== null) {
	                    this_1.garbageCollector.addPotentialGarbageKey(mutation.key);
	                }
	            }
	        };
	        var this_1 = this;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            _loop_1(batch);
	        }
	        return PersistencePromise.waitFor(promises);
	    };
	    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        var _this = this;
	        return this.checkEmpty(txn).next(function (empty) {
	            if (!empty) {
	                return PersistencePromise.resolve();
	            }
	            // Verify that there are no entries in the documentMutations index if
	            // the queue is empty.
	            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
	            var danglingMutationReferences = [];
	            return documentMutationsStore(txn)
	                .iterate({ range: startRange }, function (key, _, control) {
	                var userID = key[0];
	                if (userID !== _this.userId) {
	                    control.done();
	                    return;
	                }
	                else {
	                    var path = decode$1(key[1]);
	                    danglingMutationReferences.push(path);
	                }
	            })
	                .next(function () {
	                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. Dangling keys: ' +
	                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
	            });
	        });
	    };
	    IndexedDbMutationQueue.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
	        var _this = this;
	        var indexKey = DbDocumentMutation.prefixForPath(this.userId, key.path);
	        var encodedPath = indexKey[1];
	        var startRange = IDBKeyRange.lowerBound(indexKey);
	        var containsKey = false;
	        return documentMutationsStore(txn)
	            .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
	            var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
	            if (userID === _this.userId && keyPath === encodedPath) {
	                containsKey = true;
	            }
	            control.done();
	        })
	            .next(function () { return containsKey; });
	    };
	    /**
	     * Creates a [userId, batchId] key for use with the DbMutationQueue object
	     * store.
	     */
	    IndexedDbMutationQueue.prototype.keyForBatchId = function (batchId) {
	        return [this.userId, batchId];
	    };
	    return IndexedDbMutationQueue;
	}());
	function convertStreamToken(token) {
	    if (token instanceof Uint8Array) {
	        // TODO(b/78771403): Convert tokens to strings during deserialization
	        assert(({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence .');
	        return token.toString();
	    }
	    else {
	        return token;
	    }
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutations object store.
	 */
	function mutationsStore(txn) {
	    return getStore(txn, DbMutationBatch.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function documentMutationsStore(txn) {
	    return getStore(txn, DbDocumentMutation.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function mutationQueuesStore(txn) {
	    return getStore(txn, DbMutationQueue.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore(txn, store) {
	    if (txn instanceof SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return fail('Invalid transaction object provided!');
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var IndexedDbQueryCache = /** @class */ (function () {
	    function IndexedDbQueryCache(serializer) {
	        this.serializer = serializer;
	        /**
	         * The last received snapshot version. We store this seperately from the
	         * metadata to avoid the extra conversion to/from DbTimestamp.
	         */
	        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
	        /**
	         * A cached copy of the metadata for the query cache.
	         */
	        this.metadata = null;
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	    }
	    IndexedDbQueryCache.prototype.start = function (transaction) {
	        var _this = this;
	        return globalTargetStore(transaction)
	            .get(DbTargetGlobal.key)
	            .next(function (metadata) {
	            assert(metadata !== null, 'Missing metadata row that should be added by schema migration.');
	            _this.metadata = metadata;
	            var lastSavedVersion = metadata.lastRemoteSnapshotVersion;
	            _this.lastRemoteSnapshotVersion = SnapshotVersion.fromTimestamp(new Timestamp(lastSavedVersion.seconds, lastSavedVersion.nanoseconds));
	            return PersistencePromise.resolve();
	        });
	    };
	    IndexedDbQueryCache.prototype.getHighestTargetId = function () {
	        return this.metadata.highestTargetId;
	    };
	    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    IndexedDbQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        this.metadata.lastRemoteSnapshotVersion = snapshotVersion.toTimestamp();
	        return globalTargetStore(transaction).put(DbTargetGlobal.key, this.metadata);
	    };
	    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        var _this = this;
	        return this.saveQueryData(transaction, queryData).next(function () {
	            _this.metadata.targetCount += 1;
	            _this.updateMetadataFromQueryData(queryData);
	            return _this.saveMetadata(transaction);
	        });
	    };
	    IndexedDbQueryCache.prototype.updateQueryData = function (transaction, queryData) {
	        var _this = this;
	        return this.saveQueryData(transaction, queryData).next(function () {
	            if (_this.updateMetadataFromQueryData(queryData)) {
	                return _this.saveMetadata(transaction);
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        });
	    };
	    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        var _this = this;
	        assert(this.metadata.targetCount > 0, 'Removing from an empty query cache');
	        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId)
	            .next(function () { return targetsStore(transaction).delete(queryData.targetId); })
	            .next(function () {
	            _this.metadata.targetCount -= 1;
	            return _this.saveMetadata(transaction);
	        });
	    };
	    IndexedDbQueryCache.prototype.saveMetadata = function (transaction) {
	        return globalTargetStore(transaction).put(DbTargetGlobal.key, this.metadata);
	    };
	    IndexedDbQueryCache.prototype.saveQueryData = function (transaction, queryData) {
	        return targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
	    };
	    /**
	     * Updates the in-memory version of the metadata to account for values in the
	     * given QueryData. Saving is done separately. Returns true if there were any
	     * changes to the metadata.
	     */
	    IndexedDbQueryCache.prototype.updateMetadataFromQueryData = function (queryData) {
	        var needsUpdate = false;
	        if (queryData.targetId > this.metadata.highestTargetId) {
	            this.metadata.highestTargetId = queryData.targetId;
	            needsUpdate = true;
	        }
	        // TODO(GC): add sequence number check
	        return needsUpdate;
	    };
	    Object.defineProperty(IndexedDbQueryCache.prototype, "count", {
	        get: function () {
	            return this.metadata.targetCount;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
	        var _this = this;
	        // Iterating by the canonicalId may yield more than one result because
	        // canonicalId values are not required to be unique per target. This query
	        // depends on the queryTargets index to be efficent.
	        var canonicalId = query.canonicalId();
	        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
	        var result = null;
	        return targetsStore(transaction)
	            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
	            var found = _this.serializer.fromDbTarget(value);
	            // After finding a potential match, check that the query is
	            // actually equal to the requested query.
	            if (query.isEqual(found.query)) {
	                result = found;
	                control.done();
	            }
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // Indexeddb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = encode(key.path);
	            promises.push(store.put(new DbTargetDocument(targetId, path)));
	        });
	        return PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        var _this = this;
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = encode(key.path);
	            promises.push(store.delete([targetId, path]));
	            if (_this.garbageCollector !== null) {
	                _this.garbageCollector.addPotentialGarbageKey(key);
	            }
	        });
	        return PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        var store = documentTargetStore(txn);
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        return this.notifyGCForRemovedKeys(txn, range).next(function () {
	            return store.delete(range);
	        });
	    };
	    IndexedDbQueryCache.prototype.notifyGCForRemovedKeys = function (txn, range) {
	        var _this = this;
	        var store = documentTargetStore(txn);
	        if (this.garbageCollector !== null && this.garbageCollector.isEager) {
	            // In order to generate garbage events properly, we need to read these
	            // keys before deleting.
	            return store.iterate({ range: range, keysOnly: true }, function (key, _, control) {
	                var path = decode$1(key[1]);
	                var docKey = new DocumentKey(path);
	                // Paranoid assertion in case the the collector is set to null
	                // during the iteration.
	                assert(_this.garbageCollector !== null, 'GarbageCollector for query cache set to null during key removal.');
	                _this.garbageCollector.addPotentialGarbageKey(docKey);
	            });
	        }
	        else {
	            return PersistencePromise.resolve();
	        }
	    };
	    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var store = documentTargetStore(txn);
	        var result = documentKeySet();
	        return store
	            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
	            var path = decode$1(key[1]);
	            var docKey = new DocumentKey(path);
	            result = result.add(docKey);
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
	        assert(txn !== null, 'Persistence Transaction cannot be null for query cache containsKey');
	        var path = encode(key.path);
	        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var count = 0;
	        return documentTargetStore(txn)
	            .iterate({
	            index: DbTargetDocument.documentTargetsIndex,
	            keysOnly: true,
	            range: range
	        }, function (key, _, control) {
	            count++;
	            control.done();
	        })
	            .next(function () { return count > 0; });
	    };
	    return IndexedDbQueryCache;
	}());
	/**
	 * Helper to get a typed SimpleDbStore for the queries object store.
	 */
	function targetsStore(txn) {
	    return getStore$1(txn, DbTarget.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the target globals object store.
	 */
	function globalTargetStore(txn) {
	    return getStore$1(txn, DbTargetGlobal.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the document target object store.
	 */
	function documentTargetStore(txn) {
	    return getStore$1(txn, DbTargetDocument.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore$1(txn, store) {
	    if (txn instanceof SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return fail('Invalid transaction object provided!');
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var IndexedDbRemoteDocumentCache = /** @class */ (function () {
	    function IndexedDbRemoteDocumentCache(serializer) {
	        this.serializer = serializer;
	    }
	    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        return remoteDocumentsStore(transaction).put(dbKey(maybeDocument.key), this.serializer.toDbRemoteDocument(maybeDocument));
	    };
	    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        return remoteDocumentsStore(transaction).delete(dbKey(documentKey));
	    };
	    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        var _this = this;
	        return remoteDocumentsStore(transaction)
	            .get(dbKey(documentKey))
	            .next(function (dbRemoteDoc) {
	            return dbRemoteDoc
	                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
	                : null;
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var _this = this;
	        var results = documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var startKey = query.path.toArray();
	        var range = IDBKeyRange.lowerBound(startKey);
	        return remoteDocumentsStore(transaction)
	            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
	            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
	                control.done();
	            }
	            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        })
	            .next(function () { return results; });
	    };
	    return IndexedDbRemoteDocumentCache;
	}());
	/**
	 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
	 */
	function remoteDocumentsStore(txn) {
	    if (txn instanceof SimpleDbTransaction) {
	        return txn.store(DbRemoteDocument.store);
	    }
	    else {
	        return fail('Invalid transaction object provided!');
	    }
	}
	function dbKey(docKey) {
	    return docKey.path.toArray();
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Serializer for values stored in the LocalStore. */
	var LocalSerializer = /** @class */ (function () {
	    function LocalSerializer(remoteSerializer) {
	        this.remoteSerializer = remoteSerializer;
	    }
	    /** Decodes a remote document from storage locally to a Document. */
	    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
	        if (remoteDoc.document) {
	            return this.remoteSerializer.fromDocument(remoteDoc.document);
	        }
	        else if (remoteDoc.noDocument) {
	            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
	            var readTime = remoteDoc.noDocument.readTime;
	            var timestamp = new Timestamp(readTime.seconds, readTime.nanoseconds);
	            return new NoDocument(key, SnapshotVersion.fromTimestamp(timestamp));
	        }
	        else {
	            return fail('Unexpected DbRemoteDocument');
	        }
	    };
	    /** Encodes a document for storage locally. */
	    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
	        if (maybeDoc instanceof Document) {
	            var doc = this.remoteSerializer.toDocument(maybeDoc);
	            return new DbRemoteDocument(null, doc);
	        }
	        else {
	            var path = maybeDoc.key.path.toArray();
	            var timestamp = maybeDoc.version.toTimestamp();
	            var readTime = new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
	            return new DbRemoteDocument(new DbNoDocument(path, readTime), null);
	        }
	    };
	    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
	    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
	        var _this = this;
	        var serializedMutations = batch.mutations.map(function (m) {
	            return _this.remoteSerializer.toMutation(m);
	        });
	        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedMutations);
	    };
	    /** Decodes a DbMutationBatch into a MutationBatch */
	    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
	        var _this = this;
	        var mutations = dbBatch.mutations.map(function (m) {
	            return _this.remoteSerializer.fromMutation(m);
	        });
	        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
	        return new MutationBatch(dbBatch.batchId, timestamp, mutations);
	    };
	    /** Decodes a DbTarget into QueryData */
	    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
	        var readTime = new Timestamp(dbTarget.readTime.seconds, dbTarget.readTime.nanoseconds);
	        var version = SnapshotVersion.fromTimestamp(readTime);
	        var query;
	        if (isDocumentQuery(dbTarget.query)) {
	            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
	        }
	        else {
	            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
	        }
	        return new QueryData(query, dbTarget.targetId, QueryPurpose.Listen, version, dbTarget.resumeToken);
	    };
	    /** Encodes QueryData into a DbTarget for storage locally. */
	    LocalSerializer.prototype.toDbTarget = function (queryData) {
	        assert(QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
	            QueryPurpose.Listen +
	            ' may be stored, got ' +
	            queryData.purpose);
	        var timestamp = queryData.snapshotVersion.toTimestamp();
	        var dbTimestamp = new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
	        var queryProto;
	        if (queryData.query.isDocumentQuery()) {
	            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
	        }
	        else {
	            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
	        }
	        var resumeToken;
	        if (queryData.resumeToken instanceof Uint8Array) {
	            // TODO(b/78771403): Convert tokens to strings during deserialization
	            assert(({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence .');
	            resumeToken = queryData.resumeToken.toString();
	        }
	        else {
	            resumeToken = queryData.resumeToken;
	        }
	        // lastListenSequenceNumber is always 0 until we do real GC.
	        return new DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, 0, queryProto);
	    };
	    return LocalSerializer;
	}());
	/**
	 * A helper function for figuring out what kind of query has been stored.
	 */
	function isDocumentQuery(dbQuery) {
	    return dbQuery.documents !== undefined;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$3 = 'IndexedDbPersistence';
	/** If the owner lease is older than 5 seconds, try to take ownership. */
	var OWNER_LEASE_MAX_AGE_MS = 5000;
	/** Refresh the owner lease every 4 seconds while owner. */
	var OWNER_LEASE_REFRESH_INTERVAL_MS = 4000;
	/** LocalStorage location to indicate a zombied ownerId (see class comment). */
	var ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX = 'zombiedOwnerId';
	/** Error when the owner lease cannot be acquired or is lost. */
	var EXISTING_OWNER_ERROR_MSG = 'There is another tab open with offline' +
	    ' persistence enabled. Only one such tab is allowed at a time. The' +
	    ' other tab must be closed or persistence must be disabled.';
	var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
	    ' IndexedDB or is known to have an incomplete implementation. Offline' +
	    ' persistence has been disabled.';
	/**
	 * An IndexedDB-backed instance of Persistence. Data is stored persistently
	 * across sessions.
	 *
	 * Currently the Firestore SDK only supports a single consumer of the database,
	 * but browsers obviously support multiple tabs. IndexedDbPersistence ensures a
	 * single consumer of the database via an "owner lease" stored in the database.
	 *
	 * On startup, IndexedDbPersistence assigns itself a random "ownerId" and writes
	 * it to a special "owner" object in the database (if no entry exists already or
	 * the current entry is expired). This owner lease is then verified inside every
	 * transaction to ensure the lease has not been lost.
	 *
	 * If a tab opts not to acquire the owner lease (because there's an existing
	 * non-expired owner) or loses the owner lease, IndexedDbPersistence enters a
	 * failed state and all subsequent operations will automatically fail.
	 *
	 * The current owner regularly refreshes the owner lease with new timestamps to
	 * prevent newly-opened tabs from taking over ownership.
	 *
	 * Additionally there is an optimization so that when a tab is closed, the owner
	 * lease is released immediately (this is especially important to make sure that
	 * a refreshed tab is able to immediately re-acquire the owner lease).
	 * Unfortunately, IndexedDB cannot be reliably used in window.unload since it is
	 * an asynchronous API. So in addition to attempting to give up the lease,
	 * the owner writes its ownerId to a "zombiedOwnerId" entry in LocalStorage
	 * which acts as an indicator that another tab should go ahead and take the
	 * owner lease immediately regardless of the current lease timestamp.
	 */
	var IndexedDbPersistence = /** @class */ (function () {
	    function IndexedDbPersistence(prefix, serializer) {
	        this.ownerId = this.generateOwnerId();
	        this.dbName = prefix + IndexedDbPersistence.MAIN_DATABASE;
	        this.serializer = new LocalSerializer(serializer);
	        this.localStoragePrefix = prefix;
	    }
	    IndexedDbPersistence.prototype.start = function () {
	        var _this = this;
	        if (!IndexedDbPersistence.isAvailable()) {
	            this.persistenceError = new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
	            return Promise.reject(this.persistenceError);
	        }
	        assert(!this.started, 'IndexedDbPersistence double-started!');
	        this.started = true;
	        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, createOrUpgradeDb)
	            .then(function (db) {
	            _this.simpleDb = db;
	        })
	            .then(function () { return _this.tryAcquireOwnerLease(); })
	            .then(function () {
	            _this.scheduleOwnerLeaseRefreshes();
	            _this.attachWindowUnloadHook();
	        });
	    };
	    IndexedDbPersistence.prototype.shutdown = function (deleteData) {
	        var _this = this;
	        assert(this.started, 'IndexedDbPersistence shutdown without start!');
	        this.started = false;
	        this.detachWindowUnloadHook();
	        this.stopOwnerLeaseRefreshes();
	        return this.releaseOwnerLease().then(function () {
	            _this.simpleDb.close();
	            if (deleteData) {
	                return SimpleDb.delete(_this.dbName);
	            }
	        });
	    };
	    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
	        return IndexedDbMutationQueue.forUser(user, this.serializer);
	    };
	    IndexedDbPersistence.prototype.getQueryCache = function () {
	        return new IndexedDbQueryCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
	        return new IndexedDbRemoteDocumentCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.runTransaction = function (action, operation) {
	        var _this = this;
	        if (this.persistenceError) {
	            return Promise.reject(this.persistenceError);
	        }
	        debug(LOG_TAG$3, 'Starting transaction:', action);
	        // Do all transactions as readwrite against all object stores, since we
	        // are the only reader/writer.
	        return this.simpleDb.runTransaction('readwrite', ALL_STORES, function (txn) {
	            // Verify that we still have the owner lease as part of every transaction.
	            return _this.ensureOwnerLease(txn).next(function () { return operation(txn); });
	        });
	    };
	    IndexedDbPersistence.isAvailable = function () {
	        return SimpleDb.isAvailable();
	    };
	    /**
	     * Generates a string used as a prefix when storing data in IndexedDB and
	     * LocalStorage.
	     */
	    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
	        // Use two different prefix formats:
	        //
	        //   * firestore / persistenceKey / projectID . databaseID / ...
	        //   * firestore / persistenceKey / projectID / ...
	        //
	        // projectIDs are DNS-compatible names and cannot contain dots
	        // so there's no danger of collisions.
	        var database = databaseInfo.databaseId.projectId;
	        if (!databaseInfo.databaseId.isDefaultDatabase) {
	            database += '.' + databaseInfo.databaseId.database;
	        }
	        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
	    };
	    /**
	     * Acquires the owner lease if there's no valid owner. Else returns a rejected
	     * promise.
	     */
	    IndexedDbPersistence.prototype.tryAcquireOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [DbOwner.store], function (txn) {
	            var store = txn.store(DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (!_this.validOwner(dbOwner)) {
	                    var newDbOwner = new DbOwner(_this.ownerId, Date.now());
	                    debug(LOG_TAG$3, 'No valid owner. Acquiring owner lease. Current owner:', dbOwner, 'New owner:', newDbOwner);
	                    return store.put('owner', newDbOwner);
	                }
	                else {
	                    debug(LOG_TAG$3, 'Valid owner already. Failing. Current owner:', dbOwner);
	                    _this.persistenceError = new FirestoreError(Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                    return PersistencePromise.reject(_this.persistenceError);
	                }
	            });
	        });
	    };
	    /** Checks the owner lease and deletes it if we are the current owner. */
	    IndexedDbPersistence.prototype.releaseOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [DbOwner.store], function (txn) {
	            var store = txn.store(DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (dbOwner !== null && dbOwner.ownerId === _this.ownerId) {
	                    debug(LOG_TAG$3, 'Releasing owner lease.');
	                    return store.delete('owner');
	                }
	                else {
	                    return PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Checks the owner lease and returns a rejected promise if we are not the
	     * current owner. This should be included in every transaction to guard
	     * against losing the owner lease.
	     */
	    IndexedDbPersistence.prototype.ensureOwnerLease = function (txn) {
	        var _this = this;
	        var store = txn.store(DbOwner.store);
	        return store.get('owner').next(function (dbOwner) {
	            if (dbOwner === null || dbOwner.ownerId !== _this.ownerId) {
	                _this.persistenceError = new FirestoreError(Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                return PersistencePromise.reject(_this.persistenceError);
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns true if the provided owner exists, has a recent timestamp, and
	     * isn't zombied.
	     *
	     * NOTE: To determine if the owner is zombied, this method reads from
	     * LocalStorage which could be mildly expensive.
	     */
	    IndexedDbPersistence.prototype.validOwner = function (dbOwner) {
	        var now = Date.now();
	        var minAcceptable = now - OWNER_LEASE_MAX_AGE_MS;
	        var maxAcceptable = now;
	        if (dbOwner === null) {
	            return false; // no owner.
	        }
	        else if (dbOwner.leaseTimestampMs < minAcceptable) {
	            return false; // owner lease has expired.
	        }
	        else if (dbOwner.leaseTimestampMs > maxAcceptable) {
	            error('Persistence owner-lease is in the future. Discarding.', dbOwner);
	            return false;
	        }
	        else if (dbOwner.ownerId === this.getZombiedOwnerId()) {
	            return false; // owner's tab closed.
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Schedules a recurring timer to update the owner lease timestamp to prevent
	     * other tabs from taking the lease.
	     */
	    IndexedDbPersistence.prototype.scheduleOwnerLeaseRefreshes = function () {
	        var _this = this;
	        // NOTE: This doesn't need to be scheduled on the async queue and doing so
	        // would increase the chances of us not refreshing on time if the queue is
	        // backed up for some reason.
	        this.ownerLeaseRefreshHandle = setInterval(function () {
	            var txResult = _this.runTransaction('Refresh owner timestamp', function (txn) {
	                // NOTE: We don't need to validate the current owner contents, since
	                // runTransaction does that automatically.
	                var store = txn.store(DbOwner.store);
	                return store.put('owner', new DbOwner(_this.ownerId, Date.now()));
	            });
	            txResult.catch(function (reason) {
	                // Probably means we lost the lease. Report the error and stop trying to
	                // refresh the lease.
	                error(reason);
	                _this.stopOwnerLeaseRefreshes();
	            });
	        }, OWNER_LEASE_REFRESH_INTERVAL_MS);
	    };
	    IndexedDbPersistence.prototype.stopOwnerLeaseRefreshes = function () {
	        if (this.ownerLeaseRefreshHandle) {
	            clearInterval(this.ownerLeaseRefreshHandle);
	            this.ownerLeaseRefreshHandle = null;
	        }
	    };
	    /**
	     * Attaches a window.unload handler that will synchronously write our
	     * ownerId to a "zombie owner id" location in localstorage. This can be used
	     * by tabs trying to acquire the lease to determine that the lease should be
	     * acquired immediately even if the timestamp is recent. This is particularly
	     * important for the refresh case (so the tab correctly re-acquires the owner
	     * lease). LocalStorage is used for this rather than IndexedDb because it is
	     * a synchronous API and so can be used reliably from an unload handler.
	     */
	    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
	        var _this = this;
	        if (typeof window === 'object' &&
	            typeof window.addEventListener === 'function') {
	            this.windowUnloadHandler = function () {
	                // Record that we're zombied.
	                _this.setZombiedOwnerId(_this.ownerId);
	                // Attempt graceful shutdown (including releasing our owner lease), but
	                // there's no guarantee it will complete.
	                _this.shutdown();
	            };
	            window.addEventListener('unload', this.windowUnloadHandler);
	        }
	    };
	    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
	        if (this.windowUnloadHandler) {
	            assert(typeof window === 'object' &&
	                typeof window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
	            window.removeEventListener('unload', this.windowUnloadHandler);
	            this.windowUnloadHandler = null;
	        }
	    };
	    /**
	     * Returns any recorded "zombied owner" (i.e. a previous owner that became
	     * zombied due to their tab closing) from LocalStorage, or null if no such
	     * record exists.
	     */
	    IndexedDbPersistence.prototype.getZombiedOwnerId = function () {
	        try {
	            var zombiedOwnerId = window.localStorage.getItem(this.zombiedOwnerLocalStorageKey());
	            debug(LOG_TAG$3, 'Zombied ownerID from LocalStorage:', zombiedOwnerId);
	            return zombiedOwnerId;
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            error('Failed to get zombie owner id.', e);
	            return null;
	        }
	    };
	    /**
	     * Records a zombied owner (an owner that had its tab closed) in LocalStorage
	     * or, if passed null, deletes any recorded zombied owner.
	     */
	    IndexedDbPersistence.prototype.setZombiedOwnerId = function (zombieOwnerId) {
	        try {
	            if (zombieOwnerId === null) {
	                window.localStorage.removeItem(this.zombiedOwnerLocalStorageKey());
	            }
	            else {
	                window.localStorage.setItem(this.zombiedOwnerLocalStorageKey(), zombieOwnerId);
	            }
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            error('Failed to set zombie owner id.', e);
	        }
	    };
	    IndexedDbPersistence.prototype.zombiedOwnerLocalStorageKey = function () {
	        return this.localStoragePrefix + ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX;
	    };
	    IndexedDbPersistence.prototype.generateOwnerId = function () {
	        // For convenience, just use an AutoId.
	        return AutoId.newId();
	    };
	    /**
	     * The name of the main (and currently only) IndexedDB database. this name is
	     * appended to the prefix provided to the IndexedDbPersistence constructor.
	     */
	    IndexedDbPersistence.MAIN_DATABASE = 'main';
	    return IndexedDbPersistence;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A readonly view of the local state of all documents we're tracking (i.e. we
	 * have a cached version in remoteDocumentCache or local mutations for the
	 * document). The view is computed by applying the mutations in the
	 * MutationQueue to the RemoteDocumentCache.
	 */
	var LocalDocumentsView = /** @class */ (function () {
	    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.mutationQueue = mutationQueue;
	    }
	    /**
	     * Get the local view of the document identified by `key`.
	     *
	     * @return Local view of the document or null if we don't have any cached
	     * state for it.
	     */
	    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
	        var _this = this;
	        return this.remoteDocumentCache
	            .getEntry(transaction, key)
	            .next(function (remoteDoc) {
	            return _this.computeLocalDocument(transaction, key, remoteDoc);
	        });
	    };
	    /**
	     * Gets the local view of the documents identified by `keys`.
	     *
	     * If we don't have cached state for a document in `keys`, a NoDocument will
	     * be stored for that key in the resulting set.
	     */
	    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
	        var _this = this;
	        var promises = [];
	        var results = maybeDocumentMap();
	        keys.forEach(function (key) {
	            promises.push(_this.getDocument(transaction, key).next(function (maybeDoc) {
	                // TODO(http://b/32275378): Don't conflate missing / deleted.
	                if (!maybeDoc) {
	                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
	                }
	                results = results.insert(key, maybeDoc);
	            }));
	        });
	        return PersistencePromise.waitFor(promises).next(function () { return results; });
	    };
	    /** Performs a query against the local view of all documents. */
	    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        if (DocumentKey.isDocumentKey(query.path)) {
	            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
	        }
	        else {
	            return this.getDocumentsMatchingCollectionQuery(transaction, query);
	        }
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
	        // Just do a simple document lookup.
	        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
	            var result = documentMap();
	            if (maybeDoc instanceof Document) {
	                result = result.insert(maybeDoc.key, maybeDoc);
	            }
	            return result;
	        });
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
	        var _this = this;
	        // Query the remote documents and overlay mutations.
	        // TODO(mikelehen): There may be significant overlap between the mutations
	        // affecting these remote documents and the
	        // getAllMutationBatchesAffectingQuery() mutations. Consider optimizing.
	        var results;
	        return this.remoteDocumentCache
	            .getDocumentsMatchingQuery(transaction, query)
	            .next(function (queryResults) {
	            return _this.computeLocalDocuments(transaction, queryResults);
	        })
	            .next(function (promisedResults) {
	            results = promisedResults;
	            // Now use the mutation queue to discover any other documents that may
	            // match the query after applying mutations.
	            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
	        })
	            .next(function (matchingMutationBatches) {
	            var matchingKeys = documentKeySet();
	            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
	                var batch = matchingMutationBatches_1[_i];
	                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                    var mutation = _b[_a];
	                    // TODO(mikelehen): PERF: Check if this mutation actually
	                    // affects the query to reduce work.
	                    if (!results.get(mutation.key)) {
	                        matchingKeys = matchingKeys.add(mutation.key);
	                    }
	                }
	            }
	            // Now add in the results for the matchingKeys.
	            var promises = [];
	            matchingKeys.forEach(function (key) {
	                promises.push(_this.getDocument(transaction, key).next(function (doc) {
	                    if (doc instanceof Document) {
	                        results = results.insert(doc.key, doc);
	                    }
	                }));
	            });
	            return PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            // Finally, filter out any documents that don't actually match
	            // the query.
	            results.forEach(function (key, doc) {
	                if (!query.matches(doc)) {
	                    results = results.remove(key);
	                }
	            });
	            return results;
	        });
	    };
	    /**
	     * Takes a remote document and applies local mutations to generate the local
	     * view of the document.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the document (necessary when remoteDocument
	     *     is null).
	     * @param document The base remote document to apply mutations to or null.
	     */
	    LocalDocumentsView.prototype.computeLocalDocument = function (transaction, documentKey, document) {
	        return this.mutationQueue
	            .getAllMutationBatchesAffectingDocumentKey(transaction, documentKey)
	            .next(function (batches) {
	            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	                var batch = batches_1[_i];
	                document = batch.applyToLocalView(documentKey, document);
	            }
	            return document;
	        });
	    };
	    /**
	     * Takes a set of remote documents and applies local mutations to generate the
	     * local view of the documents.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documents The base remote documents to apply mutations to.
	     * @return The local view of the documents.
	     */
	    LocalDocumentsView.prototype.computeLocalDocuments = function (transaction, documents) {
	        var _this = this;
	        var promises = [];
	        documents.forEach(function (key, doc) {
	            promises.push(_this.computeLocalDocument(transaction, key, doc).next(function (mutatedDoc) {
	                if (mutatedDoc instanceof Document) {
	                    documents = documents.insert(mutatedDoc.key, mutatedDoc);
	                }
	                else if (mutatedDoc instanceof NoDocument) {
	                    documents = documents.remove(mutatedDoc.key);
	                }
	                else {
	                    fail('Unknown MaybeDocument: ' + mutatedDoc);
	                }
	            }));
	        });
	        return PersistencePromise.waitFor(promises).next(function () { return documents; });
	    };
	    return LocalDocumentsView;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
	 * It can be used to batch up a set of changes to be written to the cache, but
	 * additionally supports reading entries back with the `getEntry()` method,
	 * falling back to the underlying RemoteDocumentCache if no entry is
	 * buffered.
	 *
	 * NOTE: This class was introduced in iOS to work around a limitation in
	 * LevelDB. Given IndexedDb has full transaction support with
	 * read-your-own-writes capability, this class is not technically needed, but
	 * has been preserved as a convenience and to aid portability.
	 */
	var RemoteDocumentChangeBuffer = /** @class */ (function () {
	    function RemoteDocumentChangeBuffer(remoteDocumentCache) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.changes = maybeDocumentMap();
	    }
	    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
	    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
	        var changes = this.assertChanges();
	        this.changes = changes.insert(maybeDocument.key, maybeDocument);
	    };
	    // NOTE: removeEntry() is not presently necessary and so is omitted.
	    /**
	     * Looks up an entry in the cache. The buffered changes will first be checked,
	     * and if no buffered change applies, this will forward to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the entry to look up.
	     * @return The cached Document or NoDocument entry, or null if we have nothing
	     * cached.
	     */
	    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
	        var changes = this.assertChanges();
	        var bufferedEntry = changes.get(documentKey);
	        if (bufferedEntry) {
	            return PersistencePromise.resolve(bufferedEntry);
	        }
	        else {
	            return this.remoteDocumentCache.getEntry(transaction, documentKey);
	        }
	    };
	    /**
	     * Applies buffered changes to the underlying RemoteDocumentCache, using
	     * the provided transaction.
	     */
	    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
	        var _this = this;
	        var changes = this.assertChanges();
	        var promises = [];
	        changes.forEach(function (key, maybeDoc) {
	            promises.push(_this.remoteDocumentCache.addEntry(transaction, maybeDoc));
	        });
	        // We should not be used to buffer any more changes.
	        this.changes = null;
	        return PersistencePromise.waitFor(promises);
	    };
	    /** Helper to assert this.changes is not null and return it. */
	    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
	        assert(this.changes !== null, 'Changes have already been applied.');
	        return this.changes;
	    };
	    return RemoteDocumentChangeBuffer;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$4 = 'LocalStore';
	/**
	 * Local storage in the Firestore client. Coordinates persistence components
	 * like the mutation queue and remote document cache to present a
	 * latency-compensated view of stored data.
	 *
	 * The LocalStore is responsible for accepting mutations from the Sync Engine.
	 * Writes from the client are put into a queue as provisional Mutations until
	 * they are processed by the RemoteStore and confirmed as having been written
	 * to the server.
	 *
	 * The local store provides the local version of documents that have been
	 * modified locally. It maintains the constraint:
	 *
	 *   LocalDocument = RemoteDocument + Active(LocalMutations)
	 *
	 * (Active mutations are those that are enqueued and have not been previously
	 * acknowledged or rejected).
	 *
	 * The RemoteDocument ("ground truth") state is provided via the
	 * applyChangeBatch method. It will be some version of a server-provided
	 * document OR will be a server-provided document PLUS acknowledged mutations:
	 *
	 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
	 *
	 * Note that this "dirty" version of a RemoteDocument will not be identical to a
	 * server base version, since it has LocalMutations added to it pending getting
	 * an authoritative copy from the server.
	 *
	 * Since LocalMutations can be rejected by the server, we have to be able to
	 * revert a LocalMutation that has already been applied to the LocalDocument
	 * (typically done by replaying all remaining LocalMutations to the
	 * RemoteDocument to re-apply).
	 *
	 * The LocalStore is responsible for the garbage collection of the documents it
	 * contains. For now, it every doc referenced by a view, the mutation queue, or
	 * the RemoteStore.
	 *
	 * It also maintains the persistence of mapping queries to resume tokens and
	 * target ids. It needs to know this data about queries to properly know what
	 * docs it would be allowed to garbage collect.
	 *
	 * The LocalStore must be able to efficiently execute queries against its local
	 * cache of the documents, to provide the initial set of results before any
	 * remote changes have been received.
	 *
	 * Note: In TypeScript, most methods return Promises since the implementation
	 * may rely on fetching data from IndexedDB which is async.
	 * These Promises will only be rejected on an I/O error or other internal
	 * (unexpected) failure (e.g. failed assert) and always represent an
	 * unrecoverable error (should be caught / reported by the async_queue).
	 */
	var LocalStore = /** @class */ (function () {
	    function LocalStore(
	    /** Manages our in-memory or durable persistence. */
	    persistence, initialUser, 
	    /**
	     * The garbage collector collects documents that should no longer be
	     * cached (e.g. if they are no longer retained by the above reference sets
	     * and the garbage collector is performing eager collection).
	     */
	    garbageCollector) {
	        this.persistence = persistence;
	        this.garbageCollector = garbageCollector;
	        /**
	         * The set of document references maintained by any local views.
	         */
	        this.localViewReferences = new ReferenceSet();
	        /** Maps a targetID to data about its query. */
	        this.targetIds = {};
	        /** Used to generate targetIDs for queries tracked locally. */
	        this.targetIdGenerator = TargetIdGenerator.forLocalStore();
	        /**
	         * A heldBatchResult is a mutation batch result (from a write acknowledgement)
	         * that arrived before the watch stream got notified of a snapshot that
	         * includes the write. So we "hold" it until the watch stream catches up. It
	         * ensures that the local write remains visible (latency compensation) and
	         * doesn't temporarily appear reverted because the watch stream is slower than
	         * the write stream and so wasn't reflecting it.
	         *
	         * NOTE: Eventually we want to move this functionality into the remote store.
	         */
	        this.heldBatchResults = [];
	        this.mutationQueue = persistence.getMutationQueue(initialUser);
	        this.remoteDocuments = persistence.getRemoteDocumentCache();
	        this.queryCache = persistence.getQueryCache();
	        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
	        this.garbageCollector.addGarbageSource(this.localViewReferences);
	        this.garbageCollector.addGarbageSource(this.queryCache);
	        this.garbageCollector.addGarbageSource(this.mutationQueue);
	    }
	    /** Performs any initial startup actions required by the local store. */
	    LocalStore.prototype.start = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Start LocalStore', function (txn) {
	            return _this.startMutationQueue(txn).next(function () { return _this.startQueryCache(txn); });
	        });
	    };
	    /**
	     * Tells the LocalStore that the currently authenticated user has changed.
	     *
	     * In response the local store switches the mutation queue to the new user and
	     * returns any resulting document changes.
	     */
	    LocalStore.prototype.handleUserChange = function (user) {
	        var _this = this;
	        return this.persistence.runTransaction('Handle user change', function (txn) {
	            // Swap out the mutation queue, grabbing the pending mutation batches
	            // before and after.
	            var oldBatches;
	            return _this.mutationQueue
	                .getAllMutationBatches(txn)
	                .next(function (promisedOldBatches) {
	                oldBatches = promisedOldBatches;
	                _this.garbageCollector.removeGarbageSource(_this.mutationQueue);
	                _this.mutationQueue = _this.persistence.getMutationQueue(user);
	                _this.garbageCollector.addGarbageSource(_this.mutationQueue);
	                return _this.startMutationQueue(txn);
	            })
	                .next(function () {
	                // Recreate our LocalDocumentsView using the new
	                // MutationQueue.
	                _this.localDocuments = new LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
	                return _this.mutationQueue.getAllMutationBatches(txn);
	            })
	                .next(function (newBatches) {
	                // Union the old/new changed keys.
	                var changedKeys = documentKeySet();
	                for (var _i = 0, _a = [oldBatches, newBatches]; _i < _a.length; _i++) {
	                    var batches = _a[_i];
	                    for (var _b = 0, batches_1 = batches; _b < batches_1.length; _b++) {
	                        var batch = batches_1[_b];
	                        for (var _c = 0, _d = batch.mutations; _c < _d.length; _c++) {
	                            var mutation = _d[_c];
	                            changedKeys = changedKeys.add(mutation.key);
	                        }
	                    }
	                }
	                // Return the set of all (potentially) changed documents as the
	                // result of the user change.
	                return _this.localDocuments.getDocuments(txn, changedKeys);
	            });
	        });
	    };
	    LocalStore.prototype.startQueryCache = function (txn) {
	        var _this = this;
	        return this.queryCache.start(txn).next(function () {
	            var targetId = _this.queryCache.getHighestTargetId();
	            _this.targetIdGenerator = TargetIdGenerator.forLocalStore(targetId);
	        });
	    };
	    LocalStore.prototype.startMutationQueue = function (txn) {
	        var _this = this;
	        return this.mutationQueue
	            .start(txn)
	            .next(function () {
	            // If we have any leftover mutation batch results from a prior run,
	            // just drop them.
	            // TODO(http://b/33446471): We probably need to repopulate
	            // heldBatchResults or similar instead, but that is not
	            // straightforward since we're not persisting the write ack versions.
	            _this.heldBatchResults = [];
	            return _this.mutationQueue.getHighestAcknowledgedBatchId(txn);
	        })
	            .next(function (highestAck) {
	            // TODO(mikelehen): This is the only usage of
	            // getAllMutationBatchesThroughBatchId(). Consider removing it in
	            // favor of a getAcknowledgedBatches() method.
	            if (highestAck !== BATCHID_UNKNOWN) {
	                return _this.mutationQueue.getAllMutationBatchesThroughBatchId(txn, highestAck);
	            }
	            else {
	                return PersistencePromise.resolve([]);
	            }
	        })
	            .next(function (ackedBatches) {
	            if (ackedBatches.length > 0) {
	                return _this.mutationQueue.removeMutationBatches(txn, ackedBatches);
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        });
	    };
	    /* Accept locally generated Mutations and commit them to storage. */
	    LocalStore.prototype.localWrite = function (mutations) {
	        var _this = this;
	        return this.persistence.runTransaction('Locally write mutations', function (txn) {
	            var batch;
	            var localWriteTime = Timestamp.now();
	            return _this.mutationQueue
	                .addMutationBatch(txn, localWriteTime, mutations)
	                .next(function (promisedBatch) {
	                batch = promisedBatch;
	                // TODO(koss): This is doing an N^2 update by replaying ALL the
	                // mutations on each document (instead of just the ones added) in
	                // this batch.
	                var keys = batch.keys();
	                return _this.localDocuments.getDocuments(txn, keys);
	            })
	                .next(function (changedDocuments) {
	                return { batchId: batch.batchId, changes: changedDocuments };
	            });
	        });
	    };
	    /**
	     * Acknowledge the given batch.
	     *
	     * On the happy path when a batch is acknowledged, the local store will
	     *
	     *  + remove the batch from the mutation queue;
	     *  + apply the changes to the remote document cache;
	     *  + recalculate the latency compensated view implied by those changes (there
	     *    may be mutations in the queue that affect the documents but haven't been
	     *    acknowledged yet); and
	     *  + give the changed documents back the sync engine
	     *
	     * @returns The resulting (modified) documents.
	     */
	    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
	        var _this = this;
	        return this.persistence.runTransaction('Acknowledge batch', function (txn) {
	            var affected;
	            return _this.mutationQueue
	                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
	                .next(function () {
	                if (_this.shouldHoldBatchResult(batchResult.commitVersion)) {
	                    _this.heldBatchResults.push(batchResult);
	                    affected = documentKeySet();
	                    return PersistencePromise.resolve();
	                }
	                else {
	                    var documentBuffer_1 = new RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseBatchResults(txn, [batchResult], documentBuffer_1).next(function (promisedAffectedKeys) {
	                        affected = promisedAffectedKeys;
	                        return documentBuffer_1.apply(txn);
	                    });
	                }
	            })
	                .next(function () {
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affected);
	            });
	        });
	    };
	    /**
	     * Remove mutations from the MutationQueue for the specified batch;
	     * LocalDocuments will be recalculated.
	     *
	     * @returns The resulting modified documents.
	     */
	    LocalStore.prototype.rejectBatch = function (batchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Reject batch', function (txn) {
	            var toReject;
	            var affectedKeys;
	            return _this.mutationQueue
	                .lookupMutationBatch(txn, batchId)
	                .next(function (promisedToReject) {
	                assert(promisedToReject != null, 'Attempt to reject nonexistent batch!');
	                toReject = promisedToReject;
	                return _this.mutationQueue
	                    .getHighestAcknowledgedBatchId(txn)
	                    .next(function (lastAcked) {
	                    assert(batchId > lastAcked, "Acknowledged batches can't be rejected.");
	                    return toReject;
	                });
	            })
	                .next(function () {
	                return _this.removeMutationBatch(txn, toReject);
	            })
	                .next(function (promisedAffectedKeys) {
	                affectedKeys = promisedAffectedKeys;
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affectedKeys);
	            });
	        });
	    };
	    /** Returns the last recorded stream token for the current user. */
	    LocalStore.prototype.getLastStreamToken = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get last stream token', function (txn) {
	            return _this.mutationQueue.getLastStreamToken(txn);
	        });
	    };
	    /**
	     * Sets the stream token for the current user without acknowledging any
	     * mutation batch. This is usually only useful after a stream handshake or in
	     * response to an error that requires clearing the stream token.
	     */
	    LocalStore.prototype.setLastStreamToken = function (streamToken) {
	        var _this = this;
	        return this.persistence.runTransaction('Set last stream token', function (txn) {
	            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
	        });
	    };
	    /**
	     * Returns the last consistent snapshot processed (used by the RemoteStore to
	     * determine whether to buffer incoming snapshots from the backend).
	     */
	    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.queryCache.getLastRemoteSnapshotVersion();
	    };
	    /**
	     * Update the "ground-state" (remote) documents. We assume that the remote
	     * event reflects any write batches that have been acknowledged or rejected
	     * (i.e. we do not re-apply local mutations to updates from this event).
	     *
	     * LocalDocuments are re-calculated if there are remaining mutations in the
	     * queue.
	     */
	    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        var documentBuffer = new RemoteDocumentChangeBuffer(this.remoteDocuments);
	        return this.persistence.runTransaction('Apply remote event', function (txn) {
	            var promises = [];
	            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                // Do not ref/unref unassigned targetIds - it may lead to leaks.
	                var queryData = _this.targetIds[targetId];
	                if (!queryData)
	                    return;
	                var mapping = change.mapping;
	                if (mapping) {
	                    // First make sure that all references are deleted
	                    if (mapping instanceof ResetMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeysForTargetId(txn, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.documents, targetId);
	                        }));
	                    }
	                    else if (mapping instanceof UpdateMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeys(txn, mapping.removedDocuments, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.addedDocuments, targetId);
	                        }));
	                    }
	                    else {
	                        return fail('Unknown mapping type: ' + JSON.stringify(mapping));
	                    }
	                }
	                // Update the resume token if the change includes one. Don't clear
	                // any preexisting value.
	                var resumeToken = change.resumeToken;
	                if (resumeToken.length > 0) {
	                    queryData = queryData.update({
	                        resumeToken: resumeToken,
	                        snapshotVersion: change.snapshotVersion
	                    });
	                    _this.targetIds[targetId] = queryData;
	                    promises.push(_this.queryCache.updateQueryData(txn, queryData));
	                }
	            });
	            var changedDocKeys = documentKeySet();
	            remoteEvent.documentUpdates.forEach(function (key, doc) {
	                changedDocKeys = changedDocKeys.add(key);
	                promises.push(documentBuffer.getEntry(txn, key).next(function (existingDoc) {
	                    // Make sure we don't apply an old document version to the remote
	                    // cache, though we make an exception for SnapshotVersion.MIN which
	                    // can happen for manufactured events (e.g. in the case of a limbo
	                    // document resolution failing).
	                    if (existingDoc == null ||
	                        doc.version.isEqual(SnapshotVersion.MIN) ||
	                        doc.version.compareTo(existingDoc.version) >= 0) {
	                        documentBuffer.addEntry(doc);
	                    }
	                    else {
	                        debug(LOG_TAG$4, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
	                    }
	                    // The document might be garbage because it was unreferenced by
	                    // everything. Make sure to mark it as garbage if it is...
	                    _this.garbageCollector.addPotentialGarbageKey(key);
	                }));
	            });
	            // HACK: The only reason we allow a null snapshot version is so that we
	            // can synthesize remote events when we get permission denied errors while
	            // trying to resolve the state of a locally cached document that is in
	            // limbo.
	            var lastRemoteVersion = _this.queryCache.getLastRemoteSnapshotVersion();
	            var remoteVersion = remoteEvent.snapshotVersion;
	            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
	                assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
	                    remoteVersion +
	                    ' < ' +
	                    lastRemoteVersion);
	                promises.push(_this.queryCache.setLastRemoteSnapshotVersion(txn, remoteVersion));
	            }
	            var releasedWriteKeys;
	            return PersistencePromise.waitFor(promises)
	                .next(function () { return _this.releaseHeldBatchResults(txn, documentBuffer); })
	                .next(function (promisedReleasedWriteKeys) {
	                releasedWriteKeys = promisedReleasedWriteKeys;
	                return documentBuffer.apply(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, changedDocKeys.unionWith(releasedWriteKeys));
	            });
	        });
	    };
	    /**
	     * Notify local store of the changed views to locally pin documents.
	     */
	    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
	        var _this = this;
	        return this.persistence.runTransaction('Notify local view changes', function (txn) {
	            var promises = [];
	            var _loop_1 = function (view) {
	                promises.push(_this.queryCache
	                    .getQueryData(txn, view.query)
	                    .next(function (queryData) {
	                    assert(queryData !== null, 'Local view changes contain unallocated query.');
	                    var targetId = queryData.targetId;
	                    _this.localViewReferences.addReferences(view.addedKeys, targetId);
	                    _this.localViewReferences.removeReferences(view.removedKeys, targetId);
	                }));
	            };
	            for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
	                var view = viewChanges_1[_i];
	                _loop_1(view);
	            }
	            return PersistencePromise.waitFor(promises);
	        });
	    };
	    /**
	     * Gets the mutation batch after the passed in batchId in the mutation queue
	     * or null if empty.
	     * @param afterBatchId If provided, the batch to search after.
	     * @returns The next mutation or null if there wasn't one.
	     */
	    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Get next mutation batch', function (txn) {
	            if (afterBatchId === undefined) {
	                afterBatchId = BATCHID_UNKNOWN;
	            }
	            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
	        });
	    };
	    /**
	     * Read the current value of a Document with a given key or null if not
	     * found - used for testing.
	     */
	    LocalStore.prototype.readDocument = function (key) {
	        var _this = this;
	        return this.persistence.runTransaction('read document', function (txn) {
	            return _this.localDocuments.getDocument(txn, key);
	        });
	    };
	    /**
	     * Assigns the given query an internal ID so that its results can be pinned so
	     * they don't get GC'd. A query must be allocated in the local store before
	     * the store can be used to manage its view.
	     */
	    LocalStore.prototype.allocateQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Allocate query', function (txn) {
	            var queryData;
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (cached) {
	                if (cached) {
	                    // This query has been listened to previously, so reuse the
	                    // previous targetID.
	                    // TODO(mcg): freshen last accessed date?
	                    queryData = cached;
	                    return PersistencePromise.resolve();
	                }
	                else {
	                    var targetId = _this.targetIdGenerator.next();
	                    queryData = new QueryData(query, targetId, QueryPurpose.Listen);
	                    return _this.queryCache.addQueryData(txn, queryData);
	                }
	            })
	                .next(function () {
	                assert(!_this.targetIds[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
	                _this.targetIds[queryData.targetId] = queryData;
	                return queryData;
	            });
	        });
	    };
	    /** Unpin all the documents associated with the given query. */
	    LocalStore.prototype.releaseQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Release query', function (txn) {
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (queryData) {
	                assert(queryData != null, 'Tried to release nonexistent query: ' + query);
	                _this.localViewReferences.removeReferencesForId(queryData.targetId);
	                delete _this.targetIds[queryData.targetId];
	                if (_this.garbageCollector.isEager) {
	                    return _this.queryCache.removeQueryData(txn, queryData);
	                }
	                else {
	                    return PersistencePromise.resolve();
	                }
	            })
	                .next(function () {
	                // If this was the last watch target, then we won't get any more
	                // watch snapshots, so we should release any held batch results.
	                if (isEmpty(_this.targetIds)) {
	                    var documentBuffer_2 = new RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseHeldBatchResults(txn, documentBuffer_2).next(function () {
	                        documentBuffer_2.apply(txn);
	                    });
	                }
	                else {
	                    return PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Runs the specified query against all the documents in the local store and
	     * returns the results.
	     */
	    LocalStore.prototype.executeQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Execute query', function (txn) {
	            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
	        });
	    };
	    /**
	     * Returns the keys of the documents that are associated with the given
	     * target id in the remote table.
	     */
	    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
	        var _this = this;
	        return this.persistence.runTransaction('Remote document keys', function (txn) {
	            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
	        });
	    };
	    /**
	     * Collect garbage if necessary.
	     * Should be called periodically by Sync Engine to recover resources. The
	     * implementation must guarantee that GC won't happen in other places than
	     * this method call.
	     */
	    LocalStore.prototype.collectGarbage = function () {
	        var _this = this;
	        // Call collectGarbage regardless of whether isGCEnabled so the referenceSet
	        // doesn't continue to accumulate the garbage keys.
	        return this.persistence.runTransaction('Garbage collection', function (txn) {
	            return _this.garbageCollector.collectGarbage(txn).next(function (garbage) {
	                var promises = [];
	                garbage.forEach(function (key) {
	                    promises.push(_this.remoteDocuments.removeEntry(txn, key));
	                });
	                return PersistencePromise.waitFor(promises);
	            });
	        });
	    };
	    LocalStore.prototype.releaseHeldBatchResults = function (txn, documentBuffer) {
	        var toRelease = [];
	        for (var _i = 0, _a = this.heldBatchResults; _i < _a.length; _i++) {
	            var batchResult = _a[_i];
	            if (!this.isRemoteUpToVersion(batchResult.commitVersion)) {
	                break;
	            }
	            toRelease.push(batchResult);
	        }
	        if (toRelease.length === 0) {
	            return PersistencePromise.resolve(documentKeySet());
	        }
	        else {
	            this.heldBatchResults.splice(0, toRelease.length);
	            return this.releaseBatchResults(txn, toRelease, documentBuffer);
	        }
	    };
	    LocalStore.prototype.isRemoteUpToVersion = function (version) {
	        // If there are no watch targets, then we won't get remote snapshots, and
	        // we are always "up-to-date."
	        var lastRemoteVersion = this.queryCache.getLastRemoteSnapshotVersion();
	        return (version.compareTo(lastRemoteVersion) <= 0 ||
	            isEmpty(this.targetIds));
	    };
	    LocalStore.prototype.shouldHoldBatchResult = function (version) {
	        // Check if watcher isn't up to date or prior results are already held.
	        return (!this.isRemoteUpToVersion(version) || this.heldBatchResults.length > 0);
	    };
	    LocalStore.prototype.releaseBatchResults = function (txn, batchResults, documentBuffer) {
	        var _this = this;
	        var promiseChain = PersistencePromise.resolve();
	        var _loop_2 = function (batchResult) {
	            promiseChain = promiseChain.next(function () {
	                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
	            });
	        };
	        for (var _i = 0, batchResults_1 = batchResults; _i < batchResults_1.length; _i++) {
	            var batchResult = batchResults_1[_i];
	            _loop_2(batchResult);
	        }
	        return promiseChain.next(function () {
	            return _this.removeMutationBatches(txn, batchResults.map(function (result) { return result.batch; }));
	        });
	    };
	    LocalStore.prototype.removeMutationBatch = function (txn, batch) {
	        return this.removeMutationBatches(txn, [batch]);
	    };
	    /** Removes all the mutation batches named in the given array. */
	    LocalStore.prototype.removeMutationBatches = function (txn, batches) {
	        var affectedDocs = documentKeySet();
	        for (var _i = 0, batches_2 = batches; _i < batches_2.length; _i++) {
	            var batch = batches_2[_i];
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                affectedDocs = affectedDocs.add(key);
	            }
	        }
	        return this.mutationQueue
	            .removeMutationBatches(txn, batches)
	            .next(function () { return affectedDocs; });
	    };
	    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
	        var batch = batchResult.batch;
	        var docKeys = batch.keys();
	        var promiseChain = PersistencePromise.resolve();
	        docKeys.forEach(function (docKey) {
	            promiseChain = promiseChain
	                .next(function () {
	                return documentBuffer.getEntry(txn, docKey);
	            })
	                .next(function (remoteDoc) {
	                var doc = remoteDoc;
	                var ackVersion = batchResult.docVersions.get(docKey);
	                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
	                if (!doc || doc.version.compareTo(ackVersion) < 0) {
	                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
	                    if (!doc) {
	                        assert(!remoteDoc, 'Mutation batch ' +
	                            batch +
	                            ' applied to document ' +
	                            remoteDoc +
	                            ' resulted in null');
	                    }
	                    else {
	                        documentBuffer.addEntry(doc);
	                    }
	                }
	            });
	        });
	        return promiseChain;
	    };
	    return LocalStore;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MemoryMutationQueue = /** @class */ (function () {
	    function MemoryMutationQueue() {
	        /**
	         * The set of all mutations that have been sent but not yet been applied to
	         * the backend.
	         */
	        this.mutationQueue = [];
	        /** Next value to use when assigning sequential IDs to each mutation batch. */
	        this.nextBatchId = 1;
	        /** The highest acknowledged mutation in the queue. */
	        this.highestAcknowledgedBatchId = BATCHID_UNKNOWN;
	        /** The last received stream token from the server, used to acknowledge which
	         * responses the client has processed. Stream tokens are opaque checkpoint
	         * markers whose only real value is their inclusion in the next request.
	         */
	        this.lastStreamToken = emptyByteString();
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	        /** An ordered mapping between documents and the mutations batch IDs. */
	        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
	    }
	    MemoryMutationQueue.prototype.start = function (transaction) {
	        // NOTE: The queue may be shutdown / started multiple times, since we
	        // maintain the queue for the duration of the app session in case a user
	        // logs out / back in. To behave like the LevelDB-backed MutationQueue (and
	        // accommodate tests that expect as much), we reset nextBatchId and
	        // highestAcknowledgedBatchId if the queue is empty.
	        if (this.mutationQueue.length === 0) {
	            this.nextBatchId = 1;
	            this.highestAcknowledgedBatchId = BATCHID_UNKNOWN;
	        }
	        assert(this.highestAcknowledgedBatchId < this.nextBatchId, 'highestAcknowledgedBatchId must be less than the nextBatchId');
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
	        return PersistencePromise.resolve(this.mutationQueue.length === 0);
	    };
	    MemoryMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return PersistencePromise.resolve(this.nextBatchId);
	    };
	    MemoryMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return PersistencePromise.resolve(this.highestAcknowledgedBatchId);
	    };
	    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert(batchId > this.highestAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
	        // Verify that the batch in the queue is the one to be acknowledged.
	        var check = this.mutationQueue[batchIndex];
	        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
	            batchId +
	            ', got batch ' +
	            check.batchId);
	        assert(!check.isTombstone(), "Can't acknowledge a previously removed batch");
	        this.highestAcknowledgedBatchId = batchId;
	        this.lastStreamToken = streamToken;
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return PersistencePromise.resolve(this.lastStreamToken);
	    };
	    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.lastStreamToken = streamToken;
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        assert(mutations.length !== 0, 'Mutation batches should not be empty');
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        if (this.mutationQueue.length > 0) {
	            var prior = this.mutationQueue[this.mutationQueue.length - 1];
	            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
	        }
	        var batch = new MutationBatch(batchId, localWriteTime, mutations);
	        this.mutationQueue.push(batch);
	        // Track references by document key.
	        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	            var mutation = mutations_1[_i];
	            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
	        }
	        return PersistencePromise.resolve(batch);
	    };
	    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        return PersistencePromise.resolve(this.findMutationBatch(batchId));
	    };
	    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var size = this.mutationQueue.length;
	        // All batches with batchId <= this.highestAcknowledgedBatchId have been
	        // acknowledged so the first unacknowledged batch after batchID will have a
	        // batchID larger than both of these values.
	        var nextBatchId = Math.max(batchId, this.highestAcknowledgedBatchId) + 1;
	        // The requested batchId may still be out of range so normalize it to the
	        // start of the queue.
	        var rawIndex = this.indexOfBatchId(nextBatchId);
	        var index = rawIndex < 0 ? 0 : rawIndex;
	        // Finally return the first non-tombstone batch.
	        for (; index < size; index++) {
	            var batch = this.mutationQueue[index];
	            if (!batch.isTombstone()) {
	                return PersistencePromise.resolve(batch);
	            }
	        }
	        return PersistencePromise.resolve(null);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        return PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(this.mutationQueue.length));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var count = this.mutationQueue.length;
	        var endIndex = this.indexOfBatchId(batchId);
	        if (endIndex < 0) {
	            endIndex = 0;
	        }
	        else if (endIndex >= count) {
	            endIndex = count;
	        }
	        else {
	            // The endIndex is in the queue so increment to pull everything in the
	            // queue including it.
	            endIndex++;
	        }
	        return PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(endIndex));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        var start = new DocReference(documentKey, 0);
	        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
	        var result = [];
	        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
	            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
	            var batch = _this.findMutationBatch(ref.targetOrBatchId);
	            assert(batch !== null, 'Batches in the index must exist in the main table');
	            result.push(batch);
	        });
	        return PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        // Use the query path as a prefix for testing if a document matches the
	        // query.
	        var prefix = query.path;
	        var immediateChildrenPathLength = prefix.length + 1;
	        // Construct a document reference for actually scanning the index. Unlike
	        // the prefix the document key in this reference must have an even number of
	        // segments. The empty segment can be used a suffix of the query path
	        // because it precedes all other segments in an ordered traversal.
	        var startPath = prefix;
	        if (!DocumentKey.isDocumentKey(startPath)) {
	            startPath = startPath.child('');
	        }
	        var start = new DocReference(new DocumentKey(startPath), 0);
	        // Find unique batchIDs referenced by all documents potentially matching the
	        // query.
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        this.batchesByDocumentKey.forEachWhile(function (ref) {
	            var rowKeyPath = ref.key.path;
	            if (!prefix.isPrefixOf(rowKeyPath)) {
	                return false;
	            }
	            else {
	                // Rows with document keys more than one segment longer than the query
	                // path can't be matches. For example, a query on 'rooms' can't match
	                // the document /rooms/abc/messages/xyx.
	                // TODO(mcg): we'll need a different scanner when we implement
	                // ancestor queries.
	                if (rowKeyPath.length === immediateChildrenPathLength) {
	                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
	                }
	                return true;
	            }
	        }, start);
	        // Construct an array of matching batches, sorted by batchID to ensure that
	        // multiple mutations affecting the same document key are applied in order.
	        var result = [];
	        uniqueBatchIDs.forEach(function (batchId) {
	            var batch = _this.findMutationBatch(batchId);
	            if (batch !== null) {
	                result.push(batch);
	            }
	        });
	        return PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var batchCount = batches.length;
	        assert(batchCount > 0, 'Should not remove mutations when none exist.');
	        var firstBatchId = batches[0].batchId;
	        var queueCount = this.mutationQueue.length;
	        // Find the position of the first batch for removal. This need not be the
	        // first entry in the queue.
	        var startIndex = this.indexOfExistingBatchId(firstBatchId, 'removed');
	        assert(this.mutationQueue[startIndex].batchId === firstBatchId, 'Removed batches must exist in the queue');
	        // Check that removed batches are contiguous (while excluding tombstones).
	        var batchIndex = 1;
	        var queueIndex = startIndex + 1;
	        while (batchIndex < batchCount && queueIndex < queueCount) {
	            var batch = this.mutationQueue[queueIndex];
	            if (batch.isTombstone()) {
	                queueIndex++;
	                continue;
	            }
	            assert(batch.batchId === batches[batchIndex].batchId, 'Removed batches must be contiguous in the queue');
	            batchIndex++;
	            queueIndex++;
	        }
	        // Only actually remove batches if removing at the front of the queue.
	        // Previously rejected batches may have left tombstones in the queue, so
	        // expand the removal range to include any tombstones.
	        if (startIndex === 0) {
	            for (; queueIndex < queueCount; queueIndex++) {
	                var batch = this.mutationQueue[queueIndex];
	                if (!batch.isTombstone()) {
	                    break;
	                }
	            }
	            var length_1 = queueIndex - startIndex;
	            this.mutationQueue.splice(startIndex, length_1);
	        }
	        else {
	            // Mark the tombstones
	            for (var i = startIndex; i < queueIndex; i++) {
	                this.mutationQueue[i] = this.mutationQueue[i].toTombstone();
	            }
	        }
	        var references = this.batchesByDocumentKey;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            var batchId = batch.batchId;
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                if (this.garbageCollector !== null) {
	                    this.garbageCollector.addPotentialGarbageKey(key);
	                }
	                var ref = new DocReference(key, batchId);
	                references = references.delete(ref);
	            }
	        }
	        this.batchesByDocumentKey = references;
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
	        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
	    };
	    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        if (this.mutationQueue.length === 0) {
	            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
	        }
	        return PersistencePromise.resolve();
	    };
	    /**
	     * A private helper that collects all the mutations batches in the queue up to
	     * but not including the given endIndex. All tombstones in the queue are
	     * excluded.
	     */
	    MemoryMutationQueue.prototype.getAllLiveMutationBatchesBeforeIndex = function (endIndex) {
	        var result = [];
	        for (var i = 0; i < endIndex; i++) {
	            var batch = this.mutationQueue[i];
	            if (!batch.isTombstone()) {
	                result.push(batch);
	            }
	        }
	        return result;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue and asserts that
	     * the resulting index is within the bounds of the queue.
	     *
	     * @param batchId The batchId to search for
	     * @param action A description of what the caller is doing, phrased in passive
	     * form (e.g. "acknowledged" in a routine that acknowledges batches).
	     */
	    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
	        var index = this.indexOfBatchId(batchId);
	        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
	        return index;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue. This operation
	     * is O(1).
	     *
	     * @return The computed index of the batch with the given batchId, based on
	     * the state of the queue. Note this index can be negative if the requested
	     * batchId has already been remvoed from the queue or past the end of the
	     * queue if the batchId is larger than the last added batch.
	     */
	    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
	        if (this.mutationQueue.length === 0) {
	            // As an index this is past the end of the queue
	            return 0;
	        }
	        // Examine the front of the queue to figure out the difference between the
	        // batchId and indexes in the array. Note that since the queue is ordered
	        // by batchId, if the first batch has a larger batchId then the requested
	        // batchId doesn't exist in the queue.
	        var firstBatchId = this.mutationQueue[0].batchId;
	        return batchId - firstBatchId;
	    };
	    /**
	     * A version of lookupMutationBatch that doesn't return a promise, this makes
	     * other functions that uses this code easier to read and more efficent.
	     */
	    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
	        var index = this.indexOfBatchId(batchId);
	        if (index < 0 || index >= this.mutationQueue.length) {
	            return null;
	        }
	        var batch = this.mutationQueue[index];
	        assert(batch.batchId === batchId, 'If found batch must match');
	        return batch.isTombstone() ? null : batch;
	    };
	    return MemoryMutationQueue;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MemoryQueryCache = /** @class */ (function () {
	    function MemoryQueryCache() {
	        /**
	         * Maps a query to the data about that query
	         */
	        this.queries = new ObjectMap(function (q) { return q.canonicalId(); });
	        /** The last received snapshot version. */
	        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
	        /** The highest numbered target ID encountered. */
	        this.highestTargetId = 0;
	        /**
	         * A ordered bidirectional mapping between documents and the remote target
	         * IDs.
	         */
	        this.references = new ReferenceSet();
	        this.targetCount = 0;
	    }
	    MemoryQueryCache.prototype.start = function (transaction) {
	        // Nothing to do.
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    MemoryQueryCache.prototype.getHighestTargetId = function () {
	        return this.highestTargetId;
	    };
	    MemoryQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.saveQueryData = function (queryData) {
	        this.queries.set(queryData.query, queryData);
	        var targetId = queryData.targetId;
	        if (targetId > this.highestTargetId) {
	            this.highestTargetId = targetId;
	        }
	        // TODO(GC): track sequence number
	    };
	    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        assert(!this.queries.has(queryData.query), 'Adding a query that already exists');
	        this.saveQueryData(queryData);
	        this.targetCount += 1;
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.updateQueryData = function (transaction, queryData) {
	        assert(this.queries.has(queryData.query), 'Updating a non-existent query');
	        this.saveQueryData(queryData);
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        assert(this.targetCount > 0, 'Removing a target from an empty cache');
	        assert(this.queries.has(queryData.query), 'Removing a non-existent target from the cache');
	        this.queries.delete(queryData.query);
	        this.references.removeReferencesForId(queryData.targetId);
	        this.targetCount -= 1;
	        return PersistencePromise.resolve();
	    };
	    Object.defineProperty(MemoryQueryCache.prototype, "count", {
	        get: function () {
	            return this.targetCount;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
	        var queryData = this.queries.get(query) || null;
	        return PersistencePromise.resolve(queryData);
	    };
	    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        this.references.addReferences(keys, targetId);
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        this.references.removeReferences(keys, targetId);
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        this.references.removeReferencesForId(targetId);
	        return PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var matchingKeys = this.references.referencesForId(targetId);
	        return PersistencePromise.resolve(matchingKeys);
	    };
	    MemoryQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.references.setGarbageCollector(gc);
	    };
	    MemoryQueryCache.prototype.containsKey = function (txn, key) {
	        return this.references.containsKey(txn, key);
	    };
	    return MemoryQueryCache;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MemoryRemoteDocumentCache = /** @class */ (function () {
	    function MemoryRemoteDocumentCache() {
	        this.docs = maybeDocumentMap();
	    }
	    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        this.docs = this.docs.insert(maybeDocument.key, maybeDocument);
	        return PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        this.docs = this.docs.remove(documentKey);
	        return PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        return PersistencePromise.resolve(this.docs.get(documentKey));
	    };
	    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var results = documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var prefix = new DocumentKey(query.path.child(''));
	        var iterator = this.docs.getIteratorFrom(prefix);
	        while (iterator.hasNext()) {
	            var _a = iterator.getNext(), key = _a.key, maybeDoc = _a.value;
	            if (!query.path.isPrefixOf(key.path)) {
	                break;
	            }
	            if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        }
	        return PersistencePromise.resolve(results);
	    };
	    return MemoryRemoteDocumentCache;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$5 = 'MemoryPersistence';
	/**
	 * A memory-backed instance of Persistence. Data is stored only in RAM and
	 * not persisted across sessions.
	 */
	var MemoryPersistence = /** @class */ (function () {
	    function MemoryPersistence() {
	        /**
	         * Note that these are retained here to make it easier to write tests
	         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
	         * can create a new LocalStore wrapping this Persistence instance and this
	         * will make the in-memory persistence layer behave as if it were actually
	         * persisting values.
	         */
	        this.mutationQueues = {};
	        this.remoteDocumentCache = new MemoryRemoteDocumentCache();
	        this.queryCache = new MemoryQueryCache();
	        this.started = false;
	    }
	    MemoryPersistence.prototype.start = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                // No durable state to read on startup.
	                assert(!this.started, 'MemoryPersistence double-started!');
	                this.started = true;
	                return [2 /*return*/];
	            });
	        });
	    };
	    MemoryPersistence.prototype.shutdown = function (deleteData) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                // No durable state to ensure is closed on shutdown.
	                assert(this.started, 'MemoryPersistence shutdown without start!');
	                this.started = false;
	                return [2 /*return*/];
	            });
	        });
	    };
	    MemoryPersistence.prototype.getMutationQueue = function (user) {
	        var queue = this.mutationQueues[user.toKey()];
	        if (!queue) {
	            queue = new MemoryMutationQueue();
	            this.mutationQueues[user.toKey()] = queue;
	        }
	        return queue;
	    };
	    MemoryPersistence.prototype.getQueryCache = function () {
	        return this.queryCache;
	    };
	    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
	        return this.remoteDocumentCache;
	    };
	    MemoryPersistence.prototype.runTransaction = function (action, operation) {
	        debug(LOG_TAG$5, 'Starting transaction:', action);
	        return operation(new MemoryPersistenceTransaction()).toPromise();
	    };
	    return MemoryPersistence;
	}());
	/** Dummy class since memory persistence doesn't actually use transactions. */
	var MemoryPersistenceTransaction = /** @class */ (function () {
	    function MemoryPersistenceTransaction() {
	    }
	    return MemoryPersistenceTransaction;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A garbage collector implementation that does absolutely nothing. It ignores
	 * all addGarbageSource and addPotentialGarbageKey messages and and never
	 * produces any garbage.
	 */
	var NoOpGarbageCollector = /** @class */ (function () {
	    function NoOpGarbageCollector() {
	        this.isEager = false;
	    }
	    NoOpGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        // Not tracking garbage so ignore.
	    };
	    NoOpGarbageCollector.prototype.collectGarbage = function (txn) {
	        return PersistencePromise.resolve(documentKeySet());
	    };
	    return NoOpGarbageCollector;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wellknown "timer" IDs used when scheduling delayed operations on the
	 * AsyncQueue. These IDs can then be used from tests to check for the presence
	 * of operations or to run them early.
	 *
	 * The string values are used when encoding these timer IDs in JSON spec tests.
	 */
	var TimerId;
	(function (TimerId) {
	    /** All can be used with runDelayedOperationsEarly() to run all timers. */
	    TimerId["All"] = "all";
	    /**
	     * The following 4 timers are used in persistent_stream.ts for the listen and
	     * write streams. The "Idle" timer is used to close the stream due to
	     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
	     * the appropriate backoff delay has elapsed.
	     */
	    TimerId["ListenStreamIdle"] = "listen_stream_idle";
	    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
	    TimerId["WriteStreamIdle"] = "write_stream_idle";
	    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
	    /**
	     * A timer used in online_state_tracker.ts to transition from
	     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
	     * indefinitely for success or failure.
	     */
	    TimerId["OnlineStateTimeout"] = "online_state_timeout";
	})(TimerId || (TimerId = {}));
	/**
	 * Represents an operation scheduled to be run in the future on an AsyncQueue.
	 *
	 * It is created via DelayedOperation.createAndSchedule().
	 *
	 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
	 */
	var DelayedOperation = /** @class */ (function () {
	    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
	        this.asyncQueue = asyncQueue;
	        this.timerId = timerId;
	        this.targetTimeMs = targetTimeMs;
	        this.op = op;
	        this.removalCallback = removalCallback;
	        this.deferred = new Deferred$1();
	        this.then = this.deferred.promise.then.bind(this.deferred.promise);
	        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
	        // It's normal for the deferred promise to be canceled (due to cancellation)
	        // and so we attach a dummy catch callback to avoid
	        // 'UnhandledPromiseRejectionWarning' log spam.
	        this.deferred.promise.catch(function (err) { });
	    }
	    /**
	     * Creates and returns a DelayedOperation that has been scheduled to be
	     * executed on the provided asyncQueue after the provided delayMs.
	     *
	     * @param asyncQueue The queue to schedule the operation on.
	     * @param id A Timer ID identifying the type of operation this is.
	     * @param delayMs The delay (ms) before the operation should be scheduled.
	     * @param op The operation to run.
	     * @param removalCallback A callback to be called synchronously once the
	     *   operation is executed or canceled, notifying the AsyncQueue to remove it
	     *   from its delayedOperations list.
	     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
	     *   the DelayedOperation class public.
	     */
	    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
	        var targetTime = Date.now() + delayMs;
	        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
	        delayedOp.start(delayMs);
	        return delayedOp;
	    };
	    /**
	     * Starts the timer. This is called immediately after construction by
	     * createAndSchedule().
	     */
	    DelayedOperation.prototype.start = function (delayMs) {
	        var _this = this;
	        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
	    };
	    /**
	     * Queues the operation to run immediately (if it hasn't already been run or
	     * canceled).
	     */
	    DelayedOperation.prototype.skipDelay = function () {
	        return this.handleDelayElapsed();
	    };
	    /**
	     * Cancels the operation if it hasn't already been executed or canceled. The
	     * promise will be rejected.
	     *
	     * As long as the operation has not yet been run, calling cancel() provides a
	     * guarantee that the operation will not be run.
	     */
	    DelayedOperation.prototype.cancel = function (reason) {
	        if (this.timerHandle !== null) {
	            this.clearTimeout();
	            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
	        }
	    };
	    DelayedOperation.prototype.handleDelayElapsed = function () {
	        var _this = this;
	        this.asyncQueue.enqueue(function () {
	            if (_this.timerHandle !== null) {
	                _this.clearTimeout();
	                return _this.op().then(function (result) {
	                    return _this.deferred.resolve(result);
	                });
	            }
	            else {
	                return Promise.resolve();
	            }
	        });
	    };
	    DelayedOperation.prototype.clearTimeout = function () {
	        if (this.timerHandle !== null) {
	            this.removalCallback(this);
	            clearTimeout(this.timerHandle);
	            this.timerHandle = null;
	        }
	    };
	    return DelayedOperation;
	}());
	var AsyncQueue = /** @class */ (function () {
	    function AsyncQueue() {
	        // The last promise in the queue.
	        this.tail = Promise.resolve();
	        // Operations scheduled to be queued in the future. Operations are
	        // automatically removed after they are run or canceled.
	        this.delayedOperations = [];
	        // Flag set while there's an outstanding AsyncQueue operation, used for
	        // assertion sanity-checks.
	        this.operationInProgress = false;
	    }
	    /**
	     * Adds a new operation to the queue. Returns a promise that will be resolved
	     * when the promise returned by the new operation is (with its value).
	     */
	    AsyncQueue.prototype.enqueue = function (op) {
	        var _this = this;
	        this.verifyNotFailed();
	        var newTail = this.tail.then(function () {
	            _this.operationInProgress = true;
	            return op()
	                .catch(function (error$$1) {
	                _this.failure = error$$1;
	                _this.operationInProgress = false;
	                var message = error$$1.stack || error$$1.message || '';
	                error('INTERNAL UNHANDLED ERROR: ', message);
	                // Escape the promise chain and throw the error globally so that
	                // e.g. any global crash reporting library detects and reports it.
	                // (but not for simulated errors in our tests since this breaks mocha)
	                if (message.indexOf('Firestore Test Simulated Error') < 0) {
	                    setTimeout(function () {
	                        throw error$$1;
	                    }, 0);
	                }
	                // Re-throw the error so that this.tail becomes a rejected Promise and
	                // all further attempts to chain (via .then) will just short-circuit
	                // and return the rejected Promise.
	                throw error$$1;
	            })
	                .then(function (result) {
	                _this.operationInProgress = false;
	                return result;
	            });
	        });
	        this.tail = newTail;
	        return newTail;
	    };
	    /**
	     * Schedules an operation to be queued on the AsyncQueue once the specified
	     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
	     * the operation prior to its running.
	     */
	    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
	        var _this = this;
	        this.verifyNotFailed();
	        // While not necessarily harmful, we currently don't expect to have multiple
	        // ops with the same timer id in the queue, so defensively reject them.
	        assert(!this.containsDelayedOperation(timerId), "Attempted to schedule multiple operations with timer id " + timerId + ".");
	        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (op) { return _this.removeDelayedOperation(op); });
	        this.delayedOperations.push(delayedOp);
	        return delayedOp;
	    };
	    AsyncQueue.prototype.verifyNotFailed = function () {
	        if (this.failure) {
	            fail('AsyncQueue is already failed: ' +
	                (this.failure.stack || this.failure.message));
	        }
	    };
	    /**
	     * Verifies there's an operation currently in-progress on the AsyncQueue.
	     * Unfortunately we can't verify that the running code is in the promise chain
	     * of that operation, so this isn't a foolproof check, but it should be enough
	     * to catch some bugs.
	     */
	    AsyncQueue.prototype.verifyOperationInProgress = function () {
	        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
	    };
	    /**
	     * Waits until all currently queued tasks are finished executing. Delayed
	     * operations are not run.
	     */
	    AsyncQueue.prototype.drain = function () {
	        return this.enqueue(function () { return Promise.resolve(); });
	    };
	    /**
	     * For Tests: Determine if a delayed operation with a particular TimerId
	     * exists.
	     */
	    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
	        return this.delayedOperations.findIndex(function (op) { return op.timerId === timerId; }) >= 0;
	    };
	    /**
	     * For Tests: Runs some or all delayed operations early.
	     *
	     * @param lastTimerId Delayed operations up to and including this TimerId will
	     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
	     *  all delayed operations.
	     * @returns a Promise that resolves once all operations have been run.
	     */
	    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
	        var _this = this;
	        // Note that draining may generate more delayed ops, so we do that first.
	        return this.drain().then(function () {
	            assert(lastTimerId === TimerId.All ||
	                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
	            // Run ops in the same order they'd run if they ran naturally.
	            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
	            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
	                var op = _a[_i];
	                op.skipDelay();
	                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
	                    break;
	                }
	            }
	            return _this.drain();
	        });
	    };
	    /** Called once a DelayedOperation is run or canceled. */
	    AsyncQueue.prototype.removeDelayedOperation = function (op) {
	        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
	        var index = this.delayedOperations.indexOf(op);
	        assert(index >= 0, 'Delayed operation not found.');
	        this.delayedOperations.splice(index, 1);
	    };
	    return AsyncQueue;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$6 = 'ExponentialBackoff';
	/**
	 * A helper for running delayed tasks following an exponential backoff curve
	 * between attempts.
	 *
	 * Each delay is made up of a "base" delay which follows the exponential
	 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
	 * base delay. This prevents clients from accidentally synchronizing their
	 * delays causing spikes of load to the backend.
	 */
	var ExponentialBackoff = /** @class */ (function () {
	    function ExponentialBackoff(
	    /**
	     * The AsyncQueue to run backoff operations on.
	     */
	    queue, 
	    /**
	     * The ID to use when scheduling backoff operations on the AsyncQueue.
	     */
	    timerId, 
	    /**
	     * The initial delay (used as the base delay on the first retry attempt).
	     * Note that jitter will still be applied, so the actual delay could be as
	     * little as 0.5*initialDelayMs.
	     */
	    initialDelayMs, 
	    /**
	     * The multiplier to use to determine the extended base delay after each
	     * attempt.
	     */
	    backoffFactor, 
	    /**
	     * The maximum base delay after which no further backoff is performed.
	     * Note that jitter will still be applied, so the actual delay could be as
	     * much as 1.5*maxDelayMs.
	     */
	    maxDelayMs) {
	        this.queue = queue;
	        this.timerId = timerId;
	        this.initialDelayMs = initialDelayMs;
	        this.backoffFactor = backoffFactor;
	        this.maxDelayMs = maxDelayMs;
	        this.timerPromise = null;
	        this.reset();
	    }
	    /**
	     * Resets the backoff delay.
	     *
	     * The very next backoffAndWait() will have no delay. If it is called again
	     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
	     * subsequent ones will increase according to the backoffFactor.
	     */
	    ExponentialBackoff.prototype.reset = function () {
	        this.currentBaseMs = 0;
	    };
	    /**
	     * Resets the backoff delay to the maximum delay (e.g. for use after a
	     * RESOURCE_EXHAUSTED error).
	     */
	    ExponentialBackoff.prototype.resetToMax = function () {
	        this.currentBaseMs = this.maxDelayMs;
	    };
	    /**
	     * Returns a promise that resolves after currentDelayMs, and increases the
	     * delay for any subsequent attempts. If there was a pending backoff operation
	     * already, it will be canceled.
	     */
	    ExponentialBackoff.prototype.backoffAndRun = function (op) {
	        // Cancel any pending backoff operation.
	        this.cancel();
	        // First schedule using the current base (which may be 0 and should be
	        // honored as such).
	        var delayWithJitterMs = this.currentBaseMs + this.jitterDelayMs();
	        if (this.currentBaseMs > 0) {
	            debug(LOG_TAG$6, "Backing off for " + delayWithJitterMs + " ms " +
	                ("(base delay: " + this.currentBaseMs + " ms)"));
	        }
	        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, delayWithJitterMs, op);
	        // Apply backoff factor to determine next delay and ensure it is within
	        // bounds.
	        this.currentBaseMs *= this.backoffFactor;
	        if (this.currentBaseMs < this.initialDelayMs) {
	            this.currentBaseMs = this.initialDelayMs;
	        }
	        if (this.currentBaseMs > this.maxDelayMs) {
	            this.currentBaseMs = this.maxDelayMs;
	        }
	    };
	    ExponentialBackoff.prototype.cancel = function () {
	        if (this.timerPromise !== null) {
	            this.timerPromise.cancel();
	            this.timerPromise = null;
	        }
	    };
	    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
	    ExponentialBackoff.prototype.jitterDelayMs = function () {
	        return (Math.random() - 0.5) * this.currentBaseMs;
	    };
	    return ExponentialBackoff;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$7 = 'PersistentStream';
	var PersistentStreamState;
	(function (PersistentStreamState) {
	    /**
	     * The streaming RPC is not running and there's no error condition.
	     * Calling `start` will start the stream immediately without backoff.
	     * While in this state isStarted will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
	    /**
	     * The stream is starting, and is waiting for an auth token to attach to
	     * the initial request. While in this state, isStarted will return
	     * true but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Auth"] = 1] = "Auth";
	    /**
	     * The streaming RPC is up and running. Requests and responses can flow
	     * freely. Both isStarted and isOpen will return true.
	     */
	    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
	    /**
	     * The stream encountered an error. The next start attempt will back off.
	     * While in this state isStarted() will return false.
	     *
	     */
	    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
	    /**
	     * An in-between state after an error where the stream is waiting before
	     * re-starting. After
	     * waiting is complete, the stream will try to open. While in this
	     * state isStarted() will return YES but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
	    /**
	     * The stream has been explicitly stopped; no further events will be emitted.
	     */
	    PersistentStreamState[PersistentStreamState["Stopped"] = 5] = "Stopped";
	})(PersistentStreamState || (PersistentStreamState = {}));
	/**
	 * Initial backoff time in milliseconds after an error.
	 * Set to 1s according to https://cloud.google.com/apis/design/errors.
	 */
	var BACKOFF_INITIAL_DELAY_MS = 1000;
	/** Maximum backoff time in milliseconds */
	var BACKOFF_MAX_DELAY_MS = 60 * 1000;
	var BACKOFF_FACTOR = 1.5;
	/** The time a stream stays open after it is marked idle. */
	var IDLE_TIMEOUT_MS = 60 * 1000;
	/**
	 * A PersistentStream is an abstract base class that represents a streaming RPC
	 * to the Firestore backend. It's built on top of the connections own support
	 * for streaming RPCs, and adds several critical features for our clients:
	 *
	 *   - Exponential backoff on failure
	 *   - Authentication via CredentialsProvider
	 *   - Dispatching all callbacks into the shared worker queue
	 *
	 * Subclasses of PersistentStream implement serialization of models to and
	 * from the JSON representation of the protocol buffers for a specific
	 * streaming RPC.
	 *
	 * ## Starting and Stopping
	 *
	 * Streaming RPCs are stateful and need to be `start`ed before messages can
	 * be sent and received. The PersistentStream will call the onOpen function
	 * of the listener once the stream is ready to accept requests.
	 *
	 * Should a `start` fail, PersistentStream will call the registered
	 * onClose with a FirestoreError indicating what went wrong.
	 *
	 * A PersistentStream can be started and stopped repeatedly.
	 *
	 * Generic types:
	 *  SendType: The type of the outgoing message of the underlying
	 *    connection stream
	 *  ReceiveType: The type of the incoming message of the underlying
	 *    connection stream
	 *  ListenerType: The type of the listener that will be used for callbacks
	 */
	var PersistentStream = /** @class */ (function () {
	    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider) {
	        this.queue = queue;
	        this.idleTimerId = idleTimerId;
	        this.connection = connection;
	        this.credentialsProvider = credentialsProvider;
	        this.inactivityTimerPromise = null;
	        this.stream = null;
	        this.listener = null;
	        this.backoff = new ExponentialBackoff(queue, connectionTimerId, BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
	        this.state = PersistentStreamState.Initial;
	    }
	    /**
	     * Returns true if `start` has been called and no error has occurred. True
	     * indicates the stream is open or in the process of opening (which
	     * encompasses respecting backoff, getting auth tokens, and starting the
	     * actual RPC). Use `isOpen` to determine if the stream is open and ready for
	     * outbound requests.
	     */
	    PersistentStream.prototype.isStarted = function () {
	        return (this.state === PersistentStreamState.Backoff ||
	            this.state === PersistentStreamState.Auth ||
	            this.state === PersistentStreamState.Open);
	    };
	    /**
	     * Returns true if the underlying RPC is open (the openHandler has been
	     * called) and the stream is ready for outbound requests.
	     */
	    PersistentStream.prototype.isOpen = function () {
	        return this.state === PersistentStreamState.Open;
	    };
	    /**
	     * Starts the RPC. Only allowed if isStarted returns false. The stream is
	     * not immediately ready for use: onOpen will be invoked when the RPC is ready
	     * for outbound requests, at which point isOpen will return true.
	     *
	     *  When start returns, isStarted will return true.
	     */
	    PersistentStream.prototype.start = function (listener) {
	        if (this.state === PersistentStreamState.Error) {
	            this.performBackoff(listener);
	            return;
	        }
	        assert(this.state === PersistentStreamState.Initial, 'Already started');
	        this.listener = listener;
	        this.auth();
	    };
	    /**
	     * Stops the RPC. This call is idempotent and allowed regardless of the
	     * current isStarted state.
	     *
	     * When stop returns, isStarted and isOpen will both return false.
	     */
	    PersistentStream.prototype.stop = function () {
	        if (this.isStarted()) {
	            this.close(PersistentStreamState.Stopped);
	        }
	    };
	    /**
	     * After an error the stream will usually back off on the next attempt to
	     * start it. If the error warrants an immediate restart of the stream, the
	     * sender can use this to indicate that the receiver should not back off.
	     *
	     * Each error will call the onClose function. That function can decide to
	     * inhibit backoff if required.
	     */
	    PersistentStream.prototype.inhibitBackoff = function () {
	        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
	        this.state = PersistentStreamState.Initial;
	        this.backoff.reset();
	    };
	    /**
	     * Marks this stream as idle. If no further actions are performed on the
	     * stream for one minute, the stream will automatically close itself and
	     * notify the stream's onClose() handler with Status.OK. The stream will then
	     * be in a !isStarted() state, requiring the caller to start the stream again
	     * before further use.
	     *
	     * Only streams that are in state 'Open' can be marked idle, as all other
	     * states imply pending network operations.
	     */
	    PersistentStream.prototype.markIdle = function () {
	        var _this = this;
	        // Starts the idle time if we are in state 'Open' and are not yet already
	        // running a timer (in which case the previous idle timeout still applies).
	        if (this.isOpen() && this.inactivityTimerPromise === null) {
	            this.inactivityTimerPromise = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
	        }
	    };
	    /** Sends a message to the underlying stream. */
	    PersistentStream.prototype.sendRequest = function (msg) {
	        this.cancelIdleCheck();
	        this.stream.send(msg);
	    };
	    /** Called by the idle timer when the stream should close due to inactivity. */
	    PersistentStream.prototype.handleIdleCloseTimer = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (this.isOpen()) {
	                    // When timing out an idle stream there's no reason to force the stream into backoff when
	                    // it restarts so set the stream state to Initial instead of Error.
	                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /** Marks the stream as active again. */
	    PersistentStream.prototype.cancelIdleCheck = function () {
	        if (this.inactivityTimerPromise) {
	            this.inactivityTimerPromise.cancel();
	            this.inactivityTimerPromise = null;
	        }
	    };
	    /**
	     * Closes the stream and cleans up as necessary:
	     *
	     * * closes the underlying GRPC stream;
	     * * calls the onClose handler with the given 'error';
	     * * sets internal stream state to 'finalState';
	     * * adjusts the backoff timer based on the error
	     *
	     * A new stream can be opened by calling `start` unless `finalState` is set to
	     * `PersistentStreamState.Stopped`.
	     *
	     * @param finalState the intended state of the stream after closing.
	     * @param error the error the connection was closed with.
	     */
	    PersistentStream.prototype.close = function (finalState, error$$1) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var listener;
	            return tslib_1.__generator(this, function (_a) {
	                assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$$1), "Can't provide an error when not in an error state.");
	                // The stream will be closed so we don't need our idle close timer anymore.
	                this.cancelIdleCheck();
	                // Ensure we don't leave a pending backoff operation queued (in case close()
	                // was called while we were waiting to reconnect).
	                this.backoff.cancel();
	                if (finalState !== PersistentStreamState.Error) {
	                    // If this is an intentional close ensure we don't delay our next connection attempt.
	                    this.backoff.reset();
	                }
	                else if (error$$1 && error$$1.code === Code.RESOURCE_EXHAUSTED) {
	                    // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
	                    error(error$$1.toString());
	                    error('Using maximum backoff delay to prevent overloading the backend.');
	                    this.backoff.resetToMax();
	                }
	                // Clean up the underlying stream because we are no longer interested in events.
	                if (this.stream !== null) {
	                    this.tearDown();
	                    this.stream.close();
	                    this.stream = null;
	                }
	                // This state must be assigned before calling onClose() to allow the callback to
	                // inhibit backoff or otherwise manipulate the state in its non-started state.
	                this.state = finalState;
	                listener = this.listener;
	                // Clear the listener to avoid bleeding of events from the underlying streams.
	                this.listener = null;
	                // If the caller explicitly requested a stream stop, don't notify them of a closing stream (it
	                // could trigger undesirable recovery logic, etc.).
	                if (finalState !== PersistentStreamState.Stopped) {
	                    return [2 /*return*/, listener.onClose(error$$1)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * Can be overridden to perform additional cleanup before the stream is closed.
	     * Calling super.tearDown() is not required.
	     */
	    PersistentStream.prototype.tearDown = function () { };
	    PersistentStream.prototype.auth = function () {
	        var _this = this;
	        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
	        this.state = PersistentStreamState.Auth;
	        this.credentialsProvider.getToken(/*forceRefresh=*/ false).then(function (token) {
	            // Normally we'd have to schedule the callback on the AsyncQueue.
	            // However, the following calls are safe to be called outside the
	            // AsyncQueue since they don't chain asynchronous calls
	            _this.startStream(token);
	        }, function (error$$1) {
	            _this.queue.enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                var rpcError;
	                return tslib_1.__generator(this, function (_a) {
	                    if (this.state !== PersistentStreamState.Stopped) {
	                        rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error$$1.message);
	                        return [2 /*return*/, this.handleStreamClose(rpcError)];
	                    }
	                    return [2 /*return*/];
	                });
	            }); });
	        });
	    };
	    PersistentStream.prototype.startStream = function (token) {
	        var _this = this;
	        if (this.state === PersistentStreamState.Stopped) {
	            // Stream can be stopped while waiting for authorization.
	            return;
	        }
	        assert(this.state === PersistentStreamState.Auth, 'Trying to start stream in a non-auth state');
	        // Helper function to dispatch to AsyncQueue and make sure that any
	        // close will seem instantaneous and events are prevented from being
	        // raised after the close call
	        var dispatchIfStillActive = function (stream, fn) {
	            _this.queue.enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                return tslib_1.__generator(this, function (_a) {
	                    // Only raise events if the stream instance has not changed
	                    if (this.stream === stream) {
	                        return [2 /*return*/, fn()];
	                    }
	                    return [2 /*return*/];
	                });
	            }); });
	        };
	        // Only start stream if listener has not changed
	        if (this.listener !== null) {
	            var currentStream_1 = this.startRpc(token);
	            this.stream = currentStream_1;
	            this.stream.onOpen(function () {
	                dispatchIfStillActive(currentStream_1, function () {
	                    assert(_this.state === PersistentStreamState.Auth, 'Expected stream to be in state auth, but was ' + _this.state);
	                    _this.state = PersistentStreamState.Open;
	                    return _this.listener.onOpen();
	                });
	            });
	            this.stream.onClose(function (error$$1) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.handleStreamClose(error$$1);
	                });
	            });
	            this.stream.onMessage(function (msg) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.onMessage(msg);
	                });
	            });
	        }
	    };
	    PersistentStream.prototype.performBackoff = function (listener) {
	        var _this = this;
	        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff in an error case');
	        this.state = PersistentStreamState.Backoff;
	        this.backoff.backoffAndRun(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (this.state === PersistentStreamState.Stopped) {
	                    // We should have canceled the backoff timer when the stream was
	                    // closed, but just in case we make this a no-op.
	                    return [2 /*return*/];
	                }
	                this.state = PersistentStreamState.Initial;
	                this.start(listener);
	                assert(this.isStarted(), 'PersistentStream should have started');
	                return [2 /*return*/];
	            });
	        }); });
	    };
	    PersistentStream.prototype.handleStreamClose = function (error$$1) {
	        assert(this.isStarted(), "Can't handle server close on non-started stream");
	        debug(LOG_TAG$7, "close with error: " + error$$1);
	        this.stream = null;
	        // In theory the stream could close cleanly, however, in our current model
	        // we never expect this to happen because if we stop a stream ourselves,
	        // this callback will never be called. To prevent cases where we retry
	        // without a backoff accidentally, we set the stream to error in all cases.
	        return this.close(PersistentStreamState.Error, error$$1);
	    };
	    return PersistentStream;
	}());
	/**
	 * A PersistentStream that implements the Listen RPC.
	 *
	 * Once the Listen stream has called the openHandler, any number of listen and
	 * unlisten calls calls can be sent to control what changes will be sent from
	 * the server for ListenResponses.
	 */
	var PersistentListenStream = /** @class */ (function (_super) {
	    tslib_1.__extends(PersistentListenStream, _super);
	    function PersistentListenStream(queue, connection, credentials, serializer) {
	        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials) || this;
	        _this.serializer = serializer;
	        return _this;
	    }
	    PersistentListenStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Listen', token);
	    };
	    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
	        // A successful response means the stream is healthy
	        this.backoff.reset();
	        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
	        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
	        return this.listener.onWatchChange(watchChange, snapshot);
	    };
	    /**
	     * Registers interest in the results of the given query. If the query
	     * includes a resumeToken it will be included in the request. Results that
	     * affect the query will be streamed back as WatchChange messages that
	     * reference the targetId.
	     */
	    PersistentListenStream.prototype.watch = function (queryData) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.addTarget = this.serializer.toTarget(queryData);
	        var labels = this.serializer.toListenRequestLabels(queryData);
	        if (labels) {
	            request.labels = labels;
	        }
	        this.sendRequest(request);
	    };
	    /**
	     * Unregisters interest in the results of the query associated with the
	     * given targetId.
	     */
	    PersistentListenStream.prototype.unwatch = function (targetId) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.removeTarget = targetId;
	        this.sendRequest(request);
	    };
	    return PersistentListenStream;
	}(PersistentStream));
	/**
	 * A Stream that implements the Write RPC.
	 *
	 * The Write RPC requires the caller to maintain special streamToken
	 * state in between calls, to help the server understand which responses the
	 * client has processed by the time the next request is made. Every response
	 * will contain a streamToken; this value must be passed to the next
	 * request.
	 *
	 * After calling start() on this stream, the next request must be a handshake,
	 * containing whatever streamToken is on hand. Once a response to this
	 * request is received, all pending mutations may be submitted. When
	 * submitting multiple batches of mutations at the same time, it's
	 * okay to use the same streamToken for the calls to writeMutations.
	 *
	 * TODO(b/33271235): Use proto types
	 */
	var PersistentWriteStream = /** @class */ (function (_super) {
	    tslib_1.__extends(PersistentWriteStream, _super);
	    function PersistentWriteStream(queue, connection, credentials, serializer) {
	        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials) || this;
	        _this.serializer = serializer;
	        _this.handshakeComplete_ = false;
	        return _this;
	    }
	    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
	        /**
	         * Tracks whether or not a handshake has been successfully exchanged and
	         * the stream is ready to accept mutations.
	         */
	        get: function () {
	            return this.handshakeComplete_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Override of PersistentStream.start
	    PersistentWriteStream.prototype.start = function (listener) {
	        this.handshakeComplete_ = false;
	        _super.prototype.start.call(this, listener);
	    };
	    PersistentWriteStream.prototype.tearDown = function () {
	        if (this.handshakeComplete_) {
	            this.writeMutations([]);
	        }
	    };
	    PersistentWriteStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Write', token);
	    };
	    PersistentWriteStream.prototype.onMessage = function (responseProto) {
	        // Always capture the last stream token.
	        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
	        this.lastStreamToken = responseProto.streamToken;
	        if (!this.handshakeComplete_) {
	            // The first response is always the handshake response
	            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
	            this.handshakeComplete_ = true;
	            return this.listener.onHandshakeComplete();
	        }
	        else {
	            // A successful first write response means the stream is healthy,
	            // Note, that we could consider a successful handshake healthy, however,
	            // the write itself might be causing an error we want to back off from.
	            this.backoff.reset();
	            var results = this.serializer.fromWriteResults(responseProto.writeResults);
	            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
	            return this.listener.onMutationResult(commitVersion, results);
	        }
	    };
	    /**
	     * Sends an initial streamToken to the server, performing the handshake
	     * required to make the StreamingWrite RPC work. Subsequent
	     * calls should wait until onHandshakeComplete was called.
	     */
	    PersistentWriteStream.prototype.writeHandshake = function () {
	        assert(this.isOpen(), 'Writing handshake requires an opened stream');
	        assert(!this.handshakeComplete_, 'Handshake already completed');
	        // TODO(dimond): Support stream resumption. We intentionally do not set the
	        // stream token on the handshake, ignoring any stream token we might have.
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        this.sendRequest(request);
	    };
	    /** Sends a group of mutations to the Firestore backend to apply. */
	    PersistentWriteStream.prototype.writeMutations = function (mutations) {
	        var _this = this;
	        assert(this.isOpen(), 'Writing mutations requires an opened stream');
	        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
	        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
	        var request = {
	            // Protos are typed with string, but we support UInt8Array on Node
	            // tslint:disable-next-line:no-any
	            streamToken: this.lastStreamToken,
	            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
	        };
	        this.sendRequest(request);
	    };
	    return PersistentWriteStream;
	}(PersistentStream));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
	 * which provides an interface that is more convenient for the rest of the
	 * client SDK architecture to consume.
	 */
	var Datastore = /** @class */ (function () {
	    function Datastore(queue, connection, credentials, serializer) {
	        this.queue = queue;
	        this.connection = connection;
	        this.credentials = credentials;
	        this.serializer = serializer;
	    }
	    Datastore.prototype.newPersistentWriteStream = function () {
	        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer);
	    };
	    Datastore.prototype.newPersistentWatchStream = function () {
	        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer);
	    };
	    Datastore.prototype.commit = function (mutations) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
	        };
	        return this.invokeRPC('Commit', params).then(function (response) {
	            return _this.serializer.fromWriteResults(response.writeResults);
	        });
	    };
	    Datastore.prototype.lookup = function (keys) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            documents: keys.map(function (k) { return _this.serializer.toName(k); })
	        };
	        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
	            var docs = maybeDocumentMap();
	            response.forEach(function (proto) {
	                var doc = _this.serializer.fromMaybeDocument(proto);
	                docs = docs.insert(doc.key, doc);
	            });
	            var result = [];
	            keys.forEach(function (key) {
	                var doc = docs.get(key);
	                assert(!!doc, 'Missing entity in write response for ' + key);
	                result.push(doc);
	            });
	            return result;
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC. */
	    Datastore.prototype.invokeRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeRPC(rpcName, request, token);
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC with streamed results. */
	    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeStreamingRPC(rpcName, request, token);
	        });
	    };
	    return Datastore;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Internal transaction object responsible for accumulating the mutations to
	 * perform and the base versions for any documents read.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(datastore) {
	        this.datastore = datastore;
	        // The version of each document that was read during this transaction.
	        this.readVersions = documentVersionMap();
	        this.mutations = [];
	        this.committed = false;
	    }
	    Transaction.prototype.recordVersion = function (doc) {
	        var docVersion = doc.version;
	        if (doc instanceof NoDocument) {
	            // For deleted docs, we must use baseVersion 0 when we overwrite them.
	            docVersion = SnapshotVersion.forDeletedDoc();
	        }
	        var existingVersion = this.readVersions.get(doc.key);
	        if (existingVersion !== null) {
	            if (!docVersion.isEqual(existingVersion)) {
	                // This transaction will fail no matter what.
	                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
	            }
	        }
	        else {
	            this.readVersions = this.readVersions.insert(doc.key, docVersion);
	        }
	    };
	    Transaction.prototype.lookup = function (keys) {
	        var _this = this;
	        if (this.committed) {
	            return Promise.reject('Transaction has already completed.');
	        }
	        if (this.mutations.length > 0) {
	            return Promise.reject('Transactions lookups are invalid after writes.');
	        }
	        return this.datastore.lookup(keys).then(function (docs) {
	            docs.forEach(function (doc) { return _this.recordVersion(doc); });
	            return docs;
	        });
	    };
	    Transaction.prototype.write = function (mutations) {
	        if (this.committed) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Transaction has already completed.');
	        }
	        this.mutations = this.mutations.concat(mutations);
	    };
	    /**
	     * Returns the version of this document when it was read in this transaction,
	     * as a precondition, or no precondition if it was not read.
	     */
	    Transaction.prototype.precondition = function (key) {
	        var version = this.readVersions.get(key);
	        if (version) {
	            return Precondition.updateTime(version);
	        }
	        else {
	            return Precondition.NONE;
	        }
	    };
	    /**
	     * Returns the precondition for a document if the operation is an update.
	     */
	    Transaction.prototype.preconditionForUpdate = function (key) {
	        var version = this.readVersions.get(key);
	        if (version && version.isEqual(SnapshotVersion.forDeletedDoc())) {
	            // The document doesn't exist, so fail the transaction.
	            throw new FirestoreError(Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
	        }
	        else if (version) {
	            // Document exists, base precondition on document update time.
	            return Precondition.updateTime(version);
	        }
	        else {
	            // Document was not read, so we just use the preconditions for a blind
	            // update.
	            return Precondition.exists(true);
	        }
	    };
	    Transaction.prototype.set = function (key, data) {
	        this.write(data.toMutations(key, this.precondition(key)));
	    };
	    Transaction.prototype.update = function (key, data) {
	        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
	    };
	    Transaction.prototype.delete = function (key) {
	        this.write([new DeleteMutation(key, this.precondition(key))]);
	        // Since the delete will be applied before all following writes, we need to
	        // ensure that the precondition for the next write will be exists: false.
	        this.readVersions = this.readVersions.insert(key, SnapshotVersion.forDeletedDoc());
	    };
	    Transaction.prototype.commit = function () {
	        var _this = this;
	        var unwritten = this.readVersions;
	        // For each mutation, note that the doc was written.
	        this.mutations.forEach(function (mutation) {
	            unwritten = unwritten.remove(mutation.key);
	        });
	        if (!unwritten.isEmpty()) {
	            return Promise.reject(Error('Every document read in a transaction must also be written.'));
	        }
	        return this.datastore.commit(this.mutations).then(function () {
	            _this.committed = true;
	        });
	    };
	    return Transaction;
	}());
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$8 = 'OnlineStateTracker';
	// To deal with transient failures, we allow multiple stream attempts before
	// giving up and transitioning from OnlineState.Unknown to Offline.
	var MAX_WATCH_STREAM_FAILURES = 2;
	// To deal with stream attempts that don't succeed or fail in a timely manner,
	// we have a timeout for OnlineState to reach Online or Offline.
	// If the timeout is reached, we transition to Offline rather than waiting
	// indefinitely.
	var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
	/**
	 * A component used by the RemoteStore to track the OnlineState (that is,
	 * whether or not the client as a whole should be considered to be online or
	 * offline), implementing the appropriate heuristics.
	 *
	 * In particular, when the client is trying to connect to the backend, we
	 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
	 * a connection to succeed. If we have too many failures or the timeout elapses,
	 * then we set the OnlineState to Offline, and the client will behave as if
	 * it is offline (get()s will return cached data, etc.).
	 */
	var OnlineStateTracker = /** @class */ (function () {
	    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
	        this.asyncQueue = asyncQueue;
	        this.onlineStateHandler = onlineStateHandler;
	        /** The current OnlineState. */
	        this.state = OnlineState.Unknown;
	        /**
	         * A count of consecutive failures to open the stream. If it reaches the
	         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
	         * Offline.
	         */
	        this.watchStreamFailures = 0;
	        /**
	         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
	         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
	         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
	         */
	        this.onlineStateTimer = null;
	        /**
	         * Whether the client should log a warning message if it fails to connect to
	         * the backend (initially true, cleared after a successful stream, or if we've
	         * logged the message already).
	         */
	        this.shouldWarnClientIsOffline = true;
	    }
	    /**
	     * Called by RemoteStore when a watch stream is started (including on each
	     * backoff attempt).
	     *
	     * If this is the first attempt, it sets the OnlineState to Unknown and starts
	     * the onlineStateTimer.
	     */
	    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
	        var _this = this;
	        if (this.watchStreamFailures === 0) {
	            this.setAndBroadcast(OnlineState.Unknown);
	            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
	            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
	                _this.onlineStateTimer = null;
	                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
	                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
	                    "seconds.");
	                _this.setAndBroadcast(OnlineState.Offline);
	                // NOTE: handleWatchStreamFailure() will continue to increment
	                // watchStreamFailures even though we are already marked Offline,
	                // but this is non-harmful.
	                return Promise.resolve();
	            });
	        }
	    };
	    /**
	     * Updates our OnlineState as appropriate after the watch stream reports a
	     * failure. The first failure moves us to the 'Unknown' state. We then may
	     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
	     * actually transition to the 'Offline' state.
	     */
	    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error$$1) {
	        if (this.state === OnlineState.Online) {
	            this.setAndBroadcast(OnlineState.Unknown);
	            // To get to OnlineState.Online, set() must have been called which would
	            // have reset our heuristics.
	            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
	            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
	        }
	        else {
	            this.watchStreamFailures++;
	            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
	                this.clearOnlineStateTimer();
	                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
	                    ("times. Most recent error: " + error$$1.toString()));
	                this.setAndBroadcast(OnlineState.Offline);
	            }
	        }
	    };
	    /**
	     * Explicitly sets the OnlineState to the specified state.
	     *
	     * Note that this resets our timers / failure counters, etc. used by our
	     * Offline heuristics, so must not be used in place of
	     * handleWatchStreamStart() and handleWatchStreamFailure().
	     */
	    OnlineStateTracker.prototype.set = function (newState) {
	        this.clearOnlineStateTimer();
	        this.watchStreamFailures = 0;
	        if (newState === OnlineState.Online) {
	            // We've connected to watch at least once. Don't warn the developer
	            // about being offline going forward.
	            this.shouldWarnClientIsOffline = false;
	        }
	        this.setAndBroadcast(newState);
	    };
	    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
	        if (newState !== this.state) {
	            this.state = newState;
	            this.onlineStateHandler(newState);
	        }
	    };
	    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
	        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
	            "This typically indicates that your device does not have a healthy " +
	            "Internet connection at the moment. The client will operate in offline " +
	            "mode until it is able to successfully connect to the backend.";
	        if (this.shouldWarnClientIsOffline) {
	            error(message);
	            this.shouldWarnClientIsOffline = false;
	        }
	        else {
	            debug(LOG_TAG$8, message);
	        }
	    };
	    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
	        if (this.onlineStateTimer !== null) {
	            this.onlineStateTimer.cancel();
	            this.onlineStateTimer = null;
	        }
	    };
	    return OnlineStateTracker;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$9 = 'RemoteStore';
	// TODO(b/35853402): Negotiate this with the stream.
	var MAX_PENDING_WRITES = 10;
	/**
	 * RemoteStore - An interface to remotely stored data, basically providing a
	 * wrapper around the Datastore that is more reliable for the rest of the
	 * system.
	 *
	 * RemoteStore is responsible for maintaining the connection to the server.
	 * - maintaining a list of active listens.
	 * - reconnecting when the connection is dropped.
	 * - resuming all the active listens on reconnect.
	 *
	 * RemoteStore handles all incoming events from the Datastore.
	 * - listening to the watch stream and repackaging the events as RemoteEvents
	 * - notifying SyncEngine of any changes to the active listens.
	 *
	 * RemoteStore takes writes from other components and handles them reliably.
	 * - pulling pending mutations from LocalStore and sending them to Datastore.
	 * - retrying mutations that failed because of network problems.
	 * - acking mutations to the SyncEngine once they are accepted or rejected.
	 */
	var RemoteStore = /** @class */ (function () {
	    function RemoteStore(
	    /**
	     * The local store, used to fill the write pipeline with outbound
	     * mutations and resolve existence filter mismatches.
	     */
	    localStore, 
	    /** The client-side proxy for interacting with the backend. */
	    datastore, asyncQueue, onlineStateHandler) {
	        this.localStore = localStore;
	        this.datastore = datastore;
	        this.pendingWrites = [];
	        this.lastBatchSeen = BATCHID_UNKNOWN;
	        /**
	         * A mapping of watched targets that the client cares about tracking and the
	         * user has explicitly called a 'listen' for this target.
	         *
	         * These targets may or may not have been sent to or acknowledged by the
	         * server. On re-establishing the listen stream, these targets should be sent
	         * to the server. The targets removed with unlistens are removed eagerly
	         * without waiting for confirmation from the listen stream.
	         */
	        this.listenTargets = {};
	        /**
	         * A mapping of targetId to pending acks needed.
	         *
	         * If a targetId is present in this map, then we're waiting for watch to
	         * acknowledge a removal or addition of the target. If a target is not in this
	         * mapping, and it's in the listenTargets map, then we consider the target to
	         * be active.
	         *
	         * We increment the count here every time we issue a request over the stream
	         * to watch or unwatch. We then decrement the count every time we get a target
	         * added or target removed message from the server. Once the count is equal to
	         * 0 we know that the client and server are in the same state (once this state
	         * is reached the targetId is removed from the map to free the memory).
	         */
	        this.pendingTargetResponses = {};
	        this.accumulatedWatchChanges = [];
	        this.watchStream = null;
	        this.writeStream = null;
	        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
	    }
	    /**
	     * Starts up the remote store, creating streams, restoring state from
	     * LocalStore, etc.
	     */
	    RemoteStore.prototype.start = function () {
	        return this.enableNetwork();
	    };
	    RemoteStore.prototype.isNetworkEnabled = function () {
	        assert((this.watchStream == null) === (this.writeStream == null), 'WatchStream and WriteStream should both be null or non-null');
	        return this.watchStream != null;
	    };
	    /** Re-enables the network. Idempotent. */
	    RemoteStore.prototype.enableNetwork = function () {
	        var _this = this;
	        if (this.isNetworkEnabled()) {
	            return Promise.resolve();
	        }
	        // Create new streams (but note they're not started yet).
	        this.watchStream = this.datastore.newPersistentWatchStream();
	        this.writeStream = this.datastore.newPersistentWriteStream();
	        // Load any saved stream token from persistent storage
	        return this.localStore.getLastStreamToken().then(function (token) {
	            _this.writeStream.lastStreamToken = token;
	            if (_this.shouldStartWatchStream()) {
	                _this.startWatchStream();
	            }
	            else {
	                _this.onlineStateTracker.set(OnlineState.Unknown);
	            }
	            return _this.fillWritePipeline(); // This may start the writeStream.
	        });
	    };
	    /**
	     * Temporarily disables the network. The network can be re-enabled using
	     * enableNetwork().
	     */
	    RemoteStore.prototype.disableNetwork = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                this.disableNetworkInternal();
	                // Set the OnlineState to Offline so get()s return from cache, etc.
	                this.onlineStateTracker.set(OnlineState.Offline);
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * Disables the network, if it is currently enabled.
	     */
	    RemoteStore.prototype.disableNetworkInternal = function () {
	        if (this.isNetworkEnabled()) {
	            // NOTE: We're guaranteed not to get any further events from these streams (not even a close
	            // event).
	            this.watchStream.stop();
	            this.writeStream.stop();
	            this.cleanUpWatchStreamState();
	            this.cleanUpWriteStreamState();
	            this.writeStream = null;
	            this.watchStream = null;
	        }
	    };
	    RemoteStore.prototype.shutdown = function () {
	        debug(LOG_TAG$9, 'RemoteStore shutting down.');
	        this.disableNetworkInternal();
	        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
	        // triggering spurious listener events with cached data, etc.
	        this.onlineStateTracker.set(OnlineState.Unknown);
	        return Promise.resolve();
	    };
	    /** Starts new listen for the given query. Uses resume token if provided */
	    RemoteStore.prototype.listen = function (queryData) {
	        assert(!contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
	        // Mark this as something the client is currently listening for.
	        this.listenTargets[queryData.targetId] = queryData;
	        if (this.shouldStartWatchStream()) {
	            // The listen will be sent in onWatchStreamOpen
	            this.startWatchStream();
	        }
	        else if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendWatchRequest(queryData);
	        }
	    };
	    /** Removes the listen from server */
	    RemoteStore.prototype.unlisten = function (targetId) {
	        assert(contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
	        delete this.listenTargets[targetId];
	        if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendUnwatchRequest(targetId);
	            if (isEmpty(this.listenTargets)) {
	                this.watchStream.markIdle();
	            }
	        }
	    };
	    /**
	     * We need to increment the the expected number of pending responses we're due
	     * from watch so we wait for the ack to process any messages from this target.
	     */
	    RemoteStore.prototype.sendWatchRequest = function (queryData) {
	        this.recordPendingTargetRequest(queryData.targetId);
	        this.watchStream.watch(queryData);
	    };
	    /**
	     * We need to increment the expected number of pending responses we're due
	     * from watch so we wait for the removal on the server before we process any
	     * messages from this target.
	     */
	    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
	        this.recordPendingTargetRequest(targetId);
	        this.watchStream.unwatch(targetId);
	    };
	    /**
	     * Increment the mapping of how many acks are needed from watch before we can
	     * consider the server to be 'in-sync' with the client's active targets.
	     */
	    RemoteStore.prototype.recordPendingTargetRequest = function (targetId) {
	        // For each request we get we need to record we need a response for it.
	        this.pendingTargetResponses[targetId] =
	            (this.pendingTargetResponses[targetId] || 0) + 1;
	    };
	    RemoteStore.prototype.startWatchStream = function () {
	        assert(this.shouldStartWatchStream(), 'startWriteStream() called when shouldStartWatchStream() is false.');
	        this.watchStream.start({
	            onOpen: this.onWatchStreamOpen.bind(this),
	            onClose: this.onWatchStreamClose.bind(this),
	            onWatchChange: this.onWatchStreamChange.bind(this)
	        });
	        this.onlineStateTracker.handleWatchStreamStart();
	    };
	    /**
	     * Returns whether the watch stream should be started because it's necessary
	     * and has not yet been started.
	     */
	    RemoteStore.prototype.shouldStartWatchStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.watchStream.isStarted() &&
	            !isEmpty(this.listenTargets));
	    };
	    RemoteStore.prototype.cleanUpWatchStreamState = function () {
	        // If the connection is closed then we'll never get a snapshot version for
	        // the accumulated changes and so we'll never be able to complete the batch.
	        // When we start up again the server is going to resend these changes
	        // anyway, so just toss the accumulated state.
	        this.accumulatedWatchChanges = [];
	        this.pendingTargetResponses = {};
	    };
	    RemoteStore.prototype.onWatchStreamOpen = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                // TODO(b/35852690): close the stream again (with some timeout?) if no watch
	                // targets are active
	                forEachNumber(this.listenTargets, function (targetId, queryData) {
	                    _this.sendWatchRequest(queryData);
	                });
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWatchStreamClose = function (error$$1) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                assert(this.isNetworkEnabled(), 'onWatchStreamClose() should only be called when the network is enabled');
	                this.cleanUpWatchStreamState();
	                // If we still need the watch stream, retry the connection.
	                if (this.shouldStartWatchStream()) {
	                    // There should generally be an error if the watch stream was closed when
	                    // it's still needed, but it's not quite worth asserting.
	                    if (error$$1) {
	                        this.onlineStateTracker.handleWatchStreamFailure(error$$1);
	                    }
	                    this.startWatchStream();
	                }
	                else {
	                    // No need to restart watch stream because there are no active targets.
	                    // The online state is set to unknown because there is no active attempt
	                    // at establishing a connection
	                    this.onlineStateTracker.set(OnlineState.Unknown);
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var changes;
	            return tslib_1.__generator(this, function (_a) {
	                // Mark the client as online since we got a message from the server
	                this.onlineStateTracker.set(OnlineState.Online);
	                if (watchChange instanceof WatchTargetChange &&
	                    watchChange.state === WatchTargetChangeState.Removed &&
	                    watchChange.cause) {
	                    // There was an error on a target, don't wait for a consistent snapshot
	                    // to raise events
	                    return [2 /*return*/, this.handleTargetError(watchChange)];
	                }
	                // Accumulate watch changes but don't process them if there's no
	                // snapshotVersion or it's older than a previous snapshot we've processed
	                // (can happen after we resume a target using a resume token).
	                this.accumulatedWatchChanges.push(watchChange);
	                if (!snapshotVersion.isEqual(SnapshotVersion.MIN) &&
	                    snapshotVersion.compareTo(this.localStore.getLastRemoteSnapshotVersion()) >= 0) {
	                    changes = this.accumulatedWatchChanges;
	                    this.accumulatedWatchChanges = [];
	                    return [2 /*return*/, this.handleWatchChangeBatch(snapshotVersion, changes)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * Takes a batch of changes from the Datastore, repackages them as a
	     * RemoteEvent, and passes that on to the listener, which is typically the
	     * SyncEngine.
	     */
	    RemoteStore.prototype.handleWatchChangeBatch = function (snapshotVersion, changes) {
	        var _this = this;
	        var aggregator = new WatchChangeAggregator(snapshotVersion, this.listenTargets, this.pendingTargetResponses);
	        aggregator.addChanges(changes);
	        var remoteEvent = aggregator.createRemoteEvent();
	        // Get the new response counts from the aggregator
	        this.pendingTargetResponses = aggregator.pendingTargetResponses;
	        var promises = [];
	        // Handle existence filters and existence filter mismatches.
	        forEachNumber(aggregator.existenceFilters, function (targetId, filter) {
	            var queryData = _this.listenTargets[targetId];
	            if (!queryData) {
	                // A watched target might have been removed already.
	                return;
	            }
	            var query = queryData.query;
	            if (query.isDocumentQuery()) {
	                if (filter.count === 0) {
	                    // The existence filter told us the document does not exist.
	                    // We need to deduce that this document does not exist and apply
	                    // a deleted document to our updates. Without applying a deleted
	                    // document there might be another query that will raise this
	                    // document as part of a snapshot until it is resolved,
	                    // essentially exposing inconsistency between queries.
	                    var key = new DocumentKey(query.path);
	                    var deletedDoc = new NoDocument(key, snapshotVersion);
	                    remoteEvent.addDocumentUpdate(deletedDoc);
	                }
	                else {
	                    assert(filter.count === 1, 'Single document existence filter with count: ' + filter.count);
	                }
	            }
	            else {
	                // Not a document query.
	                var promise = _this.localStore
	                    .remoteDocumentKeys(targetId)
	                    .then(function (trackedRemote) {
	                    if (remoteEvent.targetChanges[targetId]) {
	                        var mapping = remoteEvent.targetChanges[targetId].mapping;
	                        if (mapping !== null) {
	                            if (mapping instanceof UpdateMapping) {
	                                trackedRemote = mapping.applyToKeySet(trackedRemote);
	                            }
	                            else {
	                                assert(mapping instanceof ResetMapping, 'Expected either reset or update mapping but got something else: ' +
	                                    mapping);
	                                trackedRemote = mapping.documents;
	                            }
	                        }
	                    }
	                    if (trackedRemote.size !== filter.count) {
	                        // Existence filter mismatch, resetting mapping.
	                        // Make sure the mismatch is exposed in the remote event.
	                        remoteEvent.handleExistenceFilterMismatch(targetId);
	                        // Clear the resume token for the query, since we're in a
	                        // known mismatch state.
	                        var newQueryData = new QueryData(query, targetId, queryData.purpose);
	                        _this.listenTargets[targetId] = newQueryData;
	                        // Cause a hard reset by unwatching and rewatching
	                        // immediately, but deliberately don't send a resume token
	                        // so that we get a full update.
	                        // Make sure we expect that this acks are going to happen.
	                        _this.sendUnwatchRequest(targetId);
	                        // Mark the query we send as being on behalf of an existence
	                        // filter mismatch, but don't actually retain that in
	                        // listenTargets. This ensures that we flag the first
	                        // re-listen this way without impacting future listens of
	                        // this target (that might happen e.g. on reconnect).
	                        var requestQueryData = new QueryData(query, targetId, QueryPurpose.ExistenceFilterMismatch);
	                        _this.sendWatchRequest(requestQueryData);
	                    }
	                });
	                promises.push(promise);
	            }
	        });
	        return Promise.all(promises).then(function () {
	            // Update in-memory resume tokens. LocalStore will update the
	            // persistent view of these when applying the completed RemoteEvent.
	            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                if (change.resumeToken.length > 0) {
	                    var queryData = _this.listenTargets[targetId];
	                    // A watched target might have been removed already.
	                    if (queryData) {
	                        _this.listenTargets[targetId] = queryData.update({
	                            resumeToken: change.resumeToken,
	                            snapshotVersion: change.snapshotVersion
	                        });
	                    }
	                }
	            });
	            // Finally handle remote event
	            return _this.syncEngine.applyRemoteEvent(remoteEvent);
	        });
	    };
	    /** Handles an error on a target */
	    RemoteStore.prototype.handleTargetError = function (watchChange) {
	        var _this = this;
	        assert(!!watchChange.cause, 'Handling target error without a cause');
	        var error$$1 = watchChange.cause;
	        var promiseChain = Promise.resolve();
	        watchChange.targetIds.forEach(function (targetId) {
	            promiseChain = promiseChain.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                return tslib_1.__generator(this, function (_a) {
	                    // A watched target might have been removed already.
	                    if (contains(this.listenTargets, targetId)) {
	                        delete this.listenTargets[targetId];
	                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error$$1)];
	                    }
	                    return [2 /*return*/];
	                });
	            }); });
	        });
	        return promiseChain;
	    };
	    RemoteStore.prototype.cleanUpWriteStreamState = function () {
	        this.lastBatchSeen = BATCHID_UNKNOWN;
	        debug(LOG_TAG$9, 'Stopping write stream with ' +
	            this.pendingWrites.length +
	            ' pending writes');
	        this.pendingWrites = [];
	    };
	    /**
	     * Notifies that there are new mutations to process in the queue. This is
	     * typically called by SyncEngine after it has sent mutations to LocalStore.
	     */
	    RemoteStore.prototype.fillWritePipeline = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                if (this.canWriteMutations()) {
	                    return [2 /*return*/, this.localStore
	                            .nextMutationBatch(this.lastBatchSeen)
	                            .then(function (batch) {
	                            if (batch === null) {
	                                if (_this.pendingWrites.length === 0) {
	                                    _this.writeStream.markIdle();
	                                }
	                            }
	                            else {
	                                _this.commit(batch);
	                                return _this.fillWritePipeline();
	                            }
	                        })];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * Returns true if the backend can accept additional write requests.
	     *
	     * When sending mutations to the write stream (e.g. in fillWritePipeline),
	     * call this method first to check if more mutations can be sent.
	     *
	     * Currently the only thing that can prevent the backend from accepting
	     * write requests is if there are too many requests already outstanding. As
	     * writes complete the backend will be able to accept more.
	     */
	    RemoteStore.prototype.canWriteMutations = function () {
	        return (this.isNetworkEnabled() && this.pendingWrites.length < MAX_PENDING_WRITES);
	    };
	    // For testing
	    RemoteStore.prototype.outstandingWrites = function () {
	        return this.pendingWrites.length;
	    };
	    /**
	     * Given mutations to commit, actually commits them to the Datastore. Note
	     * that this does *not* return a Promise specifically because the AsyncQueue
	     * should not block operations for this.
	     */
	    RemoteStore.prototype.commit = function (batch) {
	        assert(this.canWriteMutations(), "commit called when batches can't be written");
	        this.lastBatchSeen = batch.batchId;
	        this.pendingWrites.push(batch);
	        if (this.shouldStartWriteStream()) {
	            this.startWriteStream();
	        }
	        else if (this.isNetworkEnabled() && this.writeStream.handshakeComplete) {
	            this.writeStream.writeMutations(batch.mutations);
	        }
	    };
	    RemoteStore.prototype.shouldStartWriteStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.writeStream.isStarted() &&
	            this.pendingWrites.length > 0);
	    };
	    RemoteStore.prototype.startWriteStream = function () {
	        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
	        this.writeStream.start({
	            onOpen: this.onWriteStreamOpen.bind(this),
	            onClose: this.onWriteStreamClose.bind(this),
	            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
	            onMutationResult: this.onMutationResult.bind(this)
	        });
	    };
	    RemoteStore.prototype.onWriteStreamOpen = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                this.writeStream.writeHandshake();
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWriteHandshakeComplete = function () {
	        var _this = this;
	        // Record the stream token.
	        return this.localStore
	            .setLastStreamToken(this.writeStream.lastStreamToken)
	            .then(function () {
	            // Drain any pending writes.
	            //
	            // Note that at this point pendingWrites contains mutations that
	            // have already been accepted by fillWritePipeline/commitBatch. If
	            // the pipeline is full, canWriteMutations will be false, despite
	            // the fact that we actually need to send mutations over.
	            //
	            // This also means that this method indirectly respects the limits
	            // imposed by canWriteMutations since writes can't be added to the
	            // pendingWrites array when canWriteMutations is false. If the
	            // limits imposed by canWriteMutations actually protect us from
	            // DOSing ourselves then those limits won't be exceeded here and
	            // we'll continue to make progress.
	            for (var _i = 0, _a = _this.pendingWrites; _i < _a.length; _i++) {
	                var batch = _a[_i];
	                _this.writeStream.writeMutations(batch.mutations);
	            }
	        });
	    };
	    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
	        var _this = this;
	        // This is a response to a write containing mutations and should be
	        // correlated to the first pending write.
	        assert(this.pendingWrites.length > 0, 'Got result for empty pending writes');
	        var batch = this.pendingWrites.shift();
	        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
	        return this.syncEngine.applySuccessfulWrite(success).then(function () {
	            // It's possible that with the completion of this mutation another
	            // slot has freed up.
	            return _this.fillWritePipeline();
	        });
	    };
	    RemoteStore.prototype.onWriteStreamClose = function (error$$1) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            var errorHandling;
	            return tslib_1.__generator(this, function (_a) {
	                assert(this.isNetworkEnabled(), 'onWriteStreamClose() should only be called when the network is enabled');
	                // If the write stream closed due to an error, invoke the error callbacks if
	                // there are pending writes.
	                if (error$$1 && this.pendingWrites.length > 0) {
	                    assert(!!error$$1, 'We have pending writes, but the write stream closed without an error');
	                    errorHandling = void 0;
	                    if (this.writeStream.handshakeComplete) {
	                        // This error affects the actual write.
	                        errorHandling = this.handleWriteError(error$$1);
	                    }
	                    else {
	                        // If there was an error before the handshake has finished, it's
	                        // possible that the server is unable to process the stream token
	                        // we're sending. (Perhaps it's too old?)
	                        errorHandling = this.handleHandshakeError(error$$1);
	                    }
	                    return [2 /*return*/, errorHandling.then(function () {
	                            // The write stream might have been started by refilling the write
	                            // pipeline for failed writes
	                            if (_this.shouldStartWriteStream()) {
	                                _this.startWriteStream();
	                            }
	                        })];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.handleHandshakeError = function (error$$1) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                // Reset the token if it's a permanent error or the error code is
	                // ABORTED, signaling the write stream is no longer valid.
	                if (isPermanentError(error$$1.code) || error$$1.code === Code.ABORTED) {
	                    debug(LOG_TAG$9, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
	                    this.writeStream.lastStreamToken = emptyByteString();
	                    return [2 /*return*/, this.localStore.setLastStreamToken(emptyByteString())];
	                }
	                else {
	                    // Some other error, don't reset stream token. Our stream logic will
	                    // just retry with exponential backoff.
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.handleWriteError = function (error$$1) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            var batch;
	            return tslib_1.__generator(this, function (_a) {
	                if (isPermanentError(error$$1.code)) {
	                    batch = this.pendingWrites.shift();
	                    // In this case it's also unlikely that the server itself is melting
	                    // down -- this was just a bad request so inhibit backoff on the next
	                    // restart.
	                    this.writeStream.inhibitBackoff();
	                    return [2 /*return*/, this.syncEngine
	                            .rejectFailedWrite(batch.batchId, error$$1)
	                            .then(function () {
	                            // It's possible that with the completion of this mutation
	                            // another slot has freed up.
	                            return _this.fillWritePipeline();
	                        })];
	                }
	                else {
	                    // Transient error, just let the retry logic kick in.
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.createTransaction = function () {
	        return new Transaction(this.datastore);
	    };
	    RemoteStore.prototype.handleUserChange = function (user) {
	        debug(LOG_TAG$9, 'RemoteStore changing users: uid=', user.uid);
	        // If the network has been explicitly disabled, make sure we don't
	        // accidentally re-enable it.
	        if (this.isNetworkEnabled()) {
	            // Tear down and re-create our network streams. This will ensure we get a fresh auth token
	            // for the new user and re-fill the write pipeline with new mutations from the LocalStore
	            // (since mutations are per-user).
	            this.disableNetworkInternal();
	            this.onlineStateTracker.set(OnlineState.Unknown);
	            return this.enableNetwork();
	        }
	    };
	    return RemoteStore;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$10 = 'FirestoreClient';
	/** The DOMException code for an aborted operation. */
	var DOM_EXCEPTION_ABORTED = 20;
	/** The DOMException code for quota exceeded. */
	var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
	/**
	 * FirestoreClient is a top-level class that constructs and owns all of the
	 * pieces of the client SDK architecture. It is responsible for creating the
	 * async queue that is shared by all of the other components in the system.
	 */
	var FirestoreClient = /** @class */ (function () {
	    function FirestoreClient(platform, databaseInfo, credentials, 
	    /**
	     * Asynchronous queue responsible for all of our internal processing. When
	     * we get incoming work from the user (via public API) or the network
	     * (incoming GRPC messages), we should always schedule onto this queue.
	     * This ensures all of our work is properly serialized (e.g. we don't
	     * start processing a new operation while the previous one is waiting for
	     * an async I/O to complete).
	     */
	    asyncQueue) {
	        this.platform = platform;
	        this.databaseInfo = databaseInfo;
	        this.credentials = credentials;
	        this.asyncQueue = asyncQueue;
	    }
	    /**
	     * Starts up the FirestoreClient, returning only whether or not enabling
	     * persistence succeeded.
	     *
	     * The intent here is to "do the right thing" as far as users are concerned.
	     * Namely, in cases where offline persistence is requested and possible,
	     * enable it, but otherwise fall back to persistence disabled. For the most
	     * part we expect this to succeed one way or the other so we don't expect our
	     * users to actually wait on the firestore.enablePersistence Promise since
	     * they generally won't care.
	     *
	     * Of course some users actually do care about whether or not persistence
	     * was successfully enabled, so the Promise returned from this method
	     * indicates this outcome.
	     *
	     * This presents a problem though: even before enablePersistence resolves or
	     * rejects, users may have made calls to e.g. firestore.collection() which
	     * means that the FirestoreClient in there will be available and will be
	     * enqueuing actions on the async queue.
	     *
	     * Meanwhile any failure of an operation on the async queue causes it to
	     * panic and reject any further work, on the premise that unhandled errors
	     * are fatal.
	     *
	     * Consequently the fallback is handled internally here in start, and if the
	     * fallback succeeds we signal success to the async queue even though the
	     * start() itself signals failure.
	     *
	     * @param usePersistence Whether or not to attempt to enable persistence.
	     * @returns A deferred result indicating the user-visible result of enabling
	     *     offline persistence. This method will reject this if IndexedDB fails to
	     *     start for any reason. If usePersistence is false this is
	     *     unconditionally resolved.
	     */
	    FirestoreClient.prototype.start = function (usePersistence) {
	        var _this = this;
	        // We defer our initialization until we get the current user from
	        // setUserChangeListener(). We block the async queue until we got the
	        // initial user and the initialization is completed. This will prevent
	        // any scheduled work from happening before initialization is completed.
	        //
	        // If initializationDone resolved then the FirestoreClient is in a usable
	        // state.
	        var initializationDone = new Deferred$1();
	        // If usePersistence is true, certain classes of errors while starting are
	        // recoverable but only by falling back to persistence disabled.
	        //
	        // If there's an error in the first case but not in recovery we cannot
	        // reject the promise blocking the async queue because this will cause the
	        // async queue to panic.
	        var persistenceResult = new Deferred$1();
	        var initialized = false;
	        this.credentials.setUserChangeListener(function (user) {
	            if (!initialized) {
	                initialized = true;
	                _this.initializePersistence(usePersistence, persistenceResult)
	                    .then(function () { return _this.initializeRest(user); })
	                    .then(initializationDone.resolve, initializationDone.reject);
	            }
	            else {
	                _this.asyncQueue.enqueue(function () {
	                    return _this.handleUserChange(user);
	                });
	            }
	        });
	        // Block the async queue until initialization is done
	        this.asyncQueue.enqueue(function () {
	            return initializationDone.promise;
	        });
	        // Return only the result of enabling persistence. Note that this does not
	        // need to await the completion of initializationDone because the result of
	        // this method should not reflect any other kind of failure to start.
	        return persistenceResult.promise;
	    };
	    /** Enables the network connection and requeues all pending operations. */
	    FirestoreClient.prototype.enableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.enqueue(function () {
	            return _this.remoteStore.enableNetwork();
	        });
	    };
	    /**
	     * Initializes persistent storage, attempting to use IndexedDB if
	     * usePersistence is true or memory-only if false.
	     *
	     * If IndexedDB fails because it's already open in another tab or because the
	     * platform can't possibly support our implementation then this method rejects
	     * the persistenceResult and falls back on memory-only persistence.
	     *
	     * @param usePersistence indicates whether or not to use offline persistence
	     * @param persistenceResult A deferred result indicating the user-visible
	     *     result of enabling offline persistence. This method will reject this if
	     *     IndexedDB fails to start for any reason. If usePersistence is false
	     *     this is unconditionally resolved.
	     * @returns a Promise indicating whether or not initialization should
	     *     continue, i.e. that one of the persistence implementations actually
	     *     succeeded.
	     */
	    FirestoreClient.prototype.initializePersistence = function (usePersistence, persistenceResult) {
	        var _this = this;
	        if (usePersistence) {
	            return this.startIndexedDbPersistence()
	                .then(persistenceResult.resolve)
	                .catch(function (error$$1) {
	                // Regardless of whether or not the retry succeeds, from an user
	                // perspective, offline persistence has failed.
	                persistenceResult.reject(error$$1);
	                // An unknown failure on the first stage shuts everything down.
	                if (!_this.canFallback(error$$1)) {
	                    return Promise.reject(error$$1);
	                }
	                console.warn('Error enabling offline storage. Falling back to' +
	                    ' storage disabled: ' +
	                    error$$1);
	                return _this.startMemoryPersistence();
	            });
	        }
	        else {
	            // When usePersistence == false, enabling offline persistence is defined
	            // to unconditionally succeed. This allows start() to have the same
	            // signature for both cases, despite the fact that the returned promise
	            // is only used in the enablePersistence call.
	            persistenceResult.resolve();
	            return this.startMemoryPersistence();
	        }
	    };
	    /**
	     * Decides whether the provided error allows us to gracefully disable
	     * persistence (as opposed to crashing the client).
	     */
	    FirestoreClient.prototype.canFallback = function (error$$1) {
	        if (error$$1 instanceof FirestoreError) {
	            return (error$$1.code === Code.FAILED_PRECONDITION ||
	                error$$1.code === Code.UNIMPLEMENTED);
	        }
	        else if (typeof DOMException !== 'undefined' &&
	            error$$1 instanceof DOMException) {
	            // We fall back to memory persistence if we cannot acquire an owner lease.
	            // This can happen can during a schema migration, or during the initial
	            // write of the `owner` lease.
	            // For both the `QuotaExceededError` and the  `AbortError`, it is safe to
	            // fall back to memory persistence since all modifications to IndexedDb
	            // failed to commit.
	            return (error$$1.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
	                error$$1.code === DOM_EXCEPTION_ABORTED);
	        }
	        return true;
	    };
	    /**
	     * Starts IndexedDB-based persistence.
	     *
	     * @returns A promise indicating success or failure.
	     */
	    FirestoreClient.prototype.startIndexedDbPersistence = function () {
	        // TODO(http://b/33384523): For now we just disable garbage collection
	        // when persistence is enabled.
	        this.garbageCollector = new NoOpGarbageCollector();
	        var storagePrefix = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
	        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
	        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
	            useProto3Json: true
	        });
	        this.persistence = new IndexedDbPersistence(storagePrefix, serializer);
	        return this.persistence.start();
	    };
	    /**
	     * Starts Memory-backed persistence. In practice this cannot fail.
	     *
	     * @returns A promise that will successfully resolve.
	     */
	    FirestoreClient.prototype.startMemoryPersistence = function () {
	        this.garbageCollector = new EagerGarbageCollector();
	        this.persistence = new MemoryPersistence();
	        return this.persistence.start();
	    };
	    /**
	     * Initializes the rest of the FirestoreClient, assuming the initial user
	     * has been obtained from the credential provider and some persistence
	     * implementation is available in this.persistence.
	     */
	    FirestoreClient.prototype.initializeRest = function (user) {
	        var _this = this;
	        return this.platform
	            .loadConnection(this.databaseInfo)
	            .then(function (connection) {
	            _this.localStore = new LocalStore(_this.persistence, user, _this.garbageCollector);
	            var serializer = _this.platform.newSerializer(_this.databaseInfo.databaseId);
	            var datastore = new Datastore(_this.asyncQueue, connection, _this.credentials, serializer);
	            var onlineStateChangedHandler = function (onlineState) {
	                _this.syncEngine.applyOnlineStateChange(onlineState);
	                _this.eventMgr.applyOnlineStateChange(onlineState);
	            };
	            _this.remoteStore = new RemoteStore(_this.localStore, datastore, _this.asyncQueue, onlineStateChangedHandler);
	            _this.syncEngine = new SyncEngine(_this.localStore, _this.remoteStore, user);
	            // Setup wiring between sync engine and remote store
	            _this.remoteStore.syncEngine = _this.syncEngine;
	            _this.eventMgr = new EventManager(_this.syncEngine);
	            // NOTE: RemoteStore depends on LocalStore (for persisting stream
	            // tokens, refilling mutation queue, etc.) so must be started after
	            // LocalStore.
	            return _this.localStore.start();
	        })
	            .then(function () {
	            return _this.remoteStore.start();
	        });
	    };
	    FirestoreClient.prototype.handleUserChange = function (user) {
	        this.asyncQueue.verifyOperationInProgress();
	        debug(LOG_TAG$10, 'User Changed: ' + user.uid);
	        return this.syncEngine.handleUserChange(user);
	    };
	    /** Disables the network connection. Pending operations will not complete. */
	    FirestoreClient.prototype.disableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.enqueue(function () {
	            return _this.remoteStore.disableNetwork();
	        });
	    };
	    FirestoreClient.prototype.shutdown = function (options) {
	        var _this = this;
	        return this.asyncQueue
	            .enqueue(function () {
	            _this.credentials.removeUserChangeListener();
	            return _this.remoteStore.shutdown();
	        })
	            .then(function () {
	            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	            return _this.persistence.shutdown(options && options.purgePersistenceWithDataLoss);
	        });
	    };
	    FirestoreClient.prototype.listen = function (query, observer, options) {
	        var _this = this;
	        var listener = new QueryListener(query, observer, options);
	        this.asyncQueue.enqueue(function () {
	            return _this.eventMgr.listen(listener);
	        });
	        return listener;
	    };
	    FirestoreClient.prototype.unlisten = function (listener) {
	        var _this = this;
	        this.asyncQueue.enqueue(function () {
	            return _this.eventMgr.unlisten(listener);
	        });
	    };
	    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
	        var _this = this;
	        return this.asyncQueue
	            .enqueue(function () {
	            return _this.localStore.readDocument(docKey);
	        })
	            .then(function (maybeDoc) {
	            if (maybeDoc instanceof Document) {
	                return maybeDoc;
	            }
	            else {
	                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
	                    "exist on the server. Run again without setting 'source' in " +
	                    'the GetOptions to attempt to retrieve the document from the ' +
	                    'server.)');
	            }
	        });
	    };
	    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
	        var _this = this;
	        return this.asyncQueue
	            .enqueue(function () {
	            return _this.localStore.executeQuery(query);
	        })
	            .then(function (docs) {
	            var remoteKeys = documentKeySet();
	            var view = new View(query, remoteKeys);
	            var viewDocChanges = view.computeDocChanges(docs);
	            return view.applyChanges(viewDocChanges).snapshot;
	        });
	    };
	    FirestoreClient.prototype.write = function (mutations) {
	        var _this = this;
	        var deferred = new Deferred$1();
	        this.asyncQueue.enqueue(function () { return _this.syncEngine.write(mutations, deferred); });
	        return deferred.promise;
	    };
	    FirestoreClient.prototype.databaseId = function () {
	        return this.databaseInfo.databaseId;
	    };
	    FirestoreClient.prototype.transaction = function (updateFunction) {
	        var _this = this;
	        // We have to wait for the async queue to be sure syncEngine is initialized.
	        return this.asyncQueue
	            .enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
	            return [2 /*return*/];
	        }); }); })
	            .then(function () { return _this.syncEngine.runTransaction(updateFunction); });
	    };
	    return FirestoreClient;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*
	 * A wrapper implementation of Observer<T> that will dispatch events
	 * asynchronously. To allow immediate silencing, a mute call is added which
	 * causes events scheduled to no longer be raised.
	 */
	var AsyncObserver = /** @class */ (function () {
	    function AsyncObserver(observer) {
	        this.observer = observer;
	        /**
	         * When set to true, will not raise future events. Necessary to deal with
	         * async detachment of listener.
	         */
	        this.muted = false;
	    }
	    AsyncObserver.prototype.next = function (value) {
	        this.scheduleEvent(this.observer.next, value);
	    };
	    AsyncObserver.prototype.error = function (error) {
	        this.scheduleEvent(this.observer.error, error);
	    };
	    AsyncObserver.prototype.mute = function () {
	        this.muted = true;
	    };
	    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
	        var _this = this;
	        if (!this.muted) {
	            setTimeout(function () {
	                if (!_this.muted) {
	                    eventHandler(event);
	                }
	            }, 0);
	        }
	    };
	    return AsyncObserver;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Simple wrapper around a nullable UID. Mostly exists to make code more
	 * readable.
	 */
	var User = /** @class */ (function () {
	    function User(uid) {
	        this.uid = uid;
	    }
	    User.prototype.isAuthenticated = function () {
	        return this.uid != null;
	    };
	    /**
	     * Returns a key representing this user, suitable for inclusion in a
	     * dictionary.
	     */
	    User.prototype.toKey = function () {
	        if (this.isAuthenticated()) {
	            return 'uid:' + this.uid;
	        }
	        else {
	            return 'anonymous-user';
	        }
	    };
	    User.prototype.isEqual = function (otherUser) {
	        return otherUser.uid === this.uid;
	    };
	    /** A user with a null UID. */
	    User.UNAUTHENTICATED = new User(null);
	    // TODO(mikelehen): Look into getting a proper uid-equivalent for
	    // non-FirebaseAuth providers.
	    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
	    User.FIRST_PARTY = new User('first-party-uid');
	    return User;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var OAuthToken = /** @class */ (function () {
	    function OAuthToken(value, user) {
	        this.user = user;
	        this.type = 'OAuth';
	        this.authHeaders = { Authorization: "Bearer " + value };
	    }
	    return OAuthToken;
	}());
	/** A CredentialsProvider that always yields an empty token. */
	var EmptyCredentialsProvider = /** @class */ (function () {
	    function EmptyCredentialsProvider() {
	        /**
	         * Stores the User listener registered with setUserChangeListener()
	         * This isn't actually necessary since the UID never changes, but we use this
	         * to verify the listen contract is adhered to in tests.
	         */
	        this.userListener = null;
	    }
	    EmptyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(null);
	    };
	    EmptyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire with initial user.
	        listener(User.UNAUTHENTICATED);
	    };
	    EmptyCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert(this.userListener !== null, 'removeUserChangeListener() when no listener registered');
	        this.userListener = null;
	    };
	    return EmptyCredentialsProvider;
	}());
	var FirebaseCredentialsProvider = /** @class */ (function () {
	    function FirebaseCredentialsProvider(app) {
	        var _this = this;
	        this.app = app;
	        /**
	         * The auth token listener registered with FirebaseApp, retained here so we
	         * can unregister it.
	         */
	        this.tokenListener = null;
	        /**
	         * Counter used to detect if the user changed while a getToken request was
	         * outstanding.
	         */
	        this.userCounter = 0;
	        /** The User listener registered with setUserChangeListener(). */
	        this.userListener = null;
	        // We listen for token changes but all we really care about is knowing when
	        // the uid may have changed.
	        this.tokenListener = function () {
	            var newUser = _this.getUser();
	            if (!_this.currentUser || !newUser.isEqual(_this.currentUser)) {
	                _this.currentUser = newUser;
	                _this.userCounter++;
	                if (_this.userListener) {
	                    _this.userListener(_this.currentUser);
	                }
	            }
	        };
	        this.userCounter = 0;
	        // Will fire at least once where we set this.currentUser
	        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
	    }
	    FirebaseCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        var _this = this;
	        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
	        // Take note of the current value of the userCounter so that this method can
	        // fail (with an ABORTED error) if there is a user change while the request
	        // is outstanding.
	        var initialUserCounter = this.userCounter;
	        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
	            // Cancel the request since the user changed while the request was
	            // outstanding so the response is likely for a previous user (which
	            // user, we can't be sure).
	            if (_this.userCounter !== initialUserCounter) {
	                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to uid change.');
	            }
	            else {
	                if (tokenData) {
	                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
	                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
	                }
	                else {
	                    return null;
	                }
	            }
	        });
	    };
	    FirebaseCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire the initial event, but only if we received the initial user
	        if (this.currentUser) {
	            listener(this.currentUser);
	        }
	    };
	    FirebaseCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert(this.tokenListener != null, 'removeUserChangeListener() called twice');
	        assert(this.userListener !== null, 'removeUserChangeListener() called when no listener registered');
	        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
	        this.tokenListener = null;
	        this.userListener = null;
	    };
	    FirebaseCredentialsProvider.prototype.getUser = function () {
	        // TODO(mikelehen): Remove this check once we're shipping with firebase.js.
	        if (typeof this.app.INTERNAL.getUid !== 'function') {
	            fail('This version of the Firestore SDK requires at least version' +
	                ' 3.7.0 of firebase.js.');
	        }
	        var currentUid = this.app.INTERNAL.getUid();
	        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
	        return new User(currentUid);
	    };
	    return FirebaseCredentialsProvider;
	}());
	/*
	 * FirstPartyToken provides a fresh token each time its value
	 * is requested, because if the token is too old, requests will be rejected.
	 * TODO(b/33147818) this implementation violates the current assumption that
	 * tokens are immutable.  We need to either revisit this assumption or come
	 * up with some way for FPA to use the listen/unlisten interface.
	 */
	var FirstPartyToken = /** @class */ (function () {
	    function FirstPartyToken(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        this.type = 'FirstParty';
	        this.user = User.FIRST_PARTY;
	        assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
	        get: function () {
	            return {
	                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
	                'X-Goog-AuthUser': this.sessionIndex
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirstPartyToken;
	}());
	/*
	 * Provides user credentials required for the Firestore JavaScript SDK
	 * to authenticate the user, using technique that is only available
	 * to applications hosted by Google.
	 */
	var FirstPartyCredentialsProvider = /** @class */ (function () {
	    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    FirstPartyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
	    };
	    // TODO(33108925): can someone switch users w/o a page refresh?
	    // TODO(33110621): need to understand token/session lifecycle
	    FirstPartyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        // Fire with initial uid.
	        listener(User.FIRST_PARTY);
	    };
	    FirstPartyCredentialsProvider.prototype.removeUserChangeListener = function () { };
	    return FirstPartyCredentialsProvider;
	}());
	/**
	 * Builds a CredentialsProvider depending on the type of
	 * the credentials passed in.
	 */
	function makeCredentialsProvider(credentials) {
	    if (!credentials) {
	        return new EmptyCredentialsProvider();
	    }
	    switch (credentials.type) {
	        case 'gapi':
	            return new FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
	        case 'provider':
	            return credentials.client;
	        default:
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function isPartialObserver(obj) {
	    return implementsAnyMethods$1(obj, ['next', 'error', 'complete']);
	}
	/**
	 * Returns true if obj is an object and contains at least one of the specified
	 * methods.
	 */
	function implementsAnyMethods$1(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    var object = obj;
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in object && typeof object[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An opaque base class for FieldValue sentinel objects in our public API,
	 * with public static methods for creating said sentinel objects.
	 */
	// tslint:disable-next-line:class-as-namespace  We use this as a base class.
	var FieldValueImpl = /** @class */ (function () {
	    function FieldValueImpl(methodName) {
	        this.methodName = methodName;
	    }
	    FieldValueImpl.delete = function () {
	        return DeleteFieldValueImpl.instance;
	    };
	    FieldValueImpl.serverTimestamp = function () {
	        return ServerTimestampFieldValueImpl.instance;
	    };
	    // TODO(array-features): Expose this once backend support lands.
	    FieldValueImpl._arrayUnion = function () {
	        var elements = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            elements[_i] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we need access to the Firestore instance.
	        return new ArrayUnionFieldValueImpl(elements);
	    };
	    // TODO(array-features): Expose this once backend support lands.
	    FieldValueImpl._arrayRemove = function () {
	        var elements = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            elements[_i] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we need access to the Firestore instance.
	        return new ArrayRemoveFieldValueImpl(elements);
	    };
	    FieldValueImpl.prototype.isEqual = function (other) {
	        return this === other;
	    };
	    return FieldValueImpl;
	}());
	var DeleteFieldValueImpl = /** @class */ (function (_super) {
	    tslib_1.__extends(DeleteFieldValueImpl, _super);
	    function DeleteFieldValueImpl() {
	        return _super.call(this, 'FieldValue.delete') || this;
	    }
	    /** Singleton instance. */
	    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
	    return DeleteFieldValueImpl;
	}(FieldValueImpl));
	var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
	    tslib_1.__extends(ServerTimestampFieldValueImpl, _super);
	    function ServerTimestampFieldValueImpl() {
	        return _super.call(this, 'FieldValue.serverTimestamp') || this;
	    }
	    /** Singleton instance. */
	    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
	    return ServerTimestampFieldValueImpl;
	}(FieldValueImpl));
	var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
	    tslib_1.__extends(ArrayUnionFieldValueImpl, _super);
	    function ArrayUnionFieldValueImpl(_elements) {
	        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
	        _this._elements = _elements;
	        return _this;
	    }
	    return ArrayUnionFieldValueImpl;
	}(FieldValueImpl));
	var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
	    tslib_1.__extends(ArrayRemoveFieldValueImpl, _super);
	    function ArrayRemoveFieldValueImpl(_elements) {
	        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
	        _this._elements = _elements;
	        return _this;
	    }
	    return ArrayRemoveFieldValueImpl;
	}(FieldValueImpl));
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
	// be called FieldValue publicly. Internally we still use FieldValueImpl which
	// has a type-checked private constructor. Note that FieldValueImpl and
	// PublicFieldValue can be used interchangeably in instanceof checks.
	// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
	// and so we need to use FieldValueImpl as type and export it too.
	// tslint:disable-next-line:variable-name  We treat this as a class name.
	var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RESERVED_FIELD_REGEX = /^__.*__$/;
	/** The result of parsing document data (e.g. for a setData call). */
	var ParsedSetData = /** @class */ (function () {
	    function ParsedSetData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedSetData.prototype.toMutations = function (key, precondition) {
	        var mutations = [];
	        if (this.fieldMask !== null) {
	            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
	        }
	        else {
	            mutations.push(new SetMutation(key, this.data, precondition));
	        }
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedSetData;
	}());
	/** The result of parsing "update" data (i.e. for an updateData call). */
	var ParsedUpdateData = /** @class */ (function () {
	    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
	        var mutations = [
	            new PatchMutation(key, this.data, this.fieldMask, precondition)
	        ];
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedUpdateData;
	}());
	/*
	 * Represents what type of API method provided the data being parsed; useful
	 * for determining which error conditions apply during parsing and providing
	 * better error messages.
	 */
	var UserDataSource;
	(function (UserDataSource) {
	    UserDataSource[UserDataSource["Set"] = 0] = "Set";
	    UserDataSource[UserDataSource["Update"] = 1] = "Update";
	    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
	    /**
	     * Indicates the source is a where clause, cursor bound, arrayUnion()
	     * element, etc. Of note, isWrite(source) will return false.
	     */
	    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
	})(UserDataSource || (UserDataSource = {}));
	function isWrite(dataSource) {
	    switch (dataSource) {
	        case UserDataSource.Set: // fall through
	        case UserDataSource.MergeSet: // fall through
	        case UserDataSource.Update:
	            return true;
	        case UserDataSource.Argument:
	            return false;
	        default:
	            throw fail("Unexpected case for UserDataSource: " + dataSource);
	    }
	}
	/** A "context" object passed around while parsing user data. */
	var ParseContext = /** @class */ (function () {
	    /**
	     * Initializes a ParseContext with the given source and path.
	     *
	     * @param dataSource Indicates what kind of API method this data came from.
	     * @param methodName The name of the method the user called to create this
	     *     ParseContext.
	     * @param path A path within the object being parsed. This could be an empty
	     *     path (in which case the context represents the root of the data being
	     *     parsed), or a nonempty path (indicating the context represents a nested
	     *     location within the data).
	     * @param arrayElement Whether or not this context corresponds to an element
	     *     of an array.
	     * @param fieldTransforms A mutable list of field transforms encountered while
	     *     parsing the data.
	     * @param fieldMask A mutable list of field paths encountered while parsing
	     *     the data.
	     *
	     * TODO(b/34871131): We don't support array paths right now, so path can be
	     * null to indicate the context represents any location within an array (in
	     * which case certain features will not work and errors will be somewhat
	     * compromised).
	     */
	    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
	        this.dataSource = dataSource;
	        this.methodName = methodName;
	        this.path = path;
	        this.arrayElement = arrayElement;
	        // Minor hack: If fieldTransforms is undefined, we assume this is an
	        // external call and we need to validate the entire path.
	        if (fieldTransforms === undefined) {
	            this.validatePath();
	        }
	        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
	        this.fieldTransforms = fieldTransforms || [];
	        this.fieldMask = fieldMask || [];
	    }
	    ParseContext.prototype.childContextForField = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePathSegment(field);
	        return context;
	    };
	    ParseContext.prototype.childContextForFieldPath = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePath();
	        return context;
	    };
	    ParseContext.prototype.childContextForArray = function (index) {
	        // TODO(b/34871131): We don't support array paths right now; so make path
	        // null.
	        return new ParseContext(this.dataSource, this.methodName, 
	        /*path=*/ null, 
	        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
	    };
	    ParseContext.prototype.createError = function (reason) {
	        var fieldDescription = this.path === null || this.path.isEmpty()
	            ? ''
	            : " (found in field " + this.path.toString() + ")";
	        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
	            reason +
	            fieldDescription);
	    };
	    ParseContext.prototype.validatePath = function () {
	        // TODO(b/34871131): Remove null check once we have proper paths for fields
	        // within arrays.
	        if (this.path === null) {
	            return;
	        }
	        for (var i = 0; i < this.path.length; i++) {
	            this.validatePathSegment(this.path.get(i));
	        }
	    };
	    ParseContext.prototype.validatePathSegment = function (segment) {
	        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
	            throw this.createError('Document fields cannot begin and end with __');
	        }
	    };
	    return ParseContext;
	}());
	/**
	 * A placeholder object for DocumentReferences in this file, in order to
	 * avoid a circular dependency. See the comments for `DataPreConverter` for
	 * the full context.
	 */
	var DocumentKeyReference = /** @class */ (function () {
	    function DocumentKeyReference(databaseId, key) {
	        this.databaseId = databaseId;
	        this.key = key;
	    }
	    return DocumentKeyReference;
	}());
	/**
	 * Helper for parsing raw user input (provided via the API) into internal model
	 * classes.
	 */
	var UserDataConverter = /** @class */ (function () {
	    function UserDataConverter(preConverter) {
	        this.preConverter = preConverter;
	    }
	    /** Parse document data from a non-merge set() call. */
	    UserDataConverter.prototype.parseSetData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        return new ParsedSetData(updateData, 
	        /* fieldMask= */ null, context.fieldTransforms);
	    };
	    /** Parse document data from a set() call with '{merge:true}'. */
	    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
	        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        var fieldMask;
	        var fieldTransforms;
	        if (!fieldPaths) {
	            fieldMask = new FieldMask(context.fieldMask);
	            fieldTransforms = context.fieldTransforms;
	        }
	        else {
	            var validatedFieldPaths = [];
	            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
	                var stringOrFieldPath = fieldPaths_1[_i];
	                var fieldPath = void 0;
	                if (stringOrFieldPath instanceof FieldPath$1) {
	                    fieldPath = stringOrFieldPath;
	                }
	                else if (typeof stringOrFieldPath === 'string') {
	                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
	                }
	                else {
	                    fail('Expected stringOrFieldPath to be a string or a FieldPath');
	                }
	                if (!updateData.contains(fieldPath)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
	                }
	                validatedFieldPaths.push(fieldPath);
	            }
	            fieldMask = new FieldMask(validatedFieldPaths);
	            fieldTransforms = context.fieldTransforms.filter(function (transform) {
	                return fieldMask.covers(transform.field);
	            });
	        }
	        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
	    };
	    /** Parse update data from an update() call. */
	    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
	        var _this = this;
	        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var fieldMaskPaths = [];
	        var updateData = ObjectValue.EMPTY;
	        forEach(input, function (key, value) {
	            var path = fieldPathFromDotSeparatedString(methodName, key);
	            var childContext = context.childContextForFieldPath(path);
	            value = _this.runPreConverter(value, childContext);
	            if (value instanceof DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = _this.parseData(value, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        });
	        var mask = new FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /** Parse update data from a list of field/value arguments. */
	    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
	        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
	        var keys = [fieldPathFromArgument(methodName, field)];
	        var values = [value];
	        if (moreFieldsAndValues.length % 2 !== 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
	                'of arguments that alternate between field names and values.');
	        }
	        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
	            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
	            values.push(moreFieldsAndValues[i + 1]);
	        }
	        var fieldMaskPaths = [];
	        var updateData = ObjectValue.EMPTY;
	        for (var i = 0; i < keys.length; ++i) {
	            var path = keys[i];
	            var childContext = context.childContextForFieldPath(path);
	            var value_1 = this.runPreConverter(values[i], childContext);
	            if (value_1 instanceof DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = this.parseData(value_1, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        }
	        var mask = new FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /**
	     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
	     * bound).
	     */
	    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
	        var parsed = this.parseData(input, context);
	        assert(parsed != null, 'Parsed data should not be null.');
	        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
	        return parsed;
	    };
	    /** Sends data through this.preConverter, handling any thrown errors. */
	    UserDataConverter.prototype.runPreConverter = function (input, context) {
	        try {
	            return this.preConverter(input);
	        }
	        catch (e) {
	            var message = errorMessage(e);
	            throw context.createError(message);
	        }
	    };
	    /**
	     * Internal helper for parsing user data.
	     *
	     * @param input Data to be parsed.
	     * @param context A context object representing the current path being parsed,
	     * the source of the data being parsed, etc.
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseData = function (input, context) {
	        input = this.runPreConverter(input, context);
	        if (looksLikeJsonObject(input)) {
	            validatePlainObject('Unsupported field value:', context, input);
	            return this.parseObject(input, context);
	        }
	        else if (input instanceof FieldValueImpl) {
	            // FieldValues usually parse into transforms (except FieldValue.delete())
	            // in which case we do not want to include this field in our parsed data
	            // (as doing so will overwrite the field directly prior to the transform
	            // trying to transform it). So we don't add this location to
	            // context.fieldMask and we return null as our parsing result.
	            this.parseSentinelFieldValue(input, context);
	            return null;
	        }
	        else {
	            // If context.path is null we are inside an array and we don't support
	            // field mask paths more granular than the top-level array.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            if (input instanceof Array) {
	                // TODO(b/34871131): Include the path containing the array in the error
	                // message.
	                if (context.arrayElement) {
	                    throw context.createError('Nested arrays are not supported');
	                }
	                return this.parseArray(input, context);
	            }
	            else {
	                return this.parseScalarValue(input, context);
	            }
	        }
	    };
	    UserDataConverter.prototype.parseObject = function (obj, context) {
	        var _this = this;
	        var result = new SortedMap(primitiveComparator);
	        forEach(obj, function (key, val) {
	            var parsedValue = _this.parseData(val, context.childContextForField(key));
	            if (parsedValue != null) {
	                result = result.insert(key, parsedValue);
	            }
	        });
	        return new ObjectValue(result);
	    };
	    UserDataConverter.prototype.parseArray = function (array, context) {
	        var result = [];
	        var entryIndex = 0;
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var entry = array_1[_i];
	            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
	            if (parsedEntry == null) {
	                // Just include nulls in the array for fields being replaced with a
	                // sentinel.
	                parsedEntry = NullValue.INSTANCE;
	            }
	            result.push(parsedEntry);
	            entryIndex++;
	        }
	        return new ArrayValue(result);
	    };
	    /**
	     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
	     * context.fieldTransforms.
	     */
	    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
	        // Sentinels are only supported with writes, and not within arrays.
	        if (!isWrite(context.dataSource)) {
	            throw context.createError(value.methodName + "() can only be used with update() and set()");
	        }
	        if (context.path === null) {
	            throw context.createError(value.methodName + "() is not currently supported inside arrays");
	        }
	        if (value instanceof DeleteFieldValueImpl) {
	            if (context.dataSource === UserDataSource.MergeSet) {
	                // No transform to add for a delete, but we need to add it to our
	                // fieldMask so it gets deleted.
	                context.fieldMask.push(context.path);
	            }
	            else if (context.dataSource === UserDataSource.Update) {
	                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
	                    ' been handled.');
	                throw context.createError('FieldValue.delete() can only appear at the top level ' +
	                    'of your update data');
	            }
	            else {
	                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
	                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
	                    '{merge:true}');
	            }
	        }
	        else if (value instanceof ServerTimestampFieldValueImpl) {
	            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
	        }
	        else if (value instanceof ArrayUnionFieldValueImpl) {
	            var parsedElements = this.parseArrayTransformElements(value.methodName, value._elements);
	            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
	            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
	        }
	        else if (value instanceof ArrayRemoveFieldValueImpl) {
	            var parsedElements = this.parseArrayTransformElements(value.methodName, value._elements);
	            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
	            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
	        }
	        else {
	            fail('Unknown FieldValue type: ' + value);
	        }
	    };
	    /**
	     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
	     *
	     * @return The parsed value
	     */
	    UserDataConverter.prototype.parseScalarValue = function (value, context) {
	        if (value === null) {
	            return NullValue.INSTANCE;
	        }
	        else if (typeof value === 'number') {
	            if (isSafeInteger(value)) {
	                return new IntegerValue(value);
	            }
	            else {
	                return new DoubleValue(value);
	            }
	        }
	        else if (typeof value === 'boolean') {
	            return BooleanValue.of(value);
	        }
	        else if (typeof value === 'string') {
	            return new StringValue(value);
	        }
	        else if (value instanceof Date) {
	            return new TimestampValue(Timestamp.fromDate(value));
	        }
	        else if (value instanceof Timestamp) {
	            // Firestore backend truncates precision down to microseconds. To ensure
	            // offline mode works the same with regards to truncation, perform the
	            // truncation immediately without waiting for the backend to do that.
	            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
	        }
	        else if (value instanceof GeoPoint) {
	            return new GeoPointValue(value);
	        }
	        else if (value instanceof Blob) {
	            return new BlobValue(value);
	        }
	        else if (value instanceof DocumentKeyReference) {
	            return new RefValue(value.databaseId, value.key);
	        }
	        else {
	            throw context.createError("Unsupported field value: " + valueDescription(value));
	        }
	    };
	    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
	        var _this = this;
	        return elements.map(function (element, i) {
	            // Although array transforms are used with writes, the actual elements
	            // being unioned or removed are not considered writes since they cannot
	            // contain any FieldValue sentinels, etc.
	            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
	            return _this.parseData(element, context.childContextForArray(i));
	        });
	    };
	    return UserDataConverter;
	}());
	/**
	 * Checks whether an object looks like a JSON object that should be converted
	 * into a struct. Normal class/prototype instances are considered to look like
	 * JSON objects since they should be converted to a struct value. Arrays, Dates,
	 * GeoPoints, etc. are not considered to look like JSON objects since they map
	 * to specific FieldValue types other than ObjectValue.
	 */
	function looksLikeJsonObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        !(input instanceof Array) &&
	        !(input instanceof Date) &&
	        !(input instanceof Timestamp) &&
	        !(input instanceof GeoPoint) &&
	        !(input instanceof Blob) &&
	        !(input instanceof DocumentKeyReference) &&
	        !(input instanceof FieldValueImpl));
	}
	function validatePlainObject(message, context, input) {
	    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
	        var description = valueDescription(input);
	        if (description === 'an object') {
	            // Massage the error if it was an object.
	            throw context.createError(message + ' a custom object');
	        }
	        else {
	            throw context.createError(message + ' ' + description);
	        }
	    }
	}
	/**
	 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
	 */
	function fieldPathFromArgument(methodName, path) {
	    if (path instanceof FieldPath$1) {
	        return path._internalPath;
	    }
	    else if (typeof path === 'string') {
	        return fieldPathFromDotSeparatedString(methodName, path);
	    }
	    else {
	        var message = 'Field path arguments must be of type string or FieldPath.';
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Wraps fromDotSeparatedString with an error message about the method that
	 * was thrown.
	 * @param methodName The publicly visible method name
	 * @param path The dot-separated string form of a field path which will be split
	 * on dots.
	 */
	function fieldPathFromDotSeparatedString(methodName, path) {
	    try {
	        return fromDotSeparatedString(path)._internalPath;
	    }
	    catch (e) {
	        var message = errorMessage(e);
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Extracts the message from a caught exception, which should be an Error object
	 * though JS doesn't guarantee that.
	 */
	function errorMessage(error) {
	    return error instanceof Error ? error.message : error.toString();
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	var DEFAULT_HOST = 'firestore.googleapis.com';
	var DEFAULT_SSL = true;
	var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = false;
	/**
	 * A concrete type describing all the values that can be applied via a
	 * user-supplied firestore.Settings object. This is a separate type so that
	 * defaults can be supplied and the value can be checked for equality.
	 */
	var FirestoreSettings = /** @class */ (function () {
	    function FirestoreSettings(settings) {
	        if (settings.host === undefined) {
	            if (settings.ssl !== undefined) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
	            }
	            this.host = DEFAULT_HOST;
	            this.ssl = DEFAULT_SSL;
	        }
	        else {
	            validateNamedType('settings', 'string', 'host', settings.host);
	            this.host = settings.host;
	            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
	            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
	        }
	        validateOptionNames('settings', settings, [
	            'host',
	            'ssl',
	            'credentials',
	            'timestampsInSnapshots'
	        ]);
	        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
	        this.credentials = settings.credentials;
	        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
	        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
	    }
	    FirestoreSettings.prototype.isEqual = function (other) {
	        return (this.host === other.host &&
	            this.ssl === other.ssl &&
	            this.timestampsInSnapshots === other.timestampsInSnapshots &&
	            this.credentials === other.credentials);
	    };
	    return FirestoreSettings;
	}());
	var FirestoreConfig = /** @class */ (function () {
	    function FirestoreConfig() {
	    }
	    return FirestoreConfig;
	}());
	/**
	 * The root reference to the database.
	 */
	var Firestore = /** @class */ (function () {
	    function Firestore(databaseIdOrApp) {
	        var _this = this;
	        // Public for use in tests.
	        // TODO(mikelehen): Use modularized initialization instead.
	        this._queue = new AsyncQueue();
	        this.INTERNAL = {
	            delete: function (options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                return tslib_1.__generator(this, function (_a) {
	                    if (this._firestoreClient) {
	                        return [2 /*return*/, this._firestoreClient.shutdown(options)];
	                    }
	                    return [2 /*return*/];
	                });
	            }); }
	        };
	        var config = new FirestoreConfig();
	        if (typeof databaseIdOrApp.options === 'object') {
	            // This is very likely a Firebase app object
	            // TODO(b/34177605): Can we somehow use instanceof?
	            var app = databaseIdOrApp;
	            config.firebaseApp = app;
	            config.databaseId = Firestore.databaseIdFromApp(app);
	            config.persistenceKey = config.firebaseApp.name;
	            config.credentials = new FirebaseCredentialsProvider(app);
	        }
	        else {
	            var external_1 = databaseIdOrApp;
	            if (!external_1.projectId) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
	            }
	            config.databaseId = new DatabaseId(external_1.projectId, external_1.database);
	            // Use a default persistenceKey that lines up with FirebaseApp.
	            config.persistenceKey = '[DEFAULT]';
	            config.credentials = new EmptyCredentialsProvider();
	        }
	        config.settings = new FirestoreSettings({});
	        this._config = config;
	        this._databaseId = config.databaseId;
	    }
	    Firestore.prototype.settings = function (settingsLiteral) {
	        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
	        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
	        if (contains(settingsLiteral, 'persistence')) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
	                'firestore.enablePersistence().');
	        }
	        var newSettings = new FirestoreSettings(settingsLiteral);
	        if (this._firestoreClient && !this._config.settings.isEqual(newSettings)) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
	                'be changed. You can only call settings() before calling any other ' +
	                'methods on a Firestore object.');
	        }
	        this._config.settings = newSettings;
	        if (newSettings.credentials !== undefined) {
	            this._config.credentials = makeCredentialsProvider(newSettings.credentials);
	        }
	    };
	    Firestore.prototype.enableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.enableNetwork();
	    };
	    Firestore.prototype.disableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.disableNetwork();
	    };
	    Firestore.prototype.enablePersistence = function () {
	        if (this._firestoreClient) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
	                'be enabled. You can only call enablePersistence() before calling ' +
	                'any other methods on a Firestore object.');
	        }
	        return this.configureClient(/* persistence= */ true);
	    };
	    Firestore.prototype.ensureClientConfigured = function () {
	        if (!this._firestoreClient) {
	            this.configureClient(/* persistence= */ false);
	        }
	        return this._firestoreClient;
	    };
	    Firestore.prototype.configureClient = function (persistence) {
	        var _this = this;
	        assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
	        if (!this._config.settings.timestampsInSnapshots) {
	            error("\nThe behavior for Date objects stored in Firestore is going to change\nAND YOUR APP MAY BREAK.\nTo hide this warning and ensure your app does not break, you need to add the\nfollowing code to your app before calling any other Cloud Firestore methods:\n\n  const firestore = firebase.firestore();\n  const settings = {/* your settings... */ timestampsInSnapshots: true};\n  firestore.settings(settings);\n\nWith this change, timestamps stored in Cloud Firestore will be read back as\nFirebase Timestamp objects instead of as system Date objects. So you will also\nneed to update code expecting a Date to instead expect a Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at');\n  const date = timestamp.toDate();\n\nPlease audit all existing usages of Date when you enable the new behavior. In a\nfuture release, the behavior will change to the new behavior, so if you do not\nfollow these steps, YOUR APP MAY BREAK.");
	        }
	        assert(!this._firestoreClient, 'configureClient() called multiple times');
	        var databaseInfo = new DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
	        var preConverter = function (value) {
	            if (value instanceof DocumentReference) {
	                var thisDb = _this._config.databaseId;
	                var otherDb = value.firestore._config.databaseId;
	                if (!otherDb.isEqual(thisDb)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
	                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
	                        ("for database " + thisDb.projectId + "/" + thisDb.database));
	                }
	                return new DocumentKeyReference(_this._config.databaseId, value._key);
	            }
	            else {
	                return value;
	            }
	        };
	        this._dataConverter = new UserDataConverter(preConverter);
	        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
	        return this._firestoreClient.start(persistence);
	    };
	    Firestore.databaseIdFromApp = function (app) {
	        var options = app.options;
	        if (!contains(options, 'projectId')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreId' once alpha testers have upgraded.
	            if (contains(options, 'firestoreId')) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, '"firestoreId" is now specified as "projectId" in ' +
	                    'firebase.initializeApp.');
	            }
	            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
	        }
	        if (contains(options, 'firestoreOptions')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreOptions' once alpha testers have upgraded.
	            throw new FirestoreError(Code.INVALID_ARGUMENT, '"firestoreOptions" values are now specified with ' +
	                'Firestore.settings()');
	        }
	        var projectId = options['projectId'];
	        if (!projectId || typeof projectId !== 'string') {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
	        }
	        return new DatabaseId(projectId);
	    };
	    Object.defineProperty(Firestore.prototype, "app", {
	        get: function () {
	            if (!this._config.firebaseApp) {
	                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
	                    'not available');
	            }
	            return this._config.firebaseApp;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.prototype.collection = function (pathString) {
	        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
	        validateArgType('Firestore.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
	        }
	        this.ensureClientConfigured();
	        return new CollectionReference(ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.doc = function (pathString) {
	        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
	        validateArgType('Firestore.doc', 'string', 1, pathString);
	        if (!pathString) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
	        }
	        this.ensureClientConfigured();
	        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.runTransaction = function (updateFunction) {
	        var _this = this;
	        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
	        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
	        return this.ensureClientConfigured().transaction(function (transaction) {
	            return updateFunction(new Transaction$1(_this, transaction));
	        });
	    };
	    Firestore.prototype.batch = function () {
	        this.ensureClientConfigured();
	        return new WriteBatch(this);
	    };
	    Object.defineProperty(Firestore, "logLevel", {
	        get: function () {
	            switch (getLogLevel()) {
	                case LogLevel.DEBUG:
	                    return 'debug';
	                case LogLevel.ERROR:
	                    return 'error';
	                case LogLevel.SILENT:
	                    return 'silent';
	                default:
	                    return fail('Unknown log level: ' + getLogLevel());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.setLogLevel = function (level) {
	        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
	        validateArgType('Firestore.setLogLevel', 'string', 1, level);
	        switch (level) {
	            case 'debug':
	                setLogLevel(LogLevel.DEBUG);
	                break;
	            case 'error':
	                setLogLevel(LogLevel.ERROR);
	                break;
	            case 'silent':
	                setLogLevel(LogLevel.SILENT);
	                break;
	            default:
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
	        }
	    };
	    // Note: this is not a property because the minifier can't work correctly with
	    // the way TypeScript compiler outputs properties.
	    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
	        return this._config.settings.timestampsInSnapshots;
	    };
	    return Firestore;
	}());
	/**
	 * A reference to a transaction.
	 */
	var Transaction$1 = /** @class */ (function () {
	    function Transaction(_firestore, _transaction) {
	        this._firestore = _firestore;
	        this._transaction = _transaction;
	    }
	    Transaction.prototype.get = function (documentRef) {
	        var _this = this;
	        validateExactNumberOfArgs('Transaction.get', arguments, 1);
	        var ref = validateReference('Transaction.get', documentRef, this._firestore);
	        return this._transaction
	            .lookup([ref._key])
	            .then(function (docs) {
	            if (!docs || docs.length !== 1) {
	                return fail('Mismatch in docs returned from document lookup.');
	            }
	            var doc = docs[0];
	            if (doc instanceof NoDocument) {
	                return new DocumentSnapshot(_this._firestore, ref._key, null, false);
	            }
	            return new DocumentSnapshot(_this._firestore, ref._key, doc, false);
	        });
	    };
	    Transaction.prototype.set = function (documentRef, value, options) {
	        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
	        var ref = validateReference('Transaction.set', documentRef, this._firestore);
	        options = validateSetOptions('Transaction.set', options);
	        var parsed = options.merge || options.mergeFields
	            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value, options.mergeFields)
	            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
	        this._transaction.set(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('Transaction.update', arguments, 2);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
	        }
	        this._transaction.update(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.delete = function (documentRef) {
	        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
	        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
	        this._transaction.delete(ref._key);
	        return this;
	    };
	    return Transaction;
	}());
	var WriteBatch = /** @class */ (function () {
	    function WriteBatch(_firestore) {
	        this._firestore = _firestore;
	        this._mutations = [];
	        this._committed = false;
	    }
	    WriteBatch.prototype.set = function (documentRef, value, options) {
	        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
	        options = validateSetOptions('WriteBatch.set', options);
	        var parsed = options.merge || options.mergeFields
	            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value, options.mergeFields)
	            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        this.verifyNotCommitted();
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
	        }
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
	        return this;
	    };
	    WriteBatch.prototype.delete = function (documentRef) {
	        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
	        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.commit = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                this.verifyNotCommitted();
	                this._committed = true;
	                if (this._mutations.length > 0) {
	                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    WriteBatch.prototype.verifyNotCommitted = function () {
	        if (this._committed) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
	                'has been called.');
	        }
	    };
	    return WriteBatch;
	}());
	/**
	 * A reference to a particular document in a collection in the database.
	 */
	var DocumentReference = /** @class */ (function () {
	    function DocumentReference(_key, firestore) {
	        this._key = _key;
	        this.firestore = firestore;
	        this._firestoreClient = this.firestore.ensureClientConfigured();
	    }
	    DocumentReference.forPath = function (path, firestore) {
	        if (path.length % 2 !== 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
	                'references must have an even number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return new DocumentReference(new DocumentKey(path), firestore);
	    };
	    Object.defineProperty(DocumentReference.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "parent", {
	        get: function () {
	            return new CollectionReference(this._key.path.popLast(), this.firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "path", {
	        get: function () {
	            return this._key.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentReference.prototype.collection = function (pathString) {
	        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
	        validateArgType('DocumentReference.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
	        }
	        var path = ResourcePath.fromString(pathString);
	        return new CollectionReference(this._key.path.child(path), this.firestore);
	    };
	    DocumentReference.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentReference)) {
	            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
	        }
	        return this.firestore === other.firestore && this._key.isEqual(other._key);
	    };
	    DocumentReference.prototype.set = function (value, options) {
	        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
	        options = validateSetOptions('DocumentReference.set', options);
	        var parsed = options.merge || options.mergeFields
	            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value, options.mergeFields)
	            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
	        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
	    };
	    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 2] = arguments[_i];
	        }
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
	            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
	            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
	        }
	        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
	    };
	    DocumentReference.prototype.delete = function () {
	        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
	        return this._firestoreClient.write([
	            new DeleteMutation(this._key, Precondition.NONE)
	        ]);
	    };
	    DocumentReference.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
	        var options = {
	            includeMetadataChanges: false
	        };
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            validateOptionNames('DocumentReference.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        var internalOptions = {
	            includeMetadataChanges: options.includeMetadataChanges
	        };
	        if (isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
	            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(internalOptions, observer);
	    };
	    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new AsyncObserver({
	            next: function (snapshot) {
	                if (observer.next) {
	                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
	                    var doc = snapshot.docs.get(_this._key);
	                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache));
	                }
	            },
	            error: errHandler
	        });
	        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            _this._firestoreClient.unlisten(internalListener);
	        };
	    };
	    DocumentReference.prototype.get = function (options) {
	        var _this = this;
	        validateOptionNames('DocumentReference.get', options, ['source']);
	        if (options) {
	            validateNamedOptionalPropertyEquals('DocumentReference.get', 'options', 'source', options.source, ['default', 'server', 'cache']);
	        }
	        return new Promise(function (resolve, reject) {
	            if (options && options.source === 'cache') {
	                _this.firestore
	                    .ensureClientConfigured()
	                    .getDocumentFromLocalCache(_this._key)
	                    .then(function (doc) {
	                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
	                    /*fromCache=*/ true));
	                }, reject);
	            }
	            else {
	                _this.getViaSnapshotListener(resolve, reject, options);
	            }
	        });
	    };
	    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
	        var unlisten = this.onSnapshotInternal({
	            includeMetadataChanges: true,
	            waitForSyncWhenOnline: true
	        }, {
	            next: function (snap) {
	                // Remove query first before passing event to user to avoid
	                // user actions affecting the now stale query.
	                unlisten();
	                if (!snap.exists && snap.metadata.fromCache) {
	                    // TODO(dimond): If we're online and the document doesn't
	                    // exist then we resolve with a doc.exists set to false. If
	                    // we're offline however, we reject the Promise in this
	                    // case. Two options: 1) Cache the negative response from
	                    // the server so we can deliver that even when you're
	                    // offline 2) Actually reject the Promise in the online case
	                    // if the document doesn't exist.
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
	                }
	                else if (snap.exists &&
	                    snap.metadata.fromCache &&
	                    options &&
	                    options.source === 'server') {
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
	                        'document does exist in the local cache. Run again ' +
	                        'without setting source to "server" to ' +
	                        'retrieve the cached document.)'));
	                }
	                else {
	                    resolve(snap);
	                }
	            },
	            error: reject
	        });
	    };
	    return DocumentReference;
	}());
	var SnapshotMetadata = /** @class */ (function () {
	    function SnapshotMetadata(hasPendingWrites, fromCache) {
	        this.hasPendingWrites = hasPendingWrites;
	        this.fromCache = fromCache;
	    }
	    SnapshotMetadata.prototype.isEqual = function (other) {
	        return (this.hasPendingWrites === other.hasPendingWrites &&
	            this.fromCache === other.fromCache);
	    };
	    return SnapshotMetadata;
	}());
	var DocumentSnapshot = /** @class */ (function () {
	    function DocumentSnapshot(_firestore, _key, _document, _fromCache) {
	        this._firestore = _firestore;
	        this._key = _key;
	        this._document = _document;
	        this._fromCache = _fromCache;
	    }
	    DocumentSnapshot.prototype.data = function (options) {
	        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
	        options = validateSnapshotOptions('DocumentSnapshot.data', options);
	        return !this._document
	            ? undefined
	            : this.convertObject(this._document.data, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
	    };
	    DocumentSnapshot.prototype.get = function (fieldPath, options) {
	        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
	        options = validateSnapshotOptions('DocumentSnapshot.get', options);
	        if (this._document) {
	            var value = this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
	            if (value !== undefined) {
	                return this.convertValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
	            }
	        }
	        return undefined;
	    };
	    Object.defineProperty(DocumentSnapshot.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
	        get: function () {
	            return new DocumentReference(this._key, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
	        get: function () {
	            return this._document !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
	        get: function () {
	            return new SnapshotMetadata(this._document !== null && this._document.hasLocalMutations, this._fromCache);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentSnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSnapshot)) {
	            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._fromCache === other._fromCache &&
	            this._key.isEqual(other._key) &&
	            (this._document === null
	                ? other._document === null
	                : this._document.isEqual(other._document)));
	    };
	    DocumentSnapshot.prototype.convertObject = function (data, options) {
	        var _this = this;
	        var result = {};
	        data.forEach(function (key, value) {
	            result[key] = _this.convertValue(value, options);
	        });
	        return result;
	    };
	    DocumentSnapshot.prototype.convertValue = function (value, options) {
	        if (value instanceof ObjectValue) {
	            return this.convertObject(value, options);
	        }
	        else if (value instanceof ArrayValue) {
	            return this.convertArray(value, options);
	        }
	        else if (value instanceof RefValue) {
	            var key = value.value(options);
	            var database = this._firestore.ensureClientConfigured().databaseId();
	            if (!value.databaseId.isEqual(database)) {
	                // TODO(b/64130202): Somehow support foreign references.
	                error("Document " + this._key.path + " contains a document " +
	                    "reference within a different database (" +
	                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
	                    "supported. It will be treated as a reference in the current " +
	                    ("database (" + database.projectId + "/" + database.database + ") ") +
	                    "instead.");
	            }
	            return new DocumentReference(key, this._firestore);
	        }
	        else {
	            return value.value(options);
	        }
	    };
	    DocumentSnapshot.prototype.convertArray = function (data, options) {
	        var _this = this;
	        return data.internalValue.map(function (value) {
	            return _this.convertValue(value, options);
	        });
	    };
	    return DocumentSnapshot;
	}());
	var QueryDocumentSnapshot = /** @class */ (function (_super) {
	    tslib_1.__extends(QueryDocumentSnapshot, _super);
	    function QueryDocumentSnapshot(firestore, key, document, fromCache) {
	        return _super.call(this, firestore, key, document, fromCache) || this;
	    }
	    QueryDocumentSnapshot.prototype.data = function (options) {
	        var data = _super.prototype.data.call(this, options);
	        assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
	        return data;
	    };
	    return QueryDocumentSnapshot;
	}(DocumentSnapshot));
	var Query$1 = /** @class */ (function () {
	    function Query$$1(_query, firestore) {
	        this._query = _query;
	        this.firestore = firestore;
	    }
	    Query$$1.prototype.where = function (field, opStr, value) {
	        validateExactNumberOfArgs('Query.where', arguments, 3);
	        validateArgType('Query.where', 'string', 2, opStr);
	        validateDefined('Query.where', 3, value);
	        var fieldValue;
	        var fieldPath = fieldPathFromArgument('Query.where', field);
	        var relationOp = RelationOp.fromString(opStr);
	        if (fieldPath.isKeyField()) {
	            if (relationOp === RelationOp.ARRAY_CONTAINS) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform array-contains queries on " +
	                    'FieldPath.documentId() since document IDs are not arrays.');
	            }
	            if (typeof value === 'string') {
	                if (value.indexOf('/') !== -1) {
	                    // TODO(dimond): Allow slashes once ancestor queries are supported
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it contains a slash.');
	                }
	                if (value === '') {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it was an empty string.');
	                }
	                var path = this._query.path.child(new ResourcePath([value]));
	                assert(path.length % 2 === 0, 'Path should be a document key');
	                fieldValue = new RefValue(this.firestore._databaseId, new DocumentKey(path));
	            }
	            else if (value instanceof DocumentReference) {
	                var ref = value;
	                fieldValue = new RefValue(this.firestore._databaseId, ref._key);
	            }
	            else {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
	                    "string or a DocumentReference if the first parameter is " +
	                    "FieldPath.documentId(), but it was: " +
	                    (valueDescription(value) + "."));
	            }
	        }
	        else {
	            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
	        }
	        var filter = fieldFilter(fieldPath, relationOp, fieldValue);
	        this.validateNewFilter(filter);
	        return new Query$$1(this._query.addFilter(filter), this.firestore);
	    };
	    Query$$1.prototype.orderBy = function (field, directionStr) {
	        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
	        validateOptionalArgType('Query.orderBy', 'string', 2, directionStr);
	        var direction;
	        if (directionStr === undefined || directionStr === 'asc') {
	            direction = Direction.ASCENDING;
	        }
	        else if (directionStr === 'desc') {
	            direction = Direction.DESCENDING;
	        }
	        else {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
	                "expected 'asc' or 'desc'.");
	        }
	        if (this._query.startAt !== null) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
	                'Query.startAfter() before calling Query.orderBy().');
	        }
	        if (this._query.endAt !== null) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
	                'Query.endBefore() before calling Query.orderBy().');
	        }
	        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
	        var orderBy = new OrderBy(fieldPath, direction);
	        this.validateNewOrderBy(orderBy);
	        return new Query$$1(this._query.addOrderBy(orderBy), this.firestore);
	    };
	    Query$$1.prototype.limit = function (n) {
	        validateExactNumberOfArgs('Query.limit', arguments, 1);
	        validateArgType('Query.limit', 'number', 1, n);
	        if (n <= 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
	                'positive.');
	        }
	        return new Query$$1(this._query.withLimit(n), this.firestore);
	    };
	    Query$$1.prototype.startAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
	        /*before=*/ true);
	        return new Query$$1(this._query.withStartAt(bound), this.firestore);
	    };
	    Query$$1.prototype.startAfter = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
	        /*before=*/ false);
	        return new Query$$1(this._query.withStartAt(bound), this.firestore);
	    };
	    Query$$1.prototype.endBefore = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
	        /*before=*/ true);
	        return new Query$$1(this._query.withEndAt(bound), this.firestore);
	    };
	    Query$$1.prototype.endAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
	        /*before=*/ false);
	        return new Query$$1(this._query.withEndAt(bound), this.firestore);
	    };
	    Query$$1.prototype.isEqual = function (other) {
	        if (!(other instanceof Query$$1)) {
	            throw invalidClassError('isEqual', 'Query', 1, other);
	        }
	        return (this.firestore === other.firestore && this._query.isEqual(other._query));
	    };
	    /** Helper function to create a bound from a document or fields */
	    Query$$1.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
	        validateDefined(methodName, 1, docOrField);
	        if (docOrField instanceof DocumentSnapshot) {
	            if (fields.length > 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
	            }
	            var snap = docOrField;
	            if (!snap.exists) {
	                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
	                    (methodName + "()."));
	            }
	            return this.boundFromDocument(methodName, snap._document, before);
	        }
	        else {
	            var allFields = [docOrField].concat(fields);
	            return this.boundFromFields(methodName, allFields, before);
	        }
	    };
	    /**
	     * Create a Bound from a query and a document.
	     *
	     * Note that the Bound will always include the key of the document
	     * and so only the provided document will compare equal to the returned
	     * position.
	     *
	     * Will throw if the document does not contain all fields of the order by
	     * of the query.
	     */
	    Query$$1.prototype.boundFromDocument = function (methodName, doc, before) {
	        var components = [];
	        // Because people expect to continue/end a query at the exact document
	        // provided, we need to use the implicit sort order rather than the explicit
	        // sort order, because it's guaranteed to contain the document key. That way
	        // the position becomes unambiguous and the query continues/ends exactly at
	        // the provided document. Without the key (by using the explicit sort
	        // orders), multiple documents could match the position, yielding duplicate
	        // results.
	        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            if (orderBy.field.isKeyField()) {
	                components.push(new RefValue(this.firestore._databaseId, doc.key));
	            }
	            else {
	                var value = doc.field(orderBy.field);
	                if (value !== undefined) {
	                    components.push(value);
	                }
	                else {
	                    var field = orderBy.field.canonicalString();
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
	                        ("document for which the field '" + field + "' (used as the ") +
	                        "orderBy) does not exist.");
	                }
	            }
	        }
	        return new Bound(components, before);
	    };
	    /**
	     * Converts a list of field values to a Bound for the given query.
	     */
	    Query$$1.prototype.boundFromFields = function (methodName, values, before) {
	        // Use explicit order by's because it has to match the query the user made
	        var orderBy = this._query.explicitOrderBy;
	        if (values.length > orderBy.length) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
	                "The number of arguments must be less than or equal to the " +
	                "number of Query.orderBy() clauses");
	        }
	        var components = [];
	        for (var i = 0; i < values.length; i++) {
	            var rawValue = values[i];
	            var orderByComponent = orderBy[i];
	            if (orderByComponent.field.isKeyField()) {
	                if (typeof rawValue !== 'string') {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
	                        (methodName + "(), but got a " + typeof rawValue));
	                }
	                if (rawValue.indexOf('/') !== -1) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " +
	                        (methodName + "()"));
	                }
	                var key = new DocumentKey(this._query.path.child(rawValue));
	                components.push(new RefValue(this.firestore._databaseId, key));
	            }
	            else {
	                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
	                components.push(wrapped);
	            }
	        }
	        return new Bound(components, before);
	    };
	    Query$$1.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
	        var options = {};
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            validateOptionNames('Query.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        if (isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
	            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(options, observer);
	    };
	    Query$$1.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new AsyncObserver({
	            next: function (result) {
	                if (observer.next) {
	                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
	                }
	            },
	            error: errHandler
	        });
	        var firestoreClient = this.firestore.ensureClientConfigured();
	        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            firestoreClient.unlisten(internalListener);
	        };
	    };
	    Query$$1.prototype.get = function (options) {
	        var _this = this;
	        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
	        return new Promise(function (resolve, reject) {
	            if (options && options.source === 'cache') {
	                _this.firestore
	                    .ensureClientConfigured()
	                    .getDocumentsFromLocalCache(_this._query)
	                    .then(function (viewSnap) {
	                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap));
	                }, reject);
	            }
	            else {
	                _this.getViaSnapshotListener(resolve, reject, options);
	            }
	        });
	    };
	    Query$$1.prototype.getViaSnapshotListener = function (resolve, reject, options) {
	        var unlisten = this.onSnapshotInternal({
	            includeMetadataChanges: true,
	            waitForSyncWhenOnline: true
	        }, {
	            next: function (result) {
	                // Remove query first before passing event to user to avoid
	                // user actions affecting the now stale query.
	                unlisten();
	                if (result.metadata.fromCache &&
	                    options &&
	                    options.source === 'server') {
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
	                        'documents may exist in the local cache. Run again ' +
	                        'without setting source to "server" to ' +
	                        'retrieve the cached documents.)'));
	                }
	                else {
	                    resolve(result);
	                }
	            },
	            error: reject
	        });
	    };
	    Query$$1.prototype.validateNewFilter = function (filter) {
	        if (filter instanceof RelationFilter) {
	            if (filter.isInequality()) {
	                var existingField = this._query.getInequalityFilterField();
	                if (existingField !== null && !existingField.isEqual(filter.field)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
	                        ' (<, <=, >, or >=) must be on the same field. But you have' +
	                        (" inequality filters on '" + existingField.toString() + "'") +
	                        (" and '" + filter.field.toString() + "'"));
	                }
	                var firstOrderByField = this._query.getFirstOrderByField();
	                if (firstOrderByField !== null) {
	                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
	                }
	            }
	            else if (filter.op === RelationOp.ARRAY_CONTAINS) {
	                if (this._query.hasArrayContainsFilter()) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. Queries only support a single array-contains ' +
	                        'filter.');
	                }
	            }
	        }
	    };
	    Query$$1.prototype.validateNewOrderBy = function (orderBy) {
	        if (this._query.getFirstOrderByField() === null) {
	            // This is the first order by. It must match any inequality.
	            var inequalityField = this._query.getInequalityFilterField();
	            if (inequalityField !== null) {
	                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
	            }
	        }
	    };
	    Query$$1.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
	        if (!orderBy.isEqual(inequality)) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
	                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
	                ("and so you must also use '" + inequality.toString() + "' ") +
	                "as your first Query.orderBy(), but your first Query.orderBy() " +
	                ("is on field '" + orderBy.toString() + "' instead."));
	        }
	    };
	    return Query$$1;
	}());
	var QuerySnapshot = /** @class */ (function () {
	    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
	        this._firestore = _firestore;
	        this._originalQuery = _originalQuery;
	        this._snapshot = _snapshot;
	        this._cachedChanges = null;
	        this._cachedChangesIncludeMetadataChanges = null;
	        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
	    }
	    Object.defineProperty(QuerySnapshot.prototype, "docs", {
	        get: function () {
	            var result = [];
	            this.forEach(function (doc) { return result.push(doc); });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "empty", {
	        get: function () {
	            return this._snapshot.docs.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "size", {
	        get: function () {
	            return this._snapshot.docs.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
	        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
	        this._snapshot.docs.forEach(function (doc) {
	            callback.call(thisArg, _this.convertToDocumentImpl(doc));
	        });
	    };
	    Object.defineProperty(QuerySnapshot.prototype, "query", {
	        get: function () {
	            return new Query$1(this._originalQuery, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.docChanges = function (options) {
	        validateOptionNames('QuerySnapshot.docChanges', options, [
	            'includeMetadataChanges'
	        ]);
	        if (options) {
	            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	        }
	        var includeMetadataChanges = options && options.includeMetadataChanges;
	        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
	                'also pass { includeMetadataChanges:true } to onSnapshot().');
	        }
	        if (!this._cachedChanges ||
	            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
	            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot);
	            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
	        }
	        return this._cachedChanges;
	    };
	    /** Check the equality. The call can be very expensive. */
	    QuerySnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof QuerySnapshot)) {
	            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._originalQuery.isEqual(other._originalQuery) &&
	            this._snapshot.isEqual(other._snapshot));
	    };
	    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
	        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache);
	    };
	    return QuerySnapshot;
	}());
	// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
	// into a method. Because this is a runtime breaking change and somewhat subtle
	// (both Array and Function have a .length, etc.), we'll replace commonly-used
	// properties (including Symbol.iterator) to throw a custom error message. In
	// ~6 months we can delete the custom error as most folks will have hopefully
	// migrated.
	function throwDocChangesMethodError() {
	    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
	        'method, so usages like "querySnapshot.docChanges" should become ' +
	        '"querySnapshot.docChanges()"');
	}
	var docChangesPropertiesToOverride = [
	    'length',
	    'forEach',
	    'map'
	].concat((typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
	docChangesPropertiesToOverride.forEach(function (property) {
	    /**
	     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
	     * is a Function. This could fail, in particular in the case of 'length' which
	     * already exists on Function.prototype and on IE11 is improperly defined with
	     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
	     * still have a functional SDK.
	     */
	    try {
	        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
	            get: function () { return throwDocChangesMethodError(); }
	        });
	    }
	    catch (err) { } // Ignore this failure intentionally
	});
	var CollectionReference = /** @class */ (function (_super) {
	    tslib_1.__extends(CollectionReference, _super);
	    function CollectionReference(path, firestore) {
	        var _this = _super.call(this, Query.atPath(path), firestore) || this;
	        if (path.length % 2 !== 1) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
	                'references must have an odd number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return _this;
	    }
	    Object.defineProperty(CollectionReference.prototype, "id", {
	        get: function () {
	            return this._query.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "parent", {
	        get: function () {
	            var parentPath = this._query.path.popLast();
	            if (parentPath.isEmpty()) {
	                return null;
	            }
	            else {
	                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "path", {
	        get: function () {
	            return this._query.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollectionReference.prototype.doc = function (pathString) {
	        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
	        // We allow omission of 'pathString' but explicitly prohibit passing in both
	        // 'undefined' and 'null'.
	        if (arguments.length === 0) {
	            pathString = AutoId.newId();
	        }
	        validateArgType('CollectionReference.doc', 'string', 1, pathString);
	        if (pathString === '') {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
	        }
	        var path = ResourcePath.fromString(pathString);
	        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
	    };
	    CollectionReference.prototype.add = function (value) {
	        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
	        validateArgType('CollectionReference.add', 'object', 1, value);
	        var docRef = this.doc();
	        return docRef.set(value).then(function () { return docRef; });
	    };
	    return CollectionReference;
	}(Query$1));
	function validateSetOptions(methodName, options) {
	    if (options === undefined) {
	        return {
	            merge: false
	        };
	    }
	    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
	    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
	    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
	        return typeof element === 'string' || element instanceof FieldPath$1;
	    });
	    if (options.mergeFields !== undefined && options.merge !== undefined) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" and \"mergeFields\".");
	    }
	    return options;
	}
	function validateSnapshotOptions(methodName, options) {
	    if (options === undefined) {
	        return {};
	    }
	    validateOptionNames(methodName, options, ['serverTimestamps']);
	    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
	    return options;
	}
	function validateReference(methodName, documentRef, firestore) {
	    if (!(documentRef instanceof DocumentReference)) {
	        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
	    }
	    else if (documentRef.firestore !== firestore) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
	    }
	    else {
	        return documentRef;
	    }
	}
	/**
	 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
	 *
	 * Exported for testing.
	 */
	function changesFromSnapshot(firestore, includeMetadataChanges, snapshot) {
	    if (snapshot.oldDocs.isEmpty()) {
	        // Special case the first snapshot because index calculation is easy and
	        // fast
	        var lastDoc_1;
	        var index_1 = 0;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
	            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
	            lastDoc_1 = change.doc;
	            return {
	                type: 'added',
	                doc: doc,
	                oldIndex: -1,
	                newIndex: index_1++
	            };
	        });
	    }
	    else {
	        // A DocumentSet that is updated incrementally as changes are applied to use
	        // to lookup the index of a document.
	        var indexTracker_1 = snapshot.oldDocs;
	        return snapshot.docChanges
	            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
	            .map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            var oldIndex = -1;
	            var newIndex = -1;
	            if (change.type !== ChangeType.Added) {
	                oldIndex = indexTracker_1.indexOf(change.doc.key);
	                assert(oldIndex >= 0, 'Index for document not found');
	                indexTracker_1 = indexTracker_1.delete(change.doc.key);
	            }
	            if (change.type !== ChangeType.Removed) {
	                indexTracker_1 = indexTracker_1.add(change.doc);
	                newIndex = indexTracker_1.indexOf(change.doc.key);
	            }
	            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
	        });
	    }
	}
	function resultChangeType(type) {
	    switch (type) {
	        case ChangeType.Added:
	            return 'added';
	        case ChangeType.Modified:
	        case ChangeType.Metadata:
	            return 'modified';
	        case ChangeType.Removed:
	            return 'removed';
	        default:
	            return fail('Unknown change type: ' + type);
	    }
	}
	// Export the classes with a private constructor (it will fail if invoked
	// at runtime). Note that this still allows instanceof checks.
	// We're treating the variables as class names, so disable checking for lower
	// case variable names.
	// tslint:disable:variable-name
	var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
	var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
	var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
	var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
	var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
	var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
	var PublicQuery = makeConstructorPrivate(Query$1);
	var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
	var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
	// tslint:enable:variable-name
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var firestoreNamespace = {
	    Firestore: PublicFirestore,
	    GeoPoint: GeoPoint,
	    Timestamp: Timestamp,
	    Blob: PublicBlob,
	    Transaction: PublicTransaction,
	    WriteBatch: PublicWriteBatch,
	    DocumentReference: PublicDocumentReference,
	    DocumentSnapshot: PublicDocumentSnapshot,
	    Query: PublicQuery,
	    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
	    QuerySnapshot: PublicQuerySnapshot,
	    CollectionReference: PublicCollectionReference,
	    FieldPath: FieldPath$1,
	    FieldValue: PublicFieldValue,
	    setLogLevel: Firestore.setLogLevel
	};
	/**
	 * Configures Firestore as part of the Firebase SDK by calling registerService.
	 */
	function configureForFirebase(firebase$$1) {
	    firebase$$1.INTERNAL.registerService('firestore', function (app) { return new Firestore(app); }, shallowCopy(firestoreNamespace));
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerFirestore(instance) {
	    configureForFirebase(instance);
	}
	registerFirestore(firebase);
	
	exports.registerFirestore = registerFirestore;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var tslib_1 = __webpack_require__(20);
	var firebase = _interopDefault(__webpack_require__(13));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Standard error codes for different ways a request can fail, as defined by:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * This map is used primarily to convert from a backend error code string to
	 * a client SDK error code string, and make sure it's in the supported set.
	 */
	var errorCodeMap = {
	    OK: 'ok',
	    CANCELLED: 'cancelled',
	    UNKNOWN: 'unknown',
	    INVALID_ARGUMENT: 'invalid-argument',
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    NOT_FOUND: 'not-found',
	    ALREADY_EXISTS: 'already-exists',
	    PERMISSION_DENIED: 'permission-denied',
	    UNAUTHENTICATED: 'unauthenticated',
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    FAILED_PRECONDITION: 'failed-precondition',
	    ABORTED: 'aborted',
	    OUT_OF_RANGE: 'out-of-range',
	    UNIMPLEMENTED: 'unimplemented',
	    INTERNAL: 'internal',
	    UNAVAILABLE: 'unavailable',
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An explicit error that can be thrown from a handler to send an error to the
	 * client that called the function.
	 */
	var HttpsErrorImpl = /** @class */ (function (_super) {
	    tslib_1.__extends(HttpsErrorImpl, _super);
	    function HttpsErrorImpl(code, message, details) {
	        var _this = _super.call(this, message) || this;
	        // This is a workaround for a bug in TypeScript when extending Error:
	        // tslint:disable-next-line
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
	        _this.code = code;
	        _this.details = details;
	        return _this;
	    }
	    return HttpsErrorImpl;
	}(Error));
	/**
	 * Takes an HTTP status code and returns the corresponding ErrorCode.
	 * This is the standard HTTP status code -> error mapping defined in:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * @param status An HTTP status code.
	 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
	 */
	function codeForHTTPStatus(status) {
	    // Make sure any successful status is OK.
	    if (status >= 200 && status < 300) {
	        return 'ok';
	    }
	    switch (status) {
	        case 0:
	            // This can happen if the server returns 500.
	            return 'internal';
	        case 400:
	            return 'invalid-argument';
	        case 401:
	            return 'unauthenticated';
	        case 403:
	            return 'permission-denied';
	        case 404:
	            return 'not-found';
	        case 409:
	            return 'aborted';
	        case 429:
	            return 'resource-exhausted';
	        case 499:
	            return 'cancelled';
	        case 500:
	            return 'internal';
	        case 501:
	            return 'unimplemented';
	        case 503:
	            return 'unavailable';
	        case 504:
	            return 'deadline-exceeded';
	    }
	    return 'unknown';
	}
	/**
	 * Takes an HTTP response and returns the corresponding Error, if any.
	 */
	function _errorForResponse(status, bodyJSON, serializer) {
	    var code = codeForHTTPStatus(status);
	    // Start with reasonable defaults from the status code.
	    var description = code;
	    var details = undefined;
	    // Then look through the body for explicit details.
	    try {
	        var errorJSON = bodyJSON.error;
	        if (errorJSON) {
	            var status_1 = errorJSON.status;
	            if (typeof status_1 === 'string') {
	                if (!errorCodeMap[status_1]) {
	                    // They must've included an unknown error code in the body.
	                    return new HttpsErrorImpl('internal', 'internal');
	                }
	                code = errorCodeMap[status_1];
	            }
	            // TODO(klimt): Add better default descriptions for error enums.
	            // The default description needs to be updated for the new code.
	            description = status_1;
	            var message = errorJSON.message;
	            if (typeof message === 'string') {
	                description = message;
	            }
	            details = errorJSON.details;
	            if (details !== undefined) {
	                details = serializer.decode(details);
	            }
	        }
	    }
	    catch (e) {
	        // If we couldn't parse explicit error data, that's fine.
	    }
	    if (code === 'ok') {
	        // Technically, there's an edge case where a developer could explicitly
	        // return an error code of OK, and we will treat it as success, but that
	        // seems reasonable.
	        return null;
	    }
	    return new HttpsErrorImpl(code, description, details);
	}
	
	/**
	 * Helper class to get metadata that should be included with a function call.
	 */
	var ContextProvider = /** @class */ (function () {
	    function ContextProvider(app) {
	        this.app = app;
	    }
	    ContextProvider.prototype.getAuthToken = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var token, e_1;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, this.app.INTERNAL.getToken()];
	                    case 1:
	                        token = _a.sent();
	                        if (!token) {
	                            return [2 /*return*/, undefined];
	                        }
	                        return [2 /*return*/, token.accessToken];
	                    case 2:
	                        e_1 = _a.sent();
	                        // If there's any error when trying to get the auth token, leave it off.
	                        return [2 /*return*/, undefined];
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ContextProvider.prototype.getInstanceIdToken = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var messaging, token, e_2;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        // HACK: Until we have a separate instanceId package, this is a quick way
	                        // to load in the messaging instance for this app.
	                        if (!this.app.messaging) {
	                            return [2 /*return*/, undefined];
	                        }
	                        messaging = this.app.messaging();
	                        return [4 /*yield*/, messaging.getToken()];
	                    case 1:
	                        token = _a.sent();
	                        if (!token) {
	                            return [2 /*return*/, undefined];
	                        }
	                        return [2 /*return*/, token];
	                    case 2:
	                        e_2 = _a.sent();
	                        // We don't warn on this, because it usually means messaging isn't set up.
	                        // console.warn('Failed to retrieve instance id token.', e);
	                        // If there's any error when trying to get the token, leave it off.
	                        return [2 /*return*/, undefined];
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ContextProvider.prototype.getContext = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var authToken, instanceIdToken;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getAuthToken()];
	                    case 1:
	                        authToken = _a.sent();
	                        return [4 /*yield*/, this.getInstanceIdToken()];
	                    case 2:
	                        instanceIdToken = _a.sent();
	                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
	                }
	            });
	        });
	    };
	    return ContextProvider;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
	var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
	function mapValues(o, f) {
	    var result = {};
	    for (var key in o) {
	        if (o.hasOwnProperty(key)) {
	            result[key] = f(o[key]);
	        }
	    }
	    return result;
	}
	var Serializer = /** @class */ (function () {
	    function Serializer() {
	    }
	    // Takes data and encodes it in a JSON-friendly way, such that types such as
	    // Date are preserved.
	    Serializer.prototype.encode = function (data) {
	        var _this = this;
	        if (data === null || data === undefined) {
	            return null;
	        }
	        if (data instanceof Number) {
	            data = data.valueOf();
	        }
	        if (typeof data === 'number' && isFinite(data)) {
	            // Any number in JS is safe to put directly in JSON and parse as a double
	            // without any loss of precision.
	            return data;
	        }
	        if (data === true || data === false) {
	            return data;
	        }
	        if (Object.prototype.toString.call(data) === '[object String]') {
	            return data;
	        }
	        if (Array.isArray(data)) {
	            return data.map(function (x) { return _this.encode(x); });
	        }
	        if (typeof data === 'function' || typeof data === 'object') {
	            return mapValues(data, function (x) { return _this.encode(x); });
	        }
	        // If we got this far, the data is not encodable.
	        throw new Error('Data cannot be encoded in JSON: ' + data);
	    };
	    // Takes data that's been encoded in a JSON-friendly form and returns a form
	    // with richer datatypes, such as Dates, etc.
	    Serializer.prototype.decode = function (json) {
	        var _this = this;
	        if (json === null) {
	            return json;
	        }
	        if (json['@type']) {
	            switch (json['@type']) {
	                case LONG_TYPE:
	                // Fall through and handle this the same as unsigned.
	                case UNSIGNED_LONG_TYPE: {
	                    // Technically, this could work return a valid number for malformed
	                    // data if there was a number followed by garbage. But it's just not
	                    // worth all the extra code to detect that case.
	                    var value = parseFloat(json.value);
	                    if (isNaN(value)) {
	                        throw new Error('Data cannot be decoded from JSON: ' + json);
	                    }
	                    return value;
	                }
	                default: {
	                    throw new Error('Data cannot be decoded from JSON: ' + json);
	                }
	            }
	        }
	        if (Array.isArray(json)) {
	            return json.map(function (x) { return _this.decode(x); });
	        }
	        if (typeof json === 'function' || typeof json === 'object') {
	            return mapValues(json, function (x) { return _this.decode(x); });
	        }
	        // Anything else is safe to return.
	        return json;
	    };
	    return Serializer;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The main class for the Firebase Functions SDK.
	 */
	var Service = /** @class */ (function () {
	    /**
	     * Creates a new Functions service for the given app and (optional) region.
	     * @param app_ The FirebaseApp to use.
	     * @param region_ The region to call functions in.
	     */
	    function Service(app_, region_) {
	        if (region_ === void 0) { region_ = 'us-central1'; }
	        this.app_ = app_;
	        this.region_ = region_;
	        this.serializer = new Serializer();
	        this.contextProvider = new ContextProvider(app_);
	    }
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the URL for a callable with the given name.
	     * @param name The name of the callable.
	     */
	    Service.prototype._url = function (name) {
	        var projectId = this.app_.options.projectId;
	        var region = this.region_;
	        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
	    };
	    /**
	     * Returns a reference to the callable https trigger with the given name.
	     * @param name The name of the trigger.
	     */
	    Service.prototype.httpsCallable = function (name) {
	        var _this = this;
	        var callable = function (data) {
	            return _this.call(name, data);
	        };
	        return callable;
	    };
	    /**
	     * Does an HTTP POST and returns the completed response.
	     * @param url The url to post to.
	     * @param body The JSON body of the post.
	     * @param headers The HTTP headers to include in the request.
	     * @return A Promise that will succeed when the request finishes.
	     */
	    Service.prototype.postJSON = function (url, body, headers) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var response, e_1, json, e_2;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        headers.append('Content-Type', 'application/json');
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, fetch(url, {
	                                method: 'POST',
	                                body: JSON.stringify(body),
	                                headers: headers
	                            })];
	                    case 2:
	                        response = _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _a.sent();
	                        // This could be an unhandled error on the backend, or it could be a
	                        // network error. There's no way to no, since an unhandled error on the
	                        // backend will fail to set the proper CORS header, and thus will be
	                        // treated as a network error by fetch.
	                        return [2 /*return*/, {
	                                status: 0,
	                                json: null
	                            }];
	                    case 4:
	                        json = null;
	                        _a.label = 5;
	                    case 5:
	                        _a.trys.push([5, 7, , 8]);
	                        return [4 /*yield*/, response.json()];
	                    case 6:
	                        json = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 7:
	                        e_2 = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 8: return [2 /*return*/, {
	                            status: response.status,
	                            json: json
	                        }];
	                }
	            });
	        });
	    };
	    /**
	     * Calls a callable function asynchronously and returns the result.
	     * @param name The name of the callable trigger.
	     * @param data The data to pass as params to the function.s
	     */
	    Service.prototype.call = function (name, data) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var url, body, headers, context, response, error, responseData, decodedData;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = this._url(name);
	                        // Encode any special types, such as dates, in the input data.
	                        data = this.serializer.encode(data);
	                        body = { data: data };
	                        headers = new Headers();
	                        return [4 /*yield*/, this.contextProvider.getContext()];
	                    case 1:
	                        context = _a.sent();
	                        if (context.authToken) {
	                            headers.append('Authorization', 'Bearer ' + context.authToken);
	                        }
	                        if (context.instanceIdToken) {
	                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
	                        }
	                        return [4 /*yield*/, this.postJSON(url, body, headers)];
	                    case 2:
	                        response = _a.sent();
	                        error = _errorForResponse(response.status, response.json, this.serializer);
	                        if (error) {
	                            throw error;
	                        }
	                        if (!response.json) {
	                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
	                        }
	                        responseData = response.json.data;
	                        // TODO(klimt): For right now, allow "result" instead of "data", for
	                        // backwards compatibility.
	                        if (typeof responseData === 'undefined') {
	                            responseData = response.json.result;
	                        }
	                        if (typeof responseData === 'undefined') {
	                            // Consider the response malformed.
	                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
	                        }
	                        decodedData = this.serializer.decode(responseData);
	                        return [2 /*return*/, { data: decodedData }];
	                }
	            });
	        });
	    };
	    return Service;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Functions.
	 */
	var FUNCTIONS_TYPE = 'functions';
	function factory(app, unused, region) {
	    return new Service(app, region);
	}
	function registerFunctions(instance) {
	    var namespaceExports = {
	        // no-inline
	        Functions: Service
	    };
	    instance.INTERNAL.registerService(FUNCTIONS_TYPE, factory, namespaceExports, 
	    // We don't need to wait on any AppHooks.
	    undefined, 
	    // Allow multiple functions instances per app.
	    true);
	}
	registerFunctions(firebase);
	
	exports.registerFunctions = registerFunctions;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var util = __webpack_require__(30);
	var tslib_1 = __webpack_require__(20);
	var firebase = _interopDefault(__webpack_require__(13));
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ERROR_CODES = {
	    AVAILABLE_IN_WINDOW: 'only-available-in-window',
	    AVAILABLE_IN_SW: 'only-available-in-sw',
	    SHOULD_BE_INHERITED: 'should-be-overriden',
	    BAD_SENDER_ID: 'bad-sender-id',
	    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
	    PERMISSION_DEFAULT: 'permission-default',
	    PERMISSION_BLOCKED: 'permission-blocked',
	    UNSUPPORTED_BROWSER: 'unsupported-browser',
	    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
	    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
	    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
	    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
	    INVALID_SAVED_TOKEN: 'invalid-saved-token',
	    SW_REG_REDUNDANT: 'sw-reg-redundant',
	    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
	    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
	    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
	    TOKEN_UNSUBSCRIBE_FAILED: 'token-unsubscribe-failed',
	    TOKEN_UPDATE_FAILED: 'token-update-failed',
	    TOKEN_UPDATE_NO_TOKEN: 'token-update-no-token',
	    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
	    INVALID_DELETE_TOKEN: 'invalid-delete-token',
	    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
	    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
	    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
	    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
	    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
	    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
	    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
	    NO_SW_IN_REG: 'no-sw-in-reg',
	    BAD_SCOPE: 'bad-scope',
	    BAD_VAPID_KEY: 'bad-vapid-key',
	    BAD_SUBSCRIPTION: 'bad-subscription',
	    BAD_TOKEN: 'bad-token',
	    BAD_PUSH_SET: 'bad-push-set',
	    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key',
	    INVALID_PUBLIC_VAPID_KEY: 'invalid-public-vapid-key',
	    USE_PUBLIC_KEY_BEFORE_GET_TOKEN: 'use-public-key-before-get-token',
	    PUBLIC_KEY_DECRYPTION_FAILED: 'public-vapid-key-decryption-failed'
	};
	var ERROR_MAP = (_a = {}, _a[ERROR_CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.', _a[ERROR_CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.', _a[ERROR_CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.', _a[ERROR_CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
	        'correctly in the options passed into firebase.initializeApp().', _a[ERROR_CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.', _a[ERROR_CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.', _a[ERROR_CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
	        'required to use the firebase SDK.', _a[ERROR_CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.', _a[ERROR_CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
	        'default service worker. {$browserErrorMessage}', _a[ERROR_CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.', _a[ERROR_CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
	        'any existing Push Subscriptions.', _a[ERROR_CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.', _a[ERROR_CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.', _a[ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED] = 'A problem occured while unsubscribing the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_FAILED] = 'A problem occured while updating the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_NO_TOKEN] = 'FCM returned no token when updating ' + 'the user to push.', _a[ERROR_CODES.USE_SW_BEFORE_GET_TOKEN] = 'The useServiceWorker() method may only be called once and must be ' +
	        'called before calling getToken() to ensure your service worker is used.', _a[ERROR_CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
	        'deleteToken(), i.e. the token from getToken().', _a[ERROR_CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
	        'be performed as the token was not found.', _a[ERROR_CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
	        'scope could not be performed as the scope was not found.', _a[ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.', _a[ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.', _a[ERROR_CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
	        'the FCM token for push messaging. Will have to resubscribe the ' +
	        'user on next visit. {$message}', _a[ERROR_CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
	        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
	        'user on next visit.', _a[ERROR_CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.', _a[ERROR_CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
	        'successful, there was a problem accessing the service worker itself.', _a[ERROR_CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
	        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.", _a[ERROR_CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
	        'least one character.', _a[ERROR_CODES.BAD_VAPID_KEY] = 'The public VAPID key is not a Uint8Array with 65 bytes.', _a[ERROR_CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.', _a[ERROR_CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
	        'a valid token string.', _a[ERROR_CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
	        'not a valid push set string.', _a[ERROR_CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.', _a[ERROR_CODES.INVALID_PUBLIC_VAPID_KEY] = 'The public VAPID key must be a string.', _a[ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED] = 'The public VAPID key did not equal ' + '65 bytes when decrypted.', _a);
	var errorFactory = new util.ErrorFactory('messaging', 'Messaging', ERROR_MAP);
	var _a;
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
	    0x04,
	    0x33,
	    0x94,
	    0xf7,
	    0xdf,
	    0xa1,
	    0xeb,
	    0xb1,
	    0xdc,
	    0x03,
	    0xa2,
	    0x5e,
	    0x15,
	    0x71,
	    0xdb,
	    0x48,
	    0xd3,
	    0x2e,
	    0xed,
	    0xed,
	    0xb2,
	    0x34,
	    0xdb,
	    0xb7,
	    0x47,
	    0x3a,
	    0x0c,
	    0x8f,
	    0xc4,
	    0xcc,
	    0xe1,
	    0x6f,
	    0x3c,
	    0x8c,
	    0x84,
	    0xdf,
	    0xab,
	    0xb6,
	    0x66,
	    0x3e,
	    0xf2,
	    0x0c,
	    0xd4,
	    0x8b,
	    0xfe,
	    0xe3,
	    0xf9,
	    0x76,
	    0x2f,
	    0x14,
	    0x1c,
	    0x63,
	    0x08,
	    0x6a,
	    0x6f,
	    0x2d,
	    0xb1,
	    0x1a,
	    0x95,
	    0xb0,
	    0xce,
	    0x37,
	    0xc0,
	    0x9c,
	    0x6e
	]);
	var ENDPOINT = 'https://fcm.googleapis.com';
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MessageParameter;
	(function (MessageParameter) {
	    MessageParameter["TYPE_OF_MSG"] = "firebase-messaging-msg-type";
	    MessageParameter["DATA"] = "firebase-messaging-msg-data";
	})(MessageParameter || (MessageParameter = {}));
	var MessageType;
	(function (MessageType) {
	    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
	    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
	})(MessageType || (MessageType = {}));
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function isArrayBufferEqual(a, b) {
	    if (a == null || b == null) {
	        return false;
	    }
	    if (a === b) {
	        return true;
	    }
	    if (a.byteLength !== b.byteLength) {
	        return false;
	    }
	    var viewA = new DataView(a);
	    var viewB = new DataView(b);
	    for (var i = 0; i < a.byteLength; i++) {
	        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
	            return false;
	        }
	    }
	    return true;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function toBase64(arrayBuffer) {
	    var uint8Version = new Uint8Array(arrayBuffer);
	    return btoa(String.fromCharCode.apply(null, uint8Version));
	}
	function arrayBufferToBase64(arrayBuffer) {
	    var base64String = toBase64(arrayBuffer);
	    return base64String
	        .replace(/=/g, '')
	        .replace(/\+/g, '-')
	        .replace(/\//g, '_');
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var IidModel = /** @class */ (function () {
	    function IidModel() {
	    }
	    IidModel.prototype.getToken = function (senderId, subscription, publicVapidKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var p256dh, auth, fcmSubscribeBody, applicationPubKey, headers, subscribeOptions, responseData, response, err_1, message;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
	                        auth = arrayBufferToBase64(subscription.getKey('auth'));
	                        fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
	                            ("endpoint=" + subscription.endpoint + "&") +
	                            ("encryption_key=" + p256dh + "&") +
	                            ("encryption_auth=" + auth);
	                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
	                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
	                            fcmSubscribeBody += "&application_pub_key=" + applicationPubKey;
	                        }
	                        headers = new Headers();
	                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	                        subscribeOptions = {
	                            method: 'POST',
	                            headers: headers,
	                            body: fcmSubscribeBody
	                        };
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 5]);
	                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)];
	                    case 2:
	                        response = _a.sent();
	                        return [4 /*yield*/, response.json()];
	                    case 3:
	                        responseData = _a.sent();
	                        return [3 /*break*/, 5];
	                    case 4:
	                        err_1 = _a.sent();
	                        throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED);
	                    case 5:
	                        if (responseData.error) {
	                            message = responseData.error.message;
	                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED, {
	                                message: message
	                            });
	                        }
	                        if (!responseData.token) {
	                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN);
	                        }
	                        if (!responseData.pushSet) {
	                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET);
	                        }
	                        return [2 /*return*/, {
	                                token: responseData.token,
	                                pushSet: responseData.pushSet
	                            }];
	                }
	            });
	        });
	    };
	    /**
	     * Update the underlying token details for fcmToken.
	     */
	    IidModel.prototype.updateToken = function (senderId, fcmToken, fcmPushSet, subscription, publicVapidKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var p256dh, auth, fcmUpdateBody, applicationPubKey, headers, updateOptions, responseData, response, err_2, message;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
	                        auth = arrayBufferToBase64(subscription.getKey('auth'));
	                        fcmUpdateBody = "push_set=" + fcmPushSet + "&" +
	                            ("token=" + fcmToken + "&") +
	                            ("authorized_entity=" + senderId + "&") +
	                            ("endpoint=" + subscription.endpoint + "&") +
	                            ("encryption_key=" + p256dh + "&") +
	                            ("encryption_auth=" + auth);
	                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
	                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
	                            fcmUpdateBody += "&application_pub_key=" + applicationPubKey;
	                        }
	                        headers = new Headers();
	                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	                        updateOptions = {
	                            method: 'POST',
	                            headers: headers,
	                            body: fcmUpdateBody
	                        };
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 5]);
	                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', updateOptions)];
	                    case 2:
	                        response = _a.sent();
	                        return [4 /*yield*/, response.json()];
	                    case 3:
	                        responseData = _a.sent();
	                        return [3 /*break*/, 5];
	                    case 4:
	                        err_2 = _a.sent();
	                        throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED);
	                    case 5:
	                        if (responseData.error) {
	                            message = responseData.error.message;
	                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED, {
	                                message: message
	                            });
	                        }
	                        if (!responseData.token) {
	                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_NO_TOKEN);
	                        }
	                        return [2 /*return*/, responseData.token];
	                }
	            });
	        });
	    };
	    /**
	     * Given a fcmToken, pushSet and messagingSenderId, delete an FCM token.
	     */
	    IidModel.prototype.deleteToken = function (senderId, fcmToken, fcmPushSet) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var fcmUnsubscribeBody, headers, unsubscribeOptions, response, responseData, message, err_3;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        fcmUnsubscribeBody = "authorized_entity=" + senderId + "&" +
	                            ("token=" + fcmToken + "&") +
	                            ("pushSet=" + fcmPushSet);
	                        headers = new Headers();
	                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	                        unsubscribeOptions = {
	                            method: 'POST',
	                            headers: headers,
	                            body: fcmUnsubscribeBody
	                        };
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 5]);
	                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/unsubscribe', unsubscribeOptions)];
	                    case 2:
	                        response = _a.sent();
	                        return [4 /*yield*/, response.json()];
	                    case 3:
	                        responseData = _a.sent();
	                        if (responseData.error) {
	                            message = responseData.error.message;
	                            throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED, {
	                                message: message
	                            });
	                        }
	                        return [3 /*break*/, 5];
	                    case 4:
	                        err_3 = _a.sent();
	                        throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED);
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return IidModel;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function base64ToArrayBuffer(base64String) {
	    var padding = '='.repeat((4 - base64String.length % 4) % 4);
	    var base64 = (base64String + padding)
	        .replace(/\-/g, '+')
	        .replace(/_/g, '/');
	    var rawData = atob(base64);
	    var outputArray = new Uint8Array(rawData.length);
	    for (var i = 0; i < rawData.length; ++i) {
	        outputArray[i] = rawData.charCodeAt(i);
	    }
	    return outputArray;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var OLD_DB_NAME = 'undefined';
	var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
	function handleDb(db) {
	    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
	        // We found a database with the name 'undefined', but our expected object
	        // store isn't defined.
	        return;
	    }
	    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
	    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
	    var iidModel = new IidModel();
	    var openCursorRequest = objectStore.openCursor();
	    openCursorRequest.onerror = function (event) {
	        // NOOP - Nothing we can do.
	        console.warn('Unable to cleanup old IDB.', event);
	    };
	    openCursorRequest.onsuccess = function () {
	        var cursor = openCursorRequest.result;
	        if (cursor) {
	            // cursor.value contains the current record being iterated through
	            // this is where you'd do something with the result
	            var tokenDetails = cursor.value;
	            iidModel.deleteToken(tokenDetails.fcmSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet);
	            cursor.continue();
	        }
	        else {
	            db.close();
	            indexedDB.deleteDatabase(OLD_DB_NAME);
	        }
	    };
	}
	function cleanV1() {
	    var request = indexedDB.open(OLD_DB_NAME);
	    request.onerror = function (event) {
	        // NOOP - Nothing we can do.
	    };
	    request.onsuccess = function (event) {
	        var db = request.result;
	        handleDb(db);
	    };
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DbInterface = /** @class */ (function () {
	    function DbInterface() {
	        this.dbPromise = null;
	    }
	    /** Gets record(s) from the objectStore that match the given key. */
	    DbInterface.prototype.get = function (key) {
	        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
	    };
	    /** Gets record(s) from the objectStore that match the given index. */
	    DbInterface.prototype.getIndex = function (index, key) {
	        function runRequest(objectStore) {
	            var idbIndex = objectStore.index(index);
	            return idbIndex.get(key);
	        }
	        return this.createTransaction(runRequest);
	    };
	    /** Assigns or overwrites the record for the given value. */
	    // tslint:disable-next-line:no-any IndexedDB values are of type "any"
	    DbInterface.prototype.put = function (value) {
	        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
	    };
	    /** Deletes record(s) from the objectStore that match the given key. */
	    DbInterface.prototype.delete = function (key) {
	        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
	    };
	    /**
	     * Close the currently open database.
	     */
	    DbInterface.prototype.closeDatabase = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var db;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.dbPromise) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.dbPromise];
	                    case 1:
	                        db = _a.sent();
	                        db.close();
	                        this.dbPromise = null;
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Creates an IndexedDB Transaction and passes its objectStore to the
	     * runRequest function, which runs the database request.
	     *
	     * @return Promise that resolves with the result of the runRequest function
	     */
	    DbInterface.prototype.createTransaction = function (runRequest, mode) {
	        if (mode === void 0) { mode = 'readonly'; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var db, transaction, request, result;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getDb()];
	                    case 1:
	                        db = _a.sent();
	                        transaction = db.transaction(this.objectStoreName, mode);
	                        request = transaction.objectStore(this.objectStoreName);
	                        return [4 /*yield*/, promisify(runRequest(request))];
	                    case 2:
	                        result = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                transaction.oncomplete = function () {
	                                    resolve(result);
	                                };
	                                transaction.onerror = function () {
	                                    reject(transaction.error);
	                                };
	                            })];
	                }
	            });
	        });
	    };
	    /** Gets the cached db connection or opens a new one. */
	    DbInterface.prototype.getDb = function () {
	        var _this = this;
	        if (!this.dbPromise) {
	            this.dbPromise = new Promise(function (resolve, reject) {
	                var request = indexedDB.open(_this.dbName, _this.dbVersion);
	                request.onsuccess = function () {
	                    resolve(request.result);
	                };
	                request.onerror = function () {
	                    _this.dbPromise = null;
	                    reject(request.error);
	                };
	                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
	            });
	        }
	        return this.dbPromise;
	    };
	    return DbInterface;
	}());
	/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
	function promisify(request) {
	    return new Promise(function (resolve, reject) {
	        request.onsuccess = function () {
	            resolve(request.result);
	        };
	        request.onerror = function () {
	            reject(request.error);
	        };
	    });
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TokenDetailsModel = /** @class */ (function (_super) {
	    tslib_1.__extends(TokenDetailsModel, _super);
	    function TokenDetailsModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dbName = 'fcm_token_details_db';
	        _this.dbVersion = 3;
	        _this.objectStoreName = 'fcm_token_object_Store';
	        return _this;
	    }
	    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
	        var db = request.result;
	        // Lack of 'break' statements is intentional.
	        switch (event.oldVersion) {
	            case 0: {
	                // New IDB instance
	                var objectStore = db.createObjectStore(this.objectStoreName, {
	                    keyPath: 'swScope'
	                });
	                // Make sure the sender ID can be searched
	                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
	                    unique: false
	                });
	                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
	            }
	            case 1: {
	                // Prior to version 2, we were using either 'fcm_token_details_db'
	                // or 'undefined' as the database name due to bug in the SDK
	                // So remove the old tokens and databases.
	                cleanV1();
	            }
	            case 2: {
	                var objectStore = request.transaction.objectStore(this.objectStoreName);
	                var cursorRequest_1 = objectStore.openCursor();
	                cursorRequest_1.onsuccess = function () {
	                    var cursor = cursorRequest_1.result;
	                    if (cursor) {
	                        var value = cursor.value;
	                        var newValue = tslib_1.__assign({}, value);
	                        if (!value.createTime) {
	                            newValue.createTime = Date.now();
	                        }
	                        if (typeof value.vapidKey === 'string') {
	                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
	                        }
	                        if (typeof value.auth === 'string') {
	                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
	                        }
	                        if (typeof value.auth === 'string') {
	                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
	                        }
	                        cursor.update(newValue);
	                        cursor.continue();
	                    }
	                };
	            }
	        }
	    };
	    /**
	     * Given a token, this method will look up the details in indexedDB.
	     */
	    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (!fcmToken) {
	                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
	                }
	                validateInputs({ fcmToken: fcmToken });
	                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
	            });
	        });
	    };
	    /**
	     * Given a service worker scope, this method will look up the details in
	     * indexedDB.
	     * @return The details associated with that token.
	     */
	    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (!swScope) {
	                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
	                }
	                validateInputs({ swScope: swScope });
	                return [2 /*return*/, this.get(swScope)];
	            });
	        });
	    };
	    /**
	     * Save the details for the fcm token for re-use at a later date.
	     * @param input A plain js object containing args to save.
	     */
	    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (!tokenDetails.swScope) {
	                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
	                }
	                if (!tokenDetails.vapidKey) {
	                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
	                }
	                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
	                    throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
	                }
	                if (!tokenDetails.fcmSenderId) {
	                    throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
	                }
	                if (!tokenDetails.fcmToken) {
	                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
	                }
	                if (!tokenDetails.fcmPushSet) {
	                    throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
	                }
	                validateInputs(tokenDetails);
	                return [2 /*return*/, this.put(tokenDetails)];
	            });
	        });
	    };
	    /**
	     * This method deletes details of the current FCM token.
	     * It's returning a promise in case we need to move to an async
	     * method for deleting at a later date.
	     *
	     * @return Resolves once the FCM token details have been deleted and returns
	     * the deleted details.
	     */
	    TokenDetailsModel.prototype.deleteToken = function (token) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var details;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (typeof token !== 'string' || token.length === 0) {
	                            return [2 /*return*/, Promise.reject(errorFactory.create(ERROR_CODES.INVALID_DELETE_TOKEN))];
	                        }
	                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
	                    case 1:
	                        details = _a.sent();
	                        if (!details) {
	                            throw errorFactory.create(ERROR_CODES.DELETE_TOKEN_NOT_FOUND);
	                        }
	                        return [4 /*yield*/, this.delete(details.swScope)];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/, details];
	                }
	            });
	        });
	    };
	    return TokenDetailsModel;
	}(DbInterface));
	/**
	 * This method takes an object and will check for known arguments and
	 * validate the input.
	 * @return Promise that resolves if input is valid, rejects otherwise.
	 */
	function validateInputs(input) {
	    if (input.fcmToken) {
	        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
	            throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
	        }
	    }
	    if (input.swScope) {
	        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
	            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
	        }
	    }
	    if (input.vapidKey) {
	        if (!(input.vapidKey instanceof Uint8Array) ||
	            input.vapidKey.length !== 65) {
	            throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
	        }
	    }
	    if (input.endpoint) {
	        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
	            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
	        }
	    }
	    if (input.auth) {
	        if (!(input.auth instanceof ArrayBuffer)) {
	            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
	        }
	    }
	    if (input.p256dh) {
	        if (!(input.p256dh instanceof ArrayBuffer)) {
	            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
	        }
	    }
	    if (input.fcmSenderId) {
	        if (typeof input.fcmSenderId !== 'string' ||
	            input.fcmSenderId.length === 0) {
	            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
	        }
	    }
	    if (input.fcmPushSet) {
	        if (typeof input.fcmPushSet !== 'string' || input.fcmPushSet.length === 0) {
	            throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
	        }
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
	var VapidDetailsModel = /** @class */ (function (_super) {
	    tslib_1.__extends(VapidDetailsModel, _super);
	    function VapidDetailsModel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.dbName = 'fcm_vapid_details_db';
	        _this.dbVersion = 1;
	        _this.objectStoreName = 'fcm_vapid_object_Store';
	        return _this;
	    }
	    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
	        var db = request.result;
	        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
	    };
	    /**
	     * Given a service worker scope, this method will look up the vapid key
	     * in indexedDB.
	     */
	    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var result;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (typeof swScope !== 'string' || swScope.length === 0) {
	                            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
	                        }
	                        return [4 /*yield*/, this.get(swScope)];
	                    case 1:
	                        result = _a.sent();
	                        return [2 /*return*/, result ? result.vapidKey : undefined];
	                }
	            });
	        });
	    };
	    /**
	     * Save a vapid key against a swScope for later date.
	     */
	    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var details;
	            return tslib_1.__generator(this, function (_a) {
	                if (typeof swScope !== 'string' || swScope.length === 0) {
	                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
	                }
	                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
	                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
	                }
	                details = {
	                    swScope: swScope,
	                    vapidKey: vapidKey
	                };
	                return [2 /*return*/, this.put(details)];
	            });
	        });
	    };
	    /**
	     * This method deletes details of the current FCM VAPID key for a SW scope.
	     * Resolves once the scope/vapid details have been deleted and returns the
	     * deleted vapid key.
	     */
	    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var vapidKey;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
	                    case 1:
	                        vapidKey = _a.sent();
	                        if (!vapidKey) {
	                            throw errorFactory.create(ERROR_CODES.DELETE_SCOPE_NOT_FOUND);
	                        }
	                        return [4 /*yield*/, this.delete(swScope)];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/, vapidKey];
	                }
	            });
	        });
	    };
	    return VapidDetailsModel;
	}(DbInterface));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SENDER_ID_OPTION_NAME = 'messagingSenderId';
	// Database cache should be invalidated once a week.
	var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
	var BaseController = /** @class */ (function () {
	    /**
	     * An interface of the Messaging Service API
	     */
	    function BaseController(app) {
	        var _this = this;
	        if (!app.options[SENDER_ID_OPTION_NAME] ||
	            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
	            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
	        }
	        this.messagingSenderId = app.options[SENDER_ID_OPTION_NAME];
	        this.tokenDetailsModel = new TokenDetailsModel();
	        this.vapidDetailsModel = new VapidDetailsModel();
	        this.iidModel = new IidModel();
	        this.app = app;
	        this.INTERNAL = {
	            delete: function () { return _this.delete(); }
	        };
	    }
	    /**
	     * @export
	     */
	    BaseController.prototype.getToken = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        currentPermission = this.getNotificationPermission_();
	                        if (currentPermission === 'denied') {
	                            throw errorFactory.create(ERROR_CODES.NOTIFICATIONS_BLOCKED);
	                        }
	                        else if (currentPermission !== 'granted') {
	                            // We must wait for permission to be granted
	                            return [2 /*return*/, null];
	                        }
	                        return [4 /*yield*/, this.getSWRegistration_()];
	                    case 1:
	                        swReg = _a.sent();
	                        return [4 /*yield*/, this.getPublicVapidKey_()];
	                    case 2:
	                        publicVapidKey = _a.sent();
	                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
	                    case 3:
	                        pushSubscription = _a.sent();
	                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
	                    case 4:
	                        tokenDetails = _a.sent();
	                        if (tokenDetails) {
	                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
	                        }
	                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
	                }
	            });
	        });
	    };
	    /**
	     * manageExistingToken is triggered if there's an existing FCM token in the
	     * database and it can take 3 different actions:
	     * 1) Retrieve the existing FCM token from the database.
	     * 2) If VAPID details have changed: Delete the existing token and create a
	     * new one with the new VAPID key.
	     * 3) If the database cache is invalidated: Send a request to FCM to update
	     * the token, and to check if the token is still valid on FCM-side.
	     */
	    BaseController.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var isTokenValid, now;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
	                        if (isTokenValid) {
	                            now = Date.now();
	                            if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
	                                return [2 /*return*/, tokenDetails.fcmToken];
	                            }
	                            else {
	                                return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
	                            }
	                        }
	                        // If the token is no longer valid (for example if the VAPID details
	                        // have changed), delete the existing token from the FCM client and server
	                        // database. No need to unsubscribe from the Service Worker as we have a
	                        // good push subscription that we'd like to use in getNewToken.
	                        return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
	                    case 1:
	                        // If the token is no longer valid (for example if the VAPID details
	                        // have changed), delete the existing token from the FCM client and server
	                        // database. No need to unsubscribe from the Service Worker as we have a
	                        // good push subscription that we'd like to use in getNewToken.
	                        _a.sent();
	                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
	                }
	            });
	        });
	    };
	    BaseController.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var updatedToken, allDetails, e_1;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 4, , 6]);
	                        return [4 /*yield*/, this.iidModel.updateToken(this.messagingSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet, pushSubscription, publicVapidKey)];
	                    case 1:
	                        updatedToken = _a.sent();
	                        allDetails = {
	                            swScope: swReg.scope,
	                            vapidKey: publicVapidKey,
	                            fcmSenderId: this.messagingSenderId,
	                            fcmToken: updatedToken,
	                            fcmPushSet: tokenDetails.fcmPushSet,
	                            createTime: Date.now(),
	                            endpoint: pushSubscription.endpoint,
	                            auth: pushSubscription.getKey('auth'),
	                            p256dh: pushSubscription.getKey('p256dh')
	                        };
	                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
	                    case 3:
	                        _a.sent();
	                        return [2 /*return*/, updatedToken];
	                    case 4:
	                        e_1 = _a.sent();
	                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
	                    case 5:
	                        _a.sent();
	                        throw e_1;
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    BaseController.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var tokenDetails, allDetails;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.iidModel.getToken(this.messagingSenderId, pushSubscription, publicVapidKey)];
	                    case 1:
	                        tokenDetails = _a.sent();
	                        allDetails = {
	                            swScope: swReg.scope,
	                            vapidKey: publicVapidKey,
	                            fcmSenderId: this.messagingSenderId,
	                            fcmToken: tokenDetails.token,
	                            fcmPushSet: tokenDetails.pushSet,
	                            createTime: Date.now(),
	                            endpoint: pushSubscription.endpoint,
	                            auth: pushSubscription.getKey('auth'),
	                            p256dh: pushSubscription.getKey('p256dh')
	                        };
	                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
	                    case 3:
	                        _a.sent();
	                        return [2 /*return*/, tokenDetails.token];
	                }
	            });
	        });
	    };
	    /**
	     * This method deletes tokens that the token manager looks after,
	     * unsubscribes the token from FCM  and then unregisters the push
	     * subscription if it exists. It returns a promise that indicates
	     * whether or not the unsubscribe request was processed successfully.
	     */
	    BaseController.prototype.deleteToken = function (token) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var registration, pushSubscription;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: 
	                    // Delete the token details from the database.
	                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
	                    case 1:
	                        // Delete the token details from the database.
	                        _a.sent();
	                        return [4 /*yield*/, this.getSWRegistration_()];
	                    case 2:
	                        registration = _a.sent();
	                        if (!registration) return [3 /*break*/, 4];
	                        return [4 /*yield*/, registration.pushManager.getSubscription()];
	                    case 3:
	                        pushSubscription = _a.sent();
	                        if (pushSubscription) {
	                            return [2 /*return*/, pushSubscription.unsubscribe()];
	                        }
	                        _a.label = 4;
	                    case 4: 
	                    // If there's no SW, consider it a success.
	                    return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    /**
	     * This method will delete the token from the client database, and make a
	     * call to FCM to remove it from the server DB. Does not temper with the
	     * push subscription.
	     */
	    BaseController.prototype.deleteTokenFromDB = function (token) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var details;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
	                    case 1:
	                        details = _a.sent();
	                        return [4 /*yield*/, this.iidModel.deleteToken(details.fcmSenderId, details.fcmToken, details.fcmPushSet)];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Gets a PushSubscription for the current user.
	     */
	    BaseController.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
	        return swRegistration.pushManager.getSubscription().then(function (subscription) {
	            if (subscription) {
	                return subscription;
	            }
	            return swRegistration.pushManager.subscribe({
	                userVisibleOnly: true,
	                applicationServerKey: publicVapidKey
	            });
	        });
	    };
	    //
	    // The following methods should only be available in the window.
	    //
	    BaseController.prototype.requestPermission = function () {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
	    };
	    BaseController.prototype.useServiceWorker = function (registration) {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
	    };
	    BaseController.prototype.usePublicVapidKey = function (b64PublicKey) {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
	    };
	    BaseController.prototype.onMessage = function (nextOrObserver, error, completed) {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
	    };
	    BaseController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
	    };
	    //
	    // The following methods are used by the service worker only.
	    //
	    BaseController.prototype.setBackgroundMessageHandler = function (callback) {
	        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_SW);
	    };
	    //
	    // The following methods are used by the service themselves and not exposed
	    // publicly or not expected to be used by developers.
	    //
	    /**
	     * This method is required to adhere to the Firebase interface.
	     * It closes any currently open indexdb database connections.
	     */
	    BaseController.prototype.delete = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this.tokenDetailsModel.closeDatabase(),
	                            this.vapidDetailsModel.closeDatabase()
	                        ])];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Returns the current Notification Permission state.
	     */
	    BaseController.prototype.getNotificationPermission_ = function () {
	        // TODO: Remove the cast when this issue is fixed:
	        // https://github.com/Microsoft/TypeScript/issues/14701
	        // tslint:disable-next-line no-any
	        return Notification.permission;
	    };
	    BaseController.prototype.getTokenDetailsModel = function () {
	        return this.tokenDetailsModel;
	    };
	    BaseController.prototype.getVapidDetailsModel = function () {
	        return this.vapidDetailsModel;
	    };
	    // Visible for testing
	    // TODO: make protected
	    BaseController.prototype.getIidModel = function () {
	        return this.iidModel;
	    };
	    return BaseController;
	}());
	/**
	 * Checks if the tokenDetails match the details provided in the clients.
	 */
	function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
	    if (!tokenDetails.vapidKey ||
	        !isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
	        return false;
	    }
	    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
	    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
	    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
	    return isEndpointEqual && isAuthEqual && isP256dhEqual;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FCM_MSG = 'FCM_MSG';
	var SwController = /** @class */ (function (_super) {
	    tslib_1.__extends(SwController, _super);
	    function SwController(app) {
	        var _this = _super.call(this, app) || this;
	        _this.bgMessageHandler = null;
	        self.addEventListener('push', function (e) {
	            _this.onPush(e);
	        });
	        self.addEventListener('pushsubscriptionchange', function (e) {
	            _this.onSubChange(e);
	        });
	        self.addEventListener('notificationclick', function (e) {
	            _this.onNotificationClick(e);
	        });
	        return _this;
	    }
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.onPush = function (event) {
	        event.waitUntil(this.onPush_(event));
	    };
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.onSubChange = function (event) {
	        event.waitUntil(this.onSubChange_(event));
	    };
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.onNotificationClick = function (event) {
	        event.waitUntil(this.onNotificationClick_(event));
	    };
	    /**
	     * A handler for push events that shows notifications based on the content of
	     * the payload.
	     *
	     * The payload must be a JSON-encoded Object with a `notification` key. The
	     * value of the `notification` property will be used as the NotificationOptions
	     * object passed to showNotification. Additionally, the `title` property of the
	     * notification object will be used as the title.
	     *
	     * If there is no notification data in the payload then no notification will be
	     * shown.
	     */
	    SwController.prototype.onPush_ = function (event) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg, actions, maxActions;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!event.data) {
	                            return [2 /*return*/];
	                        }
	                        try {
	                            msgPayload = event.data.json();
	                        }
	                        catch (err) {
	                            // Not JSON so not an FCM message
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, this.hasVisibleClients_()];
	                    case 1:
	                        hasVisibleClients = _a.sent();
	                        if (hasVisibleClients) {
	                            // App in foreground. Send to page.
	                            return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
	                        }
	                        notificationDetails = this.getNotificationData_(msgPayload);
	                        if (!notificationDetails) return [3 /*break*/, 3];
	                        notificationTitle = notificationDetails.title || '';
	                        return [4 /*yield*/, this.getSWRegistration_()];
	                    case 2:
	                        reg = _a.sent();
	                        actions = notificationDetails.actions;
	                        maxActions = Notification.maxActions;
	                        // tslint:enable no-any
	                        if (actions && maxActions && actions.length > maxActions) {
	                            console.warn("This browser only supports " + maxActions + " actions." +
	                                "The remaining actions will not be displayed.");
	                        }
	                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
	                    case 3:
	                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
	                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
	                    case 4:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onSubChange_ = function (event) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, this.getSWRegistration_()];
	                    case 1:
	                        registration = _a.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        err_1 = _a.sent();
	                        throw errorFactory.create(ERROR_CODES.UNABLE_TO_RESUBSCRIBE, {
	                            message: err_1
	                        });
	                    case 3:
	                        _a.trys.push([3, 5, , 8]);
	                        return [4 /*yield*/, registration.pushManager.getSubscription()];
	                    case 4:
	                        _a.sent();
	                        return [3 /*break*/, 8];
	                    case 5:
	                        err_2 = _a.sent();
	                        tokenDetailsModel = this.getTokenDetailsModel();
	                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
	                    case 6:
	                        tokenDetails = _a.sent();
	                        if (!tokenDetails) {
	                            // This should rarely occure, but could if indexedDB
	                            // is corrupted or wiped
	                            throw err_2;
	                        }
	                        // Attempt to delete the token if we know it's bad
	                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
	                    case 7:
	                        // Attempt to delete the token if we know it's bad
	                        _a.sent();
	                        throw err_2;
	                    case 8: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onNotificationClick_ = function (event) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var msgPayload, clickAction, windowClient, internalMsg;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!event.notification ||
	                            !event.notification.data ||
	                            !event.notification.data[FCM_MSG]) {
	                            // Not an FCM notification, do nothing.
	                            return [2 /*return*/];
	                        }
	                        else if (event.action) {
	                            // User clicked on an action button.
	                            // This will allow devs to act on action button clicks by using a custom
	                            // onNotificationClick listener that they define.
	                            return [2 /*return*/];
	                        }
	                        // Prevent other listeners from receiving the event
	                        event.stopImmediatePropagation();
	                        event.notification.close();
	                        msgPayload = event.notification.data[FCM_MSG];
	                        if (!msgPayload.notification) {
	                            // Nothing to do.
	                            return [2 /*return*/];
	                        }
	                        clickAction = msgPayload.notification.click_action;
	                        if (!clickAction) {
	                            // Nothing to do.
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, this.getWindowClient_(clickAction)];
	                    case 1:
	                        windowClient = _a.sent();
	                        if (!!windowClient) return [3 /*break*/, 3];
	                        return [4 /*yield*/, self.clients.openWindow(clickAction)];
	                    case 2:
	                        // Unable to find window client so need to open one.
	                        windowClient = _a.sent();
	                        return [3 /*break*/, 5];
	                    case 3: return [4 /*yield*/, windowClient.focus()];
	                    case 4:
	                        windowClient = _a.sent();
	                        _a.label = 5;
	                    case 5:
	                        if (!windowClient) {
	                            // Window Client will not be returned if it's for a third party origin.
	                            return [2 /*return*/];
	                        }
	                        // Delete notification data from payload before sending to the page.
	                        delete msgPayload.notification;
	                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
	                        // Attempt to send a message to the client to handle the data
	                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
	                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
	                }
	            });
	        });
	    };
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.getNotificationData_ = function (msgPayload) {
	        if (!msgPayload) {
	            return;
	        }
	        if (typeof msgPayload.notification !== 'object') {
	            return;
	        }
	        var notificationInformation = tslib_1.__assign({}, msgPayload.notification);
	        // Put the message payload under FCM_MSG name so we can identify the
	        // notification as being an FCM notification vs a notification from
	        // somewhere else (i.e. normal web push or developer generated
	        // notification).
	        notificationInformation.data = tslib_1.__assign({}, msgPayload.notification.data, (_a = {}, _a[FCM_MSG] = msgPayload, _a));
	        return notificationInformation;
	        var _a;
	    };
	    /**
	     * Calling setBackgroundMessageHandler will opt in to some specific
	     * behaviours.
	     * 1.) If a notification doesn't need to be shown due to a window already
	     * being visible, then push messages will be sent to the page.
	     * 2.) If a notification needs to be shown, and the message contains no
	     * notification data this method will be called
	     * and the promise it returns will be passed to event.waitUntil.
	     * If you do not set this callback then all push messages will let and the
	     * developer can handle them in a their own 'push' event callback
	     *
	     * @param callback The callback to be called when a push message is received
	     * and a notification must be shown. The callback will be given the data from
	     * the push message.
	     */
	    SwController.prototype.setBackgroundMessageHandler = function (callback) {
	        if (!callback || typeof callback !== 'function') {
	            throw errorFactory.create(ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED);
	        }
	        this.bgMessageHandler = callback;
	    };
	    /**
	     * @param url The URL to look for when focusing a client.
	     * @return Returns an existing window client or a newly opened WindowClient.
	     */
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.getWindowClient_ = function (url) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        parsedURL = new URL(url, self.location.href).href;
	                        return [4 /*yield*/, getClientList()];
	                    case 1:
	                        clientList = _a.sent();
	                        suitableClient = null;
	                        for (i = 0; i < clientList.length; i++) {
	                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
	                                .href;
	                            if (parsedClientUrl === parsedURL) {
	                                suitableClient = clientList[i];
	                                break;
	                            }
	                        }
	                        return [2 /*return*/, suitableClient];
	                }
	            });
	        });
	    };
	    /**
	     * This message will attempt to send the message to a window client.
	     * @param client The WindowClient to send the message to.
	     * @param message The message to send to the client.
	     * @returns Returns a promise that resolves after sending the message. This
	     * does not guarantee that the message was successfully received.
	     */
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.attemptToMessageClient_ = function (client, message) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                // NOTE: This returns a promise in case this API is abstracted later on to
	                // do additional work
	                if (!client) {
	                    throw errorFactory.create(ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG);
	                }
	                client.postMessage(message);
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * @returns If there is currently a visible WindowClient, this method will
	     * resolve to true, otherwise false.
	     */
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.hasVisibleClients_ = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var clientList;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, getClientList()];
	                    case 1:
	                        clientList = _a.sent();
	                        return [2 /*return*/, clientList.some(function (client) { return client.visibilityState === 'visible'; })];
	                }
	            });
	        });
	    };
	    /**
	     * @param msgPayload The data from the push event that should be sent to all
	     * available pages.
	     * @returns Returns a promise that resolves once the message has been sent to
	     * all WindowClients.
	     */
	    // Visible for testing
	    // TODO: Make private
	    SwController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            var clientList, internalMsg;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, getClientList()];
	                    case 1:
	                        clientList = _a.sent();
	                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
	                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
	                                return _this.attemptToMessageClient_(client, internalMsg);
	                            }))];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * This will register the default service worker and return the registration.
	     * @return he service worker registration to be used for the push service.
	     */
	    SwController.prototype.getSWRegistration_ = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, self.registration];
	            });
	        });
	    };
	    /**
	     * This will return the default VAPID key or the uint8array version of the
	     * public VAPID key provided by the developer.
	     */
	    SwController.prototype.getPublicVapidKey_ = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var swReg, vapidKeyFromDatabase;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
	                    case 1:
	                        swReg = _a.sent();
	                        if (!swReg) {
	                            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
	                        }
	                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
	                    case 2:
	                        vapidKeyFromDatabase = _a.sent();
	                        if (vapidKeyFromDatabase == null) {
	                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
	                        }
	                        return [2 /*return*/, vapidKeyFromDatabase];
	                }
	            });
	        });
	    };
	    return SwController;
	}(BaseController));
	function getClientList() {
	    return self.clients.matchAll({
	        type: 'window',
	        includeUncontrolled: true
	        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
	    });
	}
	function createNewMsg(msgType, msgData) {
	    return _a = {}, _a[MessageParameter.TYPE_OF_MSG] = msgType, _a[MessageParameter.DATA] = msgData, _a;
	    var _a;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
	var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WindowController = /** @class */ (function (_super) {
	    tslib_1.__extends(WindowController, _super);
	    /**
	     * A service that provides a MessagingService instance.
	     */
	    function WindowController(app) {
	        var _this = _super.call(this, app) || this;
	        _this.registrationToUse = null;
	        _this.publicVapidKeyToUse = null;
	        _this.manifestCheckPromise = null;
	        _this.messageObserver = null;
	        // @ts-ignore: Unused variable error, this is not implemented yet.
	        _this.tokenRefreshObserver = null;
	        _this.onMessageInternal = util.createSubscribe(function (observer) {
	            _this.messageObserver = observer;
	        });
	        _this.onTokenRefreshInternal = util.createSubscribe(function (observer) {
	            _this.tokenRefreshObserver = observer;
	        });
	        _this.setupSWMessageListener_();
	        return _this;
	    }
	    /**
	     * This method returns an FCM token if it can be generated.
	     * The return promise will reject if the browser doesn't support
	     * FCM, if permission is denied for notifications or it's not
	     * possible to generate a token.
	     *
	     * @return Returns a promise that resolves to an FCM token or null if
	     * permission isn't granted.
	     */
	    WindowController.prototype.getToken = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.manifestCheckPromise) {
	                            this.manifestCheckPromise = manifestCheck();
	                        }
	                        return [4 /*yield*/, this.manifestCheckPromise];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/, _super.prototype.getToken.call(this)];
	                }
	            });
	        });
	    };
	    /**
	     * Request permission if it is not currently granted
	     *
	     * @return Resolves if the permission was granted, otherwise rejects
	     */
	    WindowController.prototype.requestPermission = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var permissionResult;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (this.getNotificationPermission_() === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, Notification.requestPermission()];
	                    case 1:
	                        permissionResult = _a.sent();
	                        if (permissionResult === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        else if (permissionResult === 'denied') {
	                            throw errorFactory.create(ERROR_CODES.PERMISSION_BLOCKED);
	                        }
	                        else {
	                            throw errorFactory.create(ERROR_CODES.PERMISSION_DEFAULT);
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * This method allows a developer to override the default service worker and
	     * instead use a custom service worker.
	     *
	     * @param registration The service worker registration that should be used to
	     * receive the push messages.
	     */
	    WindowController.prototype.useServiceWorker = function (registration) {
	        if (!(registration instanceof ServiceWorkerRegistration)) {
	            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
	        }
	        if (this.registrationToUse != null) {
	            throw errorFactory.create(ERROR_CODES.USE_SW_BEFORE_GET_TOKEN);
	        }
	        this.registrationToUse = registration;
	    };
	    /**
	     * This method allows a developer to override the default vapid key
	     * and instead use a custom VAPID public key.
	     *
	     * @param publicKey A URL safe base64 encoded string.
	     */
	    WindowController.prototype.usePublicVapidKey = function (publicKey) {
	        if (typeof publicKey !== 'string') {
	            throw errorFactory.create(ERROR_CODES.INVALID_PUBLIC_VAPID_KEY);
	        }
	        if (this.publicVapidKeyToUse != null) {
	            throw errorFactory.create(ERROR_CODES.USE_PUBLIC_KEY_BEFORE_GET_TOKEN);
	        }
	        var parsedKey = base64ToArrayBuffer(publicKey);
	        if (parsedKey.length !== 65) {
	            throw errorFactory.create(ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED);
	        }
	        this.publicVapidKeyToUse = parsedKey;
	    };
	    /**
	     * @export
	     * @param nextOrObserver An observer object or a function triggered on
	     * message.
	     * @param error A function triggered on message error.
	     * @param completed function triggered when the observer is removed.
	     * @return The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
	        if (typeof nextOrObserver === 'function') {
	            return this.onMessageInternal(nextOrObserver, error, completed);
	        }
	        else {
	            return this.onMessageInternal(nextOrObserver);
	        }
	    };
	    /**
	     * @param nextOrObserver An observer object or a function triggered on token
	     * refresh.
	     * @param error A function triggered on token refresh error.
	     * @param completed function triggered when the observer is removed.
	     * @return The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
	        if (typeof nextOrObserver === 'function') {
	            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
	        }
	        else {
	            return this.onTokenRefreshInternal(nextOrObserver);
	        }
	    };
	    /**
	     * Given a registration, wait for the service worker it relates to
	     * become activer
	     * @param registration Registration to wait for service worker to become active
	     * @return Wait for service worker registration to become active
	     */
	    // Visible for testing
	    // TODO: Make private
	    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
	        var serviceWorker = registration.installing || registration.waiting || registration.active;
	        return new Promise(function (resolve, reject) {
	            if (!serviceWorker) {
	                // This is a rare scenario but has occured in firefox
	                reject(errorFactory.create(ERROR_CODES.NO_SW_IN_REG));
	                return;
	            }
	            // Because the Promise function is called on next tick there is a
	            // small chance that the worker became active or redundant already.
	            if (serviceWorker.state === 'activated') {
	                resolve(registration);
	                return;
	            }
	            if (serviceWorker.state === 'redundant') {
	                reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
	                return;
	            }
	            var stateChangeListener = function () {
	                if (serviceWorker.state === 'activated') {
	                    resolve(registration);
	                }
	                else if (serviceWorker.state === 'redundant') {
	                    reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
	                }
	                else {
	                    // Return early and wait to next state change
	                    return;
	                }
	                serviceWorker.removeEventListener('statechange', stateChangeListener);
	            };
	            serviceWorker.addEventListener('statechange', stateChangeListener);
	        });
	    };
	    /**
	     * This will register the default service worker and return the registration
	     * @return The service worker registration to be used for the push service.
	     */
	    WindowController.prototype.getSWRegistration_ = function () {
	        var _this = this;
	        if (this.registrationToUse) {
	            return this.waitForRegistrationToActivate_(this.registrationToUse);
	        }
	        // Make the registration null so we know useServiceWorker will not
	        // use a new service worker as registrationToUse is no longer undefined
	        this.registrationToUse = null;
	        return navigator.serviceWorker
	            .register(DEFAULT_SW_PATH, {
	            scope: DEFAULT_SW_SCOPE
	        })
	            .catch(function (err) {
	            throw errorFactory.create(ERROR_CODES.FAILED_DEFAULT_REGISTRATION, {
	                browserErrorMessage: err.message
	            });
	        })
	            .then(function (registration) {
	            return _this.waitForRegistrationToActivate_(registration).then(function () {
	                _this.registrationToUse = registration;
	                // We update after activation due to an issue with Firefox v49 where
	                // a race condition occassionally causes the service work to not
	                // install
	                registration.update();
	                return registration;
	            });
	        });
	    };
	    /**
	     * This will return the default VAPID key or the uint8array version of the public VAPID key
	     * provided by the developer.
	     */
	    WindowController.prototype.getPublicVapidKey_ = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                if (this.publicVapidKeyToUse) {
	                    return [2 /*return*/, this.publicVapidKeyToUse];
	                }
	                return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
	            });
	        });
	    };
	    /**
	     * This method will set up a message listener to handle
	     * events from the service worker that should trigger
	     * events in the page.
	     */
	    // Visible for testing
	    // TODO: Make private
	    WindowController.prototype.setupSWMessageListener_ = function () {
	        var _this = this;
	        navigator.serviceWorker.addEventListener('message', function (event) {
	            if (!event.data || !event.data[MessageParameter.TYPE_OF_MSG]) {
	                // Not a message from FCM
	                return;
	            }
	            var workerPageMessage = event.data;
	            switch (workerPageMessage[MessageParameter.TYPE_OF_MSG]) {
	                case MessageType.PUSH_MSG_RECEIVED:
	                case MessageType.NOTIFICATION_CLICKED:
	                    var pushMessage = workerPageMessage[MessageParameter.DATA];
	                    if (_this.messageObserver) {
	                        _this.messageObserver.next(pushMessage);
	                    }
	                    break;
	                default:
	                    // Noop.
	                    break;
	            }
	        }, false);
	    };
	    return WindowController;
	}(BaseController));
	/**
	 * The method checks that a manifest is defined and has the correct GCM
	 * sender ID.
	 * @return Returns a promise that resolves if the manifest matches
	 * our required sender ID
	 */
	// Exported for testing
	function manifestCheck() {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var manifestTag, manifestContent, response, e_1;
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    manifestTag = document.querySelector('link[rel="manifest"]');
	                    if (!manifestTag) {
	                        return [2 /*return*/];
	                    }
	                    _a.label = 1;
	                case 1:
	                    _a.trys.push([1, 4, , 5]);
	                    return [4 /*yield*/, fetch(manifestTag.href)];
	                case 2:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 3:
	                    manifestContent = _a.sent();
	                    return [3 /*break*/, 5];
	                case 4:
	                    e_1 = _a.sent();
	                    // If the download or parsing fails allow check.
	                    // We only want to error if we KNOW that the gcm_sender_id is incorrect.
	                    return [2 /*return*/];
	                case 5:
	                    if (!manifestContent || !manifestContent.gcm_sender_id) {
	                        return [2 /*return*/];
	                    }
	                    if (manifestContent.gcm_sender_id !== '103953800507') {
	                        throw errorFactory.create(ERROR_CODES.INCORRECT_GCM_SENDER_ID);
	                    }
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerMessaging(instance) {
	    var messagingName = 'messaging';
	    var factoryMethod = function (app) {
	        if (!isSupported()) {
	            throw errorFactory.create(ERROR_CODES.UNSUPPORTED_BROWSER);
	        }
	        if (self && 'ServiceWorkerGlobalScope' in self) {
	            // Running in ServiceWorker context
	            return new SwController(app);
	        }
	        else {
	            // Assume we are in the window context.
	            return new WindowController(app);
	        }
	    };
	    var namespaceExports = {
	        isSupported: isSupported
	    };
	    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
	}
	registerMessaging(firebase);
	function isSupported() {
	    if (self && 'ServiceWorkerGlobalScope' in self) {
	        // Running in ServiceWorker context
	        return isSWControllerSupported();
	    }
	    else {
	        // Assume we are in the window context.
	        return isWindowControllerSupported();
	    }
	}
	/**
	 * Checks to see if the required APIs exist.
	 */
	function isWindowControllerSupported() {
	    return ('serviceWorker' in navigator &&
	        'PushManager' in window &&
	        'Notification' in window &&
	        'fetch' in window &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	/**
	 * Checks to see if the required APIs exist within SW Context.
	 */
	function isSWControllerSupported() {
	    return ('PushManager' in self &&
	        'Notification' in self &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	
	exports.registerMessaging = registerMessaging;
	exports.isSupported = isSupported;


/***/ },
/* 144 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(13));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	/**
	 * Domain and scheme for API calls.
	 */
	var domainBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Domain and scheme for object downloads.
	 */
	var downloadBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Base URL for non-upload calls to the API.
	 */
	var apiBaseUrl = '/v0';
	/**
	 * Base URL for upload calls to the API.
	 */
	var apiUploadBaseUrl = '/v0';
	var configOption = 'storageBucket';
	/**
	 * 2 minutes
	 */
	var defaultMaxOperationRetryTime = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 */
	var defaultMaxUploadRetryTime = 10 * 60 * 100;
	/**
	 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
	 * enough for us to use it directly.
	 */
	var minSafeInteger = -9007199254740991;
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            return this.message_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	var Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(Code.UNKNOWN, message);
	}
	function objectNotFound(path) {
	    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
	}
	function unauthorized(path) {
	    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	function retryLimitExceeded() {
	    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	function canceled() {
	    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
	}
	function invalidUrl(url) {
	    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	function cannotSliceBlob() {
	    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	function serverFileWrongSize() {
	    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	function noDownloadURL() {
	    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	function appDeleted() {
	    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case StringFormat.RAW:
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	        case StringFormat.DATA_URL:
	            return;
	        default:
	            throw 'Expected one of the event types: [' +
	                StringFormat.RAW +
	                ', ' +
	                StringFormat.BASE64 +
	                ', ' +
	                StringFormat.BASE64URL +
	                ', ' +
	                StringFormat.DATA_URL +
	                '].';
	    }
	}
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, opt_contentType) {
	        this.data = data;
	        this.contentType = opt_contentType || null;
	    }
	    return StringData;
	}());
	function dataFromString(format, string) {
	    switch (format) {
	        case StringFormat.RAW:
	            return new StringData(utf8Bytes_(string));
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, string));
	        case StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
	    }
	    // assert(false);
	    throw unknown();
	}
	function utf8Bytes_(string) {
	    var b = [];
	    for (var i = 0; i < string.length; i++) {
	        var c = string.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) == 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < string.length - 1 &&
	                        (string.charCodeAt(i + 1) & 64512) == 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = string.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) == 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	function percentEncodedBytes_(string) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(string);
	    }
	    catch (e) {
	        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	function base64Bytes_(format, string) {
	    switch (format) {
	        case StringFormat.BASE64: {
	            var hasMinus = string.indexOf('-') !== -1;
	            var hasUnder = string.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case StringFormat.BASE64URL: {
	            var hasPlus = string.indexOf('+') !== -1;
	            var hasSlash = string.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            string = string.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	    }
	    var bytes;
	    try {
	        bytes = atob(string);
	    }
	    catch (e) {
	        throw invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(string) {
	    var parts = new DataURLParts(string);
	    if (parts.base64) {
	        return base64Bytes_(StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	function dataURLContentType_(string) {
	    var parts = new DataURLParts(string);
	    return parts.contentType;
	}
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	var InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	var TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case InternalTaskState.RUNNING:
	        case InternalTaskState.PAUSING:
	        case InternalTaskState.CANCELING:
	            return TaskState.RUNNING;
	        case InternalTaskState.PAUSED:
	            return TaskState.PAUSED;
	        case InternalTaskState.SUCCESS:
	            return TaskState.SUCCESS;
	        case InternalTaskState.CANCELED:
	            return TaskState.CANCELED;
	        case InternalTaskState.ERROR:
	            return TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return TaskState.ERROR;
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Contains methods for working with objects.
	 */
	function contains(obj, prop) {
	    return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	function forEach(obj, f) {
	    for (var key in obj) {
	        if (contains(obj, key)) {
	            f(key, obj[key]);
	        }
	    }
	}
	function clone(obj) {
	    if (obj == null) {
	        return {};
	    }
	    var c = {};
	    forEach(obj, function (key, val) {
	        c[key] = val;
	    });
	    return c;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Implements the promise abstraction interface for external
	 * (public SDK) packaging, which just passes through to the firebase-app impl.
	 */
	/**
	 * @template T
	 * @param {function((function(T): void),
	 *                  (function(!Error): void))} resolver
	 */
	function make(resolver) {
	    return new Promise(resolver);
	}
	/**
	 * @template T
	 */
	function resolve(value) {
	    return Promise.resolve(value);
	}
	function reject(error) {
	    return Promise.reject(error);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	function isJustDef(p) {
	    return p !== void 0;
	}
	function isFunction(p) {
	    return typeof p === 'function';
	}
	function isObject(p) {
	    return typeof p === 'object';
	}
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode || (ErrorCode = {}));
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = ErrorCode.NO_ERROR;
	        this.sendPromise_ = make(function (resolve$$1, reject$$1) {
	            _this.xhr_.addEventListener('abort', function (event) {
	                _this.errorCode_ = ErrorCode.ABORT;
	                resolve$$1(_this);
	            });
	            _this.xhr_.addEventListener('error', function (event) {
	                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
	                resolve$$1(_this);
	            });
	            _this.xhr_.addEventListener('load', function (event) {
	                resolve$$1(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
	        var _this = this;
	        if (this.sent_) {
	            throw internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (isDef(opt_headers)) {
	            var headers = opt_headers;
	            forEach(headers, function (key, val) {
	                _this.xhr_.setRequestHeader(key, val.toString());
	            });
	        }
	        if (isDef(opt_body)) {
	            this.xhr_.send(opt_body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var path = '(/([^?#]*).*)?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
	            version +
	            '/b/' +
	            bucketDomain +
	            '/o' +
	            path, 'i');
	        var httpIndices = { bucket: 1, path: 3 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length == 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) {
	        return component.length > 0;
	    })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function makeNormalUrl(urlPart) {
	    return domainBase + apiBaseUrl + urlPart;
	}
	function makeDownloadUrl(urlPart) {
	    return downloadBase + apiBaseUrl + urlPart;
	}
	function makeUploadUrl(urlPart) {
	    return domainBase + apiUploadBaseUrl + urlPart;
	}
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    forEach(params, function (key, val) {
	        var nextPart = encode(key) + '=' + encode(val);
	        queryPart = queryPart + nextPart + '&';
	    });
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function noXform_(metadata, value) {
	    return value;
	}
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, opt_local, opt_writable, opt_xform) {
	        this.server = server;
	        this.local = opt_local || server;
	        this.writable = !!opt_writable;
	        this.xform = opt_xform || noXform_;
	    }
	    return Mapping;
	}());
	var mappings_ = null;
	function xformPath(fullPath) {
	    var valid = isString(fullPath);
	    if (!valid || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        fullPath = fullPath;
	        return lastComponent(fullPath);
	    }
	}
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(metadata, size) {
	        if (isDef(size)) {
	            return +size;
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    mappings_ = mappings;
	    return mappings_;
	}
	function addRef(metadata, authWrapper) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new Location(bucket, path);
	        return authWrapper.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	function fromResource(authWrapper, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, authWrapper);
	    return metadata;
	}
	function fromResourceString(authWrapper, resourceString, mappings) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(authWrapper, resource, mappings);
	}
	function downloadUrlFromResourceString(metadata, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    if (!isString(obj['downloadTokens'])) {
	        // This can happen if objects are uploaded through GCS and retrieved
	        // through list, so we don't want to throw an Error.
	        return null;
	    }
	    var tokens = obj['downloadTokens'];
	    if (tokens.length === 0) {
	        return null;
	    }
	    var encode = encodeURIComponent;
	    var tokensList = tokens.split(',');
	    var urls = tokensList.map(function (token) {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	        var base = makeDownloadUrl(urlPart);
	        var queryString = makeQueryString({
	            alt: 'media',
	            token: token
	        });
	        return base + queryString;
	    });
	    return urls[0];
	}
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	function metadataValidator(p) {
	    var validType = p && isObject(p);
	    if (!validType) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        var val = p[key];
	        if (key === 'customMetadata') {
	            if (!isObject(val)) {
	                throw 'Expected object for \'customMetadata\' mapping.';
	            }
	        }
	        else {
	            if (isNonNullObject(val)) {
	                throw "Mapping for '" + key + "' cannot be an object.";
	            }
	        }
	    }
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw invalidArgument(i, name, e.message);
	            }
	            else {
	                throw invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, opt_optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!opt_optional;
	    }
	    return ArgSpec;
	}());
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	function stringSpec(opt_validator, opt_optional) {
	    function stringValidator(p) {
	        if (!isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var validator;
	    if (opt_validator) {
	        validator = and_(stringValidator, opt_validator);
	    }
	    else {
	        validator = stringValidator;
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function metadataSpec(opt_optional) {
	    return new ArgSpec(metadataValidator, opt_optional);
	}
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function looseObjectSpec(opt_validator, opt_optional) {
	    function validator(p) {
	        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (opt_validator !== undefined && opt_validator !== null) {
	            opt_validator(p);
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	function nullFunctionSpec(opt_optional) {
	    function validator(p) {
	        var valid = p === null || isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param var_args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < var_args.length; i++) {
	            bb.append(var_args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (isNativeBlobDefined()) {
	            return new Blob(var_args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, opt_elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (opt_elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (opt_elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        if (isNativeBlobDefined()) {
	            var blobby = var_args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = var_args.map(function (val) {
	                if (isString(val)) {
	                    return dataFromString(StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns true if the object is contained in the array (compared with ===).
	 * @template T
	 */
	function contains$1(array, elem) {
	    return array.indexOf(elem) !== -1;
	}
	/**
	 * Returns a shallow copy of the array or array-like object (e.g. arguments).
	 * @template T
	 */
	function clone$1(arraylike) {
	    return Array.prototype.slice.call(arraylike);
	}
	/**
	 * Removes the given element from the given array, if it is contained.
	 * Directly modifies the passed-in array.
	 * @template T
	 */
	function remove(array, elem) {
	    var i = array.indexOf(elem);
	    if (i !== -1) {
	        array.splice(i, 1);
	    }
	}
	
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	    /**
	     * Returns the value with which to resolve the request's promise. Only called
	     * if the request is successful. Throw from this function to reject the
	     * returned Request's promise with the thrown error.
	     * Note: The XhrIo passed to this function may be reused after this callback
	     * returns. Do not keep a reference to it in any way.
	     */
	    handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw unknown();
	    }
	}
	function metadataHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	function downloadUrlHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return downloadUrlFromResourceString(metadata, text);
	    }
	    return handler;
	}
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function getMetadata(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeNormalUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function getDownloadUrl(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeNormalUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function updateMetadata(authWrapper, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeNormalUrl(urlPart);
	    var method = 'PATCH';
	    var body = toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function deleteObject(authWrapper, location) {
	    var urlPart = location.fullServerUrl();
	    var url = makeNormalUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = authWrapper.maxOperationRetryTime();
	    function handler(xhr, text) { }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	function metadataForUpload_(location, blob, opt_metadata) {
	    var metadata = clone(opt_metadata);
	    metadata['fullPath'] = location.path;
	    metadata['size'] = blob.size();
	    if (!metadata['contentType']) {
	        metadata['contentType'] = determineContentType_(null, blob);
	    }
	    return metadata;
	}
	function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str =
	                str +
	                    Math.random()
	                        .toString()
	                        .slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var metadataString = toResourceString(metadata, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    var urlParams = { name: metadata['fullPath'] };
	    var url = makeUploadUrl(urlPart);
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	function checkResumeHeader_(xhr, opt_allowed) {
	    var status;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowed = opt_allowed || ['active'];
	    handlerCheck(contains$1(allowed, status));
	    return status;
	}
	function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var urlParams = { name: metadata['fullPath'] };
	    var url = makeUploadUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = toResourceString(metadata, mappings);
	    var timeout = authWrapper.maxUploadRetryTime();
	    function handler(xhr, text) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(isString(url));
	        return url;
	    }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(authWrapper, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr, text) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        var size = parseInt(sizeString, 10);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	var resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param opt_status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status = new ResumableUploadStatus(0, 0);
	    if (opt_status) {
	        status.current = opt_status.current;
	        status.total = opt_status.total;
	    }
	    else {
	        status.current = 0;
	        status.total = blob.size();
	    }
	    if (blob.size() !== status.total) {
	        throw serverFileWrongSize();
	    }
	    var bytesLeft = status.total - status.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = opt_progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, opt_error, opt_complete) {
	        var asFunctions = isFunction(nextOrObserver) ||
	            isDef(opt_error) ||
	            isDef(opt_complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = opt_error || null;
	            this.complete = opt_complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    return UploadTaskSnapshot;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        resolve(true).then(function () {
	            f.apply(null, argsToForward);
	        });
	    };
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        var _this = this;
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.authWrapper_ = authWrapper;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = make(function (resolve$$1, reject$$1) {
	            _this.resolve_ = resolve$$1;
	            _this.reject_ = reject$$1;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded, total) {
	            _this.updateProgress_(sizeBefore + loaded);
	        };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        this.authWrapper_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case InternalTaskState.CANCELING:
	                    _this.transition_(InternalTaskState.CANCELED);
	                    break;
	                case InternalTaskState.PAUSING:
	                    _this.transition_(InternalTaskState.PAUSED);
	                    break;
	                default:
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case InternalTaskState.PAUSING:
	                this.transition_(InternalTaskState.PAUSED);
	                break;
	            case InternalTaskState.CANCELING:
	                this.transition_(InternalTaskState.CANCELED);
	                break;
	            case InternalTaskState.RUNNING:
	                this.start_();
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = taskStateFromInternalTaskState(this.state_);
	            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
	        if (error === void 0) { error = undefined; }
	        if (completed === void 0) { completed = undefined; }
	        function typeValidator(_p) {
	            if (type !== TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = nullFunctionSpec(true).validator;
	        var observerValidator = looseObjectSpec(null, true).validator;
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = isJustDef(p['next']) ||
	                    isJustDef(p['error']) ||
	                    isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            stringSpec(typeValidator),
	            looseObjectSpec(nextOrObserverValidator, true),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, opt_complete) {
	                if (specs !== null) {
	                    validate('on', specs, arguments);
	                }
	                var observer = new Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            looseObjectSpec(binderNextOrObserverValidator),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        var typeOnly = !(isJustDef(nextOrObserver) ||
	            isJustDef(error) ||
	            isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        remove(this.observers_, observer);
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = clone$1(this.observers_);
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (taskStateFromInternalTaskState(this.state_)) {
	                case TaskState.SUCCESS:
	                    async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case TaskState.CANCELED:
	                case TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case TaskState.RUNNING:
	            case TaskState.PAUSED:
	                if (observer.next !== null) {
	                    async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case TaskState.SUCCESS:
	                if (observer.complete !== null) {
	                    async(observer.complete.bind(observer))();
	                }
	                break;
	            case TaskState.CANCELED:
	            case TaskState.ERROR:
	                if (observer.error !== null) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error !== null) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        validate('resume', [], arguments);
	        var valid = this.state_ === InternalTaskState.PAUSED ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        validate('pause', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        validate('cancel', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(authWrapper, location) {
	        this.authWrapper = authWrapper;
	        if (location instanceof Location) {
	            this.location = location;
	        }
	        else {
	            this.location = Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (authWrapper, location) {
	        return new Reference(authWrapper, location);
	    };
	    Reference.prototype.mappings = function () {
	        return getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        validate('child', [stringSpec()], arguments);
	        var newPath = child(this.location.path, childPath);
	        var location = new Location(this.location.bucket, newPath);
	        return this.newRef(this.authWrapper, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new Location(this.location.bucket, newPath);
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new Location(this.location.bucket, '');
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return lastComponent(this.location.path);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.authWrapper.service();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param string The string to upload.
	     * @param opt_format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (string, format, opt_metadata) {
	        if (format === void 0) { format = StringFormat.RAW; }
	        validate('putString', [
	            stringSpec(),
	            stringSpec(formatValidator, true),
	            metadataSpec(true)
	        ], arguments);
	        this.throwIfRoot_('putString');
	        var data = dataFromString(format, string);
	        var metadata = clone(opt_metadata);
	        if (!isDef(metadata['contentType']) && isDef(data.contentType)) {
	            metadata['contentType'] = data.contentType;
	        }
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadata);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = deleteObject(self.authWrapper, self.location);
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getMetadata(self.authWrapper, self.location, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        validate('updateMetadata', [metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getDownloadUrl(self.authWrapper, self.location, self.mappings());
	            return self.authWrapper
	                .makeRequest(requestInfo, authToken)
	                .getPromise()
	                .then(function (url) {
	                if (url === null) {
	                    throw noDownloadURL();
	                }
	                return url;
	            });
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (appDelete) {
	        if (appDelete === void 0) { appDelete = false; }
	    };
	    return FailRequest;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var RequestMap = /** @class */ (function () {
	    function RequestMap() {
	        this.map_ = {};
	        this.id_ = minSafeInteger;
	    }
	    /**
	     * Registers the given request with this map.
	     * The request is unregistered when it completes.
	     * @param r The request to register.
	     */
	    RequestMap.prototype.addRequest = function (r) {
	        var id = this.id_;
	        this.id_++;
	        this.map_[id] = r;
	        var self = this;
	        function unmap() {
	            delete self.map_[id];
	        }
	        r.getPromise().then(unmap, unmap);
	    };
	    /**
	     * Cancels all registered requests.
	     */
	    RequestMap.prototype.clear = function () {
	        forEach(this.map_, function (key, val) {
	            if (val) {
	                val.cancel(true);
	            }
	        });
	        this.map_ = {};
	    };
	    return RequestMap;
	}());
	
	/**
	 * @param app If null, getAuthToken always resolves with null.
	 * @param service The storage service associated with this auth wrapper.
	 *     Untyped to avoid circular type dependencies.
	 * @struct
	 */
	var AuthWrapper = /** @class */ (function () {
	    function AuthWrapper(app, maker, requestMaker, service, pool) {
	        this.bucket_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        if (this.app_ !== null) {
	            var options = this.app_.options;
	            if (isDef(options)) {
	                this.bucket_ = AuthWrapper.extractBucket_(options);
	            }
	        }
	        this.storageRefMaker_ = maker;
	        this.requestMaker_ = requestMaker;
	        this.pool_ = pool;
	        this.service_ = service;
	        this.maxOperationRetryTime_ = defaultMaxOperationRetryTime;
	        this.maxUploadRetryTime_ = defaultMaxUploadRetryTime;
	        this.requestMap_ = new RequestMap();
	    }
	    AuthWrapper.extractBucket_ = function (config) {
	        var bucketString = config[configOption] || null;
	        if (bucketString == null) {
	            return null;
	        }
	        var loc = Location.makeFromBucketSpec(bucketString);
	        return loc.bucket;
	    };
	    AuthWrapper.prototype.getAuthToken = function () {
	        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
	        // (b/28673818).
	        if (this.app_ !== null &&
	            isDef(this.app_.INTERNAL) &&
	            isDef(this.app_.INTERNAL.getToken)) {
	            return this.app_.INTERNAL.getToken().then(function (response) {
	                if (response !== null) {
	                    return response.accessToken;
	                }
	                else {
	                    return null;
	                }
	            }, function (_error) {
	                return null;
	            });
	        }
	        else {
	            return resolve(null);
	        }
	    };
	    AuthWrapper.prototype.bucket = function () {
	        if (this.deleted_) {
	            throw appDeleted();
	        }
	        else {
	            return this.bucket_;
	        }
	    };
	    /**
	     * The service associated with this auth wrapper. Untyped to avoid circular
	     * type dependencies.
	     */
	    AuthWrapper.prototype.service = function () {
	        return this.service_;
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
	     * at the given Location.
	     * @param loc The Location.
	     * @return Actually a firebaseStorage.Reference, typing not allowed
	     *     because of circular dependency problems.
	     */
	    AuthWrapper.prototype.makeStorageReference = function (loc) {
	        return this.storageRefMaker_(this, loc);
	    };
	    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
	        if (!this.deleted_) {
	            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
	            this.requestMap_.addRequest(request);
	            return request;
	        }
	        else {
	            return new FailRequest(appDeleted());
	        }
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    AuthWrapper.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requestMap_.clear();
	    };
	    AuthWrapper.prototype.maxUploadRetryTime = function () {
	        return this.maxUploadRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
	        this.maxUploadRetryTime_ = time;
	    };
	    AuthWrapper.prototype.maxOperationRetryTime = function () {
	        return this.maxOperationRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
	        this.maxOperationRetryTime_ = time;
	    };
	    return AuthWrapper;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    function triggerCallback() {
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, arguments);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    function handler(success) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        var self = this;
	        this.promise_ = make(function (resolve$$1, reject$$1) {
	            self.resolve_ = resolve$$1;
	            self.reject_ = reject$$1;
	            self.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled$$1) {
	            if (canceled$$1) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = contains$1(self.successCodes_, status);
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve$$1 = self.resolve_;
	            var reject$$1 = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (isJustDef(result)) {
	                        resolve$$1(result);
	                    }
	                    else {
	                        resolve$$1();
	                    }
	                }
	                catch (e) {
	                    reject$$1(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject$$1(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject$$1(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_
	                            ? appDeleted()
	                            : canceled();
	                        reject$$1(err);
	                    }
	                    else {
	                        var err = retryLimitExceeded();
	                        reject$$1(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = contains$1(extraRetryCodes, status);
	        var isRequestSpecificRetryCode = contains$1(this.additionalRetryCodes_, status);
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!opt_canceled;
	    }
	    return RequestEndStatus;
	}());
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	function addVersionHeader_(headers) {
	    var number = typeof firebase !== 'undefined' ? firebase.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
	}
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, authToken, pool) {
	    var queryPart = makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = clone(requestInfo.headers);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var Service = /** @class */ (function () {
	    function Service(app, pool, url) {
	        this.bucket_ = null;
	        function maker(authWrapper, loc) {
	            return new Reference(authWrapper, loc);
	        }
	        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
	        this.app_ = app;
	        if (url != null) {
	            this.bucket_ = Location.makeFromBucketSpec(url);
	        }
	        else {
	            var authWrapperBucket = this.authWrapper_.bucket();
	            if (authWrapperBucket != null) {
	                this.bucket_ = new Location(authWrapperBucket, '');
	            }
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    Service.prototype.ref = function (path) {
	        function validator(path) {
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        validate('ref', [stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new Reference(this.authWrapper_, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    Service.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        validate('refFromURL', [stringSpec(validator, false)], arguments);
	        return new Reference(this.authWrapper_, url);
	    };
	    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxUploadRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxUploadRetryTime = function (time) {
	        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxUploadRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxOperationRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxOperationRetryTime = function (time) {
	        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxOperationRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Service.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Service;
	}());
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     * @see {!fbs.AuthWrapper.prototype.deleteApp}
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.authWrapper_.deleteApp();
	        return resolve(undefined);
	    };
	    return ServiceInternals;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(app, unused, opt_url) {
	    return new Service(app, new XhrIoPool(), opt_url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: TaskState,
	        TaskEvent: TaskEvent,
	        StringFormat: StringFormat,
	        Storage: Service,
	        Reference: Reference
	    };
	    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
	    // Allow multiple storage instances per app.
	    true);
	}
	registerStorage(firebase);
	
	exports.registerStorage = registerStorage;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var g,goog=goog||{},k=this;function l(a){return"string"==typeof a}function n(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b}function aa(){}
	function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function p(a){return"array"==ba(a)}function ca(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function da(a){return"function"==ba(a)}function ea(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var q="closure_uid_"+(1E9*Math.random()>>>0),fa=0;function ha(a,b,c){return a.call.apply(a.bind,arguments)}
	function ia(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ha:r=ia;return r.apply(null,arguments)}
	function ja(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var t=Date.now||function(){return+new Date};function u(a,b){function c(){}c.prototype=b.prototype;a.H=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Ib=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function ka(a){if(Error.captureStackTrace)Error.captureStackTrace(this,ka);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}u(ka,Error);ka.prototype.name="CustomError";function la(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");ka.call(this,c+a[d])}u(la,ka);la.prototype.name="AssertionError";function ma(a,b){throw new la("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function w(){0!=na&&(pa[this[q]||(this[q]=++fa)]=this);this.i=this.i;this.m=this.m}var na=0,pa={};w.prototype.i=!1;w.prototype.$=function(){if(!this.i&&(this.i=!0,this.w(),0!=na)){var a=this[q]||(this[q]=++fa);if(0!=na&&this.m&&0<this.m.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete pa[a]}};w.prototype.w=function(){if(this.m)for(;this.m.length;)this.m.shift()()};var qa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ra=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function sa(a){a:{var b=ta;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function ua(a){if(!p(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}function va(a){return Array.prototype.concat.apply([],arguments)}function wa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function xa(a){return/^[\s\xa0]*$/.test(a)}var ya=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function za(a,b){return a<b?-1:a>b?1:0};var x;a:{var Aa=k.navigator;if(Aa){var Ba=Aa.userAgent;if(Ba){x=Ba;break a}}x=""}function y(a){return-1!=x.indexOf(a)};function Ca(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function Da(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ea(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Fa(a){var b={},c;for(c in a)b[c]=a[c];return b}var Ga="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function Ha(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ga.length;f++)c=Ga[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Ia(a){Ia[" "](a);return a}Ia[" "]=aa;function Ja(a,b){var c=Ka;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var La=y("Opera"),z=y("Trident")||y("MSIE"),Ma=y("Edge"),Na=Ma||z,Oa=y("Gecko")&&!(-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),Pa=-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge");function Qa(){var a=k.document;return a?a.documentMode:void 0}var Ra;
	a:{var Sa="",Ta=function(){var a=x;if(Oa)return/rv:([^\);]+)(\)|;)/.exec(a);if(Ma)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Pa)return/WebKit\/(\S+)/.exec(a);if(La)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ta&&(Sa=Ta?Ta[1]:"");if(z){var Ua=Qa();if(null!=Ua&&Ua>parseFloat(Sa)){Ra=String(Ua);break a}}Ra=Sa}var Ka={};
	function Va(a){return Ja(a,function(){for(var b=0,c=ya(String(Ra)).split("."),d=ya(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=za(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||za(0==h[2].length,0==m[2].length)||za(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Wa;var Xa=k.document;
	Wa=Xa&&z?Qa()||("CSS1Compat"==Xa.compatMode?parseInt(Ra,10):5):void 0;var Ya=Object.freeze||function(a){return a};var Za=!z||9<=Number(Wa),$a=z&&!Va("9"),ab=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",aa,b);k.removeEventListener("test",aa,b);return a}();function A(a,b){this.type=a;this.a=this.target=b;this.Ra=!0}A.prototype.b=function(){this.Ra=!1};function bb(a,b){A.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(Oa){a:{try{Ia(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:cb[a.pointerType]||"";this.c=a;a.defaultPrevented&&this.b()}}u(bb,A);var cb=Ya({2:"touch",3:"pen",4:"mouse"});bb.prototype.b=function(){bb.H.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,$a)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var db="closure_listenable_"+(1E6*Math.random()|0),eb=0;function fb(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.ga=e;this.key=++eb;this.Z=this.ba=!1}function gb(a){a.Z=!0;a.listener=null;a.proxy=null;a.src=null;a.ga=null};function hb(a){this.src=a;this.a={};this.b=0}hb.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=ib(a,b,d,e);-1<h?(b=a[h],c||(b.ba=!1)):(b=new fb(b,this.src,f,!!d,e),b.ba=c,a.push(b));return b};function jb(a,b){var c=b.type;if(c in a.a){var d=a.a[c],e=qa(d,b),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(gb(b),0==a.a[c].length&&(delete a.a[c],a.b--))}}
	function ib(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.Z&&f.listener==b&&f.capture==!!c&&f.ga==d)return e}return-1};var kb="closure_lm_"+(1E6*Math.random()|0),lb={},mb=0;function nb(a,b,c,d,e){if(d&&d.once)return ob(a,b,c,d,e);if(p(b)){for(var f=0;f<b.length;f++)nb(a,b[f],c,d,e);return null}c=pb(c);return a&&a[db]?a.Ia(b,c,ea(d)?!!d.capture:!!d,e):qb(a,b,c,!1,d,e)}
	function qb(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=ea(e)?!!e.capture:!!e,m=rb(a);m||(a[kb]=m=new hb(a));c=m.add(b,c,d,h,f);if(c.proxy)return c;d=sb();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)ab||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(tb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");mb++;return c}
	function sb(){var a=ub,b=Za?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function ob(a,b,c,d,e){if(p(b)){for(var f=0;f<b.length;f++)ob(a,b[f],c,d,e);return null}c=pb(c);return a&&a[db]?a.Ja(b,c,ea(d)?!!d.capture:!!d,e):qb(a,b,c,!0,d,e)}
	function vb(a,b,c,d,e){if(p(b))for(var f=0;f<b.length;f++)vb(a,b[f],c,d,e);else(d=ea(d)?!!d.capture:!!d,c=pb(c),a&&a[db])?(a=a.f,b=String(b).toString(),b in a.a&&(f=a.a[b],c=ib(f,c,d,e),-1<c&&(gb(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=rb(a))&&(b=a.a[b.toString()],a=-1,b&&(a=ib(b,c,d,e)),(c=-1<a?b[a]:null)&&wb(c))}
	function wb(a){if("number"!=typeof a&&a&&!a.Z){var b=a.src;if(b&&b[db])jb(b.f,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(tb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);mb--;(c=rb(b))?(jb(c,a),0==c.b&&(c.src=null,b[kb]=null)):gb(a)}}}function tb(a){return a in lb?lb[a]:lb[a]="on"+a}
	function xb(a,b,c,d){var e=!0;if(a=rb(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.Z&&(f=yb(f,d),e=e&&!1!==f)}return e}function yb(a,b){var c=a.listener,d=a.ga||a.src;a.ba&&wb(a);return c.call(d,b)}
	function ub(a,b){if(a.Z)return!0;if(!Za){var c=b||n("window.event");b=new bb(c,this);var d=!0;if(!(0>c.keyCode||void 0!=c.returnValue)){a:{var e=!1;if(0==c.keyCode)try{c.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==c.returnValue)c.returnValue=!0}c=[];for(e=b.a;e;e=e.parentNode)c.push(e);a=a.type;for(e=c.length-1;0<=e;e--){b.a=c[e];var f=xb(c[e],a,!0,b);d=d&&f}for(e=0;e<c.length;e++)b.a=c[e],f=xb(c[e],a,!1,b),d=d&&f}return d}return yb(a,new bb(b,this))}
	function rb(a){a=a[kb];return a instanceof hb?a:null}var zb="__closure_events_fn_"+(1E9*Math.random()>>>0);function pb(a){if(da(a))return a;a[zb]||(a[zb]=function(b){return a.handleEvent(b)});return a[zb]};function B(){w.call(this);this.f=new hb(this);this.N=this;this.J=null}u(B,w);B.prototype[db]=!0;g=B.prototype;g.addEventListener=function(a,b,c,d){nb(this,a,b,c,d)};g.removeEventListener=function(a,b,c,d){vb(this,a,b,c,d)};
	g.dispatchEvent=function(a){var b,c=this.J;if(c)for(b=[];c;c=c.J)b.push(c);c=this.N;var d=a.type||a;if(l(a))a=new A(a,c);else if(a instanceof A)a.target=a.target||c;else{var e=a;a=new A(d,c);Ha(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.a=b[f];e=Ab(h,d,!0,a)&&e}h=a.a=c;e=Ab(h,d,!0,a)&&e;e=Ab(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.a=b[f],e=Ab(h,d,!1,a)&&e;return e};
	g.w=function(){B.H.w.call(this);if(this.f){var a=this.f,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,gb(d[e]);delete a.a[c];a.b--}}this.J=null};g.Ia=function(a,b,c,d){return this.f.add(String(a),b,!1,c,d)};g.Ja=function(a,b,c,d){return this.f.add(String(a),b,!0,c,d)};
	function Ab(a,b,c,d){b=a.f.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.Z&&h.capture==c){var m=h.listener,v=h.ga||h.src;h.ba&&jb(a.f,h);e=!1!==m.call(v,d)&&e}}return e&&0!=d.Ra};function Bb(a){return/^\s*$/.test(a)?!1:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,""))}function Cb(a){a=String(a);if(Bb(a))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function Db(a){var b=[];Eb(new Fb,a,b);return b.join("")}function Fb(){}
	function Eb(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(p(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Eb(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Gb(d,c),c.push(":"),Eb(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Gb(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Hb={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ib=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function Gb(a,b){b.push('"',a.replace(Ib,function(a){var b=Hb[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Hb[a]=b);return b}),'"')};function Jb(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Jb.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Kb(){this.b=this.a=null}var Nb=new Jb(function(){return new Lb},function(a){a.reset()});Kb.prototype.add=function(a,b){var c=Nb.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ob(){var a=Pb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Lb(){this.next=this.b=this.a=null}Lb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Lb.prototype.reset=function(){this.next=this.b=this.a=null};function Qb(a){k.setTimeout(function(){throw a;},0)}var Rb;
	function Sb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.za;c.za=null;a()}};return function(a){d.next={za:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};var Tb;function Ub(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);Tb=function(){a.then(Vb)}}else Tb=function(){var a=Vb;!da(k.setImmediate)||k.Window&&k.Window.prototype&&!y("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(Rb||(Rb=Sb()),Rb(a)):k.setImmediate(a)}}var Wb=!1,Pb=new Kb;function Vb(){for(var a;a=Ob();){try{a.a.call(a.b)}catch(c){Qb(c)}var b=Nb;b.f(a);100>b.b&&(b.b++,a.next=b.a,b.a=a)}Wb=!1};function Xb(a,b){B.call(this);this.b=a||1;this.a=b||k;this.c=r(this.qb,this);this.g=t()}u(Xb,B);g=Xb.prototype;g.ea=!1;g.O=null;g.qb=function(){if(this.ea){var a=t()-this.g;0<a&&a<.8*this.b?this.O=this.a.setTimeout(this.c,this.b-a):(this.O&&(this.a.clearTimeout(this.O),this.O=null),this.dispatchEvent("tick"),this.ea&&(this.O=this.a.setTimeout(this.c,this.b),this.g=t()))}};g.start=function(){this.ea=!0;this.O||(this.O=this.a.setTimeout(this.c,this.b),this.g=t())};
	function Yb(a){a.ea=!1;a.O&&(a.a.clearTimeout(a.O),a.O=null)}g.w=function(){Xb.H.w.call(this);Yb(this);delete this.a};function Zb(a,b,c){if(da(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)};function $b(a,b,c){w.call(this);this.f=null!=c?r(a,c):a;this.c=b;this.b=r(this.kb,this);this.a=[]}u($b,w);g=$b.prototype;g.ha=!1;g.Y=null;g.cb=function(a){this.a=arguments;this.Y?this.ha=!0:ac(this)};g.w=function(){$b.H.w.call(this);this.Y&&(k.clearTimeout(this.Y),this.Y=null,this.ha=!1,this.a=[])};g.kb=function(){this.Y=null;this.ha&&(this.ha=!1,ac(this))};function ac(a){a.Y=Zb(a.b,a.c);a.f.apply(null,a.a)};function bc(a){w.call(this);this.b=a;this.a={}}u(bc,w);var cc=[];function dc(a,b,c,d){p(c)||(c&&(cc[0]=c.toString()),c=cc);for(var e=0;e<c.length;e++){var f=nb(b,c[e],d||a.handleEvent,!1,a.b||a);if(!f)break;a.a[f.key]=f}}function ec(a){Ca(a.a,function(a,c){this.a.hasOwnProperty(c)&&wb(a)},a);a.a={}}bc.prototype.w=function(){bc.H.w.call(this);ec(this)};bc.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function fc(a,b,c){this.reset(a,b,c,void 0,void 0)}fc.prototype.a=null;var gc=0;fc.prototype.reset=function(a,b,c,d,e){"number"==typeof e||gc++;d||t();delete this.a};function hc(a){this.f=a;this.b=this.c=this.a=null}function C(a,b){this.name=a;this.value=b}C.prototype.toString=function(){return this.name};var ic=new C("SEVERE",1E3),jc=new C("WARNING",900),kc=new C("INFO",800),lc=new C("CONFIG",700),mc=new C("FINE",500);function nc(a){if(a.c)return a.c;if(a.a)return nc(a.a);ma("Root logger has no level set.");return null}hc.prototype.log=function(a,b,c){if(a.value>=nc(this).value)for(da(b)&&(b=b()),a=new fc(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};
	var oc={},pc=null;function qc(a){pc||(pc=new hc(""),oc[""]=pc,pc.c=lc);var b;if(!(b=oc[a])){b=new hc(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=qc(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;oc[a]=b}return b};function D(a,b){a&&a.log(jc,b,void 0)}function rc(a,b){a&&a.log(kc,b,void 0)}function E(a,b){a&&a.log(mc,b,void 0)};function sc(){this.a=qc("goog.labs.net.webChannel.WebChannelDebug");this.b=!0}sc.prototype.Fa=function(){this.b=!1};function tc(a,b,c,d,e,f){F(a,function(){if(a.b)if(f){var h="";for(var m=f.split("&"),v=0;v<m.length;v++){var I=m[v].split("=");if(1<I.length){var X=I[0];I=I[1];var Mb=X.split("_");h=2<=Mb.length&&"type"==Mb[1]?h+(X+"="+I+"&"):h+(X+"=redacted&")}}}else h=null;else h=f;return"XMLHTTP REQ ("+d+") [attempt "+e+"]: "+b+"\n"+c+"\n"+h})}
	function uc(a,b,c,d,e,f,h){F(a,function(){return"XMLHTTP RESP ("+d+") [ attempt "+e+"]: "+b+"\n"+c+"\n"+f+" "+h})}function G(a,b,c,d){F(a,function(){return"XMLHTTP TEXT ("+b+"): "+vc(a,c)+(d?" "+d:"")})}function wc(a,b){F(a,function(){return"TIMEOUT: "+b})}function H(a,b){E(a.a,b)}function xc(a,b,c){(a=a.a)&&a.log(ic,c||"Exception",b)}function F(a,b){rc(a.a,b)}function J(a,b){(a=a.a)&&a.log(ic,b,void 0)}
	function vc(a,b){if(!a.b)return b;if(!b)return null;try{var c=JSON.parse(b);if(c)for(var d=0;d<c.length;d++)if(p(c[d])){var e=c[d];if(!(2>e.length)){var f=e[1];if(p(f)&&!(1>f.length)){var h=f[0];if("noop"!=h&&"stop"!=h&&"close"!=h)for(var m=1;m<f.length;m++)f[m]=""}}}return Db(c)}catch(v){return H(a,"Exception parsing expected JS array - probably was not JS"),b}};var yc=new B;function zc(a){A.call(this,"serverreachability",a)}u(zc,A);function Ac(a){yc.dispatchEvent(new zc(yc,a))}function Bc(a){A.call(this,"statevent",a)}u(Bc,A);function K(a){yc.dispatchEvent(new Bc(yc,a))}function Cc(a){A.call(this,"timingevent",a)}u(Cc,A);function Dc(a,b,c){yc.dispatchEvent(new Cc(yc,a,b,c))}function Ec(a,b){if(!da(a))throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a()},b)};var Fc={NO_ERROR:0,rb:1,yb:2,xb:3,ub:4,wb:5,zb:6,Ua:7,TIMEOUT:8,Cb:9};var Gc={tb:"complete",Gb:"success",Va:"error",Ua:"abort",Eb:"ready",Fb:"readystatechange",TIMEOUT:"timeout",Ab:"incrementaldata",Db:"progress",vb:"downloadprogress",Hb:"uploadprogress"};function Hc(){}Hc.prototype.a=null;function Ic(a){var b;(b=a.a)||(b={},Jc(a)&&(b[0]=!0,b[1]=!0),b=a.a=b);return b};function Kc(){}var Lc={OPEN:"a",sb:"b",Va:"c",Bb:"d"};function Mc(){A.call(this,"d")}u(Mc,A);function Nc(){A.call(this,"c")}u(Nc,A);var Oc;function Pc(){}u(Pc,Hc);function Qc(a){return(a=Jc(a))?new ActiveXObject(a):new XMLHttpRequest}function Jc(a){if(!a.b&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.b=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.b}Oc=new Pc;function L(a,b,c,d){this.i=a;this.b=b;this.c=c;this.T=d||1;this.L=new bc(this);this.R=Rc;a=Na?125:void 0;this.S=new Xb(a);this.j=null;this.f=!1;this.l=this.g=this.h=this.J=this.D=this.U=this.s=null;this.u=[];this.a=null;this.G=0;this.m=this.o=null;this.C=-1;this.B=!1;this.N=0;this.I=null;this.v=this.X=this.K=!1}var Rc=45E3;
	function Sc(a,b){switch(a){case 0:return"Non-200 return code ("+b+")";case 1:return"XMLHTTP failure (no data)";case 2:return"HttpConnection timeout";default:return"Unknown error"}}var Tc={},Uc={};g=L.prototype;g.setTimeout=function(a){this.R=a};function Vc(a,b,c){a.J=1;a.h=Wc(M(b));a.l=c;a.K=!0;Xc(a,null)}function Yc(a,b,c,d){a.J=1;a.h=Wc(M(b));a.l=null;a.K=c;Xc(a,d)}
	function Xc(a,b){a.D=t();Zc(a);a.g=M(a.h);$c(a.g,"t",a.T);a.G=0;a.a=a.i.ca(a.i.ia()?b:null);0<a.N&&(a.I=new $b(r(a.Sa,a,a.a),a.N));dc(a.L,a.a,"readystatechange",a.nb);b=a.j?Fa(a.j):{};a.l?(a.o||(a.o="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.a.fa(a.g,a.o,a.l,b)):(a.o="GET",a.a.fa(a.g,a.o,null,b));Ac(1);tc(a.b,a.o,a.g,a.c,a.T,a.l)}g.nb=function(a){a=a.target;var b=this.I;b&&3==N(a)?(H(this.b,"Throttling readystatechange."),b.cb()):this.Sa(a)};
	g.Sa=function(a){try{a==this.a?ad(this):D(this.b.a,"Called back with an unexpected xmlhttp")}catch(c){if(H(this.b,"Failed call to OnXmlHttpReadyStateChanged_"),this.a&&this.a.V()){var b=this;xc(this.b,c,function(){return"ResponseText: "+b.a.V()})}else xc(this.b,c,"No response text")}finally{}};
	function ad(a){var b=N(a.a),c=a.a.Ga(),d=a.a.W();if(!(3>b||3==b&&!Na&&!a.a.V())){a.B||4!=b||7==c||(8==c||0>=d?Ac(3):Ac(2));bd(a);var e=a.a.W();a.C=e;(c=a.a.V())||H(a.b,function(){return"No response text for uri "+a.g+" status "+e});a.f=200==e;uc(a.b,a.o,a.g,a.c,a.T,b,e);if(a.f){if(d=cd(a))G(a.b,a.c,d,"Initial handshake response via X-HTTP-Initial-Response"),a.v=!0,dd(a,d);a.K?(ed(a,b,c),Na&&a.f&&3==b&&fd(a)):(G(a.b,a.c,c,null),dd(a,c));4==b&&gd(a);a.f&&!a.B&&(4==b?a.i.ta(a):(a.f=!1,Zc(a)))}else 400==
	e&&0<c.indexOf("Unknown SID")?(a.m=3,K(12),D(a.b.a,"XMLHTTP Unknown SID ("+a.c+")")):(a.m=0,K(13),D(a.b.a,"XMLHTTP Bad status "+e+" ("+a.c+")")),gd(a),hd(a)}}function cd(a){return!a.X||a.v?null:a.a&&(a=id(a.a,"X-HTTP-Initial-Response"))&&!xa(a)?a:null}
	function ed(a,b,c){for(var d=!0;!a.B&&a.G<c.length;){var e=jd(a,c);if(e==Uc){4==b&&(a.m=4,K(14),d=!1);G(a.b,a.c,null,"[Incomplete Response]");break}else if(e==Tc){a.m=4;K(15);G(a.b,a.c,c,"[Invalid Chunk]");d=!1;break}else G(a.b,a.c,e,null),dd(a,e)}4==b&&0==c.length&&(a.m=1,K(16),d=!1);a.f=a.f&&d;d||(G(a.b,a.c,c,"[Invalid Chunked Response]"),gd(a),hd(a))}g.mb=function(){if(this.a){var a=N(this.a),b=this.a.V();this.G<b.length&&(bd(this),ed(this,a,b),this.f&&4!=a&&Zc(this))}};
	function fd(a){dc(a.L,a.S,"tick",a.mb);a.S.start()}function jd(a,b){var c=a.G,d=b.indexOf("\n",c);if(-1==d)return Uc;c=Number(b.substring(c,d));if(isNaN(c))return Tc;d+=1;if(d+c>b.length)return Uc;b=b.substr(d,c);a.G=d+c;return b}g.cancel=function(){this.B=!0;gd(this)};function Zc(a){a.U=t()+a.R;kd(a,a.R)}function kd(a,b){if(null!=a.s)throw Error("WatchDog timer not null");a.s=Ec(r(a.lb,a),b)}function bd(a){a.s&&(k.clearTimeout(a.s),a.s=null)}
	g.lb=function(){this.s=null;var a=t();0<=a-this.U?(this.f&&J(this.b,"Received watchdog timeout even though request loaded successfully"),wc(this.b,this.g),2!=this.J&&(Ac(3),K(17)),gd(this),this.m=2,hd(this)):(D(this.b.a,"WatchDog timer called too early"),kd(this,this.U-a))};function hd(a){a.i.La()||a.B||a.i.ta(a)}function gd(a){bd(a);var b=a.I;b&&"function"==typeof b.$&&b.$();a.I=null;Yb(a.S);ec(a.L);a.a&&(b=a.a,a.a=null,b.abort(),b.$())}
	function dd(a,b){try{a.i.Oa(a,b),Ac(4)}catch(c){xc(a.b,c,"Error in httprequest callback")}};function ld(a){if(a.A&&"function"==typeof a.A)return a.A();if(l(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Da(a)}
	function md(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||l(a))ra(a,b,void 0);else{if(a.M&&"function"==typeof a.M)var c=a.M();else if(a.A&&"function"==typeof a.A)c=void 0;else if(ca(a)||l(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e)}else c=Ea(a);d=ld(a);e=d.length;for(var f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)}};function O(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof O)for(c=a.M(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=O.prototype;g.A=function(){nd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.M=function(){nd(this);return this.a.concat()};
	function od(a){a.b={};a.a.length=0;a.c=0}function pd(a,b){return P(a.b,b)?(delete a.b[b],a.c--,a.a.length>2*a.c&&nd(a),!0):!1}function nd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];P(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],P(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return P(this.b,a)?this.b[a]:b};g.set=function(a,b){P(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	g.forEach=function(a,b){for(var c=this.M(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function P(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var qd=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function rd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Q(a,b){this.b=this.j=this.f="";this.i=null;this.g=this.a="";this.h=!1;var c;a instanceof Q?(this.h=void 0!==b?b:a.h,sd(this,a.f),this.j=a.j,td(this,a.b),ud(this,a.i),this.a=a.a,vd(this,wd(a.c)),this.g=a.g):a&&(c=String(a).match(qd))?(this.h=!!b,sd(this,c[1]||"",!0),this.j=xd(c[2]||""),td(this,c[3]||"",!0),ud(this,c[4]),this.a=xd(c[5]||"",!0),vd(this,c[6]||"",!0),this.g=xd(c[7]||"")):(this.h=!!b,this.c=new yd(null,this.h))}
	Q.prototype.toString=function(){var a=[],b=this.f;b&&a.push(zd(b,Ad,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.j)&&a.push(zd(b,Ad,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.a)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(zd(c,"/"==c.charAt(0)?Bd:Cd,!0));(c=this.c.toString())&&a.push("?",c);(c=this.g)&&a.push("#",zd(c,Dd));return a.join("")};
	Q.prototype.resolve=function(a){var b=M(this),c=!!a.f;c?sd(b,a.f):c=!!a.j;c?b.j=a.j:c=!!a.b;c?td(b,a.b):c=null!=a.i;var d=a.a;if(c)ud(b,a.i);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.b&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],h=0;h<e.length;){var m=e[h++];"."==m?d&&h==e.length&&f.push(""):".."==m?((1<f.length||1==f.length&&""!=
	f[0])&&f.pop(),d&&h==e.length&&f.push("")):(f.push(m),d=!0)}d=f.join("/")}else d=e}c?b.a=d:c=""!==a.c.toString();c?vd(b,wd(a.c)):c=!!a.g;c&&(b.g=a.g);return b};function M(a){return new Q(a)}function sd(a,b,c){a.f=c?xd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function td(a,b,c){a.b=c?xd(b,!0):b}function ud(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function vd(a,b,c){b instanceof yd?(a.c=b,Ed(a.c,a.h)):(c||(b=zd(b,Fd)),a.c=new yd(b,a.h))}
	function R(a,b,c){a.c.set(b,c)}function $c(a,b,c){p(c)||(c=[String(c)]);Gd(a.c,b,c)}function Wc(a){R(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^t()).toString(36));return a}function Hd(a){return a instanceof Q?M(a):new Q(a,void 0)}function Id(a,b,c,d){var e=new Q(null,void 0);a&&sd(e,a);b&&td(e,b);c&&ud(e,c);d&&(e.a=d);return e}function xd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}
	function zd(a,b,c){return l(a)?(a=encodeURI(a).replace(b,Jd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Jd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Ad=/[#\/\?@]/g,Cd=/[#\?:]/g,Bd=/[#\?]/g,Fd=/[#\?@]/g,Dd=/#/g;function yd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function S(a){a.a||(a.a=new O,a.b=0,a.c&&rd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}g=yd.prototype;
	g.add=function(a,b){S(this);this.c=null;a=Kd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Ld(a,b){S(a);b=Kd(a,b);P(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,pd(a.a,b))}function Md(a,b){S(a);b=Kd(a,b);return P(a.a.b,b)}g.forEach=function(a,b){S(this);this.a.forEach(function(c,d){ra(c,function(c){a.call(b,c,d,this)},this)},this)};
	g.M=function(){S(this);for(var a=this.a.A(),b=this.a.M(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};g.A=function(a){S(this);var b=[];if(l(a))Md(this,a)&&(b=va(b,this.a.get(Kd(this,a))));else{a=this.a.A();for(var c=0;c<a.length;c++)b=va(b,a[c])}return b};g.set=function(a,b){S(this);this.c=null;a=Kd(this,a);Md(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.A(a):[];return 0<a.length?String(a[0]):b};
	function Gd(a,b,c){Ld(a,b);0<c.length&&(a.c=null,a.a.set(Kd(a,b),wa(c)),a.b+=c.length)}g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.M(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.A(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function wd(a){var b=new yd;b.c=a.c;a.a&&(b.a=new O(a.a),b.b=a.b);return b}
	function Kd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Ed(a,b){b&&!a.f&&(S(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Ld(this,b),Gd(this,c,a))},a));a.f=b};function Nd(){this.a=t()}var Od=null;Nd.prototype.set=function(a){this.a=a};Nd.prototype.reset=function(){this.set(t())};Nd.prototype.get=function(){return this.a};function Pd(){Od||(Od=new Nd)}function Qd(){Od||(Od=new Nd)}u(Qd,Pd);function Rd(a,b){this.a=a;this.b=b;this.c=this.i=null;this.h=!1;this.m=null;this.f=-1;this.l=this.g=null}g=Rd.prototype;g.P=null;
	function Sd(a){H(a.b,"TestConnection: starting stage 2");var b=a.a.I.a;if(null!=b)H(a.b,function(){return true?"Buffered":"Unbuffered"}),K(4),b?(K(10),Td(a.a,a,!1)):(K(11),Td(a.a,a,!0));else{a.c=new L(a,a.b,void 0,void 0);a.c.j=a.i;var c=Ud(a.a,a.g,a.m);K(4);$c(c,"TYPE","xmlhttp");var d=a.a.j,e=a.a.K;d&&e&&R(c,d,e);Yc(a.c,c,!1,a.g)}}g.ca=function(a){return this.a.ca(a)};g.abort=function(){this.c&&(this.c.cancel(),this.c=null);this.f=-1};
	g.La=function(){return!1};
	g.Oa=function(a,b){this.f=a.C;if(0==this.P){H(this.b,"TestConnection: Got data for stage 1");if(!this.a.o&&(a=a.a)){var c=id(a,"X-Client-Wire-Protocol");this.l=c?c:null;this.a.j&&((a=id(a,"X-HTTP-Session-Id"))?this.a.K=a:D(this.b.a,"Missing X_HTTP_SESSION_ID in the handshake response"))}if(b){try{var d=this.a.la.a.parse(b)}catch(e){xc(this.b,e);Vd(this.a,this);return}this.g=d[0]}else H(this.b,"TestConnection: Null responseText"),Vd(this.a,this)}else if(1==this.P)if(this.h)K(6);else if("11111"==b){if(K(5),
	this.h=!0,!z||10<=Number(Wa))this.f=200,this.c.cancel(),H(this.b,"Test connection succeeded; using streaming connection"),K(11),Td(this.a,this,!0)}else K(7),this.h=!1};
	g.ta=function(){this.f=this.c.C;this.c.f?0==this.P?(this.P=1,H(this.b,"TestConnection: request complete for initial check"),Sd(this)):1==this.P&&(H(this.b,"TestConnection: request complete for stage 2"),this.h?(H(this.b,"Test connection succeeded; using streaming connection"),K(11),Td(this.a,this,!0)):(H(this.b,"Test connection failed; not using streaming"),K(10),Td(this.a,this,!1))):(H(this.b,"TestConnection: request failed, in state "+this.P),0==this.P?K(8):1==this.P&&K(9),Vd(this.a,this))};
	g.ia=function(){return this.a.ia()};g.qa=function(){return this.a.qa()};function Wd(){this.a=this.b=null};function Xd(){this.a=new O}function Yd(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[q]||(a[q]=++fa)):b.charAt(0)+a}Xd.prototype.add=function(a){this.a.set(Yd(a),a)};Xd.prototype.A=function(){return this.a.A()};function Zd(a,b){this.a=a;this.b=b};function $d(a){this.g=a||ae;k.PerformanceNavigationTiming?(a=k.performance.getEntriesByType("navigation"),a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(k.oa&&k.oa.Ma&&k.oa.Ma()&&k.oa.Ma().Jb);this.f=a?this.g:1;this.a=null;1<this.f&&(this.a=new Xd);this.b=null;this.c=[]}var ae=10;function be(a,b){a.a||-1==b.indexOf("spdy")&&-1==b.indexOf("quic")&&-1==b.indexOf("h2")||(a.f=a.g,a.a=new Xd,a.b&&(ce(a,a.b),a.b=null))}function de(a){return a.b?!0:a.a?a.a.a.c>=a.f:!1}
	function ee(a,b){a.b?a=a.b==b:a.a?(b=Yd(b),a=P(a.a.a.b,b)):a=!1;return a}function ce(a,b){a.a?a.a.add(b):a.b=b}function fe(a,b){if(a.b&&a.b==b)a.b=null;else{var c;if(c=a.a)c=Yd(b),c=P(a.a.a.b,c);c&&pd(a.a.a,Yd(b))}}$d.prototype.cancel=function(){this.c=ge(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(ra(this.a.A(),function(a){a.cancel()}),od(this.a.a))};
	function ge(a){if(null!=a.b)return a.c.concat(a.b.u);if(null!=a.a&&0!=a.a.a.c){var b=a.c;ra(a.a.A(),function(a){b=b.concat(a.u)});return b}return wa(a.c)}function he(a,b){a.c=a.c.concat(b)};function ie(){}ie.prototype.stringify=function(a){return k.JSON.stringify(a,void 0)};ie.prototype.parse=function(a){return k.JSON.parse(a,void 0)};function je(){this.a=new ie}function ke(a,b,c){var d=c||"";try{md(a,function(a,c){var e=a;ea(a)&&(e=Db(a));b.push(d+c+"="+encodeURIComponent(e))})}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}};function le(a,b){var c=new sc;H(c,"TestLoadImage: loading "+a);var d=new Image;d.onload=ja(me,c,d,"TestLoadImage: loaded",!0,b);d.onerror=ja(me,c,d,"TestLoadImage: error",!1,b);d.onabort=ja(me,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=ja(me,c,d,"TestLoadImage: timeout",!1,b);k.setTimeout(function(){if(d.ontimeout)d.ontimeout()},1E4);d.src=a}function me(a,b,c,d,e){try{H(a,c),b.onload=null,b.onerror=null,b.onabort=null,b.ontimeout=null,e(d)}catch(f){xc(a,f)}};function T(a){B.call(this);this.headers=new O;this.s=a||null;this.c=!1;this.D=this.a=null;this.K=this.B="";this.j=0;this.g="";this.h=this.I=this.u=this.G=!1;this.l=0;this.C=null;this.L=ne;this.v=this.o=!1}u(T,B);var ne="";T.prototype.b=qc("goog.net.XhrIo");var oe=/^https?$/i,pe=["POST","PUT"];g=T.prototype;
	g.fa=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.B+"; newUri="+a);b=b?b.toUpperCase():"GET";this.B=a;this.g="";this.j=0;this.K=b;this.G=!1;this.c=!0;this.a=this.s?Qc(this.s):Qc(Oc);this.D=this.s?Ic(this.s):Ic(Oc);this.a.onreadystatechange=r(this.Na,this);try{E(this.b,U(this,"Opening Xhr")),this.I=!0,this.a.open(b,String(a),!0),this.I=!1}catch(f){E(this.b,U(this,"Error opening Xhr: "+f.message));qe(this,f);return}a=c||"";var e=new O(this.headers);
	d&&md(d,function(a,b){e.set(b,a)});d=sa(e.M());c=k.FormData&&a instanceof k.FormData;!(0<=qa(pe,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.a.setRequestHeader(b,a)},this);this.L&&(this.a.responseType=this.L);"withCredentials"in this.a&&this.a.withCredentials!==this.o&&(this.a.withCredentials=this.o);try{re(this),0<this.l&&(this.v=se(this.a),E(this.b,U(this,"Will abort after "+this.l+"ms if incomplete, xhr2 "+this.v)),this.v?(this.a.timeout=
	this.l,this.a.ontimeout=r(this.Ka,this)):this.C=Zb(this.Ka,this.l,this)),E(this.b,U(this,"Sending request")),this.u=!0,this.a.send(a),this.u=!1}catch(f){E(this.b,U(this,"Send error: "+f.message)),qe(this,f)}};function se(a){return z&&Va(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function ta(a){return"content-type"==a.toLowerCase()}
	g.Ka=function(){"undefined"!=typeof goog&&this.a&&(this.g="Timed out after "+this.l+"ms, aborting",this.j=8,E(this.b,U(this,this.g)),this.dispatchEvent("timeout"),this.abort(8))};function qe(a,b){a.c=!1;a.a&&(a.h=!0,a.a.abort(),a.h=!1);a.g=b;a.j=5;te(a);ue(a)}function te(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}
	g.abort=function(a){this.a&&this.c&&(E(this.b,U(this,"Aborting")),this.c=!1,this.h=!0,this.a.abort(),this.h=!1,this.j=a||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),ue(this))};g.w=function(){this.a&&(this.c&&(this.c=!1,this.h=!0,this.a.abort(),this.h=!1),ue(this,!0));T.H.w.call(this)};g.Na=function(){this.i||(this.I||this.u||this.h?ve(this):this.jb())};g.jb=function(){ve(this)};
	function ve(a){if(a.c&&"undefined"!=typeof goog)if(a.D[1]&&4==N(a)&&2==a.W())E(a.b,U(a,"Local request error detected and ignored"));else if(a.u&&4==N(a))Zb(a.Na,0,a);else if(a.dispatchEvent("readystatechange"),4==N(a)){E(a.b,U(a,"Request complete"));a.c=!1;try{var b=a.W();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.B).match(qd)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
	f=h.substr(0,h.length-1)}e=!oe.test(f?f.toLowerCase():"")}d=e}d?(a.dispatchEvent("complete"),a.dispatchEvent("success")):(a.j=6,a.g=a.Ha()+" ["+a.W()+"]",te(a))}finally{ue(a)}}}function ue(a,b){if(a.a){re(a);var c=a.a,d=a.D[0]?aa:null;a.a=null;a.D=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(ic,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}function re(a){a.a&&a.v&&(a.a.ontimeout=null);a.C&&(k.clearTimeout(a.C),a.C=null)}
	function N(a){return a.a?a.a.readyState:0}g.W=function(){try{return 2<N(this)?this.a.status:-1}catch(a){return-1}};g.Ha=function(){try{return 2<N(this)?this.a.statusText:""}catch(a){return E(this.b,"Can not get status: "+a.message),""}};g.V=function(){try{return this.a?this.a.responseText:""}catch(a){return E(this.b,"Can not get responseText: "+a.message),""}};
	g.eb=function(a){if(this.a){var b=this.a.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));a:{a=b;if(k.JSON)try{var c=k.JSON.parse(a);break a}catch(d){}c=Cb(a)}return c}};function id(a,b){return a.a?a.a.getResponseHeader(b):null}g.Ga=function(){return this.j};g.hb=function(){return l(this.g)?this.g:String(this.g)};function U(a,b){return b+" ["+a.K+" "+a.B+" "+a.W()+"]"};function we(a){var b="";Ca(a,function(a,d){b+=d;b+=":";b+=a;b+="\r\n"});return b}function xe(a,b,c){a:{for(d in c){var d=!1;break a}d=!0}if(d)return a;c=we(c);if(l(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var e=""}else e=a.substring(d+1,c);a=[a.substr(0,d),e,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2]}return a}R(a,b,c);return a};function ye(a){this.ya=0;this.g=[];this.a=new sc;this.I=new Wd;this.X=this.ua=this.D=this.ja=this.b=this.K=this.j=this.U=this.h=this.L=this.i=null;this.Za=this.R=0;this.Xa=!!n("internalChannelParams.failFast",a);this.ka=this.C=this.s=this.l=this.m=this.f=null;this.u=this.xa=this.N=-1;this.T=this.B=this.v=0;this.Wa=n("internalChannelParams.baseRetryDelayMs",a)||5E3;this.$a=n("internalChannelParams.retryDelaySeedMs",a)||1E4;this.Ya=n("internalChannelParams.forwardChannelMaxRetries",a)||2;this.wa=n("internalChannelParams.forwardChannelRequestTimeoutMs",
	a)||2E4;this.Ta=a&&a.Kb||void 0;this.G=void 0;this.S=a&&a.supportsCrossDomainXhr||!1;this.J="";this.c=new $d(a&&a.concurrentRequestLimit);this.la=new je;this.o=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;(this.va=a&&a.fastHandshake||!1)&&!this.o&&(D(this.a.a,"Force backgroundChannelTest when fastHandshake is enabled."),this.o=!0);a&&a.Fa&&this.a.Fa()}g=ye.prototype;g.na=8;g.F=1;
	function ze(a){H(a.a,"disconnect()");Ae(a);if(3==a.F){var b=a.R++,c=M(a.D);R(c,"SID",a.J);R(c,"RID",b);R(c,"TYPE","terminate");Be(a,c);b=new L(a,a.a,b,void 0);b.J=2;b.h=Wc(M(c));c=!1;k.navigator&&k.navigator.sendBeacon&&(c=k.navigator.sendBeacon(b.h.toString(),""));!c&&k.Image&&((new Image).src=b.h,c=!0);c||(b.a=b.i.ca(null),b.a.fa(b.h));b.D=t();Zc(b)}Ce(a)}
	function Ae(a){a.C&&(a.C.abort(),a.C=null);a.b&&(a.b.cancel(),a.b=null);a.l&&(k.clearTimeout(a.l),a.l=null);De(a);a.c.cancel();a.m&&(k.clearTimeout(a.m),a.m=null)}function Ee(a,b){1E3==a.g.length&&J(a.a,function(){return"Already have 1000 queued maps upon queueing "+Db(b)});a.g.push(new Zd(a.Za++,b));3==a.F&&Fe(a)}g.La=function(){return 0==this.F};function Fe(a){de(a.c)||a.m||(a.m=Ec(r(a.Qa,a),0),a.v=0)}
	function Ge(a,b){var c=a.c;if((c.b?1:c.a?c.a.a.c:0)>=a.c.f-(a.m?1:0))return J(a.a,"Unexpected retry request is scheduled."),!1;if(a.m)return H(a.a,"Use the retry request that is already scheduled."),a.g=b.u.concat(a.g),!0;if(1==a.F||2==a.F||a.v>=(a.Xa?0:a.Ya))return!1;H(a.a,"Going to retry POST");a.m=Ec(r(a.Qa,a,b),He(a,a.v));a.v++;return!0}
	g.Qa=function(a){this.m=null;H(this.a,"startForwardChannel_");if(1==this.F)if(a)J(this.a,"Not supposed to retry the open");else{H(this.a,"open_()");this.R=Math.floor(1E5*Math.random());a=this.R++;var b=new L(this,this.a,a,void 0),c=this.i;this.L&&(c?(c=Fa(c),Ha(c,this.L)):c=this.L);null===this.h&&(b.j=c);var d=Ie(this,b),e=M(this.D);R(e,"RID",a);R(e,"CVER",22);this.o&&this.j&&R(e,"X-HTTP-Session-Id",this.j);Be(this,e);this.h&&c&&xe(e,this.h,c);ce(this.c,b);this.va?(R(e,"$req",d),R(e,"SID","null"),
	b.X=!0,Vc(b,e,null)):Vc(b,e,d);this.F=2}else 3==this.F&&(a?Je(this,a):0==this.g.length?H(this.a,"startForwardChannel_ returned: nothing to send"):de(this.c)?J(this.a,"startForwardChannel_ returned: connection already in progress"):(Je(this),H(this.a,"startForwardChannel_ finished, sent request")))};
	function Je(a,b){var c;b?c=b.c:c=a.R++;var d=M(a.D);R(d,"SID",a.J);R(d,"RID",c);R(d,"AID",a.N);Be(a,d);a.h&&a.i&&xe(d,a.h,a.i);c=new L(a,a.a,c,a.v+1);null===a.h&&(c.j=a.i);b&&(a.g=b.u.concat(a.g));b=Ie(a,c);c.setTimeout(Math.round(.5*a.wa)+Math.round(.5*a.wa*Math.random()));ce(a.c,c);Vc(c,d,b)}function Be(a,b){a.f&&md({},function(a,d){R(b,d,a)})}
	function Ie(a,b){var c=Math.min(a.g.length,1E3),d=a.f?r(a.f.ab,a.f,a):null;a:for(var e=a.g,f=-1;;){var h=["count="+c];-1==f?0<c?(f=e[0].a,h.push("ofs="+f)):f=0:h.push("ofs="+f);for(var m=!0,v=0;v<c;v++){var I=e[v].a,X=e[v].b;I-=f;if(0>I)f=Math.max(0,e[v].a-100),m=!1;else try{ke(X,h,"req"+I+"_")}catch(Mb){d&&d(X)}}if(m){d=h.join("&");break a}}a=a.g.splice(0,c);b.u=a;return d}function Ke(a){if(!a.b&&!a.l){a.T=1;var b=a.Pa;Tb||Ub();Wb||(Tb(),Wb=!0);Pb.add(b,a);a.B=0}}
	function Le(a){if(a.b||a.l)return J(a.a,"Request already in progress"),!1;if(3<=a.B)return!1;H(a.a,"Going to retry GET");a.T++;a.l=Ec(r(a.Pa,a),He(a,a.B));a.B++;return!0}
	g.Pa=function(){this.l=null;H(this.a,"Creating new HttpRequest");this.b=new L(this,this.a,"rpc",this.T);null===this.h&&(this.b.j=this.i);this.b.N=0;var a=M(this.ua);R(a,"RID","rpc");R(a,"SID",this.J);R(a,"CI",this.ka?"0":"1");R(a,"AID",this.N);Be(this,a);R(a,"TYPE","xmlhttp");this.h&&this.i&&xe(a,this.h,this.i);this.G&&this.b.setTimeout(this.G);Yc(this.b,a,!0,this.X);H(this.a,"New Request created")};
	function Td(a,b,c){H(a.a,"Test Connection Finished");var d=b.l;d&&be(a.c,d);a.ka=c;a.u=b.f;H(a.a,"connectChannel_()");a.D=Me(a,a.ja);Fe(a)}function Vd(a,b){H(a.a,"Test Connection Failed");a.u=b.f;V(a,2)}
	g.Oa=function(a,b){if(0!=this.F&&(this.b==a||ee(this.c,a)))if(this.u=a.C,!a.v&&ee(this.c,a)&&3==this.F){try{var c=this.la.a.parse(b)}catch(f){c=null}if(p(c)&&3==c.length)if(b=c,0==b[0])a:if(H(this.a,"Server claims our backchannel is missing."),this.l)H(this.a,"But we are currently starting the request.");else{if(this.b)if(this.b.D+3E3<a.D)De(this),this.b.cancel(),this.b=null;else break a;else D(this.a.a,"We do not have a BackChannel established");Le(this);K(18)}else this.xa=b[1],a=this.xa-this.N,
	0<a&&(b=b[2],H(this.a,b+" bytes (in "+a+" arrays) are outstanding on the BackChannel"),37500>b&&this.ka&&0==this.B&&!this.s&&(this.s=Ec(r(this.ib,this),6E3)));else H(this.a,"Bad POST response data returned"),V(this,11)}else if((a.v||this.b==a)&&De(this),!xa(b))for(b=c=this.la.a.parse(b),c=0;c<b.length;c++){var d=b[c];this.N=d[0];d=d[1];if(2==this.F)if("c"==d[0]){this.J=d[1];this.X=d[2];var e=d[3];null!=e&&(this.na=e,F(this.a,"VER="+this.na));e=d[4];null!=e&&(this.ya=e,F(this.a,"SVER="+this.ya));d=
	d[5];null!=d&&"number"==typeof d&&0<d&&(this.G=d*=1.5,F(this.a,"backChannelRequestTimeoutMs_="+d));this.o&&(d=a.a)&&((e=id(d,"X-Client-Wire-Protocol"))&&be(this.c,e),this.j&&((d=id(d,"X-HTTP-Session-Id"))?(this.K=d,R(this.D,this.j,d)):D(this.a.a,"Missing X_HTTP_SESSION_ID in the handshake response")));this.F=3;this.f&&this.f.Da();d=a;this.ua=Ud(this,this.X,this.ja);d.v?(H(this.a,"Upgrade the handshake request to a backchannel."),fe(this.c,d),(e=this.G)&&d.setTimeout(e),d.s&&(bd(d),Zc(d)),this.b=d):
	Ke(this)}else"stop"!=d[0]&&"close"!=d[0]||V(this,7);else 3==this.F&&("stop"==d[0]||"close"==d[0]?"stop"==d[0]?V(this,7):ze(this):"noop"!=d[0]&&this.f&&this.f.Ca(d),this.B=0)}};g.ib=function(){null!=this.s&&(this.s=null,this.b.cancel(),this.b=null,Le(this),K(19))};function De(a){null!=a.s&&(k.clearTimeout(a.s),a.s=null)}
	g.ta=function(a){H(this.a,"Request complete");var b=null;if(this.b==a){De(this);this.b=null;var c=2}else if(ee(this.c,a))b=a.u,fe(this.c,a),c=1;else return;this.u=a.C;if(0!=this.F)if(a.f)1==c?(Dc(a.l?a.l.length:0,t()-a.D,this.v),Fe(this)):Ke(this);else{var d=a.m;if(3==d||0==d&&0<this.u)H(this.a,"Not retrying due to error type");else{var e=this;H(this.a,function(){return"Maybe retrying, last error: "+Sc(d,e.u)});if(1==c&&Ge(this,a)||2==c&&Le(this))return;H(this.a,"Exceeded max number of retries")}b&&
	0<b.length&&he(this.c,b);H(this.a,"Error: HTTP request failed");switch(d){case 1:V(this,5);break;case 4:V(this,10);break;case 3:V(this,6);break;default:V(this,2)}}};function He(a,b){var c=a.Wa+Math.floor(Math.random()*a.$a);a.qa()||(H(a.a,"Inactive channel"),c*=2);return c*b}
	function V(a,b){F(a.a,"Error code "+b);if(2==b){var c=null;a.f&&(c=null);var d=r(a.pb,a);c||(c=new Q("//www.google.com/images/cleardot.gif"),k.location&&"http"==k.location.protocol||sd(c,"https"),Wc(c));le(c.toString(),d)}else K(2);H(a.a,"HttpChannel: error - "+b);a.F=0;a.f&&a.f.Ba(b);Ce(a);Ae(a)}g.pb=function(a){a?(F(this.a,"Successfully pinged google.com"),K(2)):(F(this.a,"Failed to ping google.com"),K(1))};
	function Ce(a){a.F=0;a.u=-1;if(a.f){var b=ge(a.c);if(0!=b.length||0!=a.g.length)H(a.a,function(){return"Number of undelivered maps, pending: "+b.length+", outgoing: "+a.g.length}),a.c.c.length=0,wa(a.g),a.g.length=0;a.f.Aa()}}function Me(a,b){b=Ne(a,null,b);H(a.a,"GetForwardChannelUri: "+b);return b}function Ud(a,b,c){b=Ne(a,a.ia()?b:null,c);H(a.a,"GetBackChannelUri: "+b);return b}
	function Ne(a,b,c){var d=Hd(c);if(""!=d.b)b&&td(d,b+"."+d.b),ud(d,d.i);else{var e=k.location,f;b?f=b+"."+e.hostname:f=e.hostname;d=Id(e.protocol,f,e.port,c)}a.U&&Ca(a.U,function(a,b){R(d,b,a)});b=a.j;c=a.K;b&&c&&R(d,b,c);R(d,"VER",a.na);Be(a,d);return d}g.ca=function(a){if(a&&!this.S)throw Error("Can't create secondary domain capable XhrIo object.");a=new T(this.Ta);a.o=this.S;return a};g.qa=function(){return!!this.f&&!0};g.ia=function(){return this.S};new Qd;function Oe(){}g=Oe.prototype;g.Da=function(){};
	g.Ca=function(){};g.Ba=function(){};g.Aa=function(){};g.ab=function(){};function Pe(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var e;(e=""==b)||(e=b.length-1,e=0<=e&&b.indexOf("/",e)==e);e?b+=d:b+="/"+d}}return b};function Qe(){if(z&&!(10<=Number(Wa)))throw Error("Environmental error: no available transport.");}Qe.prototype.a=function(a,b){return new W(a,b)};
	function W(a,b){B.call(this);this.a=new ye(b);this.b=a;this.o=b&&b.testUrl?b.testUrl:Pe(this.b,"test");this.c=qc("goog.labs.net.webChannel.WebChannelBaseTransport");this.g=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.a.i=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});
	b&&b.Ea&&(a?a["X-WebChannel-Client-Profile"]=b.Ea:a={"X-WebChannel-Client-Profile":b.Ea});this.a.L=a;(a=b&&b.httpHeadersOverwriteParam)&&!xa(a)&&(this.a.h=a);this.l=b&&b.supportsCrossDomainXhr||!1;this.j=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!xa(b)&&(this.a.j=b,a=this.g,null!==a&&b in a&&(a=this.g,b in a&&delete a[b],D(this.c,"Ignore httpSessionIdParam also specified with messageUrlParams: "+b)));this.h=new Re(this)}u(W,B);g=W.prototype;
	g.addEventListener=function(a,b,c,d){W.H.addEventListener.call(this,a,b,c,d)};g.removeEventListener=function(a,b,c,d){W.H.removeEventListener.call(this,a,b,c,d)};
	g.fb=function(){this.a.f=this.h;this.l&&(this.a.S=!0);var a=this.a,b=this.o,c=this.b,d=this.g||void 0;H(a.a,"connect()");K(0);a.ja=c;a.U=d||{};a.o&&(H(a.a,"connect() bypassed channel-test."),a.I.b=[],a.I.a=!1);H(a.a,"connectTest_()");a.C=new Rd(a,a.a);null===a.h&&(a.C.i=a.i);c=b;a.h&&a.i&&(c=xe(b,a.h,a.i));a=a.C;a.m=c;b=Me(a.a,a.m);K(3);c=a.a.I.b;null!=c?(a.g=c[0],a.P=1,Sd(a)):($c(b,"MODE","init"),!a.a.o&&a.a.j&&$c(b,"X-HTTP-Session-Id",a.a.j),a.c=new L(a,a.b,void 0,void 0),a.c.j=a.i,Yc(a.c,b,!1,
	null),a.P=0)};g.close=function(){ze(this.a)};g.gb=function(a){if(l(a)){var b={};b.__data__=a;Ee(this.a,b)}else this.j?(b={},b.__data__=Db(a),Ee(this.a,b)):Ee(this.a,a)};g.w=function(){this.a.f=null;delete this.h;ze(this.a);delete this.a;W.H.w.call(this)};function Se(a){Mc.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0}(this.c=a)?(a=this.c,this.data=null!==b&&a in b?b[a]:void 0):this.data=b}else this.data=a}u(Se,Mc);function Te(){Nc.call(this);this.status=1}u(Te,Nc);
	function Re(a){this.a=a}u(Re,Oe);Re.prototype.Da=function(){rc(this.a.c,"WebChannel opened on "+this.a.b);this.a.dispatchEvent("a")};Re.prototype.Ca=function(a){this.a.dispatchEvent(new Se(a))};Re.prototype.Ba=function(a){rc(this.a.c,"WebChannel aborted on "+this.a.b+" due to channel error: "+a);this.a.dispatchEvent(new Te(a))};Re.prototype.Aa=function(){rc(this.a.c,"WebChannel closed on "+this.a.b);this.a.dispatchEvent("b")};var Ue=ja(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},Qe);function Ve(){this.b=[];this.a=[]}function We(a){0==a.b.length&&(a.b=a.a,a.b.reverse(),a.a=[]);return a.b.pop()}function Xe(a){return a.b.length+a.a.length}Ve.prototype.A=function(){for(var a=[],b=this.b.length-1;0<=b;--b)a.push(this.b[b]);var c=this.a.length;for(b=0;b<c;++b)a.push(this.a[b]);return a};function Ye(a,b){w.call(this);this.h=a||0;this.c=b||10;if(this.h>this.c)throw Error(Ze);this.a=new Ve;this.b=new Xd;this.g=null;this.aa()}u(Ye,w);var Ze="[goog.structs.Pool] Min can not be greater than max";g=Ye.prototype;g.da=function(){var a=t();if(!(null!=this.g&&0>a-this.g)){for(var b;0<Xe(this.a)&&(b=We(this.a),!this.sa(b));)this.aa();!b&&$e(this)<this.c&&(b=this.pa());b&&(this.g=a,this.b.add(b));return b}};g.ob=function(a){return pd(this.b.a,Yd(a))?(this.ma(a),!0):!1};
	g.ma=function(a){pd(this.b.a,Yd(a));this.sa(a)&&$e(this)<this.c?this.a.a.push(a):af(a)};g.aa=function(){for(var a=this.a;$e(this)<this.h;){var b=this.pa();a.a.push(b)}for(;$e(this)>this.c&&0<Xe(this.a);)af(We(a))};g.pa=function(){return{}};function af(a){if("function"==typeof a.$)a.$();else for(var b in a)a[b]=null}g.sa=function(a){return"function"==typeof a.bb?a.bb():!0};function $e(a){return Xe(a.a)+a.b.a.c}
	g.w=function(){Ye.H.w.call(this);if(0<this.b.a.c)throw Error("[goog.structs.Pool] Objects not released");delete this.b;for(var a=this.a;0!=a.b.length||0!=a.a.length;)af(We(a));delete this.a};function bf(a,b){this.a=a;this.b=b};function cf(a){this.a=[];if(a)a:{if(a instanceof cf){var b=a.M();a=a.A();if(0>=this.a.length){for(var c=this.a,d=0;d<b.length;d++)c.push(new bf(b[d],a[d]));break a}}else b=Ea(a),a=Da(a);for(d=0;d<b.length;d++)df(this,b[d],a[d])}}function df(a,b,c){var d=a.a;d.push(new bf(b,c));b=d.length-1;a=a.a;for(c=a[b];0<b;)if(d=b-1>>1,a[d].a>c.a)a[b]=a[d],b=d;else break;a[b]=c}cf.prototype.A=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].b);return b};
	cf.prototype.M=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].a);return b};function ef(){cf.call(this)}u(ef,cf);function Y(a,b){this.f=new ef;Ye.call(this,a,b)}u(Y,Ye);g=Y.prototype;g.da=function(a,b){if(!a)return Y.H.da.call(this);df(this.f,void 0!==b?b:100,a);this.ra()};g.ra=function(){for(var a=this.f;0<a.a.length;){var b=this.da();if(b){var c=a,d=c.a,e=d.length;var f=d[0];if(0>=e)f=void 0;else{if(1==e)ua(d);else{d[0]=d.pop();d=0;c=c.a;e=c.length;for(var h=c[d];d<e>>1;){var m=2*d+1,v=2*d+2;m=v<e&&c[v].a<c[m].a?v:m;if(c[m].a>h.a)break;c[d]=c[m];d=m}c[d]=h}f=f.b}f.apply(this,[b])}else break}};
	g.ma=function(a){Y.H.ma.call(this,a);this.ra()};g.aa=function(){Y.H.aa.call(this);this.ra()};g.w=function(){Y.H.w.call(this);k.clearTimeout(void 0);ua(this.f.a);this.f=null};function Z(a,b,c,d){this.l=a;this.j=!!d;Y.call(this,b,c)}u(Z,Y);Z.prototype.pa=function(){var a=new T,b=this.l;b&&b.forEach(function(b,d){a.headers.set(d,b)});this.j&&(a.o=!0);return a};Z.prototype.sa=function(a){return!a.i&&!a.a};Qe.prototype.createWebChannel=Qe.prototype.a;W.prototype.send=W.prototype.gb;W.prototype.open=W.prototype.fb;W.prototype.close=W.prototype.close;Fc.NO_ERROR=0;Fc.TIMEOUT=8;Fc.HTTP_ERROR=6;Gc.COMPLETE="complete";Kc.EventType=Lc;Lc.OPEN="a";Lc.CLOSE="b";Lc.ERROR="c";Lc.MESSAGE="d";B.prototype.listen=B.prototype.Ia;Z.prototype.getObject=Z.prototype.da;Z.prototype.releaseObject=Z.prototype.ob;T.prototype.listenOnce=T.prototype.Ja;T.prototype.getLastError=T.prototype.hb;T.prototype.getLastErrorCode=T.prototype.Ga;
	T.prototype.getStatus=T.prototype.W;T.prototype.getStatusText=T.prototype.Ha;T.prototype.getResponseJson=T.prototype.eb;T.prototype.getResponseText=T.prototype.V;T.prototype.getResponseText=T.prototype.V;T.prototype.send=T.prototype.fa;module.exports={createWebChannelTransport:Ue,ErrorCode:Fc,EventType:Gc,WebChannel:Kc,XhrIoPool:Z};}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {})
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	var bind = __webpack_require__(51);
	var Axios = __webpack_require__(149);
	var defaults = __webpack_require__(31);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(48);
	axios.CancelToken = __webpack_require__(148);
	axios.isCancel = __webpack_require__(49);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(163);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(48);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(31);
	var utils = __webpack_require__(9);
	var InterceptorManager = __webpack_require__(150);
	var dispatchRequest = __webpack_require__(151);
	var isAbsoluteURL = __webpack_require__(159);
	var combineURLs = __webpack_require__(157);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	var transformData = __webpack_require__(154);
	var isCancel = __webpack_require__(49);
	var defaults = __webpack_require__(31);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(50);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(9);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 164 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 165 */
/***/ function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(global) {
	  'use strict';
	  if (!global.console) {
	    global.console = {};
	  }
	  var con = global.console;
	  var prop, method;
	  var dummy = function() {};
	  var properties = ['memory'];
	  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
	     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
	     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
	  while (method = methods.pop()) if (!con[method]) con[method] = dummy;
	  // Using `this` for web workers & supports Browserify / Webpack.
	})(typeof window === 'undefined' ? this : window);


/***/ },
/* 166 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyObject = __webpack_require__(21);
	var _invariant = __webpack_require__(10);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 169 */
/***/ function(module, exports) {

	/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Module exports.
	 * @public
	 */
	
	module.exports = escapeHtml;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34: // "
	        escape = '&quot;';
	        break;
	      case 38: // &
	        escape = '&amp;';
	        break;
	      case 39: // '
	        escape = '&#39;';
	        break;
	      case 60: // <
	        escape = '&lt;';
	        break;
	      case 62: // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index
	    ? html + str.substring(lastIndex, index)
	    : html;
	}


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(175);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(174);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(23);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(17);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(53);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(54);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(55);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(179)['default'];
	exports['default'] = exports;


/***/ },
/* 179 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(185)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(664);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 181 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(57), src$es5$$ = __webpack_require__(184), src$compiler$$ = __webpack_require__(181), intl$messageformat$parser$$ = __webpack_require__(178);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 183 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(57);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(182), src$en$$ = __webpack_require__(183);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(187);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(663);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 187 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// https://github.com/electron/electron/issues/2288
	function isElectron() {
	    // Renderer process
	    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
	        return true;
	    }
	
	    // Main process
	    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
	        return true;
	    }
	
	    // Detect the user agent when the `nodeIntegration` option is set to true
	    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
	        return true;
	    }
	
	    return false;
	}
	
	module.exports = isElectron;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	var WHITELIST = [
		'ETIMEDOUT',
		'ECONNRESET',
		'EADDRINUSE',
		'ESOCKETTIMEDOUT',
		'ECONNREFUSED',
		'EPIPE'
	];
	
	var BLACKLIST = [
		'ENOTFOUND',
		'ENETUNREACH',
	
		// SSL errors from https://github.com/nodejs/node/blob/ed3d8b13ee9a705d89f9e0397d9e96519e7e47ac/src/node_crypto.cc#L1950
		'UNABLE_TO_GET_ISSUER_CERT',
		'UNABLE_TO_GET_CRL',
		'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
		'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
		'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
		'CERT_SIGNATURE_FAILURE',
		'CRL_SIGNATURE_FAILURE',
		'CERT_NOT_YET_VALID',
		'CERT_HAS_EXPIRED',
		'CRL_NOT_YET_VALID',
		'CRL_HAS_EXPIRED',
		'ERROR_IN_CERT_NOT_BEFORE_FIELD',
		'ERROR_IN_CERT_NOT_AFTER_FIELD',
		'ERROR_IN_CRL_LAST_UPDATE_FIELD',
		'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
		'OUT_OF_MEM',
		'DEPTH_ZERO_SELF_SIGNED_CERT',
		'SELF_SIGNED_CERT_IN_CHAIN',
		'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
		'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
		'CERT_CHAIN_TOO_LONG',
		'CERT_REVOKED',
		'INVALID_CA',
		'PATH_LENGTH_EXCEEDED',
		'INVALID_PURPOSE',
		'CERT_UNTRUSTED',
		'CERT_REJECTED'
	];
	
	module.exports = function (err) {
		if (!err || !err.code) {
			return true;
		}
	
		if (WHITELIST.indexOf(err.code) !== -1) {
			return true;
		}
	
		if (BLACKLIST.indexOf(err.code) !== -1) {
			return false;
		}
	
		return true;
	};


/***/ },
/* 190 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(43)(module)))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(195);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 194 */
[665, 16, 10, 58],
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(22);
	var assign = __webpack_require__(15);
	
	var ReactPropTypesSecret = __webpack_require__(58);
	var checkPropTypes = __webpack_require__(192);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 196 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 197 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(196);
	exports.encode = exports.stringify = __webpack_require__(197);


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.4.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(10),ba=__webpack_require__(2),m=__webpack_require__(171),p=__webpack_require__(15),v=__webpack_require__(16),da=__webpack_require__(173),ea=__webpack_require__(176),fa=__webpack_require__(172),ha=__webpack_require__(21);
	function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
	function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
	var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
	B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
	function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
	var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
	function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
	function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
	return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
	function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
	function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
	function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
	function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
	var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
	function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
	function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
	var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
	p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
	function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
	var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
	function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
	function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
	var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
	f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
	function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
	var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
	function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
	60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
	function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
	a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
	var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
	function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
	function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
	[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
	["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
	Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
	function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
	function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
	function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
	function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
	function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
	var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
	var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
	mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
	e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
	c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
	function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
	function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
	a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
	["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
	var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
	Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
	function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
	var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
	function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
	var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
	case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
	var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
	if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
	me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
	b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
	didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
	function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
	function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
	function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
	function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
	function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
	K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
	h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
	function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
	(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
	g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
	function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
	ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
	c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
	var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
	c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
	function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
	function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
	function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
	function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
	function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
	d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
	function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
	function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
	function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
	function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
	function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
	function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
	g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
	function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
	function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
	function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
	function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
	var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
	b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
	function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
	function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
	d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
	function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
	function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
	a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
	if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
	t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
	g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
	t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
	a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
	a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
	function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
	function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
	function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
	function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
	e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
	function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
	h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
	typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
	g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
	(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
	(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
	f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
	b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
	null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
	b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
	R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
	function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
	A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
	a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
	default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
	function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
	e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
	function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
	function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
	function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
	function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
	function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
	(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
	function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
	function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
	void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
	function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
	function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
	function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
	function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
	function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
	function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
	c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
	function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
	function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
	f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
	++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
	D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
	U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
	y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
	top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
	ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
	default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
	function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
	function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
	function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
	function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
	function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
	var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
	function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
	oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
	qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
	qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
	function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
	function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
	function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
	var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
	arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
	var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactBaseClasses = __webpack_require__(61);
	var ReactChildren = __webpack_require__(203);
	var ReactDOMFactories = __webpack_require__(204);
	var ReactElement = __webpack_require__(18);
	var ReactPropTypes = __webpack_require__(205);
	var ReactVersion = __webpack_require__(206);
	
	var createReactClass = __webpack_require__(207);
	var onlyChild = __webpack_require__(210);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(201);
	var ReactElement = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(16);
	var traverseAllChildren = __webpack_require__(211);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(18);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(18),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(193);
	
	module.exports = factory(isValidElement);

/***/ },
/* 206 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(61),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(18),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(64);
	var factory = __webpack_require__(167);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactElement = __webpack_require__(18);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(63);
	
	var getIteratorFn = __webpack_require__(208);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(200);
	var warning = __webpack_require__(22);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(202);


/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(59);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(215);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(67);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(33);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(213);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(217);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(218);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(67);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(216);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(33);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          "aria-modal": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(68);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(68);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(214);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(74);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(71);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(69);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(228);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(222);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(223);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(224);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(225);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(4);
	
	var _wrapMapToProps = __webpack_require__(70);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(70);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(72);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(226);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 229 */
16,
/* 230 */
10,
/* 231 */
12,
/* 232 */
[668, 73, 235, 236],
/* 233 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 234 */
[669, 237],
/* 235 */
[670, 73],
/* 236 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 238 */
[671, 233],
/* 239 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 240 */
[672, 232, 234, 239],
/* 241 */
[665, 229, 230, 242],
/* 242 */
58,
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(26);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(53);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(35);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(26);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(54);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(35);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(258);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(26);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(76);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(75);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(259);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(260);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(261);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(262);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(38);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 252 */
16,
/* 253 */
10,
/* 254 */
12,
/* 255 */
[665, 252, 253, 256],
/* 256 */
58,
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(265);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(55);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(37);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(17);
	
	var _Router = __webpack_require__(37);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(8);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(38);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(263)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(56);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(77);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(492).enable();
	  window.Promise = __webpack_require__(491);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(637);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(490);


/***/ },
/* 267 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(36);
	
	var _reactMedia = __webpack_require__(66);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _FBHome = __webpack_require__(410);
	
	var _FBHome2 = _interopRequireDefault(_FBHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //this.props.actions.initializeFirebase(this.props.actions.getUserByEmail);
	            (0, _ccImports.updateLocale)('en', function () {
	                //this.setState({initDone: true});
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _ccImports.FirebaseUtils.initializeFireBase(this.props.actions);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactRouterDom.BrowserRouter,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_FBHome2.default, null),
	                    _react2.default.createElement(
	                        _reactMedia2.default,
	                        { query: "(min-device-width : 320px) and (max-device-width : 736px)" },
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/match/:matchId/:leagueId?', component: _ccImports.LeagueRoute })
	                    ),
	                    _react2.default.createElement(
	                        _reactMedia2.default,
	                        { query: "(min-device-width : 737px)" },
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/match/:matchId/:leagueId?', component: _ccImports.Root })
	                    ),
	                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _ccImports.Root }),
	                    _react2.default.createElement(_reactRouterDom.Route, { path: '/verifyEmail', component: _ccImports.VerifyEmail })
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        //user: state.user.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(App);

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCAck = function (_Component) {
	    _inherits(CCAck, _Component);
	
	    function CCAck(props) {
	        _classCallCheck(this, CCAck);
	
	        var _this = _possibleConstructorReturn(this, (CCAck.__proto__ || Object.getPrototypeOf(CCAck)).call(this, props));
	
	        _this.state = {};
	
	        return _this;
	    }
	
	    _createClass(CCAck, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container ack-container', style: Object.assign({}, this.props.style) },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container ack-container2' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'ack-font' },
	                            this.props.title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container ack-container3', style: {} },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'ack-font' },
	                            this.props.detail
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container ack-container4' },
	                        _react2.default.createElement(_ccImports.CCIcon, { type: 'success', className: 'ack-success' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ack-container5' },
	                        _react2.default.createElement(_ccImports.CCButton, { title: this.props.buttonText, onPress: this.props.onAck })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCAck;
	}(_react.Component);
	
	CCAck.propTypes = {
	    title: _propTypes2.default.string,
	    detail: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    onAck: _propTypes2.default.func,
	    buttonText: _propTypes2.default.string
	};
	CCAck.defaultProps = {
	    title: undefined,
	    detail: undefined,
	    type: undefined,
	    buttonText: 'OK',
	    onAck: function onAck() {}
	};
	exports.default = CCAck;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCAck = undefined;
	
	var _CCAck = __webpack_require__(269);
	
	var _CCAck2 = _interopRequireDefault(_CCAck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCAck = _CCAck2.default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCActivityIndicator = undefined;
	
	var _CCActivityIndicator = __webpack_require__(27);
	
	var _CCActivityIndicator2 = _interopRequireDefault(_CCActivityIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCActivityIndicator = _CCActivityIndicator2.default;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-button.css'
	// import './cc-button-320x720.css'
	
	var CCButton = function (_Component) {
	    _inherits(CCButton, _Component);
	
	    function CCButton(props) {
	        _classCallCheck(this, CCButton);
	
	        var _this = _possibleConstructorReturn(this, (CCButton.__proto__ || Object.getPrototypeOf(CCButton)).call(this, props));
	
	        _this.state = {
	            showModal: false
	        };
	        _this._onPressed = _this._onPressed.bind(_this);
	
	        _this._getIcon = _this._getIcon.bind(_this);
	        _this._getBgColor = _this._getBgColor.bind(_this);
	        _this._getBorderColor = _this._getBorderColor.bind(_this);
	        _this._getFontColor = _this._getFontColor.bind(_this);
	        _this._getTitle = _this._getTitle.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCButton, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            var _this2 = this;
	
	            if (this.props.success != true && props.success == true) {
	                this.setState({ showModal: true });
	                this.setTimeout(function () {
	                    _this2.setState({ showModal: false });
	                }, 1000);
	            }
	        }
	    }, {
	        key: '_onPressed',
	        value: function _onPressed() {
	            var analytics = this.props.analytics;
	
	            if (analytics) {
	                var event = analytics.event,
	                    params = analytics.params;
	
	                _ccImports.CCAppEventLogger.logAppEvent(event, params ? params : {});
	            }
	            this.props.onPress();
	        }
	    }, {
	        key: '_getTitle',
	        value: function _getTitle() {
	            switch (this.props.type) {
	                case 'fb_signin':
	                    return (0, _ccImports.strings)('fb_signin');
	                case 'fb_signup':
	                    return (0, _ccImports.strings)('fb_signup');
	                    break;
	                case 'ggl_signin':
	                    return (0, _ccImports.strings)('ggl_signin');
	                    break;
	                case 'ggl_signup':
	                    return (0, _ccImports.strings)('ggl_signup');
	                    break;
	                case 'ggl_reauth':
	                    return (0, _ccImports.strings)('ggl_reauth');
	                    break;
	                case 'fb_reauth':
	                    return (0, _ccImports.strings)('fb_reauth');
	                    break;
	                    break;
	                default:
	                    return this.props.title;
	            }
	        }
	    }, {
	        key: '_getIcon',
	        value: function _getIcon() {
	            switch (this.props.type) {
	                case 'fb_signin':
	                case 'fb_signup':
	                case 'fb_reauth':
	                    return _ccImports.images.icons.old.fb_icon_160;
	                    break;
	                case 'ggl_signin':
	                case 'ggl_signup':
	                case 'ggl_reauth':
	                    return _ccImports.images.icons.old.g_plus_icon_160;
	                    break;
	                default:
	                    return this.props.icon;
	            }
	        }
	    }, {
	        key: '_getBgColor',
	        value: function _getBgColor() {
	            switch (this.props.type) {
	                case 'fb_signin':
	                case 'fb_signup':
	                case 'ggl_signin':
	                case 'ggl_signup':
	                case 'fb_reauth':
	                case 'ggl_reauth':
	                    return _ccImports.colors.theme.btn_bg_color1;
	                    break;
	                case 'dark':
	                    return this.props.darkBackgroundColor;
	                    break;
	                default:
	                    return this.props.backgroundColor;
	            }
	        }
	    }, {
	        key: '_getBorderColor',
	        value: function _getBorderColor() {
	            switch (this.props.type) {
	                case 'fb_signin':
	                case 'fb_signup':
	                case 'ggl_signin':
	                case 'ggl_signup':
	                case 'fb_reauth':
	                case 'ggl_reauth':
	                    return this.props.borderColor;
	                    break;
	                default:
	                    return this.props.borderColor;
	            }
	        }
	    }, {
	        key: '_getFontColor',
	        value: function _getFontColor() {
	            switch (this.props.type) {
	                case 'fb_signin':
	                case 'fb_signup':
	                case 'ggl_signin':
	                case 'ggl_signup':
	                case 'fb_reauth':
	                case 'ggl_reauth':
	                    return _ccImports.colors.theme2.font_color4;
	                    break;
	                case 'dark':
	                    return this.props.darkFontColor;
	                    break;
	                default:
	                    return this.props.fontColor;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                titleClassName = _props.titleClassName,
	                className = _props.className,
	                disabled = _props.disabled;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { opacity: this.props.disabled ? 0.5 : 1 }, className: 'flex-container cc-btn ' + className + ' ' + (disabled ? 'disabled' : '') + (' ' + this.props.type) },
	                this.props.loading == true ? _react2.default.createElement(_ccImports.CCActivityIndicator, { color: this._getFontColor(), size: "s" }) : _react2.default.createElement(
	                    'div',
	                    { className: 'btn cc-button-width', onClick: function onClick() {
	                            !disabled ? _this3._onPressed() : '';
	                        }, disabled: this.props.disabled },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-btn-inner' },
	                        this._getIcon() != null && _react2.default.createElement('img', { src: this._getIcon(), className: 'cc-btn-icon' }),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-btn-title ' + titleClassName, style: { fontFamily: this.props.fontFamily, fontWeight: this.props.fontWeight, color: this._getFontColor() } },
	                            this._getTitle()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCButton;
	}(_react.Component);
	
	CCButton.propTypes = {
	    backgroundColor: _propTypes2.default.string,
	    fontFamily: _propTypes2.default.string,
	    fontWeight: _propTypes2.default.string,
	
	    iconClassName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	
	    height: _propTypes2.default.number,
	
	    loading: _propTypes2.default.bool,
	    onPress: _propTypes2.default.func,
	
	    successMessage: _propTypes2.default.string,
	    success: _propTypes2.default.bool,
	    type: _propTypes2.default.string,
	
	    borderWidth: _propTypes2.default.number,
	    borderColor: _propTypes2.default.string,
	
	    title: _propTypes2.default.string,
	    fontColor: _propTypes2.default.string,
	    titleSize: _propTypes2.default.number,
	    disabled: _propTypes2.default.bool,
	    titleClassName: _propTypes2.default.string,
	
	    analytics: _propTypes2.default.object,
	    darkBackgroundColor: _propTypes2.default.string,
	    darkFontColor: _propTypes2.default.string
	};
	CCButton.defaultProps = {
	    backgroundColor: _ccImports.colors.theme2.bg_color1,
	    fontFamily: "Montserrat",
	    fontWeight: "normal",
	    iconClassName: '',
	    className: '',
	
	    height: 50,
	    loading: false,
	    onPress: function onPress() {},
	    successMessage: '',
	    success: false,
	    type: 'default',
	    title: 'Button',
	    fontColor: _ccImports.colors.theme2.font_color4,
	    titleSize: 18,
	    titleClassName: '',
	    disabled: false,
	
	    theme: 'default',
	    darkBackgroundColor: _ccImports.colors.theme2.bg_color8,
	    darkFontColor: _ccImports.colors.theme2.font_color3
	
	};
	exports.default = CCButton;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCButton = undefined;
	
	var _CCButton = __webpack_require__(272);
	
	var _CCButton2 = _interopRequireDefault(_CCButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCButton = _CCButton2.default;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCCoinPile = undefined;
	
	var _CCCoinPile = __webpack_require__(78);
	
	var _CCCoinPile2 = _interopRequireDefault(_CCCoinPile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCCoinPile = _CCCoinPile2.default;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-coins.css'
	
	
	var CCCoins = function (_Component) {
	    _inherits(CCCoins, _Component);
	
	    function CCCoins(props) {
	        _classCallCheck(this, CCCoins);
	
	        var _this = _possibleConstructorReturn(this, (CCCoins.__proto__ || Object.getPrototypeOf(CCCoins)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCCoins, [{
	        key: 'render',
	        value: function render() {
	            //const resStyles = styles.default;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container parent', style: Object.assign({}, this.props.style) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container coins_base parent-image-background' },
	                    _react2.default.createElement(_ccImports.CCIcon, { className: 'btn cc-coin-icon-s coins-icon', analytics: { event: 'CoinsIconClicked', params: { loggedIn: this.props.loggedIn } },
	                        type: 'coins',
	                        onPress: this.props.onCoinsIconPress }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container coins_text_base coins-image-background' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'btn coins-header-text coins-header' },
	                            this.props.coins
	                        )
	                    ),
	                    _react2.default.createElement(_ccImports.CCIcon, { className: 'btn cc-icon-plus-xxs', analytics: { event: 'AddCoinsClicked', params: { loggedIn: this.props.loggedIn } },
	                        type: 'coinsPlus',
	                        onPress: this.props.onPlusPress })
	                )
	            );
	        }
	    }]);
	
	    return CCCoins;
	}(_react.Component);
	
	CCCoins.propTypes = {
	    height: _propTypes2.default.number,
	    onCoinsIconPress: _propTypes2.default.func,
	    onCoinsPress: _propTypes2.default.func,
	    onPlusPress: _propTypes2.default.func,
	
	    coins: _propTypes2.default.number,
	    loggedIn: _propTypes2.default.bool
	};
	CCCoins.defaultProps = {
	    height: 40,
	    onCoinsIconPress: function onCoinsIconPress() {},
	    onCoinsPress: function onCoinsPress() {},
	    onPlusPress: function onPlusPress() {},
	
	    coins: 1000,
	    loggedIn: false
	};
	exports.default = CCCoins;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCCoins = undefined;
	
	var _CCCoins = __webpack_require__(275);
	
	var _CCCoins2 = _interopRequireDefault(_CCCoins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCCoins = _CCCoins2.default;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCCounter = function (_Component) {
	    _inherits(CCCounter, _Component);
	
	    function CCCounter(props) {
	        _classCallCheck(this, CCCounter);
	
	        var _this = _possibleConstructorReturn(this, (CCCounter.__proto__ || Object.getPrototypeOf(CCCounter)).call(this, props));
	
	        _this.state = {
	            days: 0,
	            hours: 0,
	            minutes: 0,
	            seconds: 0
	        };
	        return _this;
	    }
	
	    _createClass(CCCounter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var date = this.props.date;
	
	            setInterval(function () {
	                _this2.setState(_ccImports.CCUtils.getDateDiff(new Date(date), new Date()));
	            }, 1000);
	            setImmediate(function () {
	                _this2.setState(_ccImports.CCUtils.getDateDiff(new Date(date), new Date()));
	            }, 1000);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                days = _state.days,
	                hours = _state.hours,
	                minutes = _state.minutes,
	                seconds = _state.seconds;
	            var style = this.props.style;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container', style: Object.assign({ justifyContent: 'center', alignItems: 'center' }, style) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container', style: { flex: 1, flexDirection: 'row' } },
	                    _react2.default.createElement(_ccImports.CCCounterItem, { title: (0, _ccImports.strings)('countdown_days'), value: days }),
	                    _react2.default.createElement(_ccImports.CCCounterItem, { title: (0, _ccImports.strings)('countdown_hours'), value: hours, style: { marginLeft: 6 } }),
	                    _react2.default.createElement(_ccImports.CCCounterItem, { title: (0, _ccImports.strings)('countdown_minutes'), value: minutes, style: { marginLeft: 6 } }),
	                    _react2.default.createElement(_ccImports.CCCounterItem, { title: (0, _ccImports.strings)('countdown_seconds'), value: seconds, style: { marginLeft: 6 } })
	                )
	            );
	        }
	    }]);
	
	    return CCCounter;
	}(_react.Component);
	
	CCCounter.propTypes = {};
	CCCounter.defaultProps = {
	    title: 'Hours'
	};
	exports.default = CCCounter;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138).setImmediate))

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(436);
	
	__webpack_require__(445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-counter-item.css'
	
	
	var CCCounterItem = function (_Component) {
	    _inherits(CCCounterItem, _Component);
	
	    function CCCounterItem(props) {
	        _classCallCheck(this, CCCounterItem);
	
	        return _possibleConstructorReturn(this, (CCCounterItem.__proto__ || Object.getPrototypeOf(CCCounterItem)).call(this, props));
	    }
	
	    _createClass(CCCounterItem, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                title = _props.title,
	                value = _props.value;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style },
	                _react2.default.createElement(
	                    "div",
	                    { className: 'flex-container counter-title-container' },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: 'title' },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: 'flex-container counter-value-container' },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: 'title' },
	                        value
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCCounterItem;
	}(_react.Component);
	
	CCCounterItem.propTypes = {};
	CCCounterItem.defaultProps = {
	    title: 'Hours'
	};
	exports.default = CCCounterItem;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCCounterItem = exports.CCCounter = undefined;
	
	var _CCCounter = __webpack_require__(277);
	
	var _CCCounter2 = _interopRequireDefault(_CCCounter);
	
	var _CCCounterItem = __webpack_require__(278);
	
	var _CCCounterItem2 = _interopRequireDefault(_CCCounterItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCCounter = _CCCounter2.default;
	exports.CCCounterItem = _CCCounterItem2.default;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCCrashMe = function (_Component) {
	    _inherits(CCCrashMe, _Component);
	
	    function CCCrashMe(props) {
	        _classCallCheck(this, CCCrashMe);
	
	        var _this = _possibleConstructorReturn(this, (CCCrashMe.__proto__ || Object.getPrototypeOf(CCCrashMe)).call(this, props));
	
	        _this.state = { error: false };
	        return _this;
	    }
	
	    _createClass(CCCrashMe, [{
	        key: "onClick",
	        value: function onClick() {
	            this.setState({ error: true });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            if (this.state.error) {
	                throw new Error("Got error");
	            }
	            return _react2.default.createElement(
	                "button",
	                { onClick: function onClick() {
	                        return _this2.onClick();
	                    } },
	                "Crash me"
	            );
	        }
	    }]);
	
	    return CCCrashMe;
	}(_react.Component);
	
	exports.default = CCCrashMe;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCCrashMe = undefined;
	
	var _CCCrashMe = __webpack_require__(280);
	
	var _CCCrashMe2 = _interopRequireDefault(_CCCrashMe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCCrashMe = _CCCrashMe2.default;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCDailyBonusCounter = function (_Component) {
	    _inherits(CCDailyBonusCounter, _Component);
	
	    function CCDailyBonusCounter(props) {
	        _classCallCheck(this, CCDailyBonusCounter);
	
	        var _this = _possibleConstructorReturn(this, (CCDailyBonusCounter.__proto__ || Object.getPrototypeOf(CCDailyBonusCounter)).call(this, props));
	
	        _this.state = {
	            days: 0,
	            hours: 0,
	            minutes: 0,
	            seconds: 0,
	            date: undefined
	        };
	        return _this;
	    }
	
	    _createClass(CCDailyBonusCounter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var date = this.props.date;
	
	            this.setState({ date: date }, function () {
	                _this2.setInterval(function () {
	                    var date = _this2.state.date;
	
	                    _this2.setState(_ccImports.CCUtils.getDateDiff(new Date(date), new Date()));
	                }, 1000);
	                _this2.setImmediate(function () {
	                    var date = _this2.state.date;
	
	                    _this2.setState(_ccImports.CCUtils.getDateDiff(new Date(date), new Date()));
	                }, 1000);
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (new Date(nextProps.date) != new Date(this.props.date)) {
	                this.setState({ date: nextProps.date });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                hours = _state.hours,
	                minutes = _state.minutes,
	                seconds = _state.seconds;
	            var _props = this.props,
	                style = _props.style,
	                textStyle = _props.textStyle,
	                date = _props.date,
	                onClaimPressed = _props.onClaimPressed;
	
	            var sSize = (0, _ccImports.getSize)();
	            var now = Date.now();
	            var d = new Date(date);
	            return _react2.default.createElement('div', { style: [{ justifyContent: 'center', alignItems: 'center' }, style] });
	        }
	    }]);
	
	    return CCDailyBonusCounter;
	}(_react.Component);
	
	CCDailyBonusCounter.propTypes = {
	    textStyle: _propTypes2.default.object,
	    onClaimPressed: _propTypes2.default.func,
	    date: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	CCDailyBonusCounter.defaultProps = {
	    textStyle: { fontSize: 15 },
	    onClaimPressed: function onClaimPressed() {},
	    date: undefined,
	    style: {}
	};
	exports.default = CCDailyBonusCounter;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCDailyBonusCounter = undefined;
	
	var _CCDailyBonusCounter = __webpack_require__(282);
	
	var _CCDailyBonusCounter2 = _interopRequireDefault(_CCDailyBonusCounter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCDailyBonusCounter = _CCDailyBonusCounter2.default;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCDp = function (_Component) {
	    _inherits(CCDp, _Component);
	
	    function CCDp(props) {
	        _classCallCheck(this, CCDp);
	
	        var _this = _possibleConstructorReturn(this, (CCDp.__proto__ || Object.getPrototypeOf(CCDp)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCDp, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                imageClassName = _props.imageClassName,
	                className = _props.className,
	                imgClass = _props.imgClass;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: this.props.onPress, style: { position: 'relative' }, disabled: this.props.disabled },
	                this.props.loading ? _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 's' }) : _react2.default.createElement('img', { className: imgClass, src: _ccImports.ImageUtils.getProfilePicSrc(this.props.user) }),
	                this.props.user.id && this.props.editable && !this.props.loading && _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container cc-dp-edit-overlay' },
	                    _react2.default.createElement(_ccImports.CCIcon, { onClick: this.props.onPress, className: 'cc_icon_xxxs', type: 'plus' })
	                )
	            );
	        }
	    }]);
	
	    return CCDp;
	}(_react.Component);
	
	CCDp.propTypes = {
	
	    onPress: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool,
	    user: _propTypes2.default.object,
	    loading: _propTypes2.default.bool,
	    editable: _propTypes2.default.bool,
	    isWinner: _propTypes2.default.bool,
	
	    imageClassName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    imgClass: _propTypes2.default.string
	
	};
	CCDp.defaultProps = {
	    onPress: function onPress() {},
	    disabled: false,
	    picture: {},
	    loading: false,
	    editable: false,
	    isWinner: false,
	
	    imageClassName: '',
	    className: '',
	    imgClass: ''
	};
	exports.default = CCDp;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCDp = undefined;
	
	var _CCDp = __webpack_require__(284);
	
	var _CCDp2 = _interopRequireDefault(_CCDp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCDp = _CCDp2.default;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(447);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCEntryItem = function (_Component) {
	    _inherits(CCEntryItem, _Component);
	
	    function CCEntryItem(props) {
	        _classCallCheck(this, CCEntryItem);
	
	        var _this = _possibleConstructorReturn(this, (CCEntryItem.__proto__ || Object.getPrototypeOf(CCEntryItem)).call(this, props));
	
	        _this.state = {};
	        _this._getMessage = _this._getMessage.bind(_this);
	        _this._getScoreRank = _this._getScoreRank.bind(_this);
	        _this._getEntryDetail = _this._getEntryDetail.bind(_this);
	        _this._getCategory = _this._getCategory.bind(_this);
	        _this._isCompleted = _this._isCompleted.bind(_this);
	        _this._getIconType = _this._getIconType.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCEntryItem, [{
	        key: '_getCategory',
	        value: function _getCategory(category) {
	            switch (category) {
	                case 'DREAMTEAM':
	                    return (0, _ccImports.strings)('dream_team');
	                case 'PREDICTION':
	                    return (0, _ccImports.strings)('target_prediction_entry');
	                case 'LIVE_PREDICTION':
	                case 'QUICK_PREDICTION':
	                    return (0, _ccImports.strings)('live_prediction_entry');
	                default:
	                    return '';
	            }
	        }
	    }, {
	        key: '_getScoreRank',
	        value: function _getScoreRank(entry) {
	            if (entry.status == _ccImports.Constants.entryStatus.LIVE || entry.status == _ccImports.Constants.entryStatus.COMPLETED) {
	                var str = '';
	                if (entry.league.category == 'DREAMTEAM') {
	                    str = str + (0, _ccImports.strings)('score') + entry.score + (0, _ccImports.strings)('rank') + entry.rank;
	                } else {
	                    str = str + (0, _ccImports.strings)('rank') + entry.rank;
	                }
	                return _react2.default.createElement(
	                    'h4',
	                    { className: 'cc-entry-item-rank' },
	                    str
	                );
	            } else {
	                return undefined;
	            }
	        }
	    }, {
	        key: '_getMessage',
	        value: function _getMessage(entry) {
	            var message = entry.match.shortName + ' - ' + this._getCategory(entry.league.category);
	
	            return message;
	        }
	    }, {
	        key: '_getEntryDetail',
	        value: function _getEntryDetail(entry) {
	            if (entry.league.category == 'DREAMTEAM') {
	                var dt = '';
	                _lodash2.default.forEach(entry.dreamTeam, function (player, index) {
	                    dt = dt + player.name + (index == entry.dreamTeam.length - 1 ? '' : ', ');
	                });
	                return _react2.default.createElement(
	                    'h4',
	                    { style: { fontSize: 11, color: _ccImports.colors.theme2.font_color2 } },
	                    dt
	                );
	            } else {
	                return _react2.default.createElement(
	                    'h4',
	                    { style: { fontSize: 11, color: _ccImports.colors.theme2.font_color2 } },
	                    entry.prediction
	                );
	            }
	        }
	    }, {
	        key: '_isCompleted',
	        value: function _isCompleted(entry) {
	            return !(entry.status == _ccImports.Constants.entryStatus.LIVE || entry.status == _ccImports.Constants.entryStatus.NOT_STARTED);
	        }
	    }, {
	        key: '_getIconType',
	        value: function _getIconType(league) {
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                    return "dreamTeam";
	                    break;
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return 'livePrediction';
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return 'targetPrediction';
	                    break;
	                default:
	                    return '';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var entry = this.props.entry;
	
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container cc-entry-parent' },
	                    entry.winning && _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-entry-winning' },
	                        _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_icon_entry_win right', type: 'winBanner' }),
	                        entry.rewarded && _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_icon_entry', type: 'rewardBanner' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cc-entry-sub', disabled: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container cc-entry-sub2' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container cc-entry-sub3' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container cc-entry-icon' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container cc-entry-icon-bg' },
	                                        _react2.default.createElement(_ccImports.CCIcon, { className: "cc_league_icon_entry", type: this._getIconType(entry.league) })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container cc-entry-title' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { className: 'cc-entry-title-c' },
	                                        this._getCategory(entry.league.category)
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { className: 'cc-entry-title-sn' },
	                                        entry.match.shortName
	                                    ),
	                                    this._getScoreRank(entry),
	                                    this._getEntryDetail(entry)
	                                ),
	                                entry.winning && _react2.default.createElement(
	                                    'div',
	                                    { className: 'coin-pile-container' },
	                                    _react2.default.createElement(_ccImports.CCCoinPile, { textClass: 'entry-cp-font', iconClass: 'entry-cp-icon', theme: 'dark', coins: entry.coinsEarned })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCEntryItem;
	}(_react.Component);
	
	CCEntryItem.propTypes = {};
	CCEntryItem.defaultProps = {
	    first: false
	};
	exports.default = CCEntryItem;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCEntryItem = undefined;
	
	var _CCEntryItem = __webpack_require__(286);
	
	var _CCEntryItem2 = _interopRequireDefault(_CCEntryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCEntryItem = _CCEntryItem2.default;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-entry-summary-item.css'
	
	
	var CCEntrySummaryItem = function (_Component) {
	    _inherits(CCEntrySummaryItem, _Component);
	
	    function CCEntrySummaryItem(props) {
	        _classCallCheck(this, CCEntrySummaryItem);
	
	        var _this = _possibleConstructorReturn(this, (CCEntrySummaryItem.__proto__ || Object.getPrototypeOf(CCEntrySummaryItem)).call(this, props));
	
	        _this.state = {};
	
	        _this._getDimensions = _this._getDimensions.bind(_this);
	        _this._getTexts = _this._getTexts.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCEntrySummaryItem, [{
	        key: '_getDimensions',
	        value: function _getDimensions() {
	            var dim = { height: 60, width: 60, firstTxtSize: 14, secondTxtSize: 12, thirdTextSize: 12 };
	            switch (this.props.size) {
	                case 's':
	                    //TODO: Implement when required
	                    dim = { height: 60, width: 60, firstTxtSize: 14, secondTxtSize: 12, thirdTextSize: 12 };
	                    break;
	                case 'r':
	                    dim = { height: 70, width: 70, firstTxtSize: 14, secondTxtSize: 12, thirdTextSize: 10 };
	                    break;
	                default:
	                    dim = { height: 60, width: 60, firstTxtSize: 14, secondTxtSize: 12, thirdTextSize: 12 };
	            }
	            return dim;
	        }
	    }, {
	        key: '_getTexts',
	        value: function _getTexts() {
	            var dimension = this._getDimensions();
	            var _props = this.props,
	                entry = _props.entry,
	                placeholder = _props.placeholder,
	                firstText = _props.firstText,
	                secondText = _props.secondText,
	                thirdText = _props.thirdText;
	
	
	            if (!placeholder) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: "flex-container cc-entry-container" },
	                    firstText !== undefined && _react2.default.createElement(
	                        'h1',
	                        { className: 'entry-summary-dp-txt2' },
	                        firstText
	                    ),
	                    secondText !== undefined && _react2.default.createElement(
	                        'h3',
	                        { className: 'entry-summary-dp-txt2' },
	                        secondText
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                entry = _props2.entry,
	                onLongPress = _props2.onLongPress,
	                onPress = _props2.onPress,
	                size = _props2.size,
	                disabled = _props2.disabled,
	                placeholder = _props2.placeholder,
	                placeholderText = _props2.placeholderText;
	
	            var dimension = this._getDimensions();
	
	            var image = _ccImports.ImageUtils.getProfilePicSrc(entry.creator.id);
	
	            //console.log(this.props)
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container  cc-entry-summary-container', onClick: this.props.onPress },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container ', style: { opacity: disabled ? 0.5 : 1, flexDirection: 'column', alignItems: 'center' } },
	                    !placeholder && _react2.default.createElement(_ccImports.CCDp, { user: entry.creator, imgClass: 'entry-summary-dp' }),
	                    this._getTexts(placeholder, dimension, entry),
	                    !placeholder && _react2.default.createElement(
	                        'div',
	                        { className: 'cc-entry-extras-container' },
	                        entry.winning && _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_icon', type: 'winBanner', style: { alignItems: 'flex-end' } }),
	                        entry.rewarded && _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_icon', type: 'rewardBanner', style: { alignItems: 'flex-end' } })
	                    )
	                ),
	                placeholder && _react2.default.createElement(
	                    'div',
	                    { className: 'cc-entry-summary-placeholder-parent ' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "flex-container cc-entry-summary-dp-more" },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'cc-entry-summary-placeholder-txt' },
	                            placeholderText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCEntrySummaryItem;
	}(_react.Component);
	
	CCEntrySummaryItem.propTypes = {
	    entry: _propTypes2.default.object,
	
	    onPress: _propTypes2.default.func,
	    onLongPress: _propTypes2.default.func,
	
	    size: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	
	    placeholder: _propTypes2.default.bool,
	    placeholderText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	    firstText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    secondText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	CCEntrySummaryItem.defaultProps = {
	    entry: {},
	
	    onPress: function onPress() {},
	    onLongPress: function onLongPress() {},
	
	    size: 'r',
	    disabled: false,
	
	    placeholder: false,
	    placeholderText: undefined, PropTypes: _propTypes2.default,
	
	    firstText: undefined,
	    secondText: undefined
	};
	exports.default = CCEntrySummaryItem;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCEntrySummaryItem = undefined;
	
	var _CCEntrySummaryItem = __webpack_require__(288);
	
	var _CCEntrySummaryItem2 = _interopRequireDefault(_CCEntrySummaryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCEntrySummaryItem = _CCEntrySummaryItem2.default;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-flags.css'
	
	
	var CCFlag = function (_Component) {
	    _inherits(CCFlag, _Component);
	
	    function CCFlag() {
	        _classCallCheck(this, CCFlag);
	
	        return _possibleConstructorReturn(this, (CCFlag.__proto__ || Object.getPrototypeOf(CCFlag)).apply(this, arguments));
	    }
	
	    _createClass(CCFlag, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                disabled = _props.disabled,
	                height = _props.height,
	                width = _props.width,
	                borderRadius = _props.borderRadius;
	
	            return _react2.default.createElement(
	                "div",
	                { style: this.props.style },
	                _react2.default.createElement("div", { className: 'flex-container cc-flag', style: Object.assign({ flex: 1, borderColor: '#fff', justifyContent: 'center',
	                        alignItems: 'center', backgroundImage: 'url(' + (0, _ccImports.getFlag)(this.props.teamKey, disabled) + ')',
	                        backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }, this.props.imageStyle) })
	            );
	        }
	    }]);
	
	    return CCFlag;
	}(_react.Component);
	
	CCFlag.propTypes = {
	    borderRadius: _propTypes2.default.string,
	    teamKey: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	};
	CCFlag.defaultProps = {
	    disabled: false
	};
	exports.default = CCFlag;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCFlag = undefined;
	
	var _CCFlag = __webpack_require__(290);
	
	var _CCFlag2 = _interopRequireDefault(_CCFlag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCFlag = _CCFlag2.default;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(450);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCGridItem = function (_Component) {
	    _inherits(CCGridItem, _Component);
	
	    function CCGridItem(props) {
	        _classCallCheck(this, CCGridItem);
	
	        var _this = _possibleConstructorReturn(this, (CCGridItem.__proto__ || Object.getPrototypeOf(CCGridItem)).call(this, props));
	
	        _this.state = {};
	
	        _this.__getFontSize = _this._getFontSize.bind(_this);
	        _this.getDimensions = _this._getDimensions.bind(_this);
	        _this._getImage = _this._getImage.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCGridItem, [{
	        key: '_getImage',
	        value: function _getImage(type, _ref) {
	            var key = _ref.key,
	                flag = _ref.flag;
	
	            switch (type) {
	                case 'country':
	                    return _react2.default.createElement(_ccImports.CCFlag, { teamKey: flag.toLowerCase() });
	                    break;
	                case 'language':
	                    return _react2.default.createElement(_ccImports.CCLang, { imageStyle: { borderWidth: 0 }, code: key.toLowerCase() });
	                    break;
	            }
	        }
	    }, {
	        key: '_getDimensions',
	        value: function _getDimensions() {
	            var height = 60;
	            switch (this.props.size) {
	                case 's':
	                    height = 45;
	                    break;
	                case 'r':
	                    height = 60;
	                    break;
	                default:
	                    height = 60;
	            }
	            return height;
	        }
	    }, {
	        key: '_getFontSize',
	        value: function _getFontSize() {
	            var fontSize = 12;
	            switch (this.props.size) {
	                case 's':
	                    fontSize = 9;
	                    break;
	                case 'r':
	                    fontSize = 12;
	                    break;
	                default:
	                    fontSize = 12;
	            }
	            return fontSize;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                disabled = _props.disabled,
	                type = _props.type,
	                item = _props.item,
	                size = _props.size,
	                selected = _props.selected;
	
	            var dimension = this._getDimensions();
	            var fontSize = this._getFontSize();
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container home-root-container', disabled: disabled, onClick: this.props.onPress },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-container' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            this._getImage(type, item)
	                        ),
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'grid-font', style: { fontSize: fontSize } },
	                            item.name
	                        )
	                    ),
	                    selected && _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container grid-container2' },
	                        _react2.default.createElement(_ccImports.CCIcon, { width: 25, height: 50, type: 'selected' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCGridItem;
	}(_react.Component);
	
	CCGridItem.propTypes = {
	    onPress: _propTypes2.default.func,
	    onLongPress: _propTypes2.default.func,
	    selected: _propTypes2.default.bool,
	
	    size: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    type: _propTypes2.default.string,
	    item: _propTypes2.default.object
	};
	CCGridItem.defaultProps = {
	    onPress: function onPress() {},
	    onLongPress: function onLongPress() {},
	    selected: false,
	
	    size: 'r',
	    disabled: false,
	    type: 'country',
	    item: {}
	};
	exports.default = CCGridItem;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCGridItem = undefined;
	
	var _CCGridItem = __webpack_require__(292);
	
	var _CCGridItem2 = _interopRequireDefault(_CCGridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCGridItem = _CCGridItem2.default;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCIcon = undefined;
	
	var _CCIcon = __webpack_require__(79);
	
	var _CCIcon2 = _interopRequireDefault(_CCIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCIcon = _CCIcon2.default;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(451);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './cc-input.css'
	
	
	var CCInput = function (_Component) {
	    _inherits(CCInput, _Component);
	
	    function CCInput(props) {
	        _classCallCheck(this, CCInput);
	
	        var _this = _possibleConstructorReturn(this, (CCInput.__proto__ || Object.getPrototypeOf(CCInput)).call(this, props));
	
	        _this.handleFocus = function () {
	            return _this.setState({ isFocused: true });
	        };
	
	        _this.handleBlur = function () {
	            return _this.setState({ isFocused: false });
	        };
	
	        _this.state = {
	            isFocused: false,
	            value: null,
	            error: null
	        };
	        _this._validateAndSave = _this._validateAndSave.bind(_this);
	        _this._validate = _this._validate.bind(_this);
	        _this._validateEmail = _this._validateEmail.bind(_this);
	        _this._validateNum = _this._validateNum.bind(_this);
	        _this._isInt = _this._isInt.bind(_this);
	        _this._validateText = _this._validateText.bind(_this);
	        _this._onChangeText = _this._onChangeText.bind(_this);
	        _this._getKeyboardType = _this._getKeyboardType.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            //this._animatedIsFocused = new Animated.Value(this.state.value === null ? 0 : 1);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            /*Animated.timing(this._animatedIsFocused, {
	                toValue: (this.state.isFocused || this.state.value !== null) ? 1 : 0,
	                duration: 200,
	            }).start();*/
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value && nextProps.value != this.props.value) {
	                this.setState({ value: nextProps.value });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.value) {
	                this.setState({ value: this.props.value });
	            }
	        }
	    }, {
	        key: '_validateEmail',
	        value: function _validateEmail(required, email) {
	            var emailErr = this._validateText(required, email);
	
	            if (emailErr) {
	                return emailErr;
	            }
	
	            if (email) {
	                var atpos = email.indexOf("@");
	                var dotpos = email.lastIndexOf(".");
	
	                var emailErr = atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length;
	                if (emailErr) {
	                    return (0, _ccImports.strings)('enter_valid_email');
	                }
	            }
	            return;
	        }
	    }, {
	        key: '_validateText',
	        value: function _validateText(required, value) {
	            var isValid = required == true ? !(value == undefined || value == null || value.length == 0) : true;
	            if (!isValid) {
	                return this.props.requiredErrorText;
	            }
	            return;
	        }
	    }, {
	        key: '_isInt',
	        value: function _isInt(value) {
	            return !isNaN(value) && function (x) {
	                return (x | 0) === x;
	            }(parseFloat(value));
	        }
	    }, {
	        key: '_validateNum',
	        value: function _validateNum(required, value) {
	            var numErr = this._validateText(required, value);
	
	            if (numErr) {
	                return numErr;
	            }
	
	            if (value) {
	                if (!this._isInt(value)) {
	                    return (0, _ccImports.strings)('valid_number');
	                }
	            }
	            return;
	        }
	    }, {
	        key: '_validate',
	        value: function _validate(required, value) {
	            var error = null;
	            switch (this.props.type) {
	                case "email":
	                    error = this._validateEmail(required, value);
	                    break;
	                case 'number':
	                    error = this._validateNum(required, value);
	                    break;
	                default:
	                    error = this._validateText(required, value);
	            }
	
	            if (error) {
	                return error;
	            }
	
	            if (this.props.customValidate) {
	                var customErr = this.props.customValidate(value);
	                if (customErr) {
	                    return customErr;
	                }
	            }
	
	            return;
	        }
	    }, {
	        key: '_validateAndSave',
	        value: function _validateAndSave(value) {
	            var error = this._validate(this.props.required, value);
	            if (!error) {
	                this.props.onEndEditing(this.state.value);
	            }
	            this.setState({ error: error });
	        }
	    }, {
	        key: '_onChangeText',
	        value: function _onChangeText(event) {
	            var value = event.target.value;
	
	            //console.log(' =----  ', value)
	            if (this.props.immediate == true) {
	                var error = this._validate(this.props.required, value);
	                this.setState({
	                    value: value,
	                    error: error
	                });
	                this.props.onEndEditing(error == null ? value : null);
	            } else {
	                this.setState({
	                    value: value
	                });
	            }
	        }
	    }, {
	        key: '_getKeyboardType',
	        value: function _getKeyboardType() {
	            switch (this.props.type) {
	                case 'email':
	                    return 'email-address';
	                case 'number':
	                    return 'numeric';
	                case 'phone':
	                    return 'phone-pad';
	                default:
	                    return 'default';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                label = _props.label,
	                labelProps = _props.labelProps,
	                type = _props.type,
	                editable = _props.editable,
	                labelClassName = _props.labelClassName,
	                inputClassName = _props.inputClassName,
	                errorClassName = _props.errorClassName,
	                className = _props.className,
	                props = _objectWithoutProperties(_props, ['label', 'labelProps', 'type', 'editable', 'labelClassName', 'inputClassName', 'errorClassName', 'className']);
	
	            var textProps = this.props.textProps;
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'cc-input-label-class ' + labelClassName },
	                    label
	                ),
	                _react2.default.createElement('input', Object.assign({ type: type,
	                    editable: editable,
	                    className: 'cc-input ' + inputClassName
	                }, textProps, {
	                    blurOnSubmit: true,
	                    onSubmit: function onSubmit() {
	                        _this2._validateAndSave(_this2.state.value);
	                    },
	                    onBlur: function onBlur() {
	                        _this2._validateAndSave(_this2.state.value);
	                    },
	                    onChange: function onChange(event) {
	                        _this2._onChangeText(event);
	                    }, value: this.state.value,
	                    placeholder: this.state.value === null ? '' : this.props.placeholder,
	                    placeholderTextColor: this.props.placeholderTextColor,
	                    returnKeyType: this.props.returnKeyType,
	                    selectionColor: this.props.selectionColor
	                })),
	                this.state.error != null && _react2.default.createElement(
	                    'h3',
	                    { className: 'cc-error ' + errorClassName },
	                    this.state.error
	                )
	            );
	        }
	    }]);
	
	    return CCInput;
	}(_react.Component);
	
	CCInput.propTypes = {
	    height: _propTypes2.default.number,
	    inputClassName: _propTypes2.default.string,
	    borderBottomWidth: _propTypes2.default.number,
	    borderBottomColor: _propTypes2.default.string,
	    placeholderTextColor: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    selectionColor: _propTypes2.default.string,
	    textProps: _propTypes2.default.object,
	    required: _propTypes2.default.bool,
	    requiredErrorText: _propTypes2.default.string,
	
	    onEndEditing: _propTypes2.default.func,
	    returnKeyType: _propTypes2.default.string,
	
	    className: _propTypes2.default.string,
	
	    error: _propTypes2.default.string,
	    errorClassName: _propTypes2.default.string,
	
	    customValidate: _propTypes2.default.func,
	
	    label: _propTypes2.default.string,
	    labelColor: _propTypes2.default.string,
	    labelEndTop: _propTypes2.default.number,
	    labelClassName: _propTypes2.default.string,
	
	    type: _propTypes2.default.string,
	    immediate: _propTypes2.default.bool,
	    labelProps: _propTypes2.default.object,
	    value: _propTypes2.default.string,
	
	    editable: _propTypes2.default.bool
	};
	CCInput.defaultProps = {
	    height: 40,
	
	    inputFontSize: 18,
	    inputColor: _ccImports.colors.theme.input_text_color,
	    borderBottomWidth: 2,
	    borderBottomColor: _ccImports.colors.theme.input_underline_color2,
	    placeholderTextColor: _ccImports.colors.theme.input_place_holder_color,
	    placeholder: undefined,
	    selectionColor: _ccImports.colors.theme.input_text_color,
	    textProps: {},
	    required: false,
	    requiredErrorText: (0, _ccImports.strings)('required'),
	
	    onEndEditing: function onEndEditing() {},
	    returnKeyType: "next",
	
	    errorClassName: '',
	
	    customValidate: undefined,
	
	    label: "Text Here",
	    labelColor: _ccImports.colors.theme.input_text_color,
	    labelEndTop: 0,
	    labelClassName: '',
	
	    type: 'text',
	    immediate: false,
	    labelProps: {},
	    value: undefined,
	
	    editable: true,
	    className: '',
	    inputClassName: ''
	};
	exports.default = CCInput;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCInput = undefined;
	
	var _CCInput = __webpack_require__(295);
	
	var _CCInput2 = _interopRequireDefault(_CCInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCInput = _CCInput2.default;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(452);
	
	var _CCCoinPile = __webpack_require__(78);
	
	var _CCCoinPile2 = _interopRequireDefault(_CCCoinPile);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCLBStatusItem = function (_Component) {
	    _inherits(CCLBStatusItem, _Component);
	
	    function CCLBStatusItem(props) {
	        _classCallCheck(this, CCLBStatusItem);
	
	        var _this = _possibleConstructorReturn(this, (CCLBStatusItem.__proto__ || Object.getPrototypeOf(CCLBStatusItem)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCLBStatusItem, [{
	        key: '_getTitle',
	        value: function _getTitle(lbStatus, currentUser) {
	            if (currentUser && lbStatus.user && lbStatus.user.id == currentUser.id) {
	                return (0, _ccImports.strings)('you');
	            } else {
	                return lbStatus.user.displayName;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lbStatus = _props.lbStatus,
	                currentUser = _props.currentUser,
	                className = _props.className;
	
	            return _react2.default.createElement(
	                'div',
	                { className: "flex-container lb-parent " + className },
	                _react2.default.createElement(
	                    'div',
	                    { className: "flex-container lb-parent-sub", disabled: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container lb-cointainer3' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'flex-container lb-rank' },
	                            lbStatus.rank
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container', style: { flex: 1, position: 'relative' } },
	                            _react2.default.createElement(_ccImports.CCDp, { isWinner: true, user: lbStatus.user, width: 50, imgClass: 'leader-board-dp' }),
	                            lbStatus.rewardWinning && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container lb-winner' },
	                                _react2.default.createElement(_ccImports.CCIcon, { onPress: this.props.onPress, className: 'cc-icon-xxs', type: 'winnerBadge' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container lb-cointainer' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'lb-user-name' },
	                            this._getTitle(lbStatus, currentUser)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container lb-cointainer2 alt-right' },
	                        _react2.default.createElement(_CCCoinPile2.default, { theme: 'dark', textClass: 'coin-pile-font', iconClass: 'coin-pile-icon', coins: lbStatus.coins })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCLBStatusItem;
	}(_react.Component);
	
	CCLBStatusItem.propTypes = {
	    className: _propTypes2.default.string
	};
	CCLBStatusItem.defaultProps = {
	    first: false,
	    className: ''
	};
	exports.default = CCLBStatusItem;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLBStatusItem = undefined;
	
	var _CCLBStatusItem = __webpack_require__(297);
	
	var _CCLBStatusItem2 = _interopRequireDefault(_CCLBStatusItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLBStatusItem = _CCLBStatusItem2.default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './gradient-btn.css'
	// import './gradient-btn-320x720.css'
	
	
	var CCLGButton = function (_Component) {
	    _inherits(CCLGButton, _Component);
	
	    function CCLGButton(props) {
	        _classCallCheck(this, CCLGButton);
	
	        return _possibleConstructorReturn(this, (CCLGButton.__proto__ || Object.getPrototypeOf(CCLGButton)).call(this, props));
	    }
	
	    _createClass(CCLGButton, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                textStyles = _props.textStyles,
	                buttonStyles = _props.buttonStyles,
	                title = _props.title,
	                colors = _props.colors;
	
	            var styles = ccStyles.default;
	            return _react2.default.createElement(
	                "button",
	                { onClick: this.props.onPress, className: 'gradient-button btn ' + this.props.className + ' ' + (this.props.completed ? 'gradient-button-disabled' : ''), style: style },
	                title
	            );
	        }
	    }]);
	
	    return CCLGButton;
	}(_react.Component);
	
	CCLGButton.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    textStyles: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.shape({})]),
	    onPress: _propTypes2.default.func,
	    buttonStyles: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.shape({})])
	};
	CCLGButton.defaultProps = {
	    gradient: false,
	    start: {},
	    end: {},
	    locations: [],
	    colors: [],
	    onPress: function onPress() {}
	};
	
	
	var ccStyles = {
	    default: {
	        buttonStyles: {
	            width: 100,
	            borderRadius: 25
	        },
	        textStyles: {
	            alignSelf: 'center',
	            color: '#020202',
	            fontSize: 16,
	            fontWeight: '900',
	            paddingTop: 10,
	            paddingBottom: 10
	        }
	    },
	    s: {
	        buttonStyles: {
	            width: 80,
	            borderRadius: 25
	        },
	        textStyles: {
	            fontSize: 14
	        }
	    }
	};
	exports.default = CCLGButton;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLGButton = undefined;
	
	var _CCLGButton = __webpack_require__(299);
	
	var _CCLGButton2 = _interopRequireDefault(_CCLGButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLGButton = _CCLGButton2.default;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCLang = function (_Component) {
	    _inherits(CCLang, _Component);
	
	    function CCLang() {
	        _classCallCheck(this, CCLang);
	
	        return _possibleConstructorReturn(this, (CCLang.__proto__ || Object.getPrototypeOf(CCLang)).apply(this, arguments));
	    }
	
	    _createClass(CCLang, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "flex-container" },
	                _react2.default.createElement("img", { style: { height: 60, width: 60, marginLeft: 15 }, src: (0, _ccImports.getLang)(this.props.code) })
	            );
	        }
	    }]);
	
	    return CCLang;
	}(_react.Component);
	
	CCLang.propTypes = {
	
	    key: _propTypes2.default.string
	};
	CCLang.defaultProps = {
	    width: 50,
	    height: 50,
	    key: 'en'
	};
	exports.default = CCLang;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLang = undefined;
	
	var _CCLang = __webpack_require__(301);
	
	var _CCLang2 = _interopRequireDefault(_CCLang);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLang = _CCLang2.default;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(454);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-league-item.css'
	// import './cc-league-item-320x720.css'
	
	
	var CCLeagueItem = function (_Component) {
	    _inherits(CCLeagueItem, _Component);
	
	    function CCLeagueItem(props) {
	        _classCallCheck(this, CCLeagueItem);
	
	        var _this = _possibleConstructorReturn(this, (CCLeagueItem.__proto__ || Object.getPrototypeOf(CCLeagueItem)).call(this, props));
	
	        _this.state = {};
	        _this._getTitle = _this._getTitle.bind(_this);
	        _this._getIconType = _this._getIconType.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCLeagueItem, [{
	        key: '_getTitle',
	        value: function _getTitle(league) {
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                    return (0, _ccImports.strings)('dream_team');
	                    break;
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return (0, _ccImports.strings)('live_prediction');
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return (0, _ccImports.strings)('target_prediction');
	                    break;
	                default:
	                    return (0, _ccImports.strings)('cricrush_league');
	            }
	        }
	    }, {
	        key: '_getDescription',
	        value: function _getDescription(league) {
	            var qps = league.quickPredictionDetails;
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                    return (0, _ccImports.strings)('pick_team');
	                    break;
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return (0, _ccImports.strings)('predict_what_message', { teamName: qps.team.toUpperCase(), startOver: qps.startOver, endOver: qps.endOver });
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return (0, _ccImports.strings)('predict_score');
	                    break;
	                default:
	                    return (0, _ccImports.strings)('cricrush_league');
	            }
	        }
	    }, {
	        key: '_getCoins',
	        value: function _getCoins(league) {
	            var coins = league.coinsPerEntry;
	            switch (league.type) {
	                case _ccImports.Constants.leagueType.DOUBLE:
	                    return coins * 2;
	                    break;
	                case _ccImports.Constants.leagueType.TRIPLE:
	                    return coins * 3;
	                    break;
	                case _ccImports.Constants.leagueType.QUADRUPLE:
	                    return coins * 4;
	                    break;
	                case _ccImports.Constants.leagueType.QUINTUPLE:
	                    return coins * 5;
	                    break;
	                default:
	                    return coins * 100;
	            }
	        }
	    }, {
	        key: '_getIconType',
	        value: function _getIconType(league) {
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                    return "dreamTeam";
	                    break;
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return 'livePrediction';
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return 'targetPrediction';
	                    break;
	                default:
	                    return '';
	            }
	        }
	    }, {
	        key: '_getTitle3',
	        value: function _getTitle3(league) {
	            var title = (0, _ccImports.strings)('entries_left2', { noOfEntries: league.maxEntries - league.noOfEntries });
	            if (league.noOfEntries >= 2) {
	                title = (0, _ccImports.strings)('view_entries', { noOfEntries: league.noOfEntries });
	            }
	            return title;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var league = this.props.league;
	
	            var styles = ccStyles.default;
	            var disabled = _ccImports.Constants.leagueStatus.isCompleted(league.status) || _ccImports.Constants.leagueStatus.LIVE == league.status;
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container btn', style: Object.assign({ flex: 1 }, this.props.style) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-league-item-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container icon-container' },
	                            disabled === true && _react2.default.createElement(
	                                'div',
	                                { className: "flex-container league-icon-disabled" },
	                                _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_1_icon', type: this._getIconType(league) })
	                            ),
	                            disabled === false && _react2.default.createElement(
	                                'div',
	                                { className: "flex-container league-icon" },
	                                _react2.default.createElement(_ccImports.CCIcon, { className: 'cc_league_1_icon', type: this._getIconType(league) })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container league-content-container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container league-container' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'title', style: { color: disabled ? _ccImports.colors.theme2.font_color5 : _ccImports.colors.theme2.font_color4 }, onClick: function onClick() {
	                                            _this2.props.onPress(league);
	                                        } },
	                                    this._getTitle(league)
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'description', style: { color: disabled ? _ccImports.colors.theme2.font_color5 : _ccImports.colors.theme2.font_color4 }, onClick: function onClick() {
	                                            _this2.props.onPress(league);
	                                        } },
	                                    this._getDescription(league)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { justifyContent: 'left' } },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'entry-left', style: { color: disabled ? _ccImports.colors.theme2.font_color5 : _ccImports.colors.theme2.font_color4 }, onClick: function onClick() {
	                                            _this2.props.onEntriesPress(league);
	                                        } },
	                                    this._getTitle3(league)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container league-container2' },
	                            _react2.default.createElement(_ccImports.CCCoinPile, { textClass: 'league-coin-font', iconClass: 'league-coin-icon', coins: this._getCoins(league), theme: 'dark', disabled: false, uiDisabled: disabled })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCLeagueItem;
	}(_react.Component);
	
	CCLeagueItem.propTypes = {
	    onPress: _propTypes2.default.func,
	    onEntriesPress: _propTypes2.default.func,
	    league: _propTypes2.default.object
	};
	CCLeagueItem.defaultProps = {
	    onPress: function onPress() {},
	    onEntriesPress: function onEntriesPress() {}
	};
	exports.default = CCLeagueItem;
	
	
	var ccStyles = {
	    default: {
	        container: {
	            height: 70
	        },
	        leagueIcon: {
	            height: 40, width: 40
	        },
	        leagueTitle: {
	            fontSize: 13
	        },
	        leagueSubTitle: {
	            fontSize: 11
	        },
	        entriesLeft: {
	            fontSize: 13
	        },
	        coinsPileSize: 's'
	    },
	    s: {
	        container: {
	            height: 60
	        },
	        leagueIcon: {
	            height: 30, width: 30
	        },
	        leagueTitle: {
	            fontSize: 11
	        },
	        leagueSubTitle: {
	            fontSize: 10
	        },
	        entriesLeft: {
	            fontSize: 11
	        },
	        coinsPileSize: 'xs'
	    }
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLeagueItem = undefined;
	
	var _CCLeagueItem = __webpack_require__(303);
	
	var _CCLeagueItem2 = _interopRequireDefault(_CCLeagueItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLeagueItem = _CCLeagueItem2.default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(455);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCLeaguesGroup = function (_Component) {
	    _inherits(CCLeaguesGroup, _Component);
	
	    function CCLeaguesGroup(props) {
	        _classCallCheck(this, CCLeaguesGroup);
	
	        var _this = _possibleConstructorReturn(this, (CCLeaguesGroup.__proto__ || Object.getPrototypeOf(CCLeaguesGroup)).call(this, props));
	
	        _this.state = {};
	
	        _this._onBannerPressed = _this._onBannerPressed.bind(_this);
	        _this._onLeaguePressed = _this._onLeaguePressed.bind(_this);
	        _this._onEntryCountPressed = _this._onEntryCountPressed.bind(_this);
	        _this._onInfoPressed = _this._onInfoPressed.bind(_this);
	        _this._getHelpDetails = _this._getHelpDetails.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCLeaguesGroup, [{
	        key: '_onLeaguePressed',
	        value: function _onLeaguePressed(league) {
	            this.props.leaguePressed(league);
	        }
	    }, {
	        key: '_onEntryCountPressed',
	        value: function _onEntryCountPressed(league) {
	            this.props.entryCountPressed(league);
	        }
	    }, {
	        key: '_onInfoPressed',
	        value: function _onInfoPressed(sponsor) {
	            this.props.sponsorBannerPressed(sponsor);
	            console.log(this.props.sponsorBannerPressed(sponsor), 'ffffffffffff');
	        }
	    }, {
	        key: '_onBannerPressed',
	        value: function _onBannerPressed(sponsor) {
	            this.props.infoPressed(sponsor);
	            console.log(this.props.infoPressed(sponsor), 'aaaaaaaaaaaaa');
	        }
	    }, {
	        key: '_getPromoDetails',
	        value: function _getPromoDetails(sponsor) {
	            //return {}
	            var currUser = this.props.currUser;
	            if (currUser) {
	                return sponsor && sponsor.promoDetails && (sponsor.promoDetails[currUser.country] || sponsor.promoDetails['ALL']);
	            } else {
	                return;
	            }
	        }
	    }, {
	        key: '_getHelpDetails',
	        value: function _getHelpDetails(league) {
	            return this.props.getHelpDetails(league);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                leagueGroup = _props.leagueGroup,
	                currUser = _props.currUser;
	            var sponsor = leagueGroup.sponsor,
	                matchCompleted = leagueGroup.matchCompleted;
	
	
	            if (sponsor == undefined) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container cc-leagues-group', style: Object.assign({}, this.props.style) },
	                    leagueGroup.leagues && leagueGroup.leagues.map(function (league, index) {
	                        return _react2.default.createElement(_ccImports.CCLeagueItem, { onEntriesPress: _this2._onEntryCountPressed, onPress: _this2._onLeaguePressed, league: league, key: index, style: { marginTop: 10, marginRight: 20, marginLeft: 20 } });
	                    })
	                );
	            } else {
	                return _react2.default.createElement(
	                    _CCErrorBoundary2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-leagues-group', style: { backgroundColor: matchCompleted ? _ccImports.colors.theme2.bg_color11 : _ccImports.colors.theme2.bg_color7 } },
	                        sponsor && _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container sponsor-container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1 } },
	                                sponsor.theme && sponsor.theme.sGrpBannerImg && _react2.default.createElement(
	                                    'div',
	                                    { className: "btn", disabled: currUser == undefined || this._getPromoDetails(sponsor) == undefined, style: { flex: 1, marginRight: 5 }, onPress: function onPress() {
	                                            _this2._onBannerPressed(leagueGroup.sponsor);
	                                        } },
	                                    _react2.default.createElement('img', { className: 'sponsor-img', src: sponsor.theme.sGrpBannerImg })
	                                )
	                            ),
	                            this._getPromoDetails(sponsor) && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container helper-icon' },
	                                _react2.default.createElement(_ccImports.CCIcon, { className: "btn cc-icon-m cc-info-icon", onPress: function onPress() {
	                                        _this2._onInfoPressed(leagueGroup.sponsor);
	                                    },
	                                    type: "info"
	                                })
	                            )
	                        ),
	                        leagueGroup.leagues && leagueGroup.leagues.map(function (league, index) {
	                            return _react2.default.createElement(_ccImports.CCLeagueItem, { helpDetails: _this2._getHelpDetails(league), onEntriesPress: _this2._onEntryCountPressed, onPress: _this2._onLeaguePressed, style: { margin: 10 }, league: league, key: index });
	                        })
	                    )
	                );
	            }
	        }
	    }]);
	
	    return CCLeaguesGroup;
	}(_react.Component);
	
	CCLeaguesGroup.propTypes = {
	    leaguePressed: _propTypes2.default.func,
	    entryCountPressed: _propTypes2.default.func,
	
	    infoPressed: _propTypes2.default.func,
	    sponsorBannerPressed: _propTypes2.default.func,
	    currUser: _propTypes2.default.object,
	    getHelpDetails: _propTypes2.default.func
	
	};
	CCLeaguesGroup.defaultProps = {
	    leaguePressed: function leaguePressed() {},
	    entryCountPressed: function entryCountPressed() {},
	
	    infoPressed: function infoPressed() {},
	    sponsorBannerPressed: function sponsorBannerPressed() {},
	    currUser: {},
	    getHelpDetails: function getHelpDetails() {}
	};
	exports.default = CCLeaguesGroup;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLeaguesGroup = undefined;
	
	var _CCLeaguesGroup = __webpack_require__(305);
	
	var _CCLeaguesGroup2 = _interopRequireDefault(_CCLeaguesGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLeaguesGroup = _CCLeaguesGroup2.default;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCListView = undefined;
	
	var _CCListView = __webpack_require__(39);
	
	var _CCListView2 = _interopRequireDefault(_CCListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCListView = _CCListView2.default;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './cc-more-modal-item.css'
	
	var SideBarItem = function (_Component) {
	    _inherits(SideBarItem, _Component);
	
	    function SideBarItem(props) {
	        _classCallCheck(this, SideBarItem);
	
	        var _this = _possibleConstructorReturn(this, (SideBarItem.__proto__ || Object.getPrototypeOf(SideBarItem)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(SideBarItem, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                dpLoading = _props.dpLoading,
	                dpEditable = _props.dpEditable;
	
	
	            if (this.props.type === 'user') {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container btn', onClick: this.props.onPress },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-more-modal-user' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: "flex-container cc-more-modal-user-dp" },
	                            _react2.default.createElement(_ccImports.CCDp, { imgClass: 'profile-dp', loading: dpLoading, editable: dpEditable, onClick: this.props.onDpPress, user: user })
	                        ),
	                        user.id ? _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container cc-more-modal-user-profile' },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'cc-more-modal-user-name' },
	                                user.displayName
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'cc-more-modal-user-email' },
	                                user.email
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            { className: "flex-container cc-more-modal-user-profile" },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'cc-more-modal-user-login-title' },
	                                (0, _ccImports.strings)('login_register')
	                            )
	                        )
	                    )
	                );
	            } else if (this.props.type == 'content') {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container shadow btn cc-more-modal-content', onClick: this.props.onPress },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container cc-more-modal-content-sub' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container cc-more-modal-content-sub2' },
	                            _react2.default.createElement(_ccImports.CCIcon, { className: 'cc-icon-s cc-more-modal-icon', type: this.props.name.toLowerCase() }),
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'flex-container cc-more-modal-content-title' },
	                                this.props.title
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return SideBarItem;
	}(_react.Component);
	
	SideBarItem.propTypes = {
	    type: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onPress: _propTypes2.default.func,
	
	    onDpPress: _propTypes2.default.func,
	    dpEditable: _propTypes2.default.bool,
	    dpLoading: _propTypes2.default.bool
	
	};
	SideBarItem.defaultProps = {
	    type: 'content',
	    name: '',
	    text: '',
	
	    onPress: function onPress() {},
	    onDpPress: function onDpPress() {},
	    dpEditable: false,
	    dpLoading: false
	};
	exports.default = SideBarItem;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCMoreModalItem = undefined;
	
	var _CCMoreModalItem = __webpack_require__(308);
	
	var _CCMoreModalItem2 = _interopRequireDefault(_CCMoreModalItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCMoreModalItem = _CCMoreModalItem2.default;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './notification-item.css'
	
	
	var CCNotificationItem = function (_Component) {
	    _inherits(CCNotificationItem, _Component);
	
	    function CCNotificationItem(props) {
	        _classCallCheck(this, CCNotificationItem);
	
	        var _this = _possibleConstructorReturn(this, (CCNotificationItem.__proto__ || Object.getPrototypeOf(CCNotificationItem)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCNotificationItem, [{
	        key: '_getTitle',
	        value: function _getTitle(notification) {
	            switch (notification.type) {
	                case 'MATCH_SUMMARY':
	                    var formatDate = new Date(notification.match.date).toLocaleDateString("en-US", {
	                        year: '2-digit',
	                        month: 'short',
	                        day: 'numeric'
	                    });
	                    return notification.match.shortName + ' - ' + formatDate;
	                    break;
	                case 'INVITATION_ACCEPTED':
	                    var isInvitee = this.props.userId == notification.invitee.id;
	                    if (isInvitee) {
	                        return (0, _ccImports.strings)('received_invitation_bonus');
	                    } else {
	                        return (0, _ccImports.strings)('invitation_accepted');
	                    }
	                    break;
	                case 'REWARD_NOTIFICATION':
	                    return _ccImports.CCUIUtils.getLocaleStr(notification.title);
	                    break;
	            }
	        }
	    }, {
	        key: '_getMessage',
	        value: function _getMessage(ntfn) {
	            switch (ntfn.type) {
	                case 'MATCH_SUMMARY':
	                    //console.log(ntfn,'thanu')
	
	                    return (0, _ccImports.strings)('won_lost_refunded_coins', { earnedCoins: ntfn.earnedCoins, lostCoins: ntfn.lostCoins, refundedCoins: ntfn.refundedCoins });
	                    break;
	                case 'INVITATION_ACCEPTED':
	                    var isInvitee = this.props.userId == ntfn.invitee.id;
	                    if (isInvitee) {
	                        return (0, _ccImports.strings)('accepted_invitation_from', { invitedBy: ntfn.invitedBy.displayName, coins: ntfn.coins });
	                        break;
	                    } else {
	                        return (0, _ccImports.strings)('accepted_invitation_from_friend', { displayName: ntfn.invitee.displayName, coins: ntfn.coins });
	                    }
	                    break;
	                case 'REWARD_NOTIFICATION':
	                    return _ccImports.CCUIUtils.getLocaleStr(ntfn.message);
	            }
	        }
	    }, {
	        key: '_getButtonTitle',
	        value: function _getButtonTitle(ntfn) {
	            switch (ntfn.reward.status) {
	                case _ccImports.Constants.rewardStatus.CREATED:
	                    return (0, _ccImports.strings)('claim');
	                    break;
	                case _ccImports.Constants.rewardStatus.CLAIMED:
	                case _ccImports.Constants.rewardStatus.PROCESSED:
	                    return (0, _ccImports.strings)('view_button');
	                default:
	                    return (0, _ccImports.strings)('claim');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var notification = this.props.notification;
	            // console.log(notification,'aaa')
	
	
	            var time = _ccImports.CCUtils.formatTime(notification.createdDate);
	            return _react2.default.createElement(
	                'div',
	                { className: 'item flex-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: ' sub-item flex-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container first-row' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            this._getTitle(notification)
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'f-color' },
	                            time
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container second-row' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'msg' },
	                            this._getMessage(notification)
	                        ),
	                        notification.type == 'REWARD_NOTIFICATION' && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_ccImports.CCButton, { type: 'dark', className: 'ntfn-rwd-btn', titleClassName: 'btnTxt', title: this._getButtonTitle(notification), onPress: this.props.onClaim, loading: this.state.fbLoading })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCNotificationItem;
	}(_react.Component);
	
	CCNotificationItem.propTypes = {
	    onClaim: _propTypes2.default.func,
	    userId: _propTypes2.default.string
	};
	CCNotificationItem.defaultProps = {
	    first: false,
	    onClaim: function onClaim() {},
	    userId: undefined
	};
	exports.default = CCNotificationItem;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCNotificationItem = undefined;
	
	var _CCNotificationItem = __webpack_require__(310);
	
	var _CCNotificationItem2 = _interopRequireDefault(_CCNotificationItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCNotificationItem = _CCNotificationItem2.default;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(459);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './cc-player-item.css'
	
	
	var CCPlayerItem = function (_Component) {
	    _inherits(CCPlayerItem, _Component);
	
	    function CCPlayerItem(props) {
	        _classCallCheck(this, CCPlayerItem);
	
	        var _this = _possibleConstructorReturn(this, (CCPlayerItem.__proto__ || Object.getPrototypeOf(CCPlayerItem)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CCPlayerItem, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                player = _props.player,
	                index = _props.index,
	                size = _props.size,
	                disabled = _props.disabled;
	
	            var image = player.key ? (0, _ccImports.getIcon)('player' + index) : (0, _ccImports.getIcon)('player0');
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container cc-player-item-container', disabled: disabled, onClick: function onClick() {
	                            if (!disabled) _this2.props.onPress();
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container',
	                            style: { opacity: disabled ? 0.5 : 1, flexDirection: 'column', alignItems: 'center' } },
	                        _react2.default.createElement('img', { src: image, className: 'cc-player-item-img' }),
	                        player.name != undefined && _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-player-item-title' },
	                            player.name
	                        ),
	                        player.salary != undefined && _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-player-item-title' },
	                            '$' + player.salary
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCPlayerItem;
	}(_react.Component);
	
	CCPlayerItem.propTypes = {
	    onPress: _propTypes2.default.func,
	    onLongPress: _propTypes2.default.func,
	
	    size: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	};
	CCPlayerItem.defaultProps = {
	    onPress: function onPress() {},
	    onLongPress: function onLongPress() {},
	
	    size: 'r',
	    disabled: false
	};
	exports.default = CCPlayerItem;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCPlayerItem = undefined;
	
	var _CCPlayerItem = __webpack_require__(312);
	
	var _CCPlayerItem2 = _interopRequireDefault(_CCPlayerItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCPlayerItem = _CCPlayerItem2.default;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(461);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './transaction-item.css'
	
	
	var TransactionItem = function (_Component) {
	    _inherits(TransactionItem, _Component);
	
	    function TransactionItem(props) {
	        _classCallCheck(this, TransactionItem);
	
	        var _this = _possibleConstructorReturn(this, (TransactionItem.__proto__ || Object.getPrototypeOf(TransactionItem)).call(this, props));
	
	        _this.state = {};
	        _this._getMessage = _this._getMessage.bind(_this);
	        _this._getTitle = _this._getTitle.bind(_this);
	        _this._getBackgroundColor = _this._getBackgroundColor.bind(_this);
	        _this._getCategory = _this._getCategory.bind(_this);
	        return _this;
	    }
	
	    _createClass(TransactionItem, [{
	        key: '_getCategory',
	        value: function _getCategory(category) {
	            switch (category) {
	                case 'DREAMTEAM':
	                    return 'DREAM TEAM';
	                case 'PREDICTION':
	                    return 'TARGET PREDICTION';
	                case 'LIVE_PREDICTION':
	                    return 'LIVE PREDICTION';
	                default:
	                    return '';
	            }
	        }
	    }, {
	        key: '_getMessage',
	        value: function _getMessage(transaction) {
	            var message = ' ';
	            if (transaction.type == 'INVITE_FRIENDS') {
	                message = (0, _ccImports.strings)('friend_invite_accepted', { friendName: transaction.friend.displayName });
	            } else if (transaction.type == 'ENTRY_CREATION' || transaction.type == 'ENTRY_WON' || transaction.type == 'ENTRY_REFUND' || transaction.type == 'ENTRY_LOST') {
	
	                message = transaction.entry.match.shortName + ' - ' + this._getCategory(transaction.entry.league.category);
	                switch (transaction.type) {
	                    case 'ENTRY_LOST':
	                        message = message + (0, _ccImports.strings)('lost');
	                        break;
	                    case 'ENTRY_WON':
	                        message = message + (0, _ccImports.strings)('won');
	                        break;
	                    case 'ENTRY_REFUND':
	                        message = message + (0, _ccImports.strings)('refunded');
	                        break;
	                    case 'ENTRY_CREATION':
	                        message = message + (0, _ccImports.strings)('entry_created');
	                        break;
	                    default:
	                        return _ccImports.colors.theme.bg_color10;
	                }
	            } else if (transaction.type == 'REWARD_CLAIMED') {
	                message = (0, _ccImports.strings)('reward_claimed_title', { reference: transaction.reward.reference });
	            } else if (transaction.type == 'DAILY_LOGIN_BONUS') {
	                message = (0, _ccImports.strings)('daily_login_bonus');
	            } else {
	                message = _ccImports.CCUIUtils.getLocaleStr(transaction.message);
	            }
	
	            return message;
	        }
	    }, {
	        key: '_getTitle',
	        value: function _getTitle(transaction) {
	            var title = "";
	            if (transaction.type == 'INVITE_FRIENDS') {
	                title = (0, _ccImports.strings)('invitation_bonus');
	            } else if (transaction.type == 'ENTRY_CREATION' || transaction.type == 'ENTRY_WON' || transaction.type == 'ENTRY_REFUND' || transaction.type == 'ENTRY_LOST') {
	                switch (transaction.entry.league.category) {
	                    case 'DREAMTEAM':
	                        transaction.entry.dreamTeam.map(function (player, index) {
	                            if (index == 0) {
	                                title += player.name;
	                            } else {
	                                title += ', ' + player.name;
	                            }
	                        });
	                        break;
	                    case 'PREDICTION':
	                        title = (0, _ccImports.strings)('your_prediction', { prediction: transaction.entry.prediction });
	                        break;
	                    case 'MOM':
	                        title = (0, _ccImports.strings)('your_mom_entry', { momEntry: transaction.entry.momEntry.name });
	
	                        break;
	                    case 'LIVE_PREDICTION':
	                    case 'QUICK_PREDICTION':
	                        title = (0, _ccImports.strings)('your_live_prediction_entry', { prediction: transaction.entry.prediction });
	                        break;
	                }
	            } else if (transaction.type == 'REWARD_CLAIMED') {
	                title = (0, _ccImports.strings)('reward_claimed_msg', { reference: transaction.reward.reference });
	            } else if (transaction.type == 'DAILY_LOGIN_BONUS') {
	                title = (0, _ccImports.strings)('daily_login_bonus_claimed');
	            } else {
	                title = _ccImports.CCUIUtils.getLocaleStr(transaction.title);
	            }
	
	            return title;
	        }
	    }, {
	        key: '_getBackgroundColor',
	        value: function _getBackgroundColor(transaction) {
	            switch (transaction.type) {
	                case 'ENTRY_LOST':
	                    return _ccImports.colors.theme.bg_color6;
	                    break;
	                case 'ENTRY_WON':
	                    return _ccImports.colors.theme.bg_color10;
	                    break;
	                case 'ENTRY_REFUND':
	                    return _ccImports.colors.theme.bg_color13;
	                    break;
	                case 'ENTRY_CREATION':
	                    return _ccImports.colors.theme.bg_color6;
	                    break;
	                case 'INVITE_FRIENDS':
	                    return _ccImports.colors.theme.bg_color10;
	                    break;
	                default:
	                    return _ccImports.colors.theme.bg_color10;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var transaction = this.props.transaction;
	            var bgColor = this._getBackgroundColor(transaction);
	
	            var title = this._getTitle(transaction);
	            var message = this._getMessage(transaction);
	            var time = _ccImports.CCUtils.formatTime(transaction.date);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cc-transaction-container', style: Object.assign({}, this.props.style) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container transaction-bg' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container transaction-title' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cc-transaction-container3' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-transaction' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { className: 'title' },
	                                        message
	                                    ),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'time' },
	                                        time
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1 } },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'title3' },
	                                    title
	                                ),
	                                _react2.default.createElement(_ccImports.CCCoinPile, { className: 'flex-container flex-transaction', textClass: 'transaction-coin-font', iconClass: 'transaction-coin-icon', theme: 'dark',
	                                    coins: transaction.coins, style: { height: '5vw' } })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TransactionItem;
	}(_react.Component);
	
	TransactionItem.propTypes = {};
	TransactionItem.defaultProps = { first: false };
	exports.default = TransactionItem;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCTransactionItem = undefined;
	
	var _CCTransactionItem = __webpack_require__(314);
	
	var _CCTransactionItem2 = _interopRequireDefault(_CCTransactionItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCTransactionItem = _CCTransactionItem2.default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	var _reactRouterDom = __webpack_require__(36);
	
	__webpack_require__(462);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './SimpleMatchDetails.css';
	// import './SimpleMatchDetails_320.css';
	
	
	var getFontColor = function getFontColor(active, ccMatch) {
	    if (ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED) {
	        return _ccImports.colors.theme2.font_color5;
	    } else {
	        return active ? _ccImports.colors.theme2.font_color3 : _ccImports.colors.theme2.font_color5;
	    }
	};
	
	var InningsScore = function (_Component) {
	    _inherits(InningsScore, _Component);
	
	    function InningsScore() {
	        _classCallCheck(this, InningsScore);
	
	        var _this = _possibleConstructorReturn(this, (InningsScore.__proto__ || Object.getPrototypeOf(InningsScore)).call(this));
	
	        _this._getOvers = _this._getOvers.bind(_this);
	        _this._getWickets = _this._getWickets.bind(_this);
	        _this._getRuns = _this._getRuns.bind(_this);
	        return _this;
	    }
	
	    _createClass(InningsScore, [{
	        key: '_getRuns',
	        value: function _getRuns(innings) {
	            if (innings) return innings.runs;else return 0;
	        }
	    }, {
	        key: '_getWickets',
	        value: function _getWickets(innings) {
	            if (innings) return innings.wickets;else return 0;
	        }
	    }, {
	        key: '_getOvers',
	        value: function _getOvers(innings) {
	            if (innings) return innings.overs;else return 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                inningses = _props.inningses,
	                ccMatch = _props.ccMatch,
	                active = _props.active;
	
	            var filteredInnings = _lodash2.default.filter(inningses, function (innings) {
	                return innings.balls > 0;
	            });
	            var totalInnings = filteredInnings.length;
	            if (totalInnings == 2) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: this.props.style },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flexDirection: 'row', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'cc-score-txt_0_8', style: { color: getFontColor(active, ccMatch) } },
	                            this._getRuns(inningses[0])
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-score-txt_0_8', style: { color: getFontColor(active, ccMatch) } },
	                            '&'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'cc-score-txt_1_0', style: { color: getFontColor(active, ccMatch) } },
	                            this._getRuns(inningses[1]) + '/' + this._getWickets(inningses[1])
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-score-txt_1_0', style: { color: getFontColor(active, ccMatch) } },
	                            '(' + this._getOvers(inningses[1]) + ')'
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'cc-score-txt_1_0', style: { color: getFontColor(active, ccMatch) } },
	                        this._getRuns(inningses[0]) + '/' + this._getWickets(inningses[0])
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'cc-score-txt_1_0', style: { color: getFontColor(active, ccMatch) } },
	                        '(' + this._getOvers(inningses[0]) + ')'
	                    )
	                );
	            }
	        }
	    }]);
	
	    return InningsScore;
	}(_react.Component);
	
	var Score = function (_Component2) {
	    _inherits(Score, _Component2);
	
	    function Score(props) {
	        _classCallCheck(this, Score);
	
	        var _this2 = _possibleConstructorReturn(this, (Score.__proto__ || Object.getPrototypeOf(Score)).call(this, props));
	
	        _this2._getBowlerPerformance = _this2._getBowlerPerformance.bind(_this2);
	        _this2._getStrikerPerformance = _this2._getStrikerPerformance.bind(_this2);
	        _this2._getNonStrikerPerformance = _this2._getNonStrikerPerformance.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(Score, [{
	        key: '_getStrikerPerformance',
	        value: function _getStrikerPerformance(ccMatch) {
	            var currentStatus = ccMatch.currentStatus;
	            var teams = ccMatch.teams;
	            var team = _lodash2.default.find(teams, { key: currentStatus.batting_team });
	            var player = _lodash2.default.find(team.players, { key: currentStatus.striker });
	            if (player) {
	                var inningsPerformance = _lodash2.default.find(player.currentMatchPerformance, function (mp) {
	                    return mp.innings == currentStatus.innings;
	                });
	                // this is to handle superover
	                if (inningsPerformance) return player.name + '*: ' + inningsPerformance.batting.runs + '( ' + inningsPerformance.batting.balls + ' )';
	            }
	            return;
	        }
	    }, {
	        key: '_getNonStrikerPerformance',
	        value: function _getNonStrikerPerformance(ccMatch) {
	            var currentStatus = ccMatch.currentStatus;
	            var teams = ccMatch.teams;
	            var team = _lodash2.default.find(teams, { key: currentStatus.batting_team });
	            var player = _lodash2.default.find(team.players, { key: currentStatus.nonStriker });
	            if (player) {
	                var inningsPerformance = _lodash2.default.find(player.currentMatchPerformance, function (mp) {
	                    return mp.innings == currentStatus.innings;
	                });
	                // this is to handle superover
	                if (inningsPerformance) return player.name + ': ' + inningsPerformance.batting.runs + '( ' + inningsPerformance.batting.balls + ' )';
	            }
	            return;
	        }
	    }, {
	        key: '_getBowlerPerformance',
	        value: function _getBowlerPerformance(ccMatch) {
	            var currentStatus = ccMatch.currentStatus;
	            var teams = ccMatch.teams;
	            var team = _lodash2.default.find(teams, { key: currentStatus.bowling_team });
	            var player = _lodash2.default.find(team.players, { key: currentStatus.bowler });
	            if (player) {
	                var inningsPerformance = _lodash2.default.find(player.currentMatchPerformance, function (mp) {
	                    return mp.innings == currentStatus.innings;
	                });
	                // this is to handle superover
	                if (inningsPerformance) return player.name + ': ' + inningsPerformance.bowling.wickets + '/' + inningsPerformance.bowling.runs;
	            }
	            return;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                teamScore = _props2.teamScore,
	                ccMatch = _props2.ccMatch;
	
	            var active = teamScore.active;
	            var strikerPerformance = this._getStrikerPerformance(ccMatch);
	            var nStrikerPerformance = this._getNonStrikerPerformance(ccMatch);
	            var bowlerPerformance = this._getBowlerPerformance(ccMatch);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container', style: { flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	                _react2.default.createElement(InningsScore, { active: teamScore.active, inningses: teamScore.inningses, ccMatch: ccMatch }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    teamScore.active ? _react2.default.createElement(
	                        'div',
	                        null,
	                        strikerPerformance && _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-score-txt_0_8', style: { color: getFontColor(active, ccMatch) } },
	                            strikerPerformance
	                        ),
	                        nStrikerPerformance && _react2.default.createElement(
	                            'h3',
	                            { className: 'cc-score-txt_0_8', style: { color: getFontColor(active, ccMatch) } },
	                            nStrikerPerformance
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        bowlerPerformance && _react2.default.createElement(
	                            'h4',
	                            { className: 'cc-score-txt_0_8', style: { color: getFontColor(active, ccMatch) } },
	                            bowlerPerformance
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Score;
	}(_react.Component);
	
	var SimpleMatchDetails = function (_Component3) {
	    _inherits(SimpleMatchDetails, _Component3);
	
	    function SimpleMatchDetails(props) {
	        _classCallCheck(this, SimpleMatchDetails);
	
	        var _this3 = _possibleConstructorReturn(this, (SimpleMatchDetails.__proto__ || Object.getPrototypeOf(SimpleMatchDetails)).call(this, props));
	
	        _this3.state = {};
	        _this3._getFontSize = _this3._getFontSize.bind(_this3);
	        _this3._getButtonText = _this3._getButtonText.bind(_this3);
	        _this3._getStyle = _this3._getStyle.bind(_this3);
	        _this3._onPlayPress = _this3._onPlayPress.bind(_this3);
	        return _this3;
	    }
	
	    _createClass(SimpleMatchDetails, [{
	        key: '_onPlayPress',
	        value: function _onPlayPress(ccMatch) {
	            _ccImports.CCAppEventLogger.logAppEvent("PlayViewClicked", { matchKey: ccMatch.key, matchStatus: ccMatch.status });
	            this.props.onPlayPress && this.props.onPlayPress();
	            this.props.history.push("/match/" + ccMatch.id);
	        }
	    }, {
	        key: '_getTeamScores',
	        value: function _getTeamScores(ccMatch) {
	
	            var teamScores = [];
	            var currentStatus = ccMatch.currentStatus,
	                inningses = ccMatch.inningses,
	                teams = ccMatch.teams;
	
	
	            _lodash2.default.forEach(teams, function (team) {
	                var teamInningses = inningses[team.key];
	                var updatedInnings = [];
	
	                team.active = currentStatus.batting_team == team.key;
	
	                _lodash2.default.forEach(teamInningses, function (teamInnings) {
	                    if (teamInnings.inningsNo == currentStatus.innings && currentStatus.batting_team == team.key) {
	                        teamInnings.active = true;
	                    }
	                    updatedInnings.push(teamInnings);
	                });
	
	                updatedInnings = _lodash2.default.orderBy(updatedInnings, ['inningsNo'], ['asc']);
	                team.inningses = updatedInnings;
	                teamScores.push(team);
	            });
	            return teamScores;
	        }
	    }, {
	        key: '_getFontSize',
	        value: function _getFontSize(text) {
	            switch (text.length) {
	                case 2:
	                case 3:
	                    return 16;
	                    break;
	                case 4:
	                case 5:
	                    return 14;
	                    break;
	                default:
	                    return 14;
	            }
	        }
	    }, {
	        key: '_getButtonText',
	        value: function _getButtonText(ccMatch) {
	            return ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED ? (0, _ccImports.strings)('view_button') : (0, _ccImports.strings)('play_button');
	        }
	    }, {
	        key: '_getStyle',
	        value: function _getStyle(ccMatch) {
	            switch (ccMatch.status) {
	                case _ccImports.Constants.matchStatus.STARTED:
	                    return {
	                        height: '11.5vw',
	                        btn_bottom: '-2vw'
	                    };
	                case _ccImports.Constants.matchStatus.NOT_STARTED:
	                    return {
	                        height: '11.5vw',
	                        btn_bottom: '-2vw'
	                    };
	                default:
	                    return {
	                        height: '9vw',
	                        btn_bottom: '0vw'
	                    };
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var ccMatch = this.props.ccMatch;
	
	            var teamScores = this._getTeamScores(ccMatch);
	
	            var sSize = 's';
	
	            var teamA = teamScores[0];
	            var teamB = teamScores[1];
	
	            var showPlay = this.props.showPlay;
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container simple_match_container ' + ccMatch.status.toLowerCase() },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container simple_match_container2' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'simple_match_container3 ' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'sc-background' },
	                                ccMatch.status == _ccImports.Constants.matchStatus.NOT_STARTED ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container padT3_5', style: { flexDirection: 'column', flex: 1, alignItems: 'center' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'sm_counter_margin' },
	                                        _react2.default.createElement(_ccImports.CCCounter, { style: { flex: 1 }, date: ccMatch.date })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container cc-match-title-div' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { className: 'cc-match-title-txt' },
	                                            ccMatch.title
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container padT3_5', style: { flex: 1, flexDirection: 'column' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container', style: { flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' } },
	                                        _react2.default.createElement(Score, { teamScore: teamA, ccMatch: ccMatch }),
	                                        _react2.default.createElement(Score, { teamScore: teamB, ccMatch: ccMatch })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container cc-match-status-div' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { className: 'cc-match-status-txt' },
	                                            ccMatch.statusShortDescription
	                                        )
	                                    )
	                                ),
	                                showPlay == true && _react2.default.createElement(_ccImports.CCLGButton, { completed: ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED, className: 'cc-match-btn',
	                                    title: this._getButtonText(ccMatch),
	                                    onPress: function onPress() {
	                                        _this4._onPlayPress(ccMatch);
	                                    } })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container cc-match-flag-parent' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container', style: { flex: 1, position: 'relative', flexDirection: 'row' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container sc-top-background ' + (ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED ? 'sc-top-background-disabled' : '') },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-container cc-match-top-flag left' },
	                                            _react2.default.createElement(_ccImports.CCFlag, { height: "100%", disabled: ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED, teamKey: teamA.key }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'flex-container cc-match-top-title-div left' },
	                                                _react2.default.createElement(
	                                                    'h1',
	                                                    { className: "cc-match-top-title-txt left " + (ccMatch.status != _ccImports.Constants.matchStatus.COMPLETED && teamA.active ? '' : 'inactive') },
	                                                    teamA.key.toUpperCase()
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { ref: 'test', className: 'flex-container cc-match-top-flag right' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'flex-container cc-match-top-title-div right' },
	                                                _react2.default.createElement(
	                                                    'h1',
	                                                    { className: "cc-match-top-title-txt right " + (ccMatch.status != _ccImports.Constants.matchStatus.COMPLETED && teamA.active ? '' : 'inactive') },
	                                                    teamB.key.toUpperCase()
	                                                )
	                                            ),
	                                            _react2.default.createElement(_ccImports.CCFlag, { height: "100%", disabled: ccMatch.status == _ccImports.Constants.matchStatus.COMPLETED, teamKey: teamB.key })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SimpleMatchDetails;
	}(_react.Component);
	
	SimpleMatchDetails.propTypes = {
	    onPlayPress: _propTypes2.default.func,
	    showPlay: _propTypes2.default.bool
	};
	SimpleMatchDetails.defaultProps = {
	    matchSummary: true,
	    onPlayPress: function onPlayPress() {},
	    showPlay: false
	};
	exports.default = (0, _reactRouterDom.withRouter)(SimpleMatchDetails);
	
	
	var styles = {};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleMatchDetails = undefined;
	
	var _SimpleMatchDetails = __webpack_require__(316);
	
	var _SimpleMatchDetails2 = _interopRequireDefault(_SimpleMatchDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SimpleMatchDetails = _SimpleMatchDetails2.default;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CCCoinPile = __webpack_require__(274);
	
	Object.keys(_CCCoinPile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCCoinPile[key];
	    }
	  });
	});
	
	var _CCCoins = __webpack_require__(276);
	
	Object.keys(_CCCoins).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCCoins[key];
	    }
	  });
	});
	
	var _CCLeagueItem = __webpack_require__(304);
	
	Object.keys(_CCLeagueItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLeagueItem[key];
	    }
	  });
	});
	
	var _CCLeaguesGroup = __webpack_require__(306);
	
	Object.keys(_CCLeaguesGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLeaguesGroup[key];
	    }
	  });
	});
	
	var _CCIcon = __webpack_require__(294);
	
	Object.keys(_CCIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCIcon[key];
	    }
	  });
	});
	
	var _CCGridItem = __webpack_require__(293);
	
	Object.keys(_CCGridItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCGridItem[key];
	    }
	  });
	});
	
	var _CCLang = __webpack_require__(302);
	
	Object.keys(_CCLang).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLang[key];
	    }
	  });
	});
	
	var _CCLBStatusItem = __webpack_require__(298);
	
	Object.keys(_CCLBStatusItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLBStatusItem[key];
	    }
	  });
	});
	
	var _CCMoreModalItem = __webpack_require__(309);
	
	Object.keys(_CCMoreModalItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCMoreModalItem[key];
	    }
	  });
	});
	
	var _CCPlayerItem = __webpack_require__(313);
	
	Object.keys(_CCPlayerItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCPlayerItem[key];
	    }
	  });
	});
	
	var _CCDp = __webpack_require__(285);
	
	Object.keys(_CCDp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCDp[key];
	    }
	  });
	});
	
	var _CCTransactionItem = __webpack_require__(315);
	
	Object.keys(_CCTransactionItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCTransactionItem[key];
	    }
	  });
	});
	
	var _SimpleMatchDetails = __webpack_require__(317);
	
	Object.keys(_SimpleMatchDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SimpleMatchDetails[key];
	    }
	  });
	});
	
	var _CCCounter = __webpack_require__(279);
	
	Object.keys(_CCCounter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCCounter[key];
	    }
	  });
	});
	
	var _CCDailyBonusCounter = __webpack_require__(283);
	
	Object.keys(_CCDailyBonusCounter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCDailyBonusCounter[key];
	    }
	  });
	});
	
	var _CCLGButton = __webpack_require__(300);
	
	Object.keys(_CCLGButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLGButton[key];
	    }
	  });
	});
	
	var _CCFlag = __webpack_require__(291);
	
	Object.keys(_CCFlag).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCFlag[key];
	    }
	  });
	});
	
	var _CCNotificationItem = __webpack_require__(311);
	
	Object.keys(_CCNotificationItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCNotificationItem[key];
	    }
	  });
	});
	
	var _CCInput = __webpack_require__(296);
	
	Object.keys(_CCInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCInput[key];
	    }
	  });
	});
	
	var _CCActivityIndicator = __webpack_require__(271);
	
	Object.keys(_CCActivityIndicator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCActivityIndicator[key];
	    }
	  });
	});
	
	var _CCAck = __webpack_require__(270);
	
	Object.keys(_CCAck).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCAck[key];
	    }
	  });
	});
	
	var _CCButton = __webpack_require__(273);
	
	Object.keys(_CCButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCButton[key];
	    }
	  });
	});
	
	var _CCEntrySummaryItem = __webpack_require__(289);
	
	Object.keys(_CCEntrySummaryItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCEntrySummaryItem[key];
	    }
	  });
	});
	
	var _CCEntryItem = __webpack_require__(287);
	
	Object.keys(_CCEntryItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCEntryItem[key];
	    }
	  });
	});
	
	var _CCListView = __webpack_require__(307);
	
	Object.keys(_CCListView).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCListView[key];
	    }
	  });
	});
	
	var _CCCrashMe = __webpack_require__(281);
	
	Object.keys(_CCCrashMe).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCCrashMe[key];
	    }
	  });
	});

/***/ },
/* 319 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Constants = {
	    anonymousUser: 'anonymous',
	    cricrushSponsor: 'cricrush',
	    lbType: {
	        WEEKLY: 'WEEKLY',
	        MONTHLY: 'MONTHLY',
	        LIFETIME: 'LIFETIME',
	        DAILY: 'DAILY'
	    },
	    lbSubType: {
	        WIN_LOST_RATIO: 'WIN_LOST_RATIO',
	        NO_OF_COINS_EARNED: 'NO_OF_COINS_EARNED',
	        NO_OF_ENTRIES_PLAYED: 'NO_OF_ENTRIES_PLAYED'
	    },
	    lbStatus: {
	        ACTIVE: 'ACTIVE',
	        COMPLETED: 'COMPLETED',
	        ARCHIVED: 'ARCHIVED'
	    },
	    rewardStatus: {
	        CREATED: 'CREATED',
	        CLAIMED: 'CLAIMED',
	        PROCESSED: 'PROCESSED'
	    },
	    matchStatus: {
	        NOT_STARTED: 'NOT_STARTED',
	        STARTED: 'STARTED',
	        COMPLETED: 'COMPLETED'
	    },
	    leagueStatus: {
	        NOT_STARTED: 'NOT_STARTED',
	        LIVE: 'LIVE',
	        COMPLETED: 'COMPLETED',
	        REFUNDED: 'REFUNDED',
	        REFUNDED_NO_ENOUGH_PLAYERS: 'REFUNDED_NO_ENOUGH_PLAYERS',
	        ALL_COMPLETED: 'ALL_COMPLETED',
	        isCompleted: function isCompleted(status) {
	            return status == Constants.leagueStatus.COMPLETED || status == Constants.leagueStatus.REFUNDED || status == Constants.leagueStatus.REFUNDED_NO_ENOUGH_PLAYERS || status == Constants.leagueStatus.ALL_COMPLETED;
	        }
	    },
	    entryStatus: {
	        NOT_STARTED: 'NOT_STARTED',
	        LIVE: 'LIVE',
	        COMPLETED: 'COMPLETED',
	        REFUNDED: 'REFUNDED_ABANDONED',
	        REFUNDED_NO_ENOUGH_PLAYERS: 'REFUNDED_NO_ENOUGH_PLAYERS',
	        REFUNDED_ABANDONED: 'REFUNDED_ABANDONED',
	        ALL_COMPLETED: 'ALL_COMPLETED',
	        isCompleted: function isCompleted(status) {
	            return status == Constants.entryStatus.COMPLETED || status == Constants.entryStatus.REFUNDED || status == Constants.entryStatus.REFUNDED_NO_ENOUGH_PLAYERS || status == Constants.entryStatus.ALL_COMPLETED;
	        }
	    },
	    leagueType: {
	        DOUBLE: 'DOUBLE',
	        QUADRUPLE: 'QUADRUPLE',
	        QUINTUPLE: 'QUINTUPLE',
	        TRIPLE: 'TRIPLE'
	    },
	    leagueCategory: {
	        DREAMTEAM: 'DREAMTEAM',
	        LIVE_PREDICTION: 'LIVE_PREDICTION',
	        PREDICTION: 'PREDICTION',
	        QUICK_PREDICTION: 'QUICK_PREDICTION'
	    },
	    admins: ["ramoshan@gmail.com", "rharishan@gmail.com", ""],
	    reqStatus: {
	        SUC: 'SUCCESS',
	        PEN: 'PENDING',
	        COM: 'COMPLETED',
	        FAI: 'FAILED'
	    },
	    modals: {
	        ADD_COINS: 'ADD_COINS',
	        CHATS: 'CHATS',
	        DREAMTEAM_ENTRY_CREATION: 'DREAMTEAM_ENTRY_CREATION',
	        ENTRIES: 'ENTRIES',
	        MORE: 'MORE',
	        NOTIFICATIONS: 'NOTIFICATIONS',
	        PREDICTION_ENTRY_CREATION: 'PREDICTION_ENTRY_CREATION',
	        RE_AUTH: 'RE_AUTH',
	        SIGN_IN: 'SIGN_IN',
	        SINGLE_LEAGUE: 'SINGLE_LEAGUE',
	        SPONSOR_DETAILS: 'SPONSOR_DETAILS',
	        TRANSACTIONS: 'TRANSACTIONS',
	        INFO: 'INFO'
	    },
	    cacheKeys: {
	        LINK_PARAMS: 'LINK_PARAMS'
	    }
	};
	
	exports.Constants = Constants;

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CricrushConfig = exports.CricrushConfig = {
	    "ccServiceBaseUrl": "https://service2.cricrush.com/cc/service/v2",
	    "ccChatsBaseUrl": "http://18.218.238.211:3000",
	    "firebaseConfig": {
	        "apiKey": "AIzaSyA2-73iYXL-J4BQs8eqB6VXbzbnRjVqRpI",
	        "authDomain": "cricrush-171503.firebaseapp.com",
	        "databaseURL": "https://cricrush-171503.firebaseio.com",
	        "projectId": "cricrush-171503",
	        "storageBucket": "cricrush-171503.appspot.com",
	        "messagingSenderId": "540610660257",
	        "env": "prod"
	    },
	    "googleSigninConfig": {
	        "iosClientId": "540610660257-74ps9ti8pjdeq08rvmdeg97bqr1uvjmp.apps.googleusercontent.com",
	        "webClientId": "540610660257-siqid6fql8p6tudn4jcatcgkn23q0288.apps.googleusercontent.com"
	    },
	    "cloudMessaging": {
	        "senderId": "540610660257",
	        "authKey": "AIzaSyDRDRpjp34hQ9OQlu0noVkPLEpAeWZeiik"
	    },
	    "dynamicLinkDomain": "ubsb8.app.goo.gl"
	};

/***/ },
/* 321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var colors = {
	    theme: {
	        bg_color1: '#154352',
	        bg_color2: '#113643',
	        bg_color3: '#0f313d',
	        bg_color4: '#16252b',
	        bg_color5: '#131f24',
	        bg_color6: '#eb516c',
	        bg_color7: '#0095b7',
	        bg_color8: '#00b4c1',
	        bg_color9: '#00bec4',
	        bg_color10: '#00a6bc',
	        bg_color11: '#04687a',
	        bg_color12: '#bcb82e',
	        bg_color13: '#5abc2e',
	        bg_color14: '#00d8e8',
	        bg_color15: '#ffffff',
	        bg_color16: '#ffdf00',
	        bg_color17: '#547988',
	        bg_color18: '#04245B',
	
	        btn_bg_color: '#2a6173',
	        btn_bg_color1: '#ffffff',
	        btn_bg_color2: '#0095b7',
	        btn_bg_color3: '#0f313d',
	        btn_bg_color4: '#eb516c',
	
	        btn_font_color: '#ffffff',
	        btn_font_color2: '#2a6173',
	        btn_font_color3: '#32a2c6',
	        btn_font_color4: '#547988',
	        btn_font_color5: '#01a6bc',
	        btn_font_color6: '#ffdf00',
	
	        btn_txt_font_color: '#00ccc8',
	
	        btn_border: '#00b4c1',
	        btn_border1: '#5cafc8',
	        btn_border2: '#234c5b',
	        btn_border3: '#04687a',
	        btn_border4: '#ffffff',
	
	        border_color: '#6c7376',
	        border_color2: '#eb516c',
	        border_color3: '#ffffff',
	
	        input_underline: '#00b4c1',
	        input_text_color: '#ffffff',
	        input_place_holder_color: '#bac2c6',
	        input_place_holder_color1: '#6092a4',
	        input_underline_color: '#00b4c1',
	        input_underline_color2: '#ffffff',
	        input_underline_color_error: '#eb516c',
	
	        txt_color: '#ffffff',
	        txt_color1: '#5bddfa',
	        txt_color3: '#0f313d',
	        txt_color4: '#eb516c',
	        txt_color5: '#00a7bc',
	        txt_color6: '#0f3039',
	
	        tab_active_color: '#eb516c',
	        tab_inactive_color: '#00bfc4',
	        tab_active_color1: '#eb516c',
	        tab_inactive_color1: '#ffffff',
	        tab_count_bg1: '#0f313d',
	        tab_count_bg2: '#eb516c',
	        tab_count_txt_color1: '#00bfc4',
	        tab_count_txt_color2: '#ffffff',
	        tab_border_color: '#15414f',
	
	        sidebar_border_color1: '#000000',
	        sidebar_border_color2: '#2f505d',
	        sidebar_border_color3: '#41555c'
	    },
	    theme2: {
	        bg_color1: 'rgb(255, 255, 255)',
	        bg_color2: 'rgb(46,108,211)',
	        bg_color3: 'rgb(65,124,213)',
	        bg_color4: 'rgb(240, 69, 113)',
	        bg_color5: 'rgb(95 ,159, 255)',
	        bg_color6: 'rgb(0 ,0, 0)',
	        bg_color7: 'rgba(23,50, 114, 0.6)',
	        bg_color8: 'rgb(4,36,91)',
	        bg_color9: 'rgb(17,71,171)',
	        bg_color10: 'rgb(247, 247, 247)',
	        bg_color11: 'rgba(155, 155, 155, 0.5)',
	
	        font_color1: 'rgb(0, 0, 0)',
	        font_color2: 'rgb(135, 135, 135)',
	        font_color3: 'rgb(255, 255, 255)',
	        font_color4: 'rgb(23,50,114)',
	        font_color5: 'rgb(155,155,155)',
	
	        border_color1: 'rgb(227,233,236)',
	        border_color2: 'rgb(89,123,180)'
	
	    }
	};
	
	exports.colors = colors;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var images = {
	    home_background: __webpack_require__(516),
	    sc_background: __webpack_require__(635),
	    league_background: __webpack_require__(631),
	    login_background: __webpack_require__(632),
	    modal_background: __webpack_require__(633),
	    splash_background: __webpack_require__(636),
	    leaderboard_background: __webpack_require__(630),
	    leaderboard_background2: __webpack_require__(629),
	    cc_logo: __webpack_require__(493),
	    coinsTextBase: __webpack_require__(495),
	    coinsBase: __webpack_require__(494),
	    // splash_background: require('../images/spBackGround@3x.png'),
	    icons: {
	        old: {
	            arrow_down_00b4c1_40: __webpack_require__(552),
	            arrow_down_154352_40: __webpack_require__(553),
	            arrow_left_ffffff_40: __webpack_require__(554),
	            arrow_right_154352_40: __webpack_require__(555),
	            arrow_right_ffffff_40: __webpack_require__(556),
	            ball_ffffff_100: __webpack_require__(557),
	            bell_icon_00b4c1_132: __webpack_require__(558),
	            camera_77a4af_150: __webpack_require__(559),
	            circle_0095b7_60: __webpack_require__(560),
	            circle_154352_160: __webpack_require__(561),
	            circle_eb516c_60: __webpack_require__(562),
	            done_icon_00c6c4_132: __webpack_require__(563),
	            edit_profile: __webpack_require__(564),
	            enter_icon_154352_150: __webpack_require__(565),
	            enter_leagues_0e2c37_150: __webpack_require__(566),
	            fb_icon_160: __webpack_require__(567),
	            g_plus_icon_160: __webpack_require__(568),
	            hamburger_0095b7_100: __webpack_require__(569),
	            hamburger_03808f_100: __webpack_require__(570),
	            horizontal_logo_645_145: __webpack_require__(571),
	            lang_bn_icon_0094bb_132: __webpack_require__(127),
	            lang_en_icon_0094bb_132: __webpack_require__(128),
	            lang_hi_icon_0094bb_132: __webpack_require__(129),
	            lang_si_icon_0094bb_132: __webpack_require__(130),
	            lang_ta_icon_0094bb_132: __webpack_require__(131),
	            left_icon_fff_132: __webpack_require__(572),
	            loading_icon: __webpack_require__(573),
	            location_icon_154352_120: __webpack_require__(574),
	            location_icon_eb516c_120: __webpack_require__(575),
	            logout_icon_547988_100: __webpack_require__(576),
	            lost_icon_150: __webpack_require__(577),
	            mail_icon_FFF_132: __webpack_require__(578),
	            penta_logo_1254: __webpack_require__(579),
	            pick_entry_0e2c37_150: __webpack_require__(580),
	            pick_icon_154352_150: __webpack_require__(581),
	            play_icon_ff4d6c_120: __webpack_require__(582),
	            profile_pic_plh: __webpack_require__(583),
	            refunded_icon_150: __webpack_require__(584),
	            right_icon_fff_132: __webpack_require__(585),
	            score_points_icon_0e2c37_150: __webpack_require__(586),
	            setting_icon_ffffff_132: __webpack_require__(587),
	            share_icon_fff_132: __webpack_require__(588),
	            sponsor_banner_sample: __webpack_require__(589),
	            stumps_left_ffffff_100: __webpack_require__(590),
	            stumps_right_ffffff_100: __webpack_require__(591),
	            tab_hamburger_icon_00bfc4_160: __webpack_require__(592),
	            tab_hamburger_icon_eb516c_160: __webpack_require__(593),
	            tab_home_icon_00bfc4_160: __webpack_require__(594),
	            tab_home_icon_eb516c_160: __webpack_require__(595),
	            tab_leaderboard_icon_00bfc4_160: __webpack_require__(596),
	            tab_leaderboard_icon_eb516c_160: __webpack_require__(597),
	            tab_messages_00bfc4_160: __webpack_require__(598),
	            tab_messages_eb516c_160: __webpack_require__(599),
	            tab_notifications_eb516c_160: __webpack_require__(601),
	            tab_notifications_00bfc4_160: __webpack_require__(600),
	            tab_profile_icon_00bfc4_160: __webpack_require__(602),
	            tab_profile_icon_eb516c_160: __webpack_require__(603),
	            tab_tokens_00bfc4_160: __webpack_require__(604),
	            tab_tokens_eb516c_160: __webpack_require__(605),
	            win_icon_154352_150: __webpack_require__(607),
	            win_coins_0e2c37_150: __webpack_require__(606),
	            won_icon_150: __webpack_require__(608)
	        },
	        disabled: {
	            coinsPile: __webpack_require__(529),
	            league: __webpack_require__(530)
	        },
	        about: __webpack_require__(517),
	        avatar: __webpack_require__(518),
	        back: __webpack_require__(519),
	        chat: __webpack_require__(520),
	        clock: __webpack_require__(521),
	        close: __webpack_require__(522),
	        coins: __webpack_require__(523),
	        coinsBase: __webpack_require__(524),
	        coinsPile: __webpack_require__(525),
	        coinsPileDark: __webpack_require__(526),
	        coinsPlus: __webpack_require__(527),
	        coinsTextBase: __webpack_require__(528),
	        dreamTeam: __webpack_require__(531),
	        edition: __webpack_require__(532),
	        faq: __webpack_require__(533),
	        ficaLogo: __webpack_require__(535),
	        ficaLogo2: __webpack_require__(534),
	        groupChat: __webpack_require__(536),
	        help: __webpack_require__(537),
	        howscorescalculated: __webpack_require__(538),
	        howtoplay: __webpack_require__(539),
	        info: __webpack_require__(540),
	        inviteFriends: __webpack_require__(541),
	        lb_divider: __webpack_require__(542),
	        leaderboard: __webpack_require__(543),
	        league: __webpack_require__(544),
	        live: __webpack_require__(545),
	        livePrediction: __webpack_require__(546),
	        logout: __webpack_require__(547),
	        menu: __webpack_require__(548),
	        more: __webpack_require__(549),
	        notification: __webpack_require__(551),
	        notification2: __webpack_require__(550),
	        play: __webpack_require__(609),
	        player0: __webpack_require__(610),
	        player1: __webpack_require__(611),
	        player2: __webpack_require__(612),
	        privacy: __webpack_require__(614),
	        profile: __webpack_require__(615),
	        plus: __webpack_require__(613),
	        rewardBanner: __webpack_require__(616),
	        scBanner: __webpack_require__(617),
	        scBannerDisabled: __webpack_require__(634),
	        selected: __webpack_require__(618),
	        settings: __webpack_require__(619),
	        sideBarClose: __webpack_require__(620),
	        sponsorBanner: __webpack_require__(621),
	        success: __webpack_require__(622),
	        targetPrediction: __webpack_require__(623),
	        trophy: __webpack_require__(624),
	        upcoming: __webpack_require__(625),
	        warning: __webpack_require__(626),
	        winBanner: __webpack_require__(627),
	        winnerBadge: __webpack_require__(628)
	    },
	    d_flags: {
	        afg: __webpack_require__(93),
	        afgw: __webpack_require__(93),
	        aus: __webpack_require__(94),
	        ausw: __webpack_require__(94),
	        ban: __webpack_require__(95),
	        banw: __webpack_require__(95),
	        can: __webpack_require__(96),
	        csk: __webpack_require__(499),
	        dd: __webpack_require__(500),
	        canw: __webpack_require__(96),
	        eng: __webpack_require__(97),
	        engw: __webpack_require__(97),
	        hk: __webpack_require__(98),
	        hkw: __webpack_require__(98),
	        ind: __webpack_require__(99),
	        indw: __webpack_require__(99),
	        ire: __webpack_require__(100),
	        irew: __webpack_require__(100),
	        ken: __webpack_require__(101),
	        kkr: __webpack_require__(502),
	        kxip: __webpack_require__(503),
	        mi: __webpack_require__(504),
	        kenw: __webpack_require__(101),
	        nep: __webpack_require__(102),
	        nepw: __webpack_require__(102),
	        nl: __webpack_require__(103),
	        nlw: __webpack_require__(103),
	        nz: __webpack_require__(104),
	        nzw: __webpack_require__(104),
	        pak: __webpack_require__(105),
	        pakw: __webpack_require__(105),
	        rcb: __webpack_require__(505),
	        rr: __webpack_require__(506),
	        rsa: __webpack_require__(106),
	        rsaw: __webpack_require__(106),
	        sct: __webpack_require__(107),
	        sctw: __webpack_require__(107),
	        sl: __webpack_require__(108),
	        srh: __webpack_require__(507),
	        slw: __webpack_require__(108),
	        uae: __webpack_require__(109),
	        uaew: __webpack_require__(109),
	        uk: __webpack_require__(508),
	        wi: __webpack_require__(110),
	        wiw: __webpack_require__(110),
	        zim: __webpack_require__(111),
	        zimw: __webpack_require__(111),
	        default: __webpack_require__(501)
	    },
	    flags: {
	        afg: __webpack_require__(89),
	        afgw: __webpack_require__(89),
	        aus: __webpack_require__(90),
	        ausw: __webpack_require__(90),
	        ban: __webpack_require__(91),
	        banw: __webpack_require__(91),
	        can: __webpack_require__(92),
	        csk: __webpack_require__(496),
	        dd: __webpack_require__(497),
	        canw: __webpack_require__(92),
	        eng: __webpack_require__(112),
	        engw: __webpack_require__(112),
	        hk: __webpack_require__(113),
	        hkw: __webpack_require__(113),
	        ind: __webpack_require__(114),
	        indw: __webpack_require__(114),
	        ire: __webpack_require__(115),
	        irew: __webpack_require__(115),
	        ken: __webpack_require__(116),
	        kkr: __webpack_require__(509),
	        kxip: __webpack_require__(510),
	        mi: __webpack_require__(511),
	        kenw: __webpack_require__(116),
	        nep: __webpack_require__(117),
	        nepw: __webpack_require__(117),
	        nl: __webpack_require__(118),
	        nlw: __webpack_require__(118),
	        nz: __webpack_require__(119),
	        nzw: __webpack_require__(119),
	        pak: __webpack_require__(120),
	        pakw: __webpack_require__(120),
	        rcb: __webpack_require__(512),
	        rr: __webpack_require__(513),
	        rsa: __webpack_require__(121),
	        rsaw: __webpack_require__(121),
	        sct: __webpack_require__(122),
	        sctw: __webpack_require__(122),
	        sl: __webpack_require__(123),
	        srh: __webpack_require__(514),
	        slw: __webpack_require__(123),
	        uae: __webpack_require__(124),
	        uaew: __webpack_require__(124),
	        uk: __webpack_require__(515),
	        wi: __webpack_require__(125),
	        wiw: __webpack_require__(125),
	        zim: __webpack_require__(126),
	        zimw: __webpack_require__(126),
	        default: __webpack_require__(498)
	    },
	    langs: {
	        bn: __webpack_require__(127),
	        en: __webpack_require__(128),
	        hi: __webpack_require__(129),
	        si: __webpack_require__(130),
	        ta: __webpack_require__(131)
	    }
	};
	
	var getFlag = function getFlag(key, disabled) {
	    var flag = images.flags[key];
	    if (disabled && disabled === true) {
	        flag = images.d_flags[key];
	        return flag != null ? flag : images.d_flags.default;
	    } else {
	        return flag != null ? flag : images.flags.default;
	    }
	};
	
	var getLang = function getLang(key) {
	    var lang = images.langs[key];
	    return lang != null ? lang : images.flags.default_100;
	};
	
	var getIcon = function getIcon(key) {
	    var icon = images.icons[key];
	    return icon != null ? icon : images.flags.default_100;
	};
	
	exports.images = images;
	exports.getFlag = getFlag;
	exports.getIcon = getIcon;
	exports.getLang = getLang;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(4);
	
	var _reduxLogger = __webpack_require__(642);
	
	var _reduxThunk = __webpack_require__(645);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPromiseMiddleware = __webpack_require__(643);
	
	var _reduxPromiseMiddleware2 = _interopRequireDefault(_reduxPromiseMiddleware);
	
	var _UserReducers = __webpack_require__(352);
	
	var _UserReducers2 = _interopRequireDefault(_UserReducers);
	
	var _LeaguesReducers = __webpack_require__(345);
	
	var _LeaguesReducers2 = _interopRequireDefault(_LeaguesReducers);
	
	var _ModalsReducers = __webpack_require__(347);
	
	var _ModalsReducers2 = _interopRequireDefault(_ModalsReducers);
	
	var _AlertsReducers = __webpack_require__(340);
	
	var _AlertsReducers2 = _interopRequireDefault(_AlertsReducers);
	
	var _NotificationsReducers = __webpack_require__(348);
	
	var _NotificationsReducers2 = _interopRequireDefault(_NotificationsReducers);
	
	var _MatchesReducers = __webpack_require__(346);
	
	var _MatchesReducers2 = _interopRequireDefault(_MatchesReducers);
	
	var _TransactionsReducers = __webpack_require__(351);
	
	var _TransactionsReducers2 = _interopRequireDefault(_TransactionsReducers);
	
	var _LeaderBoardReducers = __webpack_require__(344);
	
	var _LeaderBoardReducers2 = _interopRequireDefault(_LeaderBoardReducers);
	
	var _EntryReducers = __webpack_require__(343);
	
	var _EntryReducers2 = _interopRequireDefault(_EntryReducers);
	
	var _RewardsReducers = __webpack_require__(349);
	
	var _RewardsReducers2 = _interopRequireDefault(_RewardsReducers);
	
	var _SponsorsReducer = __webpack_require__(350);
	
	var _SponsorsReducer2 = _interopRequireDefault(_SponsorsReducer);
	
	var _CacheReducers = __webpack_require__(342);
	
	var _CacheReducers2 = _interopRequireDefault(_CacheReducers);
	
	var _CCNavigationReducers = __webpack_require__(341);
	
	var _CCNavigationReducers2 = _interopRequireDefault(_CCNavigationReducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducers = (0, _redux.combineReducers)({
	    user: _UserReducers2.default,
	    cache: _CacheReducers2.default,
	
	    navigation: _CCNavigationReducers2.default,
	    modals: _ModalsReducers2.default,
	    alerts: _AlertsReducers2.default,
	
	    leagues: _LeaguesReducers2.default,
	    entries: _EntryReducers2.default,
	    matches: _MatchesReducers2.default,
	    leaderBoard: _LeaderBoardReducers2.default,
	    notifications: _NotificationsReducers2.default,
	    transactions: _TransactionsReducers2.default,
	    rewards: _RewardsReducers2.default,
	    sponsors: _SponsorsReducer2.default
	});
	
	var ccMiddleWare = function ccMiddleWare(store) {
	    return function (next) {
	        return function (action) {
	            if (action.type && action.type.includes('_FULFILLED')) {
	                if (action.payload && action.payload.data) {
	                    if (action.payload.data.success || action.payload.data.statusCode === 'S1000') {
	                        next(Object.assign({}, action, { type: action.type.split('_FULFILLED')[0] + '_CC_FULFILLED' }));
	                    } else {
	                        next(action);
	                    }
	                } else {
	                    next(action);
	                }
	            } else {
	                next(action);
	            }
	        };
	    };
	};
	
	var middleware = (0, _redux.applyMiddleware)((0, _reduxPromiseMiddleware2.default)(), ccMiddleWare, _reduxThunk2.default);
	if (false) {
	    middleware = (0, _redux.applyMiddleware)((0, _reduxPromiseMiddleware2.default)(), ccMiddleWare, _reduxThunk2.default, (0, _reduxLogger.createLogger)());
	}
	
	var store = (0, _redux.createStore)(reducers, middleware);
	
	exports.default = store;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    addToCache: function addToCache(key, value) {
	        return {
	            type: _ccImports.ActionTypes.ADD_TO_CACHE,
	            payload: { key: key, value: value }
	        };
	    },
	    removeFromCache: function removeFromCache(key) {
	        return {
	            type: _ccImports.ActionTypes.REMOVE_FROM_CACHE,
	            payload: { key: key }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    updateDimension: function updateDimension(payload) {
	        return {
	            type: _ccImports.ActionTypes.DIMENSION_CHANGED,
	            payload: payload
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    createEntry: function createEntry(entry, authDetails) {
	        return {
	            type: _ccImports.ActionTypes.CREATE_ENTRY,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).post('/entry', entry),
	            meta: {
	                type: _ccImports.DataActionTypes.CREATE
	            }
	        };
	    },
	    getEntriesByLeagueId: function getEntriesByLeagueId(req, authDetails, type, leagueId) {
	        return {
	            type: _ccImports.ActionTypes.GET_ENTRIES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/entry/leagueId/' + req.leagueId + '/skip/' + req.skip + '/limit/' + req.limit + '/'),
	            meta: {
	                type: type,
	                id: leagueId
	            }
	        };
	    },
	
	    getEntriesByUserId: function getEntriesByUserId(userId, skip, limit, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_ENTRIES,
	            payload: _ccImports.CCAxios.get('/entry/userId/' + userId + '/skip/' + skip + '/limit/' + limit + '/'),
	            meta: {
	                type: type,
	                id: userId
	            }
	        };
	    },
	
	    /*getEntriesByUserId: (req, authDetails, type) => {
	        return {
	            type: ActionTypes.GET_ENTRIES,
	            payload: CCAuthorizedAxios(authDetails).get('/entry/userId/' + req.userID + '/skip/' + req.skip + '/limit/' + req.limit + '/'),
	            meta : {
	                type : type
	            }
	        }
	    },*/
	
	    getEntriesByUserIdAndLeagueId: function getEntriesByUserIdAndLeagueId(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_ENTRIES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/entry/leagueId/' + req.leagueId + '/userId/' + req.userId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getEntriesByUserIdAndMatchId: function getEntriesByUserIdAndMatchId(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_ENTRIES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/entry/matchId/' + req.matchId + '/userId/' + req.userId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getLiveEntriesByUserId: function getLiveEntriesByUserId(accessToken, userId, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_ENTRIES,
	            payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/entry/userId/' + userId + '/live/'),
	            meta: {
	                type: type,
	                id: userId
	            }
	        };
	    },
	
	    entryUpdated: function entryUpdated(entry, id) {
	        return {
	            type: _ccImports.ActionTypes.ENTRY_UPDATED,
	            payload: entry,
	            meta: {
	                type: _ccImports.DataActionTypes.UPDATE,
	                id: id
	            }
	        };
	    }
	
	    /*getLiveEntriesByUserId: (req, authDetails, type) => {
	        return {
	            type: ActionTypes.GET_ENTRIES,
	            payload: CCAuthorizedAxios(authDetails).get('/entry/userId/' + req.userID + '/live/'),
	            meta : {
	                type : type
	            }
	        }
	    }*/
	};
	
	exports.default = Actions;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var HelpActions = {
	
	    showHelp: function showHelp(tab) {
	        return {
	            type: _ccImports.ActionTypes.SHOW_HELP,
	            payload: {
	                tab: tab
	            }
	        };
	    }
	};
	
	exports.default = HelpActions;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var LeaderBoardActions = {
	    fetchLBStatuses: function fetchLBStatuses(authDetails, req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LB_STATUS,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/leaderboard/lb/' + req.lbId + '/userId/' + req.userId + '/skip/' + req.skip + '/limit/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    fetchLBs: function fetchLBs(authDetails, req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LBS,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/leaderboard/userId/' + req.userId + '/sponsorKey/' + req.sponsorKey + '/'),
	            meta: {
	                type: type
	            }
	        };
	    }
	};
	
	exports.default = LeaderBoardActions;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	
	    getLeague: function getLeague(leagueId, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUE,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/leagueId/' + leagueId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    refreshLeague: function refreshLeague(leagueId, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.REFRESH_LEAGUE,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/leagueId/' + leagueId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getLiveLeagues: function getLiveLeagues(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/live/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getSponsoredLeagues: function getSponsoredLeagues(authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: authDetails.idToken }).get('/league/sponsored/userId/' + authDetails.userId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getUpcomingLeagues: function getUpcomingLeagues(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/upcoming/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getRecentLeagues: function getRecentLeagues(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/recent/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getLeaguesByMatchId: function getLeaguesByMatchId(accessToken, matchId, userId, skip, limit, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/league/matchId/' + matchId + '/userId/' + userId + '/' + skip + '/' + limit + '/'),
	            meta: {
	                type: type,
	                id: matchId
	            }
	        };
	    },
	
	    /*getLeaguesByMatchId: (req, authDetails, type) => {
	        return {
	            type: ActionTypes.GET_LEAGUES,
	            payload: CCAuthorizedAxios(authDetails).get('/league/matchId/' + req.matchId + '/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        }
	    },*/
	
	    getLeagues: function getLeagues(type, userId, skip, limit, accessToken, actionType) {
	        switch (type) {
	            case 'PREDICTION':
	                return {
	                    type: _ccImports.ActionTypes.GET_LEAGUES,
	                    payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/league/upcoming/category/prediction/userId/' + userId + '/' + skip + '/' + limit + '/'),
	                    meta: {
	                        type: actionType
	                    }
	                };
	                break;
	            case 'LIVE_PREDICTION':
	                return {
	                    type: _ccImports.ActionTypes.GET_LEAGUES,
	                    payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/league/upcoming/category/live_prediction/userId/' + userId + '/' + skip + '/' + limit + '/'),
	                    meta: {
	                        type: actionType
	                    }
	                };
	                break;
	            case 'DREAM_TEAM':
	                return {
	                    type: _ccImports.ActionTypes.GET_LEAGUES,
	                    payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/league/upcoming/category/dreamteam/userId/' + userId + '/' + skip + '/' + limit + '/'),
	                    meta: {
	                        type: actionType
	                    }
	                };
	                break;
	            default:
	                return {
	                    type: _ccImports.ActionTypes.GET_LEAGUES,
	                    payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).get('/league/userId/' + userId + '/' + skip + '/' + limit + '/'),
	                    meta: {
	                        type: actionType
	                    }
	                };
	        }
	    },
	
	    paginateLeagues: function paginateLeagues(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.PAGINATE_LEAGUES,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    refreshLeagues: function refreshLeagues(req, authDetails, type) {
	        return {
	            type: _ccImports.ActionTypes.REFRESH_LEAGUE,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/league/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    getMatch: function getMatch(matchId, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCH,
	            payload: _ccImports.CCAxios.get('/match/matchId/' + matchId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getMatchByKey: function getMatchByKey(key, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCH,
	            payload: _ccImports.CCAxios.get('/match/matchKey/' + key + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    refreshMatch: function refreshMatch(matchId, type) {
	        return {
	            type: _ccImports.ActionTypes.REFRESH_MATCH,
	            payload: _ccImports.CCAxios.get('/match/matchId/' + matchId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getUpComingMatches: function getUpComingMatches(req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCHES,
	            payload: _ccImports.CCAxios.get('/match/status/notstarted/' + req.page + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	
	    getAllUpComingMatches: function getAllUpComingMatches(req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCHES,
	            payload: _ccImports.CCAxios.get('/match/status/notstarted/' + req.page + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getLiveMatches: function getLiveMatches(req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCHES,
	            payload: _ccImports.CCAxios.get('/match/status/started/' + req.page + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getCompletedMatches: function getCompletedMatches(req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCHES,
	            payload: _ccImports.CCAxios.get('/match/status/completed/' + req.page + '/' + req.limit + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getRecentMatches: function getRecentMatches(type) {
	        return {
	            type: _ccImports.ActionTypes.GET_MATCHES,
	            payload: _ccImports.CCAxios.get('/match/recent/'),
	            meta: {
	                type: type
	            }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _config = __webpack_require__(19);
	
	var Actions = {
	    openHome: function openHome() {
	        return {
	            type: _ccImports.ActionTypes.HOME
	        };
	    },
	    openLeagues: function openLeagues(matchId) {
	        return {
	            type: _ccImports.ActionTypes.LEAGUES,
	            payload: {
	                matchId: matchId
	            }
	        };
	    },
	    goBack: function goBack() {
	        return {
	            type: _ccImports.ActionTypes.BACK
	        };
	    },
	
	    openAddCoinsModal: function openAddCoinsModal() {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: "AddCoinsModal"
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            });
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'AddCoins'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openSingleLeagueModal: function openSingleLeagueModal(league) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                league: league,
	                name: 'SingleLeagueModal'
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        league : league,
	                        name : 'SingleLeagueModal'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openReAuthModal: function openReAuthModal(payload) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: Object.assign({}, payload, {
	                name: 'ReAuth'
	            })
	        };
	        /* return (dispatch)=>{
	             dispatch({
	                 type : ActionTypes.PRE_CLOSE_MODAL
	             })
	             setTimeout(() => {
	                 dispatch({
	                     type: ActionTypes.OPEN_MODAL,
	                     payload : {
	                         ...payload,
	                         name : 'ReAuth'
	                     }
	                 })
	             }, 1000)
	         }*/
	    },
	    openSignInModal: function openSignInModal(payload) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: Object.assign({}, payload, {
	                name: 'SignIn'
	            })
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        ...payload,
	                        name : 'SignIn'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openEntriesModal: function openEntriesModal() {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'Entries'
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'Entries'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openNotificationsModal: function openNotificationsModal() {
	
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'Notifications'
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'Notifications'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openChatModal: function openChatModal() {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'Chats'
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'Chats'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openMoreModal: function openMoreModal() {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'More'
	            }
	        };
	    },
	    openTransactionsHistoryModal: function openTransactionsHistoryModal() {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'TransactionsHistory'
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch({
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'TransactionsHistory'
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openDreamTeamEntryCreationModal: function openDreamTeamEntryCreationModal(league) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'DreamTeamEntryCreation',
	                league: league
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type : ActionTypes.PRE_CLOSE_MODAL
	            })
	            setTimeout(() => {
	                dispatch( {
	                    type: ActionTypes.OPEN_MODAL,
	                    payload : {
	                        name : 'DreamTeamEntryCreationModal',
	                        league : league
	                    }
	                })
	            }, 1000)
	        }*/
	    },
	    openPredictionEntryCreationModal: function openPredictionEntryCreationModal(league) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'PredictionEntryCreation',
	                league: league
	            }
	        };
	        /* return (dispatch)=>{
	             dispatch({
	                 type : ActionTypes.PRE_CLOSE_MODAL
	             })
	             setTimeout(() => {
	                 dispatch(  {
	                     type: ActionTypes.OPEN_MODAL,
	                     payload : {
	                         name : 'PredictionEntryCreationModal',
	                         league : league
	                     }
	                 })
	             }, 1000)
	         }*/
	    },
	    openSponsorDetailsModal: function openSponsorDetailsModal(sponsor) {
	        return {
	            type: _ccImports.ActionTypes.OPEN_MODAL,
	            payload: {
	                name: 'SponsorDetails',
	                sponsor: sponsor
	            }
	        };
	    },
	    closeModal: function closeModal(name) {
	        return {
	            type: _ccImports.ActionTypes.CLOSE_MODAL,
	            payload: {
	                name: name
	            }
	        };
	        /*return (dispatch)=>{
	            dispatch({
	                type: ActionTypes.CLOSE_MODAL,
	                payload: {
	                    name : name
	                }
	            })
	            setTimeout(() => {
	                dispatch(  {
	                    type: ActionTypes.OPEN_LAST_OPEN_MODAL
	                })
	            }, 1000)
	        }*/
	    },
	
	    showEmailNotVerifiedMessage: function showEmailNotVerifiedMessage(callback) {
	        return {
	            type: _ccImports.ActionTypes.SHOW_ALERT,
	            payload: {
	                name: 'EmailNotVerified',
	                message: (0, _ccImports.strings)('email_not_verified') + ' ' + (0, _ccImports.strings)('email_not_verified_to_claim_rewards'),
	                clickableMessage: ' ' + (0, _ccImports.strings)('click_here_to_resend'),
	                type: 'WARNING',
	                textLines: 2,
	                buttonAction: callback
	            }
	        };
	    },
	
	    hideEmailNotVerifiedMessage: function hideEmailNotVerifiedMessage() {
	        return {
	            type: _ccImports.ActionTypes.HIDE_ALERT,
	            payload: {
	                name: 'EmailNotVerified'
	            }
	        };
	    },
	
	    showNoNetworkMessage: function showNoNetworkMessage() {
	        return {
	            type: _ccImports.ActionTypes.SHOW_ALERT,
	            payload: {
	                name: 'NoNetwork',
	                message: (0, _ccImports.strings)('no_network_connection'),
	                type: 'INFO'
	            }
	        };
	    },
	
	    hideNoNetworkMessage: function hideNoNetworkMessage() {
	        return {
	            type: _ccImports.ActionTypes.HIDE_ALERT,
	            payload: {
	                name: 'NoNetwork'
	            }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var NotificationActions = {
	
	    fetchNotifications: function fetchNotifications(userId, skip, limit, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_NOTIFICATIONS,
	            payload: _ccImports.CCAxios.get('/notification/userId/' + userId + '/' + skip + '/' + limit + '/'),
	            meta: {
	                type: type,
	                id: userId
	            }
	        };
	    },
	
	    getNtfnById: function getNtfnById(req, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_NOTIFICATION,
	            payload: _ccImports.CCAxios.get('/notification/ntfnId/' + req.ntfnId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    getUnseenCount: function getUnseenCount(req) {
	        return {
	            type: _ccImports.ActionTypes.GET_UNSEEN_COUNT,
	            payload: _ccImports.CCAxios.get('/notification/unseen/userId/' + req.userId + '/')
	        };
	    },
	    updateSeen: function updateSeen(req) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_SEEN,
	            payload: _ccImports.CCAxios.get('/notification/seen/userId/' + req.userId + '/' + req.skip + '/' + req.limit + '/')
	        };
	    },
	    ntfnUpdated: function ntfnUpdated(ntfn, userId) {
	        return {
	            type: _ccImports.ActionTypes.NOTIFICATION_UPDATED,
	            payload: ntfn
	        };
	    }
	};
	
	exports.default = NotificationActions;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    getReward: function getReward(authDetails, rewardId, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_REWARD,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/reward/rewardId/' + rewardId + '/'),
	            meta: {
	                type: type
	            }
	        };
	    },
	    claimReward: function claimReward(authDetails, reward, type) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_REWARD_CLAIM,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).post('/reward/claim/', reward),
	            meta: {
	                type: type
	            }
	        };
	    },
	    updateClaimReward: function updateClaimReward(authDetails, reward, type) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_REWARD_CLAIM,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).post('/reward/claim/update/', reward),
	            meta: {
	                type: type
	            }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var ShareActions = {
	
	    showShare: function showShare(tab) {
	        return {
	            type: _ccImports.ActionTypes.SHARE_FB,
	            payload: {
	                tab: tab
	            }
	        };
	    }
	};
	
	exports.default = ShareActions;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var SponsorsActions = {
	    getSponsorsByUserId: function getSponsorsByUserId(userId, type) {
	        return {
	            type: _ccImports.ActionTypes.GET_SPONSORS,
	            payload: _ccImports.CCAxios.get('/sponsor/userId/' + userId + '/'),
	            meta: {
	                type: type,
	                id: userId
	            }
	        };
	    }
	};
	
	exports.default = SponsorsActions;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ActionTypes = __webpack_require__(81);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Actions = {
	    fetchTransactions: function fetchTransactions(accessToken, userId, skip, limit, type) {
	        return {
	            type: _ActionTypes2.default.GET_TRANSACTIONS,
	            payload: (0, _ccImports.CCAuthorizedAxios)(accessToken).get('/transaction/userId/' + userId + '/skip/' + skip + '/limit/' + limit + '/'),
	            meta: {
	                type: type,
	                id: userId
	            }
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var Actions = {
	    getUser: function getUser(authDetails) {
	        return {
	            type: _ccImports.ActionTypes.GET_USER,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/user/userId/' + authDetails.userId + '/')
	        };
	    },
	    getUserByEmail: function getUserByEmail(authDetails) {
	        return {
	            type: _ccImports.ActionTypes.GET_USER,
	            payload: (0, _ccImports.CCAuthorizedAxios)(authDetails).get('/user/email/' + authDetails.email + '/')
	        };
	    },
	    getOrCreateUserByEmail: function getOrCreateUserByEmail(user, accessToken) {
	        return {
	            type: _ccImports.ActionTypes.GET_OR_CREATE_USER,
	            payload: (0, _ccImports.CCAuthorizedAxios)({ accessToken: accessToken }).post('/user/email/' + user.email + '/', user)
	        };
	    },
	    fbUserNotFound: function fbUserNotFound() {
	        return {
	            type: _ccImports.ActionTypes.FB_USER_NOT_FOUND
	        };
	    },
	    signUpUser: function signUpUser(user) {
	        return {
	            type: _ccImports.ActionTypes.SIGN_UP_USER,
	            payload: _ccImports.CCAxios.post('/user/', user)
	        };
	    },
	    updateShowHelp: function updateShowHelp(user) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_SHOW_HELP,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + user.id + '/', { helped: true })
	        };
	    },
	    updatePhoneNumber: function updatePhoneNumber(user) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_PHONE_NUMBER,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + user.id + '/', { phone: user.phone })
	        };
	    },
	    updateInvitedBy: function updateInvitedBy(email, invitedBy) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_INVITED_BY,
	            payload: _ccImports.CCAxios.post('/user/invitation/email/' + email + '/', { invitedBy: { id: invitedBy } })
	        };
	    },
	    updateCountry: function updateCountry(user, country) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_SETTINGS,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + user.id + '/', { country: country })
	        };
	    },
	    editionChanged: function editionChanged() {
	        return {
	            type: _ccImports.ActionTypes.EDITION_CHANGED
	        };
	    },
	    updateLanguage: function updateLanguage(user, language) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_SETTINGS,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + user.id + '/', { language: language })
	        };
	    },
	    updateSettings: function updateSettings(user, settings) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_SETTINGS,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + user.id + '/', { settings: settings })
	        };
	    },
	    updateUser: function updateUser(userId, user) {
	        return {
	            type: _ccImports.ActionTypes.UPDATE_USER,
	            payload: _ccImports.CCAxios.post('/user/update/userId/' + userId + '/', user)
	        };
	    },
	    signOutUser: function signOutUser() {
	        return {
	            type: _ccImports.ActionTypes.SIGN_OUT_USER
	        };
	    },
	    anonymousUserIn: function anonymousUserIn() {
	        return {
	            type: _ccImports.ActionTypes.ANONYMOUS_USER_IN
	        };
	    },
	    saveFailedCredentials: function saveFailedCredentials(credentials) {
	        return {
	            type: _ccImports.ActionTypes.SAVE_FAILED_CREDENTIALS,
	            payload: credentials
	        };
	    }
	};
	
	exports.default = Actions;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ActionTypes = exports.DataActionTypes = exports.CCActions = undefined;
	
	var _CacheActions = __webpack_require__(324);
	
	var _CacheActions2 = _interopRequireDefault(_CacheActions);
	
	var _DimensionActions = __webpack_require__(325);
	
	var _DimensionActions2 = _interopRequireDefault(_DimensionActions);
	
	var _EntryActions = __webpack_require__(326);
	
	var _EntryActions2 = _interopRequireDefault(_EntryActions);
	
	var _HelpActions = __webpack_require__(327);
	
	var _HelpActions2 = _interopRequireDefault(_HelpActions);
	
	var _LeaderboardActions = __webpack_require__(328);
	
	var _LeaderboardActions2 = _interopRequireDefault(_LeaderboardActions);
	
	var _LeagueActions = __webpack_require__(329);
	
	var _LeagueActions2 = _interopRequireDefault(_LeagueActions);
	
	var _MatchActions = __webpack_require__(330);
	
	var _MatchActions2 = _interopRequireDefault(_MatchActions);
	
	var _NavigationActions = __webpack_require__(331);
	
	var _NavigationActions2 = _interopRequireDefault(_NavigationActions);
	
	var _NotificationActions = __webpack_require__(332);
	
	var _NotificationActions2 = _interopRequireDefault(_NotificationActions);
	
	var _RewardActions = __webpack_require__(333);
	
	var _RewardActions2 = _interopRequireDefault(_RewardActions);
	
	var _ShareActions = __webpack_require__(334);
	
	var _ShareActions2 = _interopRequireDefault(_ShareActions);
	
	var _SponsorsActions = __webpack_require__(335);
	
	var _SponsorsActions2 = _interopRequireDefault(_SponsorsActions);
	
	var _TransactionActions = __webpack_require__(336);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	var _UserActions = __webpack_require__(337);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ActionTypes = __webpack_require__(81);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _DataActionTypes = __webpack_require__(82);
	
	var _DataActionTypes2 = _interopRequireDefault(_DataActionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCActions = Object.assign({}, _CacheActions2.default, _DimensionActions2.default, _EntryActions2.default, _HelpActions2.default, _LeaderboardActions2.default, _LeagueActions2.default, _MatchActions2.default, _NavigationActions2.default, _NotificationActions2.default, _RewardActions2.default, _ShareActions2.default, _SponsorsActions2.default, _TransactionActions2.default, _UserActions2.default);
	
	exports.CCActions = CCActions;
	exports.DataActionTypes = _DataActionTypes2.default;
	exports.ActionTypes = _ActionTypes2.default;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(338);
	
	Object.keys(_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions[key];
	    }
	  });
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    alerts: []
	};
	
	var AlertsReducer = function AlertsReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.SHOW_ALERT:
	            var alerts = _lodash2.default.unionBy(state.alerts, [action.payload], 'name');
	            return Object.assign({}, state, { alerts: alerts });
	        case _ccImports.ActionTypes.HIDE_ALERT:
	            var prevAlerts = state.alerts;
	            _lodash2.default.remove(prevAlerts, function (alert) {
	                return alert.name == action.payload.name;
	            });
	            return Object.assign({}, state, { alerts: prevAlerts });
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	        default:
	            return state;
	    }
	};
	
	exports.default = AlertsReducer;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    leagueId: undefined,
	    matchId: undefined
	};
	
	var NavigationReducers = function NavigationReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.LEAGUES:
	            return Object.assign({}, state, { matchId: action.payload.matchId });
	        default:
	            return state || initialState;
	    }
	};
	
	exports.default = NavigationReducers;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    cache: {}
	};
	
	var CacheReducers = function CacheReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.ADD_TO_CACHE:
	            var cache = state.cache;
	            cache[action.payload.key] = action.payload.value;
	            return Object.assign({}, state, { cache: cache });
	        case _ccImports.ActionTypes.REMOVE_FROM_CACHE:
	            var cache = state.cache;
	            cache[action.payload.key] = undefined;
	            return Object.assign({}, state, { cache: cache });
	        default:
	            return state;
	    }
	};
	
	exports.default = CacheReducers;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    byId: {},
	    byLeague: {},
	    byCreatorId: {},
	    liveScores: {},
	
	    pages: {},
	
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports.DataActionTypes.GET
	};
	
	var processData = function processData(oldState, newEntries, type, id) {
	    var byId = _lodash2.default.keyBy(newEntries, 'id');
	    var existingEntriesByIds = oldState.byId ? oldState.byId : [];
	    existingEntriesByIds = _lodash2.default.merge({}, existingEntriesByIds, byId);
	
	    var byLeague = _ccImports.CCUtils.groupByGetIds(newEntries, 'league', 'id');
	    byLeague = type == _ccImports.DataActionTypes.PAGINATE ? _lodash2.default.mergeWith({}, oldState.byLeague, byLeague, _ccImports.CCUtils.customArrMerger) : _lodash2.default.mergeWith({}, byLeague, oldState.byLeague, _ccImports.CCUtils.customArrMerger);
	
	    var byCreatorId = _ccImports.CCUtils.groupByGetIds(newEntries, 'creator', 'id');
	    byCreatorId = type == _ccImports.DataActionTypes.PAGINATE ? _lodash2.default.mergeWith({}, oldState.byCreatorId, byCreatorId, _ccImports.CCUtils.customArrMerger) : _lodash2.default.mergeWith({}, byCreatorId, oldState.byCreatorId, _ccImports.CCUtils.customArrMerger);
	
	    var pages = oldState.pages;
	
	    if (id) {
	        if (pages[id] == undefined) {
	            pages[id] = 0;
	        }
	        if (type == _ccImports.DataActionTypes.PAGINATE || type == _ccImports.DataActionTypes.GET) {
	            pages[id] = pages[id] + 1;
	        }
	    }
	
	    var liveScores = {};
	    _lodash2.default.forIn(existingEntriesByIds, function (entry, id) {
	        if (entry.status == _ccImports.Constants.entryStatus.LIVE) {
	            liveScores[id] = entry.score;
	        }
	    });
	
	    return {
	        byId: existingEntriesByIds,
	        byLeague: byLeague,
	        byCreatorId: byCreatorId,
	        liveScores: liveScores,
	        pages: pages
	    };
	};
	
	var EntryReducers = function EntryReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.ENTRY_UPDATED:
	            return Object.assign({}, state, processData(state, [action.payload], action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_ENTRIES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.SUC,
	                random: Math.random(),
	                error: '',
	                type: action.meta.type
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_ENTRIES):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports.DataActionTypes.PAGINATE ? _ccImports.Constants.reqStatus.COM : _ccImports.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_ENTRIES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_ENTRIES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.CREATE_ENTRY):
	            var singleEntry = action.payload.data.item;
	            singleEntry.new = true;
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.COM,
	                error: '',
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, [singleEntry], action.meta.type, undefined));
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.CREATE_ENTRY):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.FAI,
	                error: action.payload.data.statusDescription,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.CREATE_ENTRY):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.CREATE_ENTRY):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            var emptryInitialState = initialState;
	            //emptryInitialState.entries.entries={};
	            return emptryInitialState;
	            break;
	        case _ccImports.ActionTypes.CLOSE_MODAL:
	            return Object.assign({}, state, { pages: {} });
	        default:
	            return state;
	    }
	};
	
	exports.default = EntryReducers;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    lbs: {
	        byId: [],
	        bySponsor: []
	    },
	    lbStatuses: {
	        lbStatuses: {},
	        byLbId: {}
	    },
	    fetching: false,
	    fetched: false,
	    success: false,
	    completed: false,
	    type: _ccImports.DataActionTypes.GET
	};
	
	var processData = function processData(oldLbStatus, lbs) {
	    if (lbs) {
	        lbs = _lodash2.default.uniqBy(lbs, function (lb) {
	            return lb.user.id;
	        });
	    }
	
	    var byId = _lodash2.default.keyBy(lbs, 'id');
	    var existingLbIds = oldLbStatus.lbStatuses;
	    existingLbIds = _lodash2.default.merge({}, existingLbIds, byId);
	
	    var byLbId = _ccImports.CCUtils.groupByGetIds(lbs, 'lbId');
	    byLbId = _lodash2.default.mergeWith({}, byLbId, oldLbStatus.byLbId, _ccImports.CCUtils.customArrMerger);
	
	    return {
	        lbStatuses: existingLbIds,
	        byLbId: byLbId
	    };
	};
	
	var processLbs = function processLbs(oldLbs, lbs) {
	
	    var byId = _lodash2.default.keyBy(lbs, 'id');
	    var existingLbIds = oldLbs.byId;
	    existingLbIds = _lodash2.default.merge({}, existingLbIds, byId);
	
	    var bySponsor = _ccImports.CCUtils.groupByGetIds(lbs, 'sponsor', 'key');
	    bySponsor = _lodash2.default.mergeWith({}, bySponsor, oldLbs.bySponsor, _ccImports.CCUtils.customArrMerger);
	
	    return {
	        byId: byId,
	        bySponsor: bySponsor
	    };
	};
	
	var LeaderBoardReducers = function LeaderBoardReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_LBS):
	            var newLbs = action.payload.data.item;
	            return Object.assign({}, state, { fetching: false, fetched: true, lbs: processLbs(state.lbs, newLbs), success: true, completed: false, type: action.meta.type, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_LBS):
	            return Object.assign({}, state, {
	                fetching: false,
	                fetched: true,
	                success: false,
	                completed: true,
	                type: action.meta.type,
	                random: Math.random()
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_LBS):
	            return Object.assign({}, state, { fetching: true, fetched: false, type: action.meta.type });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_LBS):
	            return Object.assign({}, state, { fetching: false, fetched: true, type: action.meta.type });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_LB_STATUS):
	            return Object.assign({}, state, { fetching: false, fetched: true, lbStatuses: processData(state.lbStatuses, action.payload.data.item), success: true, completed: false, type: action.meta.type, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_LB_STATUS):
	            return Object.assign({}, state, {
	                fetching: false,
	                lbStatuses: processData(state.lbStatuses, action.payload.data.item),
	                fetched: true,
	                success: false,
	                completed: true,
	                type: action.meta.type,
	                random: Math.random()
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_LB_STATUS):
	            return Object.assign({}, state, { fetching: true, fetched: false, type: action.meta.type });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_LB_STATUS):
	            return Object.assign({}, state, { fetching: false, fetched: true, type: action.meta.type });
	            break;
	
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	            break;
	
	        default:
	            return state;
	    }
	};
	
	exports.default = LeaderBoardReducers;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	
	    byId: {},
	    byMatch: {},
	    byStatus: {},
	
	    pages: {},
	
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports2.DataActionTypes.GET
	};
	
	var processData = function processData(oldState, leagues, type, id) {
	    var byId = _lodash2.default.keyBy(leagues, 'id');
	    var existingLeagueByIds = oldState.byId ? oldState.byId : [];
	    existingLeagueByIds = _lodash2.default.merge({}, existingLeagueByIds, byId);
	
	    var byMatch = _ccImports.CCUtils.groupByGetIds(leagues, 'match', 'id');
	    byMatch = _lodash2.default.mergeWith({}, byMatch, oldState.byMatch, _ccImports.CCUtils.customArrMerger);
	
	    var byStatus = _lodash2.default.reduce(existingLeagueByIds, function (result, league, key) {
	        (result[league.status] || (result[league.status] = [])).push(key);
	        return result;
	    }, {});
	
	    var pages = oldState.pages;
	    if (id) {
	        if (pages[id] == undefined) {
	            pages[id] = 0;
	        } else {
	            if (type == _ccImports2.DataActionTypes.PAGINATE) {
	                pages[id] = pages[id] + 1;
	            }
	        }
	    }
	
	    return {
	        byId: existingLeagueByIds,
	        byMatch: byMatch,
	        byStatus: byStatus,
	        pages: pages
	    };
	};
	
	var LeaguesReducers = function LeaguesReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_LEAGUE):
	            var singleLeague = action.payload.data.item;
	            singleLeague.complete = true;
	
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                error: '',
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, [singleLeague], action.meta.type, action.meta.id));
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_LEAGUES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                error: '',
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_LEAGUE):
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_LEAGUES):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports2.DataActionTypes.PAGINATE ? _ccImports2.Constants.reqStatus.COM : _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_LEAGUE):
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_LEAGUES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_LEAGUE):
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_LEAGUES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	            break;
	        case _ccImports.ActionTypes.EDITION_CHANGED:
	            return initialState;
	        default:
	            return state;
	    }
	};
	
	exports.default = LeaguesReducers;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	
	    byId: {},
	    byStatus: {},
	
	    pages: {},
	
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports.DataActionTypes.GET
	};
	
	var processData = function processData(oldState, matches, type, id) {
	    var byId = _lodash2.default.keyBy(matches, 'id');
	    var existingMatchesByIds = oldState.byId ? oldState.byId : [];
	    existingMatchesByIds = _lodash2.default.merge({}, existingMatchesByIds, byId);
	
	    var byStatus = {};
	
	    _lodash2.default.forIn(existingMatchesByIds, function (match, id) {
	        byStatus[match.status] = byStatus[match.status] ? byStatus[match.status] : [];
	        byStatus[match.status].push(id);
	    });
	
	    var pages = oldState.pages;
	
	    if (id) {
	        if (pages[id] == undefined) {
	            pages[id] = 0;
	        } else {
	            if (type == _ccImports.DataActionTypes.PAGINATE) {
	                pages[id] = pages[id] + 1;
	            }
	        }
	    }
	
	    return {
	        byId: existingMatchesByIds,
	        byStatus: byStatus,
	        pages: pages
	    };
	};
	
	var MatchesReducers = function MatchesReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	
	        case _ccImports.ActionTypes.MATCH_UPDATED:
	            return Object.assign({}, state, {
	                type: action.meta.type
	            }, processData(state, action.payload, action.meta.type, action.meta.id), {
	                random: Math.random()
	            });
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_MATCH):
	            var singleMatch = action.payload.data.item;
	            singleMatch.complete = true;
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                random: Math.random(),
	                error: '',
	                type: action.meta.type
	            }, processData(state, [singleMatch], action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_MATCHES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                random: Math.random(),
	                error: '',
	                type: action.meta.type
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_MATCHES):
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_MATCH):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports.DataActionTypes.PAGINATE ? _ccImports2.Constants.reqStatus.COM : _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_MATCHES):
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_MATCH):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_MATCH):
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_MATCHES):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type });
	            break;
	
	        default:
	            return state;
	    }
	};
	
	exports.default = MatchesReducers;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    modals: [],
	    random: 0
	};
	
	var ModalsReducers = function ModalsReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.OPEN_MODAL:
	            var modals = _lodash2.default.unionBy(state.modals, [action.payload], 'name');
	            return Object.assign({}, state, { modals: modals, random: Math.random() });
	        case _ccImports.ActionTypes.CLOSE_MODAL:
	            var modals = state.modals;
	            _lodash2.default.remove(modals, function (modal) {
	                return modal.name == action.payload.name;
	            });
	            return Object.assign({}, state, { modals: modals, random: Math.random() });
	        default:
	            return state;
	    }
	};
	
	exports.default = ModalsReducers;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    byId: {},
	    byUserId: {},
	
	    pages: {},
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports2.DataActionTypes.GET,
	    unseenCount: 0
	
	};
	
	var processData = function processData(oldState, newNtfns, type, userId) {
	
	    var byId = _lodash2.default.keyBy(newNtfns, 'id');
	    var existingById = oldState.byId ? oldState.byId : [];
	    existingById = _lodash2.default.merge({}, existingById, byId);
	
	    var byUserId = _ccImports2.CCUtils.groupByGetIds(newNtfns, 'receiver', 'id');
	    byUserId = type == _ccImports2.DataActionTypes.PAGINATE ? _lodash2.default.mergeWith({}, oldState.byUserId, byUserId, _ccImports2.CCUtils.customArrMerger) : _lodash2.default.mergeWith({}, byUserId, oldState.byUserId, _ccImports2.CCUtils.customArrMerger);
	
	    var pages = oldState.pages;
	
	    if (userId) {
	
	        var ntfns = _lodash2.default.orderBy(byUserId[userId], [function (ntfn) {
	            if (existingById[ntfn]) {
	                return new Date(existingById[ntfn].createdDate);
	            } else {
	                return new Date();
	            }
	        }], ['desc']);
	        byUserId[userId] = ntfns;
	
	        if (pages[userId] == undefined) {
	            pages[userId] = 0;
	        }
	
	        if (type == _ccImports2.DataActionTypes.PAGINATE || type == _ccImports2.DataActionTypes.GET) {
	            pages[userId] = pages[userId] + 1;
	        }
	    }
	
	    return {
	        byId: existingById,
	        byUserId: byUserId,
	        pages: pages
	    };
	};
	
	var NotificationsReducers = function NotificationsReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.NOTIFICATION_UPDATED:
	            var _action$meta = action.meta,
	                type = _action$meta.type,
	                userId = _action$meta.userId;
	
	            return Object.assign({}, state, processData(state, [action.payload], type, userId));
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_NOTIFICATIONS):
	
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_NOTIFICATIONS):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports2.DataActionTypes.PAGINATE ? _ccImports2.Constants.reqStatus.COM : _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_NOTIFICATIONS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_NOTIFICATIONS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	
	        // TODO:  want to update
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_NOTIFICATION):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, [action.payload.data.item], action.meta.type, action.meta.id));
	            break;
	
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_NOTIFICATION):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	
	        // TODO:  want to update
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_NOTIFICATION):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_NOTIFICATION):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_UNSEEN_COUNT):
	            return Object.assign({}, state, { unseenCount: action.payload.data.item.counts });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_UNSEEN_COUNT):
	            return Object.assign({}, state, { unseenCount: action.payload.data.item.counts });
	            break;
	
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	            break;
	
	        case _ccImports.ActionTypes.CLOSE_MODAL:
	            return Object.assign({}, state, { pages: {} });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = NotificationsReducers;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    rewards: {
	        rewards: {}
	    },
	
	    type: _ccImports.DataActionTypes.GET,
	    completed: false,
	
	    fetching: false,
	    fetched: false,
	    success: false,
	    random: 0
	};
	
	var processData = function processData(oldRewards, rewards) {
	    var byId = _lodash2.default.keyBy(rewards, 'id');
	    var existingRewardsByIds = oldRewards.rewards ? oldRewards.rewards : [];
	
	    existingRewardsByIds = _lodash2.default.merge({}, existingRewardsByIds, byId);
	
	    return {
	        rewards: existingRewardsByIds
	    };
	};
	
	var RewardReducers = function RewardReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_REWARD):
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.UPDATE_REWARD_CLAIM):
	            var reward = action.payload.data.item;
	            return Object.assign({}, state, {
	                fetching: false,
	                fetched: true,
	                rewards: processData(state.rewards, [reward]),
	                success: true,
	                type: action.meta.type,
	                random: Math.random()
	            });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_REWARD):
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.UPDATE_REWARD_CLAIM):
	            return Object.assign({}, state, {
	                uFetching: false,
	                uFetched: true,
	                uSuccess: false,
	                completed: true,
	                type: action.meta.type,
	                random: Math.random()
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_REWARD):
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.UPDATE_REWARD_CLAIM):
	            return Object.assign({}, state, { fetching: true, type: action.meta.type });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_REWARD):
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.UPDATE_REWARD_CLAIM):
	            return Object.assign({}, state, { fetching: false, fetched: true, type: action.meta.type });
	            break;
	
	        default:
	            return state;
	    }
	};
	
	exports.default = RewardReducers;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    byKey: {},
	
	    pages: {},
	
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports2.DataActionTypes.GET
	};
	
	var processData = function processData(oldState, newSponsors, type, id) {
	    var byKey = _lodash2.default.keyBy(newSponsors, 'key');
	    var exSponsorsByKey = oldState.byId ? oldState.byKey : [];
	    exSponsorsByKey = _lodash2.default.merge({}, exSponsorsByKey, byKey);
	
	    var pages = oldState.pages;
	
	    if (id) {
	        if (pages[id] == undefined) {
	            pages[id] = 0;
	        } else {
	            if (type == _ccImports2.DataActionTypes.PAGINATE) {
	                pages[id] = pages[id] + 1;
	            }
	        }
	    }
	
	    return {
	        byKey: exSponsorsByKey,
	        pages: pages
	    };
	};
	
	var SponsorsReducers = function SponsorsReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_SPONSORS):
	            return Object.assign({}, state, {
	                type: action.meta.type,
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                random: Math.random(),
	                error: ''
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_SPONSORS):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports2.DataActionTypes.PAGINATE ? _ccImports2.Constants.reqStatus.COM : _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_SPONSORS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_SPONSORS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type });
	            break;
	        default:
	            return state;
	    }
	};
	
	exports.default = SponsorsReducers;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    byId: {},
	    byUserId: {},
	
	    pages: {},
	
	    reqStatus: '',
	    error: '',
	    random: 0,
	    type: _ccImports.DataActionTypes.GET
	};
	
	var processData = function processData(oldState, newTrns, type, userId) {
	
	    var byId = _lodash2.default.keyBy(newTrns, 'id');
	    var existingById = oldState.byId ? oldState.byId : [];
	    existingById = _lodash2.default.merge({}, existingById, byId);
	
	    var byUserId = _ccImports2.CCUtils.groupByGetIds(newTrns, 'user', 'id');
	    byUserId = _lodash2.default.mergeWith({}, byUserId, oldState.byUserId, _ccImports2.CCUtils.customArrMerger);
	
	    var pages = oldState.pages;
	    //console.log("******************************* ", userId, type, newTrns, byUserId)
	
	    if (userId) {
	
	        var transactions = byUserId[userId];
	        transactions = _lodash2.default.orderBy(transactions, [function (transaction) {
	            if (existingById[transaction]) {
	                return new Date(existingById[transaction].createdDate);
	            } else {
	                return new Date(-8640000000000000);
	            }
	        }], ['desc']);
	
	        byUserId[userId] = transactions;
	        // console.log("******************************* sorted", userId, type, newTrns)
	
	        if (pages[userId] == undefined) {
	            pages[userId] = 0;
	        }
	        if (type == _ccImports.DataActionTypes.PAGINATE || type == _ccImports.DataActionTypes.GET) {
	            pages[userId] = pages[userId] + 1;
	        }
	    }
	
	    return {
	        byId: existingById,
	        byUserId: byUserId,
	        pages: pages
	    };
	};
	
	var TransactionsReducers = function TransactionsReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_TRANSACTIONS):
	
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.SUC,
	                type: action.meta.type,
	                random: Math.random()
	            }, processData(state, action.payload.data.item, action.meta.type, action.meta.id));
	            break;
	
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_TRANSACTIONS):
	            return Object.assign({}, state, {
	                reqStatus: action.meta.type == _ccImports.DataActionTypes.PAGINATE ? _ccImports2.Constants.reqStatus.COM : _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_TRANSACTIONS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.PEN,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_TRANSACTIONS):
	            return Object.assign({}, state, {
	                reqStatus: _ccImports2.Constants.reqStatus.FAI,
	                type: action.meta.type
	            });
	            break;
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	            break;
	        case _ccImports.ActionTypes.CLOSE_MODAL:
	            return Object.assign({}, state, { pages: {} });
	        default:
	            return state;
	    }
	};
	
	exports.default = TransactionsReducers;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ccImports = __webpack_require__(1);
	
	var initialState = {
	    fetching: false,
	    fetched: false,
	    user: {},
	    error: null,
	    success: false,
	    failedCredentials: [],
	    random: 0,
	    anonymous: false
	};
	
	var UserReducer = function UserReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ccImports.ActionTypes.GET_USER:
	            return Object.assign({}, state, { fetching: false, fetched: false });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.UPDATE_SETTINGS):
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.UPDATE_USER):
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.UPDATE_SHOW_HELP):
	            (0, _ccImports.updateLocale)(action.payload.data.item.language);
	        //I18n.locale=action.payload.data.item.language;
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_USER):
	            _ccImports.CCAppEventLogger.setUserProperties(action.payload.data.item);
	            var savedUser = action.payload.data.item;
	            //(savedUser && savedUser.settings && savedUser.settings.language && savedUser.settings.language) && (I18n.locale = savedUser.settings.language);
	            return Object.assign({}, state, { fetching: false, fetched: true, user: action.payload.data.item, success: true, random: Math.random(), anonymous: false });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true, error: action.payload.data.statusDescription, success: false, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_USER):
	            return Object.assign({}, state, { fetching: true });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.GET_OR_CREATE_USER):
	            _ccImports.CCAppEventLogger.setUserProperties(action.payload.data.item);
	            (0, _ccImports.updateLocale)(action.payload.data.item.language);
	            //I18n.locale=action.payload.data.item.language;
	            return Object.assign({}, state, { fetching: false, fetched: true, user: action.payload.data.item, success: true, random: Math.random(), anonymous: false });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.GET_OR_CREATE_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true, error: action.payload.data.statusDescription, success: false, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.GET_OR_CREATE_USER):
	            return Object.assign({}, state, { fetching: true });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.GET_OR_CREATE_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.SIGN_UP_USER):
	            _ccImports.CCAppEventLogger.setUserProperties(action.payload.data.item);
	            return Object.assign({}, state, { fetching: false, fetched: true, user: action.payload.data.item, success: true, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.getFulfilled(_ccImports.ActionTypes.SIGN_UP_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true, error: action.payload.data.statusDescription, success: false });
	            break;
	        case _ccImports.ActionTypes.getPending(_ccImports.ActionTypes.SIGN_UP_USER):
	            return Object.assign({}, state, { fetching: true });
	            break;
	        case _ccImports.ActionTypes.getRejected(_ccImports.ActionTypes.SIGN_UP_USER):
	            return Object.assign({}, state, { fetching: false, fetched: true, error: (0, _ccImports.strings)('data.reducers.userReducer.something_wrong') });
	            break;
	
	        case _ccImports.ActionTypes.getCCFulfilled(_ccImports.ActionTypes.CREATE_ENTRY):
	            var user = state.user;
	            return Object.assign({}, state, { fetching: false, fetched: true, user: Object.assign({}, user, { coins: user.coins - action.payload.data.item.coins }), success: true, random: Math.random() });
	            break;
	        case _ccImports.ActionTypes.SAVE_FAILED_CREDENTIALS:
	            var failedCredentials = state.failedCredentials;
	            failedCredentials.push(action.payload);
	            //console.log(failedCredentials);
	            return Object.assign({}, state, { failedCredentials: failedCredentials });
	            break;
	        case _ccImports.ActionTypes.SIGN_OUT_USER:
	            return initialState;
	        case _ccImports.ActionTypes.ANONYMOUS_USER_IN:
	            return Object.assign({}, state, { random: Math.random(), anonymous: true });
	        default:
	            return state;
	    }
	    return state;
	};
	
	exports.default = UserReducer;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCBackLayout = undefined;
	
	var _CCBackLayout = __webpack_require__(28);
	
	var _CCBackLayout2 = _interopRequireDefault(_CCBackLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCBackLayout = _CCBackLayout2.default;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCLayout = undefined;
	
	var _CCLayout = __webpack_require__(83);
	
	var _CCLayout2 = _interopRequireDefault(_CCLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCLayout = _CCLayout2.default;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	var _reactModal = __webpack_require__(219);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	__webpack_require__(465);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './ccmodal-layout.css'
	// import './ccmodal-layout-320.css'
	
	var CCModalLayout = function (_Component) {
	    _inherits(CCModalLayout, _Component);
	
	    function CCModalLayout(props) {
	        _classCallCheck(this, CCModalLayout);
	
	        var _this = _possibleConstructorReturn(this, (CCModalLayout.__proto__ || Object.getPrototypeOf(CCModalLayout)).call(this, props));
	
	        _this.state = {};
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._isOpen = _this._isOpen.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCModalLayout, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            if (this.props.closeModal) {
	                this.props.closeModal();
	            } else {
	                this.props.actions.closeModal(this.props.name);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.user.user && this.props.user.user.settings) {
	                this.setState(this.props.user.user.settings);
	            }
	        }
	
	        /*_isOpen(name){
	            const modals = this.props.modals.modals;
	            var isOpen = false;
	            if(modals && modals.length>0){
	                isOpen = Platform.OS === 'ios' ? ( modals[modals.length-1].name == name && modals[modals.length-1].active==true ): _.find(modals, {name : name})!=null;
	            }
	            return isOpen;
	        }*/
	
	    }, {
	        key: '_isOpen',
	        value: function _isOpen(name) {
	            var modals = this.props.modals.modals;
	            var isOpen = false;
	            if (modals && modals.length > 0) {
	                isOpen = modals[modals.length - 1].name == name;
	            }
	            //console.log("ccModal ", isOpen)
	            return isOpen;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = this.props.name;
	
	            var isOpen = this._isOpen(name);
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactModal2.default,
	                        { overlayClassName: "cc-modal-overlay", className: "cc-modal-content", isOpen: isOpen, onRequestClose: this._closeModal },
	                        _react2.default.createElement(
	                            'div',
	                            { className: "flex-container modal-container" },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal-content flex-container cc-modal-body-layer1' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'shadow modal-background cc-modal-body-layer2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container', style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                                        this.props.children
	                                    ),
	                                    _react2.default.createElement(_ccImports.CCIcon, { onPress: this._closeModal, className: 'cc-close-icon-m cc-close-icon', type: "close" })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCModalLayout;
	}(_react.Component);
	
	CCModalLayout.propTypes = {
	    name: _propTypes2.default.string,
	    closeModal: _propTypes2.default.func
	};
	CCModalLayout.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(CCModalLayout);

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCModalLayout = undefined;
	
	var _CCModalLayout = __webpack_require__(355);
	
	var _CCModalLayout2 = _interopRequireDefault(_CCModalLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCModalLayout = _CCModalLayout2.default;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './cc-sidebar-layout.css'
	
	
	var CCSideBarLayout = function (_Component) {
	    _inherits(CCSideBarLayout, _Component);
	
	    function CCSideBarLayout(props) {
	        _classCallCheck(this, CCSideBarLayout);
	
	        var _this = _possibleConstructorReturn(this, (CCSideBarLayout.__proto__ || Object.getPrototypeOf(CCSideBarLayout)).call(this, props));
	
	        _this.state = {};
	        _this._closeModal = _this._closeModal.bind(_this);
	        return _this;
	    }
	
	    _createClass(CCSideBarLayout, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            if (this.props.closeModal) {
	                this.props.closeModal();
	                //console.log('aaa')
	            } else {
	                this.props.actions.closeModal(this.props.name, this.props.onBackPress);
	                //console.log('bbbb')
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.user.user && this.props.user.user.settings) {
	                this.setState(this.props.user.user.settings);
	            }
	        }
	
	        /*_isOpen(name){
	            const modals = this.props.modals.modals;
	            var isOpen = false;
	            if(modals && modals.length>0){
	                isOpen = Platform.OS === 'ios' ? ( modals[modals.length-1].name == name && modals[modals.length-1].active==true ): _.find(modals, {name : name})!=null;
	            }
	            return isOpen;
	        }*/
	
	    }, {
	        key: '_isOpen',
	        value: function _isOpen(name) {
	            var modals = this.props.modals.modals;
	            var isOpen = false;
	            if (modals && modals.length > 0) {
	                isOpen = modals[modals.length - 1].name == name;
	            }
	            if (isOpen) {
	                return 'modal-open';
	            } else return 'modal-close';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = this.props.name;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: "sideBar flex-container " + this._isOpen(name), style: {} },
	                _react2.default.createElement(
	                    'div',
	                    { style: { backgroundColor: _ccImports.colors.theme2.bg_color2, height: '100%' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { elevation: 10, shadowColor: _ccImports.colors.theme2.bg_color2, shadowOffset: { width: 20, height: 20 }, shadowOpacity: 1, height: '100%' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-parent flex-container side-bar-close' },
	                            _react2.default.createElement(_ccImports.CCIcon, { onPress: this._closeModal, className: 'cc-close-icon-xs', type: "sideBarClose" })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-container', style: { flex: 1, flexDirection: 'row', height: '100%' } },
	                            this.props.children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CCSideBarLayout;
	}(_react.Component);
	
	CCSideBarLayout.propTypes = {
	    name: _propTypes2.default.string,
	    closeModal: _propTypes2.default.func,
	    onBackPress: _propTypes2.default.func
	};
	CCSideBarLayout.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(CCSideBarLayout);

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCSideBarLayout = undefined;
	
	var _CCSideBarLayout = __webpack_require__(357);
	
	var _CCSideBarLayout2 = _interopRequireDefault(_CCSideBarLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CCSideBarLayout = _CCSideBarLayout2.default;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CCBackLayout = __webpack_require__(353);
	
	Object.keys(_CCBackLayout).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCBackLayout[key];
	    }
	  });
	});
	
	var _CCLayout = __webpack_require__(354);
	
	Object.keys(_CCLayout).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCLayout[key];
	    }
	  });
	});
	
	var _CCModalLayout = __webpack_require__(356);
	
	Object.keys(_CCModalLayout).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCModalLayout[key];
	    }
	  });
	});
	
	var _CCSideBarLayout = __webpack_require__(358);
	
	Object.keys(_CCSideBarLayout).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCSideBarLayout[key];
	    }
	  });
	});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isNetworkError = isNetworkError;
	exports.isRetryableError = isRetryableError;
	exports.isSafeRequestError = isSafeRequestError;
	exports.isIdempotentRequestError = isIdempotentRequestError;
	exports.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	exports.exponentialDelay = exponentialDelay;
	exports.default = axiosRetry;
	
	var _isRetryAllowed = __webpack_require__(189);
	
	var _isRetryAllowed2 = _interopRequireDefault(_isRetryAllowed);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var namespace = 'axios-retry';
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isNetworkError(error) {
	    return error.message == 'Network Error';
	}
	
	var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
	var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isRetryableError(error) {
	    return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isSafeRequestError(error) {
	    if (!error.config) {
	        // Cannot determine if the request can be retried
	        return false;
	    }
	
	    return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isIdempotentRequestError(error) {
	    if (!error.config) {
	        // Cannot determine if the request can be retried
	        return false;
	    }
	
	    return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isNetworkOrIdempotentRequestError(error) {
	    return isNetworkError(error) || isIdempotentRequestError(error);
	}
	
	/**
	 * @return {number} - delay in milliseconds, always 0
	 */
	function noDelay() {
	    return 0;
	}
	
	/**
	 * @param  {number} [retryNumber=0]
	 * @return {number} - delay in milliseconds
	 */
	function exponentialDelay() {
	    var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var delay = Math.pow(2, retryNumber) * 100;
	    var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
	    return delay + randomSum;
	}
	
	/**
	 * Initializes and returns the retry state for the given request/config
	 * @param  {AxiosRequestConfig} config
	 * @return {Object}
	 */
	function getCurrentState(config) {
	    var currentState = config[namespace] || {};
	    currentState.retryCount = currentState.retryCount || 0;
	    config[namespace] = currentState;
	    return currentState;
	}
	
	/**
	 * Returns the axios-retry options for the current request
	 * @param  {AxiosRequestConfig} config
	 * @param  {AxiosRetryConfig} defaultOptions
	 * @return {AxiosRetryConfig}
	 */
	function getRequestOptions(config, defaultOptions) {
	    return Object.assign({}, defaultOptions, config[namespace]);
	}
	
	/**
	 * @param  {Axios} axios
	 * @param  {AxiosRequestConfig} config
	 */
	function fixConfig(axios, config) {
	    if (axios.defaults.agent === config.agent) {
	        delete config.agent;
	    }
	    if (axios.defaults.httpAgent === config.httpAgent) {
	        delete config.httpAgent;
	    }
	    if (axios.defaults.httpsAgent === config.httpsAgent) {
	        delete config.httpsAgent;
	    }
	}
	
	/**
	 * Adds response interceptors to an axios instance to retry requests failed due to network issues
	 *
	 * @example
	 *
	 * import axios from 'axios';
	 *
	 * axiosRetry(axios, { retries: 3 });
	 *
	 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Exponential back-off retry delay between requests
	 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
	 *
	 * // Custom retry delay
	 * axiosRetry(axios, { retryDelay : (retryCount) => {
	 *   return retryCount * 1000;
	 * }});
	 *
	 * // Also works with custom axios instances
	 * const client = axios.create({ baseURL: 'http://example.com' });
	 * axiosRetry(client, { retries: 3 });
	 *
	 * client.get('/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Allows request-specific configuration
	 * client
	 *   .get('/test', {
	 *     'axios-retry': {
	 *       retries: 0
	 *     }
	 *   })
	 *   .catch(error => { // The first request fails
	 *     error !== undefined
	 *   });
	 *
	 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
	 * @param {Object} [defaultOptions]
	 * @param {number} [defaultOptions.retries=3] Number of retries
	 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
	 *        A function to determine if the error can be retried
	 * @param {Function} [defaultOptions.retryDelay=noDelay]
	 *        A function to determine the delay between retry requests
	 */
	function axiosRetry(axios, defaultOptions) {
	    axios.interceptors.request.use(function (config) {
	        var currentState = getCurrentState(config);
	        currentState.lastRequestTime = Date.now();
	        return config;
	    });
	
	    axios.interceptors.response.use(null, function (error) {
	        var config = error.config;
	
	        // If we have no information to retry the request
	        if (!config) {
	            return Promise.reject(error);
	        }
	
	        var _getRequestOptions = getRequestOptions(config, defaultOptions),
	            _getRequestOptions$re = _getRequestOptions.retries,
	            retries = _getRequestOptions$re === undefined ? 3 : _getRequestOptions$re,
	            _getRequestOptions$re2 = _getRequestOptions.retryCondition,
	            retryCondition = _getRequestOptions$re2 === undefined ? isNetworkOrIdempotentRequestError : _getRequestOptions$re2,
	            _getRequestOptions$re3 = _getRequestOptions.retryDelay,
	            retryDelay = _getRequestOptions$re3 === undefined ? noDelay : _getRequestOptions$re3;
	
	        var currentState = getCurrentState(config);
	
	        var shouldRetry = retryCondition(error) && currentState.retryCount < retries;
	
	        if (shouldRetry) {
	            currentState.retryCount++;
	            var delay = retryDelay(currentState.retryCount, error);
	
	            // Axios fails merging this configuration to the default configuration because it has an issue
	            // with circular structures: https://github.com/mzabriskie/axios/issues/370
	            fixConfig(axios, config);
	
	            if (config.timeout && currentState.lastRequestTime) {
	                var lastRequestDuration = Date.now() - currentState.lastRequestTime;
	                // Minimum 1ms timeout (passing 0 or less to XHR means no timeout)
	                config.timeout = Math.max(config.timeout - lastRequestDuration - delay, 1);
	            }
	
	            return new Promise(function (resolve) {
	                return setTimeout(function () {
	                    return resolve(axios(config));
	                }, delay);
	            });
	        }
	
	        return Promise.reject(error);
	    });
	}
	
	// Compatibility with CommonJS
	axiosRetry.isNetworkError = isNetworkError;
	axiosRetry.isSafeRequestError = isSafeRequestError;
	axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
	axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	axiosRetry.exponentialDelay = exponentialDelay;
	//# sourceMappingURL=index.js.map

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CCAppEventLogger = undefined;
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCAppEventLogger = {
	    logAppEvent: function logAppEvent(name, params) {
	        if (name) {
	            /*if (AppEventsLogger) {
	                AppEventsLogger.logEvent(name, params);
	            }*/
	
	            /*if (firebase && firebase.analytics()) {
	                firebase.analytics().logEvent(name, params);
	            }*/
	        }
	    },
	    logScreenNavigation: function logScreenNavigation(screenName, params) {
	        if (screenName) {
	            /*if (AppEventsLogger) {
	                AppEventsLogger.logEvent(screenName,{});
	            }
	            */
	            /*if (firebase && firebase.analytics()) {
	                firebase.analytics().setCurrentScreen(screenName);
	            }*/
	        }
	    },
	    setUserProperties: function setUserProperties(user) {
	        if (user) {
	            var coins = user.coins ? user.coins.toString() : '';
	            var id = user.id;
	            var entries = user.noOfEntries ? user.noOfEntries.toString() : '';
	            var entries_won = user.entriesWon ? user.entriesWon.toString() : '';
	
	            /*if (AppEventsLogger) {
	                AppEventsLogger.setUserID(id);
	                AppEventsLogger.updateUserProperties({
	                    'coins' : coins,
	                    'entries' : entries,
	                    'entries_won' : entries_won
	                })
	            }*/
	
	            /*if (firebase && firebase.analytics()) {
	                firebase.analytics().setUserId(id);
	                firebase.analytics().setUserProperty('coins',coins);
	                firebase.analytics().setUserProperty('entries',entries);
	                firebase.analytics().setUserProperty('entries_won',entries_won);
	            }*/
	        }
	    },
	    clearUserProperties: function clearUserProperties() {
	        /*if (AppEventsLogger) {
	            AppEventsLogger.setUserID(null);
	            AppEventsLogger.updateUserProperties({})
	        }*/
	
	        if (_app2.default && _app2.default.analytics()) {
	            _app2.default.analytics().setUserId(null);
	            _app2.default.analytics().setUserProperty('coins', '');
	            _app2.default.analytics().setUserProperty('entries', '');
	            _app2.default.analytics().setUserProperty('entries_won', '');
	        }
	    }
	}; //import {AppEventsLogger} from 'react-native-fbsdk';
	exports.CCAppEventLogger = CCAppEventLogger;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CCAuthorizedAxios = exports.CCAxios = undefined;
	
	var _axios = __webpack_require__(46);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ccImports = __webpack_require__(1);
	
	var _AxiosRetry = __webpack_require__(360);
	
	var _AxiosRetry2 = _interopRequireDefault(_AxiosRetry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO
	var CCAxios = _axios2.default.create({
	    baseURL: _ccImports.CricrushConfig.ccServiceBaseUrl,
	    headers: { 'Content-Type': 'application/json' }
	});
	
	(0, _AxiosRetry2.default)(CCAxios, { retryDelay: _AxiosRetry2.default.exponentialDelay, retries: 10000 });
	
	var CCAuthorizedAxios = function CCAuthorizedAxios(_ref) {
	    var accessToken = _ref.accessToken;
	
	    var AuthAxios = _axios2.default.create({
	        baseURL: _ccImports.CricrushConfig.ccServiceBaseUrl,
	        headers: { 'Content-Type': 'application/json', 'access_token': accessToken }
	    });
	
	    (0, _AxiosRetry2.default)(AuthAxios, { retryDelay: _AxiosRetry2.default.exponentialDelay, retries: 10000 });
	
	    return AuthAxios;
	};
	
	exports.CCAxios = CCAxios;
	exports.CCAuthorizedAxios = CCAuthorizedAxios;

/***/ },
/* 363 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var CCNavigationUtils = {
	    getTabNavigatorNextState: function getTabNavigatorNextState(navigator, action, state, tabName) {}
	};
	
	exports.CCNavigationUtils = CCNavigationUtils;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CCUtils = undefined;
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _MS_PER_DAY = 1000 * 60 * 60 * 24;
	var _MS_PER_HOUR = 1000 * 60 * 60;
	var _MS_PER_MINUTE = 1000 * 60;
	var _MS_PER_SECONDS = 1000;
	
	var CCUtils = {
	    userUpdated: function userUpdated(props1, props2) {
	        if (props1.anonymous != props2.anonymous) {
	            return true;
	        }
	        var user1 = props1.user;
	        var user2 = props2.user;
	        var u1Defined = user1 != null && user1 != undefined;
	        var u2Defined = user2 != null && user2 != undefined;
	
	        if (u1Defined && !u2Defined || !u1Defined && u2Defined) {
	            return true;
	        }
	
	        if (u1Defined && u2Defined) {
	            return user1.id != user2.id || user1.country != user2.country;
	        }
	
	        return false;
	    },
	    attachNetworkListener: function attachNetworkListener(actions) {},
	    formatTime: function formatTime(createdDate) {
	        var time = "";
	        var createdTime = new Date(createdDate);
	        var now = new Date();
	
	        var diffMins = (now.getTime() - createdTime.getTime()) / 60000;
	
	        if (diffMins <= 10) {
	            time = "Now";
	        } else if (diffMins <= 1440) {
	            time = createdTime.toLocaleTimeString("en-US", {
	                hour: '2-digit',
	                minute: '2-digit'
	            });
	        } else {
	            time = createdTime.toLocaleDateString("en-US", {
	                day: '2-digit',
	                year: '2-digit',
	                month: '2-digit'
	            });
	        }
	        return time;
	    },
	    formatDate: function formatDate(date) {
	        if (!date) {
	            return '';
	        }
	
	        var createdTime = new Date(date);
	        var time = createdTime.toLocaleDateString("en-US", {
	            day: '2-digit',
	            year: '2-digit',
	            month: '2-digit',
	            hour: '2-digit',
	            minute: '2-digit'
	        });
	        return time;
	    },
	    getSignInError: function getSignInError(err, providers, type, value) {
	        err.providers = providers;
	        switch (type) {
	            case 'password':
	                err.emailCredentials = value;
	                break;
	            case 'google':
	                err.googleCredentials = value;
	                break;
	            case 'facebook':
	                err.fbCredentials = value;
	                break;
	        }
	        return err;
	    },
	    getDoNotShowAgainMessage: function getDoNotShowAgainMessage() {},
	    groupByGetIds: function groupByGetIds(xs, key, key2) {
	        if (xs === null || xs === undefined) {
	            return {};
	        }
	        return xs.reduce(function (rv, x) {
	            if (key2) {
	                (rv[x[key][key2]] = rv[x[key][key2]] || []).push(x.id);
	            } else {
	                (rv[x[key]] = rv[x[key]] || []).push(x.id);
	            }
	            return rv;
	        }, {});
	    },
	    merge: function merge(o1, o2) {
	        for (var prop in o2) {
	            o1[prop] = o1[prop] ? _lodash2.default.union(o2[prop], o1[prop]) : o2[prop];
	            //o1[prop] ? o1[prop].concat(o2[prop]) : o1[prop] = o2[prop];
	        }
	        return o1;
	    },
	    customArrMerger: function customArrMerger(objValue, srcValue) {
	        if (_lodash2.default.isArray(objValue)) {
	            return _lodash2.default.union(objValue, srcValue);
	        }
	    },
	    isLeagueCompleted: function isLeagueCompleted(league) {
	        return league.status.status === _ccImports.Constants.leagueStatus.COMPLETED || league.status.status === _ccImports.Constants.leagueStatus.REFUNDED || league.status.status === _ccImports.Constants.leagueStatus.REFUNDED_NO_ENOUGH_PLAYERS;
	    },
	    getDateDiff: function getDateDiff(a, b) {
	        var utc1 = a.getTime();
	        var utc2 = b.getTime();
	        var negative = false;
	
	        if (utc2 > utc1) {
	            negative = true;
	            var temp = utc1;
	            utc1 = utc2;
	            utc2 = temp;
	        }
	
	        var diff = utc1 - utc2;
	        var diffO = {};
	
	        diffO.days = Math.floor(diff / _MS_PER_DAY);
	        diff = diff - diffO.days * _MS_PER_DAY;
	        diffO.hours = Math.floor(diff / _MS_PER_HOUR);
	        diff = diff - diffO.hours * _MS_PER_HOUR;
	        diffO.minutes = Math.floor(diff / _MS_PER_MINUTE);
	        diff = diff - diffO.minutes * _MS_PER_MINUTE;
	        diffO.seconds = Math.floor(diff / _MS_PER_SECONDS);
	
	        if (negative) {
	            diffO = {
	                days: 0,
	                hours: 0,
	                minutes: 0,
	                seconds: 0
	            };
	        }
	        return diffO;
	    },
	    isLoggedIn: function isLoggedIn(user) {
	        if (user && user.id) {
	            return true;
	        }
	        return false;
	    },
	
	
	    sortLbs: function sortLbs(lbs) {
	        _lodash2.default.forEach(lbs, function (lb) {
	            var up = {};
	            switch (lb.type) {
	                case _ccImports.Constants.lbType.DAILY:
	                    up.priority = 1;
	                    break;
	                case _ccImports.Constants.lbType.WEEKLY:
	                    up.priority = 2;
	                    break;
	                case _ccImports.Constants.lbType.MONTHLY:
	                    up.priority = 3;
	                    break;
	                default:
	                    up.priority = 4;
	            }
	
	            switch (lb.subType) {
	                case _ccImports.Constants.lbSubType.NO_OF_COINS_EARNED:
	                    up.priority2 = 0;
	                    break;
	                case _ccImports.Constants.lbSubType.NO_OF_ENTRIES_PLAYED:
	                    up.property2 = 1;
	                    break;
	                case _ccImports.Constants.lbSubType.WIN_LOST_RATIO:
	                    up.property2 = 2;
	            }
	
	            if (lb.country === 'ALL') {
	                up.priority3 = 1;
	            } else {
	                up.priority3 = 0;
	            }
	
	            switch (lb.status) {
	                case _ccImports.Constants.lbStatus.ACTIVE:
	                    up.priority4 = 0;
	                    break;
	                case _ccImports.Constants.lbStatus.COMPLETED:
	                    up.priority4 = 1;
	                    break;
	                case _ccImports.Constants.lbStatus.ARCHIVED:
	                    up.priority4 = 2;
	                    break;
	
	                default:
	                    up.priority4 = 3;
	            }
	
	            _lodash2.default.merge(lb, up);
	        });
	
	        var srtdLbs = _lodash2.default.orderBy(lbs, ['priority', 'priority2', 'priority3', 'priority4']);
	        return srtdLbs;
	    }
	};
	
	exports.CCUtils = CCUtils;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FirebaseUtils = undefined;
	
	var _ccImports = __webpack_require__(1);
	
	var _FirebaseSignInUtils = __webpack_require__(369);
	
	var _FirebaseSignInUtils2 = _interopRequireDefault(_FirebaseSignInUtils);
	
	var _FirebaseNotificationUtils = __webpack_require__(368);
	
	var _FirebaseNotificationUtils2 = _interopRequireDefault(_FirebaseNotificationUtils);
	
	var _FirebaseInvitesUtils = __webpack_require__(367);
	
	var _FirebaseInvitesUtils2 = _interopRequireDefault(_FirebaseInvitesUtils);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inviteUsed = false;
	var invitedBy = undefined;
	
	var FirebaseUtils = Object.assign({
	
	    getIdTokenWhenAuthChanged: function getIdTokenWhenAuthChanged(callback) {
	        _app2.default.auth().onAuthStateChanged(function (user) {
	            _app2.default.auth().currentUser && _app2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                callback && callback(idToken);
	            });
	        });
	    },
	
	    initializeFireBase: function initializeFireBase(actions, callback) {
	
	        if (!_app2.default.apps.length) {
	            //console.log(CricrushConfig.firebaseConfig)
	            _app2.default.initializeApp(_ccImports.CricrushConfig.firebaseConfig);
	        }
	
	        _FirebaseInvitesUtils2.default.getInitialLinkParams(function (params) {
	            invitedBy = params;
	        });
	
	        _FirebaseInvitesUtils2.default.subscribeToOnLinkEvents(function (params) {
	            invitedBy = params;
	        });
	
	        /* const unsubscribe = Firebase.links().onLink((url) => {
	             //FirebaseUtils.redirectBasedOnInviteLinks(ccTabNavigation, actions);
	         });*/
	
	        //On new account creation, the authStatus change not fired. so we need to fire it here once again. this is a rnfirebase specific method
	        /*Firebase.auth().onUserChanged((user)=>{
	            if(user && !user.isAnonymous){
	                user.getIdToken(false).then((res)=>{
	                    if(user.email==null || user.email==undefined){
	                        user.email = FirebaseSignInUtils._composeFBEmail(user);
	                    }
	                    actions.getOrCreateUserByEmail({ email:user.email, accessToken : res.idToken }).then(()=>{
	                        callback();
	                    })
	                })
	            }
	        });*/
	
	        _app2.default.auth().onAuthStateChanged(function (user) {
	
	            var url_string = window.location.href; //window.location.href
	            var url = new URL(url_string);
	            var invitedById = url.searchParams.get("invitedBy");
	
	            var linkParams = invitedById;
	            // console.log(user)
	
	            if (user) {
	                if (user.isAnonymous) {
	                    //actions.openHome();
	                    //actions.anonymousUserIn();
	                } else {
	                    user.getIdToken(false).then(function (res) {
	                        if (user.email == null || user.email == undefined) {
	                            user.email = _FirebaseSignInUtils2.default._composeFBEmail(user);
	                        }
	                        actions.getOrCreateUserByEmail({ email: user.email, invitedBy: { id: invitedBy } }, res.idToken).then(function () {
	                            actions.openHome();
	                            callback && callback();
	                        });
	                    });
	                }
	
	                if (!inviteUsed) {
	                    //FirebaseUtils.redirectBasedOnInviteLinks(ccTabNavigation, actions);
	                    inviteUsed = true;
	                }
	            } else {
	                _app2.default.auth().signInAnonymouslyAndRetrieveData().then(function () {
	                    actions.signOutUser();
	                }).catch(function (error) {
	                    console.log(error);
	                });
	                actions.fbUserNotFound();
	            }
	        });
	    }
	}, _FirebaseSignInUtils2.default, _FirebaseNotificationUtils2.default, _FirebaseInvitesUtils2.default);
	
	exports.FirebaseUtils = FirebaseUtils;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ImageUtils = undefined;
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageBucket = 'gs://' + _ccImports.CricrushConfig.firebaseConfig.storageBucket + '/';
	
	var STORES = {
	    "PROFILE_PICS": "private/profile_pics",
	    "PROFILE_PICS_THUMBNAILS": "private/profile_pics/thumbnails"
	};
	
	var ImageUtils = {
	    getBannerImage: function getBannerImage(url) {
	        return { uri: url, cache: 'force-cache' };
	    },
	    getProfilePicSrc: function getProfilePicSrc(user) {
	        return user && user.imageUrl ? user.imageUrl : _ccImports.images.icons.avatar;
	        return user && user.imageUrl ? { uri: user.imageUrl, cache: 'force-cache' } : _ccImports.images.icons.avatar;
	    },
	    getThumbnailProfilePicSrc: function getThumbnailProfilePicSrc(user) {
	        return user && user.thumbnailUrl ? { uri: user.thumbnailUrl } : _ccImports.images.icons.profile_pic_plh;
	    },
	    uploadProfilePicture: function uploadProfilePicture(userId, uploadUri, response, successCallback, errorCallback) {
	        var imageRef = _app2.default.storage().ref(STORES.PROFILE_PICS).child('' + userId);
	        imageRef.putFile(uploadUri, { contentType: 'image/jpg' }).then(successCallback).catch(errorCallback);
	    },
	    getProfilePicUrl: function getProfilePicUrl(id, callback, errorCallback) {
	        _app2.default.storage().refFromURL(storageBucket + STORES.PROFILE_PICS + '/' + id).getDownloadURL().then(function (url) {
	            callback && callback(url);
	        }).catch(function (error) {
	            errorCallback && errorCallback();
	        });
	    },
	    getProfilePicThumbnail: function getProfilePicThumbnail(id, callback, errorCallback) {
	        _app2.default.storage().refFromURL(storageBucket + STORES.PROFILE_PICS_THUMBNAILS + '/' + id).getDownloadURL().then(function (url) {
	            callback && callback(url);
	        }).catch(function (error) {
	            errorCallback && errorCallback();
	        });
	    },
	    openProfileImagePicker: function openProfileImagePicker(successCallback) {
	        /*if(Platform.OS === 'ios'){
	            var options = {
	                title: strings('change_profile_picture'),
	                mediaType : 'photo',
	                quality : 0.5,
	                allowsEditing : true,
	                storageOptions: {
	                    skipBackup: true,
	                    path: 'images'
	                }
	            };
	             ImagePicker.showImagePicker(options, (response) => {
	                 if (response.didCancel) {
	                    //console.log('User cancelled image picker');
	                }
	                else if (response.error) {
	                    //console.log('ImagePicker Error: ', response.error);
	                }
	                else if (response.customButton) {
	                    //console.log('User tapped custom button: ', response.customButton);
	                }
	                else {
	                     const uploadUri = Platform.OS === 'ios' ? response.uri.replace('file://', '') : response.uri;
	                    successCallback(uploadUri, response);
	                 }
	            });
	        }
	        else {
	            ImageCropPicker.openPicker({
	                width: 300,
	                height: 300,
	                mediaType : 'photo',
	                compressImageQuality : 0.5,
	                cropping: true
	            }).then(image => {
	                //console.log(image);
	                successCallback(image.path, image);
	            }).catch((error)=>{
	                //console.log(error);
	            });
	        }*/
	
	    }
	};
	
	exports.ImageUtils = ImageUtils;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _ccImports = __webpack_require__(1);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO : Check alternative
	var baseUrl = 'http://localhost:3000/?';
	var FirebaseInvitesUtils = {
	    composeLink: function composeLink(params) {
	        var url = baseUrl;
	
	        var index = 0;
	        _lodash2.default.forIn(params, function (value, key) {
	            if (value && key) {
	                url = url + (index == 0 ? '' : '&') + key + '=' + value;
	                index++;
	            }
	        });
	
	        return url;
	    },
	    extractLinks: function extractLinks(url) {
	        // var url = parse(url, true);
	        // var linkParams = {};
	        // var params = {};
	        // if(url.query && url.query.link){
	        //     linkParams = parse(url.query.link, true);
	        //     if(linkParams.query){
	        //         params = linkParams.query;
	        //     }
	        // }
	        // else {
	        //     params = url.query;
	        // }
	        // return params;
	    },
	
	
	    //verified
	    showInviteLinkDialog: function showInviteLinkDialog(params, user) {
	
	        var url = FirebaseInvitesUtils.composeLink(params);
	
	        var link = new _firebase2.default.links.DynamicLink(url, _ccImports.CricrushConfig.dynamicLinkDomain).android.setPackageName('com.cricrush').ios.setBundleId('com.cricrush.iosv1');
	
	        var userName = user.displayName && user.displayName != null ? user.displayName : '';
	
	        _firebase2.default.links().createShortDynamicLink(link, 'SHORT').then(function (url) {
	            FirebaseInvitesUtils.showShareDialog((0, _ccImports.strings)('invite_friends_share_message', { name: userName }), (0, _ccImports.strings)('invite_friends_share_title', { name: userName }), url, (0, _ccImports.strings)('invite_friends_dialog_title'));
	        });
	    },
	
	    //verified
	    showShareDialog: function showShareDialog(message, title, url, dialogTitle) {
	        var content = {
	            title: title,
	            message: message + '. ' + url
	        };
	        // if (Platform.OS === 'ios') {
	        //     Share.share(content, {
	        //         excludedActivityTypes: [
	        //             'com.apple.UIKit.activity.PostToTwitter'
	        //         ],
	        //         subject: title
	        //     });
	        // }
	        // else if (Platform.OS === 'android') {
	        //     content.message = message +' '+url;
	        //     Share.share(content, {
	        //         dialogTitle: dialogTitle
	        //     });
	        // }
	    },
	
	    //verified
	    getInitialLinkParams: function getInitialLinkParams(callback) {
	        var url_string = window.location.href; //window.location.href
	        var url = new URL(url_string);
	        var invitedById = url.searchParams.get("invitedBy");
	
	        callback(invitedById);
	    },
	
	    //verified
	    subscribeToOnLinkEvents: function subscribeToOnLinkEvents(callback) {
	        var url_string = window.location.href; //window.location.href
	        var url = new URL(url_string);
	        var invitedById = url.searchParams.get("invitedBy");
	
	        callback(invitedById);
	    },
	    redirectBasedOnInviteLinks: function redirectBasedOnInviteLinks(ccTabNavigation, actions) {
	        FirebaseInvitesUtils.extractInviteLinkDetails(function (urlParams) {
	            //console.log('Final Link', urlParams);
	            if (urlParams && urlParams.leagueId) {
	                var leagueTitle = urlParams.leagueTitle ? urlParams.leagueTitle.replace(new RegExp('\\+', 'g'), ' ') : '';
	                actions.openSingleLeague({
	                    id: urlParams.leagueId,
	                    name: decodeURIComponent(leagueTitle)
	                }, ccTabNavigation);
	            }
	        });
	    },
	    getInviteDetails: function getInviteDetails(callback) {
	        try {
	            FirebaseInvitesUtils.extractInviteLinkDetails(function (urlParams) {
	                if (urlParams && urlParams.invitedBy) {
	                    callback(urlParams.invitedBy);
	                } else {
	                    callback(null);
	                }
	            });
	        } catch (err) {
	            callback(null);
	        }
	    },
	    extractInviteLinkDetails: function extractInviteLinkDetails(callback) {
	        _firebase2.default.links().getInitialLink().then(function (url) {
	            try {
	                if (url) {
	                    var urlParams = {};
	
	                    url.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0, $1, $2, $3) {
	                        urlParams[$1] = $3;
	                    });
	
	                    // ios have diffrent url, here i replace the url for ios devices only
	
	                    if (urlParams && urlParams.link) {
	                        var decodeUrl = decodeURIComponent(urlParams.link);
	
	                        decodeUrl.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0, $1, $2, $3) {
	                            urlParams[$1] = $3;
	                        });
	                    }
	
	                    if (callback) {
	                        callback(urlParams);
	                    }
	                } else {
	                    callback();
	                }
	            } catch (e) {
	                //console.log(e, 'ERROR');
	                callback(null);
	            }
	        }).catch(function (err) {
	            callback();
	        });
	    }
	};
	
	exports.default = FirebaseInvitesUtils;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _axios = __webpack_require__(46);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO : Check alternative
	//import {CricrushConfig} from './../../cc-imports'
	
	
	var FirebaseNotificationUtils = {
	    addOnMessageListener: function addOnMessageListener(listener) {
	        _firebase2.default.messaging().onMessage(listener);
	    },
	    requestNotificationPermission: function requestNotificationPermission() {
	        _firebase2.default.messaging().requestPermissions();
	    },
	    composeTopic: function composeTopic(matchKey, notificationType) {
	        /*if (matchKey && notificationType) {
	            var topic = '/topics/follow-' + matchKey + '-'+CricrushConfig.firebaseConfig.env+'-' + notificationType;
	            //console.log(topic)
	            return topic;
	        }*/
	    },
	    subscribeTopicNotification: function subscribeTopicNotification(matchKey, notificationType) {
	        try {
	            this.requestNotificationPermission();
	            _firebase2.default.messaging().subscribeToTopic(FirebaseNotificationUtils.composeTopic(matchKey, notificationType));
	        } catch (error) {
	            // console.log(error, 'TOPIC_SUBCRIBE_ERROR');
	        }
	    },
	    subscribeToAllUsersNotifications: function subscribeToAllUsersNotifications() {
	        try {
	            this.requestNotificationPermission();
	            //Firebase.messaging().subscribeToTopic('/topics/follow-'+CricrushConfig.firebaseConfig.env+'-ALL_USERS');
	        } catch (error) {
	            //console.log(error, 'TOPIC_SUBCRIBE_ERROR');
	        }
	    },
	    getDeviceToken: function getDeviceToken(callback) {
	        _firebase2.default.messaging().getToken().then(callback);
	        //console.log('getDeviceToken Callback function running');
	    },
	    createDeviceGroup: function createDeviceGroup(notificationKeyName, deviceToken, callback, errorCallback) {
	        var url = 'https://android.googleapis.com/gcm/notification';
	        var config = {
	            /*headers: {
	                "Content-Type": "application/json",
	                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
	                "project_id": CricrushConfig.cloudMessaging.senderId
	            }*/
	        };
	        var data = {
	            operation: "create",
	            notification_key_name: notificationKeyName,
	            registration_ids: [deviceToken]
	        };
	
	        _axios2.default.post(url, data, config).then(function (response) {
	            callback && callback(response);
	        }).catch(function (error) {
	            errorCallback && errorCallback(error);
	        });
	    },
	    getDeviceGroup: function getDeviceGroup(notificationKeyName, callback, errorCallback) {
	        var getUrl = 'https://android.googleapis.com/gcm/notification?notification_key_name=' + notificationKeyName;
	        var getConfig = {
	            method: 'GET'
	            /*headers: {
	                "Content-Type": "application/json",
	                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
	                "project_id": CricrushConfig.cloudMessaging.senderId
	            }*/
	        };
	
	        var myRequest = new Request(getUrl, getConfig);
	
	        fetch(myRequest).then(function (response) {
	            response.json().then(function (body) {
	                if (body.error) {
	                    errorCallback && errorCallback(body);
	                } else {
	                    callback && callback(body);
	                }
	            });
	        }).catch(function (err) {
	            errorCallback && errorCallback();
	        });
	    },
	    addToDeviceGroup: function addToDeviceGroup(notificationKeyName, notificationKey, deviceToken, callback, errorCallback) {
	        var url = 'https://android.googleapis.com/gcm/notification';
	        var config = {
	            /* headers: {
	                 "Content-Type": "application/json",
	                 "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
	                 "project_id": CricrushConfig.cloudMessaging.senderId
	             }*/
	        };
	        var data = {
	            operation: "add",
	            notification_key_name: notificationKeyName,
	            notification_key: notificationKey,
	            registration_ids: [deviceToken]
	        };
	
	        _axios2.default.post(url, data, config).then(function (response) {
	            callback && callback(response);
	        }).catch(function (error) {
	            errorCallback && errorCallback(error);
	        });
	    },
	    removeFromDeviceGroup: function removeFromDeviceGroup(notificationKeyName, notificationKey, deviceToken, callback, errorCallback) {
	        var url = 'https://android.googleapis.com/gcm/notification';
	        var config = {
	            /*headers: {
	                "Content-Type": "application/json",
	                "Authorization": "key="+CricrushConfig.cloudMessaging.authKey,
	                "project_id": CricrushConfig.cloudMessaging.senderId
	            }*/
	        };
	        var data = {
	            operation: "remove",
	            notification_key_name: notificationKeyName,
	            notification_key: notificationKey,
	            registration_ids: [deviceToken]
	        };
	
	        _axios2.default.post(url, data, config).then(function (response) {
	            callback && callback(response);
	        }).catch(function (error) {
	            errorCallback && errorCallback(error);
	        });
	    },
	    subscribeToDeviceGroup: function subscribeToDeviceGroup(notificationKeyName) {
	        this.getDeviceToken(function (deviceToken) {
	            FirebaseNotificationUtils.getDeviceGroup(notificationKeyName, function (response) {
	                FirebaseNotificationUtils.addToDeviceGroup(notificationKeyName, response.notification_key, deviceToken, function () {}, function () {});
	            }, function (err) {
	                FirebaseNotificationUtils.createDeviceGroup(notificationKeyName, deviceToken, function (response) {
	                    //console.log(response);
	                }, function (err) {
	                    // console.log(err);
	                });
	            });
	        });
	    },
	    unsubscribeFromDeviceGroup: function unsubscribeFromDeviceGroup(notificationKeyName) {
	        this.getDeviceToken(function (deviceToken) {
	            FirebaseNotificationUtils.getDeviceGroup(notificationKeyName, function (response) {
	                FirebaseNotificationUtils.removeFromDeviceGroup(notificationKeyName, response.notification_key, deviceToken, function () {}, function () {});
	            }, function (err) {});
	        });
	    },
	    removeAllNotificationTokens: function removeAllNotificationTokens() {
	        _firebase2.default.messaging().deleteInstanceId();
	    },
	    unsubscribeFromTopic: function unsubscribeFromTopic(matchKey, notificationType) {
	        _firebase2.default.messaging().unsubscribeFromTopic(FirebaseNotificationUtils.composeTopic(matchKey, notificationType));
	    }
	};
	
	exports.default = FirebaseNotificationUtils;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FirebaseSignInUtils = {
	
	    updateUserProfileData: function updateUserProfileData(user, newUser, callback) {
	        var providerData = newUser.providerData;
	        if (providerData && (newUser.photoURL == null || newUser.displayName == null)) {
	            var update = {};
	            _lodash2.default.forEach(providerData, function (sPData) {
	                if ((newUser.displayName == null || newUser.displayName == undefined) && sPData.displayName) {
	                    update.displayName = sPData.displayName;
	                }
	                if (newUser.photoURL == null && sPData.photoURL) {
	                    update.photoURL = sPData.photoURL;
	                }
	            });
	            newUser.updateProfile(update).then(function () {
	                callback(newUser);
	            }).catch(function () {
	                callback(newUser);
	            });
	        } else {
	            callback(newUser);
	        }
	    },
	
	    signIn: function signIn(credential, successCb, errorCb, actions) {
	        _firebase2.default.auth().signInWithCredential(credential).then(function (user) {
	            //TODO added as a temperory fix to the problem where user displayname and profileUrl not merged once we linkwithCredentials
	            FirebaseSignInUtils.updateUserProfileData(null, user, successCb);
	            //successCb(user);
	        }).catch(function (err) {
	            switch (err.code) {
	                case 'auth/account-exists-with-different-credential':
	                    if (actions) actions.saveFailedCredentials(credential);
	                    if (credential.providerId == 'password' && credential.token) {
	                        _firebase2.default.auth().fetchProvidersForEmail(credential.token).then(function (providers) {
	                            errorCb(FirebaseSignInUtils.getFirebaseProviderError(providers));
	                        }).catch(function (err) {
	                            errorCb((0, _ccImports.strings)('fire_base_wrong_message'));
	                        });
	                    } else {
	                        errorCb((0, _ccImports.strings)('fire_base_already_login_different'));
	                    }
	                    break;
	                case 'auth/wrong-password':
	                    _firebase2.default.auth().fetchProvidersForEmail(credential.token).then(function (providers) {
	                        if (actions && providers && providers.length > 0) actions.saveFailedCredentials(credential);
	                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
	                    }).catch(function (err) {
	                        //errorCb(strings('fire_base_wrong_message'));
	                    });
	                    break;
	                default:
	                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	        });
	    },
	    signUp: function signUp(provider, successCb, errorCb, actions) {
	        _firebase2.default.auth().currentUser && _firebase2.default.auth().currentUser.linkWithPopup(provider).then(function (user) {
	            //TODO added as a temperory fix to the problem where user displayname and profileUrl not merged once we linkwithCredentials
	            FirebaseSignInUtils.updateUserProfileData(null, user, successCb);
	            //successCb(user);
	        }).catch(function (err) {
	            var credential = err.credential;
	
	            //TODO : this is to handle the facebook login not getting credential issue
	            if (credential == undefined) {
	                errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	            switch (err.code) {
	                case 'auth/credential-already-in-use':
	                    //console.log(Firebase.auth().AuthCredential);
	                    FirebaseSignInUtils.signIn(credential, successCb, errorCb, actions);
	                    break;
	                case 'auth/email-already-in-use':
	                    FirebaseSignInUtils.signIn(credential, successCb, errorCb, actions);
	                    break;
	                case 'auth/wrong-password':
	                    //todo verify ( double check err.email and err )
	                    _firebase2.default.auth().fetchProvidersForEmail(err.email).then(function (providers) {
	                        if (actions && providers && providers.length > 0) actions.saveFailedCredentials(credential);
	                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
	                    }).catch(function (err) {
	                        errorCb((0, _ccImports.strings)('fire_base_wrong_message'));
	                    });
	                    break;
	                default:
	                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	        });
	    },
	
	    signOnFb: function signOnFb(provider, successCb, errorCb, actions) {
	        FirebaseSignInUtils.signUp(provider, function (user) {
	            if (user.email == null || user.email == undefined) {
	                var email = FirebaseSignInUtils._composeFBEmail(user);
	                user.sendEmailVerification();
	                FirebaseSignInUtils.updateEmail(email, function () {
	                    //added to fix after updating email address, if we pass the returned user, the email is null and user not moving out of login screen
	                    user = _firebase2.default.auth().currentUser;
	                    successCb(user);
	                });
	            } else {
	                successCb(user);
	            }
	        }, errorCb, actions);
	    },
	
	    signOnGgl: function signOnGgl(provider, successCb, errorCb, actions) {
	        FirebaseSignInUtils.signUp(provider, successCb, errorCb, actions);
	    },
	
	    signInEmail: function signInEmail(user, successCb, errorCb, actions) {
	        var credential = _firebase2.default.auth.EmailAuthProvider.credential(user.email, user.password);
	        _firebase2.default.auth().signInWithCredential(credential).then(function (newUser) {
	            FirebaseSignInUtils.updateUserProfileData(user, newUser, successCb);
	        }).catch(function (err) {
	            switch (err.code) {
	                case 'auth/account-exists-with-different-credential':
	                    if (actions) actions.saveFailedCredentials(credential);
	                    if (credential.providerId == 'password' && credential.token) {
	                        _firebase2.default.auth().fetchProvidersForEmail(credential.token).then(function (providers) {
	                            errorCb(FirebaseSignInUtils.getFirebaseProviderError(providers));
	                        }).catch(function (err) {
	                            errorCb((0, _ccImports.strings)('fire_base_wrong_message'));
	                        });
	                    } else {
	                        errorCb((0, _ccImports.strings)('fire_base_already_login_different'));
	                    }
	                    break;
	                case 'auth/wrong-password':
	                    _firebase2.default.auth().fetchProvidersForEmail(credential.token).then(function (providers) {
	                        if (actions && providers && providers.length > 0) actions.saveFailedCredentials(credential);
	                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
	                    }).catch(function (err) {
	                        //errorCb(strings('fire_base_wrong_message'));
	                    });
	                    break;
	                default:
	                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	        });
	
	        /*//check if user exists for email signins to avoid users signup by clicking login
	        Firebase.auth().fetchProvidersForEmail(user.email).then((providers)=>{
	            if(providers && providers.length>0){
	                FirebaseSignInUtils.signOnEmail(user,successCb,errorCb, actions);
	            }
	            else {
	                errorCb(strings('can_t_find_account'));
	            }
	        }).catch((err)=>{
	            errorCb(strings('can_t_find_account'));
	        });*/
	    },
	
	    signUpEmail: function signUpEmail(user, successCb, errorCb, actions) {
	        var credential = _firebase2.default.auth.EmailAuthProvider.credential(user.email, user.password);
	        _firebase2.default.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then(function (usercred) {
	            var newUser = usercred.user;
	            FirebaseSignInUtils.updateUserProfileData(user, newUser, successCb);
	        }, function (err) {
	            var credential = err.credential;
	
	            //TODO : this is to handle the facebook login not getting credential issue
	            if (credential == undefined) {
	                errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	            switch (err.code) {
	                case 'auth/credential-already-in-use':
	                    //console.log(Firebase.auth().AuthCredential);
	                    FirebaseSignInUtils.signInEmail(credential, successCb, errorCb, actions);
	                    break;
	                case 'auth/email-already-in-use':
	                    FirebaseSignInUtils.signInEmail(credential, successCb, errorCb, actions);
	                    break;
	                case 'auth/wrong-password':
	                    //todo verify ( double check err.email and err )
	                    _firebase2.default.auth().fetchProvidersForEmail(err.email).then(function (providers) {
	                        if (actions && providers && providers.length > 0) actions.saveFailedCredentials(credential);
	                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
	                    }).catch(function (err) {
	                        errorCb((0, _ccImports.strings)('fire_base_wrong_message'));
	                    });
	                    break;
	                default:
	                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
	            }
	        });
	        /*
	         FirebaseSignInUtils.signUp(credential,(fbUser)=>{
	             if(fbUser.displayName==null || fbUser.displayName==undefined){
	                 fbUser.updateProfile({
	                     displayName: user.displayName
	                 }).then(()=>{
	                     fbUser.sendEmailVerification();
	                     successCb(fbUser);
	                 });
	             }
	             else {
	                 successCb(fbUser);
	             }
	         }, errorCb, actions);*/
	    },
	
	    reAuthGgl: function reAuthGgl(idToken, callback, errorCb) {
	        FirebaseSignInUtils.reAuth(_firebase2.default.auth.GoogleAuthProvider.credential(idToken), callback, errorCb);
	    },
	
	    reAuthFb: function reAuthFb(accessToken, callback, errorCb) {
	        FirebaseSignInUtils.reAuth(_firebase2.default.auth.FacebookAuthProvider.credential(accessToken), callback, errorCb);
	    },
	
	    reAuthEmail: function reAuthEmail(email, password, callback, errorCb) {
	        FirebaseSignInUtils.reAuth(_firebase2.default.auth.EmailAuthProvider.credential(email, password), callback, errorCb);
	    },
	
	    reAuth: function reAuth(credential, callback, errorCb) {
	        _firebase2.default.auth().currentUser.reauthenticateWithCredential(credential).then(function (err) {
	            callback && callback();
	        }).catch(errorCb);
	    },
	
	    getFirebaseProviderError: function getFirebaseProviderError(providers) {
	        var providersStr = '';
	        if (providers && providers.length > 0) {
	            providers.forEach(function (provider) {
	                if (provider == 'google.com') {
	                    providersStr = providersStr + ' google ';
	                } else if (provider == 'facebook.com') {
	                    providersStr = providersStr + ' facebook ';
	                }
	            });
	
	            return (0, _ccImports.strings)('providers_str', { providersStr: providersStr });
	        } else {
	            return (0, _ccImports.strings)('fire_base_wrong_message');
	        }
	    },
	    getWrongPasswordError: function getWrongPasswordError(providers) {
	        var providersStr = '';
	        if (providers && providers.length > 0) {
	            providers.forEach(function (provider) {
	                if (provider == 'google.com') {
	                    providersStr = providersStr + ' google ';
	                } else if (provider == 'facebook.com') {
	                    providersStr = providersStr + ' facebook ';
	                }
	            });
	            return (0, _ccImports.strings)('providers_str_try_google', { providersStr: providersStr });
	        } else {
	            return (0, _ccImports.strings)('password_incorrect');
	        }
	    },
	    getFirebaseError: function getFirebaseError(error) {
	        switch (error.code) {
	            case 'auth/invalid-email':
	                return (0, _ccImports.strings)('invalid_mail');
	                break;
	            case 'auth/weak-password':
	                return (0, _ccImports.strings)('weak_password');
	                break;
	            case 'auth/user-not-found':
	                return (0, _ccImports.strings)('no_email_with_account');
	                break;
	            case 'auth/user-disabled':
	                return (0, _ccImports.strings)('account_disabled');
	                break;
	            case 'auth/user-mismatch':
	                return 'We already have different account for this email.';
	                break;
	            case 'auth/user-not-found':
	                return 'Failed to authenticate you.';
	                break;
	            case 'auth/invalid-credential':
	                return 'Your credentials are invalid';
	                break;
	            default:
	                return (0, _ccImports.strings)('unknown_error');
	                break;
	        }
	    },
	
	
	    linkProviders: function linkProviders(credentials) {
	        try {
	            var currentUser = _firebase2.default.auth().currentUser;
	            if (credentials.length > 0) {
	                _lodash2.default.forEach(credentials, function (credential) {
	                    credential && currentUser.linkWithCredential(credential).then(function (error) {
	                        //console.log(error);
	                    });
	                });
	            }
	        } catch (e) {
	            //console.log(e);
	        }
	    },
	
	    signOutFirebase: function signOutFirebase(user) {
	        _firebase2.default.auth().signOut();
	    },
	
	    resendVerificationEmail: function resendVerificationEmail() {
	        _firebase2.default.auth().currentUser.sendEmailVerification().then(function () {
	            /*Alert.alert(
	                strings('mail_sent'),
	                strings('verification_mail_sent', {email :Firebase.auth().currentUser.email}),
	                [
	                    {text: 'OK', onPress: () => {}},
	                ],
	                { cancelable: true }
	            )*/
	        });
	    },
	
	
	    _composeFBEmail: function _composeFBEmail(currentUser) {
	        var providerData = currentUser.providerData;
	        var fbProvider = _lodash2.default.find(providerData, function (providerD) {
	            return providerD.providerId == 'facebook.com';
	        });
	        return fbProvider.uid + '@facebook.com';
	    },
	    updateEmailForFacebookUsers: function updateEmailForFacebookUsers(email, callback) {
	        //this scenario will be reached only when user signup using facebook connected to no email
	        /*AccessToken.getCurrentAccessToken().then(
	            (data) => {
	                var credential = Firebase.auth.FacebookAuthProvider.credential(data.accessToken);
	                Firebase.auth().currentUser.reauthenticateWithCredential(credential).then((err)=>{
	                    FirebaseSignInUtils.updateEmail(email,callback);
	                })
	            }
	        );*/
	    },
	    updateEmail: function updateEmail(email, callback) {
	        _firebase2.default.auth().currentUser.updateEmail(email).then(function () {
	            _firebase2.default.auth().currentUser.sendEmailVerification().then(function () {
	                callback && callback();
	            });
	        }, function (error) {
	            callback(FirebaseSignInUtils.getFirebaseError(error));
	        });
	    },
	    updateDisplayName: function updateDisplayName(displayName) {
	        _firebase2.default.auth().currentUser.updateProfile({
	            displayName: displayName
	        });
	    }
	};
	//import {AccessToken} from "react-native-fbsdk";
	//TODO
	exports.default = FirebaseSignInUtils;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateLocale = updateLocale;
	exports.strings = strings;
	
	var _reactIntlUniversal = __webpack_require__(60);
	
	var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locales = {
	    "en": __webpack_require__(486),
	    "ta": __webpack_require__(489),
	    "si": __webpack_require__(488),
	    "bn": __webpack_require__(485),
	    "hi": __webpack_require__(487)
	};
	
	function updateLocale(locale, callback) {
	    _reactIntlUniversal2.default.init({
	        currentLocale: locale ? locale : 'en', // TODO: determine locale here
	        locales: locales
	    }).then(function () {
	        callback && callback();
	    });
	};
	
	function strings(name) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return _reactIntlUniversal2.default.get(name, params);
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _config = __webpack_require__(19);
	
	var _DreamTeamEntryCreation = __webpack_require__(85);
	
	var _DreamTeamEntryCreation2 = _interopRequireDefault(_DreamTeamEntryCreation);
	
	var _SignIn = __webpack_require__(86);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddCoinsModal = function (_Component) {
	    _inherits(AddCoinsModal, _Component);
	
	    function AddCoinsModal(props) {
	        _classCallCheck(this, AddCoinsModal);
	
	        var _this = _possibleConstructorReturn(this, (AddCoinsModal.__proto__ || Object.getPrototypeOf(AddCoinsModal)).call(this, props));
	
	        _this.initialState = {
	            screen: 'addCoin'
	        };
	
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._onModalHide = _this._onModalHide.bind(_this);
	        _this._changeScreen = _this._changeScreen.bind(_this);
	        // this._getLeague=this._getLeague.bind(this);
	        return _this;
	    }
	
	    _createClass(AddCoinsModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("AddCoinsModal");
	        }
	    }, {
	        key: '_onModalHide',
	        value: function _onModalHide() {
	            var _this2 = this;
	
	            this.setState(this.initialState, function () {
	                _this2._closeModal();
	            });
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "AddCoinsModal" },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_ccImports.AddCoins, { style: { margin: 5 } }),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(_ccImports.CCButton, { style: { width: '80%' }, title: (0, _ccImports.strings)('close'), onPress: this._closeModal })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddCoinsModal;
	}(_react.Component);
	
	AddCoinsModal.propTypes = {};
	AddCoinsModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(AddCoinsModal);

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddCoinsModal = __webpack_require__(371);
	
	var _AddCoinsModal2 = _interopRequireDefault(_AddCoinsModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _AddCoinsModal2.default;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CCModals = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(377);
	
	var _MoreModal = __webpack_require__(379);
	
	var _TransactionsModal = __webpack_require__(29);
	
	var _index2 = __webpack_require__(375);
	
	var _SingleLeagueModal = __webpack_require__(387);
	
	var _index3 = __webpack_require__(383);
	
	var _index4 = __webpack_require__(385);
	
	var _SponsorDetailsModal = __webpack_require__(389);
	
	var _NotificationsModal = __webpack_require__(381);
	
	var _AddCoinsModal = __webpack_require__(372);
	
	var _AddCoinsModal2 = _interopRequireDefault(_AddCoinsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import SignInModal from './SignInModal/index'
	// import NotificationsModal from './NotificationsModal/index'
	// import ChatModal from './ChatsModal/index'
	
	
	var CCModals = function (_Component) {
	    _inherits(CCModals, _Component);
	
	    function CCModals(props) {
	        _classCallCheck(this, CCModals);
	
	        return _possibleConstructorReturn(this, (CCModals.__proto__ || Object.getPrototypeOf(CCModals)).call(this, props));
	    }
	
	    _createClass(CCModals, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_index.EntriesModal, null),
	                _react2.default.createElement(_index4.SignInModal, null),
	                _react2.default.createElement(_AddCoinsModal2.default, null),
	                _react2.default.createElement(_index3.PredictionEntryCreationModal, null),
	                _react2.default.createElement(_index2.DreamTeamEntryCreationModal, null),
	                _react2.default.createElement(_TransactionsModal.TransactionsModal, null),
	                _react2.default.createElement(_MoreModal.MoreModal, null),
	                _react2.default.createElement(_SingleLeagueModal.SingleLeagueModal, null),
	                _react2.default.createElement(_SponsorDetailsModal.SponsorDetailsModal, null),
	                _react2.default.createElement(_NotificationsModal.NotificationsModal, null)
	            );
	        }
	    }]);
	
	    return CCModals;
	}(_react.Component);
	
	CCModals.propTypes = {};
	CCModals.defaultProps = {};
	exports.CCModals = CCModals;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var totalSalary = 10000;
	var playersPerTeam = 2;
	
	var DreamTeamEntryCreationModal = function (_Component) {
	    _inherits(DreamTeamEntryCreationModal, _Component);
	
	    function DreamTeamEntryCreationModal(props) {
	        _classCallCheck(this, DreamTeamEntryCreationModal);
	
	        var _this = _possibleConstructorReturn(this, (DreamTeamEntryCreationModal.__proto__ || Object.getPrototypeOf(DreamTeamEntryCreationModal)).call(this, props));
	
	        _this.initialState = {
	            league: undefined,
	            screen: 'dreamTeam'
	        };
	
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._onModalHide = _this._onModalHide.bind(_this);
	        _this._changeScreen = _this._changeScreen.bind(_this);
	        _this._getLeague = _this._getLeague.bind(_this);
	        return _this;
	    }
	
	    _createClass(DreamTeamEntryCreationModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("DreamTeamEntryCreation");
	        }
	    }, {
	        key: '_onModalHide',
	        value: function _onModalHide() {
	            var _this2 = this;
	
	            this.setState(this.initialState, function () {
	                _this2._closeModal();
	            });
	        }
	    }, {
	        key: '_getLeague',
	        value: function _getLeague() {
	            var modal = _lodash2.default.find(this.props.modals.modals, function (modal) {
	                return modal.name == 'DreamTeamEntryCreation';
	            });
	            if (modal) {
	                return modal.league;
	            }
	            /*const league = this.props.leagues ? this.props.leagues.byId ? this.props.leagues.byId['5aedf887b3863354e980eccc'] : undefined : undefined;
	            console.log(league)
	            //this.setState({league:league})
	            return league;*/
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var screen = this.state.screen;
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "DreamTeamEntryCreation" },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    screen == 'dreamTeam' && _react2.default.createElement(_ccImports.DreamTeamEntryCreation, { onAck: this._closeModal, league: this._getLeague(), openSignIn: function openSignIn() {
	                            _this3._changeScreen('signIn');
	                        } }),
	                    screen == 'signIn' && _react2.default.createElement(_ccImports.SignIn, { onSignInSuccess: function onSignInSuccess() {
	                            _this3._changeScreen('dreamTeam');
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return DreamTeamEntryCreationModal;
	}(_react.Component);
	
	DreamTeamEntryCreationModal.propTypes = {};
	DreamTeamEntryCreationModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        entries: state.entries,
	        matches: state.matches,
	        leagues: state.leagues
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(DreamTeamEntryCreationModal);
	
	
	var ccStyle = {
	    default: {
	        playerItemSize: 'r',
	        selectedPlayerItemSize: 's'
	    },
	    s: {
	        playerItemSize: 's',
	        selectedPlayerItemSize: 'xs'
	    }
	};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DreamTeamEntryCreationModal = undefined;
	
	var _DreamTeamEntryCreationModal = __webpack_require__(374);
	
	var _DreamTeamEntryCreationModal2 = _interopRequireDefault(_DreamTeamEntryCreationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DreamTeamEntryCreationModal = _DreamTeamEntryCreationModal2.default;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EntriesModal = function (_Component) {
	    _inherits(EntriesModal, _Component);
	
	    function EntriesModal(props) {
	        _classCallCheck(this, EntriesModal);
	
	        var _this = _possibleConstructorReturn(this, (EntriesModal.__proto__ || Object.getPrototypeOf(EntriesModal)).call(this, props));
	
	        _this.state = {
	            data: []
	        };
	        return _this;
	    }
	
	    _createClass(EntriesModal, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "Entries" },
	                _react2.default.createElement(_ccImports.UserEntries, null)
	            );
	        }
	    }]);
	
	    return EntriesModal;
	}(_react.Component);
	
	EntriesModal.propTypes = {};
	EntriesModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)({}, dispatch),
	        dispatch: dispatch
	    };
	})(EntriesModal);

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EntriesModal = undefined;
	
	var _EntriesModal = __webpack_require__(376);
	
	var _EntriesModal2 = _interopRequireDefault(_EntriesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.EntriesModal = _EntriesModal2.default;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	__webpack_require__(440);
	
	__webpack_require__(439);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoreModal = function (_Component) {
	    _inherits(MoreModal, _Component);
	
	    function MoreModal(props) {
	        _classCallCheck(this, MoreModal);
	
	        var _this = _possibleConstructorReturn(this, (MoreModal.__proto__ || Object.getPrototypeOf(MoreModal)).call(this, props));
	
	        _this.initialState = {
	            screen: undefined,
	            moreModal: 'true'
	        };
	        _this.state = _this.initialState;
	        _this._closeModal = _this._closeModal.bind(_this);
	        return _this;
	    }
	
	    _createClass(MoreModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("More");
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // if(this.props.userId && this.props.user.user.settings){
	            //     this.setState(this.props.user.user.settings);
	            // }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (nextProps.random != this.props.random) {
	                this._updateGrouping(nextProps);
	            }
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var user = this.props.user;
	
	            var screen = this.state.screen;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex-container cc-side-bar-layer', name: "More", style: { flex: 1, flexDirection: 'row' } },
	                _react2.default.createElement(
	                    _ccImports.CCSideBarLayout,
	                    { name: "More" },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'side-shadow more-modal-item' },
	                        _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('ProfileClicked', {});if (user.id) {
	                                    _this2._changeScreen('profile');
	                                } else {
	                                    _this2._changeScreen('signIn');
	                                }
	                            }, type: 'user',
	                            user: user }),
	                        _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('LeaderBoardClicked', {});_this2._changeScreen('leaderboard');
	                            }, type: 'content',
	                            title: (0, _ccImports.strings)('leaderboard'), name: "Leaderboard" }),
	                        user.id && false && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('ProfileClicked', {});_this2._changeScreen('profile');
	                            }, type: 'content',
	                            title: (0, _ccImports.strings)('profile'), name: "Profile" }),
	                        false && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('EditionClicked', { params: { loggedIn: _ccImports.CCUtils.isLoggedIn(user) } });_this2._changeScreen('edition');
	                            }, type: 'content',
	                            title: (0, _ccImports.strings)('edition'), name: "Edition" }),
	                        false && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('HelpClicked', {});_this2._changeScreen('help');
	                            },
	                            type: 'content', title: (0, _ccImports.strings)('help'), name: "Help" }),
	                        user.id && false && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('SettingsClicked', {});_this2._changeScreen('settings');
	                            },
	                            type: 'content', title: (0, _ccImports.strings)('settings'), name: "Settings" }),
	                        false && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.CCAppEventLogger.logAppEvent('AboutUsClicked', {});_this2._changeScreen('about');
	                            },
	                            type: 'content', title: (0, _ccImports.strings)('about'), name: "About" }),
	                        (user.id != null || user.id != undefined && false) && _react2.default.createElement(_ccImports.CCMoreModalItem, { onPress: function onPress() {
	                                _ccImports.FirebaseUtils.signOutFirebase(_this2.props.user.user);_this2._closeModal();_ccImports.CCAppEventLogger.logAppEvent('LogOutClicked', {});
	                            }, type: 'content',
	                            title: (0, _ccImports.strings)('logout'), name: "Logout" })
	                    ),
	                    screen && _react2.default.createElement(
	                        'div',
	                        { className: "more-modal-item" },
	                        screen == 'about' && _react2.default.createElement(_ccImports.About, null),
	                        screen == 'edition' && _react2.default.createElement(_ccImports.Edition, null),
	                        screen == 'help' && _react2.default.createElement(_ccImports.Help, null),
	                        screen == 'more' && _react2.default.createElement(
	                            _ccImports.Profile,
	                            { sponsorKey: "cricrush", onBackPress: function onBackPress() {
	                                    _this2._changeScreen('more');
	                                } },
	                            ' '
	                        ),
	                        screen == 'leaderboard' && _react2.default.createElement(
	                            _ccImports.Leaderboard,
	                            { sponsorKey: "cricrush", onBackPress: function onBackPress() {
	                                    _this2._changeScreen('more');
	                                } },
	                            ' '
	                        ),
	                        screen == 'profile' && _react2.default.createElement(_ccImports.Profile, null),
	                        screen == 'signIn' && _react2.default.createElement(_ccImports.SignIn, { onSignInSuccess: function onSignInSuccess() {
	                                _this2._changeScreen('more');
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MoreModal;
	}(_react.Component);
	
	MoreModal.propTypes = {};
	MoreModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user.user,
	        userId: state.user.user.id,
	        screen: state.screen,
	        moreModal: state.moreModal
	
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(MoreModal);

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MoreModal = undefined;
	
	var _MoreModal = __webpack_require__(378);
	
	var _MoreModal2 = _interopRequireDefault(_MoreModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MoreModal = _MoreModal2.default;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationsModal = function (_Component) {
	    _inherits(NotificationsModal, _Component);
	
	    function NotificationsModal(props) {
	        _classCallCheck(this, NotificationsModal);
	
	        var _this = _possibleConstructorReturn(this, (NotificationsModal.__proto__ || Object.getPrototypeOf(NotificationsModal)).call(this, props));
	
	        _this.state = {
	            skip: 0,
	            screen: 'ntfns',
	            claimNtfn: {}
	        };
	        _this._claimPressed = _this._claimPressed.bind(_this);
	        _this._changeScreen = _this._changeScreen.bind(_this);
	        return _this;
	    }
	
	    _createClass(NotificationsModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("Notifications");
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: '_claimPressed',
	        value: function _claimPressed(_ref) {
	            var claimNtfn = _ref.claimNtfn;
	
	            this.setState({ claimNtfn: claimNtfn });
	            this._changeScreen('claim');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var screen = this.state.screen;
	
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "Notifications" },
	                screen == 'ntfns' && _react2.default.createElement(
	                    _ccImports.Notifications,
	                    { claimPressed: this._claimPressed },
	                    ' '
	                ),
	                screen == 'claim' && _react2.default.createElement(
	                    _ccImports.CCBackLayout,
	                    { onBackPress: function onBackPress() {
	                            _this2._changeScreen('ntfns');
	                        } },
	                    _react2.default.createElement(_ccImports.ClaimReward, { ntfn: this.state.claimNtfn })
	                )
	            );
	        }
	    }]);
	
	    return NotificationsModal;
	}(_react.Component);
	
	NotificationsModal.propTypes = {};
	NotificationsModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        byId: state.notifications.byId,
	        byUserId: state.notifications.byUserId,
	
	        pages: state.notifications.pages,
	        userId: state.user.id,
	        //userId: '5a447f1edf0e0257e62d6d1f',
	        random: state.notifications.random,
	        type: state.notifications.type,
	        reqStatus: state.notifications.reqStatus
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(NotificationsModal);

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationsModal = undefined;
	
	var _NotificationsModal = __webpack_require__(380);
	
	var _NotificationsModal2 = _interopRequireDefault(_NotificationsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NotificationsModal = _NotificationsModal2.default;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	var _config = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PredictionEntryCreationModal = function (_Component) {
	    _inherits(PredictionEntryCreationModal, _Component);
	
	    function PredictionEntryCreationModal(props) {
	        _classCallCheck(this, PredictionEntryCreationModal);
	
	        var _this = _possibleConstructorReturn(this, (PredictionEntryCreationModal.__proto__ || Object.getPrototypeOf(PredictionEntryCreationModal)).call(this, props));
	
	        _this.initialState = {
	            league: undefined,
	            screen: 'entryForm'
	        };
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._onModalHide = _this._onModalHide.bind(_this);
	        _this._changeScreen = _this._changeScreen.bind(_this);
	        _this._getLeague = _this._getLeague.bind(_this);
	        return _this;
	    }
	
	    _createClass(PredictionEntryCreationModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("PredictionEntryCreation");
	        }
	    }, {
	        key: '_onModalHide',
	        value: function _onModalHide() {
	            var _this2 = this;
	
	            this.setState(this.initialState, function () {
	                _this2._closeModal();
	            });
	        }
	    }, {
	        key: '_getLeague',
	        value: function _getLeague() {
	            var oldModal = _lodash2.default.find(this.props.modals.modals, function (modal) {
	                return modal.name == 'PredictionEntryCreation';
	            });
	            if (oldModal) {
	                return oldModal.league;
	            }
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                league = _state.league,
	                screen = _state.screen;
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "PredictionEntryCreation" },
	                _react2.default.createElement(
	                    'div',
	                    { closeModal: this._closeModal, onModalHide: this._onModalHide },
	                    screen == 'entryForm' && _react2.default.createElement(_ccImports.PredictionEntryCreation, { onAck: this._closeModal, league: this._getLeague(), openSignIn: function openSignIn() {
	                            _this3._changeScreen('signIn');
	                        } }),
	                    screen == 'signIn' && _react2.default.createElement(_ccImports.SignIn, { onSignInSuccess: function onSignInSuccess() {
	                            _this3._changeScreen('entryForm');
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return PredictionEntryCreationModal;
	}(_react.Component);
	
	PredictionEntryCreationModal.propTypes = {};
	PredictionEntryCreationModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        entries: state.entries,
	        matches: state.matches
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(PredictionEntryCreationModal);

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PredictionEntryCreationModal = undefined;
	
	var _PredictionEntryCreationModal = __webpack_require__(382);
	
	var _PredictionEntryCreationModal2 = _interopRequireDefault(_PredictionEntryCreationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PredictionEntryCreationModal = _PredictionEntryCreationModal2.default;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignInModal = function (_Component) {
	    _inherits(SignInModal, _Component);
	
	    function SignInModal(props) {
	        _classCallCheck(this, SignInModal);
	
	        var _this = _possibleConstructorReturn(this, (SignInModal.__proto__ || Object.getPrototypeOf(SignInModal)).call(this, props));
	
	        _this.initialState = {
	            fbLoading: false,
	            gglLoading: false,
	            emailLoading: false,
	
	            error: null,
	
	            email: '',
	            password: '',
	            displayName: ''
	        };
	        _this.state = Object.assign({
	            showSignIn: true
	        }, _this.initialState);
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        return _this;
	    }
	
	    _createClass(SignInModal, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("SignIn");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "SignIn" },
	                _react2.default.createElement(_ccImports.SignIn, { onSignInSuccess: this._closeModal })
	            );
	        }
	    }]);
	
	    return SignInModal;
	}(_react.Component);
	
	SignInModal.propTypes = {};
	SignInModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SignInModal);

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SignInModal = undefined;
	
	var _SignInModal = __webpack_require__(384);
	
	var _SignInModal2 = _interopRequireDefault(_SignInModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SignInModal = _SignInModal2.default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var totalSalary = 10000;
	var playersPerTeam = 2;
	
	var SingleLeagueModal = function (_Component) {
	    _inherits(SingleLeagueModal, _Component);
	
	    function SingleLeagueModal(props) {
	        _classCallCheck(this, SingleLeagueModal);
	
	        var _this = _possibleConstructorReturn(this, (SingleLeagueModal.__proto__ || Object.getPrototypeOf(SingleLeagueModal)).call(this, props));
	
	        _this.initialState = {
	            screen: 'league',
	            league: {}
	        };
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._onModalHide = _this._onModalHide.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleLeagueModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var oldModal = _lodash2.default.find(this.props.modals.modals, function (modal) {
	                return modal.name == 'SingleLeagueModal';
	            });
	            var newModal = _lodash2.default.find(nextProps.modals.modals, function (modal) {
	                return modal.name == 'SingleLeagueModal';
	            });
	            if (!_lodash2.default.isEqual(oldModal, newModal)) {
	                if (newModal && newModal.league) {
	                    this.setState({ league: newModal.league });
	                }
	            }
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("SingleLeagueModal");
	        }
	    }, {
	        key: '_onModalHide',
	        value: function _onModalHide() {
	            this.setState(this.initialState);
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                screen = _state.screen,
	                league = _state.league;
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "SingleLeagueModal", onModalHide: this._onModalHide },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    screen == 'league' && _react2.default.createElement(_ccImports.SingleLeague, { league: league, onPlayPressed: function onPlayPressed() {
	                            _this2._changeScreen('entryCreation');
	                        } }),
	                    screen == 'entryCreation' && _react2.default.createElement(
	                        _ccImports.CCBackLayout,
	                        { onBackPress: function onBackPress() {
	                                _this2._changeScreen('league');
	                            } },
	                        league.category == _ccImports.Constants.leagueCategory.DREAMTEAM ? _react2.default.createElement(_ccImports.DreamTeamEntryCreation, { onAck: this._closeModal, league: league, openSignIn: function openSignIn() {
	                                _this2._changeScreen('signIn');
	                            } }) : _react2.default.createElement(_ccImports.PredictionEntryCreation, { onAck: this._closeModal, league: league, openSignIn: function openSignIn() {
	                                _this2._changeScreen('signIn');
	                            } })
	                    ),
	                    screen == 'signIn' && _react2.default.createElement(_ccImports.SignIn, { onSignInSuccess: function onSignInSuccess() {
	                            _this2._changeScreen('entryCreation');
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return SingleLeagueModal;
	}(_react.Component);
	
	SingleLeagueModal.propTypes = {};
	SingleLeagueModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        entries: state.entries,
	        leagues: state.leagues,
	        matches: state.matches
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SingleLeagueModal);
	
	
	var ccStyles = {
	    default: {
	        entrySummarySize: 'r',
	        noEntryTitle: {
	            fontSize: 20
	        }
	    },
	    s: {
	        entrySummarySize: 's',
	        noEntryTitle: {
	            fontSize: 16
	        }
	    }
	};

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleLeagueModal = undefined;
	
	var _SingleLeagueModal = __webpack_require__(386);
	
	var _SingleLeagueModal2 = _interopRequireDefault(_SingleLeagueModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SingleLeagueModal = _SingleLeagueModal2.default;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	var _config = __webpack_require__(19);
	
	var _CCBackLayout = __webpack_require__(28);
	
	var _CCBackLayout2 = _interopRequireDefault(_CCBackLayout);
	
	var _CCLayout = __webpack_require__(83);
	
	var _CCLayout2 = _interopRequireDefault(_CCLayout);
	
	__webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var totalSalary = 10000;
	var playersPerTeam = 2;
	
	var SponsorDetailsModal = function (_Component) {
	    _inherits(SponsorDetailsModal, _Component);
	
	    function SponsorDetailsModal(props) {
	        _classCallCheck(this, SponsorDetailsModal);
	
	        var _this = _possibleConstructorReturn(this, (SponsorDetailsModal.__proto__ || Object.getPrototypeOf(SponsorDetailsModal)).call(this, props));
	
	        _this.initialState = {
	            screen: 'details',
	            sponsor: {}
	        };
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._onModalHide = _this._onModalHide.bind(_this);
	        return _this;
	    }
	
	    _createClass(SponsorDetailsModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var oldModal = _lodash2.default.find(this.props.modals.modals, function (modal) {
	                return modal.name == "SponsorDetails";
	            });
	            var newModal = _lodash2.default.find(nextProps.modals.modals, function (modal) {
	                return modal.name == "SponsorDetails";
	            });
	            if (!_lodash2.default.isEqual(oldModal, newModal)) {
	                if (newModal && newModal.sponsor) {
	                    this.setState({ sponsor: newModal.sponsor });
	                }
	            }
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("SponsorDetails");
	        }
	    }, {
	        key: '_onModalHide',
	        value: function _onModalHide() {
	            this.setState(this.initialState);
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                screen = _state.screen,
	                sponsor = _state.sponsor;
	
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "SponsorDetails", onModalHide: this._onModalHide },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'home-res2' },
	                    screen == 'details' && _react2.default.createElement(
	                        'div',
	                        { className: "sponsor-scroll" },
	                        _react2.default.createElement(_ccImports.SponsorDetails, { sponsor: sponsor, onViewRankPressed: function onViewRankPressed() {
	                                _this2._changeScreen('leaderboard');
	                            } })
	                    ),
	                    screen == 'leaderboard' && _react2.default.createElement(
	                        'div',
	                        { className: "sponsor-scroll " },
	                        _react2.default.createElement(
	                            _CCBackLayout2.default,
	                            { onBackPress: function onBackPress() {
	                                    _this2._changeScreen('details');
	                                } },
	                            _react2.default.createElement(_ccImports.Leaderboard, null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SponsorDetailsModal;
	}(_react.Component);
	
	SponsorDetailsModal.propTypes = {};
	SponsorDetailsModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        entries: state.entries,
	        matches: state.matches
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SponsorDetailsModal);
	
	
	var ccStyles = {
	    default: {
	        entrySummarySize: 'r',
	        noEntryTitle: {
	            fontSize: 20
	        }
	    },
	    s: {
	        entrySummarySize: 's',
	        noEntryTitle: {
	            fontSize: 16
	        }
	    }
	};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SponsorDetailsModal = undefined;
	
	var _SponsorDetailsModal = __webpack_require__(388);
	
	var _SponsorDetailsModal2 = _interopRequireDefault(_SponsorDetailsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SponsorDetailsModal = _SponsorDetailsModal2.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionsModal = function (_Component) {
	    _inherits(TransactionsModal, _Component);
	
	    function TransactionsModal(props) {
	        _classCallCheck(this, TransactionsModal);
	
	        var _this = _possibleConstructorReturn(this, (TransactionsModal.__proto__ || Object.getPrototypeOf(TransactionsModal)).call(this, props));
	
	        _this.state = {
	            skip: 0
	        };
	        return _this;
	    }
	
	    _createClass(TransactionsModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("TransactionsHistory");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ccImports.CCModalLayout,
	                { name: "TransactionsHistory" },
	                _react2.default.createElement(_ccImports.Transactions, null)
	            );
	        }
	    }]);
	
	    return TransactionsModal;
	}(_react.Component);
	
	TransactionsModal.propTypes = {};
	TransactionsModal.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(TransactionsModal);

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CCModals = __webpack_require__(373);
	
	Object.keys(_CCModals).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CCModals[key];
	    }
	  });
	});

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _Home = __webpack_require__(41);
	
	var _Leagues = __webpack_require__(42);
	
	var _TransactionsModal = __webpack_require__(29);
	
	__webpack_require__(87);
	
	var _CCBackLayout = __webpack_require__(28);
	
	var _CCBackLayout2 = _interopRequireDefault(_CCBackLayout);
	
	var _CCIcon = __webpack_require__(79);
	
	var _CCIcon2 = _interopRequireDefault(_CCIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeagueRoute = function (_Component) {
	    _inherits(LeagueRoute, _Component);
	
	    function LeagueRoute(props) {
	        _classCallCheck(this, LeagueRoute);
	
	        var _this = _possibleConstructorReturn(this, (LeagueRoute.__proto__ || Object.getPrototypeOf(LeagueRoute)).call(this, props));
	
	        _this.state = {
	            screens: 'league'
	
	        };
	        _this._signUpGoogle = _this._signUpGoogle.bind(_this);
	        return _this;
	    }
	
	    _createClass(LeagueRoute, [{
	        key: '_signUpGoogle',
	        value: function _signUpGoogle() {
	            //this.props.actions.signIn(this.props.actions.getUserByEmail);
	        }
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screens) {
	            this.setState({ screens: screens });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _ccImports.CCLayout,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container home-res' },
	                    this.state.screens == 'league' && _react2.default.createElement(
	                        'div',
	                        { className: 'bc-icon ' },
	                        _react2.default.createElement(_CCBackLayout2.default, { className: 'bc-icon', onBackPress: function onBackPress() {
	                                _this2._changeScreen('home');
	                            } }),
	                        _react2.default.createElement(_Leagues.Leagues, null)
	                    ),
	                    this.state.screens == 'home' && _react2.default.createElement(
	                        'div',
	                        { className: 'home-root-container' },
	                        _react2.default.createElement(_Home.Home, { onPlayState: this.state.screens = "league" })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LeagueRoute;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        //user: state.user.user,
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(LeagueRoute);

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LeagueRoute = undefined;
	
	var _LeagueRoute = __webpack_require__(392);
	
	var _LeagueRoute2 = _interopRequireDefault(_LeagueRoute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LeagueRoute = _LeagueRoute2.default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _Home = __webpack_require__(41);
	
	var _Leagues = __webpack_require__(42);
	
	var _TransactionsModal = __webpack_require__(29);
	
	var _reactMedia = __webpack_require__(66);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	__webpack_require__(87);
	
	var _CCBackLayout = __webpack_require__(28);
	
	var _CCBackLayout2 = _interopRequireDefault(_CCBackLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Component) {
	    _inherits(Root, _Component);
	
	    function Root(props) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));
	
	        _this.state = {};
	        _this._signUpGoogle = _this._signUpGoogle.bind(_this);
	        return _this;
	    }
	
	    _createClass(Root, [{
	        key: '_signUpGoogle',
	        value: function _signUpGoogle() {
	            //this.props.actions.signIn(this.props.actions.getUserByEmail);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ccImports.CCLayout,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container home-res' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container row root-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'home-root-container' },
	                            _react2.default.createElement(_Home.Home, null)
	                        ),
	                        _react2.default.createElement(
	                            _reactMedia2.default,
	                            { query: "(min-device-width : 737px)" },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'leagues-root-container' },
	                                _react2.default.createElement(_Leagues.Leagues, null)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Root;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        //user: state.user.user,
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Root);

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Root = undefined;
	
	var _Root = __webpack_require__(394);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Root = _Root2.default;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerifyEmail = function (_Component) {
	    _inherits(VerifyEmail, _Component);
	
	    function VerifyEmail(props) {
	        _classCallCheck(this, VerifyEmail);
	
	        var _this = _possibleConstructorReturn(this, (VerifyEmail.__proto__ || Object.getPrototypeOf(VerifyEmail)).call(this, props));
	
	        _this.state = {};
	        _this._signUpGoogle = _this._signUpGoogle.bind(_this);
	        return _this;
	    }
	
	    _createClass(VerifyEmail, [{
	        key: '_signUpGoogle',
	        value: function _signUpGoogle() {
	            //this.props.actions.signIn(this.props.actions.getUserByEmail);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col-sm-4' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-4' },
	                    'Verify email'
	                ),
	                _react2.default.createElement('div', { className: 'col-sm-4' })
	            );
	        }
	    }]);
	
	    return VerifyEmail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        //user: state.user.user,
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(VerifyEmail);

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VerifyEmail = undefined;
	
	var _VerifyEmail = __webpack_require__(396);
	
	var _VerifyEmail2 = _interopRequireDefault(_VerifyEmail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.VerifyEmail = _VerifyEmail2.default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Root = __webpack_require__(395);
	
	Object.keys(_Root).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Root[key];
	    }
	  });
	});
	
	var _LeaguesRoute = __webpack_require__(393);
	
	Object.keys(_LeaguesRoute).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LeaguesRoute[key];
	    }
	  });
	});
	
	var _VerifyEmail = __webpack_require__(397);
	
	Object.keys(_VerifyEmail).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _VerifyEmail[key];
	    }
	  });
	});

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	    _inherits(About, _Component);
	
	    function About(props) {
	        _classCallCheck(this, About);
	
	        var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	        _this.state = {
	            recentMatches: [],
	            upcomingMatches: [],
	            upcomingLeagues: [],
	            user: {},
	            displayNameErr: null,
	            emailErr: null
	        };
	        return _this;
	    }
	
	    _createClass(About, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /*BackHandler.addEventListener('hardwareBackPress', () => {
	                if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
	                    this.props.actions.goBack();
	                    return true;
	                }
	                return false;
	            });*/
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user.user;
	            return _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return About;
	}(_react.Component);
	
	About.propTypes = {};
	About.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(About);

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.About = undefined;
	
	var _About = __webpack_require__(399);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.About = _About2.default;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddCoins = function (_Component) {
	    _inherits(AddCoins, _Component);
	
	    function AddCoins(props) {
	        _classCallCheck(this, AddCoins);
	
	        var _this = _possibleConstructorReturn(this, (AddCoins.__proto__ || Object.getPrototypeOf(AddCoins)).call(this, props));
	
	        _this.state = {
	            screen: 'more'
	            // this._openInviteFriends=this._openInviteFriends.bind(this);
	            // this._claimDailyLoginBonus=this._claimDailyLoginBonus.bind(this);
	        };return _this;
	    }
	
	    _createClass(AddCoins, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: '_changeScreen',
	        value: function _changeScreen(screen) {
	            this.setState({ screen: screen });
	        }
	    }, {
	        key: '_openInviteFriends',
	        value: function _openInviteFriends() {
	            var user = this.props.user;
	
	            if (user) {
	                _ccImports.FirebaseUtils.showInviteLinkDialog({ 'invitedBy': user.id }, user);
	            }
	        }
	
	        // _openInviteFriends(){
	        //     const {user}=this.props;
	        //     if(user){
	        //         FirebaseUtils.showInviteLinkDialog({'invitedBy':user.id}, user);
	        //     }
	        // }
	        //
	        // _claimDailyLoginBonus(){
	        //     //console.log('onClaimPressed ---- ')
	        //     const {user}=this.props;
	        //     this.props.actions.claimDailyLoginBonus(user.id, user);
	        // }
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                style = _props.style;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { flex: 1, flexDirection: 'column' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { alignItems: 'center', justifyContent: 'center' } },
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { fontSize: 20, alignItems: 'center', justifyContent: 'center', marginLeft: 100, marginRight: 100 } },
	                        (0, _ccImports.strings)('earn_coins_bonuses')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { flex: 2, justifyContent: 'center', alignItems: 'center' } },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { marginBottom: 10, alignItems: 'center', justifyContent: 'center', marginLeft: 100, marginRight: 100, fontSize: 15 } },
	                        (0, _ccImports.strings)('invite_friends')
	                    ),
	                    _react2.default.createElement(_ccImports.CCIcon, { type: 'inviteFriends', height: 80, width: 80, style: { marginLeft: 120, marginRight: 100 }, onClick: this._openInviteFriends }),
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { marginTop: 5, alignItems: 'center', justifyContent: 'center', marginLeft: 100, marginRight: 100, fontSize: 15, textAlign: 'center' } },
	                        (0, _ccImports.strings)('invite_friends_title')
	                    )
	                ),
	                _react2.default.createElement('div', { style: { height: 1, marginLeft: 20, marginRight: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 10, borderBottomColor: _ccImports2.colors.theme2.border_color2, borderBottomWidth: 0.5 } }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { flex: 2, justifyContent: 'center', alignItems: 'center' } },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { marginBottom: 10, alignItems: 'center', justifyContent: 'center', fontSize: 15, marginLeft: 100, marginRight: 100 } },
	                        (0, _ccImports.strings)('daily_login_bonus')
	                    ),
	                    _react2.default.createElement(_ccImports.CCIcon, { type: 'clock', height: 80, width: 80, style: { marginLeft: 100, marginRight: 100 } })
	                )
	            );
	        }
	    }]);
	
	    return AddCoins;
	}(_react.Component);
	
	AddCoins.propTypes = {};
	AddCoins.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        // modals: state.modals,
	        // user : state.user.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(AddCoins);

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddCoins = undefined;
	
	var _AddCoins = __webpack_require__(401);
	
	var _AddCoins2 = _interopRequireDefault(_AddCoins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AddCoins = _AddCoins2.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './claim_rewards.css'
	
	var ClaimReward = function (_Component) {
	    _inherits(ClaimReward, _Component);
	
	    function ClaimReward(props) {
	        _classCallCheck(this, ClaimReward);
	
	        var _this = _possibleConstructorReturn(this, (ClaimReward.__proto__ || Object.getPrototypeOf(ClaimReward)).call(this, props));
	
	        _this.state = {};
	        _this._getButtonTitle = _this._getButtonTitle.bind(_this);
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        _this._isProcessed = _this._isProcessed.bind(_this);
	        return _this;
	    }
	
	    _createClass(ClaimReward, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (this.props.ntfn.reward && this.props.ntfn.reward.id) {
	                _ccImports.FirebaseUtils.getIdTokenWhenAuthChanged(function (idToken) {
	                    _this2.props.actions.getReward({ accessToken: idToken }, _this2.props.ntfn.reward.id, _ccImports.DataActionTypes.GET);
	                });
	            }
	        }
	    }, {
	        key: '_getButtonTitle',
	        value: function _getButtonTitle(reward) {
	            switch (reward.status) {
	                case _ccImports.Constants.rewardStatus.CREATED:
	                    return (0, _ccImports.strings)('claim');
	                    break;
	                case _ccImports.Constants.rewardStatus.CLAIMED:
	                    return (0, _ccImports.strings)('update');
	                    break;
	                case _ccImports.Constants.rewardStatus.PROCESSED:
	                    return (0, _ccImports.strings)('processed');
	                    break;
	            }
	        }
	    }, {
	        key: '_updateReward',
	        value: function _updateReward(reward) {
	            var _this3 = this;
	
	            var claimDetails = reward.claimDetails;
	
	            _lodash2.default.each(claimDetails, function (claimDetail) {
	                if (_this3.state[claimDetail.key]) {
	                    _lodash2.default.merge(claimDetail, { value: _this3.state[claimDetail.key] });
	                }
	            });
	            //console.log(reward,'hhhhhhh')
	
	            return reward;
	        }
	    }, {
	        key: '_validateAndSubmit',
	        value: function _validateAndSubmit(reward) {
	            var _this4 = this;
	
	            var claimDetails = reward.claimDetails;
	
	            var err = undefined;
	            _lodash2.default.each(claimDetails, function (claimDetail) {
	                var val = _this4.state[claimDetail.key];
	                if (claimDetail.value == undefined && (val == undefined || val == null)) {
	                    err = (0, _ccImports.strings)("invalid_filed_instruction", { fieldName: _ccImports.CCUIUtils.getLocaleStr(claimDetail.name) });
	                }
	            });
	
	            if (err) {
	                this.setState({ error: err });
	            } else {
	                this.setState({ error: undefined }, function () {
	                    _this4._onSubmit(reward);
	                });
	            }
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit(reward) {
	            var _this5 = this;
	
	            _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                switch (reward.status) {
	                    case _ccImports.Constants.rewardStatus.CREATED:
	                        var updatedReward = _this5._updateReward(reward);
	                        _this5.props.actions.claimReward({ accessToken: idToken }, updatedReward, _ccImports.DataActionTypes.UPDATE);
	                        break;
	                    case _ccImports.Constants.rewardStatus.CLAIMED:
	                        var updatedReward = _this5._updateReward(reward);
	                        _this5.props.actions.updateClaimReward({ accessToken: idToken }, updatedReward, _ccImports.DataActionTypes.UPDATE);
	                        break;
	                }
	            });
	        }
	    }, {
	        key: '_isProcessed',
	        value: function _isProcessed(reward) {
	            return reward.status == _ccImports.Constants.rewardStatus.PROCESSED;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var ntfn = this.props.ntfn;
	
	            var rewardId = ntfn.reward.id;
	            var reward = this.props.rewards.rewards.rewards[rewardId];
	
	            var _ref = reward ? reward : {},
	                claimProcedure = _ref.claimProcedure,
	                claimDetails = _ref.claimDetails,
	                processed = _ref.processed,
	                claimed = _ref.claimed,
	                claimCoins = _ref.claimCoins;
	
	            var _props$rewards = this.props.rewards,
	                type = _props$rewards.type,
	                fetching = _props$rewards.fetching;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { flex: 1 }, className: 'scroll' },
	                fetching && type == _ccImports.DataActionTypes.GET ? _react2.default.createElement(
	                    'div',
	                    { className: "flex-container", style: { flex: 1, alignItems: 'center', justifyContent: 'center', height: '6vw' } },
	                    _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 's' })
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { flex: 1 } },
	                    reward != undefined ? _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, alignItems: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'claimRewardsParent2' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: "claimRewardsTitle1" },
	                                _ccImports.CCUIUtils.getLocaleStr(ntfn.title)
	                            ),
	                            _react2.default.createElement(
	                                'h2',
	                                { className: "claimRewardsText1" },
	                                _ccImports.CCUIUtils.getLocaleStr(ntfn.message)
	                            ),
	                            _react2.default.createElement('div', { style: { height: 1, width: '80%', marginLeft: 20, marginRight: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 10, borderBottomColor: _ccImports.colors.theme2.border_color2, borderBottomWidth: 0.5 } }),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: "claimRewardsText2" },
	                                (0, _ccImports.strings)('reward_reference', { reference: reward.reference })
	                            ),
	                            true && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'claimRewardsText3' },
	                                    (0, _ccImports.strings)('reward_processed')
	                                )
	                            ),
	                            _react2.default.createElement('div', { style: { height: 1, width: '80%', marginLeft: 80, marginRight: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', borderBottomColor: _ccImports.colors.theme2.border_color2, borderBottomWidth: 0.5 } }),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'claimRewardsText3 m' },
	                                (0, _ccImports.strings)('claim_reward_instructions_title')
	                            ),
	                            claimProcedure && _react2.default.createElement(
	                                'div',
	                                null,
	                                claimProcedure.map(function (procedure, index) {
	                                    return _react2.default.createElement(
	                                        'h3',
	                                        { key: index, className: 'claimRewardsText3 s' },
	                                        _ccImports.CCUIUtils.getLocaleStr(procedure)
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement('div', { className: 'flex-container', style: { width: '80%', marginLeft: 20, marginRight: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 20, borderBottomColor: _ccImports.colors.theme2.border_color2, borderBottomWidth: 0.5 } }),
	                            claimDetails && _react2.default.createElement(
	                                'div',
	                                { style: { flex: 1, width: '100%', marginTop: 10, marginBottom: 10 } },
	                                claimDetails.map(function (claimDetail, index) {
	                                    return _react2.default.createElement(_ccImports.CCInput, { className: 'claimRewardsInput', inputClassName: 'claimRewardsInputLabel', errorClassName: 'claimRewardsInputLabel', labelClassName: 'claimRewardsInputLabel', immediate: true, editable: !_this6._isProcessed(reward), value: claimDetail.value, onEndEditing: function onEndEditing(value) {
	                                            var state = _this6.state;
	                                            state[claimDetail.key] = value;
	                                            _this6.setState(state, function () {});
	                                        }, key: index, type: claimDetail.type.toLowerCase(), label: _ccImports.CCUIUtils.getLocaleStr(claimDetail.name), required: claimDetail.required });
	                                })
	                            ),
	                            !this._isProcessed(reward) && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1, marginBottom: 20, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' } },
	                                claimCoins > 0 && _react2.default.createElement(
	                                    'h3',
	                                    { style: { marginTop: 5, marginBottom: 5, color: "#ffffff", fontSize: 10, textAlign: 'center' } },
	                                    (0, _ccImports.strings)('claim_coins_message', { claimCoins: claimCoins })
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'claimRewardsBtn', loading: type == _ccImports.DataActionTypes.UPDATE && fetching, disabled: this._isProcessed(reward), onClick: function onClick() {
	                                            _this6._validateAndSubmit(reward);
	                                        } },
	                                    this._getButtonTitle(reward)
	                                ),
	                                this.state.error && _react2.default.createElement(
	                                    'div',
	                                    { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { style: { width: '80%', textAlign: 'center', color: _ccImports.colors.theme.txt_color4 } },
	                                        this.state.error
	                                    )
	                                )
	                            )
	                        )
	                    ) : _react2.default.createElement('div', null)
	                )
	            );
	        }
	    }]);
	
	    return ClaimReward;
	}(_react.Component);
	
	ClaimReward.propTypes = {
	    ntfn: _propTypes2.default.object
	
	};
	ClaimReward.defaultProps = {
	    ntfn: {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser,
	        rewards: state.rewards
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(ClaimReward);

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClaimReward = undefined;
	
	var _ClaimReward = __webpack_require__(403);
	
	var _ClaimReward2 = _interopRequireDefault(_ClaimReward);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ClaimReward = _ClaimReward2.default;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DreamTeamEntryCreation = undefined;
	
	var _DreamTeamEntryCreation = __webpack_require__(85);
	
	var _DreamTeamEntryCreation2 = _interopRequireDefault(_DreamTeamEntryCreation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DreamTeamEntryCreation = _DreamTeamEntryCreation2.default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	__webpack_require__(471);
	
	var _countries = __webpack_require__(483);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _languages = __webpack_require__(484);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './Edition.css'
	
	
	var Edition = function (_Component) {
	    _inherits(Edition, _Component);
	
	    function Edition(props) {
	        _classCallCheck(this, Edition);
	
	        var _this = _possibleConstructorReturn(this, (Edition.__proto__ || Object.getPrototypeOf(Edition)).call(this, props));
	
	        _this.state = {
	            country: '',
	            language: '',
	            loading: false
	        };
	        _this._selectCountry = _this._selectCountry.bind(_this);
	        _this._selectLanguage = _this._selectLanguage.bind(_this);
	        _this._updateTeams = _this._updateTeams.bind(_this);
	        _this._saveDetails = _this._saveDetails.bind(_this);
	        return _this;
	    }
	
	    _createClass(Edition, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /*BackHandler.addEventListener('hardwareBackPress', () => {
	                if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
	                    this.props.actions.goBack();
	                    return true;
	                }
	                return false;
	            });*/
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.user.user) {
	                this.setState(this.props.user.user);
	            }
	        }
	    }, {
	        key: '_selectCountry',
	        value: function _selectCountry(country) {
	            var _this2 = this;
	
	            _ccImports.CCAppEventLogger.logAppEvent("CountrySelected", { country: country.key, loggedIn: _ccImports.CCUtils.isLoggedIn(this.props.user) });
	            this.setState({ country: country.key });
	
	            this.props.actions.updateCountry(this.props.user.user, country.key).then(function () {
	                _this2.props.actions.editionChanged();
	            });
	        }
	    }, {
	        key: '_selectLanguage',
	        value: function _selectLanguage(language) {
	            _ccImports.CCAppEventLogger.logAppEvent("LanguageSelected", { language: language.key, loggedIn: _ccImports.CCUtils.isLoggedIn(this.props.user) });
	            this.setState({ language: language.key });
	            this.props.actions.updateLanguage(this.props.user.user, language.key);
	            this._updateTeams(language.key);
	        }
	    }, {
	        key: '_updateTeams',
	        value: function _updateTeams(team) {
	            var teams = this.state.teams;
	            if (teams == null) teams = [];
	            if (_lodash2.default.find(teams, function (key) {
	                return key == team.key;
	            })) {
	                _lodash2.default.remove(teams, function (key) {
	                    return key == team.key;
	                });
	            } else {
	                teams = _lodash2.default.concat(teams, team.key);
	            }
	            this.setState({ teams: teams });
	            this.props.actions.updateSettings(this.props.user.user, Object.assign(this.state, { teams: teams }));
	        }
	    }, {
	        key: '_saveDetails',
	        value: function _saveDetails() {
	            this.setState({ loading: true });
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var user = this.props.user.user;
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sidebar-sub-background' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { resizeMode: 'cover' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { alignItems: 'center', justifyContent: 'center', width: 150 } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container edition-header' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { style: { fontSize: 25 } },
	                                    (0, _ccImports.strings)('edition')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1, width: 550 } },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'pick-country-title' },
	                                    (0, _ccImports.strings)('pick_your_country')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container pick-country-title2 ' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    (0, _ccImports.strings)('select_country')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'gridView edition-scroll', style: { flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
	                                _countries2.default.countries.map(function (country) {
	                                    return _react2.default.createElement(_ccImports.CCGridItem, { selected: _this3.state.country == country.key, onPress: function onPress() {
	                                            _this3._selectCountry(country);
	                                        }, type: 'country', item: country });
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container select-lang-title' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    null,
	                                    (0, _ccImports.strings)('select_language')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '32vw' } },
	                                _languages2.default.languages.map(function (language) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { style: { border: '1px' } },
	                                        _react2.default.createElement(_ccImports.CCGridItem, { selected: _this3.state.language == language.key, onPress: function onPress() {
	                                                _this3._selectLanguage(language);
	                                            }, type: 'language', item: language })
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '32vw' } },
	                                _react2.default.createElement(_ccImports.CCButton, { style: { width: '51vw', height: 50, borderRadius: '5px' },
	                                    title: (0, _ccImports.strings)('save'), titleSize: 15, onPress: function onPress() {
	                                        _this3._saveDetails();
	                                    } })
	                            ),
	                            false && _react2.default.createElement('div', { className: 'flex-container', style: { flex: 1 } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Edition;
	}(_react.Component);
	
	Edition.propTypes = {};
	Edition.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Edition);

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Edition = undefined;
	
	var _Edition = __webpack_require__(406);
	
	var _Edition2 = _interopRequireDefault(_Edition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Edition = _Edition2.default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Help = function (_Component) {
	    _inherits(Help, _Component);
	
	    function Help(props) {
	        _classCallCheck(this, Help);
	
	        var _this = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this, props));
	
	        _this.state = {
	            recentMatches: [],
	            upcomingMatches: [],
	            upcomingLeagues: [],
	            user: {},
	            displayNameErr: null,
	            emailErr: null
	        };
	        return _this;
	    }
	
	    _createClass(Help, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /*BackHandler.addEventListener('hardwareBackPress', () => {
	                if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
	                    this.props.actions.goBack();
	                    return true;
	                }
	                return false;
	            });*/
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user.user;
	            return _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return Help;
	}(_react.Component);
	
	Help.propTypes = {};
	Help.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Help);

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Help = undefined;
	
	var _Help = __webpack_require__(408);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Help = _Help2.default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FBHome = function (_Component) {
	    _inherits(FBHome, _Component);
	
	    function FBHome(props) {
	        _classCallCheck(this, FBHome);
	
	        var _this = _possibleConstructorReturn(this, (FBHome.__proto__ || Object.getPrototypeOf(FBHome)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(FBHome, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            // FirebaseUtils.subscribeToAllUsersNotifications();
	            //
	            // FirebaseUtils.addOnMessageListener((message)=>{
	            //     Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken) => {
	            //         var currentUserId = this.props.user.user ? this.props.user.user.id:Constants.anonymousUser;
	            //         const {skip, limit, matchKey, matchId, leagueId, userId, lbId,ntfnId, category, type, completed, allUsers} = message;
	            //         var skipInt = skip ? parseInt(skip):0;
	            //         var limitInt = limit ? parseInt(limit):20;
	            //         const {actions} = this.props;
	            //
	            //         switch (type) {
	            //             case 'match':
	            //                 matchKey && actions.getMatchByKey(matchKey);
	            //                 matchId && actions.getMatch(matchId);
	            //                 matchId && completed=='true' && actions.getLeaguesByMatchId({skip : skipInt, limit:limitInt, matchId : matchId}, {userId : currentUserId, idToken:idToken}, DataAT.AUTO_REFRESH);
	            //                 matchId && completed=='true' && actions.getEntriesByUserIdAndMatchId({  userId: currentUserId, matchId : matchId }, { accessToken: idToken, userId: currentUserId }, DataAT.AUTO_REFRESH);
	            //                 break;
	            //             case 'league':
	            //                 leagueId && actions.getLeague(leagueId,{accessToken:idToken}, DataAT.AUTO_REFRESH);
	            //                 category && actions.getLeagues(category,currentUserId,skipInt,limitInt,idToken,DataAT.AUTO_REFRESH);
	            //                 break;
	            //             case 'lb':
	            //                 var lb = this.props.leaderBoard.lbs.byId[lbId];
	            //                 lb && actions.fetchLBStatuses({accessToken:idToken}, {lbId:lb.id,userId:currentUserId, skip:skipInt, limit:limitInt}, DataAT.AUTO_REFRESH);
	            //                 break;
	            //             case 'ntfn':
	            //                 var ntfn = _.find(this.props.notifications.notifications, {'id':ntfnId});
	            //                 ntfn && actions.getNtfnById({ntfnId:ntfn.id}, DataAT.AUTO_REFRESH);
	            //                 skip && limit && actions.fetchNotifications({ userId:currentUserId, skip : skipInt , limit: limitInt }, DataAT.AUTO_REFRESH)
	            //                 break;
	            //             case 'trns':
	            //                 actions.fetchTransactions({accessToken:idToken}, { userId:currentUserId, skip : skipInt , limit: limitInt }, DataAT.AUTO_REFRESH)
	            //                 break;
	            //             case 'sponsor':
	            //                 actions.getSponsorsByUserId({ userId:currentUserId}, DataAT.AUTO_REFRESH)
	            //                 break;
	            //             case 'user':
	            //                 if(currentUserId==userId) {
	            //                     actions.getUser({userId : userId}).then(()=>{
	            //                         //TODO: later user same as in splash screen
	            //                         if(this.props.user && this.props.user.user){
	            //                             if(this.props.user.user.emailVerified==true) {
	            //                                 actions.hideEmailNotVerifiedMessage();
	            //                             }
	            //                             else {
	            //                                 actions.showEmailNotVerifiedMessage(()=>{
	            //                                     FirebaseUtils.resendVerificationEmail();
	            //                                 })
	            //                             }
	            //                         }
	            //                     })
	            //                 }
	            //                 allUsers =='true' && actions.getUser({userId : currentUserId});
	            //                 break;
	            //         }
	            //
	            //     })
	            // });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return FBHome;
	}(_react.Component);
	
	FBHome.propTypes = {};
	FBHome.defaultProps = {};
	FBHome.navigationOptions = {
	    gesturesEnabled: false
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        storedDetails: state.storedDetails,
	        fireBaseUser: state.fireBaseUser,
	        user: state.user,
	        matches: state.matches,
	        leagues: state.leagues,
	        ccNavigation: state.ccNavigation,
	        leaderBoard: state.leaderBoard,
	        notifications: state.notifications
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(FBHome);

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(472);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	    _inherits(Home, _Component);
	
	    function Home(props) {
	        _classCallCheck(this, Home);
	
	        var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
	        _this.state = {
	            selected: undefined
	        };
	        _this._getListItems = _this._getListItems.bind(_this);
	
	        _this._fetchMatches = _this._fetchMatches.bind(_this);
	        _this._autoRefresh = _this._autoRefresh.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._switchTab = _this._switchTab.bind(_this);
	        _this._playPressed = _this._playPressed.bind(_this);
	        //this._onMatchesUpdate=this._onMatchesUpdate.bind(this);
	        return _this;
	    }
	
	    _createClass(Home, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._fetchMatches(_ccImports.DataActionTypes.GET);
	            var _props = this.props,
	                user = _props.user,
	                userId = _props.userId,
	                actions = _props.actions;
	
	
	            if (user) {
	                //console.log(Firebase.auth().currentUser);
	                _ccImports.FirebaseUtils.getIdTokenWhenAuthChanged(function (idToken) {
	                    actions.getSponsorsByUserId(userId, _ccImports.DataActionTypes.GET);
	                });
	            }
	
	            /*this.setInterval(() => {
	                this._fetchMatches(DataAT.AUTO_REFRESH);
	            }, 60000);*/
	        }
	    }, {
	        key: '_getListItems',
	        value: function _getListItems() {
	            var _props2 = this.props,
	                matchesByStatus = _props2.matchesByStatus,
	                matchesById = _props2.matchesById;
	
	
	            var upcomingMatches = matchesByStatus[_ccImports.Constants.matchStatus.NOT_STARTED] ? matchesByStatus[_ccImports.Constants.matchStatus.NOT_STARTED] : [];
	            var liveMatches = matchesByStatus[_ccImports.Constants.matchStatus.STARTED] ? matchesByStatus[_ccImports.Constants.matchStatus.STARTED] : [];
	            var completedMatches = matchesByStatus[_ccImports.Constants.matchStatus.COMPLETED] ? matchesByStatus[_ccImports.Constants.matchStatus.COMPLETED] : [];
	
	            var matchIds = this.state.selected == 'upcoming' ? upcomingMatches : _lodash2.default.union(liveMatches, completedMatches);
	
	            if (this.state.selected === 'upcoming') {
	                matchIds = _lodash2.default.orderBy(matchIds, [function (id) {
	                    return matchesById[id].priority;
	                }, function (id) {
	                    return new Date(matchesById[id].date);
	                }], ['asc', 'asc']);
	            } else {
	                matchIds = _lodash2.default.orderBy(matchIds, [function (id) {
	                    return matchesById[id].status == _ccImports.Constants.matchStatus.STARTED ? 10 : 0;
	                }, function (id) {
	                    return matchesById[id].priority;
	                }, function (id) {
	                    return new Date(matchesById[id].date);
	                }], ['desc', 'asc', 'desc']);
	            }
	
	            return matchIds;
	        }
	
	        // _getBgColor(tabname){
	        //     if(this.state.selected === tabname) {
	        //         return 'rgb(17, 49, 96)'
	        //     }
	        //     else {
	        //         return 'rgb(52,105,184)'
	        //     }
	        // }
	
	    }, {
	        key: '_getBgColor',
	        value: function _getBgColor(tabName) {
	            if (this.state.selected === tabName) {
	                return _ccImports.colors.theme2.bg_color8;
	            } else {
	                return _ccImports.colors.theme2.bg_color9;
	            }
	        }
	    }, {
	        key: '_switchTab',
	        value: function _switchTab(tabName) {
	            this.setState({ selected: tabName });
	        }
	    }, {
	        key: '_fetchMatches',
	        value: function _fetchMatches(type) {
	            var _this2 = this;
	
	            this.props.actions.getRecentMatches(type).then(function () {
	                var _props3 = _this2.props,
	                    matchesByStatus = _props3.matchesByStatus,
	                    matchesById = _props3.matchesById;
	
	
	                if (_this2.state.selected === undefined) {
	                    var liveMatches = matchesByStatus[_ccImports.Constants.matchStatus.STARTED];
	                    if (liveMatches && liveMatches.length > 0) {
	                        _this2._switchTab('live');
	                    } else {
	                        _this2._switchTab('upcoming');
	                    }
	                }
	
	                /*_.forIn(matchesById,(value, key)=>{
	                 if(this.unsubscribe[key]==undefined ) this.unsubscribe[key]=this.ref.doc(key).onSnapshot(this._onMatchesUpdate);
	                 })*/
	            });
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchMatches(_ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchMatches(_ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            //No pagination at the moment
	            /* this._fetchMatches(DataAT.AUTO_REFRESH);
	             this.setState({skip : this.state.skip+1});*/
	        }
	    }, {
	        key: '_playPressed',
	        value: function _playPressed(matchId) {
	            this.props.actions.openLeagues(matchId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            //console.log(Firebase.auth().currentUser);
	            var _props4 = this.props,
	                matchesReqStatus = _props4.matchesReqStatus,
	                matchesById = _props4.matchesById,
	                matchesType = _props4.matchesType;
	
	            var styles = ccStyles.default;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container home-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { height: '100vh' } },
	                        matchesReqStatus == _ccImports.Constants.reqStatus.PEN && matchesType == _ccImports.DataActionTypes.GET && this._getListItems().length == 0 ? _react2.default.createElement(
	                            'div',
	                            { className: "flex-container activity-indicator" },
	                            _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 'm' })
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container match-selection-container' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container match-selection-container-1' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container live-switcher-container', onClick: function onClick() {
	                                                _this3._switchTab('live');
	                                            }, style: { backgroundColor: this._getBgColor('live') } },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-container btn btn-container' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'home-icon-hide' },
	                                                _react2.default.createElement(_ccImports.CCIcon, { type: "live", className: "cc-home-icon-xx", disabled: true })
	                                            ),
	                                            _react2.default.createElement(
	                                                'h1',
	                                                { style: { marginLeft: 5, fontSize: 12 } },
	                                                (0, _ccImports.strings)('live')
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container btn upcoming-container', onClick: function onClick() {
	                                                _this3._switchTab('upcoming');
	                                            }, style: { backgroundColor: this._getBgColor('upcoming') } },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-container upcoming-container-1' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'bat_icon_hide' },
	                                                _react2.default.createElement(_ccImports.CCIcon, { type: "upcoming", className: "cc-upcomming-icon-xx", disabled: true })
	                                            ),
	                                            _react2.default.createElement(
	                                                'h1',
	                                                { style: { marginLeft: 5, fontSize: 12 } },
	                                                (0, _ccImports.strings)('upcoming')
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                matchesReqStatus == _ccImports.Constants.reqStatus.PEN && matchesType == _ccImports.DataActionTypes.GET && this._getListItems().length == 0 ? _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 'm' })
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this._getListItems().map(function (match) {
	                                        return _react2.default.createElement(_ccImports.SimpleMatchDetails, { scroll: _this3.props.scroll, showPlay: true, onPlayPress: function onPlayPress() {
	                                                _this3.props.actions.openLeagues(match);
	                                            }, ccMatch: matchesById[match], key: matchesById[match].id });
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Home;
	}(_react.Component);
	
	Home.propTypes = {};
	Home.defaultProps = {};
	Home.navigationOptions = {
	    gesturesEnabled: false
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        storedDetails: state.storedDetails,
	        fireBaseUser: state.fireBaseUser,
	
	        user: state.user,
	        userId: state.user.user && state.user.user.id ? state.user.user.id : _ccImports.Constants.anonymousUser,
	
	        matchesById: state.matches.byId,
	        matchesByStatus: state.matches.byStatus,
	        matchesReqStatus: state.matches.reqStatus,
	        matchesType: state.matches.type,
	
	        leaguesById: state.leagues.byId,
	
	        ccNavigation: state.ccNavigation,
	        leaderBoard: state.leaderBoard,
	        notifications: state.notifications
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Home);
	
	
	var ccStyles = {
	    default: {
	        iconStyle: {
	            height: 40,
	            width: 40
	        },
	        imageStyle: {
	            height: 35,
	            width: 35
	        }
	    },
	    s: {
	        iconStyle: {
	            height: 35,
	            width: 35
	        },
	        imageStyle: {
	            height: 30,
	            width: 30
	        }
	    }
	};

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ccImports = __webpack_require__(1);
	
	var _CCListView = __webpack_require__(39);
	
	var _CCListView2 = _interopRequireDefault(_CCListView);
	
	var _CCSectionList = __webpack_require__(80);
	
	var _CCSectionList2 = _interopRequireDefault(_CCSectionList);
	
	__webpack_require__(473);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	var _CCUIUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leaderboard = function (_Component) {
	    _inherits(Leaderboard, _Component);
	
	    function Leaderboard(props) {
	        _classCallCheck(this, Leaderboard);
	
	        var _this = _possibleConstructorReturn(this, (Leaderboard.__proto__ || Object.getPrototypeOf(Leaderboard)).call(this, props));
	
	        _this._renderSectionHeader = function (_ref) {
	            var section = _ref.section;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    section.key
	                )
	            );
	        };
	
	        _this.initialState = {
	            title: 'Leader Board',
	
	            type: undefined, // weekly, monthly, lifetime
	            country: undefined, //ALL or LOCAL
	            subType: undefined, // NO_OF_COINS_EARNED, NO_OF_ENTRIES_PLAYED, WIN_LOST_RATIO
	            status: 'ACTIVE', // active, COMPLETED
	
	            types: [],
	            countries: [],
	            subTypes: [],
	            statuses: [],
	
	            lbId: '',
	            lb: {},
	            data: [],
	            skip: 0
	        };
	        _this.state = _this.initialState;
	        _this._updateSelectedLb = _this._updateSelectedLb.bind(_this);
	        _this._updateLBMapsAndGetDefaultLB = _this._updateLBMapsAndGetDefaultLB.bind(_this);
	        _this._updateCountry = _this._updateCountry.bind(_this);
	        _this._updateStatus = _this._updateStatus.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._updateType = _this._updateType.bind(_this);
	        _this._updateCountry = _this._updateCountry.bind(_this);
	        _this._getTitleForType = _this._getTitleForType.bind(_this);
	        _this._getTitleForCountry = _this._getTitleForCountry.bind(_this);
	        _this._getLbsForSponsor = _this._getLbsForSponsor.bind(_this);
	        return _this;
	    }
	
	    _createClass(Leaderboard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: '_getLbsForSponsor',
	        value: function _getLbsForSponsor(sponsorKey) {
	            var lbs = this.props.lbs;
	            var byId = lbs.byId,
	                bySponsor = lbs.bySponsor;
	
	            var newLbs = [];
	            if (bySponsor[sponsorKey]) {
	                _lodash2.default.forEach(bySponsor[sponsorKey], function (lbBySponsor) {
	                    if (byId[lbBySponsor]) {
	                        newLbs = _lodash2.default.unionBy(newLbs, [byId[lbBySponsor]], 'id');
	                    }
	                });
	            }
	            newLbs = _ccImports.CCUtils.sortLbs(newLbs);
	            return newLbs;
	        }
	    }, {
	        key: '_loadLbs',
	        value: function _loadLbs() {
	            var _this2 = this;
	
	            _firebase2.default.auth().currentUser && _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                var _props = _this2.props,
	                    user = _props.user,
	                    userId = _props.userId;
	
	                _this2.props.actions.fetchLBs({ accessToken: idToken }, { userId: userId, sponsorKey: _this2.props.sponsorKey }, _ccImports.DataActionTypes.GET).then(function () {
	                    _this2._updateLBMapsAndGetDefaultLB(_this2._getLbsForSponsor(_this2.props.sponsorKey), user, function (defaultLB) {
	                        if (defaultLB) {
	                            _this2.setState({ lbId: defaultLB.id, lb: defaultLB }, function () {
	                                _this2._fetchLbStatuses(defaultLB.id, 0, 20, _ccImports.DataActionTypes.GET);
	                            });
	                        }
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState(this.initialState);
	            this._loadLbs();
	        }
	    }, {
	        key: '_updateLBMapsAndGetDefaultLB',
	        value: function _updateLBMapsAndGetDefaultLB(lbs, user, callback) {
	            var types = [];
	            var countries = [];
	            var subTypes = [];
	            var statuses = [];
	
	            var defaultLB = undefined;
	
	            _lodash2.default.forEach(lbs, function (lb) {
	
	                types = _lodash2.default.union(types, [lb.type]);
	                countries = _lodash2.default.union(countries, [lb.country]);
	                subTypes = _lodash2.default.union(subTypes, [lb.subType]);
	                statuses = _lodash2.default.union(statuses, [lb.status]);
	
	                if (lb.sponsor && lb.sponsor.key && lb.sponsor.key != _ccImports.Constants.cricrushSponsor) {
	                    defaultLB = lb;
	                }
	            });
	
	            defaultLB = !defaultLB ? _lodash2.default.find(lbs, function (lb) {
	                return lb.type == 'LIFETIME';
	            }) : undefined;
	            defaultLB = !defaultLB ? _lodash2.default.find(lbs, function (lb) {
	                return lb.type == 'MONTHLY';
	            }) : undefined;
	            defaultLB = !defaultLB ? _lodash2.default.find(lbs, function (lb) {
	                return lb.type == 'WEEKLY';
	            }) : undefined;
	            defaultLB = !defaultLB ? _lodash2.default.find(lbs, function (lb) {
	                return lb.type == 'SEASON';
	            }) : undefined;
	
	            defaultLB = !defaultLB ? lbs[0] : undefined;
	
	            this.setState({
	                types: types,
	                countries: countries,
	                subTypes: subTypes,
	                statuses: statuses,
	                type: defaultLB.type,
	                country: defaultLB.country,
	                subType: defaultLB.subType,
	                status: defaultLB.status
	            }, callback(defaultLB));
	        }
	    }, {
	        key: '_fetchLbStatuses',
	        value: function _fetchLbStatuses(lbId, skip, limit, type) {
	            var _this3 = this;
	
	            //console.log("fetch lb statuses")
	            _firebase2.default.auth().currentUser && _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                var user = _this3.props.user;
	                _this3.props.actions.fetchLBStatuses({ accessToken: idToken }, { userId: user && user.id ? user.id : _ccImports.Constants.anonymousUser, lbId: lbId, skip: skip, limit: limit }, type).then(function () {
	                    _this3._updateLBStatuses(lbId);
	                }).catch(function () {
	                    _this3._updateLBStatuses(lbId);
	                });
	            });
	        }
	    }, {
	        key: '_updateLBStatuses',
	        value: function _updateLBStatuses(lbId) {
	            var userId = this.props.userId;
	            var _props$lbStatuses = this.props.lbStatuses,
	                byLbId = _props$lbStatuses.byLbId,
	                lbStatuses = _props$lbStatuses.lbStatuses;
	
	            var lbStatusesIds = byLbId[lbId];
	            var lbStatusesById = lbStatuses;
	            var data = [];
	            if (lbStatusesIds) {
	                var newLbStatuses = [];
	                _lodash2.default.forEach(lbStatusesIds, function (lbStatusesId) {
	                    newLbStatuses.push(lbStatusesById[lbStatusesId]);
	                });
	
	                //console.log(this.props.user)
	                var ownLbStatus = _lodash2.default.filter(newLbStatuses, function (status) {
	                    return status.user.id == userId;
	                });
	                if (ownLbStatus && ownLbStatus.length > 0) {
	                    data.push({
	                        data: ownLbStatus
	                    });
	                }
	
	                newLbStatuses = _lodash2.default.sortBy(newLbStatuses, ['rank']);
	
	                var winningLbStatuses = _lodash2.default.filter(newLbStatuses, { 'rewardWinning': true });
	                var notWinningLbStatuses = _lodash2.default.filter(newLbStatuses, { 'rewardWinning': false });
	
	                if (winningLbStatuses && winningLbStatuses.length > 0) {
	                    data.push({
	                        data: winningLbStatuses
	                    });
	                }
	
	                if (notWinningLbStatuses && notWinningLbStatuses.length > 0) {
	                    data.push({
	                        data: notWinningLbStatuses
	                    });
	                }
	            }
	            this.setState({ data: data });
	        }
	    }, {
	        key: '_updateSelectedLb',
	        value: function _updateSelectedLb() {
	            var _this4 = this;
	
	            var _state = this.state,
	                type = _state.type,
	                subType = _state.subType,
	                country = _state.country,
	                status = _state.status;
	            var _props2 = this.props,
	                lbs = _props2.lbs,
	                lbStatuses = _props2.lbStatuses;
	
	            var lb = undefined;
	
	            _lodash2.default.forIn(lbs.byId, function (value, key) {
	                if (value.sponsor && value.sponsor.key == _this4.props.sponsorKey && (value.country == country || value.country == 'ALL') && value.type == type && value.subType == subType && (value.status == status || value.type == _ccImports.Constants.lbType.LIFETIME)) {
	                    lb = value;
	                }
	            });
	
	            if (!lb) {
	                lb = { id: 'none' };
	            }
	
	            if (this.state.lbId != lb.id) {
	                if (!lbStatuses.byLbId[lb.id]) {
	                    this.setState({ skip: 0 }, function () {
	                        _this4._fetchLbStatuses(lb.id, _this4.state.skip, 20, _ccImports.DataActionTypes.GET);
	                    });
	                } else {
	                    this._updateLBStatuses(lb.id);
	                }
	                this.setState({ lbId: lb.id, lb: lb });
	            }
	        }
	    }, {
	        key: '_updateType',
	        value: function _updateType(type) {
	            this.setState({ type: type }, this._updateSelectedLb);
	        }
	    }, {
	        key: '_updateCountry',
	        value: function _updateCountry(country) {
	            this.setState({ country: country }, this._updateSelectedLb);
	        }
	    }, {
	        key: '_updateStatus',
	        value: function _updateStatus(status) {
	            this.setState({ status: status }, this._updateSelectedLb);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchLbStatuses(this.state.lbId, 0, this.state.skip * 20, _ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var reqStatus = this.props.reqStatus;
	
	            if (reqStatus != _ccImports.Constants.reqStatus.COM) {
	                this._fetchLbStatuses(this.state.lbId, this.state.skip + 1, 20, _ccImports.DataActionTypes.PAGINATE);
	                this.setState({ skip: this.state.skip + 1 });
	            }
	        }
	    }, {
	        key: '_getBgColor',
	        value: function _getBgColor(title) {
	            if (this.state.country == title) {
	                return '#082857';
	            } else {
	                return '#11428C';
	            }
	        }
	    }, {
	        key: '_getTitleForType',
	        value: function _getTitleForType(type) {
	            switch (type) {
	                case _ccImports.Constants.lbType.DAILY:
	                    return (0, _ccImports.strings)('daily');
	                    break;
	                case _ccImports.Constants.lbType.WEEKLY:
	                    return (0, _ccImports.strings)('weekly');
	                    break;
	                case _ccImports.Constants.lbType.MONTHLY:
	                    return (0, _ccImports.strings)('monthly');
	                    break;
	                case _ccImports.Constants.lbType.LIFETIME:
	                    return (0, _ccImports.strings)('lifetime');
	                    break;
	            }
	        }
	    }, {
	        key: '_getTitleForCountry',
	        value: function _getTitleForCountry(country, user) {
	            if (country && user && user.country && country == user.country) {
	                return (0, _ccImports.strings)('local');
	            } else {
	                return (0, _ccImports.strings)('global');
	            }
	        }
	    }, {
	        key: '_getCountryStyle',
	        value: function _getCountryStyle(index, length, country, selectedCountry) {
	            var cName = "country-heading";
	
	            if (selectedCountry == country) {
	                cName = cName + ' selected';
	            }
	
	            if (length == 1) {
	                return cName;
	            } else if (index == 0) {
	                return cName + ' left';
	            } else if (index == length - 1) {
	                return cName + ' right';
	            } else {
	                return cName;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props3 = this.props,
	                reqStatus = _props3.reqStatus,
	                lbStatuses = _props3.lbStatuses,
	                lbs = _props3.lbs,
	                type = _props3.type,
	                user = _props3.user;
	            var _state2 = this.state,
	                types = _state2.types,
	                countries = _state2.countries,
	                subTypes = _state2.subTypes,
	                statuses = _state2.statuses,
	                lb = _state2.lb,
	                status = _state2.status;
	
	
	            var data = this.state.data;
	            var selectedType = this.state.type;
	            var selectedCountry = this.state.country;
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: "flex-container", style: { flex: 1 } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container image-leader-board-background', style: { flex: 1 } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'leader-board-background-2' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container leader-board-header' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    null,
	                                    (0, _ccImports.strings)('leaderBoard')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container btn type' },
	                                types.map(function (type) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { className: 'flex-container', onClick: function onClick() {
	                                                _this5._updateType(type);
	                                            } },
	                                        _react2.default.createElement(
	                                            'h1',
	                                            { key: type, clickable: true, className: 'leader-board-type-txt ' + (selectedType == type ? 'selected' : '') },
	                                            _this5._getTitleForType(type)
	                                        )
	                                    );
	                                })
	                            ),
	                            this.state.type != _ccImports.Constants.lbType.LIFETIME && user.id != undefined && user.country != undefined && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container btn country' },
	                                countries.map(function (country, index) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { className: _this5._getCountryStyle(index, countries.length, country, selectedCountry), key: country, onClick: function onClick() {
	                                                _this5._updateCountry(country);
	                                            }, style: [{ backgroundColor: _this5._getBgColor(country) }, _this5._getCountryStyle(index, countries.length)] },
	                                        _react2.default.createElement(
	                                            'h1',
	                                            null,
	                                            _this5._getTitleForCountry(country, user)
	                                        )
	                                    );
	                                })
	                            ),
	                            this.state.type != _ccImports.Constants.lbType.LIFETIME && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container life-time' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container', style: { flex: 1, alignItems: 'flex-start' } },
	                                    status == _ccImports.Constants.lbStatus.ACTIVE && _react2.default.createElement(
	                                        'h1',
	                                        { className: 'arrow ', onClick: function onClick() {
	                                                _this5._updateStatus(_ccImports.Constants.lbStatus.COMPLETED);
	                                            }, clickable: true },
	                                        "<<"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container', style: { flex: 4 } },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { className: 'lb-date-range' },
	                                        _ccImports.CCUtils.formatDate(lb.startDate)
	                                    ),
	                                    lb.startDate && lb.endDate && _react2.default.createElement(
	                                        'h4',
	                                        { className: 'lb-date-range-divider' },
	                                        "-"
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { className: 'lb-date-range' },
	                                        _ccImports.CCUtils.formatDate(lb.endDate)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-container', style: { flex: 1, alignItems: 'flex-end', flexDirection: 'row' } },
	                                    status == _ccImports.Constants.lbStatus.COMPLETED && _react2.default.createElement(
	                                        'h1',
	                                        { className: 'arrow', onClick: function onClick() {
	                                                _this5._updateStatus(_ccImports.Constants.lbStatus.ACTIVE);
	                                            }, clickable: true },
	                                        ">>"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { flex: 1 } },
	                                _react2.default.createElement(_CCSectionList2.default, {
	                                    onEndReached: this._paginate,
	                                    onEndReachedThreshold: 1,
	                                    renderItem: function renderItem(lbStatus) {
	                                        return _react2.default.createElement(_ccImports.CCLBStatusItem, { currentUser: user, lbStatus: lbStatus, key: lbStatus.id });
	                                    },
	                                    renderSectionHeader: function renderSectionHeader(_ref2) {
	                                        var section = _ref2.section;
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { className: 'lb-divider' },
	                                            _react2.default.createElement('img', { src: _ccImports.images.icons.lb_divider, style: { width: '80%', resizeMode: 'contain' } })
	                                        );
	                                    },
	                                    sections: this.state.data,
	                                    ListFooterComponent: _CCUIUtils.CCUIUtils.getListFooter(reqStatus, type, this.state.data),
	                                    ListEmptyComponent: _CCUIUtils.CCUIUtils.getEmptyListItem(reqStatus)
	
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Leaderboard;
	}(_react.Component);
	
	Leaderboard.propTypes = {
	    sponsorKey: _propTypes2.default.string,
	    onBackPress: _propTypes2.default.func
	};
	Leaderboard.defaultProps = {
	    sponsorKey: _ccImports.Constants.cricrushSponsor,
	    onBackPress: function onBackPress() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.user.user,
	        userId: state.user.user.id ? state.user.user.id : _ccImports.Constants.anonymousUser,
	        lbs: state.leaderBoard.lbs,
	        lbStatuses: state.leaderBoard.lbStatuses,
	        reqStatus: state.leaderBoard.reqStatus,
	        error: state.leaderBoard.error,
	        random: state.leaderBoard.random,
	        type: state.leaderBoard.type
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Leaderboard);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Leaderboard = undefined;
	
	var _Leaderboard = __webpack_require__(412);
	
	var _Leaderboard2 = _interopRequireDefault(_Leaderboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Leaderboard = _Leaderboard2.default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _reactRouterDom = __webpack_require__(36);
	
	__webpack_require__(474);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leagues = function (_Component) {
	    _inherits(Leagues, _Component);
	
	    function Leagues(props) {
	        _classCallCheck(this, Leagues);
	
	        var _this = _possibleConstructorReturn(this, (Leagues.__proto__ || Object.getPrototypeOf(Leagues)).call(this, props));
	
	        _this.state = {
	            leagueGroups: [],
	            matchId: undefined
	        };
	        _this._fetchLeagues = _this._fetchLeagues.bind(_this);
	        _this._autoRefresh = _this._autoRefresh.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        _this._updateGrouping = _this._updateGrouping.bind(_this);
	
	        _this._entryCountPressed = _this._entryCountPressed.bind(_this);
	        _this._leaguePressed = _this._leaguePressed.bind(_this);
	        _this._infoPressed = _this._infoPressed.bind(_this);
	        _this._getMatchId = _this._getMatchId.bind(_this);
	        return _this;
	    }
	
	    _createClass(Leagues, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._fetchLeagues(this.props, _ccImports.DataActionTypes.GET);
	        }
	    }, {
	        key: '_getMatchId',
	        value: function _getMatchId(props) {
	            var matchId = undefined;
	            var matchesByStatus = props.matchesByStatus;
	
	            var matchIdFromUrl = props.match ? props.match.params ? props.match.params.matchId : undefined : undefined;
	            if (matchIdFromUrl) {
	                return matchIdFromUrl;
	            } else {
	                var liveMatches = matchesByStatus[_ccImports.Constants.matchStatus.STARTED];
	                var upcomingMatches = matchesByStatus[_ccImports.Constants.matchStatus.NOT_STARTED];
	                var completedMatches = matchesByStatus[_ccImports.Constants.matchStatus.COMPLETED];
	                if (liveMatches && liveMatches.length > 0) {
	                    matchId = liveMatches[0];
	                } else if (upcomingMatches && upcomingMatches.length > 0) {
	                    matchId = upcomingMatches[0];
	                } else if (completedMatches && completedMatches.length > 0) {
	                    matchId = completedMatches[0];
	                } else {
	                    matchId = undefined;
	                }
	            }
	            return matchId;
	        }
	    }, {
	        key: '_fetchLeagues',
	        value: function _fetchLeagues(props, type) {
	            var _props = this.props,
	                actions = _props.actions,
	                userId = _props.userId,
	                leaguesPages = _props.leaguesPages;
	            //const matchId = props.navigation.state.params.matchId;
	
	            var matchId = this._getMatchId(props);
	            if (matchId) {
	                actions.getMatch(matchId, type);
	                _ccImports.FirebaseUtils.getIdTokenWhenAuthChanged(function (idToken) {
	                    var page = leaguesPages[matchId] == undefined ? 0 : leaguesPages[matchId];
	                    var skip = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? 0 : page;
	                    var limit = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? page * 20 : 20;
	
	                    /*if( userId){
	                        actions.getEntriesByUserId(idToken,userId,skip,limit,type);
	                    }*/
	
	                    actions.getLeaguesByMatchId(idToken, matchId, userId, skip, limit, type);
	                });
	            }
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchLeagues(this.props, _ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchLeagues(this.props, _ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var leaguesReqStatus = this.props.leaguesReqStatus;
	
	            if (leaguesReqStatus != _ccImports.Constants.reqStatus.FAI && leaguesReqStatus != _ccImports.Constants.reqStatus.COM) {
	                this._fetchLeagues(this.props, _ccImports.DataActionTypes.PAGINATE);
	            }
	        }
	    }, {
	        key: '_updateGrouping',
	        value: function _updateGrouping(props) {
	            var matchId = this._getMatchId(this.props);
	            var leaguesByMatch = props.leaguesByMatch,
	                leaguesById = props.leaguesById,
	                matchesById = props.matchesById;
	
	
	            var leagueIds = leaguesByMatch[matchId];
	            var leaguesForMatch = [];
	            var match = matchesById[matchId];
	
	            //TODO : temp workaround
	            if (match == undefined || matchId == undefined) {
	                return [];
	            }
	
	            _lodash2.default.forEach(leagueIds, function (leagueId) {
	                var league = leaguesById[leagueId];
	                if (match.status == _ccImports.Constants.matchStatus.COMPLETED) {
	                    leaguesForMatch.push(league);
	                } else {
	                    if (league.status == _ccImports.Constants.leagueStatus.NOT_STARTED || league.status == _ccImports.Constants.leagueStatus.LIVE) {
	                        leaguesForMatch.push(league);
	                    }
	                }
	            });
	
	            var groupedLeagues = _lodash2.default.groupBy(leaguesForMatch, function (league) {
	                return league.sponsor.key == null || league.sponsor.key == undefined ? 'none' : league.sponsor.key;
	            });
	
	            var leagueGroups = [];
	
	            _lodash2.default.forIn(groupedLeagues, function (value, key) {
	                var sponsor = props.sponsorsByKey[key];
	                var sortedLeagues = _lodash2.default.orderBy(value, [function (league) {
	                    return league.status == _ccImports.Constants.leagueStatus.NOT_STARTED ? 1 : 0;
	                }, function (league) {
	                    return new Date(league.createdDate);
	                }], ['desc', 'asc']);
	                leagueGroups.push({
	                    sponsor: sponsor,
	                    priority: sponsor && sponsor.priority ? sponsor.priority : 100,
	                    leagues: sortedLeagues,
	                    matchCompleted: match.status == _ccImports.Constants.matchStatus.COMPLETED
	                });
	            });
	
	            leagueGroups = _lodash2.default.orderBy(leagueGroups, [function (leagueGroup) {
	                return leagueGroup.priority;
	            }], ['asc']);
	            //this.setState({leagueGroups});
	            return leagueGroups;
	        }
	    }, {
	        key: '_entryCountPressed',
	        value: function _entryCountPressed(league) {
	            _ccImports.CCAppEventLogger.logAppEvent("EntryCountPressed", {
	                league_type: league.type,
	                league_category: league.category,
	                match_key: league.match.key,
	                league_status: league.status,
	                loggedIn: _ccImports.CCUtils.isLoggedIn(this.props.user)
	            });
	            this.props.actions.openSingleLeagueModal(league);
	        }
	    }, {
	        key: '_leaguePressed',
	        value: function _leaguePressed(league) {
	            var actions = this.props.actions;
	
	            _ccImports.CCAppEventLogger.logAppEvent("OpenLeagueClicked", {
	                league_type: league.type,
	                league_category: league.category,
	                match_key: league.match.key,
	                league_status: league.status,
	                loggedIn: _ccImports.CCUtils.isLoggedIn(this.props.user)
	            });
	            if (league.status == _ccImports.Constants.leagueStatus.NOT_STARTED) {
	                switch (league.category) {
	                    case _ccImports.Constants.leagueCategory.PREDICTION:
	                    case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                        actions.openPredictionEntryCreationModal(league);
	                        break;
	                    case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                        actions.openDreamTeamEntryCreationModal(league);
	                        break;
	                }
	            } else {
	                actions.openSingleLeagueModal(league);
	            }
	        }
	    }, {
	        key: '_infoPressed',
	        value: function _infoPressed(sponsor) {
	            this.props.actions.openSponsorDetailsModal(sponsor);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            //var matchId = this._getMatchId();
	            if (_ccImports.CCUtils.userUpdated(this.props.user, nextProps.user)) {
	                this._fetchLeagues(nextProps, _ccImports.DataActionTypes.GET, 0);
	            }
	            if (Object.keys(nextProps.matchesById).length != Object.keys(this.props.matchesById).length) {
	                this._fetchLeagues(nextProps, _ccImports.DataActionTypes.GET, 0);
	            }
	
	            if (this.props.navMatchId != nextProps.navMatchId) {
	                this._fetchLeagues(nextProps, _ccImports.DataActionTypes.GET, 0);
	            }
	            /*if (nextProps.leaguesRandom != this.props.leaguesRandom) {
	                this._updateGrouping(nextProps);
	            }*/
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                leaguesById = _props2.leaguesById,
	                leaguesReqStatus = _props2.leaguesReqStatus,
	                matchesById = _props2.matchesById,
	                actions = _props2.actions,
	                leaguesByMatch = _props2.leaguesByMatch,
	                leaguesType = _props2.leaguesType,
	                user = _props2.user;
	
	            var matchId = this._getMatchId(this.props);
	            var match = matchesById[matchId];
	            var leagues = leaguesByMatch[matchId] ? leaguesByMatch[matchId] : [];
	            var leagueGroups = this._updateGrouping(this.props);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container leagues_container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'leagues_container_2' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'leagues-list' },
	                            match != undefined && _react2.default.createElement(_ccImports.SimpleMatchDetails, { showPlay: false, ccMatch: match }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'leagues_scroll flex-container' },
	                                matchId && leagues.length == 0 ? _react2.default.createElement('div', null) : _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    leagueGroups.map(function (leagueGroup) {
	                                        return _react2.default.createElement(_ccImports.CCLeaguesGroup, { currUser: user,
	                                            entryCountPressed: _this2._entryCountPressed,
	                                            leaguePressed: _this2._leaguePressed,
	                                            infoPressed: _this2._infoPressed,
	                                            sponsorBannerPressed: _this2._infoPressed,
	                                            leagueGroup: leagueGroup,
	                                            key: leagueGroup.sponsor });
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Leagues;
	}(_react.Component);
	
	Leagues.propTypes = {};
	Leagues.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        storedDetails: state.storedDetails,
	        fireBaseUser: state.fireBaseUser,
	
	        user: state.user.user,
	        userId: state.user.user.id ? state.user.user.id : _ccImports.Constants.anonymousUser,
	
	        matchesById: state.matches.byId,
	        matchesByStatus: state.matches.byStatus,
	        matchesReqStatus: state.matches.reqStatus,
	        matchesRandom: state.matches.random,
	
	        leagues: state.leagues,
	        leaguesById: state.leagues.byId,
	        leaguesByMatch: state.leagues.byMatch,
	        leaguesReqStatus: state.leagues.reqStatus,
	        leaguesPages: state.leagues.pages,
	        leaguesType: state.leagues.type,
	        leaguesRandom: state.leagues.random,
	
	        navMatchId: state.navigation.matchId,
	
	        sponsorsByKey: state.sponsors.byKey
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})((0, _reactRouterDom.withRouter)(Leagues));

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _ccImports2 = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CCListView = __webpack_require__(39);
	
	var _CCListView2 = _interopRequireDefault(_CCListView);
	
	__webpack_require__(475);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notifications = function (_Component) {
	    _inherits(Notifications, _Component);
	
	    function Notifications(props) {
	        _classCallCheck(this, Notifications);
	
	        var _this = _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call(this, props));
	
	        _this.state = {
	            skip: 0,
	            screen: 'ntfns',
	            claimNtfn: {},
	            reqPending: false
	        };
	
	        _this._fetchNotifications = _this._fetchNotifications.bind(_this);
	        _this._autoRefresh = _this._autoRefresh.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        _this._claimPressed = _this._claimPressed.bind(_this);
	        return _this;
	    }
	
	    _createClass(Notifications, [{
	        key: '_fetchNotifications',
	        value: function _fetchNotifications(type) {
	            var _this2 = this;
	
	            if (this.state.reqPending == true) return;
	            var _props = this.props,
	                userId = _props.userId,
	                actions = _props.actions,
	                pages = _props.pages;
	
	            this.setState({ reqPending: true }, function () {
	
	                var page = pages[userId] == undefined ? 0 : pages[userId];
	                var skip = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? 0 : page;
	                var limit = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? page * 20 : 20;
	
	                if (userId) {
	                    actions.fetchNotifications(userId, skip, limit, type).then(function () {
	                        _this2.setState({ reqPending: false });
	                    }).catch(function () {
	                        _this2.setState({ reqPending: false });
	                    });
	                }
	            });
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchNotifications(_ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchNotifications(_ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var reqStatus = this.props.reqStatus;
	
	            if (reqStatus != _ccImports2.Constants.reqStatus.FAI && reqStatus != _ccImports2.Constants.reqStatus.COM) {
	                this._fetchNotifications(_ccImports.DataActionTypes.PAGINATE);
	            }
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("Notifications");
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: '_claimPressed',
	        value: function _claimPressed(claimNtfn) {
	            var claimPressed = this.props.claimPressed;
	
	            claimPressed({ claimNtfn: claimNtfn });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.userId) {
	                this._fetchNotifications(_ccImports.DataActionTypes.GET);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                reqStatus = _props2.reqStatus,
	                type = _props2.type,
	                byId = _props2.byId,
	                byUserId = _props2.byUserId,
	                userId = _props2.userId;
	            var screen = this.state.screen;
	
	
	            var ntfns = byUserId[userId] ? byUserId[userId] : [];
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: "flex-container", style: { flex: 1, flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { alignItems: 'center', justifyContent: 'center', marginBottom: 10, marginTop: 10 } },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'notification-title' },
	                            ' ',
	                            (0, _ccImports.strings)('notifications')
	                        )
	                    ),
	                    ntfns && ntfns.length > 0 ? _react2.default.createElement(_CCListView2.default, { data: ntfns, onEndReachedThreshold: 2, onEndReached: this._paginate,
	                        endReached: reqStatus == _ccImports2.Constants.reqStatus.COM || reqStatus == _ccImports2.Constants.reqStatus.FAI,
	                        renderItem: function renderItem(ntfnId) {
	                            var ntfn = byId[ntfnId];
	                            return _react2.default.createElement(_ccImports.CCNotificationItem, { userId: userId, onClaim: function onClaim() {
	                                    _this3._claimPressed(ntfn);
	                                }, notification: ntfn, key: ntfn.id });
	                        } }) : _ccImports2.CCUIUtils.getEmptyListItem(reqStatus)
	                )
	            );
	        }
	    }]);
	
	    return Notifications;
	}(_react.Component);
	
	Notifications.propTypes = {
	    claimPressed: _propTypes2.default.func
	};
	Notifications.defaultProps = {
	    claimPressed: function claimPressed() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        byId: state.notifications.byId,
	        byUserId: state.notifications.byUserId,
	
	        pages: state.notifications.pages,
	        userId: state.user.user.id,
	        random: state.notifications.random,
	        type: state.notifications.type,
	        reqStatus: state.notifications.reqStatus
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Notifications);

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notifications = undefined;
	
	var _Notifications = __webpack_require__(415);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Notifications = _Notifications2.default;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(476);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './prediction_entry_creation.css'
	
	
	// import './prediction_entry_creation_320.css'
	
	var PredictionEntryCreation = function (_Component) {
	    _inherits(PredictionEntryCreation, _Component);
	
	    function PredictionEntryCreation(props) {
	        _classCallCheck(this, PredictionEntryCreation);
	
	        var _this = _possibleConstructorReturn(this, (PredictionEntryCreation.__proto__ || Object.getPrototypeOf(PredictionEntryCreation)).call(this, props));
	
	        _this.initialState = {
	            league: {},
	            prediction: undefined,
	            error: undefined,
	            created: false
	        };
	        _this.state = _this.initialState;
	
	        _this._updateLeague = _this._updateLeague.bind(_this);
	        _this._getTitle = _this._getTitle.bind(_this);
	        _this._getInputLabel = _this._getInputLabel.bind(_this);
	        _this._validate = _this._validate.bind(_this);
	        _this._isSubmitDisabled = _this._isSubmitDisabled.bind(_this);
	        _this._createEntry = _this._createEntry.bind(_this);
	        _this._onAck = _this._onAck.bind(_this);
	        return _this;
	    }
	
	    _createClass(PredictionEntryCreation, [{
	        key: '_updateLeague',
	        value: function _updateLeague(league) {
	            this.setState({ league: league, error: undefined });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //console.log("prediction entry creation loaded -----")
	            var league = this.props.league;
	
	            if (league) {
	                var leagueCache = this.props.cache[league.id];
	                if (leagueCache) {
	                    this.setState(leagueCache);
	                } else {
	                    this._updateLeague(league);
	                }
	            }
	        }
	    }, {
	        key: '_getTitle',
	        value: function _getTitle(league) {
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return (0, _ccImports.strings)('live_prediction_leagues');
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return (0, _ccImports.strings)('target_prediction_leagues');
	
	                    break;
	                default:
	                    return (0, _ccImports.strings)('target_prediction_leagues');
	            }
	        }
	    }, {
	        key: '_getInputLabel',
	        value: function _getInputLabel(league) {
	            var qps = league.quickPredictionDetails;
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.QUICK_PREDICTION:
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    return (0, _ccImports.strings)('predict_what_message', { teamName: qps.team.toUpperCase(), startOver: qps.startOver, endOver: qps.endOver });
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    return (0, _ccImports.strings)('predict_score');
	                    break;
	                default:
	                    return (0, _ccImports.strings)('predict_score');
	            }
	        }
	    }, {
	        key: '_validate',
	        value: function _validate(prediction) {
	            var league = this.state.league;
	            if (prediction < 0) {
	                return (0, _ccImports.strings)('runs_cannot_be_negative_value');
	            }
	            if (prediction > 1000) {
	                return (0, _ccImports.strings)('please_select_valid_score');
	            }
	            return;
	        }
	    }, {
	        key: '_isSubmitDisabled',
	        value: function _isSubmitDisabled() {
	            return this.state.prediction == undefined;
	        }
	    }, {
	        key: '_createEntry',
	        value: function _createEntry() {
	            var _this2 = this;
	
	            var _props = this.props,
	                userId = _props.userId,
	                user = _props.user;
	
	            if (userId) {
	                var league = this.state.league;
	                _ccImports.CCAppEventLogger.logAppEvent('CreateEntryClicked', { 'league_category': league.category,
	                    'league_type': league.type,
	                    'match_key': league.match.key,
	                    loggedIn: true
	                });
	
	                var entry = {};
	                entry.prediction = this.state.prediction;
	                entry.creator = user;
	                entry.league = league;
	                entry.coins = league.coinsPerEntry;
	
	                _app2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                    _this2.props.actions.createEntry(entry, { userId: userId, accessToken: idToken }).then(function () {
	                        var _props2 = _this2.props,
	                            entriesType = _props2.entriesType,
	                            entriesReqStatus = _props2.entriesReqStatus,
	                            entriesError = _props2.entriesError;
	
	
	                        if (entriesType == _ccImports.DataActionTypes.CREATE) {
	                            if (entriesReqStatus == _ccImports.Constants.reqStatus.FAI) {
	                                _this2.setState({ error: entriesError });
	                            } else {
	                                _this2.setState({ error: undefined, created: true });
	                                //this.props.actions.getLeague(league.id,{accessToken:idToken}, DataAT.AUTO_REFRESH);
	                                //this.props.actions.getUser({userId : userId});
	                            }
	                        }
	                    });
	                });
	            } else {
	                var _league = this.state.league;
	                _ccImports.CCAppEventLogger.logAppEvent('CreateEntryClicked', { 'league_category': _league.category,
	                    'league_type': _league.type,
	                    'match_key': _league.match.key,
	                    loggedIn: false
	                });
	                this.props.actions.addToCache(_league.id, this.state);
	                this.props.openSignIn();
	            }
	        }
	    }, {
	        key: '_onAck',
	        value: function _onAck() {
	            var _this3 = this;
	
	            this.props.actions.removeFromCache(this.state.league.id);
	            this.setState(this.initialState, function () {
	                _this3.props.onAck();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var prediction = this.state.prediction;
	            var _props3 = this.props,
	                entriesType = _props3.entriesType,
	                entriesReqStatus = _props3.entriesReqStatus;
	
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.created == false ? _react2.default.createElement(
	                        'div',
	                        { className: 'prediction_container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'prediction_title_container' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'title' },
	                                this._getTitle(this.state.league)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'score_info_title' },
	                            (0, _ccImports.strings)('predict_the_target_score_of_the_match')
	                        ),
	                        _react2.default.createElement(_ccImports.CCInput, { value: prediction, customValidate: this._validate, required: true, immediate: true, onEndEditing: function onEndEditing(prediction) {
	                                _this4.setState({ prediction: prediction });
	                            }, labelProps: { numberOfLines: 2 }, type: "number", label: this._getInputLabel(this.state.league) }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'prediction_btn_container' },
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'btn-h3', titleClassName: 'prediction-btn-txt', analytics: { event: 'ManualSignIn' }, title: (0, _ccImports.strings)('submit'), style: { marginTop: 5 },
	                                onPress: this._createEntry, loading: entriesType == _ccImports.DataActionTypes.CREATE && entriesReqStatus == _ccImports.Constants.reqStatus.PEN, disabled: this._isSubmitDisabled() })
	                        ),
	                        this.state.error && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'target-prediction-entry-creation-error' },
	                                this.state.error
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_ccImports.CCAck, { buttonText: (0, _ccImports.strings)('close'), title: this._getTitle(this.state.league), detail: (0, _ccImports.strings)('your_entry_created'), type: "success", onAck: this._onAck })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PredictionEntryCreation;
	}(_react.Component);
	
	PredictionEntryCreation.propTypes = {
	    openSignIn: _propTypes2.default.func,
	    league: _propTypes2.default.object,
	    onAck: _propTypes2.default.func
	};
	PredictionEntryCreation.defaultProps = {
	    openSignIn: function openSignIn() {},
	    onAck: function onAck() {},
	    league: undefined
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	
	        user: state.user.user,
	        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,
	
	        entries: state.entries,
	        entriesById: state.entries.byId,
	        entriesByLeague: state.entries.byLeague,
	        entriesByCreatorId: state.entries.byCreatorId,
	        entriesPages: state.entries.pages,
	        entriesReqStatus: state.entries.reqStatus,
	        entriesError: state.entries.error,
	        entriesType: state.entries.type,
	
	        cache: state.cache.cache
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(PredictionEntryCreation);

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PredictionEntryCreation = undefined;
	
	var _PredictionEntryCreation = __webpack_require__(417);
	
	var _PredictionEntryCreation2 = _interopRequireDefault(_PredictionEntryCreation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PredictionEntryCreation = _PredictionEntryCreation2.default;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	__webpack_require__(477);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './Profile.css'
	
	
	var Profile = function (_Component) {
	    _inherits(Profile, _Component);
	
	    function Profile(props) {
	        _classCallCheck(this, Profile);
	
	        var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	        _this.state = {
	            displayName: '',
	            email: '',
	            user: {},
	            displayNameErr: null,
	            emailErr: null,
	            dpLoading: false,
	            loading: false,
	            screen: 'profile'
	
	        };
	        _this._validateAndUpdateDisplayName = _this._validateAndUpdateDisplayName.bind(_this);
	        _this._reAuthenticate = _this._reAuthenticate.bind(_this);
	        _this._uploadProfilePicture = _this._uploadProfilePicture.bind(_this);
	        _this._loadValues = _this._loadValues.bind(_this);
	        _this._updateDetails = _this._updateDetails.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Profile, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /*BackHandler.addEventListener('hardwareBackPress', () => {
	                if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
	                    this.props.actions.goBack();
	                    return true;
	                }
	                return false;
	            });*/
	        }
	    }, {
	        key: '_loadValues',
	        value: function _loadValues(user) {
	            this.setState({
	                email: user.email,
	                displayName: user.displayName
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var user = this.props.user.user;
	            this._loadValues(user);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nexProps) {
	            if (_ccImports.CCUtils.userUpdated(this.props.user, nexProps.user)) {
	                this._loadValues(nexProps.user.user);
	            }
	        }
	    }, {
	        key: '_uploadProfilePicture',
	        value: function _uploadProfilePicture() {
	            var _this2 = this;
	
	            this.setState({ dpLoading: true });
	            _ccImports.CCAppEventLogger.logAppEvent("ProfilePicUpdateClicked", {});
	            _ccImports.ImageUtils.openProfileImagePicker(function (uri, response) {
	                _this2.setState({ dpLoading: true });
	                _ccImports.ImageUtils.uploadProfilePicture(_this2.props.user.user.id, uri, response, function (success) {
	                    _ccImports.ImageUtils.getProfilePicThumbnail(_this2.props.user.user.id, function (thumbnailurl) {
	                        _this2.props.actions.updateUser(_this2.props.user.user.id, { imageUrl: success.downloadURL, thumbnailUrl: thumbnailurl });
	                        _this2.setState({ dpLoading: false });
	                    }, function () {
	                        _this2.props.actions.updateUser(_this2.props.user.user.id, { imageUrl: success.downloadURL });
	                        _this2.setState({ dpLoading: false });
	                    });
	                    _ccImports.CCAppEventLogger.logAppEvent("ProfilePicUpdateCompleted", {});
	                }, function (err) {
	                    _this2.setState({ dpLoading: false });
	                    _ccImports.CCAppEventLogger.logAppEvent("ProfilePicUpdateFailed", {});
	                });
	            });
	        }
	    }, {
	        key: '_validateAndUpdateDisplayName',
	        value: function _validateAndUpdateDisplayName(value, callback) {
	            _ccImports.CCAppEventLogger.logAppEvent("DisplayNameUpdateClicked", {});
	            _ccImports.FirebaseUtils.updateDisplayName(value);
	            this.props.actions.updateUser(this.props.user.user.id, { displayName: value }).then(function () {
	                callback && callback();
	            });
	        }
	
	        /*_validateAndUpdateEmail(value, callback) {
	            CCAppEventLogger.logAppEvent("EmailUpdateClicked",{});
	            this.props.actions.openReAuthModal({reauth : true,callback:()=>{
	                    FirebaseUtils.updateEmail(value, (err)=>{
	                        if(err){
	                            this.setState({emailErr : err});
	                        }else {
	                            callback && callback();
	                            this.props.actions.updateUser(this.props.user.user.id, {email : value});
	                            CCAppEventLogger.logAppEvent("EmailUpdateCompleted",{});
	                        }
	                    });
	                }});
	        }
	        */
	
	    }, {
	        key: '_reAuthenticate',
	        value: function _reAuthenticate() {
	            this.setState({ screen: 'reAuth' });
	        }
	    }, {
	        key: '_onReAuthCompleted',
	        value: function _onReAuthCompleted() {
	            var _this3 = this;
	
	            var value = this.state.email;
	            _ccImports.FirebaseUtils.updateEmail(value, function (err) {
	                if (err) {
	                    _this3.setState({ emailErr: err });
	                } else {
	                    _this3.setState({ loading: false });
	                    _this3.props.actions.updateUser(_this3.props.user.user.id, { email: value });
	                    _ccImports.CCAppEventLogger.logAppEvent("EmailUpdateCompleted", {});
	                }
	            });
	            this.setState({ screen: 'profile' });
	        }
	    }, {
	        key: '_updateDetails',
	        value: function _updateDetails() {
	            var _this4 = this;
	
	            this.setState({ loading: true });
	            if (this.props.user.user.displayName != this.state.displayName) {
	                this._validateAndUpdateDisplayName(this.state.displayName, function () {
	                    _this4.setState({ loading: false });
	                });
	            }
	            if (this.props.user.user.email != this.state.email) {
	                this._reAuthenticate();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var user = this.props.user.user;
	            var screen = this.state.screen;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'sidebar-sub-background' },
	                user.id && true && _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container', style: { resizeMode: 'cover' } },
	                    screen == 'profile' && _react2.default.createElement(
	                        'div',
	                        { style: { flex: 1 } },
	                        _react2.default.createElement(_ccImports.CCMoreModalItem, { dpLoading: this.state.dpLoading, dpEditable: true,
	                            onDpPress: this._uploadProfilePicture, type: 'user',
	                            user: user }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'profile-bg2' },
	                            _react2.default.createElement(_ccImports.CCInput, { type: 'text', style: { color: '#ffffff' }, value: this.state.displayName,
	                                immediate: true, onChange: function onChange(e) {
	                                    return _this5.onTodoChange(e.target.value);
	                                },
	                                label: (0, _ccImports.strings)('display_name'), onEndEditing: function onEndEditing(displayName) {
	                                    _this5.setState({ displayName: displayName });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCInput, { editable: !this.props.user.user.emailVerified, value: this.state.email,
	                                immediate: true, label: (0, _ccImports.strings)('email_title'), type: "email",
	                                onEndEditing: function onEndEditing(email) {
	                                    _this5.setState({ email: email });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCButton, { className: 'profile-btn', titleClassName: 'text',
	                                loading: this.state.loading, title: (0, _ccImports.strings)('save'),
	                                style: { marginTop: 20 }, onPress: this._updateDetails })
	                        )
	                    ),
	                    screen == 'reAuth' && _react2.default.createElement(_ccImports.ReAuth, { onReAuthCompleted: function onReAuthCompleted() {
	                            _this5._onReAuthCompleted();
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return Profile;
	}(_react.Component);
	
	Profile.propTypes = {};
	Profile.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Profile);

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Profile = undefined;
	
	var _Profile = __webpack_require__(419);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Profile = _Profile2.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReAuth = function (_Component) {
	    _inherits(ReAuth, _Component);
	
	    function ReAuth(props) {
	        _classCallCheck(this, ReAuth);
	
	        var _this = _possibleConstructorReturn(this, (ReAuth.__proto__ || Object.getPrototypeOf(ReAuth)).call(this, props));
	
	        _this.initialState = {
	            showSignIn: false,
	
	            fbLoading: false,
	            gglLoading: false,
	            emailLoading: false,
	
	            error: null,
	
	            password: '',
	
	            showGgl: false,
	            showPwd: false,
	            showFb: false
	        };
	        _this.state = _this.initialState;
	
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._showSignUp = _this._showSignUp.bind(_this);
	        _this._showSignIn = _this._showSignIn.bind(_this);
	
	        _this._toggleLoading = _this._toggleLoading.bind(_this);
	
	        _this._fbReAuth = _this._fbReAuth.bind(_this);
	        _this._gglReAuth = _this._gglReAuth.bind(_this);
	        _this._emailReAuth = _this._emailReAuth.bind(_this);
	        _this._reAuthCallback = _this._reAuthCallback.bind(_this);
	        _this._reAuthErr = _this._reAuthErr.bind(_this);
	        return _this;
	    }
	
	    _createClass(ReAuth, [{
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({
	                fbLoading: false,
	                gglLoading: false,
	                emailLoading: false,
	                error: null
	            });
	            this.props.actions.closeModal("ReAuth");
	        }
	    }, {
	        key: '_showSignUp',
	        value: function _showSignUp() {
	            this.setState({ showSignIn: false });
	        }
	    }, {
	        key: '_showSignIn',
	        value: function _showSignIn() {
	            this.setState({ showSignIn: true });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this._setupGoogleSignin();
	
	            var providerData = _app2.default.auth().currentUser.providerData;
	            if (providerData) {
	                _lodash2.default.forEach(providerData, function (data) {
	                    if (data.providerId == 'facebook.com') {
	                        _this2.setState({ showFb: true });
	                    } else if (data.providerId == 'google.com') {
	                        _this2.setState({ showGgl: true });
	                    } else if (data.providerId == 'password') {
	                        _this2.setState({ showPwd: true });
	                    }
	                });
	            }
	        }
	    }, {
	        key: '_setupGoogleSignin',
	        value: function _setupGoogleSignin() {
	            /*GoogleSignin.hasPlayServices({
	                //load prod configs
	                autoResolve: true
	            }).then(() => {
	                GoogleSignin.configure(CricrushConfig.googleSigninConfig);
	                const user = GoogleSignin.currentUserAsync();
	            })
	                .catch((err) => {
	                    //console.log(err)
	                })*/
	        }
	    }, {
	        key: '_toggleLoading',
	        value: function _toggleLoading(type, value) {
	            switch (type) {
	                case 'fb':
	                    this.setState({ fbLoading: value });
	                    break;
	                case 'ggl':
	                    this.setState({ gglLoading: value });
	                    break;
	                case 'email':
	                    this.setState({ emailLoading: value });
	                    break;
	                default:
	                    this.setState({ fbLoading: value, gglLoading: value, emailLoading: value });
	            }
	        }
	    }, {
	        key: '_reAuthCallback',
	        value: function _reAuthCallback() {
	            /*var modal = _.find(this.props.modals.modals,(modal)=>{return modal.name=='ReAuth'})
	            this.props.actions.closeModal('ReAuth');
	            modal && modal.callback && modal.callback();*/
	            this.props.onReAuthCompleted();
	        }
	    }, {
	        key: '_reAuthErr',
	        value: function _reAuthErr(err) {
	            this.setState({ error: _ccImports.FirebaseUtils.getFirebaseError(err) });
	        }
	    }, {
	        key: '_fbReAuth',
	        value: function _fbReAuth() {
	            this._toggleLoading('fb', true);
	            /* LoginManager.logInWithReadPermissions(['public_profile', 'email', 'user_friends']).then(
	                 function (result) {
	                     if (result.isCancelled) {
	                      } else {
	                         AccessToken.getCurrentAccessToken().then(
	                             (data) => {
	                                 FirebaseUtils.reAuthFb(data.accessToken,this._reAuthCallback, this._reAuthErr);
	                             }
	                         )
	                     }
	                 }.bind(this),
	                 function (error) {
	                     this._toggleLoading('fb', false);
	                 }
	             );*/
	        }
	    }, {
	        key: '_gglReAuth',
	        value: function _gglReAuth() {
	            this._toggleLoading('ggl', true);
	            /*GoogleSignin.signIn()
	                .then((user) => {
	                    FirebaseUtils.reAuthGgl(user.idToken,this._reAuthCallback, this._reAuthErr);
	                })
	                .catch((err) => {
	                    this._toggleLoading('ggl', false);
	                })
	                .done();*/
	        }
	    }, {
	        key: '_emailReAuth',
	        value: function _emailReAuth() {
	            this._toggleLoading('email', true);
	            _ccImports.FirebaseUtils.reAuthEmail(this.props.user.user.email, this.state.password, this._reAuthCallback, this._reAuthErr);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    flexDirection: 'row',
	                                    alignItems: 'center',
	                                    justifyContent: 'center',
	                                    marginTop: 20
	                                } },
	                            _react2.default.createElement(
	                                'h1',
	                                {
	                                    onClick: this._showSignUp },
	                                (0, _ccImports.strings)('reauth_modal_title')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '90%', marginTop: 15 } },
	                            this.state.showFb == true && _react2.default.createElement(_ccImports.CCButton, { type: "fb_reauth", onPress: this._fbReAuth,
	                                loading: this.state.fbLoading }),
	                            this.state.showGgl == true && _react2.default.createElement(_ccImports.CCButton, { type: "ggl_reauth", style: { marginTop: 5 }, onPress: this._gglReAuth,
	                                loading: this.state.gglLoading })
	                        ),
	                        _react2.default.createElement('div', { style: {
	                                width: '90%',
	                                marginTop: 15,
	                                alignItems: 'center',
	                                justifyContent: "center"
	                            } }),
	                        this.state.showPwd == true && _react2.default.createElement(
	                            'div',
	                            { style: { width: '90%', marginTop: 5, marginBottom: 20 } },
	                            _react2.default.createElement(_ccImports.CCInput, { immediate: true, label: (0, _ccImports.strings)('password'), type: "password", onEndEditing: function onEndEditing(password) {
	                                    //console.log(password);
	                                    _this3.setState({ password: password });
	                                } }),
	                            _react2.default.createElement(_ccImports.CCButton, { title: (0, _ccImports.strings)('confirm'), style: { marginTop: 5 },
	                                onPress: this._emailReAuth, loading: this.state.emailLoading })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'h1',
	                            { style: { width: '80%', textAlign: 'center', color: _ccImports.colors.theme.txt_color4 } },
	                            this.state.error
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReAuth;
	}(_react.Component);
	
	ReAuth.propTypes = {
	    onReAuthCompleted: _propTypes2.default.func
	};
	ReAuth.defaultProps = {
	    onReAuthCompleted: function onReAuthCompleted() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(ReAuth);

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReAuth = undefined;
	
	var _ReAuth = __webpack_require__(421);
	
	var _ReAuth2 = _interopRequireDefault(_ReAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ReAuth = _ReAuth2.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Settings = function (_Component) {
	    _inherits(Settings, _Component);
	
	    function Settings(props) {
	        _classCallCheck(this, Settings);
	
	        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	
	        _this.state = {
	            recentMatches: [],
	            upcomingMatches: [],
	            upcomingLeagues: [],
	            user: {},
	            displayNameErr: null,
	            emailErr: null
	        };
	        return _this;
	    }
	
	    _createClass(Settings, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /*BackHandler.addEventListener('hardwareBackPress', () => {
	                if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
	                    this.props.actions.goBack();
	                    return true;
	                }
	                return false;
	            });*/
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user.user;
	            return _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return Settings;
	}(_react.Component);
	
	Settings.propTypes = {};
	Settings.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Settings);

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Settings = undefined;
	
	var _Settings = __webpack_require__(423);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Settings = _Settings2.default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SignIn = undefined;
	
	var _SignIn = __webpack_require__(86);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SignIn = _SignIn2.default;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _ccImports = __webpack_require__(1);
	
	__webpack_require__(479);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var totalSalary = 10000;
	var playersPerTeam = 2;
	
	var SingleLeague = function (_Component) {
	    _inherits(SingleLeague, _Component);
	
	    function SingleLeague(props) {
	        _classCallCheck(this, SingleLeague);
	
	        var _this = _possibleConstructorReturn(this, (SingleLeague.__proto__ || Object.getPrototypeOf(SingleLeague)).call(this, props));
	
	        _this.initialState = {
	            league: {},
	            userEntries: undefined,
	            allEntries: [],
	            screen: 'league',
	            skip: 0,
	            win: 0,
	            lost: 0,
	            refunded: 0
	        };
	        _this.state = _this.initialState;
	
	        _this._updateEntries = _this._updateEntries.bind(_this);
	        _this._fetchEntries = _this._fetchEntries.bind(_this);
	        _this._getFirstText = _this._getFirstText.bind(_this);
	        _this._getSecondText = _this._getSecondText.bind(_this);
	        _this._getMyEntryFirstText = _this._getMyEntryFirstText.bind(_this);
	        _this._isLeagueCompleted = _this._isLeagueCompleted.bind(_this);
	        _this.__isLeagueStartedOrCompleted = _this.__isLeagueStartedOrCompleted.bind(_this);
	        _this._showAllEntries = _this._showAllEntries.bind(_this);
	        _this._showLeague = _this._showLeague.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._closeModal = _this._closeModal.bind(_this);
	        _this._playLeague = _this._playLeague.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleLeague, [{
	        key: "_updateEntries",
	        value: function _updateEntries() {
	            var _props = this.props,
	                entriesByLeague = _props.entriesByLeague,
	                entriesById = _props.entriesById,
	                userId = _props.userId;
	
	
	            var entryIdsForLeague = entriesByLeague[this.state.league.id];
	            var allEntries = [];
	
	            _lodash2.default.forEach(entryIdsForLeague, function (entryId) {
	                allEntries.push(entriesById[entryId]);
	            });
	
	            allEntries = _lodash2.default.sortBy(allEntries, ["rank"]);
	
	            var userEntries = [];
	
	            if (userId) {
	                userEntries = _lodash2.default.filter(allEntries, function (entry) {
	                    return entry.creator.id == userId;
	                });
	            }
	
	            var win = 0,
	                lost = 0,
	                refunded = 0;
	
	            _lodash2.default.forEach(userEntries, function (entry) {
	                if (entry.winning) {
	                    win = win + entry.coinsEarned;
	                } else if (entry.status == _ccImports.Constants.entryStatus.COMPLETED && !entry.winning) {
	                    lost = lost + entry.coins;
	                } else {
	                    refunded = refunded + entry.coins;
	                }
	            });
	
	            this.setState({ userEntries: userEntries, allEntries: allEntries, win: win, lost: lost, refunded: refunded });
	        }
	    }, {
	        key: "_showAllEntries",
	        value: function _showAllEntries() {
	            var userId = this.props.userId;
	
	            if (this.state.league) {
	                var league = this.state.league;
	                _ccImports.CCAppEventLogger.logAppEvent("ShowAllEntries", { 'league_category': league.category,
	                    'league_type': league.type,
	                    'match_key': league.match.key,
	                    loggedIn: userId
	                });
	            }
	            this.setState({
	                screen: 'entries'
	            });
	        }
	    }, {
	        key: "_showLeague",
	        value: function _showLeague() {
	            this.setState({
	                screen: 'league'
	            });
	        }
	    }, {
	        key: "_manualRefresh",
	        value: function _manualRefresh() {
	            this._fetchEntries(this.state.league, _ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: "_paginate",
	        value: function _paginate() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                entriesReqStatus = _props2.entriesReqStatus,
	                userId = _props2.userId;
	
	            if (entriesReqStatus != _ccImports.Constants.reqStatus.FAI && entriesReqStatus != _ccImports.Constants.reqStatus.COM) {
	                var _state = this.state,
	                    league = _state.league,
	                    skip = _state.skip;
	
	                this._fetchEntries(league, _ccImports.DataActionTypes.PAGINATE, function () {
	                    _this2.setState({ skip: skip + 1 });
	                });
	            }
	        }
	    }, {
	        key: "_fetchEntries",
	        value: function _fetchEntries(league, type, callback) {
	            var _this3 = this;
	
	            //console.log('fetching entries in league ------- ', type)
	            _firebase2.default.auth().currentUser && _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                var entriesPages = _this3.props.entriesPages;
	
	
	                var userId = _this3.props.userId ? _this3.props.userId : _ccImports.Constants.anonymousUser;
	
	                var page = entriesPages[league.id] == undefined ? 0 : entriesPages[league.id];
	                var skip = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? 0 : page;
	                var limit = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? page * 20 : 20;
	
	                var promises = [];
	
	                if (type != _ccImports.DataActionTypes.PAGINATE) {
	                    promises.push(_this3.props.actions.getEntriesByUserIdAndLeagueId({
	                        userId: userId,
	                        leagueId: league.id
	                    }, {
	                        accessToken: idToken,
	                        userId: userId
	                    }, type));
	                }
	
	                promises.push(_this3.props.actions.getEntriesByLeagueId({
	                    leagueId: league.id,
	                    skip: skip,
	                    limit: limit
	                }, {
	                    accessToken: idToken,
	                    userId: userId
	                }, type, league.id).then(function () {}));
	
	                Promise.all(promises).then(function () {
	                    _this3._updateEntries();
	                    callback && callback();
	                });
	            });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            //console.log("single league component mount -------")
	            var league = this.props.league;
	
	            if (!_lodash2.default.isEqual(league, this.state.league)) {
	                this._fetchEntries(league, _ccImports.DataActionTypes.GET);
	                this.setState({ league: league });
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {}
	    }, {
	        key: "_getFirstText",
	        value: function _getFirstText(entry) {
	            return entry.creator.displayName;
	        }
	    }, {
	        key: "_getSecondText",
	        value: function _getSecondText(entry) {
	            if (entry.league.category != _ccImports.Constants.leagueCategory.DREAMTEAM) {
	                if (entry.status == _ccImports.Constants.entryStatus.COMPLETED) {
	                    return '#' + entry.rank + ' : ' + entry.prediction;
	                } else if (entry.status == _ccImports.Constants.entryStatus.LIVE) {
	                    return entry.prediction;
	                } else {
	                    return;
	                }
	            } else {
	                if (entry.status == _ccImports.Constants.entryStatus.LIVE || entry.status == _ccImports.Constants.entryStatus.COMPLETED) {
	                    return '#' + entry.rank + ' (' + entry.score + ')';
	                } else {
	                    return;
	                }
	            }
	        }
	    }, {
	        key: "_getMyEntryFirstText",
	        value: function _getMyEntryFirstText(entry, league) {
	            if (entry.league.category != _ccImports.Constants.leagueCategory.DREAMTEAM) {
	                if (entry.status == _ccImports.Constants.entryStatus.COMPLETED) {
	                    return '#' + entry.rank + ' : ' + entry.prediction;
	                } else {
	                    return entry.prediction;
	                }
	            } else {
	                if (entry.status == _ccImports.Constants.entryStatus.LIVE || entry.status == _ccImports.Constants.entryStatus.COMPLETED) {
	                    return '#' + entry.rank + ' (' + entry.score + ')';
	                } else {
	                    return;
	                }
	            }
	        }
	    }, {
	        key: "_isLeagueCompleted",
	        value: function _isLeagueCompleted(league) {
	            return !(league.status == _ccImports.Constants.leagueStatus.NOT_STARTED || league.status == _ccImports.Constants.leagueStatus.LIVE);
	        }
	    }, {
	        key: "__isLeagueStartedOrCompleted",
	        value: function __isLeagueStartedOrCompleted(league) {
	            return league.status != _ccImports.Constants.leagueStatus.NOT_STARTED;
	        }
	    }, {
	        key: "_closeModal",
	        value: function _closeModal() {
	            //console.log( this.props.actions.closeModal)
	            this.props.actions.closeModal("SingleLeagueModal");
	        }
	    }, {
	        key: "_playLeague",
	        value: function _playLeague() {
	            this.props.onPlayPressed();
	        }
	    }, {
	        key: "_getTitles",
	        value: function _getTitles(league) {
	            var titles = {};
	            var qpd = league.quickPredictionDetails;
	            switch (league.category) {
	                case _ccImports.Constants.leagueCategory.DREAMTEAM:
	                    titles.title = (0, _ccImports.strings)('dream_team_leagues');
	                    titles.description = (0, _ccImports.strings)('dream_team_description');
	                    break;
	                case _ccImports.Constants.leagueCategory.PREDICTION:
	                    titles.title = (0, _ccImports.strings)('target_prediction_leagues');
	                    titles.description = (0, _ccImports.strings)('target_prediction_description');
	                    break;
	                case _ccImports.Constants.leagueCategory.LIVE_PREDICTION:
	                    titles.title = (0, _ccImports.strings)('live_prediction_leagues');
	                    titles.description = (0, _ccImports.strings)('live_prediction_description', { teamName: qpd.team.toUpperCase(), startOver: qpd.startOver, endOver: qpd.endOver });
	                    break;
	            }
	            return titles;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var titles = this._getTitles(this.state.league);
	            var styles = ccStyles.default;
	
	            var allEntries = this.state.allEntries;
	            var _props3 = this.props,
	                entriesType = _props3.entriesType,
	                entriesReqStatus = _props3.entriesReqStatus;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: { height: '100%' } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-container", style: { flex: 1, flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-container single-league-title-container" },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: 'single-league-title-txt' },
	                            titles.title
	                        )
	                    ),
	                    this.state.screen == 'league' ? _react2.default.createElement(
	                        "div",
	                        { className: "flex-container", style: { flex: 1, flexDirection: 'column' } },
	                        this._isLeagueCompleted(this.state.league) && this.state.userEntries && this.state.userEntries.length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "flex-container single-league-section-container section1" },
	                            this.state.refunded > 0 ? _react2.default.createElement(
	                                "div",
	                                { className: "flex-container", style: { flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '.1vw' } },
	                                _react2.default.createElement(
	                                    "h1",
	                                    { className: 'single-league-title1' },
	                                    (0, _ccImports.strings)('refunded_title')
	                                ),
	                                _react2.default.createElement(_ccImports.CCCoinPile, { textClass: 's-league-cp-font', iconClass: 's-league-cp-icon', coins: this.state.refunded })
	                            ) : _react2.default.createElement(
	                                "div",
	                                { className: "flex-container", style: { flex: 1, flexDirection: 'row', marginTop: '.2vw' } },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-container", style: { flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '.1vw' } },
	                                    _react2.default.createElement(
	                                        "h1",
	                                        { className: 'single-league-title1' },
	                                        (0, _ccImports.strings)('you_won')
	                                    ),
	                                    _react2.default.createElement(_ccImports.CCCoinPile, { textClass: 's-league-cp-font', iconClass: 's-league-cp-icon', coins: this.state.win })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-container", style: { flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	                                    _react2.default.createElement(
	                                        "h1",
	                                        { className: 'single-league-title1' },
	                                        (0, _ccImports.strings)('you_lost_message'),
	                                        " "
	                                    ),
	                                    _react2.default.createElement(_ccImports.CCCoinPile, { textClass: 's-league-cp-font', iconClass: 's-league-cp-icon', coins: this.state.lost })
	                                )
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: "flex-container single-league-section-container" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: 'single-league-description1' },
	                                titles.description,
	                                " "
	                            )
	                        ),
	                        _react2.default.createElement("div", { className: "flex-container single-league-section-container divider" }),
	                        entriesType == _ccImports.DataActionTypes.GET && entriesReqStatus == _ccImports.Constants.reqStatus.PEN ? _react2.default.createElement(
	                            "div",
	                            { className: "flex-container", style: { alignItems: "center", justifyContent: 'center' } },
	                            _react2.default.createElement(_ccImports.CCActivityIndicator, { size: 's' })
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: 'flex-container', style: { flex: 1 } },
	                            this.state.userEntries != undefined && _react2.default.createElement(
	                                "div",
	                                { className: "flex-container", style: { flex: 1 } },
	                                this.state.userEntries.length > 0 ? _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-container", style: { flex: 1, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } },
	                                    _react2.default.createElement(
	                                        "h3",
	                                        { className: 'single-league-title1', style: { textAlign: 'center' } },
	                                        (0, _ccImports.strings)('your_entries'),
	                                        " "
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "flex-container entry-dp" },
	                                        this.state.userEntries.map(function (entry) {
	                                            return _react2.default.createElement(_ccImports.CCEntrySummaryItem, { size: styles.entrySummarySize, firstText: _this4._getMyEntryFirstText(entry, _this4.state.league), entry: entry, key: entry.id });
	                                        })
	                                    )
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-container", style: { flex: 1, marginTop: '.2vw', justifyContent: 'center', alignItems: 'center' } },
	                                    _react2.default.createElement(
	                                        "h3",
	                                        { className: 'single-league-description1' },
	                                        (0, _ccImports.strings)('cant_placed_entries'),
	                                        " "
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement("div", { className: "flex-container single-league-section-container divider" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-container", style: { flexDirection: 'column', flex: 1 } },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: 'all_entries_title' },
	                                (0, _ccImports.strings)('all_entries')
	                            ),
	                            entriesReqStatus == _ccImports.Constants.reqStatus.PEN && entriesType == _ccImports.DataActionTypes.GET ? _react2.default.createElement(
	                                "div",
	                                { className: 'flex-container', style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                                _react2.default.createElement(_ccImports.CCActivityIndicator, { size: "s" })
	                            ) : _react2.default.createElement(
	                                "div",
	                                { className: "flex-container no_of_entries_container" },
	                                _lodash2.default.slice(this.state.allEntries, 0, 4).map(function (entry, index) {
	                                    return _react2.default.createElement(_ccImports.CCEntrySummaryItem, { size: styles.entrySummarySize, onPress: index == 3 ? _this4._showAllEntries : function () {}, firstText: _this4._getFirstText(entry), secondText: _this4._getSecondText(entry), placeholder: index == 3, placeholderText: '+' + (_this4.state.league.noOfEntries - 3), entry: entry, key: entry.id });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-container  single-league-section-container section4" },
	                            this.__isLeagueStartedOrCompleted(this.state.league) ? _react2.default.createElement(
	                                "div",
	                                { className: "flex-container", style: { justifyContent: 'center', alignItems: 'center', marginTop: 5 } },
	                                _react2.default.createElement(_ccImports.CCButton, { titleClassName: "button_text", className: "btn-style", onPress: this._closeModal, title: (0, _ccImports.strings)('close') })
	                            ) : _react2.default.createElement(
	                                "div",
	                                { className: "flex-container", style: { justifyContent: 'center', alignItems: 'center', marginTop: 10 } },
	                                _react2.default.createElement(_ccImports.CCButton, { titleClassName: "button_text", className: "btn-style", onPress: function onPress() {
	                                        _this4._playLeague(_this4.state.league);
	                                    }, title: (0, _ccImports.strings)('play_button') })
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "flex-container single-league-entries-container " },
	                        _react2.default.createElement(
	                            _ccImports.CCBackLayout,
	                            { onBackPress: this._showLeague },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "scroll" },
	                                entriesType == _ccImports.DataActionTypes.MANUAL_REFRESH && entriesReqStatus == _ccImports.Constants.reqStatus.PEN ? _react2.default.createElement(
	                                    "div",
	                                    { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                                    _react2.default.createElement(_ccImports.CCActivityIndicator, { size: "m" })
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    { className: "gridView flex-container ", style: { justifyContent: 'center' } },
	                                    allEntries.map(function (entry) {
	                                        return _react2.default.createElement(_ccImports.CCEntrySummaryItem, { size: styles.entrySummarySize, firstText: _this4._getFirstText(entry), secondText: _this4._getSecondText(entry), entry: entry, key: entry.id });
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SingleLeague;
	}(_react.Component);
	
	SingleLeague.propTypes = {
	    onPlayPressed: _propTypes2.default.func,
	    league: _propTypes2.default.object
	};
	SingleLeague.defaultProps = {
	    onPlayPressed: function onPlayPressed() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	
	        user: state.user.user,
	        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,
	
	        entries: state.entries,
	        entriesById: state.entries.byId,
	        entriesByLeague: state.entries.byLeague,
	        entriesByCreatorId: state.entries.byCreatorId,
	        entriesPages: state.entries.pages,
	        entriesReqStatus: state.entries.reqStatus,
	        entriesError: state.entries.error,
	        entriesType: state.entries.type,
	
	        matches: state.matches
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SingleLeague);
	
	
	var ccStyles = {
	    default: {
	        entrySummarySize: 'r',
	        noEntryTitle: {
	            fontSize: 20
	        }
	    },
	    s: {
	        entrySummarySize: 's',
	        noEntryTitle: {
	            fontSize: 16
	        }
	    }
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleLeague = undefined;
	
	var _SingleLeague = __webpack_require__(426);
	
	var _SingleLeague2 = _interopRequireDefault(_SingleLeague);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SingleLeague = _SingleLeague2.default;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _firebase = __webpack_require__(11);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _ccImports = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CCErrorBoundary = __webpack_require__(7);
	
	var _CCErrorBoundary2 = _interopRequireDefault(_CCErrorBoundary);
	
	__webpack_require__(480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SponsorDetails = function (_Component) {
	    _inherits(SponsorDetails, _Component);
	
	    function SponsorDetails(props) {
	        _classCallCheck(this, SponsorDetails);
	
	        var _this = _possibleConstructorReturn(this, (SponsorDetails.__proto__ || Object.getPrototypeOf(SponsorDetails)).call(this, props));
	
	        _this.state = {};
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        return _this;
	    }
	
	    _createClass(SponsorDetails, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: '_validateAndSubmit',
	        value: function _validateAndSubmit() {}
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit(reward) {
	            var _this2 = this;
	
	            _firebase2.default.auth().currentUser.getIdToken(false).then(function (idToken) {
	                switch (reward.status) {
	                    case _ccImports.Constants.rewardStatus.CREATED:
	                        var updatedReward = _this2._updateReward(reward);
	                        _this2.props.actions.claimReward({ accessToken: idToken }, updatedReward, _ccImports.DataActionTypes.UPDATE);
	                        break;
	                    case _ccImports.Constants.rewardStatus.CLAIMED:
	                        var updatedReward = _this2._updateReward(reward);
	                        _this2.props.actions.updateClaimReward({ accessToken: idToken }, updatedReward, _ccImports.DataActionTypes.UPDATE);
	                        break;
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sponsor = _props.sponsor,
	                onViewRankPressed = _props.onViewRankPressed;
	            var theme = sponsor.theme,
	                promoDetails = sponsor.promoDetails,
	                name = sponsor.name;
	
	            console.log(theme, promoDetails);
	            var user = this.props.user.user;
	            var userPDetails;
	
	            if (promoDetails) {
	                if (user) {
	                    userPDetails = promoDetails[user.country] ? promoDetails[user.country] : promoDetails['ALL'];
	                } else {
	                    userPDetails = promoDetails['ALL'];
	                }
	            }
	
	            return _react2.default.createElement(
	                _CCErrorBoundary2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: "sponsor-container1" },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            theme && theme.sGrpBannerImg && _react2.default.createElement(
	                                'div',
	                                { className: "sponsor-container2" },
	                                _react2.default.createElement('img', { className: "sponsor-img", resizeMode: 'contain', src: theme.sDetailsBannerImg })
	                            )
	                        ),
	                        userPDetails && _react2.default.createElement(
	                            'div',
	                            { className: "sponsor-container3" },
	                            userPDetails.map(function (pDetail, index) {
	                                return _react2.default.createElement(
	                                    'h2',
	                                    { key: index, className: "sponsor-details" },
	                                    _ccImports.CCUIUtils.getLocaleStr(pDetail)
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: "rank-btn" },
	                            _react2.default.createElement(_ccImports.CCButton, { onPress: onViewRankPressed, title: 'View Your Ranks' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SponsorDetails;
	}(_react.Component);
	
	SponsorDetails.propTypes = {
	    sponsor: _propTypes2.default.object,
	    onViewRankPressed: _propTypes2.default.func
	};
	SponsorDetails.defaultProps = {
	    onViewRankPressed: function onViewRankPressed() {}
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        profile: state.profile,
	        profileTabNavigation: state.profileTabNavigation,
	        user: state.user,
	        fireBaseUser: state.fireBaseUser,
	        rewards: state.rewards
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(SponsorDetails);

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SponsorDetails = undefined;
	
	var _SponsorDetails = __webpack_require__(428);
	
	var _SponsorDetails2 = _interopRequireDefault(_SponsorDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SponsorDetails = _SponsorDetails2.default;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ccImports = __webpack_require__(1);
	
	var _index = __webpack_require__(40);
	
	var _CCActivityIndicator = __webpack_require__(27);
	
	var _CCActivityIndicator2 = _interopRequireDefault(_CCActivityIndicator);
	
	__webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './transactions.css'
	
	
	var Transactions = function (_Component) {
	    _inherits(Transactions, _Component);
	
	    function Transactions(props) {
	        _classCallCheck(this, Transactions);
	
	        var _this = _possibleConstructorReturn(this, (Transactions.__proto__ || Object.getPrototypeOf(Transactions)).call(this, props));
	
	        _this.state = {
	            skip: 0,
	            pending: false
	        };
	        _this._fetchTransactions = _this._fetchTransactions.bind(_this);
	        _this._autoRefresh = _this._autoRefresh.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        return _this;
	    }
	
	    _createClass(Transactions, [{
	        key: '_fetchTransactions',
	        value: function _fetchTransactions(type) {
	            var _this2 = this;
	
	            var _props = this.props,
	                userId = _props.userId,
	                actions = _props.actions,
	                pages = _props.pages;
	
	            if (this.state.pending == true) return;
	
	            this.setState({ pending: true }, function () {
	                _index.FirebaseUtils.getIdTokenWhenAuthChanged(function (idToken) {
	                    var page = pages[userId] == undefined ? 0 : pages[userId];
	                    var skip = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? 0 : page;
	                    var limit = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? page * 20 : 20;
	
	                    if (userId) {
	                        actions.fetchTransactions(idToken, userId, skip, limit, type).then(function () {
	                            _this2.setState({ pending: false });
	                        }).catch(function () {
	                            _this2.setState({ pending: false });
	                        });
	                    }
	                });
	            });
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchTransactions(_ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchTransactions(_ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var reqStatus = this.props.reqStatus;
	
	            if (reqStatus != _ccImports.Constants.reqStatus.FAI && reqStatus != _ccImports.Constants.reqStatus.COM) {
	                this._fetchTransactions(_ccImports.DataActionTypes.PAGINATE);
	            }
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchTransactions(_ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchTransactions(_ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var reqStatus = this.props.reqStatus;
	
	            if (reqStatus != _ccImports.Constants.reqStatus.FAI && reqStatus != _ccImports.Constants.reqStatus.COM) {
	                this._fetchTransactions(_ccImports.DataActionTypes.PAGINATE);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.userId) {
	                this._fetchTransactions(_ccImports.DataActionTypes.GET);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (_ccImports.CCUtils.userUpdated(this.props.user, nextProps.user)) {
	                this._fetchTransactions(_ccImports.DataActionTypes.GET);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                reqStatus = _props2.reqStatus,
	                type = _props2.type,
	                userId = _props2.userId,
	                byUserId = _props2.byUserId,
	                byId = _props2.byId;
	
	
	            var transactions = byUserId[userId];
	            return _react2.default.createElement(
	                'div',
	                { style: { flex: 1 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container transaction-heading-container' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'transaction_heading_title' },
	                        (0, _ccImports.strings)('transactions')
	                    )
	                ),
	                transactions && transactions.length > 0 ? _react2.default.createElement(_ccImports.CCListView, { data: transactions, onEndReachedThreshold: 2, onEndReached: this._paginate, endReached: reqStatus == _ccImports.Constants.reqStatus.COM || reqStatus == _ccImports.Constants.reqStatus.FAI, renderItem: function renderItem(trnId, index) {
	                        var trans = byId[trnId];
	                        return _react2.default.createElement(_ccImports.CCTransactionItem, { transaction: trans, key: trnId });
	                    } }) : _ccImports.CCUIUtils.getEmptyListItem(reqStatus)
	            );
	        }
	    }]);
	
	    return Transactions;
	}(_react.Component);
	
	Transactions.propTypes = {};
	Transactions.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user,
	        byId: state.transactions.byId,
	        byUserId: state.transactions.byUserId,
	
	        pages: state.transactions.pages,
	        userId: state.user.user.id,
	        random: state.transactions.random,
	        type: state.transactions.type,
	        reqStatus: state.transactions.reqStatus
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(Transactions);

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Transactions = undefined;
	
	var _Transactions = __webpack_require__(430);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Transactions = _Transactions2.default;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(482);
	
	var _ccImports = __webpack_require__(1);
	
	var _CCSectionList = __webpack_require__(80);
	
	var _CCSectionList2 = _interopRequireDefault(_CCSectionList);
	
	var _ccImports2 = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './index.css'
	
	// import './index_320.css'
	
	var UserEntries = function (_Component) {
	    _inherits(UserEntries, _Component);
	
	    function UserEntries(props) {
	        _classCallCheck(this, UserEntries);
	
	        /*this.ref = Firebase.firestore().collection('entries');
	        this.unsubscribe = {};
	        this.storeData=[];*/
	
	        var _this = _possibleConstructorReturn(this, (UserEntries.__proto__ || Object.getPrototypeOf(UserEntries)).call(this, props));
	
	        _this.state = {
	            data: [],
	            reqPending: false
	        };
	
	        _this._fetchEntries = _this._fetchEntries.bind(_this);
	        _this._autoRefresh = _this._autoRefresh.bind(_this);
	        _this._manualRefresh = _this._manualRefresh.bind(_this);
	        _this._paginate = _this._paginate.bind(_this);
	        _this._updateGrouping = _this._updateGrouping.bind(_this);
	        //this._onEntriesUpdate = this._onEntriesUpdate.bind(this);
	        return _this;
	    }
	
	    _createClass(UserEntries, [{
	        key: '_fetchEntries',
	        value: function _fetchEntries(type) {
	            var _this2 = this;
	
	            var _props = this.props,
	                userId = _props.userId,
	                actions = _props.actions,
	                pages = _props.pages,
	                reqStatus = _props.reqStatus;
	
	            if (this.state.reqPending == true) return;
	
	            this.setState({ reqPending: true }, function () {
	                var page = pages[userId] == undefined ? 0 : pages[userId];
	                var skip = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? 0 : page;
	                var limit = type == _ccImports.DataActionTypes.AUTO_REFRESH || type == _ccImports.DataActionTypes.MANUAL_REFRESH ? page * 20 : 20;
	                if (userId) {
	                    actions.getEntriesByUserId(userId, skip, limit, type).then(function () {
	                        _this2.setState({ reqPending: false });
	                    }).catch(function () {
	                        _this2.setState({ reqPending: false });
	                    });
	                }
	            });
	        }
	    }, {
	        key: '_autoRefresh',
	        value: function _autoRefresh() {
	            this._fetchEntries(_ccImports.DataActionTypes.AUTO_REFRESH);
	        }
	    }, {
	        key: '_manualRefresh',
	        value: function _manualRefresh() {
	            this._fetchEntries(_ccImports.DataActionTypes.MANUAL_REFRESH);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate() {
	            var reqStatus = this.props.reqStatus;
	
	            if (reqStatus != _ccImports.Constants.reqStatus.FAI && reqStatus != _ccImports.Constants.reqStatus.COM) {
	                this._fetchEntries(_ccImports.DataActionTypes.PAGINATE);
	            }
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.props.actions.closeModal("Entries");
	        }
	    }, {
	        key: '_updateGrouping',
	        value: function _updateGrouping(props) {
	            var userId = props.userId,
	                byCreatorId = props.byCreatorId,
	                byId = props.byId;
	
	
	            var entryIds = byCreatorId[userId];
	
	            var entriesForUser = [];
	
	            _lodash2.default.forEach(entryIds, function (entryId) {
	                entriesForUser.push(byId[entryId]);
	            });
	
	            entriesForUser = _lodash2.default.orderBy(entriesForUser, [function (entry) {
	                //console.log(entry);
	                return new Date(entry.createdDate);
	            }], ['desc']);
	
	            var groupedEntries = _lodash2.default.groupBy(entriesForUser, function (entry) {
	                //console.log('++--++__++__++', entry)
	                switch (entry.status) {
	                    case _ccImports.Constants.entryStatus.LIVE:
	                        return 'Live';
	                    case _ccImports.Constants.entryStatus.NOT_STARTED:
	                        return 'Upcoming';
	                    default:
	                        return 'Completed';
	                }
	            });
	
	            var data = [];
	            _lodash2.default.forIn(groupedEntries, function (value, key) {
	                var priority = 0;
	                //console.log("key value   ", key, value);
	                switch (key) {
	                    case 'Live':
	                        priority = 10;
	                        break;
	                    case 'Upcoming':
	                        priority = 5;
	                        break;
	                    default:
	                        priority = 0;
	
	                    //console.log("----- -- -", priority)
	                }
	                data.push({
	                    data: value,
	                    title: key,
	                    priority: priority
	                });
	            });
	
	            //console.log("grouped data", data);
	
	            data = _lodash2.default.orderBy(data, ['priority'], ['desc']);
	
	            return data;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.userId) {
	                this._fetchEntries(_ccImports.DataActionTypes.GET);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	            var _props2 = this.props,
	                reqStatus = _props2.reqStatus,
	                type = _props2.type;
	
	            var data = this._updateGrouping(this.props);
	            return _react2.default.createElement(
	                'div',
	                { style: { flex: 1 } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { alignItems: 'center', justifyContent: 'center', marginBottom: 10, marginTop: 10 } },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'user-entry-title' },
	                        (0, _ccImports.strings)('entries')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-container won-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    flex: 1,
	                                    borderRightColor: _ccImports.colors.theme2.border_color1,
	                                    flexDirection: 'column',
	                                    borderRightWidth: 0.5,
	                                    alignItems: 'center',
	                                    justifyContent: 'center',
	                                    textAlign: 'center'
	                                } },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-entries-won' },
	                                user.entriesWon
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-won-title' },
	                                (0, _ccImports.strings)('won_title')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    flex: 1,
	                                    borderRightColor: _ccImports.colors.theme2.border_color1,
	                                    flexDirection: 'column',
	                                    borderRightWidth: 0.5,
	                                    alignItems: 'center',
	                                    justifyContent: 'center',
	                                    textAlign: 'center'
	                                } },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-entries-won' },
	                                user.entriesLost
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-won-title' },
	                                (0, _ccImports.strings)('lost_title')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    flex: 1,
	                                    borderRightColor: _ccImports.colors.theme2.border_color1,
	                                    flexDirection: 'column',
	                                    borderRightWidth: 0.5,
	                                    alignItems: 'center',
	                                    justifyContent: 'center',
	                                    textAlign: 'center'
	                                } },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-entries-won' },
	                                user.entriesRefunded
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-won-title' },
	                                (0, _ccImports.strings)('refunded_title')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-container', style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: {
	                                    flex: 1,
	                                    borderRightColor: _ccImports.colors.theme2.border_color1,
	                                    flexDirection: 'column',
	                                    borderRightWidth: 0.5,
	                                    alignItems: 'center',
	                                    justifyContent: 'center',
	                                    textAlign: 'center'
	                                } },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-entries-won' },
	                                user.noOfEntries
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'user-entry-won-title' },
	                                (0, _ccImports.strings)('total')
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { flex: 1 } },
	                    data && data.length > 0 ? _react2.default.createElement(_CCSectionList2.default, {
	                        scrollClassName: 'user-entries-scroll',
	                        onEndReached: this._paginate,
	                        onEndReachedThreshold: 1,
	                        renderItem: function renderItem(entry) {
	                            return _react2.default.createElement(_ccImports.CCEntryItem, { entry: entry, key: entry.id });
	                        },
	                        renderSectionHeader: function renderSectionHeader(section) {
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'flex-container', style: { justifyContent: 'center', alignItems: 'center', margin: 5 } },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: ' user-entries-section-header' },
	                                    section.title
	                                )
	                            );
	                        },
	                        sections: data,
	                        ListEmptyComponent: _ccImports2.CCUIUtils.getEmptyListItem(reqStatus)
	                        // ListFooterComponent={CCUIUtils.getListFooter(reqStatus, type, data)}
	                        , endReached: reqStatus == _ccImports.Constants.reqStatus.FAI || reqStatus == _ccImports.Constants.reqStatus.COM
	                    }) : _ccImports2.CCUIUtils.getEmptyListItem(reqStatus)
	                )
	            );
	        }
	    }]);
	
	    return UserEntries;
	}(_react.Component);
	
	UserEntries.propTypes = {};
	UserEntries.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        modals: state.modals,
	        user: state.user.user,
	        byId: state.entries.byId,
	        byLeague: state.entries.byLeague,
	        byCreatorId: state.entries.byCreatorId,
	        liveScores: state.entries.liveScores,
	        pages: state.entries.pages,
	        userId: state.user.user.id,
	        random: state.entries.random,
	        type: state.entries.type,
	        reqStatus: state.entries.reqStatus
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, _ccImports.CCActions), dispatch),
	        dispatch: dispatch
	    };
	})(UserEntries);

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserEntries = undefined;
	
	var _UserEntries = __webpack_require__(432);
	
	var _UserEntries2 = _interopRequireDefault(_UserEntries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserEntries = _UserEntries2.default;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Leaderboard = __webpack_require__(413);
	
	Object.keys(_Leaderboard).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Leaderboard[key];
	    }
	  });
	});
	
	var _Profile = __webpack_require__(420);
	
	Object.keys(_Profile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Profile[key];
	    }
	  });
	});
	
	var _ReAuth = __webpack_require__(422);
	
	Object.keys(_ReAuth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ReAuth[key];
	    }
	  });
	});
	
	var _Edition = __webpack_require__(407);
	
	Object.keys(_Edition).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Edition[key];
	    }
	  });
	});
	
	var _Help = __webpack_require__(409);
	
	Object.keys(_Help).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Help[key];
	    }
	  });
	});
	
	var _Settings = __webpack_require__(424);
	
	Object.keys(_Settings).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Settings[key];
	    }
	  });
	});
	
	var _About = __webpack_require__(400);
	
	Object.keys(_About).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _About[key];
	    }
	  });
	});
	
	var _AddCoins = __webpack_require__(402);
	
	Object.keys(_AddCoins).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AddCoins[key];
	    }
	  });
	});
	
	var _Home = __webpack_require__(41);
	
	Object.keys(_Home).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Home[key];
	    }
	  });
	});
	
	var _Leagues = __webpack_require__(42);
	
	Object.keys(_Leagues).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Leagues[key];
	    }
	  });
	});
	
	var _ClaimReward = __webpack_require__(404);
	
	Object.keys(_ClaimReward).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ClaimReward[key];
	    }
	  });
	});
	
	var _Notifications = __webpack_require__(416);
	
	Object.keys(_Notifications).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Notifications[key];
	    }
	  });
	});
	
	var _TransactionsModal = __webpack_require__(29);
	
	Object.keys(_TransactionsModal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TransactionsModal[key];
	    }
	  });
	});
	
	var _DreamTeamEntryCreation = __webpack_require__(405);
	
	Object.keys(_DreamTeamEntryCreation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DreamTeamEntryCreation[key];
	    }
	  });
	});
	
	var _PredictionEntryCreation = __webpack_require__(418);
	
	Object.keys(_PredictionEntryCreation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PredictionEntryCreation[key];
	    }
	  });
	});
	
	var _SingleLeague = __webpack_require__(427);
	
	Object.keys(_SingleLeague).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SingleLeague[key];
	    }
	  });
	});
	
	var _SignIn = __webpack_require__(425);
	
	Object.keys(_SignIn).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SignIn[key];
	    }
	  });
	});
	
	var _SponsorDetails = __webpack_require__(429);
	
	Object.keys(_SponsorDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SponsorDetails[key];
	    }
	  });
	});
	
	var _UserEntries = __webpack_require__(433);
	
	Object.keys(_UserEntries).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _UserEntries[key];
	    }
	  });
	});
	
	var _Transactions = __webpack_require__(431);
	
	Object.keys(_Transactions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Transactions[key];
	    }
	  });
	});

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(59);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(268);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(467);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CCStore = __webpack_require__(323);
	
	var _CCStore2 = _interopRequireDefault(_CCStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _CCStore2.default },
	    _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 436 */
87,
/* 437 */
87,
/* 438 */
87,
/* 439 */
87,
/* 440 */
87,
/* 441 */
87,
/* 442 */
87,
/* 443 */
87,
/* 444 */
87,
/* 445 */
87,
/* 446 */
87,
/* 447 */
87,
/* 448 */
87,
/* 449 */
87,
/* 450 */
87,
/* 451 */
87,
/* 452 */
87,
/* 453 */
87,
/* 454 */
87,
/* 455 */
87,
/* 456 */
87,
/* 457 */
87,
/* 458 */
87,
/* 459 */
87,
/* 460 */
87,
/* 461 */
87,
/* 462 */
87,
/* 463 */
87,
/* 464 */
87,
/* 465 */
87,
/* 466 */
87,
/* 467 */
87,
/* 468 */
87,
/* 469 */
87,
/* 470 */
87,
/* 471 */
87,
/* 472 */
87,
/* 473 */
87,
/* 474 */
87,
/* 475 */
87,
/* 476 */
87,
/* 477 */
87,
/* 478 */
87,
/* 479 */
87,
/* 480 */
87,
/* 481 */
87,
/* 482 */
87,
/* 483 */
/***/ function(module, exports) {

	module.exports = {
		"countries": [
			{
				"name": "Afganistan",
				"key": "AF",
				"flag": "afg"
			},
			{
				"name": "Australia",
				"key": "AU",
				"flag": "aus"
			},
			{
				"name": "Bangladesh",
				"key": "BD",
				"flag": "ban"
			},
			{
				"name": "Canada",
				"key": "CA",
				"flag": "CAN"
			},
			{
				"name": "UK",
				"key": "GB",
				"flag": "uk"
			},
			{
				"name": "Hong Kong",
				"key": "HK",
				"flag": "hk"
			},
			{
				"name": "India",
				"key": "IN",
				"flag": "ind"
			},
			{
				"name": "Ireland",
				"key": "IE",
				"flag": "ire"
			},
			{
				"name": "Kenya",
				"key": "KE",
				"flag": "ken"
			},
			{
				"name": "Nepal",
				"key": "NP",
				"flag": "nep"
			},
			{
				"name": "Netherlands",
				"key": "NL",
				"flag": "nl"
			},
			{
				"name": "New Zealand",
				"key": "NZ",
				"flag": "nz"
			},
			{
				"name": "Pakistan",
				"key": "PK",
				"flag": "pak"
			},
			{
				"name": "South Africa",
				"key": "ZA",
				"flag": "rsa"
			},
			{
				"name": "Sri Lanka",
				"key": "LK",
				"flag": "sl"
			},
			{
				"name": "Scotland",
				"key": "SCT",
				"flag": "SCT"
			},
			{
				"name": "United Arab Emirates",
				"key": "AE",
				"flag": "UAE"
			},
			{
				"name": "West Indies",
				"key": "WI",
				"flag": "WI"
			},
			{
				"name": "Zimbabwe",
				"key": "ZW",
				"flag": "ZIM"
			},
			{
				"name": "Global",
				"key": "GLOBAL",
				"flag": "global"
			}
		]
	};

/***/ },
/* 484 */
/***/ function(module, exports) {

	module.exports = {
		"languages": [
			{
				"name": "English",
				"key": "en",
				"flag": "lang_en_icon_0094bb_132"
			},
			{
				"name": "Hindi",
				"key": "hi",
				"flag": "lang_hi_icon_0094bb_132"
			},
			{
				"name": "Tamil",
				"key": "ta",
				"flag": "lang_ta_icon_0094bb_132"
			}
		]
	};

/***/ },
/* 485 */
/***/ function(module, exports) {

	module.exports = {
		"about": "এর সম্বন্ধে",
		"accepted_invitation_from": "আপনি {invitedBy}  এর আমন্ত্রণ স্বীকার করেছেন এবং {coins} অর্জন করেছেন যোগদানের বোনাস হিসেবে ",
		"accepted_invitation_from_friend": "আপনার বন্ধু {displayName} আপনার আমন্ত্রণ স্বীকার করেছেন! আপনি {coins}  বোনাস স্বরূপ অর্জন করেছেন ",
		"account_disabled": "আপনার একাউন্টটি নিষ্ক্রিয় করা হয়েছে, দয়া করে hello@cricrush.com এ যোগাযোগ করুন ",
		"all_entries": "সকল এন্ট্রিসমূহ",
		"already_registered": "ইতোমধ্যে নিবন্ধনকৃত? ",
		"can_t_find_account": "ও হো, আমার আপনার একাউন্টটি খুঁজে পাইনি। দয়া করে আরেকটি তৈরি করুন!",
		"cant_placed_entries": "আপনি কোন এন্ট্রি বসান নি।",
		"change_profile_picture": "প্রোফাইল ফোটো পরিবর্তন করুন",
		"chat_modal_name": "চ্যাট করুন",
		"claim": "দাবি করুন",
		"click_here_to_resend": "যাচাইকরণ পুনরায় পাঠান",
		"close": "বন্ধ করুন",
		"coming_soon": "শীঘ্রই আসছে",
		"confirm": "নিশ্চিত করুন",
		"countdown_day": "দিন",
		"countdown_days": "দিনসমূহ",
		"countdown_hours": "ঘন্টাসমূহ",
		"countdown_minutes": "মিনিট সমূহ",
		"countdown_seconds": "সেকেন্ডসমূহ",
		"create_account": "একাউন্ট তৈরি করুন",
		"cricrush_league": "ক্রিক্রাশ লিগ",
		"do_not_have_an_account": "আপনার কোন একাউন্ট নেই?",
		"dream_team": "স্বপ্নের দল",
		"dream_team_entry": "স্বপ্নের দলের এন্ট্রি",
		"dream_team_entry_creation_modal_name": "স্বপ্নের দলের এন্ট্রি তৈরি",
		"dream_team_leagues": "স্বপ্নের দলের লিগসমূহ",
		"earn_coins_bonuses": "কয়েন বোনাস আয় করুন",
		"edition": "সংস্করণ",
		"email_not_verified": "ইমেইল পরীক্ষিত নয়",
		"email_not_verified_to_claim_rewards": "পুরস্কার দাবি করতে দয়া করে আপনার ইমেইল যাচাই করুন.",
		"email_title": "Email ইমেইল",
		"enter_valid_email": "সঠিক ইমেইল বসান",
		"entries": "এন্ট্রিসমূহ",
		"entry_created": " - এন্ট্রি তৈরি করা হয়েছে",
		"favourite_teams": "পছন্দের দলসমূহ",
		"fb_reauth": "ফেসবুকের সাথে নিশ্চিত করুন",
		"fb_signin": "ফেসবুক দিয়ে লগইন করুন",
		"fb_signup": "ফেসবুকের মাধ্যমে সাইন আপ করুন",
		"fire_base_already_login_different provider": "আপনি ভিন্ন প্রোভাইডারের সাহায্যে আগে সাইন আপ করেছেন, দয়া করে সঠিক প্রোভাইডার ব্যবহার করে লগইন করুন",
		"fire_base_wrong_message": "কিছু একটা সমস্যা হয়েছে, দয়া করে পরে আবার চেষ্টা করুন!",
		"friend_invite_accepted": "আপনার বন্ধু {friendName}  আপনার আমন্ত্রণ স্বীকার করেছেন  ",
		"ggl_reauth": "গুগলের মাধ্যমে নিশ্চিত করুন",
		"ggl_signin": "গুগলের মাধ্যমে লগইন করুন",
		"ggl_signup": "গুগলের সাথে সাইন আপ করুন",
		"go_back": "পিছনে যান",
		"help": "সাহায্য",
		"invalid_mail": "ভুল ইমেইল অ্যাড্রেস",
		"invitation_accepted": "আমন্ত্রণ স্বীকৃত হয়েছে!",
		"invitation_bonus": "আমন্ত্রণ বোনাস",
		"invite_friends": "বন্ধুদের আমন্ত্রণ জানান",
		"leaderboard": "লিডারবোর্ড",
		"live": "লাইভ",
		"live_prediction": "লাইভ প্রেডিকশন লিগ",
		"live_prediction_entry": "লাইভ প্রেডিকশন লিগ এন্ট্রি",
		"login": "লগইন করুন",
		"login_here": "এখানে লগইন করুন",
		"login_register": "লগইন/ নিবন্ধন করুন",
		"logout": "লগআউট করুন",
		"lost": " - পরাজিত",
		"lost_title": "পরাজিত",
		"no_email_with_account": "এই ইমেইলের সাথে কোন একাউন্ট সংযুক্ত নয়, দয়া করে সাইন আপ করুন",
		"no_network": "কোন নেটওয়ার্ক নেই!",
		"no_network_connection": "কোন নেটওয়ার্ক কানেকশন নেই",
		"notifications": "নোটিফিকেশন সমূহ",
		"or": "অথবা",
		"password_incorrect": "আপনি যে পাসওয়ার্ড দিয়েছেন তা ভুল।",
		"pick_your_country": "আপনার দেশ নির্বাচন করুন",
		"play_button": "খেলুন",
		"predict_score": "ম্যাচের টার্গেট স্কোর অনুমান করুন",
		"profile": "প্রোফাইল",
		"providers_str": "আপনি {providersStr}  পূর্বে ব্যবহার করেছেন। দয়া করে এর মধ্যে কোন একটি ব্যবহার করে লগইন করুন।",
		"providers_str_try_google": "আপনি {providersStr}  ব্যবহার করে পূর্বে লগইন করেছেন। গুগল ব্যবহার করে লগইন করার চেষ্টা করুন।",
		"reauth_modal_title": "কাজটি সম্পন্ন করতে পুনরায় প্রামাণ্যকরণ করুন",
		"received_invitation_bonus": "আমন্ত্রণ বোনাস পেয়েছেন।",
		"refunded": " - “ফেরত দেয়া হয়েছে",
		"refunded_title": "ফেরত দেয়া হয়েছে",
		"register_here": "নিবন্ধন করুন এখানে",
		"save": "সেভ করুন",
		"select_country": "দেশ নির্বাচন করুন এবং কাস্টমাইজড উইনসমূহ উপভোগ করুন!",
		"select_language": "ভাষা নির্বাচন করুন",
		"select_teams": "পছন্দের দলসমূহ",
		"settings": "সেটিংস সমূহ",
		"submit": "জমা দিন",
		"target_prediction": "টার্গেট প্রেডিকশন ",
		"target_prediction_entry": "টার্গেট প্রেডিকশন এন্ট্রি",
		"total": "সর্বমোট",
		"transactions": "ট্রানজ্যাকশনসমূহ",
		"unknown_error": "একটি অজানা সমস্যা ঘটেছে, দয়া করে hello@cricrush.com -এ আমাদের সাথে যোগাযোগ করুন",
		"upcoming": "আসন্ন",
		"user_name": "ইউজার নেম",
		"valid_number": "দয়া করে একটি সঠিক নম্বর বসান!",
		"weak_password": "দুর্বল পাসওয়ার্ড, পাসওয়ার্ডটিকে অবশ্যই ৬ চিহ্নের  বা তার বেশি হতে হবে",
		"won": " - জিতে গেছেন",
		"won_lost_refunded_coins": "আরে, আপনি {earnedCoins}টি কয়েন জিতেছেন এবং {lostCoins} টি কয়েন হারিয়েছেন এবং {refundedCoins} টি কয়েন ফেরত পেয়েছেন। ",
		"won_title": "জিতে গেছেন",
		"you_lost_message": "আপনি হেরে গেছেন",
		"you_won": "আপনি জিতে গেছেন",
		"you_won_reward": "আপনি একটি পুরস্কার জিতেছেন",
		"your_entries": "আপনার  এন্ট্রিসমূহ",
		"your_live_prediction_entry": "আপনার লাইভ প্রেডিকশন এন্ট্রি সমূহ:{prediction} ",
		"your_mom_entry": "আপনার ম্যান অব দ্য ম্যাচের এন্ট্রি:{momEntry} ",
		"your_prediction": "আপনার প্রেডিকশন: {prediction}",
		"display_name": "ডিসপ্লে নাম",
		"email": "ইমেইল",
		"password": "পাসওয়ার্ড",
		"runs_cannot_be_negative_value": "রানসমূহ নেগেটিভ ভ্যালুর হতে পারেনা",
		"budget": "বাজেট $",
		"view_button": " দেখুন",
		"score": "স্কোর: ",
		"rank": "Rank র‌্যাংক: ",
		"target_prediction_leagues": "টার্গেট প্রেডিকশন লিগসমূহ",
		"live_prediction_leagues": "লাইভ প্রেডিকশন লিগসমূহ",
		"target_prediction_description": "ম্যাচের টার্গেট স্কোর প্রেডিক্ট করুন এবং আপনার এন্ট্রি বসান। সঠিক স্কোরের সাথে তুলনা করে আপনার এন্ট্রিসমূহের র‌্যাঙ্ক ঠিক করা হবে।.",
		"required": "প্রয়োজনীয়!",
		"entries_left": " এন্ট্রিসমূহ বাকি আছে",
		"end_of_results": "ফলাফলের সমাপ্তি",
		"invalid_email_address": "ভুল ইমেইল অ্যাড্রেস",
		"completed": "সম্পন্ন হয়েছে",
		"dream_team_description": "আপনার ৪-প্লেয়ার টিম বেছে নিন এবং আপনার এন্ট্রি তৈরি করুন। এবার শান্ত হয়ে বসুন ও আপনার টিম আপনার জন্য স্কোর করতে থাকার সময় খেলা উপভোগ করুন.",
		"reward_claimed_title": "দাবিকৃত পুরস্কার - {reference}",
		"reward_claimed_msg": "রেফারেন্সসহ পুরস্কার দাবির মাধ্যমে কয়েন রিডিম করা হয়েছে- {reference}",
		"update": "আপডেট",
		"processed": "প্রোসেস করা হয়েছে",
		"claim_reward_instructions_title": "দয়া করে নির্দেশনা ভালভাবে পড়ুন!",
		"invalid_filed_instruction": "{field} টি ভুল।দয়া করে চেক করুন!",
		"reward_processed": "পুরস্কার দেয়া হয়েছে!",
		"reward_reference": "আপনার রেফারেন্স: {reference}",
		"claim_coins_message": "এই পুরস্কার দাবি করার মাধ্যমে, আপনার {claimCoins} কয়েনসমূহ কমিয়ে দেয়া হবে।",
		"weekly": "সাপ্তাহিক",
		"daily": "প্রাত্যহিক",
		"monthly": "মাসিক",
		"lifetime": "আজীবন",
		"local": "স্থানীয়",
		"global": "বৈশ্বিক",
		"no_lb_status_generated": "এই লিডার বোর্ডটি জেনারেট করার জন্য আমাদের কাছে যথেষ্ট ডেটা নেই!",
		"you": "আপনি",
		"leaderBoard": "লিডার বোর্ড",
		"mail_sent": "ইমেইল পাঠানো হয়েছে!",
		"verification_mail_sent": "{email} তে একটি ভেরিফিকেশন ইমেইল পাঠানো হয়েছে",
		"messages": "মেসেজসমূহ",
		"country_change_warning": "আপনি বর্তমানের লিডার বোর্ড র‌্যাঙ্ক হারাতে পারেন যদি আপনার দেশ পরিবর্তন করেন.",
		"faq": "ফ্যাক (এফএকিউ)",
		"how_scores_calculated": "স্কোরের হিসাব",
		"how_to_play": "কিভাবে খেলবেন",
		"live_prediction_description": " {teamName} দলের ব্যাটিং ইনিংসের {endOver}তম ওভারের শেষের দিকের স্কোর প্রেডিক্ট করুন। সঠিক স্কোরের সাথে তুলনা করে আপনার এন্ট্রিসমূহের র‌্যাঙ্ক তৈরি করা হবে। ",
		"predict_what_message": " {teamName} দলের ব্যাটিং ইনিংসের {endOver}তম ওভারের শেষের স্কোর প্রেডিক্ট করুন ",
		"pick_team": "আপনার ৪-প্লেয়ার দল বেছে নিন এবং জিতুন",
		"your_entry_created": " আপনার এন্ট্রি তৈরি করা হয়েছে !",
		"fica_title": "এর মাধ্যমে অফিসিয়ালভাবে এন্ডোর্স করা হয়েছে",
		"fica_detailed_text": " ক্রিক্রাশ হল একমাত্র ক্রিকেট অ্যাপ যা ফিকা (এফআইসিএ) এর মাধ্যমে এন্ডোর্স করা হয়েছে",
		"version": "ভার্সন",
		"match_help": "একটি ম্যাচ নির্বাচন করতে এখানে ক্লিক করুন",
		"dream_team_leagues_help": " {matchName} এর জন্য আপনার ৪-প্লেয়ার দল নির্বাচন করতে এখানে ক্লিক করুন",
		"quick_prediction_leagues_help": "{over} তম ওভারের শেষে স্কোর প্রেডিক্ট করতে এখানে ক্লিক করুন ",
		"target_prediction_leagues_help": "{matchName} ম্যাচের টার্গেট স্কোর প্রেডিক্ট করতে এখানে ক্লিক করুন",
		"entries_help": "লাইভ ম্যাচের সময়ের সাথে সাথে আপডেট করা আপনার এন্ট্রি র‌্যাঙ্ক ও স্কোরসমূহ দেখতে এখানে ক্লিক করুন ",
		"more_leaderboard_help": "আপনার লিডার বোর্ড চেক করতে এখানে ক্লিক করুন",
		"more_edition_language_help": "এখানে ক্লিক করুন ও আপনার ভাষা পরিবর্তন করতে এডিশন নির্বাচন করুন",
		"more_edition_country_help": "এখানে ক্লিক করুন ও আপনার দেশ পরিবর্তন করতে এডিশন নির্বাচন করুন",
		"add_coins_help": "কয়েন কি ফুরিয়ে যাচ্ছে? আরো ফ্রি কয়েন এখানে আয় করুন",
		"claimed": "দাবিকৃত",
		"invite_friends_title": "আপনার বন্ধুকে আমন্ত্রণ জানান এবং যখন তারা তাদের প্রথম এন্ট্রি বসাবেন তখন ১০০ কয়েন পান!",
		"daily_claim_bonus_counter_message": "আপনি ইতোমধ্যে আপনার বোনাস দাবি করেছেন!",
		"daily_claim_bonus_message": "আপনার ফ্রি কয়েন এখনই দাবি করুন!",
		"daily_login_bonus": "প্রাত্যহিক লগইন বোনাস",
		"daily_login_bonus_claimed": "প্রাত্যহিক লগইন বোনাস দাবি করা হয়েছে",
		"invite_friends_share_title": "আপনার বন্ধু {name} আপনাকে ক্রিক্রাশে যোগ দিতে আমন্ত্রণ জানিয়েছেন ",
		"invite_friends_share_message": "আপনার বন্ধু {name} ক্রিকাশে যোগদান করার জন্য আপনাকে আমন্ত্রণ জানিয়েছেন। যোগ দিতে, খেলতে এবং চমৎকার সব উপহার পেতে নিচের লিঙ্কে ক্লিক করুন",
		"invite_friends_dialog_title": "যোগ দিতে বন্ধুদের আমন্ত্রণ জানান",
		"live_status": "লাইভ",
		"view_entries": "{noOfEntries} এন্ট্রিসমূহ দেখুন >>",
		"end_of_results2": "আমাদের কাছে এতটাই আছে!",
		"leagues_not_created": "লিগসমূহ শীঘ্রই তৈরি করা হবে...",
		"add_coins": "কয়েন যোগ করুন",
		"expired": "Expired",
		"reward_expired": "Reward Expired!",
		"entries_left2": "{noOfEntries}টি  এন্ট্রিসমূহ বাকি আছে"
	};

/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports = {
		"about": "About",
		"accepted_invitation_from": "You accepted invitation from  {invitedBy} and earned {coins} as joining bonus",
		"accepted_invitation_from_friend": "Your friend {displayName} accepted your invitation! You earned {coins} as bonus",
		"account_disabled": "Your Account Disabled, Please Contact hello@cricrush.com",
		"all_entries": "All Entries",
		"already_registered": "Already Registered? ",
		"can_t_find_account": "Oops, we couldn't find your account. Please create one!",
		"cant_placed_entries": "You haven't placed any entries",
		"change_profile_picture": "Change Profile Photo",
		"chat_modal_name": "Chat",
		"claim": "Claim",
		"click_here_to_resend": "Resend verification",
		"close": "Close",
		"coming_soon": "Coming Soon",
		"confirm": "Confirm",
		"countdown_day": "Day",
		"countdown_days": "Days",
		"countdown_hours": "Hours",
		"countdown_minutes": "Minutes",
		"countdown_seconds": "Seconds",
		"create_account": "Create Account",
		"cricrush_league": "Cricrush League",
		"do_not_have_an_account": "Do not have an account?",
		"dream_team": "Dream team",
		"dream_team_entry": "Dream Team Entry",
		"dream_team_entry_creation_modal_name": "Dream Team Entry Creation",
		"dream_team_leagues": "Dream Team Leagues",
		"earn_coins_bonuses": "Earn Coins Bonuses",
		"edition": "Edition",
		"email_not_verified": "Email not verified.",
		"email_not_verified_to_claim_rewards": "Please verify your email to claim rewards.",
		"email_title": "Email",
		"enter_valid_email": "Enter valid email",
		"entries": "Entries",
		"entry_created": " - ENTRY CREATED",
		"favourite_teams": "Favourite teams",
		"fb_reauth": "Confirm with facebook",
		"fb_signin": "Login with facebook",
		"fb_signup": "Signup with facebook",
		"fire_base_already_login_different provider": "You have previously signed up using different provider, please login using correct provider.",
		"fire_base_wrong_message": "Something went wrong, Please try again later!",
		"friend_invite_accepted": "Your friend {friendName} accepted your invitation",
		"ggl_reauth": "Confirm with google",
		"ggl_signin": "Login with google",
		"ggl_signup": "Signup with google",
		"go_back": "Go back",
		"help": "Help",
		"invalid_mail": "Invalid Email Address",
		"invitation_accepted": "Invitation Accepted!",
		"invitation_bonus": "Invitation bonus",
		"invite_friends": "Invite Friends",
		"leaderboard": "Leaderboard",
		"live": "Live",
		"live_prediction": "Live Prediction League",
		"live_prediction_entry": "Live Prediction Entry",
		"login": "Login",
		"login_here": "Login Here",
		"login_register": "Login/Register",
		"logout": "Logout",
		"lost": " - LOST",
		"lost_title": "Lost",
		"no_email_with_account": "No account associated with this email, Please Signup",
		"no_network": "No network!",
		"no_network_connection": "No network connection!",
		"notifications": "Notifications",
		"or": "OR",
		"password_incorrect": "The password you entered is incorrect.",
		"pick_your_country": "Pick your country",
		"play_button": "PLAY",
		"predict_score": "Predict the target score of the match",
		"profile": "Profile",
		"providers_str": "You used {providersStr} previously. Please login again using any of those method",
		"providers_str_try_google": "You signed up using {providersStr} previously. Try login using google",
		"reauth_modal_title": "Re-Authenticate to complete the action",
		"received_invitation_bonus": "Received invitation bonus",
		"refunded": " - REFUNDED",
		"refunded_title": "Refunded",
		"register_here": "Register Here",
		"save": "Save",
		"select_country": "Select the country and enjoy customized wins!",
		"select_language": "Select language",
		"select_teams": "Favourite teams",
		"settings": "Settings",
		"submit": "Submit",
		"target_prediction": "Target Prediction",
		"target_prediction_entry": "Target Prediction Entry",
		"total": "Total",
		"transactions": "Transactions",
		"unknown_error": "Unknown error occurred, Please contact us at hello@cricrush.com",
		"upcoming": "Upcoming",
		"user_name": "USERNAME",
		"valid_number": "Please enter a valid number!",
		"weak_password": "Weak password, The password must be 6 characters long or more.",
		"won": " - WON",
		"won_lost_refunded_coins": "Hey, You won  {earnedCoins} coins and lost {lostCoins} coins and got {refundedCoins} coins refunded.",
		"won_title": "Won",
		"you_lost_message": "You Lost",
		"you_won": "You Won",
		"you_won_reward": "You won a reward",
		"your_entries": "Your Entries",
		"your_live_prediction_entry": "Your Live Prediction Entry : {prediction}",
		"your_mom_entry": "Your Man of the match Entry:{momEntry}",
		"your_prediction": "Your prediction : {prediction}",
		"display_name": "Display Name",
		"email": "Email",
		"password": "Password",
		"runs_cannot_be_negative_value": "Runs cannot be a negative value",
		"budget": "Budget $",
		"view_button": " VIEW",
		"score": "Score: ",
		"rank": "Rank: ",
		"target_prediction_leagues": "Target Prediction Leagues",
		"live_prediction_leagues": "Live Prediction Leagues",
		"target_prediction_description": "Predict the target score of the match and place your entry. Your entries will be ranked based on their proximity to real score.",
		"required": "Required!",
		"entries_left": " entries left",
		"end_of_results": "End of results",
		"invalid_email_address": "Invalid Email Address",
		"completed": "Completed",
		"dream_team_description": "Pick your 4-player team and create your entry. Now sit back and enjoy the game while your team scores for you.",
		"reward_claimed_title": "Reward Claimed - {reference}",
		"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
		"update": "Update",
		"processed": "Processed",
		"claim_reward_instructions_title": "Please read instructions carefully!",
		"invalid_filed_instruction": "{field} is invalid. Please check!",
		"reward_processed": "Reward Processed!",
		"reward_reference": "Your Reference : {reference}",
		"claim_coins_message": "By claiming this reward, you will be reduced {claimCoins} coins.",
		"weekly": "Weekly",
		"daily": "Daily",
		"monthly": "Monthly",
		"lifetime": "Lifetime",
		"local": "Local",
		"global": "Global",
		"no_lb_status_generated": "We don't have enough data to generate this leader board!",
		"you": "You",
		"leaderBoard": "Leader Board",
		"mail_sent": "Email Sent!",
		"verification_mail_sent": "A verification email sent to {email}",
		"messages": "Messages",
		"country_change_warning": "You might loose current leader board ranks if you change your country.",
		"faq": "FAQ",
		"how_scores_calculated": "Score Calculations",
		"how_to_play": "How To Play",
		"live_prediction_description": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings. Your entries will be ranked based on their proximity to real score.",
		"predict_what_message": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings",
		"pick_team": "Pick your 4-player team and win",
		"your_entry_created": "Your entry created !",
		"fica_title": "Officially endorsed by",
		"fica_detailed_text": "Cricrush is the only fantasy cricket app endorsed by FICA",
		"version": "Version",
		"match_help": "Click here to select a match",
		"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
		"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
		"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
		"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
		"more_leaderboard_help": "Click here to check your leaderboard",
		"more_edition_language_help": "Click here and select edition to change your language",
		"more_edition_country_help": "Click here and select edition to change your country",
		"add_coins_help": "Running out of coins? Earn more free coins here",
		"claimed": "Claimed",
		"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
		"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
		"daily_claim_bonus_message": "Claim your free coins now!",
		"daily_login_bonus": "Daily login bonus",
		"daily_login_bonus_claimed": "Daily login bonus claimed",
		"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
		"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
		"invite_friends_dialog_title": "Invite friends to join",
		"live_status": "LIVE",
		"view_entries": "View {noOfEntries} entries >>",
		"end_of_results2": "That's all we have!",
		"leagues_not_created": "Leagues will be created soon...",
		"add_coins": "Add Coins",
		"expired": "Expired",
		"reward_expired": "Reward Expired!",
		"entries_left2": "{noOfEntries} entries left"
	};

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports = {
		"about": "के बारे में",
		"accepted_invitation_from": "आपने {invitedBy} का आमंत्रण स्वीकार किया है और शामिल होने के लिए {coins} बोनस कमाया है| ",
		"accepted_invitation_from_friend": "आपके मित्र {displayName} ने आपका निमंत्रण स्वीकार कर लिया है| आपने {coins} बोनस के रूप मे कमाया है!|",
		"account_disabled": "आपका खाता विकलांग किया गया है। कृपया hello@cricrush.com पर संपर्क करें|",
		"all_entries": "सभी प्रविष्टियों",
		"already_registered": "पहले से पंजीकृत? ",
		"can_t_find_account": "ओह, हम आपका खाता नहीं ढूंढ सके| कृपया एक बनाएं|",
		"cant_placed_entries": "आपने कोई प्रविष्टि नहीं रखी है|",
		"change_profile_picture": "प्रोफ़ाइल चित्र बदलें",
		"chat_modal_name": "बातचीत",
		"claim": "दावा",
		"click_here_to_resend": "जाँच पुनः भेजें",
		"close": "बंद करे",
		"coming_soon": "जल्द आ रहा है",
		"confirm": "पक्का करें",
		"countdown_day": "दिन",
		"countdown_days": "दिन",
		"countdown_hours": "घंटे",
		"countdown_minutes": "मिनट",
		"countdown_seconds": "सेकंड",
		"create_account": "खाता बनाएं",
		"cricrush_league": "Cricrush संघ",
		"do_not_have_an_account": "क्या आपका कोई खाता नहीं है?",
		"dream_team": "सपने की टीम",
		"dream_team_entry": "ड्रीम टीम एंट्री",
		"dream_team_entry_creation_modal_name": "ड्रीम टीम प्रविष्टि रचना",
		"dream_team_leagues": "ड्रीम टीम लीग",
		"earn_coins_bonuses": " बोनस के सिक्के कमाएं",
		"edition": "संस्करण",
		"email_not_verified": "ईमेल सत्यापित नहीं है",
		"email_not_verified_to_claim_rewards": "पुरस्कार का दावा करने के लिए कृपया अपना ईमेल सत्यापित करें",
		"email_title": "ईमेल",
		"enter_valid_email": "मान्य ईमेल दर्ज करें",
		"entries": "प्रविष्टियां",
		"entry_created": " - प्रवेश बनाया गया",
		"favourite_teams": "पसंदीदा टीम",
		"fb_reauth": "facebook से स्थायी करें",
		"fb_signin": "facebook से लोगिन करें ",
		"fb_signup": "facebook के साथ साइन अप करें",
		"fire_base_already_login_different provider": "आपने अलग प्रदाता का उपयोग करके पहले साइन अप किया है| कृपया सही प्रदाता का उपयोग करके प्रवेश करें।",
		"fire_base_wrong_message": "कुछ गलत हो गया है। कृपया बाद में दोबारा प्रयास करें!",
		"friend_invite_accepted": "आपके मित्र {friendName} ने आपका निमंत्रण स्वीकार कर लिया है",
		"ggl_reauth": "google से स्थायी करें",
		"ggl_signin": "google से लोगिन करें",
		"ggl_signup": "google के साथ साइन अप करें ",
		"go_back": "वापस जाएँ",
		"help": "मदद",
		"invalid_mail": "अमान्य ईमेल पता",
		"invitation_accepted": "आमंत्रण स्वीकृत!",
		"invitation_bonus": "आमंत्रण बोनस",
		"invite_friends": "मित्रों को आमंत्रित करें",
		"leaderboard": "लीडरबोर्ड",
		"live": "Live",
		"live_prediction": "लाइव प्रेडिक्शन लीग",
		"live_prediction_entry": "लाइव प्रेडिक्शन प्रविष्टि",
		"login": "लॉगिन करें",
		"login_here": "यहां लॉगिन करें",
		"login_register": "लॉगिन  / पंजीकरण",
		"logout": "लॉगआउट",
		"lost": " - खो गया",
		"lost_title": "खो गया",
		"no_email_with_account": "इस ईमेल से कोई खाता नहीं है| कृपया साइन उप करें",
		"no_network": "नेटवर्क नहीं! है!",
		"no_network_connection": "नेटवर्क कनेक्शन नहीं है!",
		"notifications": "सूचनाएं",
		"or": "या",
		"password_incorrect": "आपके द्वारा दर्ज किया गया पासवर्ड गलत है.",
		"pick_your_country": "अपना देश चुनें",
		"play_button": "प्ले",
		"predict_score": "मैच के लक्ष्य स्कोर की भविष्यवाणी करें",
		"profile": "प्रोफाइल",
		"providers_str": "आपने  पहले {providersStr} का उपयोग किया था| कृपया उन तरीकों में से किसी एक का उपयोग करके फिर से लॉगिन करें",
		"providers_str_try_google": "आपने पहले {providersStr} का उपयोग करके साइन अप किया है| Google का प्रयोग करके लॉगिन करने का प्रयास करें",
		"reauth_modal_title": "क्रिया पूर्ण करने केलिए पुन: प्रमाणीकृत करें",
		"received_invitation_bonus": "आमंत्रण बोनस प्राप्त हुआ",
		"refunded": " - वापस कर दिया",
		"refunded_title": "वापस कर दिया",
		"register_here": "यहां रजिस्टर करें",
		"save": "बचाना",
		"select_country": "देश चुनें और अनुकूलित जीत का आनंद लें!",
		"select_language": "भाषा चुनिए",
		"select_teams": "पसंदीदा टीम",
		"settings": "सेटिंग्स",
		"submit": "जमा करें",
		"target_prediction": "टारगेट प्रेडिक्शन",
		"target_prediction_entry": "टारगेट प्रेडिक्शन प्रविष्टि",
		"total": "कुल",
		"transactions": "लेन-देन",
		"unknown_error": "अज्ञात त्रुटि हुई",
		"upcoming": "आगामी",
		"user_name": "उपयोगकर्ता नाम",
		"valid_number": "कृपया एक सही संख्या डालिये!",
		"weak_password": "कमजोर पासवर्ड, पासवर्ड 6 वर्ण या अधिक लंबा  होना चाहिए.",
		"won": " - जीत लिया",
		"won_lost_refunded_coins": "हे, आपने {earnedCoins} सिक्के जीते,  {lostCoins} सिक्के खोये और  {refundedCoins} सिक्के वापस मिले",
		"won_title": "जीत लिया",
		"you_lost_message": "आप हार गए",
		"you_won": "आप जीते",
		"you_won_reward": "आपने पुरस्कार जीता",
		"your_entries": "आपके प्रविष्टियां",
		"your_live_prediction_entry": "आपका लाइव भविष्यवाणी प्रविष्टि  : {prediction}",
		"your_mom_entry": "आपका मैन ऑफ़ द मैच एंट्री :{momEntry}",
		"your_prediction": "आपका पूर्वानुमान : {prediction}",
		"display_name": "डिस्प्ले नाम",
		"email": "ईमेल",
		"password": "पारण शब्द",
		"runs_cannot_be_negative_value": "रन एक नकारात्मक मूल्य नहीं हो सकता है",
		"budget": "बजट $",
		"view_button": " व्यू",
		"score": "स्कोर: ",
		"rank": "रैंक: ",
		"target_prediction_leagues": "टारगेट प्रेडिक्शन लीग",
		"live_prediction_leagues": "लाइव प्रेडिक्शन लीग",
		"target_prediction_description": "मैच के लक्ष्य स्कोर की भविष्यवाणी करें और अपनी प्रविष्टि दर्ज करें। आपकी प्रविष्टियों को वास्तविक स्कोर के साथ निकटता के आधार पर रैंक किया जाएगा।",
		"required": "Required!",
		"entries_left": " entries left",
		"end_of_results": "End of results",
		"invalid_email_address": "Invalid Email Address",
		"completed": "Completed",
		"dream_team_description": "Pick your 4-player team and create your entry. Now sit back and enjoy the game while your team scores for you.",
		"reward_claimed_title": "Reward Claimed - {reference}",
		"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
		"update": "Update",
		"processed": "Processed",
		"claim_reward_instructions_title": "Please read instructions carefully!",
		"invalid_filed_instruction": "{field} is invalid. Please check!",
		"reward_processed": "Reward Processed!",
		"reward_reference": "Your Reference : {reference}",
		"claim_coins_message": "By claiming this reward, you will be reduced {claimCoins} coins.",
		"weekly": "Weekly",
		"daily": "Daily",
		"monthly": "Monthly",
		"lifetime": "Lifetime",
		"local": "Local",
		"global": "Global",
		"no_lb_status_generated": "We don't have enough data to generate this leader board!",
		"you": "You",
		"leaderBoard": "Leader Board",
		"mail_sent": "Email Sent!",
		"verification_mail_sent": "A verification email sent to {email}",
		"messages": "Messages",
		"country_change_warning": "You might loose current leader board ranks if you change your country.",
		"faq": "FAQ",
		"how_scores_calculated": "Score Calculations",
		"how_to_play": "How To Play",
		"live_prediction_description": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings. Your entries will be ranked based on their proximity to real score.",
		"predict_what_message": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings",
		"pick_team": "Pick your 4-player team and win",
		"your_entry_created": "Your entry created !",
		"fica_title": "Officially endorsed by",
		"fica_detailed_text": "Cricrush is the only fantasy cricket app endorsed by FICA",
		"version": "Version",
		"match_help": "Click here to select a match",
		"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
		"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
		"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
		"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
		"more_leaderboard_help": "Click here to check your leaderboard",
		"more_edition_language_help": "Click here and select edition to change your language",
		"more_edition_country_help": "Click here and select edition to change your country",
		"add_coins_help": "Running out of coins? Earn more free coins here",
		"claimed": "Claimed",
		"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
		"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
		"daily_claim_bonus_message": "Claim your free coins now!",
		"daily_login_bonus": "Daily login bonus",
		"daily_login_bonus_claimed": "Daily login bonus claimed",
		"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
		"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
		"invite_friends_dialog_title": "Invite friends to join",
		"live_status": "LIVE",
		"view_entries": "View {noOfEntries} entries >>",
		"end_of_results2": "That's all we have!",
		"leagues_not_created": "Leagues will be created soon...",
		"add_coins": "Add Coins",
		"expired": "Expired",
		"reward_expired": "Reward Expired!",
		"entries_left2": "{noOfEntries} entries left"
	};

/***/ },
/* 488 */
/***/ function(module, exports) {

	module.exports = {
		"about": "විස්තර",
		"accepted_invitation_from": "ඔබ {invitedBy} }ගේ ආරාධනය පිළිගෙන බෝනස් කාසි {coins}ක් දිනා ඇත.",
		"accepted_invitation_from_friend": "ඔබේ මිතුරා {displayName} ඔබගේ ආරාධනය පිළිගෙන ඇත. ඒ වෙනුවෙන් ඔබ බෝනස් කාසි {coins}ක් දිනා ඇත.",
		"account_disabled": "ඔබේ ගිණුම ක්‍රියාවිරහිත වී ඇත. කරුණාකර hello@cricrush.com සම්බන්ධ කරගන්න.",
		"all_entries": "සියලු ලංසු",
		"already_registered": "ඔබ දැනටමත් ලියාපදිංචි වී තිබේද?",
		"can_t_find_account": "අය්යෝ, අපට ඔබගේ ගිණුම සොයාගත නොහැක. කරුණාකර ගිණුමක් සාදන්න!",
		"cant_placed_entries": "ඔබ කිසිදු ලන්සුවක් ඇතුලත් කර නැත",
		"change_profile_picture": "ගිණුම් ඡායාරූපය වෙනස් කරන්න",
		"chat_modal_name": "චැට් කරන්න",
		"claim": " හිමිකර ගන්න",
		"click_here_to_resend": "ස්ථිර කිරීම නැවත එවන්න",
		"close": "වසා දමන්න",
		"coming_soon": "ළඟදීම එනවා",
		"confirm": " ස්ථිර කරන්න",
		"countdown_day": "දවස",
		"countdown_days": "දින",
		"countdown_hours": "පැය",
		"countdown_minutes": "මිනිත්තු",
		"countdown_seconds": "තත්පර",
		"create_account": "ගිණුම සාදන්න",
		"cricrush_league": "Cricrush ලීගය",
		"do_not_have_an_account": "ඔබට දැනට  ගිණුමක් නැත්ද?",
		"dream_team": "සිහින කණ්ඩායම",
		"dream_team_entry": "සිහින කණ්ඩායමේ ලංසුව",
		"dream_team_entry_creation_modal_name": "සිහින කණ්ඩායමේ ලංසුව සෑදීම",
		"dream_team_leagues": "සිහින කණ්ඩායම් ලීග",
		"earn_coins_bonuses": "බෝනස් කාසි හිමිකරගන්න",
		"edition": "සංස්කරණය",
		"email_not_verified": "විද්‍යුත් ලිපිනය තහුවුරු කර නැත.",
		"email_not_verified_to_claim_rewards": "ත්‍යාග හිමිකරගැනීම සඳහා විද්‍යුත් ලිපිනය තහවුරු  කරන්න.",
		"email_title": "විද්‍යුත් ලිපිනය",
		"enter_valid_email": "වලංගු විද්‍යුත් ලිපිනයක් ඇතුලත් කරන්න",
		"entries": "ලංසු",
		"entry_created": "ලංසුව සාදන ලදී",
		"favourite_teams": "ප්‍රියතම කණ්ඩායම්",
		"fb_reauth": "Facebook සමඟ ස්ථිර කරන්න",
		"fb_signin": "Facebook මගින් පිවිසෙන්න",
		"fb_signup": "Facebook මගින් ලියාපදිංචි වන්න",
		"fire_base_already_login_different provider": "ඔබ වෙනත් සැපයුම්කරුවෙක් භාවිතා කර ලියාපදිංචි වී ඇත. කරුණාකර නිවැරදි සැපයුම්කරු භාවිතා කර පිවිසෙන්න.",
		"fire_base_wrong_message": "යමක් වැරදී ඇත. කරුණාකර පසුව යලිත් උත්සාහ කරන්න!",
		"friend_invite_accepted": " ඔබේ මිතුරා {friendName} ඔබේ ආරාධනය පිළිගෙන ඇත",
		"ggl_reauth": "Google සමඟ ස්ථිර කරන්න",
		"ggl_signin": "Google මගින් පිවිසෙන්න",
		"ggl_signup": "Google මගින් ලියාපදිංචි වන්න",
		"go_back": "ආපස්සට යන්න",
		"help": "උදවු",
		"invalid_mail": "අවලංගු විද්‍යුත් ලිපිනය",
		"invitation_accepted": "ආරාධනය පිළිගන්නා ලදී!",
		"invitation_bonus": "ආරාධනා බෝනස්",
		"invite_friends": "මිතුරන්ට ආරාධනා කරන්න",
		"leaderboard": "නායක පුවරුව",
		"live": "Live",
		"live_prediction": "සජීවී අනුමාන ලීගය",
		"live_prediction_entry": "සජීවී අනුමාන ලංසු",
		"login": "පිවිසෙන්න",
		"login_here": "මෙතනින් පිවිසෙන්න",
		"login_register": "පිවිසෙන්න / ලියාපදිංචි වන්න",
		"logout": "ඉවත් වන්න",
		"lost": "නැතිවුන",
		"lost_title": "නැතිවුන",
		"no_email_with_account": "මේ විද්‍යුත් ලිපිනය සමඟ සම්බන්ධ වූ ගිණුමක් නොමැත. කරුණාකර ලියාපදිංචි වන්න",
		"no_network": "අන්තර්ජාල සම්න්බන්ධතාවය අඩාල වී ඇත! ",
		"no_network_connection": "අන්තර්ජාල සම්න්බන්ධතාවය අඩාල වී ඇත!",
		"notifications": "දැනුම්දීම්",
		"or": "හෝ",
		"password_incorrect": " ඔබ ඇතුලත් කල මුරපදය වැරදිය.",
		"pick_your_country": "ඔබේ රට තෝරා ගන්න",
		"play_button": "තරඟ කරන්න",
		"predict_score": "තරඟයේ අවසන් ලකුණු අනුමාන කරන්න",
		"profile": "ගිණුම",
		"providers_str": "ඔබ පෙර වතාවකදී  {providersStr} භාවිතා  කලා. එම ක්‍රම වලින් එකක් භාවිතා කර නැවත පිවිසෙන්න",
		"providers_str_try_google": "ඔබ පෙර {providersStr} භාවිතා කර ලියාපදිංචි වී ඇත. කරුණාකර Google භාවිතා කර පිවිසීමට උත්සාහ කරන්න",
		"reauth_modal_title": "ක්‍රියාව සම්පුර්ණ කිරීමට පිවිසුම නැවත සහතික කරන්න",
		"received_invitation_bonus": "ආරාධනා බෝනස් ලැබුණි",
		"refunded": "මුදල් ආපසු දෙන ලදී",
		"refunded_title": "මුදල් ආපසු දෙන ලදී",
		"register_here": "මෙතනින් ලියාපදිංචි වන්න",
		"save": "සුරකින්න",
		"select_country": "රට තෝරා එයට විශේෂිත  වූ ත්‍යාග ලබාගන්න!",
		"select_language": "භාෂාව තෝරන්න",
		"select_teams": "ප්‍රියතම කණ්ඩායම්",
		"settings": "සැකසුම්",
		"submit": "යොමු කරන්න",
		"target_prediction": "ලකුණු අනුමානය",
		"target_prediction_entry": "ලකුණු අනුමාන ලංසුව",
		"total": "එකතුව",
		"transactions": "ගණුදෙනු",
		"unknown_error": "නොදන්නා ගැටළුවක් පැන නැගිණි. කරුණාකර hello@cricrush.com හරහා අපව සම්බන්ද කරගන්න",
		"upcoming": "එළඹෙන තරඟ",
		"user_name": "පරිශීලක නාමය",
		"valid_number": "කරුණාකර වලංගු අංකයක් ඇතුලත් කරන්න!",
		"weak_password": "මුරපදය අනාරක්ෂිතයි. අක්ෂර 6ක් හෝ ඊට වැඩි මුර පදයක් තෝරා ගන්න",
		"won": "ජයගත්තා",
		"won_lost_refunded_coins": "ඔබ විසින් {earnedCoins} මුදලක් දිනන අතර {lostCoins} මුදලක් අහිමි කරගත්තා. ඊට අමතරව {refundedCoins} මුදලක් නැවත ලබාගන්නා ලදී",
		"won_title": "ජයගත්තා",
		"you_lost_message": "ඔබ පරාදයි",
		"you_won": "ඔබ ජයගත්තා",
		"you_won_reward": "ඔබ ත්‍යාගයක් දිනා ඇත",
		"your_entries": "ඔබගේ ලංසු",
		"your_live_prediction_entry": "ඔබගේ සජීවී අනුමාන ලන්සුව: {prediction}",
		"your_mom_entry": "ඔබගේ 'තරඟයේ වීරයා' අනුමාන ලංසුව: {momEntry}",
		"your_prediction": "ඔබේ අනුමානය : {prediction}",
		"display_name": "ප්‍රදර්ශණ නාමය",
		"email": "විද්‍යුත් ලිපිනය",
		"password": "මුරපදය",
		"runs_cannot_be_negative_value": "ලකුණු ඍණ අගයක් විය නොහැක",
		"budget": "අයවැය",
		"view_button": " බලන්න",
		"score": "ලකුණු: ",
		"rank": "ශ්‍රේණිය: ",
		"target_prediction_leagues": "අවසාන ලකුණු අනුමාන කරන ලීග",
		"live_prediction_leagues": "සජීවී තරග අනුමාන ලීග",
		"target_prediction_description": "තරගයේ අවසන් ලකුණු අනුමාන කර ඔබගේ ලංසු තබන්න. සත්‍ය ලකුණු ප්‍රමාණයට ඇති සමීපතාවය මත ලංසු ශ්‍රේණිගත කරනු ඇත",
		"required": "අත්‍යවශයි!",
		"entries_left": " ඉතිරිව ඇති ලංසු ගණන",
		"end_of_results": "ප්‍රතිපල වල අවසානය",
		"invalid_email_address": "අවලංගු විද්‍යුත් ලිපිනයකි",
		"completed": "සම්පුර්ණයි",
		"dream_team_description": "ඔබගේ ක්‍රීඩකයන් 4 දෙනාගේ කණ්ඩායම තෝරාගෙන ඔබගේ ලංසු නිර්මාණය කරන්න. දැන් ඔබගේ කණ්ඩායම ඔබ වෙනුවෙන් ලකුණු ලබාගන්නවා දැකගන්න.",
		"reward_claimed_title": "ත්‍යාගය හිමිකරගත්තා  - {reference}",
		"reward_claimed_msg": "නිර්දේශනය සමඟ ත්‍යාගය හිමිකරගෙන මුදල් ලබාගත්තා",
		"update": "යාවත්කාලින කිරීම ",
		"processed": "සකසන ලදී",
		"claim_reward_instructions_title": "කරුණාකර උපදෙස් හොදින් කියවන්න",
		"invalid_filed_instruction": " {field} වලංගු නොවේ. කරුණාකර පරික්ෂා කරන්න",
		"reward_processed": "ත්‍යාග සකසන ලදී!",
		"reward_reference": "ඔබගේ නිර්දේශනය : {reference}",
		"claim_coins_message": "මෙම ත්‍යාගය  හිමිකරගැනීමෙන් ඔබගේ කාසි {claimCoins} අඩුවනු ඇත.",
		"weekly": "සතිපතා",
		"daily": "දිනපතා",
		"monthly": "මාස්පතා",
		"lifetime": " දිවි ඇති තුරා",
		"local": "දේශීය",
		"global": "ලොවපුරා",
		"no_lb_status_generated": "මෙම නායක පුවරුව සෑදීමට අපට අවශ්‍ය තරමට දත්ත නොමැත!",
		"you": "ඔබ",
		"leaderBoard": "නායක පුවරුව",
		"mail_sent": "විද්‍යුත් තැපෑල යවනු ලැබිණ!",
		"verification_mail_sent": "තහවුරු කිරීමේ ලිපියක් ඔබේ {email} විද්‍යුත් ලිපිනයට යවනු ලැබිණ",
		"messages": "පණිවිඩ",
		"country_change_warning": "ඔබ රට වෙනස් කළහොත් නායක පුවරුවේ  දැනට පවතින ශ්‍රේණිගත කිරීම අහිමි වනු ඇත.",
		"faq": "නිතර අසන ප්‍රශ්න",
		"how_scores_calculated": "ලකුණු ගණනය කරන ආකාරය ",
		"how_to_play": "තරඟ කරන ආකාරය",
		"live_prediction_description": "කණ්ඩායමේ {endOver} වන පන්දුවාරය අවසානයේ ලකුණු ගණන අනුමාන කරන්න. සත්‍ය ලකුණු ප්‍රමාණයට ඇති සමීපතාවය මත ඔබගේ ලංසු ශ්‍රේණිගත කරනු ඇත.",
		"predict_what_message": "{teamName} කණ්ඩායමේ {endOver} වන පන්දුවාරය අවසානයේ ලකුණු ගණන අනුමාන කරන්න.",
		"pick_team": "ඔබගේ සිවු දෙනෙකුගෙන් යුත් කණ්ඩායම තෝරා ගෙන දිනන්න",
		"your_entry_created": "ඔබගේ ලන්සුව ඇතුලත් කෙරුනා!",
		"fica_title": "නිල වශයෙන් අනුමත කලේ",
		"fica_detailed_text": "FICA මගින් අනුමත කල එකම ජංගම මෘදුකාංගය Cricrush වේ",
		"version": "අනුවාදය",
		"match_help": "Click here to select a match",
		"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
		"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
		"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
		"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
		"more_leaderboard_help": "Click here to check your leaderboard",
		"more_edition_language_help": "Click here and select edition to change your language",
		"more_edition_country_help": "Click here and select edition to change your country",
		"add_coins_help": "Running out of coins? Earn more free coins here",
		"claimed": "Claimed",
		"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
		"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
		"daily_claim_bonus_message": "Claim your free coins now!",
		"daily_login_bonus": "Daily login bonus",
		"daily_login_bonus_claimed": "Daily login bonus claimed",
		"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
		"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
		"invite_friends_dialog_title": "Invite friends to join",
		"live_status": "LIVE",
		"view_entries": "View {noOfEntries} entries >>",
		"end_of_results2": "That's all we have!",
		"leagues_not_created": "Leagues will be created soon...",
		"add_coins": "Add Coins",
		"expired": "Expired",
		"reward_expired": "Reward Expired!",
		"entries_left2": "{noOfEntries} ඉතිරිව ඇති ලංසු ගණන"
	};

/***/ },
/* 489 */
/***/ function(module, exports) {

	module.exports = {
		"about": "எம்மைப்பற்றி",
		"accepted_invitation_from": "நீங்கள் {invitedBy} இருந்து அழைப்பை ஏற்றுக்கொண்டு,{coins}ஐ போனஸ் ஆக பெற்றீர்கள்",
		"accepted_invitation_from_friend": "உங்கள் நண்பர் {displayName} உங்கள் அழைப்பை ஏற்றுக்கொண்டார்! {coins}ஐ போனஸ் ஆக பெற்றீர்கள்",
		"account_disabled": "உங்கள் கணக்கு முடக்கப்பட்டது, தயவுசெய்து hello@cricrush.comஐ தொடர்பு கொள்ளவும்",
		"all_entries": "அனைத்து பதிவுகள்",
		"already_registered": "முன்னரே கணக்கு இருந்தால்?",
		"can_t_find_account": "உங்கள் கணக்கைக் கண்டுபிடிக்க முடியவில்லை. தயவுசெய்து கணக்கொன்றை உருவாக்கவும்!",
		"cant_placed_entries": "நீங்கள் பதிவுகள் எதுவும் செய்யவில்லை",
		"change_profile_picture": "படத்தை மாற்றவும்",
		"chat_modal_name": "அரட்டை",
		"claim": "பெறுவதிற்கு",
		"click_here_to_resend": "மின்னஞ்சலை மீண்டும் அனுப்புக",
		"close": "விலகு",
		"coming_soon": "விரைவில்",
		"confirm": "உறுதிப்படுத்து",
		"countdown_day": "நாள்",
		"countdown_days": "நாட்கள்",
		"countdown_hours": "மணித்தியாலங்கள்",
		"countdown_minutes": "நிமிடங்கள்",
		"countdown_seconds": "விநாடிகள்",
		"create_account": "உங்கள் கணக்கை ஆரம்பியுங்கள்",
		"cricrush_league": "Cricrush லீக்",
		"do_not_have_an_account": "உங்களிடம் கணக்கு இல்லையா?",
		"dream_team": "டிரீம் ரீம்",
		"dream_team_entry": "டிரீம் ரீம் பதிவு",
		"dream_team_entry_creation_modal_name": "டிரீம் ரீம் பதிவு உருவாக்கம்",
		"dream_team_leagues": "டிரீம் டீம் லீக்ஸ்",
		"earn_coins_bonuses": "போனஸ் நாணயங்களை சம்பாதிக்கவும்",
		"edition": "பதிப்பு",
		"email_not_verified": "மின்னஞ்சல் சரிபார்க்கப்படவில்லை.",
		"email_not_verified_to_claim_rewards": "வெகுமதிகளை பெற உங்கள் மின்னஞ்சலை சரிபார்க்கவும்.",
		"email_title": "மின்னஞ்சல்",
		"enter_valid_email": "சரியான மின்னஞ்சலை உள்ளிடவும்",
		"entries": "பதிவுகள்",
		"entry_created": " -  பதிவு உருவாக்கப்பட்டது",
		"favourite_teams": "பிடித்த அணிகள்",
		"fb_reauth": "பேஸ்புக் மூலம் உறுதிப்படுத்தவும்",
		"fb_signin": "பேஸ்புக் மூலம் உள்நுழைக",
		"fb_signup": "பேஸ்புக் மூலம் பதிவு செய்க",
		"fire_base_already_login_different provider": "வெவ்வேறு வழங்குநரைப் பயன்படுத்தி முன்னர் உள்நுழைந்தீர்கள், சரியான வழங்குனரைப் மீண்டும் பயன்படுத்தி உள்நுழைக.",
		"fire_base_wrong_message": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
		"friend_invite_accepted": "உங்கள் நண்பர் {friendName} உங்கள் அழைப்பை ஏற்றுக்கொண்டார்",
		"ggl_reauth": "கூகிள்ஆல் உறுதிப்படுத்தவும்",
		"ggl_signin": "கூகிள்ஆல் உள்நுழைக",
		"ggl_signup": "கூகிள்ஆல் பதிவுசெய்தல்",
		"go_back": "திரும்பி செல்ல",
		"help": "உதவி",
		"invalid_mail": "தவறான மின்னஞ்சல் முகவரி",
		"invitation_accepted": "அழைப்பிதழ் ஏற்றுக்கொள்ளப்பட்டது!",
		"invitation_bonus": "அழைப்பிதழ் போனஸ்",
		"invite_friends": "நண்பர்களை அழைக்க",
		"leaderboard": "Leaderboard",
		"live": "Live",
		"live_prediction": "லைவ் ப்ரீடிக்ஷன் லீக்",
		"live_prediction_entry": "லைவ் ப்ரீடிக்ஷன் பதிவு",
		"login": "உள் நுழைக",
		"login_here": "உள் நுழைவதற்கு்",
		"login_register": "உள்நுழைய / கணக்கை ஆரம்பிக்க",
		"logout": "வெளியேறு",
		"lost": " - இழந்தது",
		"lost_title": "இழந்தது",
		"no_email_with_account": "இந்த மின்னஞ்சலுக்கு கணக்கு இல்லை, தயவுசெய்து புதிய கணக்கை ஆரம்பிக்கவும்",
		"no_network": "நெட்வொர்க் இல்லை!",
		"no_network_connection": "நெட்வொர்க் இணைப்பு இல்லை!",
		"notifications": "அறிவிப்புகள்",
		"or": "அல்லது",
		"password_incorrect": "நீங்கள் உள்ளிட்ட கடவுச்சொல் தவறானது.",
		"pick_your_country": "உங்கள் நாட்டைத் தேர்ந்தெடுக்கவும்",
		"play_button": "விளையாடு",
		"predict_score": "போட்டியின் டார்கெட் ஸ்கோரை ஊகிக்கவும்",
		"profile": "சுயவிபரம்",
		"providers_str": "நீங்கள் {providersStr} முன்னர் பயன்படுத்தினீர்கள். அதே முறையை மீண்டும் பயன்படுத்தி உள்நுழைக",
		"providers_str_try_google": "முன்பு நீங்கள் {providersStr} பயன்படுத்தி உள்நுழைந்தீர்கள். கூகிள் ஐப் பயன்படுத்தி உள்நுழைய முயற்சிக்கவும்",
		"reauth_modal_title": " நடவடிக்கையை முடிக்க மீண்டும் அங்கீகரிக்கவும்",
		"received_invitation_bonus": "அழைப்பிதழ் போனஸ் பெறப்பட்டது",
		"refunded": " - திருப்பிக்கொடுத்த",
		"refunded_title": "திருப்பிக்கொடுத்த",
		"register_here": "இங்கே பதிக",
		"save": "சேமிக்கவும்",
		"select_country": "பிரத்தியேக வெற்றிகளை அனுபவிக்க உங்கள் நாட்டினை தெரிவுசெய்யவும்.!",
		"select_language": "மொழியைத் தேர்ந்தெடுங்கள்",
		"select_teams": "பிடித்த அணிகள்",
		"settings": "அமைப்புகள்",
		"submit": "சமர்ப்பிக்கவும்",
		"target_prediction": "டார்கெட் ப்ரீடிக்ஷன்",
		"target_prediction_entry": "டார்கெட் ப்ரெடிக்ஷன் பதிவு",
		"total": "மொத்தம்",
		"transactions": "பரிவர்த்தனைகள்",
		"unknown_error": "எதிர்பார்க்காத முடிவு பெறப்பட்டுள்ளது. தயவு செய்து hello@cricrush.comஐ தொடர்பு கொள்ளவும்.",
		"upcoming": "எதிர்வரும்",
		"user_name": "பயனர் பெயர்",
		"valid_number": "சரியான எண்ணை உள்ளிடுக!",
		"weak_password": "பலவீனமான கடவுச்சொல், கடவுச்சொல் 6 எழுத்துகள் அல்லது அதற்கு மேற்பட்டதாக இருக்க வேண்டும்.",
		"won": " - வெற்றி பெற்ற",
		"won_lost_refunded_coins": "இந்த ஆட்டத்தில் நீங்கள் {earnedCoins} நாணயங்களைப் பெற்றுள்ளீர்கள், {lostCoins} நாணயங்களை இழந்துள்ளீர்கள், {refundedCoins} நாணயங்களை திரும்ப பெற்றுள்ளீர்கள் ",
		"won_title": "வெற்றி",
		"you_lost_message": "இழந்தவை",
		"you_won": "வென்றவை ",
		"you_won_reward": "நீங்கள் ஒரு பரிசை வென்றுள்ளீர்கள்",
		"your_entries": "உங்கள் பதிவுகள்",
		"your_live_prediction_entry": "உங்கள் லைவ் ப்ரீடிக்ஷன் பதிவு : {prediction}",
		"your_mom_entry": "உங்கள் ஆட்டநாயகன் பதிவு :{momEntry}",
		"your_prediction": "உங்கள்  ப்ரெடிக்ஷன் : {prediction}",
		"display_name": "காட்சி பெயர்",
		"email": "மின்னஞ்சல்",
		"password": "கடவுச்சொல்",
		"runs_cannot_be_negative_value": "ஓட்டங்கள் எதிர்மறை பெறுமதியில் இருக்க முடியாது",
		"budget": "பட்ஜெட் $",
		"view_button": "நோக்கு",
		"score": "மதிப்பெண்: ",
		"rank": "நிலை: ",
		"target_prediction_leagues": "டார்கெட் ப்ரீடிக்ஷன் லீக்ஸ்",
		"live_prediction_leagues": "லைவ் ப்ரீடிக்ஷன் லீக்ஸ் ",
		"target_prediction_description": "ஆட்ட நிர்ணய ஒட்டத்தை ஊகித்து உங்கள் பதிவை உருவாக்கவும். உங்கள் ஊகம் எவ்வளவு அண்ணளவாக உள்ளது என்பதை பொறுத்து நீங்கள் தரவரிசை படுத்தப்படுவீர்கள். ",
		"required": "கட்டாயம்!",
		"entries_left": " பதிவுகள் இன்னும் உள்ளன ",
		"end_of_results": "இறுதி முடிவு!",
		"invalid_email_address": "தவறான மின்னஞ்சல் முகவரி",
		"completed": "முடிவடைந்து விட்டது",
		"dream_team_description": "நான்கு பேர் கொண்ட அணியை தெரிவு செய்து உங்கள் பதிவை உருவாக்குக. உங்கள் அணி உங்களுக்காக பெற்றுத்தரும் ஓட்டங்களை பெற்று மகிழ்ந்திருங்கள்.",
		"reward_claimed_title": "பரிசை பெற்றுக்கொள்க - {reference}",
		"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
		"update": "மேம்படுத்த",
		"processed": "பரிசீலிக்கப்பட்டது",
		"claim_reward_instructions_title": "தயவுசெய்து வழிமுறைகளை கவனமாக வாசிக்கவும்!",
		"invalid_filed_instruction": "{field} தவறானது. தயவுசெய்து சரிபார்க்கவும்!",
		"reward_processed": "Reward Processed!",
		"reward_reference": "உங்களது  குறிப்பு இலக்கம்  : {reference}",
		"claim_coins_message": "இப் பரிசை பெறுக்கொள்வதன் மூலம் உங்களது நாணயங்கள் {claimCoins}ஆல் குறைக்கப்படுகின்றது.",
		"weekly": "வாராந்த",
		"daily": "நாளாந்த",
		"monthly": "மாதாந்த",
		"lifetime": "ஆயுட்கால",
		"local": "Local",
		"global": "Global",
		"no_lb_status_generated": "உங்களது leader boardஐ பெற்றுக்கொள்ள போதுமான தரவு இல்லை!",
		"you": "நீங்கள்",
		"leaderBoard": "Leader Board",
		"mail_sent": "மின்னஞ்சல் அனுப்பப்பட்டது!",
		"verification_mail_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் {email}க்கு அனுப்பப்பட்டது",
		"messages": "தகவல்கள்",
		"country_change_warning": "நாட்டினை மாற்றுவதன் மூலம் தங்களது leaderboard தரவரிசகளை இழக்கநேரிடலாம்.",
		"faq": "FAQ",
		"how_scores_calculated": "கணிப்பு விதிமுறைகள்.",
		"how_to_play": "விளையாடும் முறை",
		"live_prediction_description": "{endOver}வது பந்துபரிமாற்ற முடிவில் உங்களது {teamName}அணியின் ஓட்ட எண்ணிக்கையை ஊகிக்கவும். அணியின் உண்மையான  ஓட்ட எண்ணிக்கையை வைத்து தங்களது பதிவின் தரவரிசை கணிக்கப்படும்.",
		"predict_what_message": "{endOver}வது பந்துபரிமாற்ற முடிவில் உங்களது {teamName}அணியின் ஓட்ட எண்ணிக்கையை ஊகிக்கவும்.",
		"pick_team": "நான்கு பேர்கொண்ட அணியை தெரிவுசெய்து வெற்றிபெறுக",
		"your_entry_created": "உங்களது பதிவு உருவாக்கப்பட்டது!",
		"fica_title": "Officially endorsed by",
		"fica_detailed_text": "Cricrush மட்டுமே FICA ஆல் ஒப்புதலளிக்கப்பட ஒரேயொரு செயலியாகும் ",
		"version": "பதிப்பு",
		"match_help": "Click here to select a match",
		"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
		"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
		"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
		"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
		"more_leaderboard_help": "Click here to check your leaderboard",
		"more_edition_language_help": "Click here and select edition to change your language",
		"more_edition_country_help": "Click here and select edition to change your country",
		"add_coins_help": "Running out of coins? Earn more free coins here",
		"claimed": "Claimed",
		"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
		"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
		"daily_claim_bonus_message": "Claim your free coins now!",
		"daily_login_bonus": "Daily login bonus",
		"daily_login_bonus_claimed": "Daily login bonus claimed",
		"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
		"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
		"invite_friends_dialog_title": "Invite friends to join",
		"live_status": "LIVE",
		"view_entries": "View {noOfEntries} entries >>",
		"end_of_results2": "That's all we have!",
		"leagues_not_created": "Leagues will be created soon...",
		"add_coins": "Add Coins",
		"expired": "Expired",
		"reward_expired": "Reward Expired!",
		"entries_left2": "{noOfEntries} பதிவுகள் இன்னும் உள்ளன "
	};

/***/ },
/* 490 */
15,
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(88);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(88);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cc_logo@3x.2eac099b.png";

/***/ },
/* 494 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 496 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAAFjlJREFUeAHtXQmYXUWVPnUT0unsJOlsJN1JZyUJZGEJaEJAZQAN4AgzOIq4sIpKRFRQxhGXUQQHR0GCYhBQcICBDxlBh08hkGEL2UMWspCks4d09rWT3Jr/1Ov3vP1e1ev3ul/3q9f3nO+rd+89Vbdu1X//W6+WU1WKmiFa65Nx+4fh+FgJVwVXDdcZTkQQaC4ChxBBDdz6+uNKHF+Bm6uUCnFskqh87wLRz8M918B9BK5PvvdLeEGgAAjsQRxM/qfgHsMHoPOJM2fSg+wjEPHdcJfk8wAJKwi0MALzEP90EP+1XJ/TKOlB9naI7E64r8K1zzViCScItDICT+B514P8/C+QVbKSHoTvhrufg5uaNRbxFAT8QIDr/OeD+NwOcIqT9CD8INz1Etww593iIQj4h8AOJGkaiP+WK2lW0oPwg3HDHLgK141Gf7SWdO2rRLWvkN63lKgOz6vbThQeyXqbeAoCOSGgTiDq0AuuglTnoUS9ziXVG/0nZf0au70OAS4C8bnQzpAM0tdXabhx4C7hj+0lveYu0jUPEunjGZGKQhBoSQRU30tIjfwBUceTsj1mLzzHg/hr0wM1ID0IHyAAfx3OOrze/gLpZTejRK9Nj0uuBYHWQyAoIzXs26QGfynbM1fB83QQnz+AlDDJo3IjLtyEX3cf6YVXCeGjiMl5cRBAFVqv/C7ppdOz1TaGI3H3pCcwVdKjlD8Rnmvg+JghesWtqM7MzNCLQhAoNgKq13mkJj5OxG2ATNFQnYbSfkHSK1rSo5LkIPy6+4XwScTk6B0CuvZllPg3udLFBfuMqKchPUr50VDeEPVInuvaWaRX3ZG8lKMg4CUCevNTpNf+wpW2SeD45UnPZEn/FSh45LWhcL1p8bWoM4UN9XIlCHiIgF79I6KD61wpuyXpkST9pUlF9KjX/4ro6K6oSs4FAX8R0MfQlc4WM1bh0r43+wQ4OQ3H/rZguuYBm1p0goC3COgtT6Og3mlLH9ftp7EHl/SX8Em66D1o7B7B6KqIIFBSCGjS2553pfhi9mDSj7OG2M52ZiKCQAkisN1J+omcGyZ9X2u29iy0qkUpCPiOgN4zz5XEAezhJL0+ssV1o+gFAb8R4M4XfdSWxg5ow3Zm0g+0+dLhTVa1KAWBkkDg8FZXMvsw6a1jt3Sc5+SKCAKliYA+tseV8O5MehFBIFYICOlj9bols4yAkF54EDsEhPSxe+WSYSG9cCB2CAjpY/fKJcNCeuFA7BAQ0sfulUuGhfTCgdghIKSP3SuXDAvphQOxQ0BIH7tXLhkW0gsHYoeAkD52r1wyLKQXDsQOASF97F65ZFhILxyIHQJC+ti9csmwkF44EDsEhPSxe+WSYSG9cCB2CAjpY/fKJcNCeuFA7BAQ0sfulUuGhfTCgdghIKSP3SuXDAvphQOxQ0BIH7tXLhlu32YhaNeFqBwLMnccSIq3U2/XCZs+7yBd9z6OcEf42Io7rSjsY1eGXY46YNsjONWhF5bOhcM+SYTFRvVRLDiK9NH+5UTHD7TZ1+JDxtoO6TsNJXXSp0hVnG+ITu27WfFN7RbNvoc3kH7/r6R3/JVo52yQ7aD1niYr23cn1fvDRH0uwPEjRLh2yd/ThZ0cD6whvXeRSZPe9ifzUbjuy6rvNo6Cs/6WGWTvQgrfRHoKLe17UHDGs0Rdx2bGfGgthW9hy6e6bZl+rawpbdIH5aT6XQKyX4ltn8/OH7qOg0gN+rxxxNuHbn2W9Oof42PYmH9c0Ts69CE14ruk+l+GXazzhRg1zs7DScFR/8tJjb6bCB9muOkPOP45+hS/ztt3peD0/7YT/vBmCt/+hBeEZ9DyfSOeAB2QGvp1UlVfRA66FiZNQRmpAVfgI/o46Q0zsTXjPShhd+cZN9JVeQ2pYd8qXLpUB/xTfJQCONo9h8J3/5Voz/w809XCwVGVDE57iqjb+MwHoSoZzgXh8a/qi5ReQxZ19ODMP4H03ywcsaJvg8lfdSMF52Dfol4fivo0ch5QMP5hUqOwgW+hPsT0J/Y4k4JJ/4u2ypB0n+Jdo60UTMS/UPfTM9OAQiOcdzk2NF6d6VdETWmV9H2nUTDm5yCVu25sxTLErip1O9GA7InFycutQTKUeEYw8XHSS6eT3vxEhne6Qo35mSmR0/UZ15yWI9ga5vAW0jgqrv6ccGKigdt5GKpD9o1hUvGgPk6oH3shQUcKJvzeXrU8vh+E/2eifUu9SGo0ESVDenXyXah7fyGadvv50VpDUr3rTRBrEwiCv9XoZrrcq1PWl9SJZ6HRewFK83MTPTu22EBINfaXptdFr/1PWwijU0Omo13xaac/txF0zYOJj4d7aCKiI+eEfxnqdioplOiq76UoPc0OkNEQiGdmg+uiXaDaFUx4lKjnOZlJwIcdzgcevlXD6lNaEqRX1ai/ZyU8qFP7KumNj5Le/oJrZ7lEllEC0cH9pA+ih2TTYyj5O5q41dCv4R+kR+YLZA03Kon7VxpQlH3wwXQmNeQrifP0XzxLL/0qGsjPwQe9Mo0JGtO0+23S7NbhY+MGLfdIcd7xHMKuedzYLrqgMAjGP2Sv/mFXv3Dh54l2vVb0ZLoS4D/p0eWnhqH+7hJuKC25EaR/2RUiuz48THr9/fgAHsdzbjMN0egNeuPvSC/DB2EjPLRq4GfsHwu//AVXodvx1Wh0+Z0fWEV65ffwAcxAG+YbaFjvw7dzOL84Ch0a4w3BqQ8SVVyYGbM+TuHi64m4C9hj8Zv05VUA+FeAL7BDiL71cPENhekKQ6NLr7iNaO8CUmNQlUHdWtf8JqGzP91oDekt/no5PtTmED4aJwbR9HKQvuiiSJ1yP7bbvtiSEmxPj/YPbeN/Nb/FX9JzI2n8I/ZSFJjqml+DkLfzWUER5karRltA9ZyS6LPPGjs+xk7VmSFQ4uktz2TqS1yjxt6LLl2MPVhEL78NbZb/svj4p/KW9KYeaxvZYwxRguoV6K8uMOFTr2fn/5GGa1TYvMHW27JvcZszJVCj/wPjGJ+0QqJX/dCMbVg9PVQ66g3FT6mqRGPIJjy6t+ha+OTQMLTdX0hdxwHW2PShGqu+VJVq1J1ou3zWmnz93s8oW8+W9aYiK/0kPQ8KWQdgQhD+C+jFqC0ybPWPP7LFmg7VZZRVX4pKNeJ7GY37ZD5MN+zqf09elszRS9IHlSC2TWCDQnvm2nyKozu0ETWsusxndxpG1GV0pr7ENGrY7aQGf8maau7t0itgblGC4h/pYWZAFf9ghTLc8FurvnhKVLEOrs98vOnWeyDRt57pWxIaVX0LqeqbrWk1hnkYfyhV8Y70ig2rbF2UbLDkYf+vfv8v9nePkj6Y/BYsLWF7UmKihtyEMQtHKf7+i6SXoJvYhzZVE3H1jvSEvnmb6I2PQV3Y7knbc/LVcUOugZlDNIKyfujXfsAYyBFs20tBVNX1pIb/mz2pPC6yCB0MPPGlhMU70qvyQVY4tYeGSyahx/bCDPkua5pTyh5nmckcwQdfB6G+AwOtD6CrEybDnomZWzDS0TBFWypccCUKeJhKlLj410/vID0drvEWah65NdMSB385exo7jyA1hB1GLtmcYPdcMx6gd76SMM7CoFaxxNj4wKjPKvuXwWLyijYz9uAh6SutuBtrSbuPF1q98g6YDG8jNfL7SI9qPE0YcaaekzHyC0e3JexqYKSld7wMo7nnE+bHjcdSkBCq/z8lTC9c6WbTZ04v7SnI84odiV/VGzb7tdnKowpB7DwXvX5GYu5pLUrufIUnnsCIS538EwqmLsFc0/+BdeXVwAP6FhQ2YVZj78MTslABE9qDCb9DEJg+twHJktM2kLtiZAETusN5l5kpcsYMuEmTzfFPgTm/5gOYMt/M5GqRNgB6yhQb9PFKDY0JbPsVT+BpA+IX6dnWHcthZAivbOBY3SAjrC8Ktg9afA2Fs0aZo94KA7S0CSQ5JRVVC64yBZNfN/b1Od2TSyCszhCMQ1skj4nr3P2qhpRu/3wSFr9Iz6ly2a24GrjJnPh6RElvBnMWX2c+gPCNqaTfRZfgjr/l1zAsH4yuT0yQ6XFG83PKJtvjHwbhLT1IbCHKk2scooZ/225L7wjvo9pD0mMQyiYdHQ1cW1ifdeh65Ukr4fwrKHxpKIVzLoIJM7oJMVuq0QEflPrB6fjHwBo/zZJUwzQtFib8ki8m5gW/d0+aZ/ISE+BPxWhzCdsXeUd6zXNaLaK6jrFoS1zFgzw8NRADXEz+cNZoM1OKuJrnEkxsD0be4fJthj4k/c6X8a+EjwqiV/8odZ4RKS/5MQH/Bif0zPAqBYV3pKdD6624qYGYaOzqUrPeUYJKXnZw3b0Uzp6ESShPujNQcRG6O6e4/fP2YcLfhGc+1eBOvQTjDrvfaqBLXaSqSP71eqfS6DjxjvRmYrfNrgOrkREvjRcHwdJ3GvN+zSJJmGtrE9XvEzZ1E3Q8ze9m+6wnWJCaUdiD79njxcgyr1JRauId6c2SejBqskmAJfhiJdwDtOZua5ZV52qrPj8lCL/s61kbrrwCQzj/k077IjXwKqe9fX5pab3Q/pEeeQ9rHrIjUIGS3raSlj10m9DqDY/Y89Hcxixi1ctvxbIpjvijT0VJb1Z2cNjdKLbX6TU1eofX516SnmpfcqzihZ6DcfggeInruAjPErOt9FvWD02cdk1GgSeA6A2OwsUW6+43Tb3f5sXpCMbNtE+St95QXKWfpAcmusYxYQTzUoNxDyKEt0kv7BvlwSM2z0gXXmO/qQZq+5YAX8YwP9Fbnza9Ota7eJlu7tFpYbMJ67PzVHrLHFMK7XvHnh0sJadG/RB+yu7fXC2W+1Ojfpxb/LzJQnllc5/ovp/t8Hl1s3Q5uDZdk/t1Uz8WPEGj/15v/oP9WViRzZT4nhdI3pKeTW/DhZ+1myUAclV5XWKgpkNf+wtoopaNvNi4SlVe27ghFqeDVzg++5UWmyGVmEmWmRl9YGWmspU03NtjNrGwPQ+T+hOWpjZPP3T+kp7xQZ+9WSbONWMKfdXBB2ahEXVe89HkjRR4MSNYOSarTma9+mwGWbAHUjyJHX/pPENK8XJ3BWhgJjNjno+pezbRG39vU7eODoNqpkByfHiq6gazBmfrJCb/p/hNes4P5sVmnZnUoQIbAjwJ93RipV/b4kvZcOEFWKu/RsGUOVjM6F8yQqp+/5hoPFuqUqry6gb1bRN28puwa3kUNjJnZsSVswJ5UAM/B6vGX+AWSxWOF0ct9qoQMPU2XZnctrCIGv1TYDDJ4lN8FVpJ/ovpq+bltUEEu4AY6DJT7HJZqrtjfyzVjYGVPhcmlprOaieO0UpjH68bPpq3/qm8vqHOXCEtyZ1D0NXH95qZUbWznVW1VCRY60cNvDKx7De3FWyC+ni42pMBIRgHhgs+Ddv/P+LPsbxhankpbyzLaPa2au52Rg1jbvZVSZCec8mDKATimM0PspkZozuT69nsUtKUTRn4Zm5X8Cq8PJMpXdrhJR94N7GZQrpf8hrrXCp2ZlAtRNcjSsUjO4yJsT66gxQThbsey/oknM3qMRlX/VEvu8WvZbCxBn0II7Vg3G+RwrR/JXy4vGlDOOejhd/ELg2XfC79r95EcqO3/ZHCN87FX/u8iDaHUyYXrzuZXhpluxV94+FcLFZqIzzfh40ewrexP9WqH+CLPJotpno/QM2Nbjac438kXgiVlzvhjRd4rZ9cCM/Ldm8qYl3elUvsgMhLilsF65EGp8ywehVLWVKkNyDxX+qcjxnLxKzWiE1FlDdSWPMTGH2hTu4ytkrFjWH8tT/HX/j5xB9kiy2NYUZEP2WM0VKP9uxEr7sPo7sP21PV52PkXEfHfkeLakuP9AwHeg/YBj2cNQbGUujdMLbozcSJyY4RynD2GQl7l3w2MMZ4gl50NYWvTkh8jIVaaxObMPCKwOFrk7Gdpt0eqZm5LujtbNZgJsdYYjUrpqFTwAdRGmJLSPiioyFlC+yDjpfX4EagWfwV1QXbKGZ6OnkLHrN5Mgi1E9PxcqqmpEdiuWbzAGwvqXp+0DSYTS9GriOV2InPpIlJvuuN5qWptTdPZijY1v5MtIFs8x94L6o5F2Pji4UW0AqrUmfPImVf6n1C2yF9Ombc2OV6POrLqhwfQYCpcWhEam5MmgbldtTLYdfSKoI/VB617QCbITjFky/YsQEX9zbVsX0Nu/q0tUqa2vZDspG+ZHpv8n5FvGTIfnbLXUNbeUfZ9BvQc3NoXcIhEutfa9MjlzvzRKA06/R5ZlKCCwJRBIT0UTTkPBYICOlj8Zolk1EEhPRRNOQ8FggI6WPxmiWTUQSE9FE05DwWCAjpY/GaJZNRBIT0UTTkPBYICOlj8Zolk1EEhPRRNOQ8FggI6WPxmiWTUQSE9FE05DwWCAjpY/GaJZNRBIT0UTTkPBYICOlj8Zolk1EEhPRRNOQ8FggI6WPxmiWTUQSE9FE05DwWCAjpY/GaJZNRBIT0UTTkPBYICOlj8Zolk1EEhPRRNOQ8FggI6WPxmiWTUQSE9FE05DwWCAjpY/GaJZNRBIT0UTTkPBYICOlj8Zolk1EEhPRRNOQ8FggI6WPxmiWTUQSE9FE05DwWCAjpY/GaJZNRBJj0B6KK1DlvYiAiCJQoAsq9E81+Jv02a77K+lvVohQESgIB3n3GLludpFeuzXvtEYlWEPAHAewCT8q6yc5RpVSWkr77eH8yISkRBPJAQHU7xRW6hj24pJ9vDdH7fKtalIKA9whUXOhK4iL2YNL/2RZC9TwH2yN2snmJThDwGgFVcYErfdjrE6RHHWcujtjLMU3Qe6MGfS5NKZeCgN8IqBPPJuo83JXI59iDS3oWe2lf/U3sd9ojEUJ+BQHfEcCm1erkn7pSuQAF/A72TJL+XmvI9l1InfJrtISTwayhRCkIeIGAGnY7UZeRrrTMSHoYNtdXcZ5OKqNH1ftDpIbfEVXJuSDgHQKq/2WkhtzkStdKeDyU9IwW4d+A8njSI3pUg28kVXlNVCXngoA3CKheU0mNvS9bem5FwZ7idor0UK7FXTNdd6pRd6LE/47LW/SCQFEQUAOuIDXxSVTBT3A9fz64/WzUU0UvtNZdcf063NioPnqutz9PesW3iA5vjqrlXBBoXQTadydVfQtxLSSL1MJvEki/JhqmAenZA8TviwMPWA3ga6voo6Q3P0FU8xvS+96xBhGlINAiCJRXkTrpM6SqrmtsHIkNKaeA8AvS05FBeg4A4nMTeDZcBV9nlbrtpGtnEe2eR3r/CqJ9S4mO7c56i3gKAjkhwJaSXUaQ6jKKqNt4Ur3OJepUncutdQh0KQj/F1tgK+k5IIg/CIcX4fBEEUGgZBDYjpROA+HfdqU41ZBND4CbNkB3BtwL6X5yLQh4igDXtSdkIzyn20l69sTN+3GYBnclHH8EIoKAjwhwffpWuNPA2UZ7WJzVm/ScobpTBt10OAx7Ubd0f7kWBIqAANfd74f7Psi+K9fn50z6ZIQgf0+cc8l/GdxkuKz/FvAXEQQKjQCbCD8D9wjIvj7fyPMmffQB+AB64/pyOO7Xr6p33LzG1BURQaDZCBxCDDVwTGw+Lod7BkRfh2OT5f8BLDLoraa7yz0AAAAASUVORK5CYII="

/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default@3x.dadcaa8f.png";

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default@3x.4abbf878.png";

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAAEKhJREFUeAHtXVtsVccVHQMxD8c2BszDD14xGBcSCqZJpNBUKG2kSrRR1Hz2M2r70SqVqiof/Wt/KvUzUqNKaaV+9KOqmo9IfagfSE1ToiaByAkxCeZhIDhgMIYEYjDB7l4Og46PZ597r33neF+ftaXx8Z3X2bNm3Tl79sy5U+fmIJOTkz1S/CkJuG6UsEnCVgkNEihEYK4IjEkF5yScvXc9Idd/S3inrq5uQq6zkrpKSwnRD0iZ5yV8U8LaSsszPxGoAgLXpQ6Q/y8S/iRfgMlK6iyb9EL27VLxbyR8t5IbMC8RiIzAEan/BSH+f8u9T0nSC9kXS2W/lvBTCUvKrZj5iEDOCPxZ7vdDIT+eApmSSXohfJOUfk3CNzJrYSIRsIEAbP5vCfExD1BFJb0QvlNKHZLQpZZmAhGwh8AVUemgEP9/mmpB0gvhN0uBtyS0agURf+vWLTc0NOQuXLjgRkZGpj6PjY25u3fvZhVjGhEoC4FFixa5ZcuWueXLl7vm5mbX3t7uOjs73YoVK0qVH5cM3xbiY9CeITNIf8+kweRAHeHHx8fd0aNH3QcffOAk/4xKGUEEYiKwZcsW9/jjj7uGhkzP+Keiw1eF+GfSukwjvRB4kWTAt0O14QcHB90bb7wxNaqnK+NnIpAXAosXL3a9vb3ukUceybrlgCTuE+LjC3Bf0qT/saS8dD819c97773n3noLVg+FCNhAoLu72+3fv98JsTWFfi9pzycT7+eUUb5FEk5JwHWGHD582PX398+IZwQRmG8EOjo63NNPP+0wBwgI7O9eIf67Pi2Z61cSGST8+++/T8J7xHg1h8DHH3/sXn/9dU0vDOwvJxOnSC+j/Fck8kfJBP8/PDM0aTwavFpF4OTJk66vr09T7zHh+HM+0Y/0P5EIrLxOE7geDx06RA/NNFT4wSoCR44ccZ9+Om3OmlT1Z/6DJ/0zPiJ5PXbsmLt9+3Yyiv8TAbMITExMTLnSFQUx2q9B2iL5p1euG0IZQXoKEaglBGDmKAM1bPuDaAtG+uCuycuXLzusrlKIQK0hgLUkRb6DeJB+dyhDRsFQdsYRATMIZHB3L5QE6deFtMVITyECtYjA8PCwpnYbElTS37x5UyvIeCJgGgHY9JjUBqRe5rANIH1HINGR9CFUGFcrCHz++eeaqmtB+gdCqV988UUomnFEoCYQUDw40L0ZpKcQgUIhQNIXqrvZWCBA0pMHhUOApC9cl7PBJD05UDgESPrCdTkbTNKTA4VDgKQvXJezwSQ9OVA4BEj6wnU5G0zSkwOFQ4CkL1yXs8EkPTlQOARI+sJ1ORtM0pMDhUOApC9cl7PBJD05UDgESPrCdTkbTNKTA4VDgKQvXJezwSQ9OVA4BEj6wnU5G0zSkwOFQ4CkL1yXs8EkPTlQOARI+sJ1ORtM0pMDhUOApC9cl7PBJD05UDgEllhr8UMPPeSam5tnqIWzhDJOjpuRv9yINWvWuI0bNwaz4zjRS5cuBdMQuXbtWoeDe9OCMihbbVmxYoXbtm2bwxHxabl+/bo7dQpnX4dF0zWcOxyL33zHiZM+4Hgm/KQ7fha7lo5qMkf6MNxxYletWqUS/uLFi5mEj6ORXuvy5ctdV1dXkPCfffaZO336tF64Sik4kRvhgQe+/HX3hoYGh0EDMj4+7kZGRtyVK1fcnTt3qnTHONUUlvQtLS1u06ZNQVRxfMvQ0FAwbT4ily1bNjXCL1kys7tu3LgxNcLLCRvzodr9e9bX17sNGza49evXT5EfTzo8ESxKIW36lStXus2bN7u6OpyyOF0wUuHYdSuydOlSlfAwK2DSKEfNzEsTgClG/56eHtfU1DQvOpS6aeFIj47YsmVLkPCjo6Pu3LlzpTDLLR2jJ2x4b04kb3zr1i03MDBgdjSF7jDH8ES1JjOfl9Y0rKI+IPzWrVuDhMdEMOMoxipqUV5VIPr27dsdyJMWHC1TLcJfvXrVlXuSJMwr6IOnD/TDFZPrLMETFabXtWvXsrLlmlYY0jc2Nk4RHhOxtPiJ4HzbxV6vLMJjwgjCV2uyiHrmcqgeJtiw5WEyhgTmDojf398/NdkN5ck7biYD8tYgh/vBywBXaIjw6HDYxVYIj9EUJg1G0bTg8DsQHsS3InBVwnN0/Phxh8EjJMC9vb09lDQvcQue9CA8bMsQ4TERhP/fykTQEx7emrR4wmecmpcukutnkB+Dh6YfbHv0hQVZ0KTP8m1jIgjCW3GrYcEJIzx0Tgu+lCCU9QUg6IlRXxtEsC5iQRYs6UEebfXSTwStnJVbDuHnYnfnSTR8MbXV6NBKe566+XstSNJnLeZUeyLogZztFWYXzK+QFwTzDIycmq0823vGLgdPWEi85yeUlmfcgiN91mKOt4utTATh2QDhQ7YuCH/mzJko+41iEwz4amZjyAUbW590/QuK9ABUW8xBJ8DzoU200sDE/uwJ/+CDDwZvhUUyS77toJIZkdr8I7SVIqOaKEkLhvRZvm1MrDBp1ToiCrIZlYLwcKFi7SAk58+fn9q/EkqrlTg4CkJC0odQmUVcKcLD82FlIgjCY1VY25eCjW7lrpDOAqrciqBPQlKtRbVQ3eXG1fxI733bocUcixNBrE5qXgxsZ0ZYCBKamKNdFuZTNU167+oLLeYA4MHBQVMTQRBe24CF0d3SdmbgN1vBQKSN9BbmVDVLehAeG7JCiznorLNnzzrsmrQi2LuvLc7g5QvY8QtFtFEezgTNq5Nn22uS9CA8XH0a4QGgBdeY78jOzk63evVq/3HGVRsVZ2SsgQj0Ddobkhive4buUyqu5kjvF3NCvu1kY7N2/iXzxf4f79C2trZm3gaT2tC7tpmFjCbifePQ/ArqZr1vnGdzaor03tVXivAeQNjQWU8Dny/WFTsL8UJ2OYJ8/n3TcvJbzINXBbU5C0Z5bPCzIDVDej/Ca77tEJgoA3/4fPiG29ra3Lp160JqqXEwC7TFKrWQgQTMVXbu3OnQZk0seaVq5iUSEEKzfeGDB8FDozpsexD/xIkTue2ZBwk0XbEVAi9zh1668D78Dz/80IRrL0RgDCAwX9A+XDFX0bxnvjy8UmizFakZ0mskAuGxvQATqB07dgTJBnMItiY8OnmIpisIjy8f3HaYiIeeWiAVvqQfffSRukW3mm2ASaWZJOn7QDcMLpUICG9plIfulbWgktbmkBeE9y+BYKUPK6/aXm6MSOXa1zFU95vdsDzvF820pXo8sfDyeh6CwQJPw3JCpYT/5JNPzBEemNYs6f1bT0m/L+KwM1ETeEi05X+tTDXiPeGTe3+gN76wSAsJVm2zbORQGStxmLTCRAPpLUpNkh7kgUmTJLwHF3u5s363BiNoKRvU11WNK3SErknC+3qxJJ/1dII3RFvQ8nVYusJuh1mGL7MVT00In5ojPcgDuzhEeN9A/EIZQkjwOIfNjGtsySK8vzdMNGyX0ARzEW2FUyszX/GYq6A91qVmJrIAMmuETwON0R7ehdDmLsRjpyNG4FgCwpc74mHfPF6xC/1igHe7wlyIsUOxkt+9wXwJARN1TMTTNj7mTTBtLG3/CPVvzYz0mPSBpJoNHGoc7HvtMQvPibZcHqqrkji/f7+SUQ+rlfhJwZCAZHg6waVZbfG/ewNdSwUMOhjNYcZom+OyXMvV1n229dUM6TESVkJ4AALywWbWtrNie0CMVVCQtxLC+87D21La/hSYOFhhtiIwH0Pv7sKtaUnPEF41Q3q4+WYj3pWpzQFirILOVle0Dy+Chya9SIM/HZNbK4K5SGggwlO00tXoPNtUM6SfCyggEUydEBn9KqiVXZneNNLsd7gxQ/OUueAz27LQUdsSDT1DK+SzvVc1yxWC9AAMZoPWQX4VND0xqybQldQFMvlFt1A5uF2tEAqTVkyG04LBRPt16HTevD8XhvQAFra2tr01z1XQcjrZP51Ceb1HB19WC4LBJDRvwnqIxS3ThSI9CIIJseZSg9kQchvOF7Gw0KY9nWCOaT87nre+mC/Bvg8JnAXzsQoe0sXHFY70aDg6SPOuYAJmaRUU785qC23YhhzL7eoJUu4VbkxtYxlelbTyVEJ7Ckl6TGjhytReUsYqaLkvqpRLirnkw0Kb9lN5cLnO50a6ZLuw1ya0LoJ1Bu18r2T5vP4vJOkBLlxtIH7IlQmbGaaDtkU4r85J3idroQ0mmQUTAoMJnqLwQKUFpmOMNZH0fcr5XFjSAxys8sIvHnJlxlwFLadj0nmyFtq8pwTbK+ZbgKn2q8WY1FrQsdCkB0Gwqqi9XGJtFTRroQ0b6LAfJo+NdKW+WJiHhFaW8QS14Mask1EuuNT5yiuvlGob04mAWQSeffZZ7WdX9hR+pDfba1QsGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0WApLfaM9QrGgIkfTRoWbFVBEh6qz1DvaIhQNJHg5YVW0UApL8ZUs7KQcIh3RhHBEohkHFe2A2Q/lKoAkun64X0YxwRyEIAx40qclElvZVj2BXFGU0EVAQwyiuWyh05lE4f6a0cf6i2jAlEQEFg9erVSoo7hwSM9EdDOaycRB3SjXFEIAsBHH6tSB/iQfp/hDK0tbWZOto8pCPjiEAIgQzS/w35F4mN845cL6cL4zzSnp6edDQ/EwHTCKxfv96tXLlS0/E1JGCkhwRH+71795o44flLFfmXCGQjgJPTn3jiCS3Tu5J+BYme9C+FcmIWfODAAYfKKETAOgL79u1zLS0tmpov+4Qp0t8zcf7qI5PXjo4O9+ijjyaj+D8RMIdAV1eX2717t6bXCUn4g0/0Iz0+/1zCXZ+QvD788MNu586dySj+TwTMINDe3u6efPLJLH1elIH9Pren2S2Tk5O/k5I/0Er39fW5t99+W0tmPBHIHYFt27ZNET7DBD8qab1JxdKkb5TEwxJ2JTMl/x8cHHRvvvmmu3kzuGUnmZX/E4FoCNTX17s9e/Y4WCEZMiJpjwnpTyXzTCM9EmS0XycXLFi14XNIJiYm3MDAgOvv73cjI6iXQgTyQaCxsdF1d3e7Xbt2lVpHwqj8dSH8u2nNZpAeGYT43XL5j4RWfM6SsbExd+HCBTc8POxGR0fd1atX3e3bt7OKMI0IlIUAvIfwucMj09ra6mC7NzU1lVN2XDI9I4T/ZyhzkPTIKMTvlMu/JOzAZwoRqBEEhkXPg0J4dfKZ9N5Ma5MUOi8RX5Pw92kJ/EAE7CJwTFTbk0V4qK6SHolS+IZcDkr4vgR8CShEwCIC10SpFyX0CmeHSimomjfpgmLuLJW4FyT8QkJZhlW6Dn4mAlVGALb7byX8Usg+Wm7dZZPeVyjkXyX/Y+T/noT9EjKfFpJOIQLVRgBbhF+V8Ech+9lKK6+Y9MkbyBdgjXx+TgL8+pvuha1ybZBAIQJzRWBMKjgnAcTG9biEV4Xog3Kdtfwfd1ehruMZ0YEAAAAASUVORK5CYII="

/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 504 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAADFZJREFUeAHtnUtsFMkdxsvvx+AXfmBsjzcsOA7hFTBhkSBEaBOkSCR7yB5zXCU5JNpIUbSH3JJLpBxXyiqHRMohhyjKHlbKQzkghRBQYAEZsCMBVrxgGxg/IGB7bAPj/D8v7e7pqWr3zPSM21vfXyq6ul5d9atvaqpqynSFKsJWV1f3SvY3xeHaL+41ca+LS4ijkUCxBNJSwD1xn7y63pbrP8R9XFFRkZFrQVaRby4R+mnJ8464r4nryjc/05NABAT+J2VA/H8U93v5AKzmU2Zo0YvYPy8F/1Lct/J5ANOSQIkJXJXy3xXh/yvsczYUvYi9Sgr7hbgfiasOWzDTkUCZCfxBnvc9ET++BQItUPQi+GbJ/ZG4rwaWwkgSiAcBzPm/LsLHOsBoRtGL4JOS65y4PcbcjCCB+BGYkSqdFeH/21Q1rehF8J+TDJfFdZoyInxpaUlNTU2pyclJNTs7u3afTqfVy5cvg7IxjgRCEaisrFT19fWqoaFBtbS0qN7eXpVMJlVjY+NG+VckwTdE+Bi0cyxH9K+mNFgcGEf4lZUVde3aNTUyMqIkfU6hDCCBUhLYtWuXOn78uEokAnfGn0odviTC/6+/LlmiFwFXSgJ8Ooxz+PHxcXXhwoW1Ud1fGO9JoFwEqqqq1NDQkDp48GDQI+9I5FERPj4A6+YX/Q8k5v31WJ/nxo0b6vJlzHpoJBAPAoODg+rkyZNKhG2q0G8k7h1v5HpKGeXbJGJMHK45dvHiRTU6OpoTzgAS2GwCfX196syZMwprAI1h/j0kwr/uxHlT/VwCtYK/efMmBe8Q4zV2BCYmJtT58+dN9cLA/oE3ck30Msp/UQK/741w/NiZ4ZTGocFrXAncvXtXDQ8Pm6r3hmj8bSfSGel/KAH45TXLsPV47tw57tBkUeFNXAlcvXpVPX2atWb1VvXHzo0j+recAO/11q1banl52RtEPwnElkAmk1nbSjdUEKN9B+IqxTMk1526hBA9jQS2EgFMcwwDNeb2Z9EWjPTaU5PT09MKv67SSGCrEcBvSQb7JsIh+kO6BAEZdckZRgKxIRCg3SOoJES/Q1dbjPQ0EtiKBFKplKnaPYgwin5hYcGUkeEkEGsCmNNjUauxWlnDJiD6Pk2kouh1VBi2VQgsLi6aqtoF0dfoYl+8eKELZhgJbAkChh0c1L0FoqeRgFUEKHqrupuNBQGKnjqwjgBFb12Xs8EUPTVgHQGK3rouZ4MpemrAOgIUvXVdzgZT9NSAdQQoeuu6nA2m6KkB6whQ9NZ1ORtM0VMD1hGg6K3rcjaYoqcGrCNA0VvX5WwwRU8NWEeAoreuy9lgip4asI4ARW9dl7PBFD01YB0Bit66LmeDKXpqwDoCFL11Xc4GU/TUgHUEKHrrupwNpuipAesIUPTWdTkbTNFTA9YRqLauxZ4G7969W7W0tHhClHr48KGamprKCtuMm6amJjUwMJD1aLztMeC1kVlpnZuuri6Flwv77dGjRwqvS7XRONL7eh0iqaur84WW9xavfE8mk+V9qEVPo+h9nY1XretGRl+ykt52dnaq+vr6kj7D5sIpek3vY8rT3NysiSl9UHV1tdq5U/uG09I/3JInUPSGjsb0AtOMcltvb6+qqsp5eftaNTajPuVufzmeR9EbKGNev2OH9sWLhhzFBzc2Nqr29vbiC2IJgQQo+gA83d3dqqZG+0qugFyFR3HxWji7fHJS9AG0yrmo3b59u0okEgG1YVRUBCj6DUi2tbUp7JmX0vDhwlyeVh4CFH0IzqVe1GK3ppzTqBBN/kwnoehDdC/2zLF3XgrDghk/iNHKR4Ci17DGz/1+K9VojB/C/FuR8ip3xZdX+3sgunuKXsPywYMHOaHYO4963o0fwPxnf/BgnIt5/vx5Th0YEA0Bil7DcXZ2Vi0sLOTERLnDYjpfs7KysnboLefhDIiMAEVvQHn//n1tTH9/vzY830DTwbaJiQmVyWTyLY7p8yBA0RtgLS4uqunp6ZzYhoaGohe12KnRna959uyZevLkSc4zGRAtAYo+gCfO1esWlBCs6XxMQHHrUVgbYG/ea1i8mr5dvOnoL55ANvniy/tMlYBdHN0fWuAkZKGLWvzqirWB31KplFpaWloPxoeAVhoCFP0GXE2L2o6ODoUDYvma7nwNdmp0O0b5ls304QhQ9CE4maYdOgEHFYcTlLoPCr5NuHgNIhdtHEUfgqdpUYupStijwKZ9/vn5eTU3NxeiFkwSFQGKPiRJ06IWc/swi1osfrEW8BoXr14a5fNT9CFZBy1qdduP3mJNZ3ewJZpOp71J6S8DAYo+D8imRS0Oo2H/3mS6U5rYCs138eo/o2N6HsODCVD0wXxyYnWLWojR9D8otLa2as/jY/GqO9iW80AGRE6Aos8TqWlRiz80wR+ceM30YcC5HnxrBBn36YPoFBdH0RfAL2hR6/2lFX9YXltbm/ME3bdFTiIGlIwARV8AWkxLdP/1HwTuLGpxvgZ/WO43LF7xbUHbPAIUfYHsZ2ZmtMePndOTmON7R308BotX3YelwCowW4EEKPoCwSGbbpqCeTz+Y1j//B7pIXguXkFic42iL4I/pikY8f2m+38oTWn9eXlfegIUfZGMsfWoO37sL1b3reBPw/vyEKDoi+RsWtR6izX9qOVNQ3/5CFD0EbA2LWpRND4UujP5ETyWRRRIgKIvEJw/m2n6YtrT9+fnffkIUPQRsdYtVHGYTPd3thE9ksUUSCD7rGuBhTDbpwQwjcFxBGd/3jT6F8qLB84KJZedj6LP5lHUHebvIyMjRZXhZObZG4dE9FdOb6JnyhJjToCij3kHsXrRE6Doo2fKEmNOgKKPeQd5q8f/McFLo3C/1QvZsbGxwsmVOOft27cjeQL+Eyk4mkuAI73Lgj5LCFD0lnQ0m+kSoOhdFvRZQoCit6Sj2UyXAEXvsqDPEgIUvSUdzWa6BCh6lwV9lhCg6C3paDbTJUDRuyzos4QARW9JR7OZLgGK3mVBnyUEKHpLOprNdAlQ9C4L+iwhQNFb0tFspkuAondZ0GcJAYreko5mM10CFL3Lgj5LCFD0lnQ0m+kSoOhdFvRZQoCit6Sj2UyXAEXvsqDPEgIUvSUdzWa6BCh6lwV9lhCg6C3paDbTJUDRuyzos4QARW9JR7OZLgGK3mVBnyUEKHpLOprNdAlQ9C4L+iwhQNFb0tFspkuAondZ0GcJAYreko5mM10CEP2Ce+v6nNdCuiH0kcDWIVBTU2Oq7DxE/0gXm0gkdMEMI4EtQWDbtm2mej40ir6hocGUieEkEGsCGOUNM5Xn8gJq80jf0dER64axciRgItDe3m6KuocIjPTXdCmSyaQumGEkEHsC/f39pjoOIwKi/6suRU9Pj6qutvrlgzosDNsCBAJE/2dUv1LmOB/LddrflqqqKrV3715/MO9JINYEuru7VWtrq6mOHyECIz1MO9ofOXJE1dXVfZqC/5JAzAnIAK5OnDhhquV1iZ9BpCP693UpsQo+ffq0QmE0Eog7gaNHj6q2tjZTNT9wItZE/2qK8ycn0Hvt6+tTx44d8wbRTwKxI7Bnzx516NAhU73w+vXfOpHOSI/7n4h76UR4rwcOHFD79u3zBtFPArEh0Nvbq06dOhVUn/dkYF/Xdta8ZXV19deS87um3MPDw+rKlSumaIaTQNkJDAwMrAk+YAp+TeKGvBXzi75JIi+K2+9N5PWPj4+rS5cuqYUF7ZEdb1L6SaBkBGpra9Xhw4cVZiEBNitxb4jox7xpskSPCBntd8gFP1j14F5nmUxG3blzR42OjqrZWZRLI4HyEGhqalKDg4Nq//79G/2OhFH5KyL46/6a5YgeCUT4g3L5p7hO3AdZOp1Wk5OTKpVKqcePH6u5uTm1vLwclIVxJBCKAHYPseeOHZnOzk6FuXtzc3OYvCuS6C0R/N90ibWiR0IRPs4h/F3cF3BPI4EtQiAl9TwrgjcuPr27N1ltkkz3JeDL4v6SFcEbEogvgVtStcNBgkfVjaJHpGSel8tZcd8Rhw8BjQTiSOCJVOo9cUOi2amNKmic3vgzynQH5xHeFfdTcaEmVv4yeE8CERPA3P1X4n4mYn8ctuzQoncKFPFvFz9G/m+LOyku8NtC4mkkEDUBHBH+UNzvROyf5Ft43qL3PkA+APhLk7fFYV//tVfudbkmxNFIoFgCaSngnjgIG9f/iPtQhD4u14Lt/5J+w/MMC4VPAAAAAElFTkSuQmCC"

/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAADeFJREFUeAHtXUtsFMkZLmzwa/AL22CwjbGxYxwMBExYJAgRSoIUiWQPu8c9rpIcEm2kKNpDbsklUo4rZZVDIuWQQxRlDyvloRyQQggosBgZG/MGY2wDxg8wGD8AO/8360btcVV7uqc91Li+X6rp7nr1X199XfPXo7vWqQxkYWGhXZJ/SxyO28U1imsWlxBHIQKZIjAtGQyIu7d4vCHHf4v7Yt26dfNyjCTrwqYSoh+XNB+K+7a4zWHTMz4RiAGBp5IHyP8XcX+SB2AhTJ5pk17I/hXJ+Dfivh/mBoxLBFYZgYuS/0dC/P+me58VSS9kz5fMfi3up+LWp5sx4xGBLCPwZ7nfD4X8+BcIlEDSC+HLJPXn4r4ZmAsDiYAdCMDm/44QH/0AoxhJL4RvkFSnxLUYUzOACNiHwKiodFKI/z+TalrSC+F3SILz4mpMCeE/MzOjhoeH1dDQkBobG0teT09Pq9evXwclYxgRSAuBvLw8VVRUpIqLi1V5ebmqq6tTDQ0NqqSkZKX0cxLhu0J8NNrLZBnpF00adA6MLfzc3Jzq6upSV65cURJ/Wab0IAKriUBTU5M6fPiwSiQCR8YnRYevCfHvpuqyhPRC4DyJgKfDaMP39/erM2fOJFv11Mx4TQSyhUB+fr7q7OxUe/fuDbrlTQk8KMTHA/BGUkn/Ywn55E1oysnly5fV+fOweihEwA4E2tra1NGjR5UQ26TQ7yXsQ3/gm5jSyldKwG1xOC6Ts2fPqr6+vmX+9CACbxuB+vp6deLECYU+gEZgf3cK8S95Yf5YvxJPLeF7enpIeA8xHq1DYHBwUJ0+fdqkFxr2T/2BSdJLK/9V8fyRP8A7x8gMTRoPDR5tReDWrVuqu7vbpN47wvH3vUCvpf+JeGDmdYlg6PHUqVMcoVmCCi9sReDixYtqcnJJn9Wv6s+8C4/073oe/mNvb6+anZ31e/GcCFiLwPz8fHIo3aAgWvtqhOXJSacct+oigvQUIpBLCMDMMTTUsO1Poixo6bWrJh8/fqwwu0ohArmGAOaSDPI9+IP0+3QRAhLqotOPCFiDQAB3D0BJkH6LTlu09BQikIsIjIyMmNTehgAj6aempkwJ6U8ErEYANj06tRopkD5sAqSv1wQqkl6HCv1yBYEXL16YVN0M0m/Qhb569UrnTT8ikBMIGEZwoHs5SE8hAk4hQNI7Vd0sLBAg6ckD5xAg6Z2rchaYpCcHnEOApHeuyllgkp4ccA4Bkt65KmeBSXpywDkESHrnqpwFJunJAecQIOmdq3IWmKQnB5xDgKR3rspZYJKeHHAOAZLeuSpngUl6csA5BEh656qcBSbpyQHnECDpnatyFpikJwecQ4Ckd67KWWCSnhxwDgGS3rkqZ4FJenLAOQRIeueqnAUm6ckB5xAg6Z2rchaYpCcHnENgvQsl3rlzpyovL8+oqNhp0XP4ojO2Jnr+/LnCJ6Hn5uYyytufuKSkRO3atcvvFfpcvsG+RFfoh0+vw0FfhLssTpA+jgrOz89XcJ6UlpaqzZs3Jy9BpNHRUTU+Pm7aDMBLlpUjtoxfv3590hUWFqpEIqEqK7/cFxubFUBPl/cUI+ljoCFa5+3bt6u6ujr14MEDFbD9Swx3yywLbCVfXV2ddM+ePVMDAwOm3fgyu5HFqWnTx1g5+Ceor69XbW1tCi2s7YJ/q/b29jf/WLbrG5d+JH1cSPrygTkB4hcVFfl87TxFy48HtaGhwU4FV0Erp82bwcHBtPfWKigoUH4HQge15rCpW1tb1Y0bN2IxH2ZmZtS9e/fSogD+cfy64hwmGAhukpqammQHF5isdXGa9CBSuhvK6eJhRGjr1q1JQumIsmHDBtXc3KyuXr2qCw7lhw6oTod0M8FDWFtbm7TlTeRHxxwjUk+ePEk325yMZ370c7I42VX66dOn6tq1a+r27dvGYcvi4mKFVvRtC4ZZ0Yr39vYmR25M+sDUwejPWhaSPobaBflBfMPepcl/A1PrGsPtQ2UB8t+/f19NTExo08EU2rJFu5+2Nn4uepL0MdUaJqtM9jBMi7KyspjuFE826B/AvNOJN6avC1sLfiR9jLWICSqTPZzpjHCMaiazwr/S3bt3tdnCJEOLv1aFpI+5ZmHq6MS2lh464t/JtITCRn11uEbxI+mjoBaQxrQ9O0ZybBQQXye26qvTNawfSR8WsRXiw042LeiCbW+bmEhvo65xYUfSx4XkYj4gvMlksJFIJH3MBHA1O5NpgOFC28TUYbVR17iwY0sfF5KL+WBpgm5MHqMlNhIJIzU6mZ2d1XmvCT+SPuZqzDUSmfQ1mWgxw/VWsiPpY4YdKyx1YmPLiYVpppWgNuqrwzWKH0kfBTVDGqxkNK2zwQsbtglefNGts3n58qVxtta2MkTRh6SPgpomDVrNpqYmrT0PWx6ztTYJHk7TcoNHjx4Zh11tKkNUXUj6qMj50qHjumPHDuP6erw+aBq792WTtVO8MYXVlDqx8QHV6ZmJn32zJZmUJstpQXasQYczjcHjCwp4CdsGQX9j27ZtCqQ3CXQ1rRY1pck1f5I+RI1hTNtz6ADiBWsT2ZEtyHPnzp3k5zhC3CaWqKlvT1VUVASSHTfFuqGHDx/Gcn+bM3Ga9DBJ0mnVvE9q6Dp9pspFvlhjH1cHFkOLHR0dptst8Qfh4cLI5ORk8gG1yQwLo3+YuE6TPqiVDgNialyvhY+L8MgfD5xp9jT1/mGvQXg8oC4QHtg4Tfqw5FgpPkiDURqYCBj2s12wOG54eNj4DoDt+kfVj6SPilxKurGxseSHnnJhJhM6guz40pmLwiHLmGodXxHIBcKjuDC/TO/IxgSH1dk43dKH+e4NiAKHN4p0H0aCH4i/WtP3MEXS/e4NzCwMlUJaWlqWzR9g5Anj9HhB3EVxmvQgUthvyWAcG8RPfefVm6C6fv36qvAID1xYXaEI3oPF19ZSR54wI4shSnRiXROaNxFqHC2urqOKyR98/MkmweuL+KisTjBku1ojWLr72eJH0keoCUzVm0wNfEXMtNIywq1iSYLRJN2/BAjf2NgYyz1yKROSPmJtwSzQLS+AGYEWVPciScRbxZKsv79fOxEHMw0zyy4JSZ9BbaMjjH5BquDtKV1nNzVeNq/RwTZ1XNGpDfoYbTb1zMa9SPoMUMYoCVpQ3UxmVVWVwnoXmwRzCbqPUeFfCcuiUzu7Nukepy4kfYZoBnUU8ZKG6SXxDG8bObmpE44XYGzrhEcu5AoJSfoVAEonGB1FjNGnCjqKsO9tEozfB3XCN27caJO6q6ILSR8TrDBzvAkhf5b+Ddn8/m/z3NQJh054SMOu0HybZYlyb5I+CmqaNFiCYOoo4sUN01cHNFllxcvUCcdKTphla1lI+hhrFwu4dGtavNlamzqK6HxjtlbXCce7s5s2bYoRGbuyIuljrg9sUambrUVLjy03bRJ80g+rLXWCIdfVWr+vu182/ZxYe4MXJLIlsOt7enoi3w6jQV1dXZHTh02ILx/AuSRs6V2qbZY1iQBJTyI4hwBJ71yVs8AkPTngHAIkvXNVzgKT9OSAcwiQ9M5VOQtM0pMDziFA0jtX5SwwSU8OOIcASe9clbPAJD054BwCJL1zVc4Ck/TkgHMIkPTOVTkLTNKTA84hQNI7V+UsMElPDjiHAEnvXJWzwCQ9OeAcAiS9c1XOApP05IBzCJD0zlU5C0zSkwPOIUDSO1flLDBJTw44hwBJ71yVs8AkPTngHAIkvXNVzgKT9OSAcwiQ9M5VOQtM0pMDziEA0k/pSm3bjtc6HelHBEwIBGxl+hyk125DkUgkTPnRnwhYj0DA1qAPjaS3bTc861GmgtYggFbeYKm8lM3uzC19dXW1NYWgIkQgDAJVVVWm6AMIQEuv3dULu8tRiEAuIhCwD243ygPS/0NXMGz4i23eKUQg1xAIIP3fUJY8sXG+kOPj1IJhq/T29vZUb14TAasRqK2tVRUVFSYdP0cAWnqItrU/cOCAKiws/DIGf4mA5QhgR/YjR46YtLwk4aMI9Ej/iS4mesHHjx9XyIxCBGxH4ODBg6qystKk5qdeQJL0iybOXz1P/7G+vl4dOnTI78VzImAdAi0tLWrfvn0mvW5IwB+8QK+lx/XPxb32AvzHPXv2qN27d/u9eE4ErEGgrq5OHTt2LEifj6Vhf8PtJXbLwsLC7yTlD0ypu7u71YULF0zB9CcCWUegtbU1SfgAE7xLwjr9iqWSvlQCz4rr8Efyn/f396tz586pqSntkh1/VJ4TgVVDoKCgQO3fv1/BCgmQMQl7R0h/2x9nCekRIK39FjlgwmobrnUyPz+vbt68qfr6+tTYGPKlEIHsIFBaWqra2tpUR0fHSvNIaJW/IYS/lKrZMtIjghC/TQ7/EVeD6yCZnp5WQ0NDamRkRE1MTKjx8XE1OzsblIRhRCAtBDB6iDF3jMjU1NQo2O5lZWXppJ2TSO8K4f+pi6wlPSIK8bEO4V/iduGaQgRyBIER0fOkEN7Y+fSP3iwpkyS6Lx5fF/f3JQG8IAL2ItArqu0PIjxUN5IegZL4uRxOivtAHB4CChGwEYEnotTH4jqFs8MrKWg0b1ITirmD9QgfifuFuLQMq9Q8eE0EYkYAtvtvxf1SyD6Rbt5pk97LUMi/Sc7R8r8n7qi4wH8LCacQgbgRwBLhz8T9Uch+L2zmoUnvv4E8AHjT5H1xGNdvXHTNckyIoxCBTBGYlgwGxIHYOF4V95kQvV+OkeX/56DxigmUCQgAAAAASUVORK5CYII="

/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 508 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACTCAYAAADbcRh2AAAAAXNSR0IArs4c6QAAFEZJREFUeAHtXQl4VcUVPgkQliQkhCSsAQn7JktQFgXZFQybREUFVzaxaq21aLXaSmttba1fqQLiVopFVAhEEIoiIFBQkEUFBGQJm4EAJkDYCT3/w5e+vDvzFrjvvXtzz/m+yX3vzNy55/7zv8nMnFmi6Ark4sWLzfn2XhxwrcehPod0DrEcRASBK0XgFGewh0PuT9dtfF3GYW1UVFQxXy9LooK9i4neg+8ZyaE3h9Rg75f0goAJCBRyHiD/Bxze5R/AxWDyDJj0TPYmnPFLHAYG8wBJKwiEGIGvOP9HmfgrA32OX9Iz2ctxZi9y+DmH8oFmLOkEgTAjMJOfN4bJj/8CPsUn6ZnwVfnuHA43+MxFIgUBayCANn8fJj76AVrRkp4Jn8Z3fcahkfZuiRAErIfAYTYpk4n/hc40JemZ8FfxDV9ySNHdCH1R4Snatn4vhz20f0e+6/uxo0V0/twFX7dJnCAQEALlykdTXEJlikusQil1q1HT9vWo+bUNKKG638HBs/yAfkx8VNoGMZD+pyYNOgfaGv500Rla+K/VtHzOBiouDqrjbDBAFIJAsAi06dqYBo/tRokp8b5uPcaRbZn4u7wTlSI9Ez6aE+DXoW3Df/PfHTTzb5+6anXvzOS7IBAuBCrElKd+93SmHrdm+Hrkdo7swMTHD6BEvEn/M46ZWBLr9eGzD9bSR1NXeGnlqyAQOQQ63tSSbvt5b4qOLkVlT4PeZNKP9FSUpORavhpH7OCAq0Fm/WMJrcjZaNCLQhCINAJNM+rTqAmDCH0AhaD9ncHEX++O80w1gZVKwi+dtU4I70ZMrpZDYOtXufTeXz/R2YWKfZJnpIv0XMu3YOVYzwj3563r9lDO68vdX+UqCFgSgbWLt9DimWt0tnVkjme5I901/cOsgOe1lJw/e56m/eFj4htK6eWLIGBFBD5+ZxUdPlCoM+1xd4Sb9IPcCs/rsuz1dPL4aU+VfBYELItA8YViWjhtlc4+1PbJiIzmDxjzqaVK+Xn2BpVadIKAZRFYt+Q7KjqmrKjRts+E4ajplbMm92w9SPCuiggCdkIALfFvVn6vM3kAIkD6NqoUG5djXF9EELAfAl+v0JK+Pd4GpK+heq292w6q1KITBCyPQO53eTobayNCS/rCwyd0N4peELA0Ahh8uXC+WGVjDPdhY0H6uqrYgvzjKrXoBAFbIHDsiLbSTgXpK6je4uyZ8yq16AQBWyBwimcCayQBpBcRBByFgJDeUcUtLwsEhPTCA8chIKR3XJHLCwvphQOOQ0BI77gilxcW0gsHHIeAkN5xRS4vLKQXDjgOASG944pcXlhILxxwHAJCescVubywkF444DgEhPSOK3J5YSG9cMBxCAjpHVfk8sJCeuGA4xAQ0juuyOWFhfTCAcchIKR3XJHLCwvphQOOQ0BI77gilxcW0gsHHIeAkN5xRS4vLKQXDjgOASG944pcXlhILxxwHAJCescVubywkF444DgEylvtjUc+P4hadmpgMGvqb+bS5i92GfRXqujUr5XrxOmokmOk/5/jR2+soM/eX/t/hden7lntadDobl5aoiUffhWSY0jrNk6lh/48lCrFVjQ889tVO+nt331ExcXqkyB1thoy8qE4xztZYzfgUyfOuA7gy8s9QjimKXfLD4TPdjmE0nKk94G56VEdejen2x7tRSrCL3r3C5+EN90YPxnWTk+mB1+8RUn4bXzW7zu/n68lvJ+sA46uULE8IVRNinXd06Blbercv7XrMw7xWL3gW1rFweoHeji2edOuexO645d9KSraWMUvm72eFvxTezRjwCQxK2GNeklM+KFUJb6SIctdmw7Qm7/NoQvnLhjiwqlISI6jG0d0omenP0C3P9abKlWJCefjg3qWI0l/9XWNaPj4myhaQXjUVnMmLwsKxFAmTqmTSOO4SROXWNnwmH3bD9HrT8+hs6etc4AGMEWTcfzUu6lpRn2DzVZQOI70LTo2oLuf7k/R5Yyvvm7JVnr/lU+tUC4uG6rXTKCHXsoqaU54GpaXe5QmPzWbTp8866m2zOfElDga84fB1L5HU8vY5DbEUW161Dz3PZtJ5cobCb9p9U5698//sUxnLDElngk/lNBs8JYjPxTSpPGzdIcEeyf3+R0/9M/5ZHh/EsUdH/y3qVajKiWlVuVrPOFHic61TtB0vOtXN9L5sxfoa/3ZrrrbQ6Z3DOkbtalLD/x2AJWvUM4A5rb13BGcwB1BPmbdCpJQPdZVw4Ng3lKQf4Je+9Us0w62LuQDyXwcQen9eMP3Og1TqO/wjtS6SyPlgAD+ow5/8iZ6ceQ0OnrwmOH+SCiMVV4krAjxMzHKMGrCINfIg/ejXB3B53LofIQ7gm674qtV4TZ8FiXXTnCrSq4nCk7SpCdnWYY8MGz/jnweKp1Hf3lwOm3fsLfEVs8PGPEZOLqrpyqin8s86es1q+lqW8ZUMh6iuO/7QzT1mbmW6QjGJlSmcX8aSqlp1QykOHn8DBN+Nh3a+6MhzgqKAzsP05tceeTvU9vXpmtjQuVjBSnTpK/bKJXGvjCEKiqGzw7uQUcw2+VssUJBVImvSON4HL7mVdUN5pw5dY5HabIJxLKywM63uZkIJ5ZKMExsBSmzpK/VIJnGMokqxxm9lyUdwcJTVigD15j22D/eQrW5fewt57gT+Mazc6+o3e2dZyi//7DrMMGTrZJWndJV6rDryiTpa6QlcTPhFoqtanTmwFv4Go98FB4pCjvYqgdWrFyBxvB/o7QmNQzROOr9nefn0fcb9xnirKzQTRdBxzyZ/Q6RljJHeoA6jof64hKrGLA9UXDKRfijedYYRUAHb9SEwXRVi1oGWzGHZvqLC2jzl+bPNzI8zGTFkbxCrf8gUTEEa/Lj/WZXpkifVLMqT8hSO3MwSQrOHKt0BDF0OvL5gdTw6jqGQsLErZkvf0IbPt9uiLOLQtf/wOhUpKXMkN7lzGHCwxPoLZc6gnNcw2vecZH4DufY/ewzaNKunvLx2a8tpS8XbVbG2UV5kGddqiS2qnE6hSpdKHVlgvSY9Qd3PWp6b0FHEENpu3n6qxUEzpp7f5NJza+5SmnO/LdX0vK5G5RxdlImKCof2H+cfQ2RFtuTHm13EF7lzHF1BCfM0zpNwg0+3PJ3P9WPWnVOVz760xlrCKEsSJ2G6ukJGDmLtNia9BidwQxElTPnIjqCf1oYkoUnl1NomLOPeShtujVW3o7aHbV8WRA42TCVQiVCehUqAeow/v4gey9rKZw5yGImz5bcsGxbgLmFPtmwx/tSRs9myget+WQLzX51qTLOjsr67AVXCQYTECIttqzpsUABzhxMdtJJYnK8Lirs+lt5dda1fVton4s+iWoxi/YGC0egbIY82F1pISb2WUFsR3rMoRnN87TrNTU6czwBxSqeq69v5KmKyGcQoMvNl5bU6QxomlGPhoy9QRdtK/2wx/so+1d4icXvWaO/YivSw5kz+veDApq4dKkNfZPP/wahZtPAUV2p25C2AT2m6+C2rhVHASW2YCL8p+pz57WEiWUq2fpVLu3llV5WENuQHoQf+Ts4c+oGjFtMJb6HHUAq72zAmVxmwn73dKYet2YEdXfWwz0pvbXRWRVUJmFODLJn9GpGT71xN/W/t4v26Z/M+FIbF+4I2ywiQTNBNyKAOfHYFkPVqYXT6v7nMulVXngRrsXT7Xs009qKOfG7Nv1Ara9raChrl9OKV3a9/PAMsspUCW8j4VG9tHqKV07VSuC+Skvl6JnnfRiV2vH1fk9VRD/bhvQ6wmPVzxReHF2ZSf/YxGHK9aSYx42tPmb8ZVFYwNbZirk/rz7xIR3aV8Ad8SHUuG2awR4M92Hvn1ceeY/n+Z8zxJut6MJbeLTt5n/KL5qLsQlVqEKMceWZL5sWTFtlOd+DbZo3KmCx0dBkXlhxhhdHF+QfJ2wIpSMKRk+w4VGkpOjYaddkNyzoxrLEt3n25MG9R5Xm4D/WCHZigWihFqw1qJYa7zfgP2awhP/P9NW0aPoXoX6FoPO3Lemx/QUI77kbAHTTXlhAcEypZODIrlr3vyq9WbqTx0+7FnJjrrlbMF6N7TvQ3FEJvLb977tOFWV53Xdrc+nln82ghdNWW9JWW5Ie6zKxVhRbzHkLdjWYM0W9b41rGgBv/4H59uESkHvS+NnKyW5ot7/xbI52pVHvYddoHVrhsj+Y5+z89gD9/bH3acqvs2nvtoPB3BrWtLYjPWpL7AaANaM6+Tx7Ay2fo560BecJRnSwPC/Ucpp/lFjXirW4OkGfxNfWI7f/oo9fn4Qu73Drj/I8egwqWF1s05EFkHm7j7hGYdBc8CfZvEtZEu/LotoMFgtN7nnmZprCa2R1G576y99fPJpdWIMbSI23cfl2mvfmChow8npDtmhHP8BDtS8/9O+QrPYKdN8bGIYdI9BnwggOpoB4b6eCvUE38Sa7Vpr+YQCUFbap6bGQG8OORQGua0W7ftoL8wntfJVgLvuQcd1VUVesw/x9/IsPZj8Z7I68av43ymdjmgKIH2xHUpmZl9K97w1s9RfQrMzfX0Boxsx/Sz057tZHeinXNHg9NqJfbUN61IS6Tp8OQezxiBEdjOyo5PqBbfxOEVDd50+H/TB3bw5+/v6HEz8jdAJVgjW0mLRmFVk6ax2p5tKg2XjnEzeGZeTpcrGwDekvtxly7GgRvc5722BYUyW3PNSDGgXh5VXl4a0rLr68ndLwjthy23OUxzNv7AvZ545rPVUR/fzvlxYp+1bwP3TPCs4bHc4XsQ3prwQUkMi1f7ti2z54Qe9lLyj2ZbSC4Mf5+jNztNv29WNXf+suRm9uJGzHzhIf/H2x8tE3s52+ZsEqbwqT0hGkB5ZoNnz4jyVKWLEYBSM62I7DCoL9Ki/tvGb0yLom0vE249jXxwqCTuvaxVsMppTjhe/Dn+wXkn6I4WFBKhxDeuCCjqLuOB3sLDbiqf6WaYtimHPaCx8rHW34cY7iHymmLFhBZk1cQj8qNmetWT+J97A0Hk8UaZsdRXqAjd23MESoEgxvZj5gHDZUpQ2HbtPqXYShV5Vg0tf9zw1QbjuuSh9KHYZnp2Obc4UnHIMFukXwobTJV96OIz3AeJfXzuqGE3ve1oE69GruC7OwxsHJBmebStJb1SZMR7aC7PxmPy3WHEqHY46s8l8JWDmS9O79IbETl0pu/0Vv0q3zVKUPtW7O5KWE6RUqwVE3Nwxpp4oKuw7ndKm8z3BmDWPPslXEkaQH+JjmO/XpucqFyvA0YjMm1SkgkSg47HiG9r3O0TZwTDdLnO+E2aPT/7hQOZcIE+g6+1k2GS5sHUt6AIypvW/x2avYH8db4AXFSi2s2LKC+HK04XCze3giXUpd47724bYdmOZMXa587OAxNxAOjou0OJr0AB87AusOV8N5Sndye9Qq4nK08XRkz+nUbtuwJQpGdLCYJtKyImcjbVmz22AGlm9inYDqkDtD4hAqoi6yqPJ/rO8rKrXoBAFbIPDE5Luodrpyi5h2jq/pbVGCYqSpCAjpTYVTMrMDAkJ6O5SS2GgqAkJ6U+GUzOyAgJDeDqUkNpqKgJDeVDglMzsgIKS3QymJjaYiIKQ3FU7JzA4ICOntUEpio6kICOlNhVMyswMCQno7lJLYaCoCQnpT4ZTM7ICAkN4OpSQ2moqAkN5UOCUzOyAgpLdDKYmNpiIgpDcVTsnMDggI6e1QSmKjqQgI6U2FUzKzAwJCejuUkthoKgJCelPhlMzsgICQ3g6lJDaaioCQ3lQ4JTM7ICCkt0MpiY2mIiCkNxVOycwOCAjp7VBKYqOpCAjpTYVTMrMDAkJ6O5SS2GgqAkJ6U+GUzOyAgJDeDqUkNpqKgJDeVDglMzsgIKS3QymJjaYiIKQ3FU7JzA4IgPRFKkPLlS+nUotOELAFAjGVYnR2ngDpD6piE5PjVGrRCQK2QCCpRrzOzjwt6eMSrXEatc5y0QsCOgRworrmXKtzUVFR+po+rUkNXZ6iFwQsjUCdRqk6+/YgAjX9OlWKFh0bqNSiEwQsj0DLTlruboTxIP0C1Vs0bptGMZUqqKJEJwhYGoFWndJ19s1HRDS3cdbyNd87FU7Nvi7zam+1fBcELI1Aw9Z1KDUtSWdjDiJQ00OUtf2NIzpSlbhKl1LIX0HA4gjg5PSsR3rqrFzPFfxhRLpJP1GVsmLlGBrx637EiVXRohMELIVA//u6UM361XU2TXJHuEj/UxNnllvpeW3WoT4NGHW9p0o+CwKWQyCjZzPqdfs1Oru2ccRb7kh3TY/vT3C44I7wvPbIyqCug9p6quSzIGAZBJq0r0d3/LKvL3vGc8Vewu1S7ZaLFy9O4TtH6+5e/N4amvfWSl206AWBsCNwTZ/mNOzxvoT2vEbWMeEzPONKpWTSw3f7Xw6tPBN5fv565feU/epSKjh8wlMtnwWBsCJQOa4i9b2rI3Uf2t7Xc49wZEcm/Q7PRKVIjwgmPlyxcFjVxneVXDhfTGs+3Uwr5m6k/TsMo52qW0QnCJiCQPWaCdSpfyvqNritPz8SJlJ2ZcKv936wgfRIwMRvypflHFLw3Zcc//EkbV2XS7lb8ihv9xE6sCufTh4/4+sWiRMEAkIAc2hq8GhMLQ6YFtOU2+7JdRIDufcsJxrEhF+oSqwkPRIy8dP4sohDM3wXEQRsgsAhtjOTCb9GZ6/n6E2pNHzTXlZgDOjjUhHyRRCwLgLfsmntfBEepmtJj0i+Gb3VTA7DOeBHICIIWBGBAjZqPIcM5uwBfwZqmzfeN3JzpyLrHuXwNIeq3vHyXRCIAAJou7/G4Xkm+4+BPj9g0rszZPJjNg9q/qEc4Kr1+d+C40UEAbMRwBTh2Rz+yWTPDTbzoEnv+QD+ASTz9ywOGNev/1NI52ssBxFB4EoROMUZ7OEAYuO6hcNsJvpuvl62/A+N3L9hVXy08gAAAABJRU5ErkJggg=="

/***/ },
/* 510 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 513 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/home_background@3x.2c46a9be.png";

/***/ },
/* 517 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/avatar@3x.a4a302fe.png";

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAiCAYAAADGUiAIAAAAAXNSR0IArs4c6QAAAhFJREFUWAnNmLtLw1AUh42IiAiCj0HBwaGCg6LgIi4OugiODuIgTo7+GTq5OOjmrLg4+Rq0XRx0UcTBDoqDSEUQBFEQ63dKA30kuScpN8mBH0nuPY8vl+bmpE1NEaxYLPajE/SJLtB8hDT2QwDLoFdUa1v2q4eoAN0geqmlrLieCpEutGuzNgKgAXyzqC8gZjxgruEpFSygAphDAhxkb0GT1ucA7UUPyGTysPVaB/IrQPEudG+iLM8v+eWxPg5AJ7pRgq5ZB/IrAGAHulaCbvjlsT4OYDu6VILuWgfyKwBgG8oqQQ/wU+0mfvUij1O4FZ0pQeVV2xK5WMRAR+LKhQ85nVPkKeCzjL4Vvo24/BH85DjOc1USYPeUK5qE2xVFMwLscLLKcaeKPn0XdyCNCewtJyPp46sjmpanubTEdVPpGxgS2Hz6uDyJ8gK77TmVrsEcOKLS1rWfxGOurHmMX4dwVu6zR1zPyKDBZJ9dQV8Gv0anvfdZyQp9mFftOf6xv8Gq7h4AaWK03VZyvYFLDaz0sdqGO7muqwJY+ynDfRXX3bjEjkD0oWehUVhyXwruCgEp/xMUFLDisujGJXYEYhi9C43BPpjvSQzULQzEKJJPbZMtuDE2jvK6NRoNsHRms8jUcHcbk8XlwLLOoJ+A5Z2Mi0VVB9A59OsBfKpKELcToBNIPi7ld/yINlF73ByprvcPYeDMkFMLHoMAAAAASUVORK5CYII="

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/coins@3x.30091e65.png";

/***/ },
/* 524 */
494,
/* 525 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 526 */
525,
/* 527 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA2CAYAAABnctHeAAAAAXNSR0IArs4c6QAABQ9JREFUaAXVWk9sVEUc/n5v61I0EGm7bZAIaLEhxhguXrzUiyfPJJLsHvBuPHrRi4l68eBV4sGkgQsxIWJMPJmYmBhjDKYaUEBQSqXdpRQx1NLu+/nNe7vl7dvt7ryZEdZJ3r6ZN78/3zf/3m/mreCBpKM7MV5+DhIdQaSHoThAt9MQYV7nEcWvYunUb6GgjIQylNipVA8BeoTgnybYAwQ9w/IzJLGfeUl98dbKJWWRFxCXXmP+rbTe/9ef1ERtFqJVAn2RaJ/dQtzmYBhkSfTGTPLhkh+pierbiPCODeq+kEXH+tYXrIwKyt8Xn6juRSQkFCCpPB7AypYJd1JNGd+y4psRjPqayOq7k9rActaQZ/5RT/0OdXdSf8/VucJtdlhzLSjKrqq99NxJca3mMr3Yy2jhZ4JHCuv0UfAhZcz+2ce2fZXqDnvhwZK+pG4MdmElUbKSshTyIxVrqOE3RKQiqVs2Xn8xFb8gIGfdr6eggYafDg6kcsD7FT1JyVI/4wXqhojUZhxoTskQzSk0rxfojQcm6jf8VnYHmlNh+XquOic2oLVV7peCRtlWFCePTUFLM4xrStyUbqK+9h1w+p7R9SSVuDe9FZKUoFKdZlx5mGHYweRKd9H7SMD42cNG3MP7jmTzmSwxClRGV4HaB6jPveu/6lSqX9HxS3RSPCnBQK8S7BVeCyhFMyw/z03nzuLGWhpNedm/p8Qy/kvwxytsgDS6j2QXYezj0GFv4CB7poXKs50jfSUllYxP2Yv6nV+Bs3eLtVIuUjfgFBv8WSSBO0ijhUlu+8dIwGzbeW8Bz+LP5osByEnrkxy/tfcJ4E06Ss2q3mLLLVCSQ0Lmmf8BzfgaRvQmNqSBlZN/JVZ2HZtAeWSaR14fs0x55UZPpij/FO/lnKfBxaSnCMGbnJ4RTNZu0qP7wYfiEoEcGozaQsIQa/eihXhvEf0o4lAxY9sj6aSHcnjVWBbNy/cPT8uPeeoHVldDSi86W02HS9C4zRnLlmJ8maTEndSWoVAZ71UCiOViBIkvhIL00O0oVrk6L3Ch0J/cwQRoWXfnvTR/NA8j3MN8r9qH86wdVbh612+MZoTbp25xsfjdzYwvCDev22o19aypM0s6OQnD9v95UnzC+fStYZGSQvypEyXz9g/VWT7RhOJL4J/X2xzaM93EgNxCYLZdYX03YEwAG4n70bGasw7h51Hh8QBjTIEJ3eIEQywxP+qtsG4J2mywH+hQjNMbaKxfaW8Ms3jbpIDdR8dQHj1OnVbYJHcR6zXa5ibQGOqX6ERwghLjXE1NFN7qQt7ue+g2YKyaeuUXlPrcVLeA25N+LotZrFSvk8wTHUpJU7SRt2qSRs5IpQHsMpbDkWrNqYwT16zgapeqaTIDOrmbvJEw5cxlHmlrqJl8gBSOFOSyOx5N54+7gQ7NcKQUv3RYLlYYUlKx/lyMR0ZauMIFTOF6SnDeA9eQkmqsX+Jy3nQkFq5xCSCgsdMk5Pi9SjU91XJskbxaQFI0nbz58y4sysKj44ApLCnIbSdsQ/SXg278ivRMsLtmwJOh+jyaw5oGormHNsVhffka7HFysmvDIicjYf6P0bIaeE7puRxau6LoF3aCdlJhSWn0dfF3lZ7BWvSeHVw7qSRuthO1lKpUP2QU/sb20rrGqPx7ylxAHH+GxsnPt5d1qwlPyuCoVI/zd5Yvrv3cV6xzt3E+OYpTOcfdKo+xzIv6v0v/AjGETssGS5JdAAAAAElFTkSuQmCC"

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAAAXNSR0IArs4c6QAAArZJREFUOBGllEtoE1EUhjPJJGCpOi5cKAHXLYiFIsWNogur+EBBN640TbKoGB8bH5uCiBsfNNSIJiERREUo2oUggli7iUZBiqiUFBEVAm5Mo+1IHpP4nYkTxjSjES/8+c/9z7n/vefeaRXXX0YqleqtVqthRVE2UNoHfLKkXq9/g16AKbfbfTUYDH4VXZEfp5FIJC6SOwH+WCfmbDgUCoXGHQuTyeRxCi87bdZGL1M/4G6TMCWSe5xyDrqPU25zNGTRfUxn4bKDQatc5i4fL2o5Ho/LxS+3V3s8nlnDMNaiHeUU2+05idl4HhpUVXXONEyn0xovOYJ4EGhg0WDRBGZRsLJWq92SAmJ55WtwDu0SPKnIiSQg0dZIFtoHxoc0TbtbLBZ3o/eAQTAA5HD7VcwmCDoyo05OlS4UCq+5rwTTpaIxDDa64vV6H7gJOjZrrHW5MFvGus9gBtzgfnvY6B3Xdkpe+ZhV2AljMMUH/BSDw9SPwQYbZImvE+ekZQ3spXAUcY2TKfkidaOcZpy/oH7mMea9Ug9Ly1Fe+Z5KcAHkEE/Dc7BccB+xeRXM5TTTaM/APhY9gUNoOjUzxM954fN8Wptp+aSKECc5DN+GDVg+hffEb+EKi+T1AvBNtG7iLyzOlEqlHTzCJvStv1peQe6AGGYo/MguI3AXc/mvIjAHWpNZ/IrJUKVSWYLpQ+a/tRwOh++IYRqzRyzcRYEYSsurwSrQhb6AnoUnOck8cYL4HLlmy8zPYvYBzSWGUjAM74S/wy9BHrwBOpChYTQGrwNmy4FAYL0kWkdry/KhbmktYiNTwrTZcmuNNf+flj9ZJnb+55Y55TSfTsZuYo/VfD5/xO/3W6/s2DJGP0AUnOH+rLu1e5lx43IIY7FYt8/n20jYDzxmtvGzwB1mdV3PRiKRkk1vG/4E5LpdP6obA7YAAAAASUVORK5CYII="

/***/ },
/* 530 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAgtJREFUSA3Fl8FxwjAQRbGAc+ggdBCnAkgFIR2YA8xwpAJMBSEnZuBg6CCpIE4HTgdOB3AGhvyvSB4RjHEmtqwZWHkl7dtdyZLs1HKW+Xzertfrj47j9NSQLuXxeIyhiymFECH6vPX7/Y3qkymczFY0LhYLD2ICQBsyV4Ejq8PhMB2NRnHWgItwQF0AnzG4m2XgStus0WhML2UiFc5oAQ6uGM7VjCxEyMJTWhbO4Mvl0ofVSS7L+Ttt4MTDcDiMzCEn8CIjNiGsc0E2m817cwqE7qTmuJBUa5um5ILd7Xbvpi6BQzkzG8qowwGX2dW2JVylu6OVJctJEAQtMiQcHvklAxPzTP9+v/eoENy5IG/5YKtg8fXIEtgEZMUWmBxE32HqhfbCJpwspN41V7ttviuYAttUxWtVGbl81b4qirzGBRdXASeXc14JHAFHjDy0HTmYWx6vAsfcq204si2ZQp2va8sOrMiTrxp2G58PNgpS/jEYDEKyJJz3KyhfbMBxn/M0J9lkMPc+HPjUDSXJsXmRdEyI+jCIsCBuTH1B9TXS7Zm2ksipVF51US161zsDk3cSORUsPGtx2QuRgbsfzb/+x4h4lmYhFa47qrudj+c/33S4qrm4zDnWdrXMhLMTs8A7F4z1kInM4xd9tmoDWenXSYPS5FW4OUg54kLHX0u3ARqjHv3+ItHtl+Q3nd/MdOuu/h8AAAAASUVORK5CYII="

/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAABGCAYAAADfGPQFAAAAAXNSR0IArs4c6QAABDlJREFUWAm9mVuITVEYx+e4Exm3chsaIg+IUCK8KMwDnniQZp48UcoTCg2KJMrzSOOBB5EkMcmM3JLEA1PUTEbjgci4JNfj9x1nn7P22utbe+85Z/vq317f9X++tddea7dPTY0h+Xx+LXgI+kCD4ar+EILB4CsI5DuD1dVnKlak+FDwKWArXr9xXZol6UoIhMSUzyiLsiRdDYFMpykfUeZnSdoAwS+TkfF7MCtL0s0Q/LZI36DXZ0m61SIUtQdMypJ0u4P0BbYJWZLucZA+xzY2S9JjDtKn2EZmSXrKQXof24gsSVsdpB3YhmRCSuEB4LyD9Cq2QYlJCd4IToBbYD9YoCXjGwiEwJZLGAZoeSU7QWfszKLeVAqyBviHgDZHnkx5zgovqzh3OpJMk6/TYQTK/QtE9mCZpQNgXZnFGOFoBz45YIRHhiSOAI+AbAam/EGJ/lgzQhm3R1gsA3mjwFzww6pxEz3cKYYnVpCtnrTqR1QS6sFbO7GoS6cLgyRZUe2Boly9forVkdcBtL1VFtB6UBaStC7PlKOiI/ImgG4QJ2si2WScBAGxLKSdEsRVHvTZYBVYCgp7J9fRQDbwJLI5QugyUGkLkEPXlJ8ozUBWZpy0ENANZDH53wAJ2AsqkQsk50Ad6AFfwAxXYzKNy0Alcp3k0r7KeBa4BqZphJdx9lfukjjMWVgzkiDt90dk0Y3S6qr2/jCR0wXGqUV9DhJ7U5JKvGwAsaKdXVdiM8MBx3O53OuwKYXGr12essPbKcq7QyGUe5JGprorha3alEpUazg0VtsaG+ELoDU5ctLIM1+9RD7Y7qVhJHZJXGHflEru2bgCll9eHwdatuQqybXAfm3A5JWm5AyOSEpf9JaPOuVkqKjLFdGasZaKu7wTSxEOULuMWzTBJM8JBgmvsq/277nkh8uLriadmgO7s8skHU7xdHUQ32vF7+wyCeFkpaCYe8A+j7+ZTkMrNgmhr8M3kLWCLoVUutxi+pIQejvkHPxDQV+XG9ISah1+gOxXsdg5rt1mYWNca4xrKulQprMgxS5fBLrvmoRQ67BE6COwfUkItXuYGaGsNJdUn5BnSN4zS6/sFmuvpSdS46ZUm04pXv0OKTrd87MzIdz93wi5f02QLVMI89irdw8hk93hmEIm5vM87EKaWrRFc5RK45Vqfdh3KL5Yc4SQ7haTtc2TuYvu3nv8XleIEDI5u057Mh5A1uLxx7pChETLVM1TsuRkaFR8ic0lQrqbSJa8MmhymO4SnQhaAbGXCBkfAdoHcyE6BCqWAiHdDaeS72tRI90Fh21FpEGH8lVe+9TRAtmDiliM5AIhBWWZPzHswfAdg12BEnOVdxuXhOxBhxIonxjlM2Swg3Qy3sSPkQc9ibxUgh4r9n9m7qd8klwFBnsDLSfxM4H9Z+crbGOs0OqpFF8E2sANcBREyP4C7fC7VgT258gAAAAASUVORK5CYII="

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ficaLogo2@3x.083f4719.png";

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ficaLogo@3x.6576ab56.png";

/***/ },
/* 536 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAuCAYAAACWPmGbAAAAAXNSR0IArs4c6QAABYdJREFUaAXtmGuIFlUYx3fNC5mZ9wslVi7qhoTpZtqFLCtCrA9SIpGsBgVl9EFR6Usf7AIR9MUIIjaKkCQkYksjK90i0RbJZa1IcV13kzAVr5l5Wbfff3zn9Z3ZM3Mu78t+aR/4MXPO+T/PucyZOWdOVVWf9Y3A/2sEuru7R8EK2AZH4DhsgVfh1kqPBjFfgH1wCc7Av3AevoTaStcXxSNwf1gDpyHLuihYC9eU2whizIZjkGcnKXwP+pVbX9GfYIOgGVxtG8JBxQCeN/g+BZfBxc4h+sqzimw5wTR6vvZhdsTsEioZCZqmPvYP4tXZUa+WVF+97XlHkBpy90LIVJlbXV39vaISpz+XB2AeTINT0Aob0bRxjQzdLm5mFpI+l9OIbyHWcR+nhJbK34RQ+0DBcF4MnTlBGimrAb0urtPXFG5FovG+CSLuMUV1yGtHcxt866CV5BTMhXVKBNpO3/4l9FSqD4Cv6R26ET7xdNTSMgn0pEOsM9F4Q8L2LnYZfGxZaxFMgMU2Yap8COkN8Bz8nSpzSXbbRLbOttsCpMpV4TuwKpXvmqxDqA/UOleHEt2xknvjra2zTUav7MxfKboAC7Il1pJHUXxmVfUUbOyZlcyxdXZ9Um5NaXQnwkCrMltwO0Ud2cXGknPkvm8sKcnM7Szrlr5wDSV6263W7eE2kaV8DOVal11Nr04jbS17GqvC5dCiGwebhOaogy5PIv8H8wSpssOk61N5xmTuk5UHI3aey33QqLTFtJM5CCcturzinygcAnpieXaZwiaoLbQxT+tfxuK3ALQOpvevv5Gn37HoXeW6AUJNX2TtvLTm/gD6rSs1/V1pszPbvwcBHlQ0ELRD0q5nejpEoUz/oL72XTqW0gSZAvVwLwwwaVzy9EFxNiqS/iaYApPhOvgLDkEz06m4GUD7MnlvgKvJdzox2uSA/3ilQR8s3at8f4GD6C5xX1lTB0Ejqn3rUcgyTW2dWtRDNIhc3wYXa0N0D+gk5HVogTzTlvRzqIdyv/5XBoxAo2E7+NpuHOYoCteFkPXXc4iylTAMXoOz4Gvavz/v8ogzpzEBZhFAX+CxLoEMmovkLWO6rSdW/D97d0H3J9dWaAa9FpthGpRjm3BeQn0nsoIYO0vjZuCwA6Kva5azQ/4BNI/QAE1TxZoKiq219AzsgXdhEViXQTQ224fgLupzW/po1ETIezcpttovKOZBLWipUjwtGaV2gYTevQPwCrwFIb+UuCVM52WDbaOi90unBXsTrn4JNX45jIP9fq7RyeWz+Hzq6WeSbzF1Nj119Gs22SR0yOtEo028rn+Ato4+dj1iTWm9c0+A/p5C7WFGYFmmM4XjIeRrqJHtAJ1OvKREBUxL2P0Q2h414QQMM3aYggYpAkznR1NBB2uVMr3f+oo/BCE7sbgdmilFixf/oeQcgZDD7YX47QbtfNKvBVnBpqVrKYyAkJML3KrOwli+zrpeMYbhxXgoPK+bFQGf3z39XOWaxgPgR1cHg+6ZQjeLndWOJ8TqcHoyxNHD52O0czz0aen2YmcpGZoudUxvVRC07Y76UNlhHLUkbgoNgN8otVXvWLyFU9rHPiLIHTjc7OMUoNV29TFoCPCNXaI+qrOz4hyPq04RvoAlHj7lSJ/GWd8HHayFWPRTos5qr+pru3DQ/lON6A2bTyXXwteBlUWnGursuIAAel81NUYH+Ia46HTicfgmxBmfCfJTZ0fqxtNa0YdMf89qEnLV93Mixz2htTq4sx349nZn66hTv4whpsOBfvqpbgE9YR9TZ+/0caiAVl9+/SQ0QbTz4+pjg0OctLbKrwuC/H1amNLW6CAgleec9H2iceAbuOntjqpu819M3CrLNbSzlTnRszTOUNzXWcOg9GX9B51K3nSC7YNwAAAAAElFTkSuQmCC"

/***/ },
/* 537 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 538 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 539 */
537,
/* 540 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA99JREFUaAXVms1P1EAYxllERRQ1UTEEP4iGcFDjiYOCmhiJJ8+K3jzIgT+Av8E/wBgOmHjQRM8aNaBGSDDRxJMmCGK8KIL4gZ8g6vp7Sttsd9tu6XQ/+ibvzszbzjPPMzM7O51upiYBy2azW4FpzfGd5Otw2QI+n+Ofyb/F32QymTlSI8vErQ1pEezAu/HtMXHeUe8B/gQxf+NgrFgAxNfQUBd+At8Up1GfOl+I3cdHEbLkcz0wFFmATfwoSOrxDYGIZhe+UX0YH0HI7yhQkQRAXlOkD98SBTSBez6AcRkRM8WwigqA/H5AzuNri4ElfH0RvCuIeB6GGyoA8p1UPoPXhoGU8No/sG8iYjSojUABkD9MpXNBFcscv4aIMb82nbXacw3y+wj0eIIrL2itf2VX20u6Y+UQbo0eOM0j4oUbsTMFI8CN+sL24yZz/g71b9NgVu2AqXZO4qdUjmn6TlwE0/PF9sxtGtKI9OIm5Cdo5JZDXmSVx++SHVc5polTr83RhfAIIKpe0giY2MuQygVTIORev0viJo6uuQJQtpmofqRMLWz0Gk3Bqd9tc7WgXAGUjuOrrajZx0EaKMAhJvJa2UxN2OJqmSUAcPWa1vwkTMN8AUxru0Faix8g1o8ntQXpBLNeZK1ViIL2OKcVSNC0u3yPa2quTxDXgbrBwjDiTKGket8BV7oKb8FLQV742hHX1NH7asDkR0Y4ufaVgmetzrm4jbxGJAlrEXet++1JoOVgjDO0V3PKbpYGta864gbMM+2aQq3mOBVDaJWA5oo1b95wswQ0meNUDKFJAtZVrHnzhusloMEcp2IIDRKgp560WlYCtM9Oqy1KwM+0shd3CZhNsYBZCZhOsYBpCZhKsYApCdDJgfXwnTIh4jxRy8brB5nJlJEX3Um4/9IIyJ4uJ6n6tDg7Ap5BfSFF9MVVnJfPPBkKBXyP7nRTFdqYzdlzaPsQoktVSDafkjiKq2XOFNLp2SciQ3a8mpMhm6tXgM34HmnQ82w1iBI3cXTNHQFFUPaHZACP9HpHdcpo2nQO2BzdZguO17lhhofvQe7oxT0C3VrhmUbqtwXcEveloLb8g+KWj2sdbOUHVYZEJ8lZv2sViAW+4AgUIJKIOEQiEXFGQhCmpp6/Ts8/DgIKFaBKiEjvSz5HNSJ0YNuHl+s160fauuQ35x1OTlp0BJwbEaE39MfwblzHkaWw74AO448gH2kljCzAYWsL6aIsIRuduGFa+r8a5BNEiJbgDlxCNMXimI7f1ePl+7OHH0vE6O82e/Ddtu8i1fG6TD9A6mHnLzf6u40eY18zTeZIjew/3un8970XOAMAAAAASUVORK5CYII="

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/inviteFriends@3x.df787e52.png";

/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA0wAAAAECAYAAAC9fr8rAAAAAXNSR0IArs4c6QAABVlJREFUaAXtm82OIzUQx/3RSSbJaEEjcYMDQpy48Fyc4Ek48AK81N4QIMEFCe1hRD463bb5/cudTGaF9jC7s6MEt2bisl0ul6uqHf+7K95d2fX5D38sP+nv4268icv1PvbjPC7SIXa5i+NijDHxl/koY0xdF0NJMedYy46SvlwoYSzF++c2T3Ah5JIjU4XgcrCyhFhcMtqXAk1f9oHeGOArqfL54KOD9moTn8mADzp4F4or/MPl4EO2+J57Pe+SLx3RxdZl+ogu0sl088W54EqRvugN7c/oUzttrM3ZWId/VJ/4RSNPY73WbuuVDNnC1v7s/nzX+i+lT7ab7CsfYG75CVubP+Qjb77iE5pWs63Z+YGGGz58MPmo+kD2N9+YDPxoc51kOOaaYta7m0uxV9OzWaBZ4MNagP1mz16Q2RoyktlGRLvMDlHYZGijbtuQy/TBrjaf6dNuUsdB2ziPjBMNHxLYiJA1jSuMkxBk0me0ya9zf9iFXaE0+cNsJ/t72Vd2hcbGmLr6RXQ5o99ul1/Fc/TBkcZ3x3Y4MsLkb/5rXIif7//0kmbVuqQDyp90Q6/E1xv6mq7QxKTxhWRtojltcparfKFkDngpcxolLLM3mhI6Iyd4+AqdTiZ43svm9CFFn7g4CEMnHYwH9IOMvqM+pnHoUkc5hFmaxSEddvO0iH3adcu0WmzT/d+v0u8/f7l/Xm0/rnT/zXevb10sX3FY/4xN5da5uGIjWWO0FfU1x505zl8SoAvq81p3J5qNZaJ992TVkcuNFrnROjbByNwdGyDyoJ1oDvzedSeaPvGwea6ePGcb2CzQLNAs0CzQLNAs0CzQLNAs0CzwkSxQNmCJkbM+ILBYqTqYeeQBeuKsP9Ke6B/BFyPYI4HAR9qHpytYBh6GHJBxAID3zGc06LNnrgNye0DvHtDbQ2/g2/CSYssj3Q31f8bi/rqfv/qVsQ/Xt9//9ulu7Fe8zlgDeFeoueZ58hygsoRrwWIMMInmkf0EniqQYrHvBZh4EgFgCh1yeLMjWR6ABJQDMGEwAFMFUaLVxuLhpb8CJ0CWE8iK1uZ4k1Hgk0yN5c2GgS/Jpo6Bavkfdfi01nY1CzQLNAs0CzQLNAs0CzQLNAv8Py1QypYzc+JcDmih5M2ZgA5ABrADQlBJnbO3wA/lxKvyrfoJ/DjAD0DJxlWglDjPA5wElJwBJs71kgufgJXN9Z6ACbB1BpKONOsx8AQU6HnFt0fnnvd6G5Jjtnn0m2Ex2/zy09f3R+c/AkzHxla+jAWUTngX34Rtv4q3sQuD3walFN6EfUi7GGaLIabQhdSHMPNDGGddnA2DsvXAuDFmrzQ+aKUZUoIewbW8TFWKofW9bEpeINWQV8qWKndKP0xK28qkfgGJ0TckZR/CQ5oXuXaUuZZTGiKMxm/9fKjkhiKdcUpB1MLP0hGPNOJhYZZ2XbQF2KBrbMj3lnJJrFRC7fj3cXonXXL8WUoh8QIjm7fFg+JCMhV/CKxxSP2BVgoiUizORGsS8cNeqIuXTppbfF10ZF218jU1jZuDg4mC+VHaFCsnlEmX0h2gVCjSgLgfoGsqG0NqWhVMxgc/W6mlrll9SmOzdCkGI4fUJJMDH9s5w6zP5tB2TZqRyedoUlOrrtr41744i5fq55qCR1DIr5aixpN3o4kHoktur/GldDTiQHW+vsk6sw7qpLFN7ZwX+LXElKLmIGrYwD+lpjGYnzTAkF80Ja/GMycX008KZ+iYQRjomjMnGOtTfyKdTb+pGMosK50t5nk+ZDLxlikrpW22HvOsrPLuvk+Luz6/SXf5zx+/2F17DF3K+v4FaMakq9nHZNEAAAAASUVORK5CYII="

/***/ },
/* 543 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABSCAYAAADU+8NvAAAAAXNSR0IArs4c6QAAAolJREFUeAHt3LEuBFEYxXEjClQkOo1STWIbz8ALKBUSlWg8gkIkerVWolCKRiHxEBoNCh3d+G6xm2tG7LlzMoXd/ySbvTtzzoz7y+bu2GKrmQ5bXddnUTuMx3yH+n+ufMUff1FV1UnpJKrSQiCvROettDdh+eXA/iiZ02xJOGXjAu/xdFfam6D8bSlymnvxO3oIFu/sQYwXhq+n5PkzkB+nZK5ME4E/BMYuHbFELEV/Lx7pQ5CtLfAau67GrdsK9FOcaLN9fvZkAg8BvZ29bg2L7zpaZ2BHEhj7/8Sc4HQQmXSDztLxO1a63T39/RB7EZhUgdaHYdxlrMVk04Otu8BzfDg+5/Uf0IF8FAfP8wDjzgLHgT2ybN517HY+LcWmwE6+owl9kx9kbAlcW23KCCCAQHwfHXca90D0L5Cg6/4vwxWadx2I9CTQ/FLpMq7z0tO1pu20qzHh/dGk09KRbVujAwwsgTAdZK41S4fFqZeB1q2sJNAWn14GWreykkBbfHoZaN3KSgJt8elloHUrKwm0xaeXgdatrCTQFp9eBlq3spJAW3x6GWjdykoCbfHpZaB1KysJtMWnl4HWrawk0BafXgZat7KSQFt8ehlo3cpKAm3x6WWgdSsrCbTFp5eB1q2sJNAWn14GWreykkBbfHoZaN3KSgJt8elloHUrKwm0xaeXgdatrCTQFp9eBlq3spJAW3x6GWjdykoCbfHpZaB1KysJtMWnl4HWrawk0BafXgZat7KSQFt8ehlo3cpKAm3x6WWgdSsrCbTFp5eB1q2sJNAWn14GWreykkBbfHoZaN3KSjZ/924jfkJs0Toj5aHA+nCQnvnJzFyjxzFLR4+4+amBzjV6HH8DnVdcum/N66wAAAAASUVORK5CYII="

/***/ },
/* 544 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 545 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA9CAYAAAC6CNk6AAAAAXNSR0IArs4c6QAABUpJREFUWAnlmPuLVVUUx+/1kaGpJWqYllhWYBFSKZWhlRVUgj+MNNAPQRAUQf0FYVkxBRnhDz0IIogIguyHLCKytKcFPijylYjT1Iw0Ouro5Hh9zO3zPbPXYZ9z9n2cO2cyaMH3rLXX8+z3ubdcapKq1eqFuK4Ey8HNYB4og06wHXwOPi6Xy4PwkRMFJ4HnwVHQiPpxeBFMHlFlEiwBf4C81EPAnS0VJ3AlqOSt6PmfRn4wV3EC7gdnvSStiucIbA8V1+JIEI4zUHSCiQlD641ThM5n0XX7Kcb4DSc/By+qqFJqN3RI8CnRY3o7BWMvmOA7FSCfIcdl9Pqw5RpnguNz4C+ldEU1Z5MoLlyml8tQJHpeVKU6eSoqPHQeCneHFledFy3O9P8rXNzY5cykxfUMMVrV+8Bv4GUwGvQ0Sa8Ds8CJEoV1mIs2gPHgkBoFk67LCWCry9ulxVUBoiFOFp0wq6NWsY815FYdbV3RaRXWIS6KVjgObyBvlqIg+pE861wu20WnJAw45VjHxdpAj9duVdS530ZnzrkEdkT3q3C/U453vITjEeSl4HfTtcB1DS4ll98Bq3FMhQ+5pImrkID96BeD9c6eh32K8yJy7E0F6YoU9amw3RhTI5X3ILAXrEJ1D/jMM9USv8RwHzErwMGAk9Xo1ZhrSESXDLPskyQb0W5kK1wKT3/eHkAXfd7ipzkNErE6K6Y5Y4/28ZNub2k/j9r1SO7pro7YKg215lKkiZ8eSXUeBLWDHWCzwx743DohZtKJZbRfQ73HWvDLgS02T50Q9Vm0MKEplS5ItUPNKzzlLvVYc3TSKZt5cy8+FpWnEV3lHLpYC5UxPKoofnHK+Y2isdux57sqRyOywr/K0d50t4tKD2Eo2dmAMqRLu13rFD+LW2FtB9ENw6zu0y4V30mXSyO6yTl8L26FNznlNaxQO12cKsMGMxpum4AuVpFzJg3bMd/IEBVmnnciHwVanY16HepxSEeqmO5w0l5qnZBsPZas00l06zCr+fw7YDke0Pkqnfmi74ZZsvBXTnmvGWvwgZS+Qi9CK913u8s1NvjKSGYepgH9NB0EOsWChG028Kkv6OiUOM5wzsfhcd54qHnrI/huA1pct7m4ELP722zRnFkjwJc43RfUiFd/XNgZ7e7VnyxBIlhD7Q9to/ltd4ksdzYvQ2E3iP7D8D+FEs7YDgOjbxNGr4HDOKCp082XuHYTPaY3+ij4CcwCy7wcaVHTYuTLpjO+AkFTt57c2q4xJQo77VuOPxR7ZQV/QSUSplwfde03U/pskyHRh7eGUqsweIqh/wQYBX95YJwJ9OfLvmyV5D6O7AyJTqG3wWTQFimzD/8Tp9ZQP0yYRvS1bHgNDW85z73tjpALtheA0WM1fHbiMACmhOyhOdZ39QGcPwILCbw+EOj3+K+0nZgH0C0Aa8nVaLslwwleAETvJi0lfSDqu8voxoB9E0ZtoblpW1NtAj8AZ4C2V0y0bwFGadvdzrAuDsgrkEBDLVrrx9K283oIOT5/5UP7Q6D/QOf4MbllErwP1Ov4ewxZJ5K2iv+7SEUXA9EruQulA0ii26UTPOXbaN8OFqV076DrBhN9/X9KbuonCz3QYaL9uhzoyrS9qSvxT6BfI1vA1+AHtlAV3jpR8CLwLNB/GM1SF46KsZfL9wIEPg76QKt0jMAnmq6K88XAvwRaLWxxryPUn1IcpoLtFlEgf49cweNZe1B7c0uBxdKpMkdvNA14daQ9R6H9iM15NPYUuBKFLuzwcJj3yLl+DFzNdjtohTr+haJ67UngVQnnjf4BRNy2s6T0IsUAAAAASUVORK5CYII="

/***/ },
/* 546 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAqCAYAAAAUJM0rAAAAAXNSR0IArs4c6QAABJZJREFUaAXlmllIFVEYx7ttti9UUtlGZFG0kJiFBCmYYVFSZEmRSBS99NJ7BT0FQb33UoRIZfYQBYkKLVhZ0GYLIVG2mC22l5Vl9vvjPaETeme8y5xrH/w8Z2a+c873/efMzJm5BnrFqbW2tvYm9AxIgwUwFcbBaPgCb+Ed3IFTUB4IBL5R/h+GQEmwG+rBi33H+Thk9milSHAClEALhGsP6GBzjxKMhBJgJ3yDSNtFOkyOe8FIYhLURlodR38/2C6MW7EIPhm83occGnja3B53YpHeLGj0lGZknHd1JlagswN+7SffkYx9H8b6FEMOy4gy59hai9hmRQTkl0jS4ignK8kpilVCEeA2AlzhDDLG2yMYr9g5pjWXHiKNIbg6GOQM0qftlVyCZ8zYNs2oHRaJJH32c/L6GKGsmFEENJiAGmCoCcyScgOz6qhisWVG5RKLbSJJnwL9kdki1Pq2cKz7u5TZnmiFUASik5VtnURtAeketU7VmM8onSHYCMWwhRjmwQAFY6ktVFx9ox0cYiQwxmLQrBESRg+RJngDtluqAoyKUIgzi76XgYRZAgPhN9yAvVAOl3mi/MR3J3WbbQYx9o6IUHSkz69ZIGFywLyC1FM/BhJGn2L1adZpWgnbbJr9w7slFML0p3E6SBiRAuZyukDdCKOX21A2JJSDBcdHuhYKccYT8FqQMJmgV41WuAX7QOJUMWuaKb3YFy/OPvm2uBaKAPdDPjRAKUiYMoTRrx3h2IdwGseobaMuF1fGjJqC4zCEqXHVwKUT/Rbietilux9uzeSc4HpG4VwXTpQIMpf2H+nniaOf645t2zZfKKCoLTgRRj8vFYIWlq8Z6zZoaeC0e+z46dxp0fYlxeJ6RoUKHDGG4aObfBYshRkg+wTnoQJOQAdjhv2m7Vl2rupwwJ6NCwrF9T3KGTfJ9WPfIpAoEicN9G6k2VENlSBxriFGC2WnRl95HCzp1MHfA8nE/9CTUCQ0m5jNjMmgriWC7C5IGHGejr9Surag6FqM2ramukQui0MmQgLjoQCK4BUY0+9tR2ATJIbsyIUD/eiLom329/NPh3sUUerjWQaYWTMzmONnSl2rupQqUdnNijvYNHTBuHPw0npMM1FfO22w5wRx0gQSIEi9za8GiaN7ju4zv+Aq6FKSONWI0+V9Bh/XxpgTcdZ45oSMCTY+R5kZrPtdrCXnDkLpqTQUNEskjDiHU8ReLRBmOH1KACPMdOoy80Q04z5i300wM1k+flgF+We3H1gzaj47Gjjwsv2BcOr02Z/26WBmTSp180S8Qt0I888TkbbTOH4DdPL8sEYGTUGPZ1EbnCTzoQyawFgNlQOwHMxTsssY8MsFP0z/2ZLSZXCROMggVfAUDsEGMPcez93TditoMRor01i6V8efEfgaaI6BUhojL/4UahcxCaRDbRTF+kDf+lwd/0Yi+vfEPaBv7JEyXWqlkBz/CjkyIKnJcBDCEUz/LHsa5ji673mbJKlPOHtBDw89qdzYY5x2QVJ3FPH0UtydAaLdhsQTGENrQf3yMwr0pP0FDUG0PtQ68T1lt+0PYvbv79qScgQAAAAASUVORK5CYII="

/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 548 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAA2CAYAAABkxd/2AAAAAXNSR0IArs4c6QAAAR5JREFUaAXt2TEKwjAUxvHWKzgIrt7EA9QDuFRcPJPgITyPuOsgItq5fg9cREoaSINJ/w8yaNL38n6FLq9o27bWumvlEtZLXQSK0lQC5fqrNKUixIUmIZLknAMgx9sFqAfQRmcejnMpbVsv1hOBAAIIIIAAAggggAACCCCAAAIIIIAAAghEFrCxz0o1D1rTyLVjl7up4FbToKNPYQO66IGZz0MJn33q7nMhvfr2kO3gsAvAd6DI2KdL8vO/ATWOMzlte/dqQGst+4DlHtaj9UoggAACCCCAAAIIIIAAAggggAACCCCAAAIDCdhUY6nce63FQDVSTXvSxXdjm4v5vqzr6OZivkLMxRxiY5uLOTh+thsDqrTsg0R8C5z1s3oDqGoDcZrO4FYAAAAASUVORK5CYII="

/***/ },
/* 549 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAAAaCAYAAADR2YAqAAAAAXNSR0IArs4c6QAABVZJREFUaAXtmmuIVVUUx+fmK00NzMJUbEKiwPoQAwb2mk9iJWQPCqEPOkRUBH3o8SGQCoo+FERREBQhURSVzUBFGEVT4lhR4CMKnMQpG0WbssxGe3n7/ce7L+fO3Wevde85l7604M/eZ6+1/ut/zz2Pvfe9la6EVavVqbh7wU2gB5wNzgQ/gwNgJ+gH71UqleO0HTO0nA75anAdOB9Iy1xwEIyCreAtMISWKm3HDC3nQC4dV4NusBCcAvaDfWAz2ISOYdrWjQLXghHgsV8IehToiynV4JwBHgC/A499S9BtYEapQiCDcwHYCE4Ajw0StMqtg+C54G0PcyTmMGO6Q0oxuJaB4Ugdz9AOgs4oRQgkcF0PjngKR2JeZkx3Rr4RcC7QlVPEjpJ8aX4VnweONWC8iBByd4MFvor5UXA8UlCH0t8AU6JVcMwHI6AM+xWSC6KFHIPkXgH+LEMIHDvBaY6y0RByHypJh2g2NhVhsAI+lbdE+x6u2U3FjAFyuoG+vDJtwCgbdSPgxjJF1LjubijG4O0dKCLKBxsKOQ7IealDWnod5eshaJgCdAGVbZqcnLwo6UwHY44K/xDzORgE2x3xCvkNaIroMmKXAtWxTO+CLUBaRqzgmn/QJaIWRM6tTl6dO+kQdGI9dvKiJHKVI/oTYpZmxXPcC1TQsvXZvFQfIs+L7Rni6o8z+tPAWjAKLOtO1c/6INpqkB3DfxeohDz6em/eB/4CKds7kUPEs6kofEMg+pZmfBZ4H6Ts3SDOaiHR7CRlj+VxkKS75rtUMr578/Kz48RpPm/N5Vdmc7J9cq8C1oShp4sg60V7ZZZ4cp98TU9TQn+cnBM7hkPri5Rpjj0rlhvG8K9PEeB7PcSmWuK0wEzZB6l8+Ui23l13aOK/OEE0yhL544S/C79uoaFEjG7FaQl/cC0KnZx2gFrjOb4w/Bqdv8NBpLVqhBQr7pUQmGitmEU6+dqXyDPtU3jsByPIs+1grUZNLXw5x9BxOKFlfsKXdRXWAtnuLGGkP08n/6eIIwwtCR2jTd09Sj1k5Ms9ZsRYNXSrnwrHvASP6xFYhpbaEyF1pw7r5I8mxC7kA5nPfPJXJDjGEJJ6FIRU7QimTM/hmakAfGtBdHJQy7NqBHor7pYQaLRP5PiPMD7geTFoTp97u+J7E6TsnRwBTcOQWPtKLxKjC6bJGJ8N9oCU3dOUGBmAYHGKpOZbF0ltGCJO0+AnQXbtonXBZROBdNYAy7RDeA3Izmk1Heu3EvH3NShKHBD7tINPX/bFWRqOl4OvHbnex6guyl0Gn2Z4DwPr5Syus8CdYF1DPAfeFS6h1W/AINgGrHksIRMrvlZWuCuU5DStP6TFu9r+KPuFWX14Nzh1aLElHS+Ayy3eJj9J94NO2IamYsYAIgY6IQTO5UbpBjfxWkDub0PLq+REH40NBcIBwTPbLJTSNoKz5a1ccrRo8/5qlaqf9W0Kn7WVFoJ2dzVd75a6FgpdBI5mFRfoF93Pb/dDxyR/yaA1S6qfh8kdcp+LkRpj2ybzmMcQrgRFr7pDcPSYxYwAOPQyK2pfQOBZ4OWqIV8zlg9bFLInlzDloMiFYG+LxUK4XoL6V0EpBtfN4Hggb7F9nvjpZQiBZyrwzMSCRG1ztGcwzAGPA2trNBQ7SKcP1Kei7VVuzoJzCXgKjAOPfUXQJc1MxUfECzQh0DQzz/bhcF2AyZMFyXlI1mruBrCsJv8ErZbpB8B20A82s4r9g7ZjhpY5kOt/MtKi34f1AbP/29nCsf638xlaqrQdM7Robq//7awG3UD7Y1rFD4E+6nu2Uwj93/6zM/Avdy4G5OpEoLoAAAAASUVORK5CYII="

/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAABNCAYAAADtoJffAAAAAXNSR0IArs4c6QAABSdJREFUeAHtm9+LVVUUx+eO/U7JDIMCHcjsB2KDhVG9NKVEFhVBP/DBt+hFijSCXsroqR8EvRT0ENRDFPQfBEb1kGUvEZoNJsxkPyzDUBs1dZw+3zz7cM65a5+513v3dZ2xBd85Z6+1zj7f76x99zln33OHhhLazMzMteB18CX4B0yDD8GqhKdN2zXk14PjIGbPpmWQoHeUrAYnMkX72W4GD4K3wREQ7L4Ep0/XJay/ypj/wXZp8Uy0R8AOIPsZnF+Mu92H6EoxzmyDRZTY8pDA9n4rp1ffcK8dGMffmPlOsv3YiA+1Wq3d+PdmsRusnF59KYSFPrWdriF4SRYL+TWp3YdSdLqjQPhOixLDbwz/FVlsp5Xj0gfxbdlnSJPDiiJJ2iNgHMgmwHnFuOt9yN4CwnSva5mEfga+B7pQB1vnWkggB9v5YB14A+wGs9kkCW+BsdCHmy2kWuBh8AU4Cc7U9nDgFrDkrIqDwDB4HISLLbt9sVP08g5YOHCBnHQU7AIpTXctawcmjpM9CepubvspVtV7GbSSCuQEL/WTdRd9vU/uvCTi6FjPVWfTPuLk/RVHhxoOHuyDvlUNNQ94UFTg8Hwn4mo/lHSmZyndy83vpLMB5ZziPLfzhLC97nyz3QRv4WBPoqRFnF/TTp1FK0a1lnHgOOjvB7aOTXextVRta+yQuoo941iU9NQuBpkVo1p6CNwPwsOgOvJmMxBaTtX2WMRiFXuIZM+ipEVFWa8dy2LC1ljJDn1RnrGhqPJe41BIlZIWjBYwHI9VA20V4/Ol6b0JoqRFywphVUzt3NqEEUmyHJafsf8711tdWsKusxId+0y+lrDFjkVY1Ey+ljBvt1CWmKLP5HtOCbPEFv9D3vZNvpbzb2/MZ+EzZcXPKWEHrP+AY99Bi5tVsZ+sRMe+SYubJWyvlejYN2Fxs4SpYlpXaIp1VjHulI+j6LemqIKnOcKsiknToYYIm6YQhy2uMWHTVrJDn0aXaTFhF5jZ/pxRnjFh4Ytvf1LKjObxYHx52XW61SaMxAsJLbKSnfqWWLzahJG0DJhrIVYHDnwdP2iaawgOBMQo3GwFrIrdZiU69pl8LWHm2zSOhd2RzQsliiVhJFxFdHUpw39Dk93dVZolYQQfrSY0pK0l+ZKVZj8qto2oOWZLR/lr/AWlxdxe5XdMecUQpW8vmyhK/2ZdpEvvZeXCCOj7sCbbU0Xy/w1FqrUA5y9A2ybbKMPxOwkIFdvEftNFSc+L+iPTm2ua4n8E3r/oE99ObIyqfa6KvQLmiigJf5NiDatiR2lcJM8csqWqWD4u54AwLUJtYiieXgehahvBoF7V41RJTPzzO5D8zgOn3rbWS1ijDaycpvgNYapv4484PWqregdAE+xPSOrF0HDZatNUcpB4GXgVHAIeTb9o0ux3ZtdeDtTr5k8DvWHtwfZB4gVgLuCUqtNJg470xvYa8B6YAoO0g5xMb5c+AqLLbVUd+eRRDcTadH4xMT233QX0UKo1ks7GOImzmN6PmgC7wE6wFXzKpHCCbVfWtbBq7wi9FN8qcCu4EqitL7zDVs9ImrVE+iagz4Wen/Zl+D3bTrL9ARHH2P5vsf9AzxWzOqaK7+K/F/wKpowc3cLp5nucCt1jxHt2pfqJk4bd1RnqSI7XBXuJ9etDX+WwveqItL+J+H26GYoLwWFQZ/qx94hPBTWsIP0YCD+OswQ+V3O47xBqVoBPKqq+pf1EauZJZsUqaYTo+rUIHGUW/LoaT9H+FxI3HzR4nzCaAAAAAElFTkSuQmCC"

/***/ },
/* 552 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 555 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 556 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAADEFJREFUeNrsnXmQFNUdxz8LZDkFpESRoGAUMCJRS0WkiEYMMZGYaOKBJwbR8qp4BFeMVqlRQTGgRvGIHKFEPDBo8NioFKh4IQQxGhRvUIRA0EUBhWX3mz/eb6pme7pnunuOnZmdb9UW1EzPr/u9b7/3O997VZIoAfQEBgL7A33srwfQHegMtAPa27Vbgc1AHbAe+Az4BHgXWAasBBqKtaFVRUrIvsAxwFD765FD2ZuB5cBCoBZ4o5gIKiZCBgEnA7+1EVAofAk8CzxqBG1ryYTsCowCxgD9iuCl2AjMBKYAH7ckQvoDY4EzgbZFOGXuAOYAE216K1tC+gHXAiOBViVgTAh4AqgBPiwnQnYBrgfOA9pQetgO3AncaNZbyRJSBYy2od+N0scG4FJgdikS0huYDgyj/DDXRvvGXAvO1zx+GvBWmZKx0hR9x3wIz/V83ha4HTi/zEhYDzwCzDJHMm/IJSE9bCgfXiYkNJrDOA2YB9QHzDDDgDOAu4ClxaJDBgBPAnuVARGrgRmm/1YHXLO3ObSjgD3ts6+B44CXsjO0pWz/BknaqNJGo6T5ko6X1Dqgne0ljZL0ol3vh+8kXZhNf2ZLxo8lbSphIjZLulfS/mnaeKCkuyTVRZB7v6SqQhNyWMSHLCZ8IelKSV0D2tZB0jmSlmRxjylx+jWuDhkIvAjsXGL6YQUw2awlv6huX7MQf5ejto006yyvVlZ34OkSI+N1YDzwlMWnvNGEXwC/B4bnyDdbCfwdeDvfZm+1mYB7lAgRi4CbzHz1ooOZq5fjos/Z4j9GwmNxiIhrZf21RHTEAklHBbRhN0k3SNqQg/uskTRR0sAM/fb9sEo+ChmnlwARr0s6OuD5e5u19G2W9/hG0kxJP5XUKk1/9ZE01p6pUdJ1uSRkryI3b9+W9OuAt7C/pOmStmd5jyWSxkjqlKaf9pRUI+kNn9/vkHRwrgiZX6RErJJ0RsCb2l/SbEkNWY6G+yUdkqZvOpnD+HyIe83PBSGnFiERdZKuNu/Zb2qaLqk+C/nvS7pYUueAPqmSNEzSDCMtCkZnQ0gXSWuLiIh6c7h28XnW3U1HbMvSGBiRRjd0k3SZpJVZ3GOLpP3iEnJnkVlO+wXEmK6O8aYm0CDp4Qzz+yAbDVuzbMMnksZL6huHkB+aIioGPXFSwLRxqn0fd7TNNF3j1/42kk6RtDjL518n6S+ShoQxfdN9+UgzE/GdpBsD9MQgSa/FlLtN0lRJewe0u7OkSyV9muWzPyrp2DTR40iE7JcmxFwILJY0wOe5ukq6O6bl1GAjok8ah/HWLM37pWYMdMvQ8btIOl/SkWEJ+VszEbFV0hU2XXifaaRFaePgqTTedC+bUuLqhzpJd4Tw1ruYeVyb5BMt805jfj/skaWlEhevBMzne0t6LqbM1yxnE+Ts3pdFW9+UdK6kjmlIaGtJr7k2jfnhhEyEXNUMuqLGx9SslnRNzDf3M1P4VQEj4r6Yfso2SQ9IOjzDaDjELNQwmdRl6QipkvRRgUMeB8g/E7kiC0OgU8C8/eeYBG+UdJPNHqTRQVdKejeG/H5BhAwpEBENkiZJaufjeE2LaVA8IWmfgNDGtZK+jiHzA1PSQdNSK0nDJc3JMlZWE0TI7QUg43MLO3jvPSKm0l4j6TcBnTU6psylJrNVmtEwTtKHOeqT14IIWZVnMmoldfexPmbEkNUoV6Dglxf/ic3NcTpmRBoHbrCkB/Ng9DRI6uklZGAeidhu86u3ocMlrY4h7z1JR/h02D5m0UTFC3L5DT8SvmcGwuI8v6xneQm5LI+hj8GeRrYzKySqrtgm6U8+uqe9ff5tjBExLICInST9wSy2QmCal5C5ebjJMz5e675mw0fFooDg4nGSPo4o6x25hJYfEd3lUryFLv5710vI+hwKbzTz06sUR8WIyn5lYQbvdNdH0pMRZX0s6cwAZd3bPPYtzRSlaJDUKfEwe+RQ8CbzTr2m5wMxTdndfaKwl8tVHYbFNxaSqQ5wFO9ppuiEF0OSTc5cYIVP+KN/DCfvS7nUrLfzDjaTNMpbN82H1ERC6440IY3mwOjEw9XkSF908Znfo0ZPa+XKZpLldDRHMkq4Y6GkgwI89knKPtmUD9yceMi7sxQ0WU3j/lXmHTdGnOrO89EVQyMq7XUBo6varKavVLyYnXjY2pgC6k3hehM88yLKeV0u+uqNlN6i8LmPBnuxuvrE50ZaGKTY8ULioZfG+PHXkn6m1LqktyPO8Teb85Us54CIcpbJZRG9o+JQxc8sNgdWJB48arpyrdy6Ca/C/SKijOE+8adxESyeOkmXKDWhtbNZTg0qLXyRaECUdR7vKTUN+suI/kWtpF2VmhhbEEHGQz7WU5X5OutVmqhLNCSsxbHEJzh4kcJXpzSYsvc6ZkcpfP3Xp3LFA97paYCkl1TaqE80JgwWWHwn+W2cENHj9nZka4tBhZlaGk1pd/JxFK8pMn8iNhKNyhQu+KealuO0lqt5DYvlSi27iTJFfeajbxLr/95UGSHRsHVprnnKTNBke35OhHvMkluz562r+jzk7x8wJe01iW9QdvW7Ra1Dlgdc8Lgn/tPeCFLIKeYqn7d6lMKFyTdIOtHn9z+KaBKXEjYkGunnyM3xkNFBruQ+DLb6dGYbSbdF0Fc9fUziseWiK4Is2ERjJ3u++IfHtm8v6dkI/oXXSeumcGtMdpiC9lphe0Q0iUsVLycafG7Sh/M9I6NthNDKv81bT+7MvnLrLcIQ6bcucKRc9Lcl4KFEow+3D171KOBqSU+HFLZQqQtchirc4sqFSq15aidX0NaSMCE5gfQvNQ2fVyt8kPAJpea5TwypvCf5hD76lps5GxLneZP6yU7frJBCpiu15P6SEM7eFpuO/Fb7fqOWicOCyiKnhBRwq5rmL8J676uVmjxqK1dn1VLRIKmjHxnjQgoY5xMGCbOxwKtKDSz2lKt+b8l4Sz6VixcoXJbvCqVm48KsuHrYR9cMlisHbem410vIAIWL2l7hYw2FKccZr9T07Jgyd/SiYKSXkCplXu5bo9R9pTJ579ut471e+10VDpo4xN2CpqxckrFJqVHaneQqVCpI8tAVUP3eRf7rHK72maYyhVLW+VhSvUx5VdAUlyrNkrZFnosn+ijwTKGUT5S6OP7AivIONHd7JfrJb/e0p5P+fx9wpWcDs8eBn6fZgusdYAjwQdJnI2wzsZ5U4MV84PN0W40/Z//OAy5K2hKvte0feGwa4a8CRwBrkz47G3fkQ6dK3/tiaqYd5arktjXq4Pks09r1+UrNDNaoeTcgKHas8sbxgkInXn/hlgyCa9U0514lVwBXQXqMVYxtYscBE9J8Pw84CXfoSWIanFKGG/LnGl8CPwA2RdmV9BzbXjUIjwGnJ5HR2ubEsyv9nRGTvGRk2oy/De4wxn0Cvn/YtlltSCJjBu6grwrSY5316xa/4xaCsAO4MOC7OT5kzKyQERp/9CMj7HEVU23qSmCubaFdn0TGg8AplX4OhSXAYDufJBYhXczZ62VnhJzo0RmzjKAKMqMed6Lp8qALwuxzvgl3AFath4wq4N4KGZEwngwHVUY5HaGN6ZUEJgOXVfo4NBbjDlreke6iKCcBJAu6rkJGJNThTq7bkenCOEczXIA7PrWCcJD5aqEOO45DyPMEH5ZVgb+J+0zYi+OesNMHF07vVenvtLgnjS+XU0LAHYKyCHfiTgWpmAucnOQ8h0I2x/usBI4B/lfp+xQ8A5walYxsCQF4EzgSF5upwOFx4IQkf62ghIA7+WwoTVO2LRXTaJqKaBZCAD7CnYH7cgslotGsqTFxpql8EALubPFhwN0tjIwNuGP3JuRCWL4OuD/NTL7OZU7GQlzKYU2uBObrgPvZwIHAK2VKxHbgetxBlGtyKThfIySZ8AtwUc5yGS0LgItx2dS8dFi+ld0UYF/c+eSNJUzEWlxM6uh8kVGIEeLFQcANuErGUsF/gdvsxdqc75sVmpAEDsGVFx2PyzoWI1YDt5pv8W2hbtpchCTQG1e/dRbFUffbaDpiqnnc2wv9AM1NSAKtzYc5CfgVsFuBSXgDV2M2h2ZOLRQLIV5D41DgKFycbDDQNccErMAVhr+EKy7fUCyNL0ZC/LAXcADQD1d+uaeNou64qvpqoKNdW4dLlW60v1W4yHTi730CaqIqhFSQgv8PAN2m4UjKZ/oUAAAAAElFTkSuQmCC"

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bell_icon_00b4c1_132.9d68615c.png";

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/done_icon_00c6c4_132.0c3d0e89.png";

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/edit_profile.740d2356.png";

/***/ },
/* 565 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/enter_leagues_0e2c37_150.f477b5eb.png";

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 570 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/horizontal_logo_645_145.0b22f07b.png";

/***/ },
/* 572 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/loading.8c98da9c.png";

/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 576 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lost_icon_150.9f57242d.png";

/***/ },
/* 578 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/penta_logo_1254.db4588c4.png";

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pick_entry_0e2c37_150.7b29e7b5.png";

/***/ },
/* 581 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAACuFJREFUeNrsnXuwVlUZh58DRwgSQQLUkDTEHDQCR5LoHhFGpnGJilQKczIpKlFyovACannBzLuleEsqEwQJ0kAQQlLBpGwo5EQMYQqEQBRX4euPd31xOHK+ffn2XmfvfX7PjCOja++1vr0e9mWt9b6rplQqIUTStNAlEBJLSCwhsYSQWEJiCYklhMQSEktILCEklpBYQmIJIbGExBISSwiJJbJLLUCXgcPDlO0IDAMGAL2AbkD7kPW8ADwOLAFWAZuBXQ3KtAHOAgYBfYDjXZ016qZEKAFjgdvTrmjj/OkmVgDHAZcD5wCtI/6QGcDVwIoK5Y4ExgNjIogqojO+SqlqgXbAltB3rEaoAcYBk93dJArrgPOBpwLKfdb92C7q91S5ApgS47i+wHnAYOAE9+q0F/gT8Gtgquvr0GK1AaYBQ2I05hlgKLApQNrr3N8ikS7XA5MiHnM0cDPwuUO8ihwGnOb++Q5wGzAR2B0kViv3PjQwxo9YCHwa2BFQ7jb36BPpcitwWcRjTgZ+C3QNUbaNuzl80N3VtlX6KrwnplSr3Z0qSKrxksoL9wLfinjMu4AFIaWqT3/3Pt2yMbFGu2dqVN5wL/fbAsq9D7hWfZ4604AL3QdUWLq7d+KjYtY5oP6rTX2xOrjncRzuApYFlGnhHoG16vdUmQGMAvZFOOZYYL77dzVMcB4dJNbFQKcYJ9sV8i40zL3wifT4DTAyolRHu8ffOxOov517cv1frMOAi2Ke7FfAqyHKfVP9nioLsOGbPRGO6QzMA05MsB2fqi/WQFdJHH4Rokw39+Ug0mEpNmuxI8Ix7YEngXcn3Jbe9cX6eMyT7AGeDvlip6mZdFju7hJRpDrCSXVqCu05qr5Yp8c8ycqQP+h09X8qvESD8aMQtAVmA/1SatOu+mL1iHmSupDlesiBxFnlXmH+FeGY1sBM4MMptuu1+mJ1iHmS10OW6yAPEmWNk2pjhGNaAY8Cn0i5bcvgwJhSm5gnCftZG/f8K4AL5NGbWEfludiGtAQexqbbfAx5ZH6w8j/YWi4Rn5bAfW4oIm1ewYaftIK04NRgsyLnearvqoYv76KY3OzxVWImtoABiVVsrsPfbMdCbCqnJLGKzRXYIjwf/J5DjPpLrOJxKXClp7pewAZo/9vwf0isYjEWuMFTXRVH/SVWcfgK8GNPda3GBlobHUuTWMXgHOBu/Ez0/x1bVLChUiGJlX+GAw9Qb715iqzHppLWBxWUWPnmTGx9uw+pNjqp1oQpLLHyy0BsUrmVh7o2u/pWhT1AYuWTDwGzgLd4qGsb8En3FYjEKi79sIV6bT3UtQNbnbo86oESK1/0AZ7AT/KUHdiI+tI4B0us/HAKFvrewUNde4ARWOQPEqu49MDCtDp7qGsfFps4t5qTSKzsczy2euAYT1KNwqKpkVjFJanQ9zCUsHwP05I4mcTKLl2cVCd4qu/bWIaaxqiJIrjEyiadnFQnearvMuCWgDLXu69EiZVT2rshhV6e6ptEcJahK7F1XqEpYkqhjljKgO7uz9uwGfmFuGDKDHM4Fj7lKyvPFGy1aSXGhyhTaLG6Y4l4R2DZcw71xTMX+D6WnDVrlEPf+3uq7w6Cc8COJWbOtKI8Cs/F5rK+2IhUYCsAzsKW016Ssfa3cp/4H/VU3/3AN6ic8a+qhYNFEOtC4EHCz53VAjcC12RIqkeAMzzV90ssJKySVCOpcuFg3sXqh6WfjHMBJmBppJuSlsBDwGc81TcLC16tlBphqGtTVWu88ixWDXBnle+Jk7BNEpqq/fdiudR98KSra2+FMoOxRHpVLxzMs1iDSSZx2I3A15pAqruAL3mqbxGWA7ZSGskBJLhwMM9ifSHBTr4D+LLHtt8EfNVTXc8SnEby/dimEYmt8cqzWP0TvoPc4+mxdA02feKDF7HVn9srlOmLDcO8NcmK8yxW0hOz5Rfps1Ns80T30eCDP7svzUppJHthA7KJLxzMq1jtSGe9dyssv9OgFM49juibJcWlzv2GSsnZTsLmIzul0YC8irUd22aFlOR6DPhIgucc4z4SfLAW+BiVc+93d1Kltp1fnh+FdSmeu617mU0is/Bo4o+1RWU9FvpeKaC0Ix7WeOVZrMUpn7+cC71PlV+uP/Uk1SYnVdBfuK4ks71JYcV62EMd7bEAhlNiHJvICHZIXscCSv+alc7J+x1rkYd6Oju5ouSqL49g+1g9Ug4ozdSKjbzPFV5EtK0+4vJ2LBTquBBlEx3BDmAHlmJ7WdY6Ju9i/YXo26jFpZt76a20++gH8BelvAsbc1uSxY4pwrKZx7HpGB9yVYrvey8wx5NUe7C87U9ltVOKstDvZ0TfqjYuPZ1cR9b7b+/BX+j7PizR2pwsd0iRginibK4dl94cmArp6R6RHT1JNdq9w2WaogVT3Opemn2Mcvdzcr0DP6HvJfex8lAeOqKIUTpTsJn6qzzU1d/j77oYG2zNBUWNK5wE/LBAv+d7+MuILLEC+C62l0zemQxcm7dGFz0Sehzwkxy3/0fA5XlseNHFKmHr2e/PYdvvJnvxjxKrgVwXYPF0eeEB9wVYkljZZh8WTzczB219BItCLuX5gjenbDN7gc/j9izOKLMJDiiVWBmkPMe2IINtm+fatqcIF7o55scqp5l+JkNtWgwMKYpUzVWsslxnAs9noC3PERxQKrFyRHnl5R+bsA0rXBv+XbSL29xTRW7BAhBWNkHdK7HYv61FvLDKQWrRLQNJN5ysIXUE7FAqsYrBq1iQ51oPda3DcqT+s8gXVGIdIPTuoVXwipNqXdEvpsQ6mL+5jt+Q0iN3kOdHrsTKEC+n8P6ztQk/EiRWhniJ4BRAYcnCsIbEyhAvOrmqGWMqj/I/19wunsSqTDWj4ruxaZrfNccLJ7GCWYyly94V4ZjyDqXzmutFk1jhmE/4lQf7sJ0yZjfnCyaxwjMH21Kl0lqpEnA+lm4SiSXCMp3GF+KV19c/qMskseLwcyxHe8Olw5eQ74ggiZUBpmJbrpXlmoiFaglHrS5BbG4HWmPJQK7W5ZBYSXKTLoEehUJiCYklhMQSEktILCEklpBYQmIJcRBZH3k/HDhN3ZQoPXyKtRNoE+P4sFum7YzZvj7AcrmQGUKv/y8/CrfGrOhtIcttVZ8Ugq1RxYobRHliyHJ16pNCUBdVrLh5ok7GdpQP4nn1SSHuVqujihV3e7JabOPHIBaQ82StggXA/qhizSd+SPm5Icr8g4xu2ChCMy1K4bJYe4E7Y1Y4hHBb2t6ivskt64BZccQC23dmc8zHYZi9XmZgYesif0wG3ogr1hZgfMyKR2IpeiqxHxgTtYGiyVmCBY8QVyyA+4i30WINtl/NsQHlngUmqK9ywyYsjnJ/tWKB7TszP0YjjgHmErzb6A1VvM8Jf2zHEqKsjXPwocTaA5wd9WXN0QtYRPB81NexnVBFNnkNS5sZO/1SY6sbdgJDgUuJPs/XE1gGjKpQpuTOPQLYqH7MFE8AfalyULtFQOdPwUbXp2L5nsLSAdsabYl7qa9ppNyjTsQfkEz2PBGfP2DpmgZjSXiroqZUKtFl4PAwZTsCw7Dkr72BrsARIetZ4x6tT2NpGDfw5mRmbdwz/QzgVGxsrKP6OxV2uxfzl4GlwGNOrETYOH+6iSVE0mgFqZBYQmIJiSWExBISS0gsISSWkFhCYgkhsYTEEhJLCIklJJaQWEJILJFh/jcAetvyBB+MW8wAAAAASUVORK5CYII="

/***/ },
/* 582 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/profile_pic_plh.c7939e21.png";

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/refunded_icon_150.4cf40227.png";

/***/ },
/* 585 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/score_points_icon_0e2c37_150.e8c72a57.png";

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/setting_icon_ffffff_132.b501c5b6.png";

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/share_icon_fff_132.c5ed5a01.png";

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sponsor_banner_sample.12355b97.png";

/***/ },
/* 590 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 591 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 592 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 595 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAACXBIWXMAAC4jAAAuIwF4pT92AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAACq9JREFUeNrsnX2wVVUZh5/LBUT57jogQjghFhZgiGWGqQgKBpKYhVEqGmpaGZYMDAMohpM4OWEMmBqoZeYXIYSSJCkBEqLFmDEKEmSZoHwFXJCPy+mPd53xMgJ3n/d87H3O/j0zzjiw33POXuth773etda7qzKZDELERSM1gZCAQgIKIQGFBBRCAorU0Bhg86XfV0vkTitgNHAx0B3YAjwHTAbWqHl0BSwmpwArgfHAaUA10A64AvgbMFRNJAGLxVnAS8Anj/D3xwFPAtepqSRgofkqsAg4voHjqoH7gIlqMglYKEYBTwDH5hAzCZgRhBQS0EU1cA/wM2d73RBuyc3UlBIwV44FngJuyvNzhgJ/ANqoSSVgVNoBLwCXFOjzzgUWAx3UtBKwIU4JI90zC/y5PYHlQDc1sQQ8En2CJCcX6fNPApYWQW4JWAF8DXgeqCny99Rg6ZyLJKDI8iPgMedodZcjpjkwF7hKAqabamAa8FNne/wR6Aw84IhtAjwIjJGA6aQ5MBv4njP+QWAQsA2bervd8RlVwJ1YnrFKAqaH9sCfgK84YjPAbcA1wP56f34r8F2gzvGZo4BHgKYSsPL5FJZm+bwjdh9wNTbNdjhmAMOADxyfPRx4FmgpASuXLwX5ujhi/wd8GXi4geNmAwOB7Y7v6IclwNtLwMrj68BC4GOO2H8HeRdFPH4xNvvxruO7emO5wi4SsHIYjT/Nsgr4AvD3HONeA74IvOn4zq7AsiCjBCxjqoHpwF3OUeZzwDnAf53fvwGbXVnhiD0h3I77ScDypDnwNHCjM34mMBjYmefv2BIkWuCIbRkGJsMkYHmRvXoMdsRmgAnASOBAgX5PLZbyedgR2xR4lPyXhUnAEnFqGOl+zhG7D5sem1yE37UfS+FMcfbVPVjSukoCJpdzwgjyE47Y7Vj65NdF/H0ZYCxwc/j/XBkDzCJsqZWAyeIb+NMsbwNnh9t2KZgKfDNccXNlBDAH24EnARPCGOA3wDGO2L9iaZZ/lPg3/xZLbHsGOYOxqcQaCRgv1cAv8ng2WoA/YVwIFgF9gU2O2DPD48ZJEjAeWmBr6q53xt8PDMG3nq+QvBpu/+scsd2whHV3CVhaTgBexJZDeQYC44K4BxJyPm9hCetXHbEdgT+HK7kELAGfBv6Cb5pqL/At4CcJPK9N4Xa8yBHbFtv6OVQCFpfz8nju2QYMwJK6SWVnGJg87ohtRpnVpSk3AYdjc7NtHbEbwnPW4jI4z31YSmmqc1B2H7Y4VgIWkHH4Vwy/glW1Wl1G55vBktVj8SWsbwsiVkvA/GgcGvIOfGmWZ8Jte2OZPu9O4aNL/6NyHQmvS5N0AVsA8/J4prkXWwBQS3nzUB7nkei6NEkWsENILXg2b2ewmZEb8W0QSiILsCVdWxyx5wJLsHSNBIzAZ7A0Sy9H7N7wAH8XlceKMJD6lyO2O5aw7iYBj05fLM3S2RG7FbjAmcIoF94IA6rXHLGJq0uTNAGvyON5ZT22/2IJlc+7fFjuLVeydWkGScBDGY+tFvakWV4OV4U3SQ/bsbWLcxyx2a0KIySgpVl+CfwYX5plLnA+vtUk5c4HWEWvGc52n0XMdWniFrAlMB/4tjN+Ola5vpb0UoeVA/HMfNSvS9MobQKeiKVZBjhiDwK3YEWF6hBghZGux1+X5lFiqEsTl4A9sDTLZ523ncuBu+XcR7gfuBTY44gdRgx1aeIQsF8YqX7cEbsF6I9NL4nDMw+4EFv54+mbktalKbWAV4V/Za0dsevCSHeZHGuQpdjuwHccsb1DG3etNAEnYgUdPc8ZK7Ac31q5FZnX8a8AOjlI3LsSBGwShvuT8KVZ5mCzI+/JqZzJVvRa7ohtTwnq0hRbwGya5Wpn/M+xPNceueRma3hunu/sv2fDoK/sBOwULuMXOmIPYosxf4DSLIVgN7Ysa6YjNluXZlQ5CdgjXPZ7OmL3hKveVHlTUA4A12ILe3OlCktWF7wuTTEEvCBc+To5YjeHZ47fyZeikMHm3G8Kd5lcKXhdmkILOAJbAt/KEbs2jNqWy5OiMw1LPO919vE8bEFDYgSswjbBzAqj3lxZjqVZ3pIbJeMpbLX5DkfsRdiSrpokCJh928+tzueD2eG2u1lOlJwXsHWFng1bBalLk6+ArcMw3fu+s6lY5XqlWeJjVbj7rHHEZuvS9IxDwE7YnG5/R2wdlmK52fkwLArLemyvyUpHbEc+fCVFyQQ8DVvN0sMRuwe4DEsyi+TwPrawd6Ejtg3OujQeAQfg3+L3Hjat9rT6O5HsAi7GV6I4W5fmO8UU8Brg9/jWjK0Jzxor1M+JJluk3bPeshorBjCp0AJWYStuZ+JLsywL8q1T/5YFGWzF+S346tJMJGJdmigCNsVKQ0xwnsyTYaCyRf1adtwNXImvkHqkujQNCdgaKwlxZR4n4H11qUgGj4TnQk8Z46HYG+XbegTsjCUaz3d8cR22Ych7CRfJYmHw4H1H7NnY5rOOuQjYC5se8xS+rsU2xkxXv1UUK7Ea1v90xB6xLs3hBByIJRZPdHzRpvAvZZ76qyJZGyRc5YjN1qU562gCjsSfZskWzXlZ/VTRbMRmPTxvlKoBnqfeCyTrCzgWeADfWq8l4V/GevVPKtiBrYh5whF7HLbPZ3h9Afvif23B49gi1K3ql1SRrcM4zRHbGPgVcHpWwB86f8SU8CP2qj8qkoZehngQW109ntyzHdXAmKyAfXIMrsPK30ap4N4pHCfKj4eIttTqDnwv9+6bFbBFDkG7sILZ90Y4tif+VTMifjpgGZHzIhw7C0s8787h84/PChg1t7MxPC8+E+HY/iS0MLbIiTbYUqvLIhw7P/R71PHAfxrVG0g0xGoszfJKhGOzNWBaqf8qgmOAx8JjV0Msx6oxRCmkPrdRvcHEqqMc+CI2pbIhwodOwPaINFG/VRTV2OxWlKVWq8O44vWjXf2AyVkBd2PVlKZwaA2WTdhmoyjlvhpjy7Vup8Cbl0WimIjVIWxoqdU7QcKZHPqWpzpsQXIfYFP9pPPOMFodB7QLEm2MOLxugS29Gaj+SQXXYsWLLufoG8p2hNHxaOBULO/8BvV2QB5u1uMguW3T6xAGJb3UL6liCLZKZkiEu+M24KXD/UW+2zK7hYdOyZdOskut3BVV8xXwEvLcmCzKnu7AGXEJKEReSEAhAYUEFEICCgkohAQUElAICSgkoBBFpXFKzvN07P1n5cZmfPtvJWDCGAncUIa/eym2uli3YCEkoJCAOk+hjsmdlupqCSiEBBQSUAgNQkQySEsiOuog5G18hbhzpTXQVfqlR8Co3Em0ql/5Mggr5KNbsJrgEA6oCSRgnNSqCSSgzlMCpnYQIiSgkIDpRS9VlICxotdNSECdpwTUIERIQCEB04cS0RIwVjQVJwF1nhJQgxAhAYUETB+aCZGAsaKZEAkoJGDl0VpdLQGFkIB6BpSAGgWL1AmoF2hLwFhppa6WgEJIwAbYpyaQgHGyR01QWkpVG6YF0EXNnTPNYm63ZpUi4JDwn8iNM4B1ugULIQFLwn41gQSMk91qAgkoJKAQElBIwFRRpyaQgHGyS00gAUXKqMpkMmoFoSugkIBCSEAhAYWQgEICCiEBhQQUQgIKCSiEBBQSUIiC8f8BANTC6xkQsHssAAAAAElFTkSuQmCC"

/***/ },
/* 596 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 597 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 598 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 599 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 601 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 602 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 603 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 604 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 605 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/win_coins_0e2c37_150.bf3264d6.png";

/***/ },
/* 607 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/won_icon_150.887170d3.png";

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/play@3x.12cac885.png";

/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 611 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 612 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAANhJREFUaAXtmcENgzAQBOM0kT5SWgpJafSRKkD5ItBKK9CurOGHT+c7z5x44PG4+Xm9P+tRid/yHUfrV609r9qobR8O1mZE9YMxRagtjrE2I6ofjClCbXGMtRlR/WBMEWqLY6zNiOoHY4pQWxxjbUZUPxhThNriGGszovoZZ//9VGJ7nFFsN7TvD2N7Iu3v0xq79cbjb/Xsq8ttiznz044iBzMnIpaGsRh6szDGTHCxNIzF0JuFMWaCi6VhLIbeLIwxE1wsDWMx9GZhjJngYmkYi6E3C09rbAOTKQoka+GODwAAAABJRU5ErkJggg=="

/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 616 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/scBanner@3x.3ac5a519.png";

/***/ },
/* 618 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAYAAAAeYmHpAAAAAXNSR0IArs4c6QAAAiRJREFUaAXt2cFKAzEQBuBu9QE8KAoKivgWvpJH7z166MFDQcSDIAgeCqLP4EMoiGDVg0/gdf1HOhCSuk26s9kkTCAEdjez803S7tIOBtq0AloBrYBWQCugFdAKaAW0AloBrYBWQCvgVKCu61P0sXOi1ANzMIa/Vj4cTFphu5ULh3QRmAtQHnwJuDw4RCNWeYz5rziQYw+ofUm+8BXBXID84C3BDJ9k89gWAhP8G30zebgw+FDBqVWg9xVGAhsxiyII/kKs8C2NSfSq94l+EAOO+6zyHMY0pxF4PzhnTDLfbTuH435JgbmMncFxgwnfpOUossJ2DgTfC942DRMQL2kwF+BdCp4LWAyeAnjEmoBx5RVPAdzmW5PgOw0fWedU7mDeFK++8N7BWIIh+o+zFOEHjjDlaRmcwLjuJDy8M+MDR46rqpo5Z3wPIJkzdIn274ojuNRjaYZYu762xusQ6FxCjRgOHMeuhGLLgbkaSEwSvkVxkwZ3AH8G+DLZFWYwj0j0QihZiTDyW5qh9pgIPB6YC9AzPD7YgF9L7NHAGP2BCY5kK/SY8H7BxmrHgqcBtuC3gds05PI3XCzzpsVJS4xIaojeBZzA2xI5dhKjA3jaYK7iHD7F2LblATbgaxC3gecFFoDnCbbgjwH7PG+wAV8H+sEDXgbYgt83wMsCG3D6crtbAC8TbMDplfXGgJcNtuD0u9gLerpvWpyw5Ahw1D/zfXP/BQ6lTqd6NDLZAAAAAElFTkSuQmCC"

/***/ },
/* 619 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 620 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAABxCAYAAADifkzQAAAAAXNSR0IArs4c6QAABPxJREFUeAHtnT9rFEEYh41GEQkRNaKgvYWNjQhiIaJgJQgKgmAhWNj5FfQLpIudlWAhCIKFCDb+AbFQUEFBBP0Cooga/2B83rAjibd7N7M7t7Oz93vhzcTdmZ13nuf2bvfugmvWKERABERABERABERABERABERABERABERABERABERABERABERABERABERABERABESgksDS0tJe8gG5pbKTdnSXQCHwI63FK3Kuu9WqsgECCNtHOoH8uhxv+CmRA7Q6uAFRJvDzsrbBHxLZQWerSsLZ/iECnVKJXEWtQ/8oBH5xpka0Eunpbq1nv1jdQubbw6SPEK3XyFj0Yx0HKQdI37PRTladkbHgxzxOIfKrGfIMiYwpINaxkHeIzFIkde8mH5I7Y/HI9jhAyE6kiSPfkxZvye3ZCohVOBCyEWnCCnE0/+I1v22NxSPb4wChjsgdbS7YRJEmrCxesHFzm/V0ci4gmMjFMkIV296xvRWRzGMCTdSweMbOmU7CbbMoIBwhOyWSejaTowTSZTme8HNTm8w6ORcQOiOSWmZIO8N84zcdj3YSbNtFASK5SGrYRNqZ5Rt/6HiqbVadng8gyUQy90bS7gN9wwSe7TTQVMUBxkT+8CVJv8YXOxxjA3k/YE7rej4VoyzmBdBxshWRzGMC75IhcTELkKmLhOjYRTLHNBkq8FJqNlnNP06RHHsdeZsMCQms8wiCcPQzkmOuJW+G2KPv5Tr1a0xBAIAm8lcAdLvY2VUGkO1T5PWAY1nX+bJjaVsgAUCeIENEfqD/gEi2XSNDYiGwVHUfRgDyjUQyfiHEHn2vDatH+2oSqCuScfOhAuk/VbNMDRtFoIbIT4EC7TVTAkeJaLq/EGlvPscOu2oN+YZe06VM9nhgnyJjirT7xnWTTTXB6iOKtHduphMsQVMagQgi7c3vDaKZmEADkfbx08bE5Wt6RwAZV8mQ+E7nbW682sQEkHGGrHOR85hx+rJTYn/2mmgC7ZP2uvGUgRKZSiTwmwp04iUyhcSIAiWyJwIlsk2RNc5Au3j56Sx5tHpqHafQGgLvMWY9eYyUyHHK8Tl2XYHu2BLpSCRqmwp0ZUukI9FyC/hzZMh94PJTaFWZEllFZkzbawi8w5j1o8opRC7S+oYudkZBLdsP3dAz0AR6f5xE38NkqMjZslq1rYTAuAW6KWuIfM4YiXQAq9q2BLr5JdKRiNS2LdCVLZGORMM2lUBXtkQ6EjXb1AJd2RLpSAS2XRHoypZIR8KzBdgFMuRGPug2wrOMgW4SOYCkfEMhkMY7btHT+z6wfFb/rcwVeh85WbcfALIzMCRMYOtf7GVOiSx73AMmC4Gu9kLkN1rf6PcZCYWsBK4QeZDaQ0X27//9yFVgA5GvWHN/ROYucOJF9kXgxIpEoH0vNCSSXIU6Qb4tCwp9jXzJmNavrn3XM7Qfhc+Rb0ifyEKgWzAL8hVpb2acc+OybFmAibQX+WFxg53ZPVKpeZRIE3gmS3H/F81CtpBVIk1gtn8jT+1VIvsj0AmtEJm1wBVr+1+k/YVWP85At0jXFiLtHQ2LXghcsTYn0gSedNt72bLAWfIKme1TaJUY1mQiT1ft13YREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREAEREIH2CfwFftFVxMOtHqkAAAAASUVORK5CYII="

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sponsorBanner@3x.6809098c.png";

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/success@3x.ef6cd2b0.png";

/***/ },
/* 623 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAsCAYAAADSHWDqAAAAAXNSR0IArs4c6QAAAoRJREFUaAXtmr9rFEEUx91TsbNRwagJChaKCEIQwULIGYm1/4RWaWxsVCzsxF6s7MTOThGFgIUoCKJgY2FpsNAUaiIx5+cbvCs27+Z2Z8Yb9mYffLOzM+/Xd97t7Nzkim1Ir9fbz+U+OAP2gUmUH5D6ABaLongtggXERfYdmFJHBrIOxwUm4EWHxh2QC3HVdgd4oIYq/5XrXt1kJsdV+RyJq84HRD5b0effJSsMfgRrLqXSWMH9NDgM1A6VZRx8Alqoqsp2FI+Ag04DnnlL/tB5zWk4YhD7E+Cz5bxi30/0Lo0I4xzGvgu+DYnX1TvekiDi/YxwPAVWrAAV+hb6fkKuxJkFKmZZTPJf0Iq2FuDrZjlqhfulEMJlW+I9NGJ2LZJv2ABslB0E3L/ysPWxcYUx/Vnkv7u8eIxp0awrY8nBIl830cbqt+QbW7rAxNvKB05gY81TVn6eWZsD71PN3qi9/f/Ma4n9xDqbD59XYZS8UpK/AXFtpmaiMPFwkpL8dY98o5qkfOajEvFx1pL3mbVJsElZ+Z2s9jrpeZlqIlOST8V5EDflav9cBwxkcnKQzZgbKcmfGzPXLeGy/thb5A9tmaKwDh9/PjauLE1/FvnTPIq7XZ5qjl2oqS/1eXKwcvNwtWly0TTUomPII/r0GgoSfMyBDcN/la5bQcH/GRPoypBg5tF1X/cZjVNgV50k0Nc/P6fBZbAKQuQuxsdArYUZ/Q44CvTlaZh0laheNznK+ZjPVeMmsCXfuJJFSritfKSJbJwbVf5347KOk/CayOtnaDnKW5G/nSHze5yj/Orw5zHkdZKay2bnKVyvquCD/TsbvVnuz4I9GphA6f/89AkF3yz0X7yMsCQrFZYhAAAAAElFTkSuQmCC"

/***/ },
/* 624 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 625 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAYAAACMGIOFAAAAAXNSR0IArs4c6QAAA9RJREFUaAXtmjtoFUEUhu/VEEVRiagRgqJVREQLGzUqQVGDKIgP1CIqFkIwiI2PRtJYBK0tFAvxEbFRC0EUFbuIAQO+QSVIFAQhIUV8m+t3wg5ZNruz79ndiwf+zNyZnXPOtzOzu3dvSqWCWKVSqUHn0S8k9gldRk0FQdCnCUgZdSEvk755ei857iV5AbzuRWdr/079aI5R3FMj6aCANtbKBRnn7jFnrREBFeyZnOGMTycmoALdNd5zTloSAhTQATQnJ1hjaSQIKJBinWPec1AjoSgXmVESzZ9B+mpygFcqpQSo2JsmZk0pgOTQhfaklMv7CSk5DuTWAKDkUZ8ZJICyitKcQXWiu1XFaCmA6CZK214TwPxEEtQU4Dti1RudPQlGULlNXENp2wcCZAYY5NtE3BOQGaAsUROAb7OaQVN7UABnZbEH/wPG3XzW+KqfwZfVvkQFsK6a92BmgPJe1MSjWqaAd6wLQZpF1QP2ZrUHZYmamEEBnJ7FRcYUYE+1Az4DcIbxGZSABD6H0rbEAEP/ZgCZfE/7kvLZfYH/NeVyeSiJOFFeDQwSuD+J4B4+BLA5KUCPGP7NzOYKNJzCen2Oz5n+GYQ7IvRyVe5JZjX1B2iSaotZqhkc0PkhbiP9O9Ew6kHdzPoIZTpGwHXoB4prb3CgnUH6a1G7S6CvtLUmTojTBcop9bigAjhb+XMr6V+CBPAR8rJTbmMjtxHlCWpRDqgL6E8U1oIAyhu+V+gQuu8TIJmfGggyDf1BAuUEDbN0fQHlJBJjLRI7jvzuz73qxMcqCXRCIlrmBhpkRuXFr3aJqiQ57qQVS/7DY71V1xXxnpDwvAH9dkRwgrbQrwMVwLkKwq/k2LNWvG+UU9At67NXsdDPp2c/HnUXmKCgoQAlGeIes9F0UK9D/bY2e1W2UbRbGgM3Ir/95gTdxBj7A4Pc6APPoDrbjGlEymQ2V6L5qFs12sobalyoEge7kXOJ2vyOVkf4+xidRpNVAOrL0V10EU1V7WFLxt5DyuRktokPSsntNpLYl5D2Xusal0GbkSwBnT2lc5Grg4Qa8d+A5KZvt4d8OIAWo9pIoRi4BclZ05n8vmHkJ3niyAOBvONxWh8NS0NDMmgf+ot0dpXOKN9iQuejBhBPHgyWoSOoA+1A4WeRQQeR7DGdGQdUoLFLqA7ryKy+QgO2AlHVM7gNQL+r6BWOMboHYy9N5YDEm5HffbA4/0OqwOwlgJ+RzjrtxxeyDl2fhrC9kFDOpAHc7gIpF6D9zmML/RmgveijBTtEubXQQF7JAyZPE6tQg9cxRW3/B+RLqQ+D0YbzAAAAAElFTkSuQmCC"

/***/ },
/* 626 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 627 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABPCAYAAACZD4ePAAAAAXNSR0IArs4c6QAABfBJREFUaAXtmUloFE0Ux//thitKXFDcIrgibhCi0STGcYk7KohCbqJ41aOI4HbWi14URUG9ieK+EpcYDZOYqAQXRI1EDBq+0c8hJuKkrf/UVHrGTL7uqp58yaHfYbr7TS2/flX13qtqy87Ls9F9paRH92WTZAGg3xEKLBhY0K8F/NYP5mBgQb8W8Fs/mIOBBf1awG9973MwOxs4ehSYPdvpc8gQqSssdHTqzrKAQ4eAzZuVRl4PHgS2bUvV/ceTd8APH4CxY4ENG5zmvn0DBgwANm1ydOpu/nxg3jzg7VulAaZNA0Ih4P17R+dy5x2QDV25AhQVAQMHOs1euwbMmQOMHOnoeLd6NdDYCFRWOvpVq4AfP4AHDxydy50e4KVLQK9ewLJlTrME/P0bWLPG0Q0eDCxYIF9Iafv0AZYuBW7fBn79UlrXqx5gQwNQUwPQEkqiUaC8PBVw+XL5Ipcvq1IA5+mgQcDVq47Ow50eIBukxTiXxo1zmmenw4YBOTlSt24d8OIF8PmzU4YvVVcHvHzp6Dzc6QPeuSOHaO1ap/myMiASkfNu6lRg/PhUSxE+NxfgFNEUfcDmZoCQK1cCdCUUW+xcb92SC2jjRvkCfFZC67HM9etK4/mqD8imuZrpA7kQlFy8CHAhrFgB3L8P8EWU0NqPHgF0S5piBsiFwvlFV6KE8+vNG/mUvBDo2EeNSh1yVcfD1QyQDdOKdMa0pBIuIAphlXB4aTla0EDMAelCevYEioudbpVP5Pyk9O0rI8eNG0AsJnWav+aAjBJVVQBdihLlE9evl5rFi4F+/QDOT0MxB2SHnGt0KZMnO90rnzh3rnTor14BHz86/2ve+QMsLQV+/kyNLMonbt0qM5/kBaMJx+L+ABlT6e8Y2oYOlUCjR0vd9OkyRt+8aYDlVBGR36d8+SJjbHLcVU1++qSVGKhqyVdzwKwsYM8egHOtpUVGF/pHupRJk+S8pCM/dQrYtSvV9SQTuNxbRies/fsDx44BY8YAx48DFy4ATU3tu+L/e/cC2dnAli0mi8XwhPXAAdnp9u3A2bPp4YhbXw+wTDgMHDkC0Oqaor9ImGrl5QGnTwOvX7t3Rwe9b59MLLiyNUUfkJsgJq4nT3rvionDmTMyqR0+3Hs9UVIfcNYs4N49/dB1964MjTNmdCJg797AiBHAu3dancQLMzQyFDLyaIieBbkZomhsemSFxC+HmvsSDdEDVAkno4Wu9BBdMdrQsWuIHiC3l1y5+fkaXSSKcu5yi/DsmVZdPUA2zX0tXQ036zrC4w6u/k7f1TFqcKgZvhhRvAi3Bkz9Dx/2UjqljL4FmV7t3w9wHp44AUycmNJguwduC3bsAM6dAx4+bPe3m8IsFrNVpli7d8v2z5+X2TUPiriZ4vHIokUy26blGHUYu/WlxByQnU2ZAuzcCcyc2b5rhjjGYIIxqzYTn4Cq0wkTZHzm/oOpF4/Xnj+XJ1mqjNm1RIxFBoRAGmd+Oj3qLxKd1jNQNgD0a8TAgoEF/VrAb/1gDnYnC0bR2hoSZ9EVfqGS62dqiKMiWw5ZFRWl4kvSEtFBdXInfu79A9r2v3G48nKRuoisvrY2KjZVItfKDKQ/QMLFYgutBJyylFVV9T0Oadvia44/MQdUcOFwTTqEOKRlFYk56QvSFDASt1wHcArYevz4HzH8ReLZOGM1AYyIr5sFlgtcCmRzs/iSaAapC6jgahWAl6tVXf1VfHkqFMMtNi164h3QthsTltOCUzhxyFisQBfSK+BXAZcvhtUIrg0yHG4Qc7dAPNcpndvVC2BENFJoVVZ6OK106074SUK2tvLsxBOkGyDhForVaLwK0yGLiFMfh/QwJzsGtO3vCThffiwdIHVxSA9zMj2ghAsJy3UKnIKOD7cLZDpAcQyKkPXkyVPVUGde3SD/BowKN7Dk/4JTL94GmcaZO4C23ZSAy2g+pyDcrnHINBFHAkq4YmG5LoFT8G0RJ8mSBGwRlisWq6pMFezKaxukyoLs3NxQVwJ11Lf4hpgl2HL+AE2UI+2wKXQZAAAAAElFTkSuQmCC"

/***/ },
/* 628 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/leaderboard_background2@3x.2174c227.png";

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/leaderboard_background@3x.926e88fa.png";

/***/ },
/* 631 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/login_background@3x.a710f00c.png";

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/modal_background@3x.5fd38c9c.png";

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/scBannerDisabled@3x.acba8eeb.png";

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sc_background@3x.78196aa7.png";

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/splash_background@3x.a63bf919.png";

/***/ },
/* 637 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.4.1
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(15),n=__webpack_require__(10),p=__webpack_require__(21),q=__webpack_require__(16),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
	r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
	var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
	G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
	function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
	function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
	var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
	b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
	assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(132);
	
	var _diff = __webpack_require__(641);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  var isUsingDefaultFormatter = typeof options.titleFormatter === 'undefined';
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title && isUsingDefaultFormatter) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title && isUsingDefaultFormatter) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ },
/* 640 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(168);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.createLogger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(639);
	
	var _helpers = __webpack_require__(132);
	
	var _defaults = __webpack_require__(640);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = function defaultLogger() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      dispatch = _ref2.dispatch,
	      getState = _ref2.getState;
	
	  if (typeof dispatch === 'function' || typeof getState === 'function') {
	    return createLogger()({ dispatch: dispatch, getState: getState });
	  } else {
	    // eslint-disable-next-line no-console
	    console.error('\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from \'redux-logger\'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from \'redux-logger\'\n');
	  }
	};
	
	exports.defaults = _defaults2.default;
	exports.createLogger = createLogger;
	exports.logger = defaultLogger;
	exports.default = defaultLogger;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = promiseMiddleware;
	
	var _isPromise = __webpack_require__(644);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTypes = ['PENDING', 'FULFILLED', 'REJECTED'];
	
	/**
	 * @function promiseMiddleware
	 * @description
	 * @returns {function} thunk
	 */
	function promiseMiddleware() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypes;
	
	  return function (ref) {
	    var dispatch = ref.dispatch;
	
	
	    return function (next) {
	      return function (action) {
	        if (action.payload) {
	          if (!(0, _isPromise2.default)(action.payload) && !(0, _isPromise2.default)(action.payload.promise)) {
	            return next(action);
	          }
	        } else {
	          return next(action);
	        }
	
	        // Deconstruct the properties of the original action object to constants
	        var type = action.type,
	            payload = action.payload,
	            meta = action.meta;
	
	        // Assign values for promise type suffixes
	
	        var _promiseTypeSuffixes = _slicedToArray(promiseTypeSuffixes, 3),
	            PENDING = _promiseTypeSuffixes[0],
	            FULFILLED = _promiseTypeSuffixes[1],
	            REJECTED = _promiseTypeSuffixes[2];
	
	        /**
	         * @function getAction
	         * @description Utility function for creating a rejected or fulfilled
	         * flux standard action object.
	         * @param {boolean} Is the action rejected?
	         * @returns {object} action
	         */
	
	
	        var getAction = function getAction(newPayload, isRejected) {
	          return _extends({
	            type: type + '_' + (isRejected ? REJECTED : FULFILLED)
	          }, newPayload === null || typeof newPayload === 'undefined' ? {} : {
	            payload: newPayload
	          }, meta !== undefined ? { meta: meta } : {}, isRejected ? {
	            error: true
	          } : {});
	        };
	
	        /**
	         * Assign values for promise and data variables. In the case the payload
	         * is an object with a `promise` and `data` property, the values of those
	         * properties will be used. In the case the payload is a promise, the
	         * value of the payload will be used and data will be null.
	         */
	        var promise = void 0;
	        var data = void 0;
	
	        if (!(0, _isPromise2.default)(action.payload) && _typeof(action.payload) === 'object') {
	          promise = payload.promise;
	          data = payload.data;
	        } else {
	          promise = payload;
	          data = undefined;
	        }
	
	        /**
	         * First, dispatch the pending action. This flux standard action object
	         * describes the pending state of a promise and will include any data
	         * (for optimistic updates) and/or meta from the original action.
	         */
	        next(_extends({
	          type: type + '_' + PENDING
	        }, data !== undefined ? { payload: data } : {}, meta !== undefined ? { meta: meta } : {}));
	
	        /*
	         * @function handleReject
	         * @description Dispatch the rejected action and return
	         * an error object. The error object is the original error
	         * that was thrown. The user of the library is responsible for
	         * best practices in ensure that they are throwing an Error object.
	         * @params reason The reason the promise was rejected
	         * @returns {object}
	         */
	        var handleReject = function handleReject(reason) {
	          var rejectedAction = getAction(reason, true);
	          dispatch(rejectedAction);
	          throw reason;
	        };
	
	        /*
	         * @function handleFulfill
	         * @description Dispatch the fulfilled action and
	         * return the success object. The success object should
	         * contain the value and the dispatched action.
	         * @param value The value the promise was resloved with
	         * @returns {object}
	         */
	        var handleFulfill = function handleFulfill() {
	          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	          var resolvedAction = getAction(value, false);
	          dispatch(resolvedAction);
	
	          return { value: value, action: resolvedAction };
	        };
	
	        /**
	         * Second, dispatch a rejected or fulfilled action. This flux standard
	         * action object will describe the resolved state of the promise. In
	         * the case of a rejected promise, it will include an `error` property.
	         *
	         * In order to allow proper chaining of actions using `then`, a new
	         * promise is constructed and returned. This promise will resolve
	         * with two properties: (1) the value (if fulfilled) or reason
	         * (if rejected) and (2) the flux standard action.
	         *
	         * Rejected object:
	         * {
	         *   reason: ...
	         *   action: {
	         *     error: true,
	         *     type: 'ACTION_REJECTED',
	         *     payload: ...
	         *   }
	         * }
	         *
	         * Fulfilled object:
	         * {
	         *   value: ...
	         *   action: {
	         *     type: 'ACTION_FULFILLED',
	         *     payload: ...
	         *   }
	         * }
	         */
	        return promise.then(handleFulfill, handleReject);
	      };
	    };
	  };
	}

/***/ },
/* 644 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPromise;
	function isPromise(value) {
	  if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    return value && typeof value.then === 'function';
	  }
	
	  return false;
	}

/***/ },
/* 645 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(133);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 647 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(134);
	
	var _isPlainObject = __webpack_require__(137);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(135);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 649 */
[668, 136, 652, 653],
/* 650 */
233,
/* 651 */
[669, 654],
/* 652 */
[670, 136],
/* 653 */
236,
/* 654 */
237,
/* 655 */
[671, 650],
/* 656 */
239,
/* 657 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(24)))

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(660);


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(661);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(43)(module)))

/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 662 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 663 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 664 */
663,
/* 665 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.90d235fd.js